// Image Picker
// by Rodrigo Vera
//
// Version 0.2.4
// Full source at https://github.com/rvera/image-picker
// MIT License, https://github.com/rvera/image-picker/blob/master/LICENSE
// Generated by CoffeeScript 1.4.0
(function() {
    var ImagePicker, ImagePickerOption, both_array_are_equal, sanitized_options,
        __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
        __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

    jQuery.fn.extend({
        imagepicker: function(opts) {
            if (opts == null) {
                opts = {};
            }
            return this.each(function() {
                var select;
                select = jQuery(this);
                if (select.data("picker")) {
                    select.data("picker").destroy();
                }
                select.data("picker", new ImagePicker(this, sanitized_options(opts)));
                if (opts.initialized != null) {
                    return opts.initialized.call(select.data("picker"));
                }
            });
        }
    });

    sanitized_options = function(opts) {
        var default_options;
        default_options = {
            hide_select: true,
            show_label: false,
            initialized: void 0,
            changed: void 0,
            clicked: void 0,
            selected: void 0,
            limit: void 0,
            limit_reached: void 0,
            qty: void 0
        };
        return jQuery.extend(default_options, opts);
    };

    both_array_are_equal = function(a, b) {
        return jQuery(a).not(b).length === 0 && jQuery(b).not(a).length === 0;
    };

    ImagePicker = (function() {

        function ImagePicker(select_element, opts) {
            this.opts = opts != null ? opts : {};
            this.sync_picker_with_select = __bind(this.sync_picker_with_select, this);

            this.select = jQuery(select_element);
            this.multiple = this.select.attr("multiple") === "multiple";
            if (this.select.data("limit") != null) {
                this.opts.limit = parseInt(this.select.data("limit"));
            }
            /* FIX by justselling - check if qtytype is set */
            if(this.select.data('qty-type') != '') {
                this.opts.qty = {};
                this.opts.qty.type = this.select.data('qty-type');
            }
            this.abstractOption = Justselling_Configento_App_Helper.getConfigurator().getOptionByInternalId(this.select.data('cf-id'));

            /* end FIX  */
            this.build_and_append_picker();
        }

        ImagePicker.prototype.destroy = function() {
            var option, _i, _len, _ref;
            _ref = this.picker_options;
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                option = _ref[_i];
                option.destroy();
            }
            this.picker.remove();
            this.select.unbind("change");
            this.select.removeData("picker");
            return this.select.show();
        };

        ImagePicker.prototype.build_and_append_picker = function() {
            var _this = this;
            if (this.opts.hide_select) {
                this.select.hide();
            }
            this.select.change(function() {
                return _this.sync_picker_with_select();
            });
            if (this.picker != null) {
                this.picker.remove();
            }
            this.create_picker();
            this.select.after(this.picker);
            return this.sync_picker_with_select();
        };

        ImagePicker.prototype.sync_picker_with_select = function() {
            var option, _i, _len, _ref, _results;
            _ref = this.picker_options;
            _results = [];
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                option = _ref[_i];
                if (option.is_selected()) {
                    _results.push(option.mark_as_selected());
                } else {
                    _results.push(option.unmark_as_selected());
                }
            }
            return _results;
        };

        ImagePicker.prototype.create_picker = function() {
            var qtyClass = '';
            if (typeof this.opts.qty == 'object') {
                qtyClass = 'hasQty';
            }
                this.picker = jQuery("<ul class='thumbnails "+qtyClass+" image_picker_selector'></ul>");
            this.picker_options = [];
            // removed options for loading images only if picker ist shown
            //this.recursively_parse_option_groups(this.select, this.picker);
            return this.picker;
        };

        ImagePicker.prototype.recursively_parse_option_groups = function(scoped_dom, target_container) {
            var container, option, option_group, _i, _j, _len, _len1, _ref, _ref1, _results;
            _ref = scoped_dom.children("optgroup");
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                option_group = _ref[_i];
                option_group = jQuery(option_group);
                container = jQuery("<ul></ul>");
                container.append(jQuery("<li class='group_title'>" + (option_group.attr("label")) + "</li>"));
                target_container.append(jQuery("<li>").append(container));
                this.recursively_parse_option_groups(option_group, container);
            }
            _ref1 = (function() {
                var _k, _len1, _ref1, _results1;
                _ref1 = scoped_dom.children("option");
                _results1 = [];
                for (_k = 0, _len1 = _ref1.length; _k < _len1; _k++) {
                    option = _ref1[_k];
                    /* FIX by justselling - only render options that do not have prop "hidden" */
                    if (!jQuery(option).prop("hidden")) {
                        _results1.push(new ImagePickerOption(option, this, this.opts));
                    }
                    /* end FIX */
                }
                return _results1;
            }).call(this);
            _results = [];
            for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
                option = _ref1[_j];
                this.picker_options.push(option);
                if (!option.has_image()) {
                    continue;
                }
                _results.push(target_container.append(option.node));
            }
            return _results;
        };

        ImagePicker.prototype.has_implicit_blanks = function() {
            var option;
            return ((function() {
                    var _i, _len, _ref, _results;
                    _ref = this.picker_options;
                    _results = [];
                    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                        option = _ref[_i];
                        if (option.is_blank() && !option.has_image()) {
                            _results.push(option);
                        }
                    }
                    return _results;
                }).call(this)).length > 0;
        };

        ImagePicker.prototype.selected_values = function() {
            /* FIX by justselling - check for internal-id attribute to make selection independent of value
             (was issue when value appeared more than one time) */
            if (this.multiple) {
                var avtiveInternalIds = [];
                if(this.abstractOption && this.abstractOption.getActiveChoice()) {
                    var activeChoice = this.abstractOption.getActiveChoice();
                    if (_.isArray(activeChoice)) {
                        avtiveInternalIds = _.map(activeChoice, function (choice) {
                            return choice.getInternalId();
                        });
                    } else {
                        avtiveInternalIds = [activeChoice.getInternalId()];
                    }

                }
                return avtiveInternalIds;
            } else {
                if(this.abstractOption && this.abstractOption.getActiveChoice()) {
                    var avtiveInternalIds = [];
                    var activeChoice = this.abstractOption.getActiveChoice();
                    if (_.isArray(activeChoice)) {
                        avtiveInternalIds = _.map(activeChoice, function (choice) {
                            return choice.getInternalId();
                        });
                    } else {
                        avtiveInternalIds = [activeChoice.getInternalId()];
                    }

                    return avtiveInternalIds;
                }
                return [''];
            }
            /* end FIX */
        };

        ImagePicker.prototype.toggle = function(imagepicker_option) {
            var new_values, old_values, selected_value;
            old_values = this.selected_values();
            /* FIX by justselling - check for internal-id attribute to make selection independent of value
             (was issue when value appeared more than one time) */
            //selected_value = imagepicker_option.value().toString();
            selected_value = imagepicker_option.internalId().toString();

            if (this.multiple) {
                if (__indexOf.call(this.selected_values(), selected_value) >= 0) {
                    new_values = this.selected_values();
                    new_values.splice(jQuery.inArray(selected_value, old_values), 1);
                    this.select.val([]);
                    this.select.find('option').prop('selected', false);
                    _.each(new_values, function (new_internalId) {
                        this.select.find('option[data-cf-internalid=' + new_internalId + ']').prop('selected', true);
                    }, this);
                 //   this.select.val(new_values);
                } else {
                    if ((this.opts.limit != null) && this.selected_values().length >= this.opts.limit) {
                        if (this.opts.limit_reached != null) {
                            this.opts.limit_reached.call(this.select);
                        }
                    } else {
                        this.select.find('option').prop('selected', false);
                        _.each(this.selected_values().concat(selected_value), function (new_internalId) {
                            this.select.find('option[data-cf-internalid=' + new_internalId + ']').prop('selected', true);
                        }, this);
                    }
                }
            } else {
                var selChoice = this.abstractOption.getChoiceByInternalId(selected_value);
                this.abstractOption.setActiveChoice(selChoice);
                if(selChoice) {
                    this.abstractOption.setValue(selChoice.getValue());
                }
                //this.select.val(selected_value);
                var internal_id = imagepicker_option.internalId().toString();
                var selectedOption = this.select.find('option[selected=selected]');
                var newOption = this.select.find('option[data-cf-internalid='+internal_id+']');
                if(selectedOption.attr('id') !== newOption.attr('id') ) {
                    selectedOption.removeAttr('selected');
                }
                newOption.prop('selected', true);

                /*
                if (this.has_implicit_blanks() && imagepicker_option.is_selected()) {
                    this.select.find('option[selected=selected]').removeAttr('selected');
                    this.select.find('option[data-cf-internalid='+internal_id+']').attr('selected', 'selected');
                //  this.select.val(""); // Avoid de-select if selected value
                } else {
                    this.select.find('option[selected=selected]').removeAttr('selected');
                    this.select.find('option[data-cf-internalid='+internal_id+']').attr('selected', 'selected');
                  //  this.select.val(selected_value);
                }
                */
            }
            if (!both_array_are_equal(old_values, this.selected_values())) {
                this.select.change();
                if (this.opts.changed != null) {
                    return this.opts.changed.call(this.select, old_values, this.selected_values());
                }
            }
            /* end FIX */

        };

        return ImagePicker;

    })();

    ImagePickerOption = (function() {

        function ImagePickerOption(option_element, picker, opts) {
            this.picker = picker;
            this.opts = opts != null ? opts : {};
            this.clicked = __bind(this.clicked, this);

            this.option = jQuery(option_element);
            this.create_node();
        }

        ImagePickerOption.prototype.destroy = function() {
            return this.node.find(".thumbnail").unbind();
        };

        ImagePickerOption.prototype.has_image = function() {
            return this.option.data("img-src") != null;
        };

        ImagePickerOption.prototype.is_blank = function() {
            return !((this.value() != null) && this.value() !== "");
        };

        ImagePickerOption.prototype.is_selected = function() {
            var select_value;

            /* FIX by justselling - check for internal-id attribute to make selection independent of value
            (was issue when value appeared more than one time) */

            select_value = this.picker.select.find('option:selected').attr('data-cf-internalid');
        //  select_value = this.picker.select.val();
            if (this.picker.multiple) {
                return jQuery.inArray(this.internalId(), select_value) >= 0;
            } else {
                return this.internalId() === select_value;
            //  return this.value() === select_value;
            }
            /* end FIX */

        };
        /* FIX by justselling - return internal ID of current option */
        ImagePickerOption.prototype.internalId = function() {
            return this.option.attr('data-cf-internalid');
        };
        /* end FIX */

        ImagePickerOption.prototype.mark_as_selected = function() {
            return this.node.find(".thumbnail").addClass("selected");
        };

        ImagePickerOption.prototype.unmark_as_selected = function() {
            return this.node.find(".thumbnail").removeClass("selected");
        };

        ImagePickerOption.prototype.value = function() {
            return this.option.val();
        };

        ImagePickerOption.prototype.label = function() {
            if (this.option.data("img-label")) {
                return this.option.data("img-label");
            } else {
                return this.option.text();
            }
        };

        ImagePickerOption.prototype.clicked = function() {
            this.picker.toggle(this);
            if (this.opts.clicked != null) {
                this.opts.clicked.call(this.picker.select, this);
            }
            if ((this.opts.selected != null) && this.is_selected()) {
                return this.opts.selected.call(this.picker.select, this);
            }
        };

        ImagePickerOption.prototype.create_node = function() {
            var image, thumbnail;
            this.node = jQuery("<li/>");
            image = jQuery("<img class='image_picker_image'/>");
            image.attr("src", this.option.data("img-src"));

            var thumbWidth = this.option.data("img-width");
            var thumbHeight = this.option.data("img-height");
            if(thumbWidth) {
                if(!isNaN(thumbWidth)){
                    thumbWidth = thumbWidth+'px';
                }
                else if(thumbWidth.substr(-1,1) != '%' && thumbWidth.substr(-2,2) != 'px') {
                    thumbWidth = '';
                }
                image.attr("width", thumbWidth);
                image.css("width",thumbWidth);
            }
            if(thumbHeight) {
                if(!isNaN(thumbHeight)){
                    thumbHeight = thumbHeight+'px';
                }
                else if(thumbHeight.substr(-1,1) != '%' && thumbHeight.substr(-2,2) != 'px') {
                    thumbHeight = '';
                }
                image.attr("height", thumbHeight);
                image.css("height",thumbHeight);
            }
            thumbnail = jQuery("<div class='thumbnail'>");
            thumbnail.click({
                option: this
            }, function(event) {
                /* case we have packages, than this options must be disabled */
                if (thumbnail.parents('.image_picker_selector').prev().hasClass('prevent-click')) {
                    return false;
                }
                return event.data.option.clicked();
            });
            thumbnail.append(image);

            this.node.append(thumbnail);

            if (this.opts.show_label) {
                thumbnail.after(jQuery("<p/>").html(this.label()));
            }

            /* FIX by justselling - add qty field and listen to changes */
            if (typeof this.opts.qty == 'object') {

                var qtyElement = '';
                var qtyType = this.opts.qty.type;
                var qty =  this.option.data('qty-qty');
                var qtyMin =  this.option.data('qty-min');
                var qtyMax =  this.option.data('qty-max');
                var id =  this.option.attr('id');
                if(this.option.data('qty-qty')) {
                    if (qtyType == 1) {
                        qtyElement = Justselling_Configento_App_Helper.qtyInputHtml(qty, qtyMin, qtyMax, id);
                    }
                    else if (qtyType == 2) {
                        qtyElement = Justselling_Configento_App_Helper.qtySelectHtml(qty, qtyMin, qtyMax, id);
                    }
                }
                thumbnail.after(jQuery(qtyElement));
                var selectId = this.picker.select.attr('id');
                jQuery('#'+selectId).parent().on('change', '.qty', function(event) {
                    if(jQuery(this).val() != qty) {
                        var start = new Date().getTime();

                        Justselling_Configento_App_Debug.addDebug("changed qty");
                        jQuery('#' + selectId).trigger('change');

                        var end = new Date().getTime();
                        var time = end - start;
                        Justselling_Configento_App_Profiler.addMeasuring("imagepicker changed qty", time);
                    }
                });
            }
            /*  end FIX */

            /* Add info-text from configurator */
            if (this.option.data("cfInfotext")) {
                var infoTextContent = this.option.data("cfInfotext");
                var $infoText = jQuery("<p class='infotextcontent'/>");
                $infoText.html(infoTextContent);
                thumbnail.append($infoText);
                var $element = thumbnail.find(".image_picker_image");
                $element.tooltipster({
                    content: $infoText,
                    theme: 'tooltipster-light',
                    contentAsHTML: true,
                    /*maxWidth: 300,*/
                    interactive: true
                });
            }
            if (this.option.attr('data-cf-additionalInfo')) {
                thumbnail.append(this.option.attr('data-cf-additionalInfo'));
            }

            return this.node;
        };

        return ImagePickerOption;

    })();

}).call(this);

/*!
 *  Project: jquery.responsiveTabs.js
 *  Description: A plugin that creates responsive tabs, optimized for all devices
 *  Author: Jelle Kralt (jelle@jellekralt.nl)
 *  Version: 1.5.0
 *  License: MIT
 */

;(function ( $, window, undefined ) {

    /** Default settings */
    var defaults = {
        active: null,
        event: 'click',
        disabled: [],
        collapsible: 'accordion',
        startCollapsed: false,
        rotate: false,
        setHash: false,
        animation: 'default',
        animationQueue: false,
        duration: 500,
        scrollToAccordion: false,
        accordionTabElement: '<div></div>',
        activate: function(){},
        deactivate: function(){},
        load: function(){},
        activateState: function(){},
        classes: {
            stateDefault: 'r-tabs-state-default',
            stateActive: 'r-tabs-state-active',
            stateDisabled: 'r-tabs-state-disabled',
            stateExcluded: 'r-tabs-state-excluded',
            container: 'r-tabs',
            ul: 'r-tabs-nav',
            tab: 'r-tabs-tab',
            anchor: 'r-tabs-anchor',
            panel: 'r-tabs-panel',
            accordionTitle: 'r-tabs-accordion-title'
        }
    };

    /**
     * Responsive Tabs
     * @constructor
     * @param {object} element - The HTML element the validator should be bound to
     * @param {object} options - An option map
     */
    function ResponsiveTabs(element, options) {
        this.element = element; // Selected DOM element
        this.$element = $(element); // Selected jQuery element

        this.tabs = []; // Create tabs array
        this.state = ''; // Define the plugin state (tabs/accordion)
        this.rotateInterval = 0; // Define rotate interval
        this.$queue = $({});

        // Extend the defaults with the passed options
        this.options = $.extend( {}, defaults, options);

        this.init();
    }


    /**
     * This function initializes the tab plugin
     */
    ResponsiveTabs.prototype.init = function () {
        var _this = this;

        // Load all the elements
        this.tabs = this._loadElements();
        this._loadClasses();
        this._loadEvents();

        // Window resize bind to check state
        $(window).on('resize', function(e) {
            _this._setState(e);
        });

        // Hashchange event
        $(window).on('hashchange', function(e) {
            var tabRef = _this._getTabRefBySelector(window.location.hash);
            var oTab = _this._getTab(tabRef);

            // Check if a tab is found that matches the hash
            if(tabRef >= 0 && !oTab._ignoreHashChange && !oTab.disabled) {
                // If so, open the tab and auto close the current one
                _this._openTab(e, _this._getTab(tabRef), true);
            }
        });

        // Start rotate event if rotate option is defined
        if(this.options.rotate !== false) {
            this.startRotation();
        }

        // --------------------
        // Define plugin events
        //

        // Activate: this event is called when a tab is selected
        this.$element.bind('tabs-activate', function(e, oTab) {
            _this.options.activate.call(this, e, oTab);
        });
        // Deactivate: this event is called when a tab is closed
        this.$element.bind('tabs-deactivate', function(e, oTab) {
            _this.options.deactivate.call(this, e, oTab);
        });
        // Activate State: this event is called when the plugin switches states
        this.$element.bind('tabs-activate-state', function(e, state) {
            _this.options.activateState.call(this, e, state);
        });

        // Load: this event is called when the plugin has been loaded
        this.$element.bind('tabs-load', function(e) {
            var startTab;

            _this._setState(e); // Set state

            // Check if the panel should be collaped on load
            if(_this.options.startCollapsed !== true && !(_this.options.startCollapsed === 'accordion' && _this.state === 'accordion')) {

                startTab = _this._getStartTab();

                // Open the initial tab
                _this._openTab(e, startTab); // Open first tab

                // Call the callback function
                _this.options.load.call(this, e, startTab); // Call the load callback
            }
        });
        // Trigger loaded event
        this.$element.trigger('tabs-load');
    };

    //
    // PRIVATE FUNCTIONS
    //

    /**
     * This function loads the tab elements and stores them in an array
     * @returns {Array} Array of tab elements
     */
    ResponsiveTabs.prototype._loadElements = function() {
        var _this = this;
        var $ul = this.$element.children('ul');
        var tabs = [];
        var id = 0;

        // Add the classes to the basic html elements
        this.$element.addClass(_this.options.classes.container); // Tab container
        $ul.addClass(_this.options.classes.ul); // List container

        // Get tab buttons and store their data in an array
        $('li', $ul).each(function() {
            var $tab = $(this);
            var isExcluded = $tab.hasClass(_this.options.classes.stateExcluded);
            var $anchor, $panel, $accordionTab, $accordionAnchor, panelSelector;

            // Check if the tab should be excluded
            if(!isExcluded) {

                $anchor = $('a', $tab);
                panelSelector = $anchor.attr('href');
                $panel = $(panelSelector);
                $accordionTab = $(_this.options.accordionTabElement).insertBefore($panel);
                $accordionAnchor = $('<a></a>').attr('href', panelSelector).html($anchor.html()).appendTo($accordionTab);

                var oTab = {
                    _ignoreHashChange: false,
                    id: id,
                    disabled: ($.inArray(id, _this.options.disabled) !== -1),
                    tab: $(this),
                    anchor: $('a', $tab),
                    panel: $panel,
                    selector: panelSelector,
                    accordionTab: $accordionTab,
                    accordionAnchor: $accordionAnchor,
                    active: false
                };

                // 1up the ID
                id++;
                // Add to tab array
                tabs.push(oTab);
            }
        });
        return tabs;
    };


    /**
     * This function adds classes to the tab elements based on the options
     */
    ResponsiveTabs.prototype._loadClasses = function() {
        for (var i=0; i<this.tabs.length; i++) {
            this.tabs[i].tab.addClass(this.options.classes.stateDefault).addClass(this.options.classes.tab);
            this.tabs[i].anchor.addClass(this.options.classes.anchor);
            this.tabs[i].panel.addClass(this.options.classes.stateDefault).addClass(this.options.classes.panel);
            this.tabs[i].accordionTab.addClass(this.options.classes.accordionTitle);
            this.tabs[i].accordionAnchor.addClass(this.options.classes.anchor);
            if(this.tabs[i].disabled) {
                this.tabs[i].tab.removeClass(this.options.classes.stateDefault).addClass(this.options.classes.stateDisabled);
                this.tabs[i].accordionTab.removeClass(this.options.classes.stateDefault).addClass(this.options.classes.stateDisabled);
            }
        }
    };

    /**
     * This function adds events to the tab elements
     */
    ResponsiveTabs.prototype._loadEvents = function() {
        var _this = this;

        // Define activate event on a tab element
        var fActivate = function(e) {
            var current = _this._getCurrentTab(); // Fetch current tab
            var activatedTab = e.data.tab;

            e.preventDefault();

            // Make sure this tab isn't disabled
            if(!activatedTab.disabled) {

                // Check if hash has to be set in the URL location
                if(_this.options.setHash) {
                    // Set the hash using the history api if available to tackle Chromes repaint bug on hash change
                    if(history.pushState) {
                        history.pushState(null, null, activatedTab.selector);
                    } else {
                        // Otherwise fallback to the hash update for sites that don't support the history api
                        window.location.hash = activatedTab.selector;
                    }
                }

                e.data.tab._ignoreHashChange = true;

                // Check if the activated tab isnt the current one or if its collapsible. If not, do nothing
                if(current !== activatedTab || _this._isCollapisble()) {
                    // The activated tab is either another tab of the current one. If it's the current tab it is collapsible
                    // Either way, the current tab can be closed
                    _this._closeTab(e, current);

                    // Check if the activated tab isnt the current one or if it isnt collapsible
                    if(current !== activatedTab || !_this._isCollapisble()) {
                        _this._openTab(e, activatedTab, false, true);
                    }
                }
            }
        };

        // Loop tabs
        for (var i=0; i<this.tabs.length; i++) {
            // Add activate function to the tab and accordion selection element
            this.tabs[i].anchor.on(_this.options.event, {tab: _this.tabs[i]}, fActivate);
            this.tabs[i].accordionAnchor.on(_this.options.event, {tab: _this.tabs[i]}, fActivate);
        }
    };

    /**
     * This function gets the tab that should be opened at start
     * @returns {Object} Tab object
     */
    ResponsiveTabs.prototype._getStartTab = function() {
        var tabRef = this._getTabRefBySelector(window.location.hash);
        var startTab;

        // Check if the page has a hash set that is linked to a tab
        if(tabRef >= 0 && !this._getTab(tabRef).disabled) {
            // If so, set the current tab to the linked tab
            startTab = this._getTab(tabRef);
        } else if(this.options.active > 0 && !this._getTab(this.options.active).disabled) {
            startTab = this._getTab(this.options.active);
        } else {
            // If not, just get the first one
            startTab = this._getTab(0);
        }

        return startTab;
    };

    /**
     * This function sets the current state of the plugin
     * @param {Event} e - The event that triggers the state change
     */
    ResponsiveTabs.prototype._setState = function(e) {
        var $ul = $('ul', this.$element);
        var oldState = this.state;
        var startCollapsedIsState = (typeof this.options.startCollapsed === 'string');
        var startTab;

        // The state is based on the visibility of the tabs list
        if($ul.is(':visible')){
            // Tab list is visible, so the state is 'tabs'
            this.state = 'tabs';
        } else {
            // Tab list is invisible, so the state is 'accordion'
            this.state = 'accordion';
        }

        // If the new state is different from the old state
        if(this.state !== oldState) {
            // If so, the state activate trigger must be called
            this.$element.trigger('tabs-activate-state', {oldState: oldState, newState: this.state});

            // Check if the state switch should open a tab
            if(oldState && startCollapsedIsState && this.options.startCollapsed !== this.state && this._getCurrentTab() === undefined) {
                // Get initial tab
                startTab = this._getStartTab(e);
                // Open the initial tab
                this._openTab(e, startTab); // Open first tab
            }
        }
    };

    /**
     * This function opens a tab
     * @param {Event} e - The event that triggers the tab opening
     * @param {Object} oTab - The tab object that should be opened
     * @param {Boolean} closeCurrent - Defines if the current tab should be closed
     * @param {Boolean} stopRotation - Defines if the tab rotation loop should be stopped
     */
    ResponsiveTabs.prototype._openTab = function(e, oTab, closeCurrent, stopRotation) {
        var _this = this;

        // Check if the current tab has to be closed
        if(closeCurrent) {
            this._closeTab(e, this._getCurrentTab());
        }

        // Check if the rotation has to be stopped when activated
        if(stopRotation && this.rotateInterval > 0) {
            this.stopRotation();
        }

        // Set this tab to active
        oTab.active = true;
        // Set active classes to the tab button and accordion tab button
        oTab.tab.removeClass(_this.options.classes.stateDefault).addClass(_this.options.classes.stateActive);
        oTab.accordionTab.removeClass(_this.options.classes.stateDefault).addClass(_this.options.classes.stateActive);

        // Run panel transiton
        _this._doTransition(oTab.panel, _this.options.animation, 'open', function() {
            // When finished, set active class to the panel
            oTab.panel.removeClass(_this.options.classes.stateDefault).addClass(_this.options.classes.stateActive);

            // And if enabled and state is accordion, scroll to the accordion tab
            if(_this.getState() === 'accordion' && _this.options.scrollToAccordion && (!_this._isInView(oTab.accordionTab) || _this.options.animation !== 'default')) {
                // Check if the animation option is enabled, and if the duration isn't 0
                if(_this.options.animation !== 'default' && _this.options.duration > 0) {
                    // If so, set scrollTop with animate and use the 'animation' duration
                    $('html, body').animate({
                        scrollTop: oTab.accordionTab.offset().top
                    }, _this.options.duration);
                } else {
                    //  If not, just set scrollTop
                    $('html, body').scrollTop(oTab.accordionTab.offset().top);
                }
            }
        });

        this.$element.trigger('tabs-activate', oTab);
    };

    /**
     * This function closes a tab
     * @param {Event} e - The event that is triggered when a tab is closed
     * @param {Object} oTab - The tab object that should be closed
     */
    ResponsiveTabs.prototype._closeTab = function(e, oTab) {
        var _this = this;
        var doQueueOnState = typeof _this.options.animationQueue === 'string';
        var doQueue;

        if(oTab !== undefined) {
            if(doQueueOnState && _this.getState() === _this.options.animationQueue) {
                doQueue = true;
            } else if(doQueueOnState) {
                doQueue = false;
            } else {
                doQueue = _this.options.animationQueue;
            }

            // Deactivate tab
            oTab.active = false;
            // Set default class to the tab button
            oTab.tab.removeClass(_this.options.classes.stateActive).addClass(_this.options.classes.stateDefault);

            // Run panel transition
            _this._doTransition(oTab.panel, _this.options.animation, 'close', function() {
                // Set default class to the accordion tab button and tab panel
                oTab.accordionTab.removeClass(_this.options.classes.stateActive).addClass(_this.options.classes.stateDefault);
                oTab.panel.removeClass(_this.options.classes.stateActive).addClass(_this.options.classes.stateDefault);
            }, !doQueue);

            this.$element.trigger('tabs-deactivate', oTab);
        }
    };

    /**
     * This function runs an effect on a panel
     * @param {Element} panel - The HTML element of the tab panel
     * @param {String} method - The transition method reference
     * @param {String} state - The state (open/closed) that the panel should transition to
     * @param {Function} callback - The callback function that is called after the transition
     * @param {Boolean} dequeue - Defines if the event queue should be dequeued after the transition
     */
    ResponsiveTabs.prototype._doTransition = function(panel, method, state, callback, dequeue) {
        var effect;
        var _this = this;

        // Get effect based on method
        switch(method) {
            case 'slide':
                effect = (state === 'open') ? 'slideDown' : 'slideUp';
                break;
            case 'fade':
                effect = (state === 'open') ? 'fadeIn' : 'fadeOut';
                break;
            default:
                effect = (state === 'open') ? 'show' : 'hide';
                // When default is used, set the duration to 0
                _this.options.duration = 0;
                break;
        }

        // Add the transition to a custom queue
        this.$queue.queue('responsive-tabs',function(next){
            // Run the transition on the panel
            panel[effect]({
                duration: _this.options.duration,
                complete: function() {
                    // Call the callback function
                    callback.call(panel, method, state);
                    // Run the next function in the queue
                    next();
                }
            });
        });

        // When the panel is openend, dequeue everything so the animation starts
        if(state === 'open' || dequeue) {
            this.$queue.dequeue('responsive-tabs');
        }

    };

    /**
     * This function returns the collapsibility of the tab in this state
     * @returns {Boolean} The collapsibility of the tab
     */
    ResponsiveTabs.prototype._isCollapisble = function() {
        return (typeof this.options.collapsible === 'boolean' && this.options.collapsible) || (typeof this.options.collapsible === 'string' && this.options.collapsible === this.getState());
    };

    /**
     * This function returns a tab by numeric reference
     * @param {Integer} numRef - Numeric tab reference
     * @returns {Object} Tab object
     */
    ResponsiveTabs.prototype._getTab = function(numRef) {
        return this.tabs[numRef];
    };

    /**
     * This function returns the numeric tab reference based on a hash selector
     * @param {String} selector - Hash selector
     * @returns {Integer} Numeric tab reference
     */
    ResponsiveTabs.prototype._getTabRefBySelector = function(selector) {
        // Loop all tabs
        for (var i=0; i<this.tabs.length; i++) {
            // Check if the hash selector is equal to the tab selector
            if(this.tabs[i].selector === selector) {
                return i;
            }
        }
        // If none is found return a negative index
        return -1;
    };

    /**
     * This function returns the current tab element
     * @returns {Object} Current tab element
     */
    ResponsiveTabs.prototype._getCurrentTab = function() {
        return this._getTab(this._getCurrentTabRef());
    };

    /**
     * This function returns the next tab's numeric reference
     * @param {Integer} currentTabRef - Current numeric tab reference
     * @returns {Integer} Numeric tab reference
     */
    ResponsiveTabs.prototype._getNextTabRef = function(currentTabRef) {
        var tabRef = (currentTabRef || this._getCurrentTabRef());
        var nextTabRef = (tabRef === this.tabs.length - 1) ? 0 : tabRef + 1;
        return (this._getTab(nextTabRef).disabled) ? this._getNextTabRef(nextTabRef) : nextTabRef;
    };

    /**
     * This function returns the previous tab's numeric reference
     * @returns {Integer} Numeric tab reference
     */
    ResponsiveTabs.prototype._getPreviousTabRef = function() {
        return (this._getCurrentTabRef() === 0) ? this.tabs.length - 1 : this._getCurrentTabRef() - 1;
    };

    /**
     * This function returns the current tab's numeric reference
     * @returns {Integer} Numeric tab reference
     */
    ResponsiveTabs.prototype._getCurrentTabRef = function() {
        // Loop all tabs
        for (var i=0; i<this.tabs.length; i++) {
            // If this tab is active, return it
            if(this.tabs[i].active) {
                return i;
            }
        }
        // No tabs have been found, return negative index
        return -1;
    };

    //
    // HELPER FUNCTIONS
    //

    ResponsiveTabs.prototype._isInView = function($element) {
        var docViewTop = $(window).scrollTop(),
            docViewBottom = docViewTop + $(window).height(),
            elemTop = $element.offset().top,
            elemBottom = elemTop + $element.height();
        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    };

    //
    // PUBLIC FUNCTIONS
    //

    /**
     * This function activates a tab
     * @param {Integer} tabRef - Numeric tab reference
     * @param {Boolean} stopRotation - Defines if the tab rotation should stop after activation
     */
    ResponsiveTabs.prototype.activate = function(tabRef, stopRotation) {
        var e = jQuery.Event('tabs-activate');
        var oTab = this._getTab(tabRef);
        if(!oTab.disabled) {
            this._openTab(e, oTab, true, stopRotation || true);
        }
    };

    /**
     * This function deactivates a tab
     * @param {Integer} tabRef - Numeric tab reference
     */
    ResponsiveTabs.prototype.deactivate = function(tabRef) {
        var e = jQuery.Event('tabs-dectivate');
        var oTab = this._getTab(tabRef);
        if(!oTab.disabled) {
            this._closeTab(e, oTab);
        }
    };

    /**
     * This function enables a tab
     * @param {Integer} tabRef - Numeric tab reference
     */
    ResponsiveTabs.prototype.enable = function(tabRef) {
        var oTab = this._getTab(tabRef);
        if(oTab){
            oTab.disabled = false;
            oTab.tab.addClass(this.options.classes.stateDefault).removeClass(this.options.classes.stateDisabled);
            oTab.accordionTab.addClass(this.options.classes.stateDefault).removeClass(this.options.classes.stateDisabled);
        }
    };

    /**
     * This function disable a tab
     * @param {Integer} tabRef - Numeric tab reference
     */
    ResponsiveTabs.prototype.disable = function(tabRef) {
        var oTab = this._getTab(tabRef);
        if(oTab){
            oTab.disabled = true;
            oTab.tab.removeClass(this.options.classes.stateDefault).addClass(this.options.classes.stateDisabled);
            oTab.accordionTab.removeClass(this.options.classes.stateDefault).addClass(this.options.classes.stateDisabled);
        }
    };

    /**
     * This function gets the current state of the plugin
     * @returns {String} State of the plugin
     */
    ResponsiveTabs.prototype.getState = function() {
        return this.state;
    };

    /**
     * This function starts the rotation of the tabs
     * @param {Integer} speed - The speed of the rotation
     */
    ResponsiveTabs.prototype.startRotation = function(speed) {
        var _this = this;
        // Make sure not all tabs are disabled
        if(this.tabs.length > this.options.disabled.length) {
            this.rotateInterval = setInterval(function(){
                var e = jQuery.Event('rotate');
                _this._openTab(e, _this._getTab(_this._getNextTabRef()), true);
            }, speed || (($.isNumeric(_this.options.rotate)) ? _this.options.rotate : 4000) );
        } else {
            throw new Error("Rotation is not possible if all tabs are disabled");
        }
    };

    /**
     * This function stops the rotation of the tabs
     */
    ResponsiveTabs.prototype.stopRotation = function() {
        window.clearInterval(this.rotateInterval);
        this.rotateInterval = 0;
    };

    /**
     * This function can be used to get/set options
     * @return {any} Option value
     */
    ResponsiveTabs.prototype.option = function(key, value) {
        if(value) {
            this.options[key] = value;
        }
        return this.options[key];
    };

    /** jQuery wrapper */
    $.fn.responsiveTabs = function ( options ) {
        var args = arguments;
        if (options === undefined || typeof options === 'object') {
            return this.each(function () {
                if (!$.data(this, 'responsivetabs')) {
                    $.data(this, 'responsivetabs', new ResponsiveTabs( this, options ));
                }
            });
        } else if (typeof options === 'string' && options[0] !== '_' && options !== 'init') {
            return this.each(function () {
                var instance = $.data(this, 'responsivetabs');

                if (instance instanceof ResponsiveTabs && typeof instance[options] === 'function') {
                    instance[options].apply( instance, Array.prototype.slice.call( args, 1 ) );
                }

                // Allow instances to be destroyed via the 'destroy' method
                if (options === 'destroy') {
                    // TODO: destroy instance classes, etc
                    $.data(this, 'responsivetabs', null);
                }
            });
        }
    };

}(jQuery, window));
/* Tooltipster v3.3.0 */;(function(e,t,n){function s(t,n){this.bodyOverflowX;this.callbacks={hide:[],show:[]};this.checkInterval=null;this.Content;this.$el=e(t);this.$elProxy;this.elProxyPosition;this.enabled=true;this.options=e.extend({},i,n);this.mouseIsOverProxy=false;this.namespace="tooltipster-"+Math.round(Math.random()*1e5);this.Status="hidden";this.timerHide=null;this.timerShow=null;this.$tooltip;this.options.iconTheme=this.options.iconTheme.replace(".","");this.options.theme=this.options.theme.replace(".","");this._init()}function o(t,n){var r=true;e.each(t,function(e,i){if(typeof n[e]==="undefined"||t[e]!==n[e]){r=false;return false}});return r}function f(){return!a&&u}function l(){var e=n.body||n.documentElement,t=e.style,r="transition";if(typeof t[r]=="string"){return true}v=["Moz","Webkit","Khtml","O","ms"],r=r.charAt(0).toUpperCase()+r.substr(1);for(var i=0;i<v.length;i++){if(typeof t[v[i]+r]=="string"){return true}}return false}var r="tooltipster",i={animation:"fade",arrow:true,arrowColor:"",autoClose:true,content:null,contentAsHTML:false,contentCloning:true,debug:true,delay:200,minWidth:0,maxWidth:null,functionInit:function(e,t){},functionBefore:function(e,t){t()},functionReady:function(e,t){},functionAfter:function(e){},hideOnClick:false,icon:"(?)",iconCloning:true,iconDesktop:false,iconTouch:false,iconTheme:"tooltipster-icon",interactive:false,interactiveTolerance:350,multiple:false,offsetX:0,offsetY:0,onlyOne:false,position:"top",positionTracker:false,positionTrackerCallback:function(e){if(this.option("trigger")=="hover"&&this.option("autoClose")){this.hide()}},restoration:"current",speed:350,timer:0,theme:"tooltipster-default",touchDevices:true,trigger:"hover",updateAnimation:true};s.prototype={_init:function(){var t=this;if(n.querySelector){var r=null;if(t.$el.data("tooltipster-initialTitle")===undefined){r=t.$el.attr("title");if(r===undefined)r=null;t.$el.data("tooltipster-initialTitle",r)}if(t.options.content!==null){t._content_set(t.options.content)}else{t._content_set(r)}var i=t.options.functionInit.call(t.$el,t.$el,t.Content);if(typeof i!=="undefined")t._content_set(i);t.$el.removeAttr("title").addClass("tooltipstered");if(!u&&t.options.iconDesktop||u&&t.options.iconTouch){if(typeof t.options.icon==="string"){t.$elProxy=e('<span class="'+t.options.iconTheme+'"></span>');t.$elProxy.text(t.options.icon)}else{if(t.options.iconCloning)t.$elProxy=t.options.icon.clone(true);else t.$elProxy=t.options.icon}t.$elProxy.insertAfter(t.$el)}else{t.$elProxy=t.$el}if(t.options.trigger=="hover"){t.$elProxy.on("mouseenter."+t.namespace,function(){if(!f()||t.options.touchDevices){t.mouseIsOverProxy=true;t._show()}}).on("mouseleave."+t.namespace,function(){if(!f()||t.options.touchDevices){t.mouseIsOverProxy=false}});if(u&&t.options.touchDevices){t.$elProxy.on("touchstart."+t.namespace,function(){t._showNow()})}}else if(t.options.trigger=="click"){t.$elProxy.on("click."+t.namespace,function(){if(!f()||t.options.touchDevices){t._show()}})}}},_show:function(){var e=this;if(e.Status!="shown"&&e.Status!="appearing"){if(e.options.delay){e.timerShow=setTimeout(function(){if(e.options.trigger=="click"||e.options.trigger=="hover"&&e.mouseIsOverProxy){e._showNow()}},e.options.delay)}else e._showNow()}},_showNow:function(n){var r=this;r.options.functionBefore.call(r.$el,r.$el,function(){if(r.enabled&&r.Content!==null){if(n)r.callbacks.show.push(n);r.callbacks.hide=[];clearTimeout(r.timerShow);r.timerShow=null;clearTimeout(r.timerHide);r.timerHide=null;if(r.options.onlyOne){e(".tooltipstered").not(r.$el).each(function(t,n){var r=e(n),i=r.data("tooltipster-ns");e.each(i,function(e,t){var n=r.data(t),i=n.status(),s=n.option("autoClose");if(i!=="hidden"&&i!=="disappearing"&&s){n.hide()}})})}var i=function(){r.Status="shown";e.each(r.callbacks.show,function(e,t){t.call(r.$el)});r.callbacks.show=[]};if(r.Status!=="hidden"){var s=0;if(r.Status==="disappearing"){r.Status="appearing";if(l()){r.$tooltip.clearQueue().removeClass("tooltipster-dying").addClass("tooltipster-"+r.options.animation+"-show");if(r.options.speed>0)r.$tooltip.delay(r.options.speed);r.$tooltip.queue(i)}else{r.$tooltip.stop().fadeIn(i)}}else if(r.Status==="shown"){i()}}else{r.Status="appearing";var s=r.options.speed;r.bodyOverflowX=e("body").css("overflow-x");e("body").css("overflow-x","hidden");var o="tooltipster-"+r.options.animation,a="-webkit-transition-duration: "+r.options.speed+"ms; -webkit-animation-duration: "+r.options.speed+"ms; -moz-transition-duration: "+r.options.speed+"ms; -moz-animation-duration: "+r.options.speed+"ms; -o-transition-duration: "+r.options.speed+"ms; -o-animation-duration: "+r.options.speed+"ms; -ms-transition-duration: "+r.options.speed+"ms; -ms-animation-duration: "+r.options.speed+"ms; transition-duration: "+r.options.speed+"ms; animation-duration: "+r.options.speed+"ms;",f=r.options.minWidth?"min-width:"+Math.round(r.options.minWidth)+"px;":"",c=r.options.maxWidth?"max-width:"+Math.round(r.options.maxWidth)+"px;":"",h=r.options.interactive?"pointer-events: auto;":"";r.$tooltip=e('<div class="tooltipster-base '+r.options.theme+'" style="'+f+" "+c+" "+h+" "+a+'"><div class="tooltipster-content"></div></div>');if(l())r.$tooltip.addClass(o);r._content_insert();r.$tooltip.appendTo("body");r.reposition();r.options.functionReady.call(r.$el,r.$el,r.$tooltip);if(l()){r.$tooltip.addClass(o+"-show");if(r.options.speed>0)r.$tooltip.delay(r.options.speed);r.$tooltip.queue(i)}else{r.$tooltip.css("display","none").fadeIn(r.options.speed,i)}r._interval_set();e(t).on("scroll."+r.namespace+" resize."+r.namespace,function(){r.reposition()});if(r.options.autoClose){e("body").off("."+r.namespace);if(r.options.trigger=="hover"){if(u){setTimeout(function(){e("body").on("touchstart."+r.namespace,function(){r.hide()})},0)}if(r.options.interactive){if(u){r.$tooltip.on("touchstart."+r.namespace,function(e){e.stopPropagation()})}var p=null;r.$elProxy.add(r.$tooltip).on("mouseleave."+r.namespace+"-autoClose",function(){clearTimeout(p);p=setTimeout(function(){r.hide()},r.options.interactiveTolerance)}).on("mouseenter."+r.namespace+"-autoClose",function(){clearTimeout(p)})}else{r.$elProxy.on("mouseleave."+r.namespace+"-autoClose",function(){r.hide()})}if(r.options.hideOnClick){r.$elProxy.on("click."+r.namespace+"-autoClose",function(){r.hide()})}}else if(r.options.trigger=="click"){setTimeout(function(){e("body").on("click."+r.namespace+" touchstart."+r.namespace,function(){r.hide()})},0);if(r.options.interactive){r.$tooltip.on("click."+r.namespace+" touchstart."+r.namespace,function(e){e.stopPropagation()})}}}}if(r.options.timer>0){r.timerHide=setTimeout(function(){r.timerHide=null;r.hide()},r.options.timer+s)}}})},_interval_set:function(){var t=this;t.checkInterval=setInterval(function(){if(e("body").find(t.$el).length===0||e("body").find(t.$elProxy).length===0||t.Status=="hidden"||e("body").find(t.$tooltip).length===0){if(t.Status=="shown"||t.Status=="appearing")t.hide();t._interval_cancel()}else{if(t.options.positionTracker){var n=t._repositionInfo(t.$elProxy),r=false;if(o(n.dimension,t.elProxyPosition.dimension)){if(t.$elProxy.css("position")==="fixed"){if(o(n.position,t.elProxyPosition.position))r=true}else{if(o(n.offset,t.elProxyPosition.offset))r=true}}if(!r){t.reposition();t.options.positionTrackerCallback.call(t,t.$el)}}}},200)},_interval_cancel:function(){clearInterval(this.checkInterval);this.checkInterval=null},_content_set:function(e){if(typeof e==="object"&&e!==null&&this.options.contentCloning){e=e.clone(true)}this.Content=e},_content_insert:function(){var e=this,t=this.$tooltip.find(".tooltipster-content");if(typeof e.Content==="string"&&!e.options.contentAsHTML){t.text(e.Content)}else{t.empty().append(e.Content)}},_update:function(e){var t=this;t._content_set(e);if(t.Content!==null){if(t.Status!=="hidden"){t._content_insert();t.reposition();if(t.options.updateAnimation){if(l()){t.$tooltip.css({width:"","-webkit-transition":"all "+t.options.speed+"ms, width 0ms, height 0ms, left 0ms, top 0ms","-moz-transition":"all "+t.options.speed+"ms, width 0ms, height 0ms, left 0ms, top 0ms","-o-transition":"all "+t.options.speed+"ms, width 0ms, height 0ms, left 0ms, top 0ms","-ms-transition":"all "+t.options.speed+"ms, width 0ms, height 0ms, left 0ms, top 0ms",transition:"all "+t.options.speed+"ms, width 0ms, height 0ms, left 0ms, top 0ms"}).addClass("tooltipster-content-changing");setTimeout(function(){if(t.Status!="hidden"){t.$tooltip.removeClass("tooltipster-content-changing");setTimeout(function(){if(t.Status!=="hidden"){t.$tooltip.css({"-webkit-transition":t.options.speed+"ms","-moz-transition":t.options.speed+"ms","-o-transition":t.options.speed+"ms","-ms-transition":t.options.speed+"ms",transition:t.options.speed+"ms"})}},t.options.speed)}},t.options.speed)}else{t.$tooltip.fadeTo(t.options.speed,.5,function(){if(t.Status!="hidden"){t.$tooltip.fadeTo(t.options.speed,1)}})}}}}else{t.hide()}},_repositionInfo:function(e){return{dimension:{height:e.outerHeight(false),width:e.outerWidth(false)},offset:e.offset(),position:{left:parseInt(e.css("left")),top:parseInt(e.css("top"))}}},hide:function(n){var r=this;if(n)r.callbacks.hide.push(n);r.callbacks.show=[];clearTimeout(r.timerShow);r.timerShow=null;clearTimeout(r.timerHide);r.timerHide=null;var i=function(){e.each(r.callbacks.hide,function(e,t){t.call(r.$el)});r.callbacks.hide=[]};if(r.Status=="shown"||r.Status=="appearing"){r.Status="disappearing";var s=function(){r.Status="hidden";if(typeof r.Content=="object"&&r.Content!==null){r.Content.detach()}r.$tooltip.remove();r.$tooltip=null;e(t).off("."+r.namespace);e("body").off("."+r.namespace).css("overflow-x",r.bodyOverflowX);e("body").off("."+r.namespace);r.$elProxy.off("."+r.namespace+"-autoClose");r.options.functionAfter.call(r.$el,r.$el);i()};if(l()){r.$tooltip.clearQueue().removeClass("tooltipster-"+r.options.animation+"-show").addClass("tooltipster-dying");if(r.options.speed>0)r.$tooltip.delay(r.options.speed);r.$tooltip.queue(s)}else{r.$tooltip.stop().fadeOut(r.options.speed,s)}}else if(r.Status=="hidden"){i()}return r},show:function(e){this._showNow(e);return this},update:function(e){return this.content(e)},content:function(e){if(typeof e==="undefined"){return this.Content}else{this._update(e);return this}},reposition:function(){var n=this;if(e("body").find(n.$tooltip).length!==0){n.$tooltip.css("width","");n.elProxyPosition=n._repositionInfo(n.$elProxy);var r=null,i=e(t).width(),s=n.elProxyPosition,o=n.$tooltip.outerWidth(false),u=n.$tooltip.innerWidth()+1,a=n.$tooltip.outerHeight(false);if(n.$elProxy.is("area")){var f=n.$elProxy.attr("shape"),l=n.$elProxy.parent().attr("name"),c=e('img[usemap="#'+l+'"]'),h=c.offset().left,p=c.offset().top,d=n.$elProxy.attr("coords")!==undefined?n.$elProxy.attr("coords").split(","):undefined;if(f=="circle"){var v=parseInt(d[0]),m=parseInt(d[1]),g=parseInt(d[2]);s.dimension.height=g*2;s.dimension.width=g*2;s.offset.top=p+m-g;s.offset.left=h+v-g}else if(f=="rect"){var v=parseInt(d[0]),m=parseInt(d[1]),y=parseInt(d[2]),b=parseInt(d[3]);s.dimension.height=b-m;s.dimension.width=y-v;s.offset.top=p+m;s.offset.left=h+v}else if(f=="poly"){var w=[],E=[],S=0,x=0,T=0,N=0,C="even";for(var k=0;k<d.length;k++){var L=parseInt(d[k]);if(C=="even"){if(L>T){T=L;if(k===0){S=T}}if(L<S){S=L}C="odd"}else{if(L>N){N=L;if(k==1){x=N}}if(L<x){x=L}C="even"}}s.dimension.height=N-x;s.dimension.width=T-S;s.offset.top=p+x;s.offset.left=h+S}else{s.dimension.height=c.outerHeight(false);s.dimension.width=c.outerWidth(false);s.offset.top=p;s.offset.left=h}}var A=0,O=0,M=0,_=parseInt(n.options.offsetY),D=parseInt(n.options.offsetX),P=n.options.position;function H(){var n=e(t).scrollLeft();if(A-n<0){r=A-n;A=n}if(A+o-n>i){r=A-(i+n-o);A=i+n-o}}function B(n,r){if(s.offset.top-e(t).scrollTop()-a-_-12<0&&r.indexOf("top")>-1){P=n}if(s.offset.top+s.dimension.height+a+12+_>e(t).scrollTop()+e(t).height()&&r.indexOf("bottom")>-1){P=n;M=s.offset.top-a-_-12}}if(P=="top"){var j=s.offset.left+o-(s.offset.left+s.dimension.width);A=s.offset.left+D-j/2;M=s.offset.top-a-_-12;H();B("bottom","top")}if(P=="top-left"){A=s.offset.left+D;M=s.offset.top-a-_-12;H();B("bottom-left","top-left")}if(P=="top-right"){A=s.offset.left+s.dimension.width+D-o;M=s.offset.top-a-_-12;H();B("bottom-right","top-right")}if(P=="bottom"){var j=s.offset.left+o-(s.offset.left+s.dimension.width);A=s.offset.left-j/2+D;M=s.offset.top+s.dimension.height+_+12;H();B("top","bottom")}if(P=="bottom-left"){A=s.offset.left+D;M=s.offset.top+s.dimension.height+_+12;H();B("top-left","bottom-left")}if(P=="bottom-right"){A=s.offset.left+s.dimension.width+D-o;M=s.offset.top+s.dimension.height+_+12;H();B("top-right","bottom-right")}if(P=="left"){A=s.offset.left-D-o-12;O=s.offset.left+D+s.dimension.width+12;var F=s.offset.top+a-(s.offset.top+s.dimension.height);M=s.offset.top-F/2-_;if(A<0&&O+o>i){var I=parseFloat(n.$tooltip.css("border-width"))*2,q=o+A-I;n.$tooltip.css("width",q+"px");a=n.$tooltip.outerHeight(false);A=s.offset.left-D-q-12-I;F=s.offset.top+a-(s.offset.top+s.dimension.height);M=s.offset.top-F/2-_}else if(A<0){A=s.offset.left+D+s.dimension.width+12;r="left"}}if(P=="right"){A=s.offset.left+D+s.dimension.width+12;O=s.offset.left-D-o-12;var F=s.offset.top+a-(s.offset.top+s.dimension.height);M=s.offset.top-F/2-_;if(A+o>i&&O<0){var I=parseFloat(n.$tooltip.css("border-width"))*2,q=i-A-I;n.$tooltip.css("width",q+"px");a=n.$tooltip.outerHeight(false);F=s.offset.top+a-(s.offset.top+s.dimension.height);M=s.offset.top-F/2-_}else if(A+o>i){A=s.offset.left-D-o-12;r="right"}}if(n.options.arrow){var R="tooltipster-arrow-"+P;if(n.options.arrowColor.length<1){var U=n.$tooltip.css("background-color")}else{var U=n.options.arrowColor}if(!r){r=""}else if(r=="left"){R="tooltipster-arrow-right";r=""}else if(r=="right"){R="tooltipster-arrow-left";r=""}else{r="left:"+Math.round(r)+"px;"}if(P=="top"||P=="top-left"||P=="top-right"){var z=parseFloat(n.$tooltip.css("border-bottom-width")),W=n.$tooltip.css("border-bottom-color")}else if(P=="bottom"||P=="bottom-left"||P=="bottom-right"){var z=parseFloat(n.$tooltip.css("border-top-width")),W=n.$tooltip.css("border-top-color")}else if(P=="left"){var z=parseFloat(n.$tooltip.css("border-right-width")),W=n.$tooltip.css("border-right-color")}else if(P=="right"){var z=parseFloat(n.$tooltip.css("border-left-width")),W=n.$tooltip.css("border-left-color")}else{var z=parseFloat(n.$tooltip.css("border-bottom-width")),W=n.$tooltip.css("border-bottom-color")}if(z>1){z++}var X="";if(z!==0){var V="",J="border-color: "+W+";";if(R.indexOf("bottom")!==-1){V="margin-top: -"+Math.round(z)+"px;"}else if(R.indexOf("top")!==-1){V="margin-bottom: -"+Math.round(z)+"px;"}else if(R.indexOf("left")!==-1){V="margin-right: -"+Math.round(z)+"px;"}else if(R.indexOf("right")!==-1){V="margin-left: -"+Math.round(z)+"px;"}X='<span class="tooltipster-arrow-border" style="'+V+" "+J+';"></span>'}n.$tooltip.find(".tooltipster-arrow").remove();var K='<div class="'+R+' tooltipster-arrow" style="'+r+'">'+X+'<span style="border-color:'+U+';"></span></div>';n.$tooltip.append(K)}n.$tooltip.css({top:Math.round(M)+"px",left:Math.round(A)+"px"})}return n},enable:function(){this.enabled=true;return this},disable:function(){this.hide();this.enabled=false;return this},destroy:function(){var t=this;t.hide();if(t.$el[0]!==t.$elProxy[0]){t.$elProxy.remove()}t.$el.removeData(t.namespace).off("."+t.namespace);var n=t.$el.data("tooltipster-ns");if(n.length===1){var r=null;if(t.options.restoration==="previous"){r=t.$el.data("tooltipster-initialTitle")}else if(t.options.restoration==="current"){r=typeof t.Content==="string"?t.Content:e("<div></div>").append(t.Content).html()}if(r){t.$el.attr("title",r)}t.$el.removeClass("tooltipstered").removeData("tooltipster-ns").removeData("tooltipster-initialTitle")}else{n=e.grep(n,function(e,n){return e!==t.namespace});t.$el.data("tooltipster-ns",n)}return t},elementIcon:function(){return this.$el[0]!==this.$elProxy[0]?this.$elProxy[0]:undefined},elementTooltip:function(){return this.$tooltip?this.$tooltip[0]:undefined},option:function(e,t){if(typeof t=="undefined")return this.options[e];else{this.options[e]=t;return this}},status:function(){return this.Status}};e.fn[r]=function(){var t=arguments;if(this.length===0){if(typeof t[0]==="string"){var n=true;switch(t[0]){case"setDefaults":e.extend(i,t[1]);break;default:n=false;break}if(n)return true;else return this}else{return this}}else{if(typeof t[0]==="string"){var r="#*$~&";this.each(function(){var n=e(this).data("tooltipster-ns"),i=n?e(this).data(n[0]):null;if(i){if(typeof i[t[0]]==="function"){var s=i[t[0]](t[1],t[2])}else{throw new Error('Unknown method .tooltipster("'+t[0]+'")')}if(s!==i){r=s;return false}}else{throw new Error("You called Tooltipster's \""+t[0]+'" method on an uninitialized element')}});return r!=="#*$~&"?r:this}else{var o=[],u=t[0]&&typeof t[0].multiple!=="undefined",a=u&&t[0].multiple||!u&&i.multiple,f=t[0]&&typeof t[0].debug!=="undefined",l=f&&t[0].debug||!f&&i.debug;this.each(function(){var n=false,r=e(this).data("tooltipster-ns"),i=null;if(!r){n=true}else if(a){n=true}else if(l){console.log('Tooltipster: one or more tooltips are already attached to this element: ignoring. Use the "multiple" option to attach more tooltips.')}if(n){i=new s(this,t[0]);if(!r)r=[];r.push(i.namespace);e(this).data("tooltipster-ns",r);e(this).data(i.namespace,i)}o.push(i)});if(a)return o;else return this}}};var u=!!("ontouchstart"in t);var a=false;e("body").one("mousemove",function(){a=true})})(jQuery,window,document);
;(function($) {
    var methods = {
        init: function(settings) {

            return this.each(function() {
                var self = this;
                if (typeof self.pleaseWait != 'undefined')
                    return;
                self.pleaseWait = {
                    opt:  $.extend(true, {}, $.fn.pleaseWait.defaults, settings),
                    cog: document.createElement('img'),
                    timer: false,
                    overlay: document.createElement('div'),
                    degrees: 1
                };

                var targetWidth = $(self).outerWidth();
                var targetHeight = $(self).outerHeight();
                var verticalMidpoint = (targetHeight / 2) - (self.pleaseWait.opt.height / 2);
                var horizontalMidpoint = (targetWidth / 2) - (self.pleaseWait.opt.width / 2);
                var offset = $(self).offset();

                $(self.pleaseWait.cog).css({
                    'position':'fixed',
                    'z-index':'999999',
                    'left':offset.left + horizontalMidpoint,
                    'top':offset.top + verticalMidpoint
                });
                $(document.body).append(self.pleaseWait.cog);

                self.pleaseWait.overlay = document.createElement('div');
                $(self.pleaseWait.overlay).css({
                    'position':'fixed',
                    'z-index':'999998',
                    'left':offset.left,
                    'top':offset.top,
                    'width':targetWidth,
                    'height':targetHeight,
                    'background-color':'rgba(255,255,255,0.8)',
                    'display':'none'
                });
                $(document.body).append(self.pleaseWait.overlay);

                if (self.pleaseWait.opt.imageType != 'encoded' && self.pleaseWait.opt.image.length > 0) {
                    self.pleaseWait.cog.src = self.pleaseWait.opt.image;
                } else {
                    self.pleaseWait.cog.src = 'data:image/png;base64,'+self.pleaseWait.opt.image;
                }

                $(self).attr('data-pleaseWait', '1');

                methods.start.call(self);

            });
        },
        start: function () {
            var self = $(this);
            if (typeof self.length != 'undefined' && self.length > 0)
                self = self[0];
            if (typeof self.pleaseWait == 'undefined')
                return;

            var targetWidth = $(self).outerWidth();
            var targetHeight = $(self).outerHeight();
            var verticalMidpoint = (targetHeight / 2) - (self.pleaseWait.opt.height / 2);
            var horizontalMidpoint = (targetWidth / 2) - (self.pleaseWait.opt.width / 2);
            var offset = $(self).offset();
            $(self.pleaseWait.cog).css({
                'left':offset.left + horizontalMidpoint,
                'top':offset.top + verticalMidpoint
            });
            $(self.pleaseWait.overlay).css({
                'left':offset.left,
                'top':offset.top,
                'width':targetWidth,
                'height':targetHeight,
            });

            $(self.pleaseWait.cog).css('display', '');
            $(self.pleaseWait.overlay).css('display', '');
            if (self.pleaseWait.timer != false)
                clearTimeout(self.pleaseWait.timer);
            var drawMethod = methods.draw;
            var removeMethod = methods.remove;
            self.pleaseWait.timer = setInterval(function () {
                if (document.body.contains(self)) {
                    drawMethod.call(self)
                } else {
                    removeMethod.call(self);
                }
            },self.pleaseWait.opt.speed);
            return self;
        },
        stop: function () {
            var self = $(this);
            if (typeof self.length != 'undefined' && self.length > 0)
                self = self[0];
            if (typeof self.pleaseWait == 'undefined')
                return;
            if (self.pleaseWait.timer != false)
                clearTimeout(self.pleaseWait.timer);
            self.pleaseWait.timer = false;
            $(self.pleaseWait.cog).css('display', 'none');
            $(self.pleaseWait.overlay).css('display', 'none');
            return self;
        },
        draw: function () {
            var self = this;
            if (typeof self.length != 'undefined' && self.length > 0)
                self = self[0];
            if (typeof self.pleaseWait == 'undefined')
                return;

            var rotateTarget = self.pleaseWait.cog;
            if (self.pleaseWait.opt.crazy)
                rotateTarget = self;

            if(navigator.userAgent.match("MSIE")){
                rotateTarget.style.msTransform = "rotate("+self.pleaseWait.degrees+"deg)";
            } else if(navigator.userAgent.match("Opera")){
                rotateTarget.style.OTransform = "rotate("+self.pleaseWait.degrees+"deg)";
            } else {
                rotateTarget.style.transform = "rotate("+self.pleaseWait.degrees+"deg)";
            }
            self.pleaseWait.degrees = parseInt(self.pleaseWait.degrees) + parseInt(self.pleaseWait.opt.increment);
            if(self.pleaseWait.degrees > 359){
                self.pleaseWait.degrees = 1;
            }
        },
        remove: function () {
            var self = this;
            if (typeof self.length != 'undefined' && self.length > 0)
                self = self[0];
            if (typeof self.pleaseWait != 'undefined'){
                if (self.pleaseWait.timer != false)
                    clearTimeout(self.pleaseWait.timer);

                $(self.pleaseWait.cog).remove();
                $(self.pleaseWait.overlay).remove();

                $(self).removeAttr('data-pleaseWait');
                delete self.pleaseWait.overlay;
                delete self.pleaseWait.opt;
                delete self.pleaseWait.cog;
                delete self.pleaseWait.timer;
                delete self.pleaseWait;
            }
        }
    };
    $.fn.pleaseWait = function(method) {
        if (!methods[method]) {
            var attr = $(this).attr('data-pleaseWait');
            if (typeof attr == 'undefined' || attr == false)
                return methods.init.apply(this, arguments);
            method = 'start';
        }
        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('pleaseWait plugin :: method "' + method + '" does not exist!');
        }
    };
    // reverse image
    // 'iVBORw0KGgoAAAANSUhEUgAAAEEAAABBCAYAAACO98lFAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABEFJREFUeNrsW1tIFFEYPpuG2ZppGl3QUInAl8igCxZdiKCHKKwIeuitCCKoHoIopHqo6CGKqCB66SIEPtiFiOglwgysSBGiCCnBJK00b+ul3Xb6f+YbPJ40d2Yvs7tnfvjYOcPOmdlv/tv5/7M+wzCE7jLNpfseJxjAeV1J8DQhHUnII+xKZRIyo7g2g7CPcJTgJ3wgvNdNE/4QNhFyQchZXc3hDMhgWUmo0pEEVv8aaXyMMF1Hx3iB0IvjEsIBHUnoBRGWHCbM1zFPqJEiA0eKah1JYOd4UhpXwVFqlzG+JjyTxqd0TZtPE4I4rkiVkDkZCcUO52sj3JDG1fARSS2+CeoJawmXCQ8J1wndNufkH10vRYirhHPKd5ZJPqMZppQ0JHCiUytpwiDhJs4FbczLZnANx98JK2xe7yoJ+YQThI3K99oJVwjPbcxdi7B5idCfauYg8OY4BS5Tzr+CqXxOp3qC7z81RnaaOwgHsVK0JEyog60PpjsJluQQDoEQOZr0w3HWgZi0JsESNo0jhErlPJvGRUKjDiRYsk6Y1SQ1l9grzOqSFiRYoXQ3YT/M5SW0ROhEgiUFcJy3EEa1JCHtQ6RHgkeCR4KeJHALbY3D698R7qY6CdyGm0tY7PD6jnTQBK8rDXNgTZjt8PoBQpfnGL3o4JHgkeCRMF7mEX6IxFeXMnBPw00SsglbCRuEWVl+kWASOKr5hFnmG3GDhPWE7WKsuxQQZrcpkCAC/EpYHyX0EUKJIGGJMCtKamntE+E24WeCSMgGCWqyF0DuEo4HCYXC3KZXoZzn7hJXm5tcynZniX97nWEQEYgVCVmELYTNYvxeJFa/p8JsxYeEu5IJrchSzodgIqPRkLCasFOMb7ywNBAeiORrrc3As6p7M0fwrCE7JJQQ9uBTljbCPXxGImUwl2i7VHlQ7Ugauj6YR47iLwzJXxhTkTBHmJsy5Ql6CPeFvfa5Hw6UH6oZCDtwfsWwe36GLzb9BWvFTOX8MOHXVEtpvlk9jpn5J8LcfWJ3/8Aq+BBWzVKHCU0GCLBeTo6Na5nwXiRxv6Xzg5Gagx++4DFIsSu8OWObNH5E6FS+w0Wcchy3isk7V6UggGWI8NEhodl4IQORFlXYdu44JIDVXy7VtU5AgB35KpkRq3a+w3mGJyMgHpUlfrsFkjlF26QNwrlaUhSHZ47phOwDlkvjphil0d+kyMD3WJDMJFRI3ph/fEuM5g3DLORVa1YyksDhaKk0bozx0rpH8uw+4XyLYVxJqJTm6oRDjLW0S5FhthQ+k4KERYCVmTXEKS0eUiJWEbTCdRJ8WGNYwvG+W8RPOpSQWZgMJJQjtxfIzN7EeZEURLSwZKGI7s9sMSPBkuZIlq0xkC7pPpnSS3CNBN7//Ba22iISIwac5BAqWlFXs9wquUe6dkhYiUp78Uhw0RxypRVhnxj7S6Er8leAAQAs1TY2lWgC2wAAAABJRU5ErkJggg=='
    $.fn.pleaseWait.defaults = {
        crazy:false,
        speed:8,
        increment: 2,
        image:'iVBORw0KGgoAAAANSUhEUgAAAEEAAABBCAYAAACO98lFAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABK1JREFUeNrsXFtIFFEYPqsbZl7S1G5oqETgS2SghUUXIughCiuCHnrrAhFUD0EUUj1E9BBFVBC9RAWBD92IiF4iykCLlCCKkBLU0i5meU/b7f/b79DxtLo7t53dnf3hw5lxZ+bMN//9nF1fMBgUsRSfzxf2eKzHoUqaS/c9xM8NnBQuS5pIifDbqdKRxE2Vd1oT8ghbPKcJkHTCDsIBQhbhDeF1IpJgRRN+E9YQckHIiUTVBKvmcBxksFQTar1IAqv/dWX/IGGK10hgOUXoxXYpYbcXSegFEVL2EWZ7jQQBk5CRgSNFnRdJYOd4RNmvhaP0FAksTYSHyv7RhCOBU+FoMYkcI4xiuzJRQuZEmlBi8npthEvKfh18RHwLFzVaYbOc8AIPUGDikvzQLwkfgcNhCqhFhF1AtToON+CTA4Oac6JTr2hCP+Eyjo0aIILN4AK2PxOq+Py/N4zDpopOQj7e3Grtc+2Ec4RHBq5dj7B5hvAznktpnQQpVUiBy7XPPyOcJbxPpn7CRCRIp7mJsAeVopQA4SbhPMwlqUmQkk3YC0LUaMIqfhGEBOL9Qa2SIIVNYz+hRjvOpnGa0OgFEqSsQDdJzyW2c3fJKyTIULqVsBPm8hRaIrxEgpQCOM4rCKOeJCFhIkBUJHhZUiSkSAAJXvUDOgk8hbbM5PlcMl9LdBJ4Gq6IMN/k+Z3JYA6pqXmYA2vCdJPn9xG6k8EnpBxjKkSmSEjM2sGOcepjtIOEWYQvAt2lGJKQjnsG3SQhk7CesEqEOsuPY0xCERw7t/mG3SBhJWGj+De7NCBCkzUDMSIhSwvrI4QfhDEzJBhduLVAhDpKJWEyx0yQEQsJADLZyyDMxP37hNL4tdMxFqLGqNSO8+wSd5ubXXCMTECO+H+uMwAiBuwyB2Z4HWGtGL8WidXvgQhNxY+5HB38MI0M7fgYTGTECglLCZvF+IkXlgbCbTgkR8KnyUg1FWPVTXwYYx0zQkIpYRv+qtJGuIG/0Ug5zKXfIgl5UO1oJoR9MI9srTgMKv4iGImEGSK0KFO9QA/hlgitRIlWsuBA+aItQMAgCZlwwDkYwweD1TFrxTTt+BDhuz4OvZTmmz3BNjN/X4RWnzQZVM0l8CGsmmVqQmNg9Us6CJAvJ9tg9OhFEvdLOd4fbXTIgi+4B1KMCi/f26Ds3yV0SXPAfbiJU4H/twpt5koZSxkIYBkkvDWTIUKr/DAHEUkTZOJz1SQBPHq1VdcqCTApHUrMZ9XON3mdIUlAOPGbCW2TeG9+uwWKOTVajIijcK5ycWgx1DxgZ+FmZ3uNfcBiZb/ZpgzykxIZ+B5z7M497CShUvHG/PCvbEyRO7SqNSMeSeBwtFDZbzSav0eQHsWz+4T5JYaOklCjXKsLDtFuaVciw3QlfMYFCfMAmZk1OFQ2DGoRq1jY1Ci2SoIPNYYU/h7UNwfrp04tZBbGAwkVyO0FMrPnDvcRRhEtpMwV1r7MZhsJUlrCla0OSLdyH7/yElwj4Y4IrYPusTEkRqzI4STZR7wjfLXcozCTaVn5hqzB2sH2XoXTyVLCit/sG3VU32P9cwYu/X5CrlIRch+w183pwD8CDAC/RBaBiIoXIgAAAABJRU5ErkJggg==',
        imageType: 'encoded',
        height:65,
        width:65
    };
})(jQuery);
/*
 * Collapse plugin for jQuery
 * --
 * source: http://github.com/danielstocks/jQuery-Collapse/
 * site: http://webcloud.se/jQuery-Collapse
 *
 * @author Daniel Stocks (http://webcloud.se)
 * Copyright 2013, Daniel Stocks
 * Released under the MIT, BSD, and GPL Licenses.
 */

(function($, exports) {

    // Constructor
    function Collapse (el, options) {
        options = options || {};
        var _this = this,
            query = options.query || "> :even";

        $.extend(_this, {
            $el: el,
            options : options,
            sections: [],
            isAccordion : options.accordion || false,
            db : options.persist ? jQueryCollapseStorage(el.get(0).id) : false
        });

        // Figure out what sections are open if storage is used
        _this.states = _this.db ? _this.db.read() : [];

        // For every pair of elements in given
        // element, create a section
        _this.$el.find(query).each(function() {
            new jQueryCollapseSection($(this), _this);
        });

        // Capute ALL the clicks!
        (function(scope) {
            _this.$el.on("click", "[data-collapse-summary] " + (scope.options.clickQuery || ""),
                $.proxy(_this.handleClick, scope));

            _this.$el.bind("toggle close open",
                $.proxy(_this.handleEvent, scope));

        }(_this));
    }

    Collapse.prototype = {
        handleClick: function(e, state) {
            e.preventDefault();
            state = state || "toggle";
            var sections = this.sections,
                l = sections.length;
            while(l--) {
                if($.contains(sections[l].$summary[0], e.target)) {
                    sections[l][state]();
                    break;
                }
            }
        },
        handleEvent: function(e) {
            if(e.target == this.$el.get(0)) return this[e.type]();
            this.handleClick(e, e.type);
        },
        open: function(eq) {
            this._change("open", eq);
        },
        close: function(eq) {
            this._change("close", eq);
        },
        toggle: function(eq) {
            this._change("toggle", eq);
        },
        _change: function(action, eq) {
            if(isFinite(eq)) return this.sections[eq][action]();
            $.each(this.sections, function(i, section) {
                section[action]();
            });
        }
    };

    // Section constructor
    function Section($el, parent) {

        if(!parent.options.clickQuery) $el.wrapInner('<a href="#"/>');

        $.extend(this, {
            isOpen : false,
            $summary : $el.attr("data-collapse-summary",""),
            $details : $el.next(),
            options: parent.options,
            parent: parent
        });
        parent.sections.push(this);

        // Check current state of section
        var state = parent.states[this._index()];

        if(state === 0) {
            this.close(true);
        }
        else if(this.$summary.is(".open") || state === 1) {
            this.open(true);
        } else {
            this.close(true);
        }
    }

    Section.prototype = {
        toggle : function() {
            this.isOpen ? this.close() : this.open();
        },
        close: function(bypass) {
            this._changeState("close", bypass);
        },
        open: function(bypass) {
            var _this = this;
            if(_this.options.accordion && !bypass) {
                $.each(_this.parent.sections, function(i, section) {
                    section.close();
                });
            }
            _this._changeState("open", bypass);
        },
        _index: function() {
            return $.inArray(this, this.parent.sections);
        },
        _changeState: function(state, bypass) {

            var _this = this;
            _this.isOpen = state == "open";
            if($.isFunction(_this.options[state]) && !bypass) {
                _this.options[state].apply(_this.$details);
            } else {
                _this.$details[_this.isOpen ? "show" : "hide"]();
            }

            _this.$summary.toggleClass("open", state !== "close");
            _this.$details.attr("aria-hidden", state === "close");
            _this.$summary.attr("aria-expanded", state === "open");
            _this.$summary.trigger(state === "open" ? "opened" : "closed", _this);
            if(_this.parent.db) {
                _this.parent.db.write(_this._index(), _this.isOpen);
            }
        }
    };

    // Expose in jQuery API
    $.fn.extend({
        collapse: function(options, scan) {
            var nodes = (scan) ? $("body").find("[data-collapse]") : $(this);
            return nodes.each(function() {
                var settings = (scan) ? {} : options,
                    values = $(this).attr("data-collapse") || "";
                $.each(values.split(" "), function(i,v) {
                    if(v) settings[v] = true;
                });
                new Collapse($(this), settings);
            });
        }
    });

    // Expose constructor to
    // global namespace
    exports.jQueryCollapse = Collapse;
    exports.jQueryCollapseSection = Section;

    //jQuery DOM Ready
    $(function() {
        $.fn.collapse(false, true);
    });

})(window.jQuery, window);

/*! Lazy Load 1.9.7 - MIT license - Copyright 2010-2015 Mika Tuupola */
!function(a,b,c,d){var e=a(b);a.fn.lazyload=function(f){function g(){var b=0;i.each(function(){var c=a(this);if(!j.skip_invisible||c.is(":visible"))if(a.abovethetop(this,j)||a.leftofbegin(this,j));else if(a.belowthefold(this,j)||a.rightoffold(this,j)){if(++b>j.failure_limit)return!1}else c.trigger("appear"),b=0})}var h,i=this,j={threshold:0,failure_limit:0,event:"scroll",effect:"show",container:b,data_attribute:"original",skip_invisible:!1,appear:null,load:null,placeholder:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"};return f&&(d!==f.failurelimit&&(f.failure_limit=f.failurelimit,delete f.failurelimit),d!==f.effectspeed&&(f.effect_speed=f.effectspeed,delete f.effectspeed),a.extend(j,f)),h=j.container===d||j.container===b?e:a(j.container),0===j.event.indexOf("scroll")&&h.bind(j.event,function(){return g()}),this.each(function(){var b=this,c=a(b);b.loaded=!1,(c.attr("src")===d||c.attr("src")===!1)&&c.is("img")&&c.attr("src",j.placeholder),c.one("appear",function(){if(!this.loaded){if(j.appear){var d=i.length;j.appear.call(b,d,j)}a("<img />").bind("load",function(){var d=c.attr("data-"+j.data_attribute);c.hide(),c.is("img")?c.attr("src",d):c.css("background-image","url('"+d+"')"),c[j.effect](j.effect_speed),b.loaded=!0;var e=a.grep(i,function(a){return!a.loaded});if(i=a(e),j.load){var f=i.length;j.load.call(b,f,j)}}).attr("src",c.attr("data-"+j.data_attribute))}}),0!==j.event.indexOf("scroll")&&c.bind(j.event,function(){b.loaded||c.trigger("appear")})}),e.bind("resize",function(){g()}),/(?:iphone|ipod|ipad).*os 5/gi.test(navigator.appVersion)&&e.bind("pageshow",function(b){b.originalEvent&&b.originalEvent.persisted&&i.each(function(){a(this).trigger("appear")})}),a(c).ready(function(){g()}),this},a.belowthefold=function(c,f){var g;return g=f.container===d||f.container===b?(b.innerHeight?b.innerHeight:e.height())+e.scrollTop():a(f.container).offset().top+a(f.container).height(),g<=a(c).offset().top-f.threshold},a.rightoffold=function(c,f){var g;return g=f.container===d||f.container===b?e.width()+e.scrollLeft():a(f.container).offset().left+a(f.container).width(),g<=a(c).offset().left-f.threshold},a.abovethetop=function(c,f){var g;return g=f.container===d||f.container===b?e.scrollTop():a(f.container).offset().top,g>=a(c).offset().top+f.threshold+a(c).height()},a.leftofbegin=function(c,f){var g;return g=f.container===d||f.container===b?e.scrollLeft():a(f.container).offset().left,g>=a(c).offset().left+f.threshold+a(c).width()},a.inviewport=function(b,c){return!(a.rightoffold(b,c)||a.leftofbegin(b,c)||a.belowthefold(b,c)||a.abovethetop(b,c))},a.extend(a.expr[":"],{"below-the-fold":function(b){return a.belowthefold(b,{threshold:0})},"above-the-top":function(b){return!a.belowthefold(b,{threshold:0})},"right-of-screen":function(b){return a.rightoffold(b,{threshold:0})},"left-of-screen":function(b){return!a.rightoffold(b,{threshold:0})},"in-viewport":function(b){return a.inviewport(b,{threshold:0})},"above-the-fold":function(b){return!a.belowthefold(b,{threshold:0})},"right-of-fold":function(b){return a.rightoffold(b,{threshold:0})},"left-of-fold":function(b){return!a.rightoffold(b,{threshold:0})}})}(jQuery,window,document);
/*!

 handlebars v3.0.3

Copyright (C) 2011-2014 by Yehuda Katz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

@license
*/
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
/*	else if(typeof define === 'function' && define.amd)
		define(factory);*/
	else if(typeof exports === 'object')
		exports["Handlebars"] = factory();
	else
		root["Handlebars"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(8)['default'];

	exports.__esModule = true;

	var _runtime = __webpack_require__(1);

	var _runtime2 = _interopRequireDefault(_runtime);

	// Compiler imports

	var _AST = __webpack_require__(2);

	var _AST2 = _interopRequireDefault(_AST);

	var _Parser$parse = __webpack_require__(3);

	var _Compiler$compile$precompile = __webpack_require__(4);

	var _JavaScriptCompiler = __webpack_require__(5);

	var _JavaScriptCompiler2 = _interopRequireDefault(_JavaScriptCompiler);

	var _Visitor = __webpack_require__(6);

	var _Visitor2 = _interopRequireDefault(_Visitor);

	var _noConflict = __webpack_require__(7);

	var _noConflict2 = _interopRequireDefault(_noConflict);

	var _create = _runtime2['default'].create;
	function create() {
	  var hb = _create();

	  hb.compile = function (input, options) {
	    return _Compiler$compile$precompile.compile(input, options, hb);
	  };
	  hb.precompile = function (input, options) {
	    return _Compiler$compile$precompile.precompile(input, options, hb);
	  };

	  hb.AST = _AST2['default'];
	  hb.Compiler = _Compiler$compile$precompile.Compiler;
	  hb.JavaScriptCompiler = _JavaScriptCompiler2['default'];
	  hb.Parser = _Parser$parse.parser;
	  hb.parse = _Parser$parse.parse;

	  return hb;
	}

	var inst = create();
	inst.create = create;

	_noConflict2['default'](inst);

	inst.Visitor = _Visitor2['default'];

	inst['default'] = inst;

	exports['default'] = inst;
	module.exports = exports['default'];

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireWildcard = __webpack_require__(9)['default'];

	var _interopRequireDefault = __webpack_require__(8)['default'];

	exports.__esModule = true;

	var _import = __webpack_require__(10);

	var base = _interopRequireWildcard(_import);

	// Each of these augment the Handlebars object. No need to setup here.
	// (This is done to easily share code between commonjs and browse envs)

	var _SafeString = __webpack_require__(11);

	var _SafeString2 = _interopRequireDefault(_SafeString);

	var _Exception = __webpack_require__(12);

	var _Exception2 = _interopRequireDefault(_Exception);

	var _import2 = __webpack_require__(13);

	var Utils = _interopRequireWildcard(_import2);

	var _import3 = __webpack_require__(14);

	var runtime = _interopRequireWildcard(_import3);

	var _noConflict = __webpack_require__(7);

	var _noConflict2 = _interopRequireDefault(_noConflict);

	// For compatibility and usage outside of module systems, make the Handlebars object a namespace
	function create() {
	  var hb = new base.HandlebarsEnvironment();

	  Utils.extend(hb, base);
	  hb.SafeString = _SafeString2['default'];
	  hb.Exception = _Exception2['default'];
	  hb.Utils = Utils;
	  hb.escapeExpression = Utils.escapeExpression;

	  hb.VM = runtime;
	  hb.template = function (spec) {
	    return runtime.template(spec, hb);
	  };

	  return hb;
	}

	var inst = create();
	inst.create = create;

	_noConflict2['default'](inst);

	inst['default'] = inst;

	exports['default'] = inst;
	module.exports = exports['default'];

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	var AST = {
	  Program: function Program(statements, blockParams, strip, locInfo) {
	    this.loc = locInfo;
	    this.type = 'Program';
	    this.body = statements;

	    this.blockParams = blockParams;
	    this.strip = strip;
	  },

	  MustacheStatement: function MustacheStatement(path, params, hash, escaped, strip, locInfo) {
	    this.loc = locInfo;
	    this.type = 'MustacheStatement';

	    this.path = path;
	    this.params = params || [];
	    this.hash = hash;
	    this.escaped = escaped;

	    this.strip = strip;
	  },

	  BlockStatement: function BlockStatement(path, params, hash, program, inverse, openStrip, inverseStrip, closeStrip, locInfo) {
	    this.loc = locInfo;
	    this.type = 'BlockStatement';

	    this.path = path;
	    this.params = params || [];
	    this.hash = hash;
	    this.program = program;
	    this.inverse = inverse;

	    this.openStrip = openStrip;
	    this.inverseStrip = inverseStrip;
	    this.closeStrip = closeStrip;
	  },

	  PartialStatement: function PartialStatement(name, params, hash, strip, locInfo) {
	    this.loc = locInfo;
	    this.type = 'PartialStatement';

	    this.name = name;
	    this.params = params || [];
	    this.hash = hash;

	    this.indent = '';
	    this.strip = strip;
	  },

	  ContentStatement: function ContentStatement(string, locInfo) {
	    this.loc = locInfo;
	    this.type = 'ContentStatement';
	    this.original = this.value = string;
	  },

	  CommentStatement: function CommentStatement(comment, strip, locInfo) {
	    this.loc = locInfo;
	    this.type = 'CommentStatement';
	    this.value = comment;

	    this.strip = strip;
	  },

	  SubExpression: function SubExpression(path, params, hash, locInfo) {
	    this.loc = locInfo;

	    this.type = 'SubExpression';
	    this.path = path;
	    this.params = params || [];
	    this.hash = hash;
	  },

	  PathExpression: function PathExpression(data, depth, parts, original, locInfo) {
	    this.loc = locInfo;
	    this.type = 'PathExpression';

	    this.data = data;
	    this.original = original;
	    this.parts = parts;
	    this.depth = depth;
	  },

	  StringLiteral: function StringLiteral(string, locInfo) {
	    this.loc = locInfo;
	    this.type = 'StringLiteral';
	    this.original = this.value = string;
	  },

	  NumberLiteral: function NumberLiteral(number, locInfo) {
	    this.loc = locInfo;
	    this.type = 'NumberLiteral';
	    this.original = this.value = Number(number);
	  },

	  BooleanLiteral: function BooleanLiteral(bool, locInfo) {
	    this.loc = locInfo;
	    this.type = 'BooleanLiteral';
	    this.original = this.value = bool === 'true';
	  },

	  UndefinedLiteral: function UndefinedLiteral(locInfo) {
	    this.loc = locInfo;
	    this.type = 'UndefinedLiteral';
	    this.original = this.value = undefined;
	  },

	  NullLiteral: function NullLiteral(locInfo) {
	    this.loc = locInfo;
	    this.type = 'NullLiteral';
	    this.original = this.value = null;
	  },

	  Hash: function Hash(pairs, locInfo) {
	    this.loc = locInfo;
	    this.type = 'Hash';
	    this.pairs = pairs;
	  },
	  HashPair: function HashPair(key, value, locInfo) {
	    this.loc = locInfo;
	    this.type = 'HashPair';
	    this.key = key;
	    this.value = value;
	  },

	  // Public API used to evaluate derived attributes regarding AST nodes
	  helpers: {
	    // a mustache is definitely a helper if:
	    // * it is an eligible helper, and
	    // * it has at least one parameter or hash segment
	    helperExpression: function helperExpression(node) {
	      return !!(node.type === 'SubExpression' || node.params.length || node.hash);
	    },

	    scopedId: function scopedId(path) {
	      return /^\.|this\b/.test(path.original);
	    },

	    // an ID is simple if it only has one part, and that part is not
	    // `..` or `this`.
	    simpleId: function simpleId(path) {
	      return path.parts.length === 1 && !AST.helpers.scopedId(path) && !path.depth;
	    }
	  }
	};

	// Must be exported as an object rather than the root of the module as the jison lexer
	// must modify the object to operate properly.
	exports['default'] = AST;
	module.exports = exports['default'];

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(8)['default'];

	var _interopRequireWildcard = __webpack_require__(9)['default'];

	exports.__esModule = true;
	exports.parse = parse;

	var _parser = __webpack_require__(15);

	var _parser2 = _interopRequireDefault(_parser);

	var _AST = __webpack_require__(2);

	var _AST2 = _interopRequireDefault(_AST);

	var _WhitespaceControl = __webpack_require__(16);

	var _WhitespaceControl2 = _interopRequireDefault(_WhitespaceControl);

	var _import = __webpack_require__(17);

	var Helpers = _interopRequireWildcard(_import);

	var _extend = __webpack_require__(13);

	exports.parser = _parser2['default'];

	var yy = {};
	_extend.extend(yy, Helpers, _AST2['default']);

	function parse(input, options) {
	  // Just return if an already-compiled AST was passed in.
	  if (input.type === 'Program') {
	    return input;
	  }

	  _parser2['default'].yy = yy;

	  // Altering the shared object here, but this is ok as parser is a sync operation
	  yy.locInfo = function (locInfo) {
	    return new yy.SourceLocation(options && options.srcName, locInfo);
	  };

	  var strip = new _WhitespaceControl2['default']();
	  return strip.accept(_parser2['default'].parse(input));
	}

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(8)['default'];

	exports.__esModule = true;
	exports.Compiler = Compiler;
	exports.precompile = precompile;
	exports.compile = compile;

	var _Exception = __webpack_require__(12);

	var _Exception2 = _interopRequireDefault(_Exception);

	var _isArray$indexOf = __webpack_require__(13);

	var _AST = __webpack_require__(2);

	var _AST2 = _interopRequireDefault(_AST);

	var slice = [].slice;

	function Compiler() {}

	// the foundHelper register will disambiguate helper lookup from finding a
	// function in a context. This is necessary for mustache compatibility, which
	// requires that context functions in blocks are evaluated by blockHelperMissing,
	// and then proceed as if the resulting value was provided to blockHelperMissing.

	Compiler.prototype = {
	  compiler: Compiler,

	  equals: function equals(other) {
	    var len = this.opcodes.length;
	    if (other.opcodes.length !== len) {
	      return false;
	    }

	    for (var i = 0; i < len; i++) {
	      var opcode = this.opcodes[i],
	          otherOpcode = other.opcodes[i];
	      if (opcode.opcode !== otherOpcode.opcode || !argEquals(opcode.args, otherOpcode.args)) {
	        return false;
	      }
	    }

	    // We know that length is the same between the two arrays because they are directly tied
	    // to the opcode behavior above.
	    len = this.children.length;
	    for (var i = 0; i < len; i++) {
	      if (!this.children[i].equals(other.children[i])) {
	        return false;
	      }
	    }

	    return true;
	  },

	  guid: 0,

	  compile: function compile(program, options) {
	    this.sourceNode = [];
	    this.opcodes = [];
	    this.children = [];
	    this.options = options;
	    this.stringParams = options.stringParams;
	    this.trackIds = options.trackIds;

	    options.blockParams = options.blockParams || [];

	    // These changes will propagate to the other compiler components
	    var knownHelpers = options.knownHelpers;
	    options.knownHelpers = {
	      helperMissing: true,
	      blockHelperMissing: true,
	      each: true,
	      'if': true,
	      unless: true,
	      'with': true,
	      log: true,
	      lookup: true
	    };
	    if (knownHelpers) {
	      for (var _name in knownHelpers) {
	        if (_name in knownHelpers) {
	          options.knownHelpers[_name] = knownHelpers[_name];
	        }
	      }
	    }

	    return this.accept(program);
	  },

	  compileProgram: function compileProgram(program) {
	    var childCompiler = new this.compiler(),
	        // eslint-disable-line new-cap
	    result = childCompiler.compile(program, this.options),
	        guid = this.guid++;

	    this.usePartial = this.usePartial || result.usePartial;

	    this.children[guid] = result;
	    this.useDepths = this.useDepths || result.useDepths;

	    return guid;
	  },

	  accept: function accept(node) {
	    this.sourceNode.unshift(node);
	    var ret = this[node.type](node);
	    this.sourceNode.shift();
	    return ret;
	  },

	  Program: function Program(program) {
	    this.options.blockParams.unshift(program.blockParams);

	    var body = program.body,
	        bodyLength = body.length;
	    for (var i = 0; i < bodyLength; i++) {
	      this.accept(body[i]);
	    }

	    this.options.blockParams.shift();

	    this.isSimple = bodyLength === 1;
	    this.blockParams = program.blockParams ? program.blockParams.length : 0;

	    return this;
	  },

	  BlockStatement: function BlockStatement(block) {
	    transformLiteralToPath(block);

	    var program = block.program,
	        inverse = block.inverse;

	    program = program && this.compileProgram(program);
	    inverse = inverse && this.compileProgram(inverse);

	    var type = this.classifySexpr(block);

	    if (type === 'helper') {
	      this.helperSexpr(block, program, inverse);
	    } else if (type === 'simple') {
	      this.simpleSexpr(block);

	      // now that the simple mustache is resolved, we need to
	      // evaluate it by executing `blockHelperMissing`
	      this.opcode('pushProgram', program);
	      this.opcode('pushProgram', inverse);
	      this.opcode('emptyHash');
	      this.opcode('blockValue', block.path.original);
	    } else {
	      this.ambiguousSexpr(block, program, inverse);

	      // now that the simple mustache is resolved, we need to
	      // evaluate it by executing `blockHelperMissing`
	      this.opcode('pushProgram', program);
	      this.opcode('pushProgram', inverse);
	      this.opcode('emptyHash');
	      this.opcode('ambiguousBlockValue');
	    }

	    this.opcode('append');
	  },

	  PartialStatement: function PartialStatement(partial) {
	    this.usePartial = true;

	    var params = partial.params;
	    if (params.length > 1) {
	      throw new _Exception2['default']('Unsupported number of partial arguments: ' + params.length, partial);
	    } else if (!params.length) {
	      params.push({ type: 'PathExpression', parts: [], depth: 0 });
	    }

	    var partialName = partial.name.original,
	        isDynamic = partial.name.type === 'SubExpression';
	    if (isDynamic) {
	      this.accept(partial.name);
	    }

	    this.setupFullMustacheParams(partial, undefined, undefined, true);

	    var indent = partial.indent || '';
	    if (this.options.preventIndent && indent) {
	      this.opcode('appendContent', indent);
	      indent = '';
	    }

	    this.opcode('invokePartial', isDynamic, partialName, indent);
	    this.opcode('append');
	  },

	  MustacheStatement: function MustacheStatement(mustache) {
	    this.SubExpression(mustache); // eslint-disable-line new-cap

	    if (mustache.escaped && !this.options.noEscape) {
	      this.opcode('appendEscaped');
	    } else {
	      this.opcode('append');
	    }
	  },

	  ContentStatement: function ContentStatement(content) {
	    if (content.value) {
	      this.opcode('appendContent', content.value);
	    }
	  },

	  CommentStatement: function CommentStatement() {},

	  SubExpression: function SubExpression(sexpr) {
	    transformLiteralToPath(sexpr);
	    var type = this.classifySexpr(sexpr);

	    if (type === 'simple') {
	      this.simpleSexpr(sexpr);
	    } else if (type === 'helper') {
	      this.helperSexpr(sexpr);
	    } else {
	      this.ambiguousSexpr(sexpr);
	    }
	  },
	  ambiguousSexpr: function ambiguousSexpr(sexpr, program, inverse) {
	    var path = sexpr.path,
	        name = path.parts[0],
	        isBlock = program != null || inverse != null;

	    this.opcode('getContext', path.depth);

	    this.opcode('pushProgram', program);
	    this.opcode('pushProgram', inverse);

	    this.accept(path);

	    this.opcode('invokeAmbiguous', name, isBlock);
	  },

	  simpleSexpr: function simpleSexpr(sexpr) {
	    this.accept(sexpr.path);
	    this.opcode('resolvePossibleLambda');
	  },

	  helperSexpr: function helperSexpr(sexpr, program, inverse) {
	    var params = this.setupFullMustacheParams(sexpr, program, inverse),
	        path = sexpr.path,
	        name = path.parts[0];

	    if (this.options.knownHelpers[name]) {
	      this.opcode('invokeKnownHelper', params.length, name);
	    } else if (this.options.knownHelpersOnly) {
	      throw new _Exception2['default']('You specified knownHelpersOnly, but used the unknown helper ' + name, sexpr);
	    } else {
	      path.falsy = true;

	      this.accept(path);
	      this.opcode('invokeHelper', params.length, path.original, _AST2['default'].helpers.simpleId(path));
	    }
	  },

	  PathExpression: function PathExpression(path) {
	    this.addDepth(path.depth);
	    this.opcode('getContext', path.depth);

	    var name = path.parts[0],
	        scoped = _AST2['default'].helpers.scopedId(path),
	        blockParamId = !path.depth && !scoped && this.blockParamIndex(name);

	    if (blockParamId) {
	      this.opcode('lookupBlockParam', blockParamId, path.parts);
	    } else if (!name) {
	      // Context reference, i.e. `{{foo .}}` or `{{foo ..}}`
	      this.opcode('pushContext');
	    } else if (path.data) {
	      this.options.data = true;
	      this.opcode('lookupData', path.depth, path.parts);
	    } else {
	      this.opcode('lookupOnContext', path.parts, path.falsy, scoped);
	    }
	  },

	  StringLiteral: function StringLiteral(string) {
	    this.opcode('pushString', string.value);
	  },

	  NumberLiteral: function NumberLiteral(number) {
	    this.opcode('pushLiteral', number.value);
	  },

	  BooleanLiteral: function BooleanLiteral(bool) {
	    this.opcode('pushLiteral', bool.value);
	  },

	  UndefinedLiteral: function UndefinedLiteral() {
	    this.opcode('pushLiteral', 'undefined');
	  },

	  NullLiteral: function NullLiteral() {
	    this.opcode('pushLiteral', 'null');
	  },

	  Hash: function Hash(hash) {
	    var pairs = hash.pairs,
	        i = 0,
	        l = pairs.length;

	    this.opcode('pushHash');

	    for (; i < l; i++) {
	      this.pushParam(pairs[i].value);
	    }
	    while (i--) {
	      this.opcode('assignToHash', pairs[i].key);
	    }
	    this.opcode('popHash');
	  },

	  // HELPERS
	  opcode: function opcode(name) {
	    this.opcodes.push({ opcode: name, args: slice.call(arguments, 1), loc: this.sourceNode[0].loc });
	  },

	  addDepth: function addDepth(depth) {
	    if (!depth) {
	      return;
	    }

	    this.useDepths = true;
	  },

	  classifySexpr: function classifySexpr(sexpr) {
	    var isSimple = _AST2['default'].helpers.simpleId(sexpr.path);

	    var isBlockParam = isSimple && !!this.blockParamIndex(sexpr.path.parts[0]);

	    // a mustache is an eligible helper if:
	    // * its id is simple (a single part, not `this` or `..`)
	    var isHelper = !isBlockParam && _AST2['default'].helpers.helperExpression(sexpr);

	    // if a mustache is an eligible helper but not a definite
	    // helper, it is ambiguous, and will be resolved in a later
	    // pass or at runtime.
	    var isEligible = !isBlockParam && (isHelper || isSimple);

	    // if ambiguous, we can possibly resolve the ambiguity now
	    // An eligible helper is one that does not have a complex path, i.e. `this.foo`, `../foo` etc.
	    if (isEligible && !isHelper) {
	      var _name2 = sexpr.path.parts[0],
	          options = this.options;

	      if (options.knownHelpers[_name2]) {
	        isHelper = true;
	      } else if (options.knownHelpersOnly) {
	        isEligible = false;
	      }
	    }

	    if (isHelper) {
	      return 'helper';
	    } else if (isEligible) {
	      return 'ambiguous';
	    } else {
	      return 'simple';
	    }
	  },

	  pushParams: function pushParams(params) {
	    for (var i = 0, l = params.length; i < l; i++) {
	      this.pushParam(params[i]);
	    }
	  },

	  pushParam: function pushParam(val) {
	    var value = val.value != null ? val.value : val.original || '';

	    if (this.stringParams) {
	      if (value.replace) {
	        value = value.replace(/^(\.?\.\/)*/g, '').replace(/\//g, '.');
	      }

	      if (val.depth) {
	        this.addDepth(val.depth);
	      }
	      this.opcode('getContext', val.depth || 0);
	      this.opcode('pushStringParam', value, val.type);

	      if (val.type === 'SubExpression') {
	        // SubExpressions get evaluated and passed in
	        // in string params mode.
	        this.accept(val);
	      }
	    } else {
	      if (this.trackIds) {
	        var blockParamIndex = undefined;
	        if (val.parts && !_AST2['default'].helpers.scopedId(val) && !val.depth) {
	          blockParamIndex = this.blockParamIndex(val.parts[0]);
	        }
	        if (blockParamIndex) {
	          var blockParamChild = val.parts.slice(1).join('.');
	          this.opcode('pushId', 'BlockParam', blockParamIndex, blockParamChild);
	        } else {
	          value = val.original || value;
	          if (value.replace) {
	            value = value.replace(/^\.\//g, '').replace(/^\.$/g, '');
	          }

	          this.opcode('pushId', val.type, value);
	        }
	      }
	      this.accept(val);
	    }
	  },

	  setupFullMustacheParams: function setupFullMustacheParams(sexpr, program, inverse, omitEmpty) {
	    var params = sexpr.params;
	    this.pushParams(params);

	    this.opcode('pushProgram', program);
	    this.opcode('pushProgram', inverse);

	    if (sexpr.hash) {
	      this.accept(sexpr.hash);
	    } else {
	      this.opcode('emptyHash', omitEmpty);
	    }

	    return params;
	  },

	  blockParamIndex: function blockParamIndex(name) {
	    for (var depth = 0, len = this.options.blockParams.length; depth < len; depth++) {
	      var blockParams = this.options.blockParams[depth],
	          param = blockParams && _isArray$indexOf.indexOf(blockParams, name);
	      if (blockParams && param >= 0) {
	        return [depth, param];
	      }
	    }
	  }
	};

	function precompile(input, options, env) {
	  if (input == null || typeof input !== 'string' && input.type !== 'Program') {
	    throw new _Exception2['default']('You must pass a string or Handlebars AST to Handlebars.precompile. You passed ' + input);
	  }

	  options = options || {};
	  if (!('data' in options)) {
	    options.data = true;
	  }
	  if (options.compat) {
	    options.useDepths = true;
	  }

	  var ast = env.parse(input, options),
	      environment = new env.Compiler().compile(ast, options);
	  return new env.JavaScriptCompiler().compile(environment, options);
	}

	function compile(input, _x, env) {
	  var options = arguments[1] === undefined ? {} : arguments[1];

	  if (input == null || typeof input !== 'string' && input.type !== 'Program') {
	    throw new _Exception2['default']('You must pass a string or Handlebars AST to Handlebars.compile. You passed ' + input);
	  }

	  if (!('data' in options)) {
	    options.data = true;
	  }
	  if (options.compat) {
	    options.useDepths = true;
	  }

	  var compiled = undefined;

	  function compileInput() {
	    var ast = env.parse(input, options),
	        environment = new env.Compiler().compile(ast, options),
	        templateSpec = new env.JavaScriptCompiler().compile(environment, options, undefined, true);
	    return env.template(templateSpec);
	  }

	  // Template is only compiled on first use and cached after that point.
	  function ret(context, execOptions) {
	    if (!compiled) {
	      compiled = compileInput();
	    }
	    return compiled.call(this, context, execOptions);
	  }
	  ret._setup = function (setupOptions) {
	    if (!compiled) {
	      compiled = compileInput();
	    }
	    return compiled._setup(setupOptions);
	  };
	  ret._child = function (i, data, blockParams, depths) {
	    if (!compiled) {
	      compiled = compileInput();
	    }
	    return compiled._child(i, data, blockParams, depths);
	  };
	  return ret;
	}

	function argEquals(a, b) {
	  if (a === b) {
	    return true;
	  }

	  if (_isArray$indexOf.isArray(a) && _isArray$indexOf.isArray(b) && a.length === b.length) {
	    for (var i = 0; i < a.length; i++) {
	      if (!argEquals(a[i], b[i])) {
	        return false;
	      }
	    }
	    return true;
	  }
	}

	function transformLiteralToPath(sexpr) {
	  if (!sexpr.path.parts) {
	    var literal = sexpr.path;
	    // Casting to string here to make false and 0 literal values play nicely with the rest
	    // of the system.
	    sexpr.path = new _AST2['default'].PathExpression(false, 0, [literal.original + ''], literal.original + '', literal.loc);
	  }
	}

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(8)['default'];

	exports.__esModule = true;

	var _COMPILER_REVISION$REVISION_CHANGES = __webpack_require__(10);

	var _Exception = __webpack_require__(12);

	var _Exception2 = _interopRequireDefault(_Exception);

	var _isArray = __webpack_require__(13);

	var _CodeGen = __webpack_require__(18);

	var _CodeGen2 = _interopRequireDefault(_CodeGen);

	function Literal(value) {
	  this.value = value;
	}

	function JavaScriptCompiler() {}

	JavaScriptCompiler.prototype = {
	  // PUBLIC API: You can override these methods in a subclass to provide
	  // alternative compiled forms for name lookup and buffering semantics
	  nameLookup: function nameLookup(parent, name /* , type*/) {
	    if (JavaScriptCompiler.isValidJavaScriptVariableName(name)) {
	      return [parent, '.', name];
	    } else {
	      return [parent, '[\'', name, '\']'];
	    }
	  },
	  depthedLookup: function depthedLookup(name) {
	    return [this.aliasable('this.lookup'), '(depths, "', name, '")'];
	  },

	  compilerInfo: function compilerInfo() {
	    var revision = _COMPILER_REVISION$REVISION_CHANGES.COMPILER_REVISION,
	        versions = _COMPILER_REVISION$REVISION_CHANGES.REVISION_CHANGES[revision];
	    return [revision, versions];
	  },

	  appendToBuffer: function appendToBuffer(source, location, explicit) {
	    // Force a source as this simplifies the merge logic.
	    if (!_isArray.isArray(source)) {
	      source = [source];
	    }
	    source = this.source.wrap(source, location);

	    if (this.environment.isSimple) {
	      return ['return ', source, ';'];
	    } else if (explicit) {
	      // This is a case where the buffer operation occurs as a child of another
	      // construct, generally braces. We have to explicitly output these buffer
	      // operations to ensure that the emitted code goes in the correct location.
	      return ['buffer += ', source, ';'];
	    } else {
	      source.appendToBuffer = true;
	      return source;
	    }
	  },

	  initializeBuffer: function initializeBuffer() {
	    return this.quotedString('');
	  },
	  // END PUBLIC API

	  compile: function compile(environment, options, context, asObject) {
	    this.environment = environment;
	    this.options = options;
	    this.stringParams = this.options.stringParams;
	    this.trackIds = this.options.trackIds;
	    this.precompile = !asObject;

	    this.name = this.environment.name;
	    this.isChild = !!context;
	    this.context = context || {
	      programs: [],
	      environments: []
	    };

	    this.preamble();

	    this.stackSlot = 0;
	    this.stackVars = [];
	    this.aliases = {};
	    this.registers = { list: [] };
	    this.hashes = [];
	    this.compileStack = [];
	    this.inlineStack = [];
	    this.blockParams = [];

	    this.compileChildren(environment, options);

	    this.useDepths = this.useDepths || environment.useDepths || this.options.compat;
	    this.useBlockParams = this.useBlockParams || environment.useBlockParams;

	    var opcodes = environment.opcodes,
	        opcode = undefined,
	        firstLoc = undefined,
	        i = undefined,
	        l = undefined;

	    for (i = 0, l = opcodes.length; i < l; i++) {
	      opcode = opcodes[i];

	      this.source.currentLocation = opcode.loc;
	      firstLoc = firstLoc || opcode.loc;
	      this[opcode.opcode].apply(this, opcode.args);
	    }

	    // Flush any trailing content that might be pending.
	    this.source.currentLocation = firstLoc;
	    this.pushSource('');

	    /* istanbul ignore next */
	    if (this.stackSlot || this.inlineStack.length || this.compileStack.length) {
	      throw new _Exception2['default']('Compile completed with content left on stack');
	    }

	    var fn = this.createFunctionContext(asObject);
	    if (!this.isChild) {
	      var ret = {
	        compiler: this.compilerInfo(),
	        main: fn
	      };
	      var programs = this.context.programs;
	      for (i = 0, l = programs.length; i < l; i++) {
	        if (programs[i]) {
	          ret[i] = programs[i];
	        }
	      }

	      if (this.environment.usePartial) {
	        ret.usePartial = true;
	      }
	      if (this.options.data) {
	        ret.useData = true;
	      }
	      if (this.useDepths) {
	        ret.useDepths = true;
	      }
	      if (this.useBlockParams) {
	        ret.useBlockParams = true;
	      }
	      if (this.options.compat) {
	        ret.compat = true;
	      }

	      if (!asObject) {
	        ret.compiler = JSON.stringify(ret.compiler);

	        this.source.currentLocation = { start: { line: 1, column: 0 } };
	        ret = this.objectLiteral(ret);

	        if (options.srcName) {
	          ret = ret.toStringWithSourceMap({ file: options.destName });
	          ret.map = ret.map && ret.map.toString();
	        } else {
	          ret = ret.toString();
	        }
	      } else {
	        ret.compilerOptions = this.options;
	      }

	      return ret;
	    } else {
	      return fn;
	    }
	  },

	  preamble: function preamble() {
	    // track the last context pushed into place to allow skipping the
	    // getContext opcode when it would be a noop
	    this.lastContext = 0;
	    this.source = new _CodeGen2['default'](this.options.srcName);
	  },

	  createFunctionContext: function createFunctionContext(asObject) {
	    var varDeclarations = '';

	    var locals = this.stackVars.concat(this.registers.list);
	    if (locals.length > 0) {
	      varDeclarations += ', ' + locals.join(', ');
	    }

	    // Generate minimizer alias mappings
	    //
	    // When using true SourceNodes, this will update all references to the given alias
	    // as the source nodes are reused in situ. For the non-source node compilation mode,
	    // aliases will not be used, but this case is already being run on the client and
	    // we aren't concern about minimizing the template size.
	    var aliasCount = 0;
	    for (var alias in this.aliases) {
	      // eslint-disable-line guard-for-in
	      var node = this.aliases[alias];

	      if (this.aliases.hasOwnProperty(alias) && node.children && node.referenceCount > 1) {
	        varDeclarations += ', alias' + ++aliasCount + '=' + alias;
	        node.children[0] = 'alias' + aliasCount;
	      }
	    }

	    var params = ['depth0', 'helpers', 'partials', 'data'];

	    if (this.useBlockParams || this.useDepths) {
	      params.push('blockParams');
	    }
	    if (this.useDepths) {
	      params.push('depths');
	    }

	    // Perform a second pass over the output to merge content when possible
	    var source = this.mergeSource(varDeclarations);

	    if (asObject) {
	      params.push(source);

	      return Function.apply(this, params);
	    } else {
	      return this.source.wrap(['function(', params.join(','), ') {\n  ', source, '}']);
	    }
	  },
	  mergeSource: function mergeSource(varDeclarations) {
	    var isSimple = this.environment.isSimple,
	        appendOnly = !this.forceBuffer,
	        appendFirst = undefined,
	        sourceSeen = undefined,
	        bufferStart = undefined,
	        bufferEnd = undefined;
	    this.source.each(function (line) {
	      if (line.appendToBuffer) {
	        if (bufferStart) {
	          line.prepend('  + ');
	        } else {
	          bufferStart = line;
	        }
	        bufferEnd = line;
	      } else {
	        if (bufferStart) {
	          if (!sourceSeen) {
	            appendFirst = true;
	          } else {
	            bufferStart.prepend('buffer += ');
	          }
	          bufferEnd.add(';');
	          bufferStart = bufferEnd = undefined;
	        }

	        sourceSeen = true;
	        if (!isSimple) {
	          appendOnly = false;
	        }
	      }
	    });

	    if (appendOnly) {
	      if (bufferStart) {
	        bufferStart.prepend('return ');
	        bufferEnd.add(';');
	      } else if (!sourceSeen) {
	        this.source.push('return "";');
	      }
	    } else {
	      varDeclarations += ', buffer = ' + (appendFirst ? '' : this.initializeBuffer());

	      if (bufferStart) {
	        bufferStart.prepend('return buffer + ');
	        bufferEnd.add(';');
	      } else {
	        this.source.push('return buffer;');
	      }
	    }

	    if (varDeclarations) {
	      this.source.prepend('var ' + varDeclarations.substring(2) + (appendFirst ? '' : ';\n'));
	    }

	    return this.source.merge();
	  },

	  // [blockValue]
	  //
	  // On stack, before: hash, inverse, program, value
	  // On stack, after: return value of blockHelperMissing
	  //
	  // The purpose of this opcode is to take a block of the form
	  // `{{#this.foo}}...{{/this.foo}}`, resolve the value of `foo`, and
	  // replace it on the stack with the result of properly
	  // invoking blockHelperMissing.
	  blockValue: function blockValue(name) {
	    var blockHelperMissing = this.aliasable('helpers.blockHelperMissing'),
	        params = [this.contextName(0)];
	    this.setupHelperArgs(name, 0, params);

	    var blockName = this.popStack();
	    params.splice(1, 0, blockName);

	    this.push(this.source.functionCall(blockHelperMissing, 'call', params));
	  },

	  // [ambiguousBlockValue]
	  //
	  // On stack, before: hash, inverse, program, value
	  // Compiler value, before: lastHelper=value of last found helper, if any
	  // On stack, after, if no lastHelper: same as [blockValue]
	  // On stack, after, if lastHelper: value
	  ambiguousBlockValue: function ambiguousBlockValue() {
	    // We're being a bit cheeky and reusing the options value from the prior exec
	    var blockHelperMissing = this.aliasable('helpers.blockHelperMissing'),
	        params = [this.contextName(0)];
	    this.setupHelperArgs('', 0, params, true);

	    this.flushInline();

	    var current = this.topStack();
	    params.splice(1, 0, current);

	    this.pushSource(['if (!', this.lastHelper, ') { ', current, ' = ', this.source.functionCall(blockHelperMissing, 'call', params), '}']);
	  },

	  // [appendContent]
	  //
	  // On stack, before: ...
	  // On stack, after: ...
	  //
	  // Appends the string value of `content` to the current buffer
	  appendContent: function appendContent(content) {
	    if (this.pendingContent) {
	      content = this.pendingContent + content;
	    } else {
	      this.pendingLocation = this.source.currentLocation;
	    }

	    this.pendingContent = content;
	  },

	  // [append]
	  //
	  // On stack, before: value, ...
	  // On stack, after: ...
	  //
	  // Coerces `value` to a String and appends it to the current buffer.
	  //
	  // If `value` is truthy, or 0, it is coerced into a string and appended
	  // Otherwise, the empty string is appended
	  append: function append() {
	    if (this.isInline()) {
	      this.replaceStack(function (current) {
	        return [' != null ? ', current, ' : ""'];
	      });

	      this.pushSource(this.appendToBuffer(this.popStack()));
	    } else {
	      var local = this.popStack();
	      this.pushSource(['if (', local, ' != null) { ', this.appendToBuffer(local, undefined, true), ' }']);
	      if (this.environment.isSimple) {
	        this.pushSource(['else { ', this.appendToBuffer('\'\'', undefined, true), ' }']);
	      }
	    }
	  },

	  // [appendEscaped]
	  //
	  // On stack, before: value, ...
	  // On stack, after: ...
	  //
	  // Escape `value` and append it to the buffer
	  appendEscaped: function appendEscaped() {
	    this.pushSource(this.appendToBuffer([this.aliasable('this.escapeExpression'), '(', this.popStack(), ')']));
	  },

	  // [getContext]
	  //
	  // On stack, before: ...
	  // On stack, after: ...
	  // Compiler value, after: lastContext=depth
	  //
	  // Set the value of the `lastContext` compiler value to the depth
	  getContext: function getContext(depth) {
	    this.lastContext = depth;
	  },

	  // [pushContext]
	  //
	  // On stack, before: ...
	  // On stack, after: currentContext, ...
	  //
	  // Pushes the value of the current context onto the stack.
	  pushContext: function pushContext() {
	    this.pushStackLiteral(this.contextName(this.lastContext));
	  },

	  // [lookupOnContext]
	  //
	  // On stack, before: ...
	  // On stack, after: currentContext[name], ...
	  //
	  // Looks up the value of `name` on the current context and pushes
	  // it onto the stack.
	  lookupOnContext: function lookupOnContext(parts, falsy, scoped) {
	    var i = 0;

	    if (!scoped && this.options.compat && !this.lastContext) {
	      // The depthed query is expected to handle the undefined logic for the root level that
	      // is implemented below, so we evaluate that directly in compat mode
	      this.push(this.depthedLookup(parts[i++]));
	    } else {
	      this.pushContext();
	    }

	    this.resolvePath('context', parts, i, falsy);
	  },

	  // [lookupBlockParam]
	  //
	  // On stack, before: ...
	  // On stack, after: blockParam[name], ...
	  //
	  // Looks up the value of `parts` on the given block param and pushes
	  // it onto the stack.
	  lookupBlockParam: function lookupBlockParam(blockParamId, parts) {
	    this.useBlockParams = true;

	    this.push(['blockParams[', blockParamId[0], '][', blockParamId[1], ']']);
	    this.resolvePath('context', parts, 1);
	  },

	  // [lookupData]
	  //
	  // On stack, before: ...
	  // On stack, after: data, ...
	  //
	  // Push the data lookup operator
	  lookupData: function lookupData(depth, parts) {
	    if (!depth) {
	      this.pushStackLiteral('data');
	    } else {
	      this.pushStackLiteral('this.data(data, ' + depth + ')');
	    }

	    this.resolvePath('data', parts, 0, true);
	  },

	  resolvePath: function resolvePath(type, parts, i, falsy) {
	    var _this = this;

	    if (this.options.strict || this.options.assumeObjects) {
	      this.push(strictLookup(this.options.strict, this, parts, type));
	      return;
	    }

	    var len = parts.length;
	    for (; i < len; i++) {
	      /*eslint-disable no-loop-func */
	      this.replaceStack(function (current) {
	        var lookup = _this.nameLookup(current, parts[i], type);
	        // We want to ensure that zero and false are handled properly if the context (falsy flag)
	        // needs to have the special handling for these values.
	        if (!falsy) {
	          return [' != null ? ', lookup, ' : ', current];
	        } else {
	          // Otherwise we can use generic falsy handling
	          return [' && ', lookup];
	        }
	      });
	      /*eslint-enable no-loop-func */
	    }
	  },

	  // [resolvePossibleLambda]
	  //
	  // On stack, before: value, ...
	  // On stack, after: resolved value, ...
	  //
	  // If the `value` is a lambda, replace it on the stack by
	  // the return value of the lambda
	  resolvePossibleLambda: function resolvePossibleLambda() {
	    this.push([this.aliasable('this.lambda'), '(', this.popStack(), ', ', this.contextName(0), ')']);
	  },

	  // [pushStringParam]
	  //
	  // On stack, before: ...
	  // On stack, after: string, currentContext, ...
	  //
	  // This opcode is designed for use in string mode, which
	  // provides the string value of a parameter along with its
	  // depth rather than resolving it immediately.
	  pushStringParam: function pushStringParam(string, type) {
	    this.pushContext();
	    this.pushString(type);

	    // If it's a subexpression, the string result
	    // will be pushed after this opcode.
	    if (type !== 'SubExpression') {
	      if (typeof string === 'string') {
	        this.pushString(string);
	      } else {
	        this.pushStackLiteral(string);
	      }
	    }
	  },

	  emptyHash: function emptyHash(omitEmpty) {
	    if (this.trackIds) {
	      this.push('{}'); // hashIds
	    }
	    if (this.stringParams) {
	      this.push('{}'); // hashContexts
	      this.push('{}'); // hashTypes
	    }
	    this.pushStackLiteral(omitEmpty ? 'undefined' : '{}');
	  },
	  pushHash: function pushHash() {
	    if (this.hash) {
	      this.hashes.push(this.hash);
	    }
	    this.hash = { values: [], types: [], contexts: [], ids: [] };
	  },
	  popHash: function popHash() {
	    var hash = this.hash;
	    this.hash = this.hashes.pop();

	    if (this.trackIds) {
	      this.push(this.objectLiteral(hash.ids));
	    }
	    if (this.stringParams) {
	      this.push(this.objectLiteral(hash.contexts));
	      this.push(this.objectLiteral(hash.types));
	    }

	    this.push(this.objectLiteral(hash.values));
	  },

	  // [pushString]
	  //
	  // On stack, before: ...
	  // On stack, after: quotedString(string), ...
	  //
	  // Push a quoted version of `string` onto the stack
	  pushString: function pushString(string) {
	    this.pushStackLiteral(this.quotedString(string));
	  },

	  // [pushLiteral]
	  //
	  // On stack, before: ...
	  // On stack, after: value, ...
	  //
	  // Pushes a value onto the stack. This operation prevents
	  // the compiler from creating a temporary variable to hold
	  // it.
	  pushLiteral: function pushLiteral(value) {
	    this.pushStackLiteral(value);
	  },

	  // [pushProgram]
	  //
	  // On stack, before: ...
	  // On stack, after: program(guid), ...
	  //
	  // Push a program expression onto the stack. This takes
	  // a compile-time guid and converts it into a runtime-accessible
	  // expression.
	  pushProgram: function pushProgram(guid) {
	    if (guid != null) {
	      this.pushStackLiteral(this.programExpression(guid));
	    } else {
	      this.pushStackLiteral(null);
	    }
	  },

	  // [invokeHelper]
	  //
	  // On stack, before: hash, inverse, program, params..., ...
	  // On stack, after: result of helper invocation
	  //
	  // Pops off the helper's parameters, invokes the helper,
	  // and pushes the helper's return value onto the stack.
	  //
	  // If the helper is not found, `helperMissing` is called.
	  invokeHelper: function invokeHelper(paramSize, name, isSimple) {
	    var nonHelper = this.popStack(),
	        helper = this.setupHelper(paramSize, name),
	        simple = isSimple ? [helper.name, ' || '] : '';

	    var lookup = ['('].concat(simple, nonHelper);
	    if (!this.options.strict) {
	      lookup.push(' || ', this.aliasable('helpers.helperMissing'));
	    }
	    lookup.push(')');

	    this.push(this.source.functionCall(lookup, 'call', helper.callParams));
	  },

	  // [invokeKnownHelper]
	  //
	  // On stack, before: hash, inverse, program, params..., ...
	  // On stack, after: result of helper invocation
	  //
	  // This operation is used when the helper is known to exist,
	  // so a `helperMissing` fallback is not required.
	  invokeKnownHelper: function invokeKnownHelper(paramSize, name) {
	    var helper = this.setupHelper(paramSize, name);
	    this.push(this.source.functionCall(helper.name, 'call', helper.callParams));
	  },

	  // [invokeAmbiguous]
	  //
	  // On stack, before: hash, inverse, program, params..., ...
	  // On stack, after: result of disambiguation
	  //
	  // This operation is used when an expression like `{{foo}}`
	  // is provided, but we don't know at compile-time whether it
	  // is a helper or a path.
	  //
	  // This operation emits more code than the other options,
	  // and can be avoided by passing the `knownHelpers` and
	  // `knownHelpersOnly` flags at compile-time.
	  invokeAmbiguous: function invokeAmbiguous(name, helperCall) {
	    this.useRegister('helper');

	    var nonHelper = this.popStack();

	    this.emptyHash();
	    var helper = this.setupHelper(0, name, helperCall);

	    var helperName = this.lastHelper = this.nameLookup('helpers', name, 'helper');

	    var lookup = ['(', '(helper = ', helperName, ' || ', nonHelper, ')'];
	    if (!this.options.strict) {
	      lookup[0] = '(helper = ';
	      lookup.push(' != null ? helper : ', this.aliasable('helpers.helperMissing'));
	    }

	    this.push(['(', lookup, helper.paramsInit ? ['),(', helper.paramsInit] : [], '),', '(typeof helper === ', this.aliasable('"function"'), ' ? ', this.source.functionCall('helper', 'call', helper.callParams), ' : helper))']);
	  },

	  // [invokePartial]
	  //
	  // On stack, before: context, ...
	  // On stack after: result of partial invocation
	  //
	  // This operation pops off a context, invokes a partial with that context,
	  // and pushes the result of the invocation back.
	  invokePartial: function invokePartial(isDynamic, name, indent) {
	    var params = [],
	        options = this.setupParams(name, 1, params, false);

	    if (isDynamic) {
	      name = this.popStack();
	      delete options.name;
	    }

	    if (indent) {
	      options.indent = JSON.stringify(indent);
	    }
	    options.helpers = 'helpers';
	    options.partials = 'partials';

	    if (!isDynamic) {
	      params.unshift(this.nameLookup('partials', name, 'partial'));
	    } else {
	      params.unshift(name);
	    }

	    if (this.options.compat) {
	      options.depths = 'depths';
	    }
	    options = this.objectLiteral(options);
	    params.push(options);

	    this.push(this.source.functionCall('this.invokePartial', '', params));
	  },

	  // [assignToHash]
	  //
	  // On stack, before: value, ..., hash, ...
	  // On stack, after: ..., hash, ...
	  //
	  // Pops a value off the stack and assigns it to the current hash
	  assignToHash: function assignToHash(key) {
	    var value = this.popStack(),
	        context = undefined,
	        type = undefined,
	        id = undefined;

	    if (this.trackIds) {
	      id = this.popStack();
	    }
	    if (this.stringParams) {
	      type = this.popStack();
	      context = this.popStack();
	    }

	    var hash = this.hash;
	    if (context) {
	      hash.contexts[key] = context;
	    }
	    if (type) {
	      hash.types[key] = type;
	    }
	    if (id) {
	      hash.ids[key] = id;
	    }
	    hash.values[key] = value;
	  },

	  pushId: function pushId(type, name, child) {
	    if (type === 'BlockParam') {
	      this.pushStackLiteral('blockParams[' + name[0] + '].path[' + name[1] + ']' + (child ? ' + ' + JSON.stringify('.' + child) : ''));
	    } else if (type === 'PathExpression') {
	      this.pushString(name);
	    } else if (type === 'SubExpression') {
	      this.pushStackLiteral('true');
	    } else {
	      this.pushStackLiteral('null');
	    }
	  },

	  // HELPERS

	  compiler: JavaScriptCompiler,

	  compileChildren: function compileChildren(environment, options) {
	    var children = environment.children,
	        child = undefined,
	        compiler = undefined;

	    for (var i = 0, l = children.length; i < l; i++) {
	      child = children[i];
	      compiler = new this.compiler(); // eslint-disable-line new-cap

	      var index = this.matchExistingProgram(child);

	      if (index == null) {
	        this.context.programs.push(''); // Placeholder to prevent name conflicts for nested children
	        index = this.context.programs.length;
	        child.index = index;
	        child.name = 'program' + index;
	        this.context.programs[index] = compiler.compile(child, options, this.context, !this.precompile);
	        this.context.environments[index] = child;

	        this.useDepths = this.useDepths || compiler.useDepths;
	        this.useBlockParams = this.useBlockParams || compiler.useBlockParams;
	      } else {
	        child.index = index;
	        child.name = 'program' + index;

	        this.useDepths = this.useDepths || child.useDepths;
	        this.useBlockParams = this.useBlockParams || child.useBlockParams;
	      }
	    }
	  },
	  matchExistingProgram: function matchExistingProgram(child) {
	    for (var i = 0, len = this.context.environments.length; i < len; i++) {
	      var environment = this.context.environments[i];
	      if (environment && environment.equals(child)) {
	        return i;
	      }
	    }
	  },

	  programExpression: function programExpression(guid) {
	    var child = this.environment.children[guid],
	        programParams = [child.index, 'data', child.blockParams];

	    if (this.useBlockParams || this.useDepths) {
	      programParams.push('blockParams');
	    }
	    if (this.useDepths) {
	      programParams.push('depths');
	    }

	    return 'this.program(' + programParams.join(', ') + ')';
	  },

	  useRegister: function useRegister(name) {
	    if (!this.registers[name]) {
	      this.registers[name] = true;
	      this.registers.list.push(name);
	    }
	  },

	  push: function push(expr) {
	    if (!(expr instanceof Literal)) {
	      expr = this.source.wrap(expr);
	    }

	    this.inlineStack.push(expr);
	    return expr;
	  },

	  pushStackLiteral: function pushStackLiteral(item) {
	    this.push(new Literal(item));
	  },

	  pushSource: function pushSource(source) {
	    if (this.pendingContent) {
	      this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation));
	      this.pendingContent = undefined;
	    }

	    if (source) {
	      this.source.push(source);
	    }
	  },

	  replaceStack: function replaceStack(callback) {
	    var prefix = ['('],
	        stack = undefined,
	        createdStack = undefined,
	        usedLiteral = undefined;

	    /* istanbul ignore next */
	    if (!this.isInline()) {
	      throw new _Exception2['default']('replaceStack on non-inline');
	    }

	    // We want to merge the inline statement into the replacement statement via ','
	    var top = this.popStack(true);

	    if (top instanceof Literal) {
	      // Literals do not need to be inlined
	      stack = [top.value];
	      prefix = ['(', stack];
	      usedLiteral = true;
	    } else {
	      // Get or create the current stack name for use by the inline
	      createdStack = true;
	      var _name = this.incrStack();

	      prefix = ['((', this.push(_name), ' = ', top, ')'];
	      stack = this.topStack();
	    }

	    var item = callback.call(this, stack);

	    if (!usedLiteral) {
	      this.popStack();
	    }
	    if (createdStack) {
	      this.stackSlot--;
	    }
	    this.push(prefix.concat(item, ')'));
	  },

	  incrStack: function incrStack() {
	    this.stackSlot++;
	    if (this.stackSlot > this.stackVars.length) {
	      this.stackVars.push('stack' + this.stackSlot);
	    }
	    return this.topStackName();
	  },
	  topStackName: function topStackName() {
	    return 'stack' + this.stackSlot;
	  },
	  flushInline: function flushInline() {
	    var inlineStack = this.inlineStack;
	    this.inlineStack = [];
	    for (var i = 0, len = inlineStack.length; i < len; i++) {
	      var entry = inlineStack[i];
	      /* istanbul ignore if */
	      if (entry instanceof Literal) {
	        this.compileStack.push(entry);
	      } else {
	        var stack = this.incrStack();
	        this.pushSource([stack, ' = ', entry, ';']);
	        this.compileStack.push(stack);
	      }
	    }
	  },
	  isInline: function isInline() {
	    return this.inlineStack.length;
	  },

	  popStack: function popStack(wrapped) {
	    var inline = this.isInline(),
	        item = (inline ? this.inlineStack : this.compileStack).pop();

	    if (!wrapped && item instanceof Literal) {
	      return item.value;
	    } else {
	      if (!inline) {
	        /* istanbul ignore next */
	        if (!this.stackSlot) {
	          throw new _Exception2['default']('Invalid stack pop');
	        }
	        this.stackSlot--;
	      }
	      return item;
	    }
	  },

	  topStack: function topStack() {
	    var stack = this.isInline() ? this.inlineStack : this.compileStack,
	        item = stack[stack.length - 1];

	    /* istanbul ignore if */
	    if (item instanceof Literal) {
	      return item.value;
	    } else {
	      return item;
	    }
	  },

	  contextName: function contextName(context) {
	    if (this.useDepths && context) {
	      return 'depths[' + context + ']';
	    } else {
	      return 'depth' + context;
	    }
	  },

	  quotedString: function quotedString(str) {
	    return this.source.quotedString(str);
	  },

	  objectLiteral: function objectLiteral(obj) {
	    return this.source.objectLiteral(obj);
	  },

	  aliasable: function aliasable(name) {
	    var ret = this.aliases[name];
	    if (ret) {
	      ret.referenceCount++;
	      return ret;
	    }

	    ret = this.aliases[name] = this.source.wrap(name);
	    ret.aliasable = true;
	    ret.referenceCount = 1;

	    return ret;
	  },

	  setupHelper: function setupHelper(paramSize, name, blockHelper) {
	    var params = [],
	        paramsInit = this.setupHelperArgs(name, paramSize, params, blockHelper);
	    var foundHelper = this.nameLookup('helpers', name, 'helper');

	    return {
	      params: params,
	      paramsInit: paramsInit,
	      name: foundHelper,
	      callParams: [this.contextName(0)].concat(params)
	    };
	  },

	  setupParams: function setupParams(helper, paramSize, params) {
	    var options = {},
	        contexts = [],
	        types = [],
	        ids = [],
	        param = undefined;

	    options.name = this.quotedString(helper);
	    options.hash = this.popStack();

	    if (this.trackIds) {
	      options.hashIds = this.popStack();
	    }
	    if (this.stringParams) {
	      options.hashTypes = this.popStack();
	      options.hashContexts = this.popStack();
	    }

	    var inverse = this.popStack(),
	        program = this.popStack();

	    // Avoid setting fn and inverse if neither are set. This allows
	    // helpers to do a check for `if (options.fn)`
	    if (program || inverse) {
	      options.fn = program || 'this.noop';
	      options.inverse = inverse || 'this.noop';
	    }

	    // The parameters go on to the stack in order (making sure that they are evaluated in order)
	    // so we need to pop them off the stack in reverse order
	    var i = paramSize;
	    while (i--) {
	      param = this.popStack();
	      params[i] = param;

	      if (this.trackIds) {
	        ids[i] = this.popStack();
	      }
	      if (this.stringParams) {
	        types[i] = this.popStack();
	        contexts[i] = this.popStack();
	      }
	    }

	    if (this.trackIds) {
	      options.ids = this.source.generateArray(ids);
	    }
	    if (this.stringParams) {
	      options.types = this.source.generateArray(types);
	      options.contexts = this.source.generateArray(contexts);
	    }

	    if (this.options.data) {
	      options.data = 'data';
	    }
	    if (this.useBlockParams) {
	      options.blockParams = 'blockParams';
	    }
	    return options;
	  },

	  setupHelperArgs: function setupHelperArgs(helper, paramSize, params, useRegister) {
	    var options = this.setupParams(helper, paramSize, params, true);
	    options = this.objectLiteral(options);
	    if (useRegister) {
	      this.useRegister('options');
	      params.push('options');
	      return ['options=', options];
	    } else {
	      params.push(options);
	      return '';
	    }
	  }
	};

	(function () {
	  var reservedWords = ('break else new var' + ' case finally return void' + ' catch for switch while' + ' continue function this with' + ' default if throw' + ' delete in try' + ' do instanceof typeof' + ' abstract enum int short' + ' boolean export interface static' + ' byte extends long super' + ' char final native synchronized' + ' class float package throws' + ' const goto private transient' + ' debugger implements protected volatile' + ' double import public let yield await' + ' null true false').split(' ');

	  var compilerWords = JavaScriptCompiler.RESERVED_WORDS = {};

	  for (var i = 0, l = reservedWords.length; i < l; i++) {
	    compilerWords[reservedWords[i]] = true;
	  }
	})();

	JavaScriptCompiler.isValidJavaScriptVariableName = function (name) {
	  return !JavaScriptCompiler.RESERVED_WORDS[name] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(name);
	};

	function strictLookup(requireTerminal, compiler, parts, type) {
	  var stack = compiler.popStack(),
	      i = 0,
	      len = parts.length;
	  if (requireTerminal) {
	    len--;
	  }

	  for (; i < len; i++) {
	    stack = compiler.nameLookup(stack, parts[i], type);
	  }

	  if (requireTerminal) {
	    return [compiler.aliasable('this.strict'), '(', stack, ', ', compiler.quotedString(parts[i]), ')'];
	  } else {
	    return stack;
	  }
	}

	exports['default'] = JavaScriptCompiler;
	module.exports = exports['default'];

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(8)['default'];

	exports.__esModule = true;

	var _Exception = __webpack_require__(12);

	var _Exception2 = _interopRequireDefault(_Exception);

	var _AST = __webpack_require__(2);

	var _AST2 = _interopRequireDefault(_AST);

	function Visitor() {
	  this.parents = [];
	}

	Visitor.prototype = {
	  constructor: Visitor,
	  mutating: false,

	  // Visits a given value. If mutating, will replace the value if necessary.
	  acceptKey: function acceptKey(node, name) {
	    var value = this.accept(node[name]);
	    if (this.mutating) {
	      // Hacky sanity check:
	      if (value && (!value.type || !_AST2['default'][value.type])) {
	        throw new _Exception2['default']('Unexpected node type "' + value.type + '" found when accepting ' + name + ' on ' + node.type);
	      }
	      node[name] = value;
	    }
	  },

	  // Performs an accept operation with added sanity check to ensure
	  // required keys are not removed.
	  acceptRequired: function acceptRequired(node, name) {
	    this.acceptKey(node, name);

	    if (!node[name]) {
	      throw new _Exception2['default'](node.type + ' requires ' + name);
	    }
	  },

	  // Traverses a given array. If mutating, empty respnses will be removed
	  // for child elements.
	  acceptArray: function acceptArray(array) {
	    for (var i = 0, l = array.length; i < l; i++) {
	      this.acceptKey(array, i);

	      if (!array[i]) {
	        array.splice(i, 1);
	        i--;
	        l--;
	      }
	    }
	  },

	  accept: function accept(object) {
	    if (!object) {
	      return;
	    }

	    if (this.current) {
	      this.parents.unshift(this.current);
	    }
	    this.current = object;

	    var ret = this[object.type](object);

	    this.current = this.parents.shift();

	    if (!this.mutating || ret) {
	      return ret;
	    } else if (ret !== false) {
	      return object;
	    }
	  },

	  Program: function Program(program) {
	    this.acceptArray(program.body);
	  },

	  MustacheStatement: function MustacheStatement(mustache) {
	    this.acceptRequired(mustache, 'path');
	    this.acceptArray(mustache.params);
	    this.acceptKey(mustache, 'hash');
	  },

	  BlockStatement: function BlockStatement(block) {
	    this.acceptRequired(block, 'path');
	    this.acceptArray(block.params);
	    this.acceptKey(block, 'hash');

	    this.acceptKey(block, 'program');
	    this.acceptKey(block, 'inverse');
	  },

	  PartialStatement: function PartialStatement(partial) {
	    this.acceptRequired(partial, 'name');
	    this.acceptArray(partial.params);
	    this.acceptKey(partial, 'hash');
	  },

	  ContentStatement: function ContentStatement() {},
	  CommentStatement: function CommentStatement() {},

	  SubExpression: function SubExpression(sexpr) {
	    this.acceptRequired(sexpr, 'path');
	    this.acceptArray(sexpr.params);
	    this.acceptKey(sexpr, 'hash');
	  },

	  PathExpression: function PathExpression() {},

	  StringLiteral: function StringLiteral() {},
	  NumberLiteral: function NumberLiteral() {},
	  BooleanLiteral: function BooleanLiteral() {},
	  UndefinedLiteral: function UndefinedLiteral() {},
	  NullLiteral: function NullLiteral() {},

	  Hash: function Hash(hash) {
	    this.acceptArray(hash.pairs);
	  },
	  HashPair: function HashPair(pair) {
	    this.acceptRequired(pair, 'value');
	  }
	};

	exports['default'] = Visitor;
	module.exports = exports['default'];
	/* content */ /* comment */ /* path */ /* string */ /* number */ /* bool */ /* literal */ /* literal */

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	exports.__esModule = true;
	/*global window */

	exports['default'] = function (Handlebars) {
	  /* istanbul ignore next */
	  var root = typeof global !== 'undefined' ? global : window,
	      $Handlebars = root.Handlebars;
	  /* istanbul ignore next */
	  Handlebars.noConflict = function () {
	    if (root.Handlebars === Handlebars) {
	      root.Handlebars = $Handlebars;
	    }
	  };
	};

	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	exports["default"] = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	};

	exports.__esModule = true;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	exports["default"] = function (obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};

	    if (typeof obj === "object" && obj !== null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }

	    newObj["default"] = obj;
	    return newObj;
	  }
	};

	exports.__esModule = true;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireWildcard = __webpack_require__(9)['default'];

	var _interopRequireDefault = __webpack_require__(8)['default'];

	exports.__esModule = true;
	exports.HandlebarsEnvironment = HandlebarsEnvironment;
	exports.createFrame = createFrame;

	var _import = __webpack_require__(13);

	var Utils = _interopRequireWildcard(_import);

	var _Exception = __webpack_require__(12);

	var _Exception2 = _interopRequireDefault(_Exception);

	var VERSION = '3.0.1';
	exports.VERSION = VERSION;
	var COMPILER_REVISION = 6;

	exports.COMPILER_REVISION = COMPILER_REVISION;
	var REVISION_CHANGES = {
	  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
	  2: '== 1.0.0-rc.3',
	  3: '== 1.0.0-rc.4',
	  4: '== 1.x.x',
	  5: '== 2.0.0-alpha.x',
	  6: '>= 2.0.0-beta.1'
	};

	exports.REVISION_CHANGES = REVISION_CHANGES;
	var isArray = Utils.isArray,
	    isFunction = Utils.isFunction,
	    toString = Utils.toString,
	    objectType = '[object Object]';

	function HandlebarsEnvironment(helpers, partials) {
	  this.helpers = helpers || {};
	  this.partials = partials || {};

	  registerDefaultHelpers(this);
	}

	HandlebarsEnvironment.prototype = {
	  constructor: HandlebarsEnvironment,

	  logger: logger,
	  log: log,

	  registerHelper: function registerHelper(name, fn) {
	    if (toString.call(name) === objectType) {
	      if (fn) {
	        throw new _Exception2['default']('Arg not supported with multiple helpers');
	      }
	      Utils.extend(this.helpers, name);
	    } else {
	      this.helpers[name] = fn;
	    }
	  },
	  unregisterHelper: function unregisterHelper(name) {
	    delete this.helpers[name];
	  },

	  registerPartial: function registerPartial(name, partial) {
	    if (toString.call(name) === objectType) {
	      Utils.extend(this.partials, name);
	    } else {
	      if (typeof partial === 'undefined') {
	        throw new _Exception2['default']('Attempting to register a partial as undefined');
	      }
	      this.partials[name] = partial;
	    }
	  },
	  unregisterPartial: function unregisterPartial(name) {
	    delete this.partials[name];
	  }
	};

	function registerDefaultHelpers(instance) {
	  instance.registerHelper('helperMissing', function () {
	    if (arguments.length === 1) {
	      // A missing field in a {{foo}} constuct.
	      return undefined;
	    } else {
	      // Someone is actually trying to call something, blow up.
	      throw new _Exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
	    }
	  });

	  instance.registerHelper('blockHelperMissing', function (context, options) {
	    var inverse = options.inverse,
	        fn = options.fn;

	    if (context === true) {
	      return fn(this);
	    } else if (context === false || context == null) {
	      return inverse(this);
	    } else if (isArray(context)) {
	      if (context.length > 0) {
	        if (options.ids) {
	          options.ids = [options.name];
	        }

	        return instance.helpers.each(context, options);
	      } else {
	        return inverse(this);
	      }
	    } else {
	      if (options.data && options.ids) {
	        var data = createFrame(options.data);
	        data.contextPath = Utils.appendContextPath(options.data.contextPath, options.name);
	        options = { data: data };
	      }

	      return fn(context, options);
	    }
	  });

	  instance.registerHelper('each', function (context, options) {
	    if (!options) {
	      throw new _Exception2['default']('Must pass iterator to #each');
	    }

	    var fn = options.fn,
	        inverse = options.inverse,
	        i = 0,
	        ret = '',
	        data = undefined,
	        contextPath = undefined;

	    if (options.data && options.ids) {
	      contextPath = Utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
	    }

	    if (isFunction(context)) {
	      context = context.call(this);
	    }

	    if (options.data) {
	      data = createFrame(options.data);
	    }

	    function execIteration(field, index, last) {
	      if (data) {
	        data.key = field;
	        data.index = index;
	        data.first = index === 0;
	        data.last = !!last;

	        if (contextPath) {
	          data.contextPath = contextPath + field;
	        }
	      }

	      ret = ret + fn(context[field], {
	        data: data,
	        blockParams: Utils.blockParams([context[field], field], [contextPath + field, null])
	      });
	    }

	    if (context && typeof context === 'object') {
	      if (isArray(context)) {
	        for (var j = context.length; i < j; i++) {
	          execIteration(i, i, i === context.length - 1);
	        }
	      } else {
	        var priorKey = undefined;

	        for (var key in context) {
	          if (context.hasOwnProperty(key)) {
	            // We're running the iterations one step out of sync so we can detect
	            // the last iteration without have to scan the object twice and create
	            // an itermediate keys array.
	            if (priorKey) {
	              execIteration(priorKey, i - 1);
	            }
	            priorKey = key;
	            i++;
	          }
	        }
	        if (priorKey) {
	          execIteration(priorKey, i - 1, true);
	        }
	      }
	    }

	    if (i === 0) {
	      ret = inverse(this);
	    }

	    return ret;
	  });

	  instance.registerHelper('if', function (conditional, options) {
	    if (isFunction(conditional)) {
	      conditional = conditional.call(this);
	    }

	    // Default behavior is to render the positive path if the value is truthy and not empty.
	    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
	    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
	    if (!options.hash.includeZero && !conditional || Utils.isEmpty(conditional)) {
	      return options.inverse(this);
	    } else {
	      return options.fn(this);
	    }
	  });

	  instance.registerHelper('unless', function (conditional, options) {
	    return instance.helpers['if'].call(this, conditional, { fn: options.inverse, inverse: options.fn, hash: options.hash });
	  });

	  instance.registerHelper('with', function (context, options) {
	    if (isFunction(context)) {
	      context = context.call(this);
	    }

	    var fn = options.fn;

	    if (!Utils.isEmpty(context)) {
	      if (options.data && options.ids) {
	        var data = createFrame(options.data);
	        data.contextPath = Utils.appendContextPath(options.data.contextPath, options.ids[0]);
	        options = { data: data };
	      }

	      return fn(context, options);
	    } else {
	      return options.inverse(this);
	    }
	  });

	  instance.registerHelper('log', function (message, options) {
	    var level = options.data && options.data.level != null ? parseInt(options.data.level, 10) : 1;
	    instance.log(level, message);
	  });

	  instance.registerHelper('lookup', function (obj, field) {
	    return obj && obj[field];
	  });
	}

	var logger = {
	  methodMap: { 0: 'debug', 1: 'info', 2: 'warn', 3: 'error' },

	  // State enum
	  DEBUG: 0,
	  INFO: 1,
	  WARN: 2,
	  ERROR: 3,
	  level: 1,

	  // Can be overridden in the host environment
	  log: function log(level, message) {
	    if (typeof console !== 'undefined' && logger.level <= level) {
	      var method = logger.methodMap[level];
	      (console[method] || console.log).call(console, message); // eslint-disable-line no-console
	    }
	  }
	};

	exports.logger = logger;
	var log = logger.log;

	exports.log = log;

	function createFrame(object) {
	  var frame = Utils.extend({}, object);
	  frame._parent = object;
	  return frame;
	}

	/* [args, ]options */

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	// Build out our basic SafeString type
	function SafeString(string) {
	  this.string = string;
	}

	SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
	  return '' + this.string;
	};

	exports['default'] = SafeString;
	module.exports = exports['default'];

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var errorProps = ['description', 'fileName', 'lineNumber', 'message', 'name', 'number', 'stack'];

	function Exception(message, node) {
	  var loc = node && node.loc,
	      line = undefined,
	      column = undefined;
	  if (loc) {
	    line = loc.start.line;
	    column = loc.start.column;

	    message += ' - ' + line + ':' + column;
	  }

	  var tmp = Error.prototype.constructor.call(this, message);

	  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
	  for (var idx = 0; idx < errorProps.length; idx++) {
	    this[errorProps[idx]] = tmp[errorProps[idx]];
	  }

	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, Exception);
	  }

	  if (loc) {
	    this.lineNumber = line;
	    this.column = column;
	  }
	}

	Exception.prototype = new Error();

	exports['default'] = Exception;
	module.exports = exports['default'];

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.extend = extend;

	// Older IE versions do not directly support indexOf so we must implement our own, sadly.
	exports.indexOf = indexOf;
	exports.escapeExpression = escapeExpression;
	exports.isEmpty = isEmpty;
	exports.blockParams = blockParams;
	exports.appendContextPath = appendContextPath;
	var escape = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  '\'': '&#x27;',
	  '`': '&#x60;'
	};

	var badChars = /[&<>"'`]/g,
	    possible = /[&<>"'`]/;

	function escapeChar(chr) {
	  return escape[chr];
	}

	function extend(obj /* , ...source */) {
	  for (var i = 1; i < arguments.length; i++) {
	    for (var key in arguments[i]) {
	      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
	        obj[key] = arguments[i][key];
	      }
	    }
	  }

	  return obj;
	}

	var toString = Object.prototype.toString;

	exports.toString = toString;
	// Sourced from lodash
	// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
	/*eslint-disable func-style, no-var */
	var isFunction = function isFunction(value) {
	  return typeof value === 'function';
	};
	// fallback for older versions of Chrome and Safari
	/* istanbul ignore next */
	if (isFunction(/x/)) {
	  exports.isFunction = isFunction = function (value) {
	    return typeof value === 'function' && toString.call(value) === '[object Function]';
	  };
	}
	var isFunction;
	exports.isFunction = isFunction;
	/*eslint-enable func-style, no-var */

	/* istanbul ignore next */
	var isArray = Array.isArray || function (value) {
	  return value && typeof value === 'object' ? toString.call(value) === '[object Array]' : false;
	};exports.isArray = isArray;

	function indexOf(array, value) {
	  for (var i = 0, len = array.length; i < len; i++) {
	    if (array[i] === value) {
	      return i;
	    }
	  }
	  return -1;
	}

	function escapeExpression(string) {
	  if (typeof string !== 'string') {
	    // don't escape SafeStrings, since they're already safe
	    if (string && string.toHTML) {
	      return string.toHTML();
	    } else if (string == null) {
	      return '';
	    } else if (!string) {
	      return string + '';
	    }

	    // Force a string conversion as this will be done by the append regardless and
	    // the regex test will do this transparently behind the scenes, causing issues if
	    // an object's to string has escaped characters in it.
	    string = '' + string;
	  }

	  if (!possible.test(string)) {
	    return string;
	  }
	  return string.replace(badChars, escapeChar);
	}

	function isEmpty(value) {
	  if (!value && value !== 0) {
	    return true;
	  } else if (isArray(value) && value.length === 0) {
	    return true;
	  } else {
	    return false;
	  }
	}

	function blockParams(params, ids) {
	  params.path = ids;
	  return params;
	}

	function appendContextPath(contextPath, id) {
	  return (contextPath ? contextPath + '.' : '') + id;
	}

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireWildcard = __webpack_require__(9)['default'];

	var _interopRequireDefault = __webpack_require__(8)['default'];

	exports.__esModule = true;
	exports.checkRevision = checkRevision;

	// TODO: Remove this line and break up compilePartial

	exports.template = template;
	exports.wrapProgram = wrapProgram;
	exports.resolvePartial = resolvePartial;
	exports.invokePartial = invokePartial;
	exports.noop = noop;

	var _import = __webpack_require__(13);

	var Utils = _interopRequireWildcard(_import);

	var _Exception = __webpack_require__(12);

	var _Exception2 = _interopRequireDefault(_Exception);

	var _COMPILER_REVISION$REVISION_CHANGES$createFrame = __webpack_require__(10);

	function checkRevision(compilerInfo) {
	  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
	      currentRevision = _COMPILER_REVISION$REVISION_CHANGES$createFrame.COMPILER_REVISION;

	  if (compilerRevision !== currentRevision) {
	    if (compilerRevision < currentRevision) {
	      var runtimeVersions = _COMPILER_REVISION$REVISION_CHANGES$createFrame.REVISION_CHANGES[currentRevision],
	          compilerVersions = _COMPILER_REVISION$REVISION_CHANGES$createFrame.REVISION_CHANGES[compilerRevision];
	      throw new _Exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
	    } else {
	      // Use the embedded version info since the runtime doesn't know about this revision yet
	      throw new _Exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
	    }
	  }
	}

	function template(templateSpec, env) {
	  /* istanbul ignore next */
	  if (!env) {
	    throw new _Exception2['default']('No environment passed to template');
	  }
	  if (!templateSpec || !templateSpec.main) {
	    throw new _Exception2['default']('Unknown template object: ' + typeof templateSpec);
	  }

	  // Note: Using env.VM references rather than local var references throughout this section to allow
	  // for external users to override these as psuedo-supported APIs.
	  env.VM.checkRevision(templateSpec.compiler);

	  function invokePartialWrapper(partial, context, options) {
	    if (options.hash) {
	      context = Utils.extend({}, context, options.hash);
	    }

	    partial = env.VM.resolvePartial.call(this, partial, context, options);
	    var result = env.VM.invokePartial.call(this, partial, context, options);

	    if (result == null && env.compile) {
	      options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
	      result = options.partials[options.name](context, options);
	    }
	    if (result != null) {
	      if (options.indent) {
	        var lines = result.split('\n');
	        for (var i = 0, l = lines.length; i < l; i++) {
	          if (!lines[i] && i + 1 === l) {
	            break;
	          }

	          lines[i] = options.indent + lines[i];
	        }
	        result = lines.join('\n');
	      }
	      return result;
	    } else {
	      throw new _Exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
	    }
	  }

	  // Just add water
	  var container = {
	    strict: function strict(obj, name) {
	      if (!(name in obj)) {
	        throw new _Exception2['default']('"' + name + '" not defined in ' + obj);
	      }
	      return obj[name];
	    },
	    lookup: function lookup(depths, name) {
	      var len = depths.length;
	      for (var i = 0; i < len; i++) {
	        if (depths[i] && depths[i][name] != null) {
	          return depths[i][name];
	        }
	      }
	    },
	    lambda: function lambda(current, context) {
	      return typeof current === 'function' ? current.call(context) : current;
	    },

	    escapeExpression: Utils.escapeExpression,
	    invokePartial: invokePartialWrapper,

	    fn: function fn(i) {
	      return templateSpec[i];
	    },

	    programs: [],
	    program: function program(i, data, declaredBlockParams, blockParams, depths) {
	      var programWrapper = this.programs[i],
	          fn = this.fn(i);
	      if (data || depths || blockParams || declaredBlockParams) {
	        programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
	      } else if (!programWrapper) {
	        programWrapper = this.programs[i] = wrapProgram(this, i, fn);
	      }
	      return programWrapper;
	    },

	    data: function data(value, depth) {
	      while (value && depth--) {
	        value = value._parent;
	      }
	      return value;
	    },
	    merge: function merge(param, common) {
	      var obj = param || common;

	      if (param && common && param !== common) {
	        obj = Utils.extend({}, common, param);
	      }

	      return obj;
	    },

	    noop: env.VM.noop,
	    compilerInfo: templateSpec.compiler
	  };

	  function ret(context) {
	    var options = arguments[1] === undefined ? {} : arguments[1];

	    var data = options.data;

	    ret._setup(options);
	    if (!options.partial && templateSpec.useData) {
	      data = initData(context, data);
	    }
	    var depths = undefined,
	        blockParams = templateSpec.useBlockParams ? [] : undefined;
	    if (templateSpec.useDepths) {
	      depths = options.depths ? [context].concat(options.depths) : [context];
	    }

	    return templateSpec.main.call(container, context, container.helpers, container.partials, data, blockParams, depths);
	  }
	  ret.isTop = true;

	  ret._setup = function (options) {
	    if (!options.partial) {
	      container.helpers = container.merge(options.helpers, env.helpers);

	      if (templateSpec.usePartial) {
	        container.partials = container.merge(options.partials, env.partials);
	      }
	    } else {
	      container.helpers = options.helpers;
	      container.partials = options.partials;
	    }
	  };

	  ret._child = function (i, data, blockParams, depths) {
	    if (templateSpec.useBlockParams && !blockParams) {
	      throw new _Exception2['default']('must pass block params');
	    }
	    if (templateSpec.useDepths && !depths) {
	      throw new _Exception2['default']('must pass parent depths');
	    }

	    return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
	  };
	  return ret;
	}

	function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
	  function prog(context) {
	    var options = arguments[1] === undefined ? {} : arguments[1];

	    return fn.call(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), depths && [context].concat(depths));
	  }
	  prog.program = i;
	  prog.depth = depths ? depths.length : 0;
	  prog.blockParams = declaredBlockParams || 0;
	  return prog;
	}

	function resolvePartial(partial, context, options) {
	  if (!partial) {
	    partial = options.partials[options.name];
	  } else if (!partial.call && !options.name) {
	    // This is a dynamic partial that returned a string
	    options.name = partial;
	    partial = options.partials[partial];
	  }
	  return partial;
	}

	function invokePartial(partial, context, options) {
	  options.partial = true;

	  if (partial === undefined) {
	    throw new _Exception2['default']('The partial ' + options.name + ' could not be found');
	  } else if (partial instanceof Function) {
	    return partial(context, options);
	  }
	}

	function noop() {
	  return '';
	}

	function initData(context, data) {
	  if (!data || !('root' in data)) {
	    data = data ? _COMPILER_REVISION$REVISION_CHANGES$createFrame.createFrame(data) : {};
	    data.root = context;
	  }
	  return data;
	}

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;
	/* istanbul ignore next */
	/* Jison generated parser */
	var handlebars = (function () {
	    var parser = { trace: function trace() {},
	        yy: {},
	        symbols_: { error: 2, root: 3, program: 4, EOF: 5, program_repetition0: 6, statement: 7, mustache: 8, block: 9, rawBlock: 10, partial: 11, content: 12, COMMENT: 13, CONTENT: 14, openRawBlock: 15, END_RAW_BLOCK: 16, OPEN_RAW_BLOCK: 17, helperName: 18, openRawBlock_repetition0: 19, openRawBlock_option0: 20, CLOSE_RAW_BLOCK: 21, openBlock: 22, block_option0: 23, closeBlock: 24, openInverse: 25, block_option1: 26, OPEN_BLOCK: 27, openBlock_repetition0: 28, openBlock_option0: 29, openBlock_option1: 30, CLOSE: 31, OPEN_INVERSE: 32, openInverse_repetition0: 33, openInverse_option0: 34, openInverse_option1: 35, openInverseChain: 36, OPEN_INVERSE_CHAIN: 37, openInverseChain_repetition0: 38, openInverseChain_option0: 39, openInverseChain_option1: 40, inverseAndProgram: 41, INVERSE: 42, inverseChain: 43, inverseChain_option0: 44, OPEN_ENDBLOCK: 45, OPEN: 46, mustache_repetition0: 47, mustache_option0: 48, OPEN_UNESCAPED: 49, mustache_repetition1: 50, mustache_option1: 51, CLOSE_UNESCAPED: 52, OPEN_PARTIAL: 53, partialName: 54, partial_repetition0: 55, partial_option0: 56, param: 57, sexpr: 58, OPEN_SEXPR: 59, sexpr_repetition0: 60, sexpr_option0: 61, CLOSE_SEXPR: 62, hash: 63, hash_repetition_plus0: 64, hashSegment: 65, ID: 66, EQUALS: 67, blockParams: 68, OPEN_BLOCK_PARAMS: 69, blockParams_repetition_plus0: 70, CLOSE_BLOCK_PARAMS: 71, path: 72, dataName: 73, STRING: 74, NUMBER: 75, BOOLEAN: 76, UNDEFINED: 77, NULL: 78, DATA: 79, pathSegments: 80, SEP: 81, $accept: 0, $end: 1 },
	        terminals_: { 2: "error", 5: "EOF", 13: "COMMENT", 14: "CONTENT", 16: "END_RAW_BLOCK", 17: "OPEN_RAW_BLOCK", 21: "CLOSE_RAW_BLOCK", 27: "OPEN_BLOCK", 31: "CLOSE", 32: "OPEN_INVERSE", 37: "OPEN_INVERSE_CHAIN", 42: "INVERSE", 45: "OPEN_ENDBLOCK", 46: "OPEN", 49: "OPEN_UNESCAPED", 52: "CLOSE_UNESCAPED", 53: "OPEN_PARTIAL", 59: "OPEN_SEXPR", 62: "CLOSE_SEXPR", 66: "ID", 67: "EQUALS", 69: "OPEN_BLOCK_PARAMS", 71: "CLOSE_BLOCK_PARAMS", 74: "STRING", 75: "NUMBER", 76: "BOOLEAN", 77: "UNDEFINED", 78: "NULL", 79: "DATA", 81: "SEP" },
	        productions_: [0, [3, 2], [4, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [12, 1], [10, 3], [15, 5], [9, 4], [9, 4], [22, 6], [25, 6], [36, 6], [41, 2], [43, 3], [43, 1], [24, 3], [8, 5], [8, 5], [11, 5], [57, 1], [57, 1], [58, 5], [63, 1], [65, 3], [68, 3], [18, 1], [18, 1], [18, 1], [18, 1], [18, 1], [18, 1], [18, 1], [54, 1], [54, 1], [73, 2], [72, 1], [80, 3], [80, 1], [6, 0], [6, 2], [19, 0], [19, 2], [20, 0], [20, 1], [23, 0], [23, 1], [26, 0], [26, 1], [28, 0], [28, 2], [29, 0], [29, 1], [30, 0], [30, 1], [33, 0], [33, 2], [34, 0], [34, 1], [35, 0], [35, 1], [38, 0], [38, 2], [39, 0], [39, 1], [40, 0], [40, 1], [44, 0], [44, 1], [47, 0], [47, 2], [48, 0], [48, 1], [50, 0], [50, 2], [51, 0], [51, 1], [55, 0], [55, 2], [56, 0], [56, 1], [60, 0], [60, 2], [61, 0], [61, 1], [64, 1], [64, 2], [70, 1], [70, 2]],
	        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$) {

	            var $0 = $$.length - 1;
	            switch (yystate) {
	                case 1:
	                    return $$[$0 - 1];
	                    break;
	                case 2:
	                    this.$ = new yy.Program($$[$0], null, {}, yy.locInfo(this._$));
	                    break;
	                case 3:
	                    this.$ = $$[$0];
	                    break;
	                case 4:
	                    this.$ = $$[$0];
	                    break;
	                case 5:
	                    this.$ = $$[$0];
	                    break;
	                case 6:
	                    this.$ = $$[$0];
	                    break;
	                case 7:
	                    this.$ = $$[$0];
	                    break;
	                case 8:
	                    this.$ = new yy.CommentStatement(yy.stripComment($$[$0]), yy.stripFlags($$[$0], $$[$0]), yy.locInfo(this._$));
	                    break;
	                case 9:
	                    this.$ = new yy.ContentStatement($$[$0], yy.locInfo(this._$));
	                    break;
	                case 10:
	                    this.$ = yy.prepareRawBlock($$[$0 - 2], $$[$0 - 1], $$[$0], this._$);
	                    break;
	                case 11:
	                    this.$ = { path: $$[$0 - 3], params: $$[$0 - 2], hash: $$[$0 - 1] };
	                    break;
	                case 12:
	                    this.$ = yy.prepareBlock($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], false, this._$);
	                    break;
	                case 13:
	                    this.$ = yy.prepareBlock($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], true, this._$);
	                    break;
	                case 14:
	                    this.$ = { path: $$[$0 - 4], params: $$[$0 - 3], hash: $$[$0 - 2], blockParams: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 5], $$[$0]) };
	                    break;
	                case 15:
	                    this.$ = { path: $$[$0 - 4], params: $$[$0 - 3], hash: $$[$0 - 2], blockParams: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 5], $$[$0]) };
	                    break;
	                case 16:
	                    this.$ = { path: $$[$0 - 4], params: $$[$0 - 3], hash: $$[$0 - 2], blockParams: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 5], $$[$0]) };
	                    break;
	                case 17:
	                    this.$ = { strip: yy.stripFlags($$[$0 - 1], $$[$0 - 1]), program: $$[$0] };
	                    break;
	                case 18:
	                    var inverse = yy.prepareBlock($$[$0 - 2], $$[$0 - 1], $$[$0], $$[$0], false, this._$),
	                        program = new yy.Program([inverse], null, {}, yy.locInfo(this._$));
	                    program.chained = true;

	                    this.$ = { strip: $$[$0 - 2].strip, program: program, chain: true };

	                    break;
	                case 19:
	                    this.$ = $$[$0];
	                    break;
	                case 20:
	                    this.$ = { path: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 2], $$[$0]) };
	                    break;
	                case 21:
	                    this.$ = yy.prepareMustache($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0 - 4], yy.stripFlags($$[$0 - 4], $$[$0]), this._$);
	                    break;
	                case 22:
	                    this.$ = yy.prepareMustache($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0 - 4], yy.stripFlags($$[$0 - 4], $$[$0]), this._$);
	                    break;
	                case 23:
	                    this.$ = new yy.PartialStatement($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], yy.stripFlags($$[$0 - 4], $$[$0]), yy.locInfo(this._$));
	                    break;
	                case 24:
	                    this.$ = $$[$0];
	                    break;
	                case 25:
	                    this.$ = $$[$0];
	                    break;
	                case 26:
	                    this.$ = new yy.SubExpression($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], yy.locInfo(this._$));
	                    break;
	                case 27:
	                    this.$ = new yy.Hash($$[$0], yy.locInfo(this._$));
	                    break;
	                case 28:
	                    this.$ = new yy.HashPair(yy.id($$[$0 - 2]), $$[$0], yy.locInfo(this._$));
	                    break;
	                case 29:
	                    this.$ = yy.id($$[$0 - 1]);
	                    break;
	                case 30:
	                    this.$ = $$[$0];
	                    break;
	                case 31:
	                    this.$ = $$[$0];
	                    break;
	                case 32:
	                    this.$ = new yy.StringLiteral($$[$0], yy.locInfo(this._$));
	                    break;
	                case 33:
	                    this.$ = new yy.NumberLiteral($$[$0], yy.locInfo(this._$));
	                    break;
	                case 34:
	                    this.$ = new yy.BooleanLiteral($$[$0], yy.locInfo(this._$));
	                    break;
	                case 35:
	                    this.$ = new yy.UndefinedLiteral(yy.locInfo(this._$));
	                    break;
	                case 36:
	                    this.$ = new yy.NullLiteral(yy.locInfo(this._$));
	                    break;
	                case 37:
	                    this.$ = $$[$0];
	                    break;
	                case 38:
	                    this.$ = $$[$0];
	                    break;
	                case 39:
	                    this.$ = yy.preparePath(true, $$[$0], this._$);
	                    break;
	                case 40:
	                    this.$ = yy.preparePath(false, $$[$0], this._$);
	                    break;
	                case 41:
	                    $$[$0 - 2].push({ part: yy.id($$[$0]), original: $$[$0], separator: $$[$0 - 1] });this.$ = $$[$0 - 2];
	                    break;
	                case 42:
	                    this.$ = [{ part: yy.id($$[$0]), original: $$[$0] }];
	                    break;
	                case 43:
	                    this.$ = [];
	                    break;
	                case 44:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 45:
	                    this.$ = [];
	                    break;
	                case 46:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 53:
	                    this.$ = [];
	                    break;
	                case 54:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 59:
	                    this.$ = [];
	                    break;
	                case 60:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 65:
	                    this.$ = [];
	                    break;
	                case 66:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 73:
	                    this.$ = [];
	                    break;
	                case 74:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 77:
	                    this.$ = [];
	                    break;
	                case 78:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 81:
	                    this.$ = [];
	                    break;
	                case 82:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 85:
	                    this.$ = [];
	                    break;
	                case 86:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 89:
	                    this.$ = [$$[$0]];
	                    break;
	                case 90:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 91:
	                    this.$ = [$$[$0]];
	                    break;
	                case 92:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	            }
	        },
	        table: [{ 3: 1, 4: 2, 5: [2, 43], 6: 3, 13: [2, 43], 14: [2, 43], 17: [2, 43], 27: [2, 43], 32: [2, 43], 46: [2, 43], 49: [2, 43], 53: [2, 43] }, { 1: [3] }, { 5: [1, 4] }, { 5: [2, 2], 7: 5, 8: 6, 9: 7, 10: 8, 11: 9, 12: 10, 13: [1, 11], 14: [1, 18], 15: 16, 17: [1, 21], 22: 14, 25: 15, 27: [1, 19], 32: [1, 20], 37: [2, 2], 42: [2, 2], 45: [2, 2], 46: [1, 12], 49: [1, 13], 53: [1, 17] }, { 1: [2, 1] }, { 5: [2, 44], 13: [2, 44], 14: [2, 44], 17: [2, 44], 27: [2, 44], 32: [2, 44], 37: [2, 44], 42: [2, 44], 45: [2, 44], 46: [2, 44], 49: [2, 44], 53: [2, 44] }, { 5: [2, 3], 13: [2, 3], 14: [2, 3], 17: [2, 3], 27: [2, 3], 32: [2, 3], 37: [2, 3], 42: [2, 3], 45: [2, 3], 46: [2, 3], 49: [2, 3], 53: [2, 3] }, { 5: [2, 4], 13: [2, 4], 14: [2, 4], 17: [2, 4], 27: [2, 4], 32: [2, 4], 37: [2, 4], 42: [2, 4], 45: [2, 4], 46: [2, 4], 49: [2, 4], 53: [2, 4] }, { 5: [2, 5], 13: [2, 5], 14: [2, 5], 17: [2, 5], 27: [2, 5], 32: [2, 5], 37: [2, 5], 42: [2, 5], 45: [2, 5], 46: [2, 5], 49: [2, 5], 53: [2, 5] }, { 5: [2, 6], 13: [2, 6], 14: [2, 6], 17: [2, 6], 27: [2, 6], 32: [2, 6], 37: [2, 6], 42: [2, 6], 45: [2, 6], 46: [2, 6], 49: [2, 6], 53: [2, 6] }, { 5: [2, 7], 13: [2, 7], 14: [2, 7], 17: [2, 7], 27: [2, 7], 32: [2, 7], 37: [2, 7], 42: [2, 7], 45: [2, 7], 46: [2, 7], 49: [2, 7], 53: [2, 7] }, { 5: [2, 8], 13: [2, 8], 14: [2, 8], 17: [2, 8], 27: [2, 8], 32: [2, 8], 37: [2, 8], 42: [2, 8], 45: [2, 8], 46: [2, 8], 49: [2, 8], 53: [2, 8] }, { 18: 22, 66: [1, 32], 72: 23, 73: 24, 74: [1, 25], 75: [1, 26], 76: [1, 27], 77: [1, 28], 78: [1, 29], 79: [1, 31], 80: 30 }, { 18: 33, 66: [1, 32], 72: 23, 73: 24, 74: [1, 25], 75: [1, 26], 76: [1, 27], 77: [1, 28], 78: [1, 29], 79: [1, 31], 80: 30 }, { 4: 34, 6: 3, 13: [2, 43], 14: [2, 43], 17: [2, 43], 27: [2, 43], 32: [2, 43], 37: [2, 43], 42: [2, 43], 45: [2, 43], 46: [2, 43], 49: [2, 43], 53: [2, 43] }, { 4: 35, 6: 3, 13: [2, 43], 14: [2, 43], 17: [2, 43], 27: [2, 43], 32: [2, 43], 42: [2, 43], 45: [2, 43], 46: [2, 43], 49: [2, 43], 53: [2, 43] }, { 12: 36, 14: [1, 18] }, { 18: 38, 54: 37, 58: 39, 59: [1, 40], 66: [1, 32], 72: 23, 73: 24, 74: [1, 25], 75: [1, 26], 76: [1, 27], 77: [1, 28], 78: [1, 29], 79: [1, 31], 80: 30 }, { 5: [2, 9], 13: [2, 9], 14: [2, 9], 16: [2, 9], 17: [2, 9], 27: [2, 9], 32: [2, 9], 37: [2, 9], 42: [2, 9], 45: [2, 9], 46: [2, 9], 49: [2, 9], 53: [2, 9] }, { 18: 41, 66: [1, 32], 72: 23, 73: 24, 74: [1, 25], 75: [1, 26], 76: [1, 27], 77: [1, 28], 78: [1, 29], 79: [1, 31], 80: 30 }, { 18: 42, 66: [1, 32], 72: 23, 73: 24, 74: [1, 25], 75: [1, 26], 76: [1, 27], 77: [1, 28], 78: [1, 29], 79: [1, 31], 80: 30 }, { 18: 43, 66: [1, 32], 72: 23, 73: 24, 74: [1, 25], 75: [1, 26], 76: [1, 27], 77: [1, 28], 78: [1, 29], 79: [1, 31], 80: 30 }, { 31: [2, 73], 47: 44, 59: [2, 73], 66: [2, 73], 74: [2, 73], 75: [2, 73], 76: [2, 73], 77: [2, 73], 78: [2, 73], 79: [2, 73] }, { 21: [2, 30], 31: [2, 30], 52: [2, 30], 59: [2, 30], 62: [2, 30], 66: [2, 30], 69: [2, 30], 74: [2, 30], 75: [2, 30], 76: [2, 30], 77: [2, 30], 78: [2, 30], 79: [2, 30] }, { 21: [2, 31], 31: [2, 31], 52: [2, 31], 59: [2, 31], 62: [2, 31], 66: [2, 31], 69: [2, 31], 74: [2, 31], 75: [2, 31], 76: [2, 31], 77: [2, 31], 78: [2, 31], 79: [2, 31] }, { 21: [2, 32], 31: [2, 32], 52: [2, 32], 59: [2, 32], 62: [2, 32], 66: [2, 32], 69: [2, 32], 74: [2, 32], 75: [2, 32], 76: [2, 32], 77: [2, 32], 78: [2, 32], 79: [2, 32] }, { 21: [2, 33], 31: [2, 33], 52: [2, 33], 59: [2, 33], 62: [2, 33], 66: [2, 33], 69: [2, 33], 74: [2, 33], 75: [2, 33], 76: [2, 33], 77: [2, 33], 78: [2, 33], 79: [2, 33] }, { 21: [2, 34], 31: [2, 34], 52: [2, 34], 59: [2, 34], 62: [2, 34], 66: [2, 34], 69: [2, 34], 74: [2, 34], 75: [2, 34], 76: [2, 34], 77: [2, 34], 78: [2, 34], 79: [2, 34] }, { 21: [2, 35], 31: [2, 35], 52: [2, 35], 59: [2, 35], 62: [2, 35], 66: [2, 35], 69: [2, 35], 74: [2, 35], 75: [2, 35], 76: [2, 35], 77: [2, 35], 78: [2, 35], 79: [2, 35] }, { 21: [2, 36], 31: [2, 36], 52: [2, 36], 59: [2, 36], 62: [2, 36], 66: [2, 36], 69: [2, 36], 74: [2, 36], 75: [2, 36], 76: [2, 36], 77: [2, 36], 78: [2, 36], 79: [2, 36] }, { 21: [2, 40], 31: [2, 40], 52: [2, 40], 59: [2, 40], 62: [2, 40], 66: [2, 40], 69: [2, 40], 74: [2, 40], 75: [2, 40], 76: [2, 40], 77: [2, 40], 78: [2, 40], 79: [2, 40], 81: [1, 45] }, { 66: [1, 32], 80: 46 }, { 21: [2, 42], 31: [2, 42], 52: [2, 42], 59: [2, 42], 62: [2, 42], 66: [2, 42], 69: [2, 42], 74: [2, 42], 75: [2, 42], 76: [2, 42], 77: [2, 42], 78: [2, 42], 79: [2, 42], 81: [2, 42] }, { 50: 47, 52: [2, 77], 59: [2, 77], 66: [2, 77], 74: [2, 77], 75: [2, 77], 76: [2, 77], 77: [2, 77], 78: [2, 77], 79: [2, 77] }, { 23: 48, 36: 50, 37: [1, 52], 41: 51, 42: [1, 53], 43: 49, 45: [2, 49] }, { 26: 54, 41: 55, 42: [1, 53], 45: [2, 51] }, { 16: [1, 56] }, { 31: [2, 81], 55: 57, 59: [2, 81], 66: [2, 81], 74: [2, 81], 75: [2, 81], 76: [2, 81], 77: [2, 81], 78: [2, 81], 79: [2, 81] }, { 31: [2, 37], 59: [2, 37], 66: [2, 37], 74: [2, 37], 75: [2, 37], 76: [2, 37], 77: [2, 37], 78: [2, 37], 79: [2, 37] }, { 31: [2, 38], 59: [2, 38], 66: [2, 38], 74: [2, 38], 75: [2, 38], 76: [2, 38], 77: [2, 38], 78: [2, 38], 79: [2, 38] }, { 18: 58, 66: [1, 32], 72: 23, 73: 24, 74: [1, 25], 75: [1, 26], 76: [1, 27], 77: [1, 28], 78: [1, 29], 79: [1, 31], 80: 30 }, { 28: 59, 31: [2, 53], 59: [2, 53], 66: [2, 53], 69: [2, 53], 74: [2, 53], 75: [2, 53], 76: [2, 53], 77: [2, 53], 78: [2, 53], 79: [2, 53] }, { 31: [2, 59], 33: 60, 59: [2, 59], 66: [2, 59], 69: [2, 59], 74: [2, 59], 75: [2, 59], 76: [2, 59], 77: [2, 59], 78: [2, 59], 79: [2, 59] }, { 19: 61, 21: [2, 45], 59: [2, 45], 66: [2, 45], 74: [2, 45], 75: [2, 45], 76: [2, 45], 77: [2, 45], 78: [2, 45], 79: [2, 45] }, { 18: 65, 31: [2, 75], 48: 62, 57: 63, 58: 66, 59: [1, 40], 63: 64, 64: 67, 65: 68, 66: [1, 69], 72: 23, 73: 24, 74: [1, 25], 75: [1, 26], 76: [1, 27], 77: [1, 28], 78: [1, 29], 79: [1, 31], 80: 30 }, { 66: [1, 70] }, { 21: [2, 39], 31: [2, 39], 52: [2, 39], 59: [2, 39], 62: [2, 39], 66: [2, 39], 69: [2, 39], 74: [2, 39], 75: [2, 39], 76: [2, 39], 77: [2, 39], 78: [2, 39], 79: [2, 39], 81: [1, 45] }, { 18: 65, 51: 71, 52: [2, 79], 57: 72, 58: 66, 59: [1, 40], 63: 73, 64: 67, 65: 68, 66: [1, 69], 72: 23, 73: 24, 74: [1, 25], 75: [1, 26], 76: [1, 27], 77: [1, 28], 78: [1, 29], 79: [1, 31], 80: 30 }, { 24: 74, 45: [1, 75] }, { 45: [2, 50] }, { 4: 76, 6: 3, 13: [2, 43], 14: [2, 43], 17: [2, 43], 27: [2, 43], 32: [2, 43], 37: [2, 43], 42: [2, 43], 45: [2, 43], 46: [2, 43], 49: [2, 43], 53: [2, 43] }, { 45: [2, 19] }, { 18: 77, 66: [1, 32], 72: 23, 73: 24, 74: [1, 25], 75: [1, 26], 76: [1, 27], 77: [1, 28], 78: [1, 29], 79: [1, 31], 80: 30 }, { 4: 78, 6: 3, 13: [2, 43], 14: [2, 43], 17: [2, 43], 27: [2, 43], 32: [2, 43], 45: [2, 43], 46: [2, 43], 49: [2, 43], 53: [2, 43] }, { 24: 79, 45: [1, 75] }, { 45: [2, 52] }, { 5: [2, 10], 13: [2, 10], 14: [2, 10], 17: [2, 10], 27: [2, 10], 32: [2, 10], 37: [2, 10], 42: [2, 10], 45: [2, 10], 46: [2, 10], 49: [2, 10], 53: [2, 10] }, { 18: 65, 31: [2, 83], 56: 80, 57: 81, 58: 66, 59: [1, 40], 63: 82, 64: 67, 65: 68, 66: [1, 69], 72: 23, 73: 24, 74: [1, 25], 75: [1, 26], 76: [1, 27], 77: [1, 28], 78: [1, 29], 79: [1, 31], 80: 30 }, { 59: [2, 85], 60: 83, 62: [2, 85], 66: [2, 85], 74: [2, 85], 75: [2, 85], 76: [2, 85], 77: [2, 85], 78: [2, 85], 79: [2, 85] }, { 18: 65, 29: 84, 31: [2, 55], 57: 85, 58: 66, 59: [1, 40], 63: 86, 64: 67, 65: 68, 66: [1, 69], 69: [2, 55], 72: 23, 73: 24, 74: [1, 25], 75: [1, 26], 76: [1, 27], 77: [1, 28], 78: [1, 29], 79: [1, 31], 80: 30 }, { 18: 65, 31: [2, 61], 34: 87, 57: 88, 58: 66, 59: [1, 40], 63: 89, 64: 67, 65: 68, 66: [1, 69], 69: [2, 61], 72: 23, 73: 24, 74: [1, 25], 75: [1, 26], 76: [1, 27], 77: [1, 28], 78: [1, 29], 79: [1, 31], 80: 30 }, { 18: 65, 20: 90, 21: [2, 47], 57: 91, 58: 66, 59: [1, 40], 63: 92, 64: 67, 65: 68, 66: [1, 69], 72: 23, 73: 24, 74: [1, 25], 75: [1, 26], 76: [1, 27], 77: [1, 28], 78: [1, 29], 79: [1, 31], 80: 30 }, { 31: [1, 93] }, { 31: [2, 74], 59: [2, 74], 66: [2, 74], 74: [2, 74], 75: [2, 74], 76: [2, 74], 77: [2, 74], 78: [2, 74], 79: [2, 74] }, { 31: [2, 76] }, { 21: [2, 24], 31: [2, 24], 52: [2, 24], 59: [2, 24], 62: [2, 24], 66: [2, 24], 69: [2, 24], 74: [2, 24], 75: [2, 24], 76: [2, 24], 77: [2, 24], 78: [2, 24], 79: [2, 24] }, { 21: [2, 25], 31: [2, 25], 52: [2, 25], 59: [2, 25], 62: [2, 25], 66: [2, 25], 69: [2, 25], 74: [2, 25], 75: [2, 25], 76: [2, 25], 77: [2, 25], 78: [2, 25], 79: [2, 25] }, { 21: [2, 27], 31: [2, 27], 52: [2, 27], 62: [2, 27], 65: 94, 66: [1, 95], 69: [2, 27] }, { 21: [2, 89], 31: [2, 89], 52: [2, 89], 62: [2, 89], 66: [2, 89], 69: [2, 89] }, { 21: [2, 42], 31: [2, 42], 52: [2, 42], 59: [2, 42], 62: [2, 42], 66: [2, 42], 67: [1, 96], 69: [2, 42], 74: [2, 42], 75: [2, 42], 76: [2, 42], 77: [2, 42], 78: [2, 42], 79: [2, 42], 81: [2, 42] }, { 21: [2, 41], 31: [2, 41], 52: [2, 41], 59: [2, 41], 62: [2, 41], 66: [2, 41], 69: [2, 41], 74: [2, 41], 75: [2, 41], 76: [2, 41], 77: [2, 41], 78: [2, 41], 79: [2, 41], 81: [2, 41] }, { 52: [1, 97] }, { 52: [2, 78], 59: [2, 78], 66: [2, 78], 74: [2, 78], 75: [2, 78], 76: [2, 78], 77: [2, 78], 78: [2, 78], 79: [2, 78] }, { 52: [2, 80] }, { 5: [2, 12], 13: [2, 12], 14: [2, 12], 17: [2, 12], 27: [2, 12], 32: [2, 12], 37: [2, 12], 42: [2, 12], 45: [2, 12], 46: [2, 12], 49: [2, 12], 53: [2, 12] }, { 18: 98, 66: [1, 32], 72: 23, 73: 24, 74: [1, 25], 75: [1, 26], 76: [1, 27], 77: [1, 28], 78: [1, 29], 79: [1, 31], 80: 30 }, { 36: 50, 37: [1, 52], 41: 51, 42: [1, 53], 43: 100, 44: 99, 45: [2, 71] }, { 31: [2, 65], 38: 101, 59: [2, 65], 66: [2, 65], 69: [2, 65], 74: [2, 65], 75: [2, 65], 76: [2, 65], 77: [2, 65], 78: [2, 65], 79: [2, 65] }, { 45: [2, 17] }, { 5: [2, 13], 13: [2, 13], 14: [2, 13], 17: [2, 13], 27: [2, 13], 32: [2, 13], 37: [2, 13], 42: [2, 13], 45: [2, 13], 46: [2, 13], 49: [2, 13], 53: [2, 13] }, { 31: [1, 102] }, { 31: [2, 82], 59: [2, 82], 66: [2, 82], 74: [2, 82], 75: [2, 82], 76: [2, 82], 77: [2, 82], 78: [2, 82], 79: [2, 82] }, { 31: [2, 84] }, { 18: 65, 57: 104, 58: 66, 59: [1, 40], 61: 103, 62: [2, 87], 63: 105, 64: 67, 65: 68, 66: [1, 69], 72: 23, 73: 24, 74: [1, 25], 75: [1, 26], 76: [1, 27], 77: [1, 28], 78: [1, 29], 79: [1, 31], 80: 30 }, { 30: 106, 31: [2, 57], 68: 107, 69: [1, 108] }, { 31: [2, 54], 59: [2, 54], 66: [2, 54], 69: [2, 54], 74: [2, 54], 75: [2, 54], 76: [2, 54], 77: [2, 54], 78: [2, 54], 79: [2, 54] }, { 31: [2, 56], 69: [2, 56] }, { 31: [2, 63], 35: 109, 68: 110, 69: [1, 108] }, { 31: [2, 60], 59: [2, 60], 66: [2, 60], 69: [2, 60], 74: [2, 60], 75: [2, 60], 76: [2, 60], 77: [2, 60], 78: [2, 60], 79: [2, 60] }, { 31: [2, 62], 69: [2, 62] }, { 21: [1, 111] }, { 21: [2, 46], 59: [2, 46], 66: [2, 46], 74: [2, 46], 75: [2, 46], 76: [2, 46], 77: [2, 46], 78: [2, 46], 79: [2, 46] }, { 21: [2, 48] }, { 5: [2, 21], 13: [2, 21], 14: [2, 21], 17: [2, 21], 27: [2, 21], 32: [2, 21], 37: [2, 21], 42: [2, 21], 45: [2, 21], 46: [2, 21], 49: [2, 21], 53: [2, 21] }, { 21: [2, 90], 31: [2, 90], 52: [2, 90], 62: [2, 90], 66: [2, 90], 69: [2, 90] }, { 67: [1, 96] }, { 18: 65, 57: 112, 58: 66, 59: [1, 40], 66: [1, 32], 72: 23, 73: 24, 74: [1, 25], 75: [1, 26], 76: [1, 27], 77: [1, 28], 78: [1, 29], 79: [1, 31], 80: 30 }, { 5: [2, 22], 13: [2, 22], 14: [2, 22], 17: [2, 22], 27: [2, 22], 32: [2, 22], 37: [2, 22], 42: [2, 22], 45: [2, 22], 46: [2, 22], 49: [2, 22], 53: [2, 22] }, { 31: [1, 113] }, { 45: [2, 18] }, { 45: [2, 72] }, { 18: 65, 31: [2, 67], 39: 114, 57: 115, 58: 66, 59: [1, 40], 63: 116, 64: 67, 65: 68, 66: [1, 69], 69: [2, 67], 72: 23, 73: 24, 74: [1, 25], 75: [1, 26], 76: [1, 27], 77: [1, 28], 78: [1, 29], 79: [1, 31], 80: 30 }, { 5: [2, 23], 13: [2, 23], 14: [2, 23], 17: [2, 23], 27: [2, 23], 32: [2, 23], 37: [2, 23], 42: [2, 23], 45: [2, 23], 46: [2, 23], 49: [2, 23], 53: [2, 23] }, { 62: [1, 117] }, { 59: [2, 86], 62: [2, 86], 66: [2, 86], 74: [2, 86], 75: [2, 86], 76: [2, 86], 77: [2, 86], 78: [2, 86], 79: [2, 86] }, { 62: [2, 88] }, { 31: [1, 118] }, { 31: [2, 58] }, { 66: [1, 120], 70: 119 }, { 31: [1, 121] }, { 31: [2, 64] }, { 14: [2, 11] }, { 21: [2, 28], 31: [2, 28], 52: [2, 28], 62: [2, 28], 66: [2, 28], 69: [2, 28] }, { 5: [2, 20], 13: [2, 20], 14: [2, 20], 17: [2, 20], 27: [2, 20], 32: [2, 20], 37: [2, 20], 42: [2, 20], 45: [2, 20], 46: [2, 20], 49: [2, 20], 53: [2, 20] }, { 31: [2, 69], 40: 122, 68: 123, 69: [1, 108] }, { 31: [2, 66], 59: [2, 66], 66: [2, 66], 69: [2, 66], 74: [2, 66], 75: [2, 66], 76: [2, 66], 77: [2, 66], 78: [2, 66], 79: [2, 66] }, { 31: [2, 68], 69: [2, 68] }, { 21: [2, 26], 31: [2, 26], 52: [2, 26], 59: [2, 26], 62: [2, 26], 66: [2, 26], 69: [2, 26], 74: [2, 26], 75: [2, 26], 76: [2, 26], 77: [2, 26], 78: [2, 26], 79: [2, 26] }, { 13: [2, 14], 14: [2, 14], 17: [2, 14], 27: [2, 14], 32: [2, 14], 37: [2, 14], 42: [2, 14], 45: [2, 14], 46: [2, 14], 49: [2, 14], 53: [2, 14] }, { 66: [1, 125], 71: [1, 124] }, { 66: [2, 91], 71: [2, 91] }, { 13: [2, 15], 14: [2, 15], 17: [2, 15], 27: [2, 15], 32: [2, 15], 42: [2, 15], 45: [2, 15], 46: [2, 15], 49: [2, 15], 53: [2, 15] }, { 31: [1, 126] }, { 31: [2, 70] }, { 31: [2, 29] }, { 66: [2, 92], 71: [2, 92] }, { 13: [2, 16], 14: [2, 16], 17: [2, 16], 27: [2, 16], 32: [2, 16], 37: [2, 16], 42: [2, 16], 45: [2, 16], 46: [2, 16], 49: [2, 16], 53: [2, 16] }],
	        defaultActions: { 4: [2, 1], 49: [2, 50], 51: [2, 19], 55: [2, 52], 64: [2, 76], 73: [2, 80], 78: [2, 17], 82: [2, 84], 92: [2, 48], 99: [2, 18], 100: [2, 72], 105: [2, 88], 107: [2, 58], 110: [2, 64], 111: [2, 11], 123: [2, 70], 124: [2, 29] },
	        parseError: function parseError(str, hash) {
	            throw new Error(str);
	        },
	        parse: function parse(input) {
	            var self = this,
	                stack = [0],
	                vstack = [null],
	                lstack = [],
	                table = this.table,
	                yytext = "",
	                yylineno = 0,
	                yyleng = 0,
	                recovering = 0,
	                TERROR = 2,
	                EOF = 1;
	            this.lexer.setInput(input);
	            this.lexer.yy = this.yy;
	            this.yy.lexer = this.lexer;
	            this.yy.parser = this;
	            if (typeof this.lexer.yylloc == "undefined") this.lexer.yylloc = {};
	            var yyloc = this.lexer.yylloc;
	            lstack.push(yyloc);
	            var ranges = this.lexer.options && this.lexer.options.ranges;
	            if (typeof this.yy.parseError === "function") this.parseError = this.yy.parseError;
	            function popStack(n) {
	                stack.length = stack.length - 2 * n;
	                vstack.length = vstack.length - n;
	                lstack.length = lstack.length - n;
	            }
	            function lex() {
	                var token;
	                token = self.lexer.lex() || 1;
	                if (typeof token !== "number") {
	                    token = self.symbols_[token] || token;
	                }
	                return token;
	            }
	            var symbol,
	                preErrorSymbol,
	                state,
	                action,
	                a,
	                r,
	                yyval = {},
	                p,
	                len,
	                newState,
	                expected;
	            while (true) {
	                state = stack[stack.length - 1];
	                if (this.defaultActions[state]) {
	                    action = this.defaultActions[state];
	                } else {
	                    if (symbol === null || typeof symbol == "undefined") {
	                        symbol = lex();
	                    }
	                    action = table[state] && table[state][symbol];
	                }
	                if (typeof action === "undefined" || !action.length || !action[0]) {
	                    var errStr = "";
	                    if (!recovering) {
	                        expected = [];
	                        for (p in table[state]) if (this.terminals_[p] && p > 2) {
	                            expected.push("'" + this.terminals_[p] + "'");
	                        }
	                        if (this.lexer.showPosition) {
	                            errStr = "Parse error on line " + (yylineno + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
	                        } else {
	                            errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == 1 ? "end of input" : "'" + (this.terminals_[symbol] || symbol) + "'");
	                        }
	                        this.parseError(errStr, { text: this.lexer.match, token: this.terminals_[symbol] || symbol, line: this.lexer.yylineno, loc: yyloc, expected: expected });
	                    }
	                }
	                if (action[0] instanceof Array && action.length > 1) {
	                    throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
	                }
	                switch (action[0]) {
	                    case 1:
	                        stack.push(symbol);
	                        vstack.push(this.lexer.yytext);
	                        lstack.push(this.lexer.yylloc);
	                        stack.push(action[1]);
	                        symbol = null;
	                        if (!preErrorSymbol) {
	                            yyleng = this.lexer.yyleng;
	                            yytext = this.lexer.yytext;
	                            yylineno = this.lexer.yylineno;
	                            yyloc = this.lexer.yylloc;
	                            if (recovering > 0) recovering--;
	                        } else {
	                            symbol = preErrorSymbol;
	                            preErrorSymbol = null;
	                        }
	                        break;
	                    case 2:
	                        len = this.productions_[action[1]][1];
	                        yyval.$ = vstack[vstack.length - len];
	                        yyval._$ = { first_line: lstack[lstack.length - (len || 1)].first_line, last_line: lstack[lstack.length - 1].last_line, first_column: lstack[lstack.length - (len || 1)].first_column, last_column: lstack[lstack.length - 1].last_column };
	                        if (ranges) {
	                            yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
	                        }
	                        r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);
	                        if (typeof r !== "undefined") {
	                            return r;
	                        }
	                        if (len) {
	                            stack = stack.slice(0, -1 * len * 2);
	                            vstack = vstack.slice(0, -1 * len);
	                            lstack = lstack.slice(0, -1 * len);
	                        }
	                        stack.push(this.productions_[action[1]][0]);
	                        vstack.push(yyval.$);
	                        lstack.push(yyval._$);
	                        newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
	                        stack.push(newState);
	                        break;
	                    case 3:
	                        return true;
	                }
	            }
	            return true;
	        }
	    };
	    /* Jison generated lexer */
	    var lexer = (function () {
	        var lexer = { EOF: 1,
	            parseError: function parseError(str, hash) {
	                if (this.yy.parser) {
	                    this.yy.parser.parseError(str, hash);
	                } else {
	                    throw new Error(str);
	                }
	            },
	            setInput: function setInput(input) {
	                this._input = input;
	                this._more = this._less = this.done = false;
	                this.yylineno = this.yyleng = 0;
	                this.yytext = this.matched = this.match = "";
	                this.conditionStack = ["INITIAL"];
	                this.yylloc = { first_line: 1, first_column: 0, last_line: 1, last_column: 0 };
	                if (this.options.ranges) this.yylloc.range = [0, 0];
	                this.offset = 0;
	                return this;
	            },
	            input: function input() {
	                var ch = this._input[0];
	                this.yytext += ch;
	                this.yyleng++;
	                this.offset++;
	                this.match += ch;
	                this.matched += ch;
	                var lines = ch.match(/(?:\r\n?|\n).*/g);
	                if (lines) {
	                    this.yylineno++;
	                    this.yylloc.last_line++;
	                } else {
	                    this.yylloc.last_column++;
	                }
	                if (this.options.ranges) this.yylloc.range[1]++;

	                this._input = this._input.slice(1);
	                return ch;
	            },
	            unput: function unput(ch) {
	                var len = ch.length;
	                var lines = ch.split(/(?:\r\n?|\n)/g);

	                this._input = ch + this._input;
	                this.yytext = this.yytext.substr(0, this.yytext.length - len - 1);
	                //this.yyleng -= len;
	                this.offset -= len;
	                var oldLines = this.match.split(/(?:\r\n?|\n)/g);
	                this.match = this.match.substr(0, this.match.length - 1);
	                this.matched = this.matched.substr(0, this.matched.length - 1);

	                if (lines.length - 1) this.yylineno -= lines.length - 1;
	                var r = this.yylloc.range;

	                this.yylloc = { first_line: this.yylloc.first_line,
	                    last_line: this.yylineno + 1,
	                    first_column: this.yylloc.first_column,
	                    last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
	                };

	                if (this.options.ranges) {
	                    this.yylloc.range = [r[0], r[0] + this.yyleng - len];
	                }
	                return this;
	            },
	            more: function more() {
	                this._more = true;
	                return this;
	            },
	            less: function less(n) {
	                this.unput(this.match.slice(n));
	            },
	            pastInput: function pastInput() {
	                var past = this.matched.substr(0, this.matched.length - this.match.length);
	                return (past.length > 20 ? "..." : "") + past.substr(-20).replace(/\n/g, "");
	            },
	            upcomingInput: function upcomingInput() {
	                var next = this.match;
	                if (next.length < 20) {
	                    next += this._input.substr(0, 20 - next.length);
	                }
	                return (next.substr(0, 20) + (next.length > 20 ? "..." : "")).replace(/\n/g, "");
	            },
	            showPosition: function showPosition() {
	                var pre = this.pastInput();
	                var c = new Array(pre.length + 1).join("-");
	                return pre + this.upcomingInput() + "\n" + c + "^";
	            },
	            next: function next() {
	                if (this.done) {
	                    return this.EOF;
	                }
	                if (!this._input) this.done = true;

	                var token, match, tempMatch, index, col, lines;
	                if (!this._more) {
	                    this.yytext = "";
	                    this.match = "";
	                }
	                var rules = this._currentRules();
	                for (var i = 0; i < rules.length; i++) {
	                    tempMatch = this._input.match(this.rules[rules[i]]);
	                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
	                        match = tempMatch;
	                        index = i;
	                        if (!this.options.flex) break;
	                    }
	                }
	                if (match) {
	                    lines = match[0].match(/(?:\r\n?|\n).*/g);
	                    if (lines) this.yylineno += lines.length;
	                    this.yylloc = { first_line: this.yylloc.last_line,
	                        last_line: this.yylineno + 1,
	                        first_column: this.yylloc.last_column,
	                        last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length };
	                    this.yytext += match[0];
	                    this.match += match[0];
	                    this.matches = match;
	                    this.yyleng = this.yytext.length;
	                    if (this.options.ranges) {
	                        this.yylloc.range = [this.offset, this.offset += this.yyleng];
	                    }
	                    this._more = false;
	                    this._input = this._input.slice(match[0].length);
	                    this.matched += match[0];
	                    token = this.performAction.call(this, this.yy, this, rules[index], this.conditionStack[this.conditionStack.length - 1]);
	                    if (this.done && this._input) this.done = false;
	                    if (token) {
	                        return token;
	                    } else {
	                        return;
	                    }
	                }
	                if (this._input === "") {
	                    return this.EOF;
	                } else {
	                    return this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), { text: "", token: null, line: this.yylineno });
	                }
	            },
	            lex: function lex() {
	                var r = this.next();
	                if (typeof r !== "undefined") {
	                    return r;
	                } else {
	                    return this.lex();
	                }
	            },
	            begin: function begin(condition) {
	                this.conditionStack.push(condition);
	            },
	            popState: function popState() {
	                return this.conditionStack.pop();
	            },
	            _currentRules: function _currentRules() {
	                return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
	            },
	            topState: function topState() {
	                return this.conditionStack[this.conditionStack.length - 2];
	            },
	            pushState: function begin(condition) {
	                this.begin(condition);
	            } };
	        lexer.options = {};
	        lexer.performAction = function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {

	            function strip(start, end) {
	                return yy_.yytext = yy_.yytext.substr(start, yy_.yyleng - end);
	            }

	            var YYSTATE = YY_START;
	            switch ($avoiding_name_collisions) {
	                case 0:
	                    if (yy_.yytext.slice(-2) === "\\\\") {
	                        strip(0, 1);
	                        this.begin("mu");
	                    } else if (yy_.yytext.slice(-1) === "\\") {
	                        strip(0, 1);
	                        this.begin("emu");
	                    } else {
	                        this.begin("mu");
	                    }
	                    if (yy_.yytext) {
	                        return 14;
	                    }break;
	                case 1:
	                    return 14;
	                    break;
	                case 2:
	                    this.popState();
	                    return 14;

	                    break;
	                case 3:
	                    yy_.yytext = yy_.yytext.substr(5, yy_.yyleng - 9);
	                    this.popState();
	                    return 16;

	                    break;
	                case 4:
	                    return 14;
	                    break;
	                case 5:
	                    this.popState();
	                    return 13;

	                    break;
	                case 6:
	                    return 59;
	                    break;
	                case 7:
	                    return 62;
	                    break;
	                case 8:
	                    return 17;
	                    break;
	                case 9:
	                    this.popState();
	                    this.begin("raw");
	                    return 21;

	                    break;
	                case 10:
	                    return 53;
	                    break;
	                case 11:
	                    return 27;
	                    break;
	                case 12:
	                    return 45;
	                    break;
	                case 13:
	                    this.popState();return 42;
	                    break;
	                case 14:
	                    this.popState();return 42;
	                    break;
	                case 15:
	                    return 32;
	                    break;
	                case 16:
	                    return 37;
	                    break;
	                case 17:
	                    return 49;
	                    break;
	                case 18:
	                    return 46;
	                    break;
	                case 19:
	                    this.unput(yy_.yytext);
	                    this.popState();
	                    this.begin("com");

	                    break;
	                case 20:
	                    this.popState();
	                    return 13;

	                    break;
	                case 21:
	                    return 46;
	                    break;
	                case 22:
	                    return 67;
	                    break;
	                case 23:
	                    return 66;
	                    break;
	                case 24:
	                    return 66;
	                    break;
	                case 25:
	                    return 81;
	                    break;
	                case 26:
	                    // ignore whitespace
	                    break;
	                case 27:
	                    this.popState();return 52;
	                    break;
	                case 28:
	                    this.popState();return 31;
	                    break;
	                case 29:
	                    yy_.yytext = strip(1, 2).replace(/\\"/g, "\"");return 74;
	                    break;
	                case 30:
	                    yy_.yytext = strip(1, 2).replace(/\\'/g, "'");return 74;
	                    break;
	                case 31:
	                    return 79;
	                    break;
	                case 32:
	                    return 76;
	                    break;
	                case 33:
	                    return 76;
	                    break;
	                case 34:
	                    return 77;
	                    break;
	                case 35:
	                    return 78;
	                    break;
	                case 36:
	                    return 75;
	                    break;
	                case 37:
	                    return 69;
	                    break;
	                case 38:
	                    return 71;
	                    break;
	                case 39:
	                    return 66;
	                    break;
	                case 40:
	                    return 66;
	                    break;
	                case 41:
	                    return "INVALID";
	                    break;
	                case 42:
	                    return 5;
	                    break;
	            }
	        };
	        lexer.rules = [/^(?:[^\x00]*?(?=(\{\{)))/, /^(?:[^\x00]+)/, /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/, /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/, /^(?:[^\x00]*?(?=(\{\{\{\{\/)))/, /^(?:[\s\S]*?--(~)?\}\})/, /^(?:\()/, /^(?:\))/, /^(?:\{\{\{\{)/, /^(?:\}\}\}\})/, /^(?:\{\{(~)?>)/, /^(?:\{\{(~)?#)/, /^(?:\{\{(~)?\/)/, /^(?:\{\{(~)?\^\s*(~)?\}\})/, /^(?:\{\{(~)?\s*else\s*(~)?\}\})/, /^(?:\{\{(~)?\^)/, /^(?:\{\{(~)?\s*else\b)/, /^(?:\{\{(~)?\{)/, /^(?:\{\{(~)?&)/, /^(?:\{\{(~)?!--)/, /^(?:\{\{(~)?![\s\S]*?\}\})/, /^(?:\{\{(~)?)/, /^(?:=)/, /^(?:\.\.)/, /^(?:\.(?=([=~}\s\/.)|])))/, /^(?:[\/.])/, /^(?:\s+)/, /^(?:\}(~)?\}\})/, /^(?:(~)?\}\})/, /^(?:"(\\["]|[^"])*")/, /^(?:'(\\[']|[^'])*')/, /^(?:@)/, /^(?:true(?=([~}\s)])))/, /^(?:false(?=([~}\s)])))/, /^(?:undefined(?=([~}\s)])))/, /^(?:null(?=([~}\s)])))/, /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/, /^(?:as\s+\|)/, /^(?:\|)/, /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/, /^(?:\[[^\]]*\])/, /^(?:.)/, /^(?:$)/];
	        lexer.conditions = { mu: { rules: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42], inclusive: false }, emu: { rules: [2], inclusive: false }, com: { rules: [5], inclusive: false }, raw: { rules: [3, 4], inclusive: false }, INITIAL: { rules: [0, 1, 42], inclusive: true } };
	        return lexer;
	    })();
	    parser.lexer = lexer;
	    function Parser() {
	        this.yy = {};
	    }Parser.prototype = parser;parser.Parser = Parser;
	    return new Parser();
	})();exports["default"] = handlebars;
	module.exports = exports["default"];

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(8)['default'];

	exports.__esModule = true;

	var _Visitor = __webpack_require__(6);

	var _Visitor2 = _interopRequireDefault(_Visitor);

	function WhitespaceControl() {}
	WhitespaceControl.prototype = new _Visitor2['default']();

	WhitespaceControl.prototype.Program = function (program) {
	  var isRoot = !this.isRootSeen;
	  this.isRootSeen = true;

	  var body = program.body;
	  for (var i = 0, l = body.length; i < l; i++) {
	    var current = body[i],
	        strip = this.accept(current);

	    if (!strip) {
	      continue;
	    }

	    var _isPrevWhitespace = isPrevWhitespace(body, i, isRoot),
	        _isNextWhitespace = isNextWhitespace(body, i, isRoot),
	        openStandalone = strip.openStandalone && _isPrevWhitespace,
	        closeStandalone = strip.closeStandalone && _isNextWhitespace,
	        inlineStandalone = strip.inlineStandalone && _isPrevWhitespace && _isNextWhitespace;

	    if (strip.close) {
	      omitRight(body, i, true);
	    }
	    if (strip.open) {
	      omitLeft(body, i, true);
	    }

	    if (inlineStandalone) {
	      omitRight(body, i);

	      if (omitLeft(body, i)) {
	        // If we are on a standalone node, save the indent info for partials
	        if (current.type === 'PartialStatement') {
	          // Pull out the whitespace from the final line
	          current.indent = /([ \t]+$)/.exec(body[i - 1].original)[1];
	        }
	      }
	    }
	    if (openStandalone) {
	      omitRight((current.program || current.inverse).body);

	      // Strip out the previous content node if it's whitespace only
	      omitLeft(body, i);
	    }
	    if (closeStandalone) {
	      // Always strip the next node
	      omitRight(body, i);

	      omitLeft((current.inverse || current.program).body);
	    }
	  }

	  return program;
	};
	WhitespaceControl.prototype.BlockStatement = function (block) {
	  this.accept(block.program);
	  this.accept(block.inverse);

	  // Find the inverse program that is involed with whitespace stripping.
	  var program = block.program || block.inverse,
	      inverse = block.program && block.inverse,
	      firstInverse = inverse,
	      lastInverse = inverse;

	  if (inverse && inverse.chained) {
	    firstInverse = inverse.body[0].program;

	    // Walk the inverse chain to find the last inverse that is actually in the chain.
	    while (lastInverse.chained) {
	      lastInverse = lastInverse.body[lastInverse.body.length - 1].program;
	    }
	  }

	  var strip = {
	    open: block.openStrip.open,
	    close: block.closeStrip.close,

	    // Determine the standalone candiacy. Basically flag our content as being possibly standalone
	    // so our parent can determine if we actually are standalone
	    openStandalone: isNextWhitespace(program.body),
	    closeStandalone: isPrevWhitespace((firstInverse || program).body)
	  };

	  if (block.openStrip.close) {
	    omitRight(program.body, null, true);
	  }

	  if (inverse) {
	    var inverseStrip = block.inverseStrip;

	    if (inverseStrip.open) {
	      omitLeft(program.body, null, true);
	    }

	    if (inverseStrip.close) {
	      omitRight(firstInverse.body, null, true);
	    }
	    if (block.closeStrip.open) {
	      omitLeft(lastInverse.body, null, true);
	    }

	    // Find standalone else statments
	    if (isPrevWhitespace(program.body) && isNextWhitespace(firstInverse.body)) {
	      omitLeft(program.body);
	      omitRight(firstInverse.body);
	    }
	  } else if (block.closeStrip.open) {
	    omitLeft(program.body, null, true);
	  }

	  return strip;
	};

	WhitespaceControl.prototype.MustacheStatement = function (mustache) {
	  return mustache.strip;
	};

	WhitespaceControl.prototype.PartialStatement = WhitespaceControl.prototype.CommentStatement = function (node) {
	  /* istanbul ignore next */
	  var strip = node.strip || {};
	  return {
	    inlineStandalone: true,
	    open: strip.open,
	    close: strip.close
	  };
	};

	function isPrevWhitespace(body, i, isRoot) {
	  if (i === undefined) {
	    i = body.length;
	  }

	  // Nodes that end with newlines are considered whitespace (but are special
	  // cased for strip operations)
	  var prev = body[i - 1],
	      sibling = body[i - 2];
	  if (!prev) {
	    return isRoot;
	  }

	  if (prev.type === 'ContentStatement') {
	    return (sibling || !isRoot ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(prev.original);
	  }
	}
	function isNextWhitespace(body, i, isRoot) {
	  if (i === undefined) {
	    i = -1;
	  }

	  var next = body[i + 1],
	      sibling = body[i + 2];
	  if (!next) {
	    return isRoot;
	  }

	  if (next.type === 'ContentStatement') {
	    return (sibling || !isRoot ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(next.original);
	  }
	}

	// Marks the node to the right of the position as omitted.
	// I.e. {{foo}}' ' will mark the ' ' node as omitted.
	//
	// If i is undefined, then the first child will be marked as such.
	//
	// If mulitple is truthy then all whitespace will be stripped out until non-whitespace
	// content is met.
	function omitRight(body, i, multiple) {
	  var current = body[i == null ? 0 : i + 1];
	  if (!current || current.type !== 'ContentStatement' || !multiple && current.rightStripped) {
	    return;
	  }

	  var original = current.value;
	  current.value = current.value.replace(multiple ? /^\s+/ : /^[ \t]*\r?\n?/, '');
	  current.rightStripped = current.value !== original;
	}

	// Marks the node to the left of the position as omitted.
	// I.e. ' '{{foo}} will mark the ' ' node as omitted.
	//
	// If i is undefined then the last child will be marked as such.
	//
	// If mulitple is truthy then all whitespace will be stripped out until non-whitespace
	// content is met.
	function omitLeft(body, i, multiple) {
	  var current = body[i == null ? body.length - 1 : i - 1];
	  if (!current || current.type !== 'ContentStatement' || !multiple && current.leftStripped) {
	    return;
	  }

	  // We omit the last node if it's whitespace only and not preceeded by a non-content node.
	  var original = current.value;
	  current.value = current.value.replace(multiple ? /\s+$/ : /[ \t]+$/, '');
	  current.leftStripped = current.value !== original;
	  return current.leftStripped;
	}

	exports['default'] = WhitespaceControl;
	module.exports = exports['default'];

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(8)['default'];

	exports.__esModule = true;
	exports.SourceLocation = SourceLocation;
	exports.id = id;
	exports.stripFlags = stripFlags;
	exports.stripComment = stripComment;
	exports.preparePath = preparePath;
	exports.prepareMustache = prepareMustache;
	exports.prepareRawBlock = prepareRawBlock;
	exports.prepareBlock = prepareBlock;

	var _Exception = __webpack_require__(12);

	var _Exception2 = _interopRequireDefault(_Exception);

	function SourceLocation(source, locInfo) {
	  this.source = source;
	  this.start = {
	    line: locInfo.first_line,
	    column: locInfo.first_column
	  };
	  this.end = {
	    line: locInfo.last_line,
	    column: locInfo.last_column
	  };
	}

	function id(token) {
	  if (/^\[.*\]$/.test(token)) {
	    return token.substr(1, token.length - 2);
	  } else {
	    return token;
	  }
	}

	function stripFlags(open, close) {
	  return {
	    open: open.charAt(2) === '~',
	    close: close.charAt(close.length - 3) === '~'
	  };
	}

	function stripComment(comment) {
	  return comment.replace(/^\{\{~?\!-?-?/, '').replace(/-?-?~?\}\}$/, '');
	}

	function preparePath(data, parts, locInfo) {
	  locInfo = this.locInfo(locInfo);

	  var original = data ? '@' : '',
	      dig = [],
	      depth = 0,
	      depthString = '';

	  for (var i = 0, l = parts.length; i < l; i++) {
	    var part = parts[i].part,

	    // If we have [] syntax then we do not treat path references as operators,
	    // i.e. foo.[this] resolves to approximately context.foo['this']
	    isLiteral = parts[i].original !== part;
	    original += (parts[i].separator || '') + part;

	    if (!isLiteral && (part === '..' || part === '.' || part === 'this')) {
	      if (dig.length > 0) {
	        throw new _Exception2['default']('Invalid path: ' + original, { loc: locInfo });
	      } else if (part === '..') {
	        depth++;
	        depthString += '../';
	      }
	    } else {
	      dig.push(part);
	    }
	  }

	  return new this.PathExpression(data, depth, dig, original, locInfo);
	}

	function prepareMustache(path, params, hash, open, strip, locInfo) {
	  // Must use charAt to support IE pre-10
	  var escapeFlag = open.charAt(3) || open.charAt(2),
	      escaped = escapeFlag !== '{' && escapeFlag !== '&';

	  return new this.MustacheStatement(path, params, hash, escaped, strip, this.locInfo(locInfo));
	}

	function prepareRawBlock(openRawBlock, content, close, locInfo) {
	  if (openRawBlock.path.original !== close) {
	    var errorNode = { loc: openRawBlock.path.loc };

	    throw new _Exception2['default'](openRawBlock.path.original + ' doesn\'t match ' + close, errorNode);
	  }

	  locInfo = this.locInfo(locInfo);
	  var program = new this.Program([content], null, {}, locInfo);

	  return new this.BlockStatement(openRawBlock.path, openRawBlock.params, openRawBlock.hash, program, undefined, {}, {}, {}, locInfo);
	}

	function prepareBlock(openBlock, program, inverseAndProgram, close, inverted, locInfo) {
	  // When we are chaining inverse calls, we will not have a close path
	  if (close && close.path && openBlock.path.original !== close.path.original) {
	    var errorNode = { loc: openBlock.path.loc };

	    throw new _Exception2['default'](openBlock.path.original + ' doesn\'t match ' + close.path.original, errorNode);
	  }

	  program.blockParams = openBlock.blockParams;

	  var inverse = undefined,
	      inverseStrip = undefined;

	  if (inverseAndProgram) {
	    if (inverseAndProgram.chain) {
	      inverseAndProgram.program.body[0].closeStrip = close.strip;
	    }

	    inverseStrip = inverseAndProgram.strip;
	    inverse = inverseAndProgram.program;
	  }

	  if (inverted) {
	    inverted = inverse;
	    inverse = program;
	    program = inverted;
	  }

	  return new this.BlockStatement(openBlock.path, openBlock.params, openBlock.hash, program, inverse, openBlock.strip, inverseStrip, close && close.strip, this.locInfo(locInfo));
	}

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	/*global define */

	var _isArray = __webpack_require__(13);

	var SourceNode = undefined;

	try {
	  /* istanbul ignore next */
	  if (false) {
	    // We don't support this in AMD environments. For these environments, we asusme that
	    // they are running on the browser and thus have no need for the source-map library.
	    var SourceMap = require('source-map');
	    SourceNode = SourceMap.SourceNode;
	  }
	} catch (err) {}

	/* istanbul ignore if: tested but not covered in istanbul due to dist build  */
	if (!SourceNode) {
	  SourceNode = function (line, column, srcFile, chunks) {
	    this.src = '';
	    if (chunks) {
	      this.add(chunks);
	    }
	  };
	  /* istanbul ignore next */
	  SourceNode.prototype = {
	    add: function add(chunks) {
	      if (_isArray.isArray(chunks)) {
	        chunks = chunks.join('');
	      }
	      this.src += chunks;
	    },
	    prepend: function prepend(chunks) {
	      if (_isArray.isArray(chunks)) {
	        chunks = chunks.join('');
	      }
	      this.src = chunks + this.src;
	    },
	    toStringWithSourceMap: function toStringWithSourceMap() {
	      return { code: this.toString() };
	    },
	    toString: function toString() {
	      return this.src;
	    }
	  };
	}

	function castChunk(chunk, codeGen, loc) {
	  if (_isArray.isArray(chunk)) {
	    var ret = [];

	    for (var i = 0, len = chunk.length; i < len; i++) {
	      ret.push(codeGen.wrap(chunk[i], loc));
	    }
	    return ret;
	  } else if (typeof chunk === 'boolean' || typeof chunk === 'number') {
	    // Handle primitives that the SourceNode will throw up on
	    return chunk + '';
	  }
	  return chunk;
	}

	function CodeGen(srcFile) {
	  this.srcFile = srcFile;
	  this.source = [];
	}

	CodeGen.prototype = {
	  prepend: function prepend(source, loc) {
	    this.source.unshift(this.wrap(source, loc));
	  },
	  push: function push(source, loc) {
	    this.source.push(this.wrap(source, loc));
	  },

	  merge: function merge() {
	    var source = this.empty();
	    this.each(function (line) {
	      source.add(['  ', line, '\n']);
	    });
	    return source;
	  },

	  each: function each(iter) {
	    for (var i = 0, len = this.source.length; i < len; i++) {
	      iter(this.source[i]);
	    }
	  },

	  empty: function empty() {
	    var loc = arguments[0] === undefined ? this.currentLocation || { start: {} } : arguments[0];

	    return new SourceNode(loc.start.line, loc.start.column, this.srcFile);
	  },
	  wrap: function wrap(chunk) {
	    var loc = arguments[1] === undefined ? this.currentLocation || { start: {} } : arguments[1];

	    if (chunk instanceof SourceNode) {
	      return chunk;
	    }

	    chunk = castChunk(chunk, this, loc);

	    return new SourceNode(loc.start.line, loc.start.column, this.srcFile, chunk);
	  },

	  functionCall: function functionCall(fn, type, params) {
	    params = this.generateList(params);
	    return this.wrap([fn, type ? '.' + type + '(' : '(', params, ')']);
	  },

	  quotedString: function quotedString(str) {
	    return '"' + (str + '').replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\u2028/g, '\\u2028') // Per Ecma-262 7.3 + 7.8.4
	    .replace(/\u2029/g, '\\u2029') + '"';
	  },

	  objectLiteral: function objectLiteral(obj) {
	    var pairs = [];

	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        var value = castChunk(obj[key], this);
	        if (value !== 'undefined') {
	          pairs.push([this.quotedString(key), ':', value]);
	        }
	      }
	    }

	    var ret = this.generateList(pairs);
	    ret.prepend('{');
	    ret.add('}');
	    return ret;
	  },

	  generateList: function generateList(entries, loc) {
	    var ret = this.empty(loc);

	    for (var i = 0, len = entries.length; i < len; i++) {
	      if (i) {
	        ret.add(',');
	      }

	      ret.add(castChunk(entries[i], this, loc));
	    }

	    return ret;
	  },

	  generateArray: function generateArray(entries, loc) {
	    var ret = this.generateList(entries, loc);
	    ret.prepend('[');
	    ret.add(']');

	    return ret;
	  }
	};

	exports['default'] = CodeGen;
	module.exports = exports['default'];

	/* NOP */

/***/ }
/******/ ])
});
;
/*
 * $Id: base64.js,v 2.15 2014/04/05 12:58:57 dankogai Exp dankogai $
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 */

(function(global) {
    'use strict';
    // existing version for noConflict()
    var _Base64 = global.Base64;
    var version = "2.1.9";
    // if node.js, we use Buffer
    var buffer;
    if (typeof module !== 'undefined' && module.exports) {
        try {
            buffer = require('buffer').Buffer;
        } catch (err) {}
    }
    // constants
    var b64chars
        = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    var b64tab = function(bin) {
        var t = {};
        for (var i = 0, l = bin.length; i < l; i++) t[bin.charAt(i)] = i;
        return t;
    }(b64chars);
    var fromCharCode = String.fromCharCode;
    // encoder stuff
    var cb_utob = function(c) {
        if (c.length < 2) {
            var cc = c.charCodeAt(0);
            return cc < 0x80 ? c
                : cc < 0x800 ? (fromCharCode(0xc0 | (cc >>> 6))
            + fromCharCode(0x80 | (cc & 0x3f)))
                : (fromCharCode(0xe0 | ((cc >>> 12) & 0x0f))
            + fromCharCode(0x80 | ((cc >>>  6) & 0x3f))
            + fromCharCode(0x80 | ( cc         & 0x3f)));
        } else {
            var cc = 0x10000
                + (c.charCodeAt(0) - 0xD800) * 0x400
                + (c.charCodeAt(1) - 0xDC00);
            return (fromCharCode(0xf0 | ((cc >>> 18) & 0x07))
            + fromCharCode(0x80 | ((cc >>> 12) & 0x3f))
            + fromCharCode(0x80 | ((cc >>>  6) & 0x3f))
            + fromCharCode(0x80 | ( cc         & 0x3f)));
        }
    };
    var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
    var utob = function(u) {
        return u.replace(re_utob, cb_utob);
    };
    var cb_encode = function(ccc) {
        var padlen = [0, 2, 1][ccc.length % 3],
            ord = ccc.charCodeAt(0) << 16
                | ((ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8)
                | ((ccc.length > 2 ? ccc.charCodeAt(2) : 0)),
            chars = [
                b64chars.charAt( ord >>> 18),
                b64chars.charAt((ord >>> 12) & 63),
                padlen >= 2 ? '=' : b64chars.charAt((ord >>> 6) & 63),
                padlen >= 1 ? '=' : b64chars.charAt(ord & 63)
            ];
        return chars.join('');
    };
    var btoa = global.btoa ? function(b) {
        return global.btoa(b);
    } : function(b) {
        return b.replace(/[\s\S]{1,3}/g, cb_encode);
    };
    var _encode = buffer ? function (u) {
            return (u.constructor === buffer.constructor ? u : new buffer(u))
                .toString('base64')
        }
            : function (u) { return btoa(utob(u)) }
        ;
    var encode = function(u, urisafe) {
        return !urisafe
            ? _encode(String(u))
            : _encode(String(u)).replace(/[+\/]/g, function(m0) {
            return m0 == '+' ? '-' : '_';
        }).replace(/=/g, '');
    };
    var encodeURI = function(u) { return encode(u, true) };
    // decoder stuff
    var re_btou = new RegExp([
        '[\xC0-\xDF][\x80-\xBF]',
        '[\xE0-\xEF][\x80-\xBF]{2}',
        '[\xF0-\xF7][\x80-\xBF]{3}'
    ].join('|'), 'g');
    var cb_btou = function(cccc) {
        switch(cccc.length) {
            case 4:
                var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
                        |    ((0x3f & cccc.charCodeAt(1)) << 12)
                        |    ((0x3f & cccc.charCodeAt(2)) <<  6)
                        |     (0x3f & cccc.charCodeAt(3)),
                    offset = cp - 0x10000;
                return (fromCharCode((offset  >>> 10) + 0xD800)
                + fromCharCode((offset & 0x3FF) + 0xDC00));
            case 3:
                return fromCharCode(
                    ((0x0f & cccc.charCodeAt(0)) << 12)
                    | ((0x3f & cccc.charCodeAt(1)) << 6)
                    |  (0x3f & cccc.charCodeAt(2))
                );
            default:
                return  fromCharCode(
                    ((0x1f & cccc.charCodeAt(0)) << 6)
                    |  (0x3f & cccc.charCodeAt(1))
                );
        }
    };
    var btou = function(b) {
        return b.replace(re_btou, cb_btou);
    };
    var cb_decode = function(cccc) {
        var len = cccc.length,
            padlen = len % 4,
            n = (len > 0 ? b64tab[cccc.charAt(0)] << 18 : 0)
                | (len > 1 ? b64tab[cccc.charAt(1)] << 12 : 0)
                | (len > 2 ? b64tab[cccc.charAt(2)] <<  6 : 0)
                | (len > 3 ? b64tab[cccc.charAt(3)]       : 0),
            chars = [
                fromCharCode( n >>> 16),
                fromCharCode((n >>>  8) & 0xff),
                fromCharCode( n         & 0xff)
            ];
        chars.length -= [0, 0, 2, 1][padlen];
        return chars.join('');
    };
    var atob = global.atob ? function(a) {
        return global.atob(a);
    } : function(a){
        return a.replace(/[\s\S]{1,4}/g, cb_decode);
    };
    var _decode = buffer ? function(a) {
        return (a.constructor === buffer.constructor
            ? a : new buffer(a, 'base64')).toString();
    }
        : function(a) { return btou(atob(a)) };
    var decode = function(a){
        return _decode(
            String(a).replace(/[-_]/g, function(m0) { return m0 == '-' ? '+' : '/' })
                .replace(/[^A-Za-z0-9\+\/]/g, '')
        );
    };
    var noConflict = function() {
        var Base64 = global.Base64;
        global.Base64 = _Base64;
        return Base64;
    };
    // export Base64
    global.Base64 = {
        VERSION: version,
        atob: atob,
        btoa: btoa,
        fromBase64: decode,
        toBase64: encode,
        utob: utob,
        encode: encode,
        encodeURI: encodeURI,
        btou: btou,
        decode: decode,
        noConflict: noConflict
    };
    // if ES5 is available, make Base64.extendString() available
    if (typeof Object.defineProperty === 'function') {
        var noEnum = function(v){
            return {value:v,enumerable:false,writable:true,configurable:true};
        };
        global.Base64.extendString = function () {
            Object.defineProperty(
                String.prototype, 'fromBase64', noEnum(function () {
                    return decode(this)
                }));
            Object.defineProperty(
                String.prototype, 'toBase64', noEnum(function (urisafe) {
                    return encode(this, urisafe)
                }));
            Object.defineProperty(
                String.prototype, 'toBase64URI', noEnum(function () {
                    return encode(this, true)
                }));
        };
    }
    // that's it!
    if (global['Meteor']) {
        Base64 = global.Base64; // for normal export in Meteor.js
    }
})(this);
//Erweiterte JSON, die auch spezielle Objekte parst und zu JSON umwandelt:
//Objekte, die sich selbst enthalten
//Objekte, die Funktionen enthalten
var JSONE = {};
JSONE.to = {};
JSONE.to.removeCycle = function(obj,already,lvl,path){
    already = typeof already !== 'undefined' ? already : [];
    lvl = typeof lvl !== 'undefined' ? lvl : 1;
    path = typeof path !== 'undefined' ? path : "PATH#obj";

    if(typeof obj === "object")
    {
        for(var i in already)
        {
            if(already[i].obj===obj && (already[i].lvl<lvl-1||already[i].lvl==0))
            {
                return already[i].loc;
            }
        }

        if(lvl===1)
        {
            already.push({obj:obj,loc:path,lvl:0});
        }
        for(var i in obj)
        {
            already.push({obj:obj[i],loc:path + "." + i,lvl:lvl});
        }
        for(var i in obj)
        {
            obj[i] = JSONE.to.removeCycle(obj[i],already,lvl+1,path + "." + i);
        }
    }
    return obj;
}
JSONE.to.changeFuncs = function(obj)
{
    if(typeof obj === "function")
    {
        return "FUNCTION#" + obj.toString();
    }
    else if(typeof obj === "object")
    {
        var cl = clone(obj);
        for(var i in cl)
        {
            cl[i] = JSONE.to.changeFuncs(cl[i]);
        }
        return cl;
    }
    return obj;
}
JSONE.stringify = function(obj)
{
    if(typeof obj === "object")
    {
        for(var i in JSONE.to)
        {
            obj = JSONE.to[i](obj);
        }
    }
    return JSON.stringify(obj);
}
JSONE.from = {};
JSONE.from.addFuncs = function(obj)
{
    if(typeof obj === "string" && obj.substr(0,9)==="FUNCTION#")
    {
        var ret;
        try
        {
            eval("ret = " + obj.substr(9));
            return ret;
        }
        catch(e)
        {
            return obj;
        }
    }
    else if(typeof obj === "object")
    {
        for(var i in obj)
        {
            obj[i] = JSONE.from.addFuncs(obj[i]);
        }
        return obj;
    }
    return obj;
}
JSONE.from.addCycle = function(obj,paths,already,path)  {
    already = typeof already !== 'undefined' ? already : [];
    paths = typeof paths !== 'undefined' ? paths : [];
    path = typeof path !== 'undefined' ? path : "PATH#obj";

    for(var i in already)
    {
        if(already[i]===obj)
        {
            return obj;
        }
    }
    for(var i in paths)
    {
        if(paths[i].path===obj)
        {
            obj = paths[i].obj;
        }
    }
    for(var i in already)
    {
        if(already[i]===obj)
        {
            return obj;
        }
    }
    paths.push({path:path,obj:obj});
    already.push(obj);

    for(var i in obj)
    {
        obj[i] = JSONE.from.addCycle(obj[i],paths,already,path + "." + i);
    }
    return obj;
}
JSONE.parse = function(txt) {
    var obj = JSON.parse(txt);
    if(typeof obj === "object")
    {
        for(var i in JSONE.from)
        {
            obj = JSONE.from[i](obj);
        }
    }
    return obj;
}

//Funktion, die auch Objekte klont, die sich selbst enthalten
function clone(obj,already)  {
    already = typeof already !== 'undefined' ? already : [];

    if(typeof obj === "object")
    {
        for(var i in already)
        {
            if(already[i].obj === obj)
            {
                return already[i].cl;
            }
        }

        var cl = {};
        already.push({obj:obj,cl:cl});
        for(var i in obj)
        {
            cl[i] = clone(obj[i],already);
        }
        return cl;
    }
    return obj;
}
/*!
 * accounting.js v0.4.2, copyright 2014 Open Exchange Rates, MIT license, http://openexchangerates.github.io/accounting.js
 */
(function(p,z){function q(a){return!!(""===a||a&&a.charCodeAt&&a.substr)}function m(a){return u?u(a):"[object Array]"===v.call(a)}function r(a){return"[object Object]"===v.call(a)}function s(a,b){var d,a=a||{},b=b||{};for(d in b)b.hasOwnProperty(d)&&null==a[d]&&(a[d]=b[d]);return a}function j(a,b,d){var c=[],e,h;if(!a)return c;if(w&&a.map===w)return a.map(b,d);for(e=0,h=a.length;e<h;e++)c[e]=b.call(d,a[e],e,a);return c}function n(a,b){a=Math.round(Math.abs(a));return isNaN(a)?b:a}function x(a){var b=c.settings.currency.format;"function"===typeof a&&(a=a());return q(a)&&a.match("%v")?{pos:a,neg:a.replace("-","").replace("%v","-%v"),zero:a}:!a||!a.pos||!a.pos.match("%v")?!q(b)?b:c.settings.currency.format={pos:b,neg:b.replace("%v","-%v"),zero:b}:a}var c={version:"0.4.1",settings:{currency:{symbol:"$",format:"%s%v",decimal:".",thousand:",",precision:2,grouping:3},number:{precision:0,grouping:3,thousand:",",decimal:"."}}},w=Array.prototype.map,u=Array.isArray,v=Object.prototype.toString,o=c.unformat=c.parse=function(a,b){if(m(a))return j(a,function(a){return o(a,b)});a=a||0;if("number"===typeof a)return a;var b=b||".",c=RegExp("[^0-9-"+b+"]",["g"]),c=parseFloat((""+a).replace(/\((.*)\)/,"-$1").replace(c,"").replace(b,"."));return!isNaN(c)?c:0},y=c.toFixed=function(a,b){var b=n(b,c.settings.number.precision),d=Math.pow(10,b);return(Math.round(c.unformat(a)*d)/d).toFixed(b)},t=c.formatNumber=c.format=function(a,b,d,i){if(m(a))return j(a,function(a){return t(a,b,d,i)});var a=o(a),e=s(r(b)?b:{precision:b,thousand:d,decimal:i},c.settings.number),h=n(e.precision),f=0>a?"-":"",g=parseInt(y(Math.abs(a||0),h),10)+"",l=3<g.length?g.length%3:0;return f+(l?g.substr(0,l)+e.thousand:"")+g.substr(l).replace(/(\d{3})(?=\d)/g,"$1"+e.thousand)+(h?e.decimal+y(Math.abs(a),h).split(".")[1]:"")},A=c.formatMoney=function(a,b,d,i,e,h){if(m(a))return j(a,function(a){return A(a,b,d,i,e,h)});var a=o(a),f=s(r(b)?b:{symbol:b,precision:d,thousand:i,decimal:e,format:h},c.settings.currency),g=x(f.format);return(0<a?g.pos:0>a?g.neg:g.zero).replace("%s",f.symbol).replace("%v",t(Math.abs(a),n(f.precision),f.thousand,f.decimal))};c.formatColumn=function(a,b,d,i,e,h){if(!a)return[];var f=s(r(b)?b:{symbol:b,precision:d,thousand:i,decimal:e,format:h},c.settings.currency),g=x(f.format),l=g.pos.indexOf("%s")<g.pos.indexOf("%v")?!0:!1,k=0,a=j(a,function(a){if(m(a))return c.formatColumn(a,f);a=o(a);a=(0<a?g.pos:0>a?g.neg:g.zero).replace("%s",f.symbol).replace("%v",t(Math.abs(a),n(f.precision),f.thousand,f.decimal));if(a.length>k)k=a.length;return a});return j(a,function(a){return q(a)&&a.length<k?l?a.replace(f.symbol,f.symbol+Array(k-a.length+1).join(" ")):Array(k-a.length+1).join(" ")+a:a})};if(0&&"undefined"!==typeof exports){if("undefined"!==typeof module&&module.exports)exports=module.exports=c;exports.accounting=c}else 0&&"function"===typeof define&&define.amd?define('acocounting',[],function(){return c}):(c.noConflict=function(a){return function(){p.accounting=a;c.noConflict=z;return c}}(p.accounting),p.accounting=c)})(this);
/**
 * @license jCanvas v20.1.2
 * Copyright 2017 Caleb Evans
 * Released under the MIT license
 */
(function (jQuery, global, factory) {
    'use strict';

    if (typeof module === 'object' && typeof module.exports === 'object') {
        module.exports = function (jQuery, w) {
            return factory(jQuery, w);
        };
    } else {
        factory(jQuery, global);
    }

// Pass this if window is not defined yet
}(typeof window !== 'undefined' ? window.jQuery : {}, typeof window !== 'undefined' ? window : this, function ($, window) {
    'use strict';

    var document = window.document,
        Image = window.Image,
        Array = window.Array,
        getComputedStyle = window.getComputedStyle,
        Math = window.Math,
        Number = window.Number,
        parseFloat = window.parseFloat;

// Define local aliases to frequently used properties
    var defaults,
        // Aliases to jQuery methods
        extendObject = $.extend,
        inArray = $.inArray,
        typeOf = function (operand) {
            return Object.prototype.toString.call(operand)
                .slice(8, -1).toLowerCase();
        },
        isFunction = $.isFunction,
        isPlainObject = $.isPlainObject,
        // Math constants and functions
        PI = Math.PI,
        round = Math.round,
        abs = Math.abs,
        sin = Math.sin,
        cos = Math.cos,
        atan2 = Math.atan2,
        // The Array slice() method
        arraySlice = Array.prototype.slice,
        // jQuery's internal event normalization function
        jQueryEventFix = $.event.fix,
        // Object for storing a number of internal property maps
        maps = {},
        // jQuery internal caches
        caches = {
            dataCache: {},
            propCache: {},
            imageCache: {}
        },
        // Base transformations
        baseTransforms = {
            rotate: 0,
            scaleX: 1,
            scaleY: 1,
            translateX: 0,
            translateY: 0,
            // Store all previous masks
            masks: []
        },
        // Object for storing CSS-related properties
        css = {},
        tangibleEvents = [
            'mousedown',
            'mousemove',
            'mouseup',
            'mouseover',
            'mouseout',
            'touchstart',
            'touchmove',
            'touchend'
        ];

// Constructor for creating objects that inherit from jCanvas preferences and defaults
    function jCanvasObject(args) {
        var params = this,
            propName;
        // Copy the given parameters into new object
        for (propName in args) {
            // Do not merge defaults into parameters
            if (Object.prototype.hasOwnProperty.call(args, propName)) {
                params[propName] = args[propName];
            }
        }
        return params;
    }

// jCanvas object in which global settings are other data are stored
    var jCanvas = {
        // Events object for storing jCanvas event initiation functions
        events: {},
        // Object containing all jCanvas event hooks
        eventHooks: {},
        // Settings for enabling future jCanvas features
        future: {}
    };

// jCanvas default property values
    function jCanvasDefaults() {
        extendObject(this, jCanvasDefaults.baseDefaults);
    }
    jCanvasDefaults.baseDefaults = {
        align: 'center',
        arrowAngle: 90,
        arrowRadius: 0,
        autosave: true,
        baseline: 'middle',
        bringToFront: false,
        ccw: false,
        closed: false,
        compositing: 'source-over',
        concavity: 0,
        cornerRadius: 0,
        count: 1,
        cropFromCenter: true,
        crossOrigin: null,
        cursors: null,
        disableEvents: false,
        draggable: false,
        dragGroups: null,
        groups: null,
        data: null,
        dx: null,
        dy: null,
        end: 360,
        eventX: null,
        eventY: null,
        fillStyle: 'transparent',
        fontStyle: 'normal',
        fontSize: '12pt',
        fontFamily: 'sans-serif',
        fromCenter: true,
        height: null,
        imageSmoothing: true,
        inDegrees: true,
        intangible: false,
        index: null,
        letterSpacing: null,
        lineHeight: 1,
        layer: false,
        mask: false,
        maxWidth: null,
        miterLimit: 10,
        name: null,
        opacity: 1,
        r1: null,
        r2: null,
        radius: 0,
        repeat: 'repeat',
        respectAlign: false,
        restrictDragToAxis: null,
        rotate: 0,
        rounded: false,
        scale: 1,
        scaleX: 1,
        scaleY: 1,
        shadowBlur: 0,
        shadowColor: 'transparent',
        shadowStroke: false,
        shadowX: 0,
        shadowY: 0,
        sHeight: null,
        sides: 0,
        source: '',
        spread: 0,
        start: 0,
        strokeCap: 'butt',
        strokeDash: null,
        strokeDashOffset: 0,
        strokeJoin: 'miter',
        strokeStyle: 'transparent',
        strokeWidth: 1,
        sWidth: null,
        sx: null,
        sy: null,
        text: '',
        translate: 0,
        translateX: 0,
        translateY: 0,
        type: null,
        visible: true,
        width: null,
        x: 0,
        y: 0
    };
    defaults = new jCanvasDefaults();
    jCanvasObject.prototype = defaults;

    /* Internal helper methods */

// Determines if the given operand is a string
    function isString(operand) {
        return (typeOf(operand) === 'string');
    }

// Determines if the given operand is numeric
    function isNumeric(operand) {
        return !isNaN(Number(operand)) && !isNaN(parseFloat(operand));
    }

// Get 2D context for the given canvas
    function _getContext(canvas) {
        return (canvas && canvas.getContext ? canvas.getContext('2d') : null);
    }

// Coerce designated number properties from strings to numbers
    function _coerceNumericProps(props) {
        var propName, propType, propValue;
        // Loop through all properties in given property map
        for (propName in props) {
            if (Object.prototype.hasOwnProperty.call(props, propName)) {
                propValue = props[propName];
                propType = typeOf(propValue);
                // If property is non-empty string and value is numeric
                if (propType === 'string' && isNumeric(propValue) && propName !== 'text') {
                    // Convert value to number
                    props[propName] = parseFloat(propValue);
                }
            }
        }
        // Ensure value of text property is always a string
        if (props.text !== undefined) {
            props.text = String(props.text);
        }
    }

// Clone the given transformations object
    function _cloneTransforms(transforms) {
        // Clone the object itself
        transforms = extendObject({}, transforms);
        // Clone the object's masks array
        transforms.masks = transforms.masks.slice(0);
        return transforms;
    }

// Save canvas context and update transformation stack
    function _saveCanvas(ctx, data) {
        var transforms;
        ctx.save();
        transforms = _cloneTransforms(data.transforms);
        data.savedTransforms.push(transforms);
    }

// Restore canvas context update transformation stack
    function _restoreCanvas(ctx, data) {
        if (data.savedTransforms.length === 0) {
            // Reset transformation state if it can't be restored any more
            data.transforms = _cloneTransforms(baseTransforms);
        } else {
            // Restore canvas context
            ctx.restore();
            // Restore current transform state to the last saved state
            data.transforms = data.savedTransforms.pop();
        }
    }

// Set the style with the given name
    function _setStyle(canvas, ctx, params, styleName) {
        if (params[styleName]) {
            if (isFunction(params[styleName])) {
                // Handle functions
                ctx[styleName] = params[styleName].call(canvas, params);
            } else {
                // Handle string values
                ctx[styleName] = params[styleName];
            }
        }
    }

// Set canvas context properties
    function _setGlobalProps(canvas, ctx, params) {
        _setStyle(canvas, ctx, params, 'fillStyle');
        _setStyle(canvas, ctx, params, 'strokeStyle');
        ctx.lineWidth = params.strokeWidth;
        // Optionally round corners for paths
        if (params.rounded) {
            ctx.lineCap = ctx.lineJoin = 'round';
        } else {
            ctx.lineCap = params.strokeCap;
            ctx.lineJoin = params.strokeJoin;
            ctx.miterLimit = params.miterLimit;
        }
        // Reset strokeDash if null
        if (!params.strokeDash) {
            params.strokeDash = [];
        }
        // Dashed lines
        if (ctx.setLineDash) {
            ctx.setLineDash(params.strokeDash);
        }
        ctx.webkitLineDash = params.strokeDash;
        ctx.lineDashOffset = ctx.webkitLineDashOffset = ctx.mozDashOffset = params.strokeDashOffset;
        // Drop shadow
        ctx.shadowOffsetX = params.shadowX;
        ctx.shadowOffsetY = params.shadowY;
        ctx.shadowBlur = params.shadowBlur;
        ctx.shadowColor = params.shadowColor;
        // Opacity and composite operation
        ctx.globalAlpha = params.opacity;
        ctx.globalCompositeOperation = params.compositing;
        // Support cross-browser toggling of image smoothing
        if (params.imageSmoothing) {
            ctx.imageSmoothingEnabled = params.imageSmoothingEnabled;
        }
    }

// Optionally enable masking support for this path
    function _enableMasking(ctx, data, params) {
        if (params.mask) {
            // If jCanvas autosave is enabled
            if (params.autosave) {
                // Automatically save transformation state by default
                _saveCanvas(ctx, data);
            }
            // Clip the current path
            ctx.clip();
            // Keep track of current masks
            data.transforms.masks.push(params._args);
        }
    }

// Restore individual shape transformation
    function _restoreTransform(ctx, params) {
        // If shape has been transformed by jCanvas
        if (params._transformed) {
            // Restore canvas context
            ctx.restore();
        }
    }

// Close current canvas path
    function _closePath(canvas, ctx, params) {
        var data;

        // Optionally close path
        if (params.closed) {
            ctx.closePath();
        }

        if (params.shadowStroke && params.strokeWidth !== 0) {
            // Extend the shadow to include the stroke of a drawing

            // Add a stroke shadow by stroking before filling
            ctx.stroke();
            ctx.fill();
            // Ensure the below stroking does not inherit a shadow
            ctx.shadowColor = 'transparent';
            ctx.shadowBlur = 0;
            // Stroke over fill as usual
            ctx.stroke();

        } else {
            // If shadowStroke is not enabled, stroke & fill as usual

            ctx.fill();
            // Prevent extra shadow created by stroke (but only when fill is present)
            if (params.fillStyle !== 'transparent') {
                ctx.shadowColor = 'transparent';
            }
            if (params.strokeWidth !== 0) {
                // Only stroke if the stroke is not 0
                ctx.stroke();
            }

        }

        // Optionally close path
        if (!params.closed) {
            ctx.closePath();
        }

        // Restore individual shape transformation
        _restoreTransform(ctx, params);

        // Mask shape if chosen
        if (params.mask) {
            // Retrieve canvas data
            data = _getCanvasData(canvas);
            _enableMasking(ctx, data, params);
        }

    }

// Transform (translate, scale, or rotate) shape
    function _transformShape(canvas, ctx, params, width, height) {

        // Get conversion factor for radians
        params._toRad = (params.inDegrees ? (PI / 180) : 1);

        params._transformed = true;
        ctx.save();

        // Optionally measure (x, y) position from top-left corner
        if (!params.fromCenter && !params._centered && width !== undefined) {
            // Always draw from center unless otherwise specified
            if (height === undefined) {
                height = width;
            }
            params.x += width / 2;
            params.y += height / 2;
            params._centered = true;
        }
        // Optionally rotate shape
        if (params.rotate) {
            _rotateCanvas(ctx, params, null);
        }
        // Optionally scale shape
        if (params.scale !== 1 || params.scaleX !== 1 || params.scaleY !== 1) {
            _scaleCanvas(ctx, params, null);
        }
        // Optionally translate shape
        if (params.translate || params.translateX || params.translateY) {
            _translateCanvas(ctx, params, null);
        }

    }

    /* Plugin API */

// Extend jCanvas with a user-defined method
    jCanvas.extend = function extend(plugin) {

        // Create plugin
        if (plugin.name) {
            // Merge properties with defaults
            if (plugin.props) {
                extendObject(defaults, plugin.props);
            }
            // Define plugin method
            $.fn[plugin.name] = function self(args) {
                var $canvases = this, canvas, e, ctx,
                    params;

                for (e = 0; e < $canvases.length; e += 1) {
                    canvas = $canvases[e];
                    ctx = _getContext(canvas);
                    if (ctx) {

                        params = new jCanvasObject(args);
                        _addLayer(canvas, params, args, self);

                        _setGlobalProps(canvas, ctx, params);
                        plugin.fn.call(canvas, ctx, params);

                    }
                }
                return $canvases;
            };
            // Add drawing type to drawing map
            if (plugin.type) {
                maps.drawings[plugin.type] = plugin.name;
            }
        }
        return $.fn[plugin.name];
    };

    /* Layer API */

// Retrieved the stored jCanvas data for a canvas element
    function _getCanvasData(canvas) {
        var dataCache = caches.dataCache, data;
        if (dataCache._canvas === canvas && dataCache._data) {

            // Retrieve canvas data from cache if possible
            data = dataCache._data;

        } else {

            // Retrieve canvas data from jQuery's internal data storage
            data = $.data(canvas, 'jCanvas');
            if (!data) {

                // Create canvas data object if it does not already exist
                data = {
                    // The associated canvas element
                    canvas: canvas,
                    // Layers array
                    layers: [],
                    // Layer maps
                    layer: {
                        names: {},
                        groups: {}
                    },
                    eventHooks: {},
                    // All layers that intersect with the event coordinates (regardless of visibility)
                    intersecting: [],
                    // The topmost layer whose area contains the event coordinates
                    lastIntersected: null,
                    cursor: $(canvas).css('cursor'),
                    // Properties for the current drag event
                    drag: {
                        layer: null,
                        dragging: false
                    },
                    // Data for the current event
                    event: {
                        type: null,
                        x: null,
                        y: null
                    },
                    // Events which already have been bound to the canvas
                    events: {},
                    // The canvas's current transformation state
                    transforms: _cloneTransforms(baseTransforms),
                    savedTransforms: [],
                    // Whether a layer is being animated or not
                    animating: false,
                    // The layer currently being animated
                    animated: null,
                    // The device pixel ratio
                    pixelRatio: 1,
                    // Whether pixel ratio transformations have been applied
                    scaled: false,
                    // Whether the canvas should be redrawn when a layer mousemove
                    // event triggers (either directly, or indirectly via dragging)
                    redrawOnMousemove: false
                };
                // Use jQuery to store canvas data
                $.data(canvas, 'jCanvas', data);

            }
            // Cache canvas data for faster retrieval
            dataCache._canvas = canvas;
            dataCache._data = data;

        }
        return data;
    }

// Initialize all of a layer's associated jCanvas events
    function _addLayerEvents($canvas, data, layer) {
        var eventName;
        // Determine which jCanvas events need to be bound to this layer
        for (eventName in jCanvas.events) {
            if (Object.prototype.hasOwnProperty.call(jCanvas.events, eventName)) {
                // If layer has callback function to complement it
                if (layer[eventName] || (layer.cursors && layer.cursors[eventName])) {
                    // Bind event to layer
                    _addExplicitLayerEvent($canvas, data, layer, eventName);
                }
            }
        }
        if (!data.events.mouseout) {
            $canvas.bind('mouseout.jCanvas', function () {
                // Retrieve the layer whose drag event was canceled
                var layer = data.drag.layer, l;
                // If cursor mouses out of canvas while dragging
                if (layer) {
                    // Cancel drag
                    data.drag = {};
                    _triggerLayerEvent($canvas, data, layer, 'dragcancel');
                }
                // Loop through all layers
                for (l = 0; l < data.layers.length; l += 1) {
                    layer = data.layers[l];
                    // If layer thinks it's still being moused over
                    if (layer._hovered) {
                        // Trigger mouseout on layer
                        $canvas.triggerLayerEvent(data.layers[l], 'mouseout');
                    }
                }
                // Redraw layers
                $canvas.drawLayers();
            });
            // Indicate that an event handler has been bound
            data.events.mouseout = true;
        }
    }

// Initialize the given event on the given layer
    function _addLayerEvent($canvas, data, layer, eventName) {
        // Use touch events if appropriate
        // eventName = _getMouseEventName(eventName);
        // Bind event to layer
        jCanvas.events[eventName]($canvas, data);
        layer._event = true;
    }

// Add a layer event that was explicitly declared in the layer's parameter map,
// excluding events added implicitly (e.g. mousemove event required by draggable
// layers)
    function _addExplicitLayerEvent($canvas, data, layer, eventName) {
        _addLayerEvent($canvas, data, layer, eventName);
        if (eventName === 'mouseover' || eventName === 'mouseout' || eventName === 'mousemove') {
            data.redrawOnMousemove = true;
        }
    }

// Enable drag support for this layer
    function _enableDrag($canvas, data, layer) {
        var dragHelperEvents, eventName, i;
        // Only make layer draggable if necessary
        if (layer.draggable || layer.cursors) {

            // Organize helper events which enable drag support
            dragHelperEvents = ['mousedown', 'mousemove', 'mouseup'];

            // Bind each helper event to the canvas
            for (i = 0; i < dragHelperEvents.length; i += 1) {
                // Use touch events if appropriate
                eventName = dragHelperEvents[i];
                // Bind event
                _addLayerEvent($canvas, data, layer, eventName);
            }
            // Indicate that this layer has events bound to it
            layer._event = true;

        }
    }

// Update a layer property map if property is changed
    function _updateLayerName($canvas, data, layer, props) {
        var nameMap = data.layer.names;

        // If layer name is being added, not changed
        if (!props) {

            props = layer;

        } else {

            // Remove old layer name entry because layer name has changed
            if (props.name !== undefined && isString(layer.name) && layer.name !== props.name) {
                delete nameMap[layer.name];
            }

        }

        // Add new entry to layer name map with new name
        if (isString(props.name)) {
            nameMap[props.name] = layer;
        }
    }

// Create or update the data map for the given layer and group type
    function _updateLayerGroups($canvas, data, layer, props) {
        var groupMap = data.layer.groups,
            group, groupName, g,
            index, l;

        // If group name is not changing
        if (!props) {

            props = layer;

        } else {

            // Remove layer from all of its associated groups
            if (props.groups !== undefined && layer.groups !== null) {
                for (g = 0; g < layer.groups.length; g += 1) {
                    groupName = layer.groups[g];
                    group = groupMap[groupName];
                    if (group) {
                        // Remove layer from its old layer group entry
                        for (l = 0; l < group.length; l += 1) {
                            if (group[l] === layer) {
                                // Keep track of the layer's initial index
                                index = l;
                                // Remove layer once found
                                group.splice(l, 1);
                                break;
                            }
                        }
                        // Remove layer group entry if group is empty
                        if (group.length === 0) {
                            delete groupMap[groupName];
                        }
                    }
                }
            }

        }

        // Add layer to new group if a new group name is given
        if (props.groups !== undefined && props.groups !== null) {

            for (g = 0; g < props.groups.length; g += 1) {

                groupName = props.groups[g];

                group = groupMap[groupName];
                if (!group) {
                    // Create new group entry if it doesn't exist
                    group = groupMap[groupName] = [];
                    group.name = groupName;
                }
                if (index === undefined) {
                    // Add layer to end of group unless otherwise stated
                    index = group.length;
                }
                // Add layer to its new layer group
                group.splice(index, 0, layer);

            }

        }
    }

// Get event hooks object for the first selected canvas
    $.fn.getEventHooks = function getEventHooks() {
        var $canvases = this, canvas, data,
            eventHooks = {};

        if ($canvases.length !== 0) {
            canvas = $canvases[0];
            data = _getCanvasData(canvas);
            eventHooks = data.eventHooks;
        }
        return eventHooks;
    };

// Set event hooks for the selected canvases
    $.fn.setEventHooks = function setEventHooks(eventHooks) {
        var $canvases = this, e,
            data;
        for (e = 0; e < $canvases.length; e += 1) {
            data = _getCanvasData($canvases[e]);
            extendObject(data.eventHooks, eventHooks);
        }
        return $canvases;
    };

// Get jCanvas layers array
    $.fn.getLayers = function getLayers(callback) {
        var $canvases = this, canvas, data,
            layers, layer, l,
            matching = [];

        if ($canvases.length !== 0) {

            canvas = $canvases[0];
            data = _getCanvasData(canvas);
            // Retrieve layers array for this canvas
            layers = data.layers;

            // If a callback function is given
            if (isFunction(callback)) {

                // Filter the layers array using the callback
                for (l = 0; l < layers.length; l += 1) {
                    layer = layers[l];
                    if (callback.call(canvas, layer)) {
                        // Add layer to array of matching layers if test passes
                        matching.push(layer);
                    }
                }

            } else {
                // Otherwise, get all layers

                matching = layers;

            }

        }
        return matching;
    };

// Get a single jCanvas layer object
    $.fn.getLayer = function getLayer(layerId) {
        var $canvases = this, canvas,
            data, layers, layer, l,
            idType;

        if ($canvases.length !== 0) {

            canvas = $canvases[0];
            data = _getCanvasData(canvas);
            layers = data.layers;
            idType = typeOf(layerId);

            if (layerId && layerId.layer) {

                // Return the actual layer object if given
                layer = layerId;

            } else if (idType === 'number') {

                // Retrieve the layer using the given index

                // Allow for negative indices
                if (layerId < 0) {
                    layerId = layers.length + layerId;
                }
                // Get layer with the given index
                layer = layers[layerId];

            } else if (idType === 'regexp') {

                // Get layer with the name that matches the given regex
                for (l = 0; l < layers.length; l += 1) {
                    // Check if layer matches name
                    if (isString(layers[l].name) && layers[l].name.match(layerId)) {
                        layer = layers[l];
                        break;
                    }
                }

            } else {

                // Get layer with the given name
                layer = data.layer.names[layerId];

            }

        }
        return layer;
    };

// Get all layers in the given group
    $.fn.getLayerGroup = function getLayerGroup(groupId) {
        var $canvases = this, canvas, data,
            groups, groupName, group,
            idType = typeOf(groupId);

        if ($canvases.length !== 0) {

            canvas = $canvases[0];

            if (idType === 'array') {

                // Return layer group if given
                group = groupId;

            } else if (idType === 'regexp') {

                // Get canvas data
                data = _getCanvasData(canvas);
                groups = data.layer.groups;
                // Loop through all layers groups for this canvas
                for (groupName in groups) {
                    // Find a group whose name matches the given regex
                    if (groupName.match(groupId)) {
                        group = groups[groupName];
                        // Stop after finding the first matching group
                        break;
                    }
                }

            } else {

                // Find layer group with the given group name
                data = _getCanvasData(canvas);
                group = data.layer.groups[groupId];
            }

        }
        return group;
    };

// Get index of layer in layers array
    $.fn.getLayerIndex = function getLayerIndex(layerId) {
        var $canvases = this,
            layers = $canvases.getLayers(),
            layer = $canvases.getLayer(layerId);

        return inArray(layer, layers);
    };

// Set properties of a layer
    $.fn.setLayer = function setLayer(layerId, props) {
        var $canvases = this, $canvas, e,
            data, layer,
            propName, propValue, propType;

        for (e = 0; e < $canvases.length; e += 1) {
            $canvas = $($canvases[e]);
            data = _getCanvasData($canvases[e]);

            layer = $($canvases[e]).getLayer(layerId);
            if (layer) {

                // Update layer property maps
                _updateLayerName($canvas, data, layer, props);
                _updateLayerGroups($canvas, data, layer, props);

                _coerceNumericProps(props);

                // Merge properties with layer
                for (propName in props) {
                    if (Object.prototype.hasOwnProperty.call(props, propName)) {
                        propValue = props[propName];
                        propType = typeOf(propValue);
                        if (propType === 'object' && isPlainObject(propValue)) {
                            // Clone objects
                            layer[propName] = extendObject({}, propValue);
                            _coerceNumericProps(layer[propName]);
                        } else if (propType === 'array') {
                            // Clone arrays
                            layer[propName] = propValue.slice(0);
                        } else if (propType === 'string') {
                            if (propValue.indexOf('+=') === 0) {
                                // Increment numbers prefixed with +=
                                layer[propName] += parseFloat(propValue.substr(2));
                            } else if (propValue.indexOf('-=') === 0) {
                                // Decrement numbers prefixed with -=
                                layer[propName] -= parseFloat(propValue.substr(2));
                            } else if (!isNaN(propValue) && isNumeric(propValue) && propName !== 'text') {
                                // Convert numeric values as strings to numbers
                                layer[propName] = parseFloat(propValue);
                            } else {
                                // Otherwise, set given string value
                                layer[propName] = propValue;
                            }
                        } else {
                            // Otherwise, set given value
                            layer[propName] = propValue;
                        }
                    }
                }

                // Update layer events
                _addLayerEvents($canvas, data, layer);
                _enableDrag($canvas, data, layer);

                // If layer's properties were changed
                if ($.isEmptyObject(props) === false) {
                    _triggerLayerEvent($canvas, data, layer, 'change', props);
                }

            }
        }
        return $canvases;
    };

// Set properties of all layers (optionally filtered by a callback)
    $.fn.setLayers = function setLayers(props, callback) {
        var $canvases = this, $canvas, e,
            layers, l;
        for (e = 0; e < $canvases.length; e += 1) {
            $canvas = $($canvases[e]);

            layers = $canvas.getLayers(callback);
            // Loop through all layers
            for (l = 0; l < layers.length; l += 1) {
                // Set properties of each layer
                $canvas.setLayer(layers[l], props);
            }
        }
        return $canvases;
    };

// Set properties of all layers in the given group
    $.fn.setLayerGroup = function setLayerGroup(groupId, props) {
        var $canvases = this, $canvas, e,
            group, l;

        for (e = 0; e < $canvases.length; e += 1) {
            // Get layer group
            $canvas = $($canvases[e]);

            group = $canvas.getLayerGroup(groupId);
            // If group exists
            if (group) {

                // Loop through layers in group
                for (l = 0; l < group.length; l += 1) {
                    // Merge given properties with layer
                    $canvas.setLayer(group[l], props);
                }

            }
        }
        return $canvases;
    };

// Move a layer to the given index in the layers array
    $.fn.moveLayer = function moveLayer(layerId, index) {
        var $canvases = this, $canvas, e,
            data, layers, layer;

        for (e = 0; e < $canvases.length; e += 1) {
            $canvas = $($canvases[e]);
            data = _getCanvasData($canvases[e]);

            // Retrieve layers array and desired layer
            layers = data.layers;
            layer = $canvas.getLayer(layerId);
            if (layer) {

                // Ensure layer index is accurate
                layer.index = inArray(layer, layers);

                // Remove layer from its current placement
                layers.splice(layer.index, 1);
                // Add layer in its new placement
                layers.splice(index, 0, layer);

                // Handle negative indices
                if (index < 0) {
                    index = layers.length + index;
                }
                // Update layer's stored index
                layer.index = index;

                _triggerLayerEvent($canvas, data, layer, 'move');

            }
        }
        return $canvases;
    };

// Remove a jCanvas layer
    $.fn.removeLayer = function removeLayer(layerId) {
        var $canvases = this, $canvas, e, data,
            layers, layer;

        for (e = 0; e < $canvases.length; e += 1) {
            $canvas = $($canvases[e]);
            data = _getCanvasData($canvases[e]);

            // Retrieve layers array and desired layer
            layers = $canvas.getLayers();
            layer = $canvas.getLayer(layerId);
            // Remove layer if found
            if (layer) {

                // Ensure layer index is accurate
                layer.index = inArray(layer, layers);
                // Remove layer and allow it to be re-added later
                layers.splice(layer.index, 1);
                delete layer._layer;

                // Update layer name map
                _updateLayerName($canvas, data, layer, {
                    name: null
                });
                // Update layer group map
                _updateLayerGroups($canvas, data, layer, {
                    groups: null
                });

                // Trigger 'remove' event
                _triggerLayerEvent($canvas, data, layer, 'remove');

            }
        }
        return $canvases;
    };

// Remove all layers
    $.fn.removeLayers = function removeLayers(callback) {
        var $canvases = this, $canvas, e,
            data, layers, layer, l;

        for (e = 0; e < $canvases.length; e += 1) {
            $canvas = $($canvases[e]);
            data = _getCanvasData($canvases[e]);
            layers = $canvas.getLayers(callback);
            // Remove all layers individually
            for (l = 0; l < layers.length; l += 1) {
                layer = layers[l];
                $canvas.removeLayer(layer);
                // Ensure no layer is skipped over
                l -= 1;
            }
            // Update layer maps
            data.layer.names = {};
            data.layer.groups = {};
        }
        return $canvases;
    };

// Remove all layers in the group with the given ID
    $.fn.removeLayerGroup = function removeLayerGroup(groupId) {
        var $canvases = this, $canvas, e, group, l;

        if (groupId !== undefined) {
            for (e = 0; e < $canvases.length; e += 1) {
                $canvas = $($canvases[e]);

                group = $canvas.getLayerGroup(groupId);
                // Remove layer group using given group name
                if (group) {

                    // Clone groups array
                    group = group.slice(0);

                    // Loop through layers in group
                    for (l = 0; l < group.length; l += 1) {
                        $canvas.removeLayer(group[l]);
                    }

                }
            }
        }
        return $canvases;
    };

// Add an existing layer to a layer group
    $.fn.addLayerToGroup = function addLayerToGroup(layerId, groupName) {
        var $canvases = this, $canvas, e,
            layer, groups = [groupName];

        for (e = 0; e < $canvases.length; e += 1) {
            $canvas = $($canvases[e]);
            layer = $canvas.getLayer(layerId);

            // If layer is not already in group
            if (layer.groups) {
                // Clone groups list
                groups = layer.groups.slice(0);
                // If layer is not already in group
                if (inArray(groupName, layer.groups) === -1) {
                    // Add layer to group
                    groups.push(groupName);
                }
            }
            // Update layer group maps
            $canvas.setLayer(layer, {
                groups: groups
            });

        }
        return $canvases;
    };

// Remove an existing layer from a layer group
    $.fn.removeLayerFromGroup = function removeLayerFromGroup(layerId, groupName) {
        var $canvases = this, $canvas, e,
            layer, groups = [],
            index;

        for (e = 0; e < $canvases.length; e += 1) {
            $canvas = $($canvases[e]);
            layer = $canvas.getLayer(layerId);

            if (layer.groups) {

                // Find index of layer in group
                index = inArray(groupName, layer.groups);

                // If layer is in group
                if (index !== -1) {

                    // Clone groups list
                    groups = layer.groups.slice(0);

                    // Remove layer from group
                    groups.splice(index, 1);

                    // Update layer group maps
                    $canvas.setLayer(layer, {
                        groups: groups
                    });

                }

            }

        }
        return $canvases;
    };

// Get topmost layer that intersects with event coordinates
    function _getIntersectingLayer(data) {
        var layer, i,
            mask, m;

        // Store the topmost layer
        layer = null;

        // Get the topmost layer whose visible area intersects event coordinates
        for (i = data.intersecting.length - 1; i >= 0; i -= 1) {

            // Get current layer
            layer = data.intersecting[i];

            // If layer has previous masks
            if (layer._masks) {

                // Search previous masks to ensure
                // layer is visible at event coordinates
                for (m = layer._masks.length - 1; m >= 0; m -= 1) {
                    mask = layer._masks[m];
                    // If mask does not intersect event coordinates
                    if (!mask.intersects) {
                        // Indicate that the mask does not
                        // intersect event coordinates
                        layer.intersects = false;
                        // Stop searching previous masks
                        break;
                    }

                }

                // If event coordinates intersect all previous masks
                // and layer is not intangible
                if (layer.intersects && !layer.intangible) {
                    // Stop searching for topmost layer
                    break;
                }

            }

        }
        // If resulting layer is intangible
        if (layer && layer.intangible) {
            // Cursor does not intersect this layer
            layer = null;
        }
        return layer;
    }

// Draw individual layer (internal)
    function _drawLayer($canvas, ctx, layer, nextLayerIndex) {
        if (layer && layer.visible && layer._method) {
            if (nextLayerIndex) {
                layer._next = nextLayerIndex;
            } else {
                layer._next = null;
            }
            // If layer is an object, call its respective method
            if (layer._method) {
                layer._method.call($canvas, layer);
            }
        }
    }

// Handle dragging of the currently-dragged layer
    function _handleLayerDrag($canvas, data, eventType) {
        var layers, layer, l,
            drag, dragGroups,
            group, groupName, g,
            newX, newY;

        drag = data.drag;
        layer = drag.layer;
        dragGroups = (layer && layer.dragGroups) || [];
        layers = data.layers;

        if (eventType === 'mousemove' || eventType === 'touchmove') {
            // Detect when user is currently dragging layer

            if (!drag.dragging) {
                // Detect when user starts dragging layer

                // Signify that a layer on the canvas is being dragged
                drag.dragging = true;
                layer.dragging = true;

                // Optionally bring layer to front when drag starts
                if (layer.bringToFront) {
                    // Remove layer from its original position
                    layers.splice(layer.index, 1);
                    // Bring layer to front
                    // push() returns the new array length
                    layer.index = layers.push(layer);
                }

                // Set drag properties for this layer
                layer._startX = layer.x;
                layer._startY = layer.y;
                layer._endX = layer._eventX;
                layer._endY = layer._eventY;

                // Trigger dragstart event
                _triggerLayerEvent($canvas, data, layer, 'dragstart');

            }

            if (drag.dragging) {

                // Calculate position after drag
                newX = layer._eventX - (layer._endX - layer._startX);
                newY = layer._eventY - (layer._endY - layer._startY);
                if (layer.updateDragX) {
                    newX = layer.updateDragX.call($canvas[0], layer, newX);
                }
                if (layer.updateDragY) {
                    newY = layer.updateDragY.call($canvas[0], layer, newY);
                }
                layer.dx = newX - layer.x;
                layer.dy = newY - layer.y;
                if (layer.restrictDragToAxis !== 'y') {
                    layer.x = newX;
                }
                if (layer.restrictDragToAxis !== 'x') {
                    layer.y = newY;
                }

                // Trigger drag event
                _triggerLayerEvent($canvas, data, layer, 'drag');

                // Move groups with layer on drag
                for (g = 0; g < dragGroups.length; g += 1) {

                    groupName = dragGroups[g];
                    group = data.layer.groups[groupName];
                    if (layer.groups && group) {

                        for (l = 0; l < group.length; l += 1) {
                            if (group[l] !== layer) {
                                if (layer.restrictDragToAxis !== 'y' && group[l].restrictDragToAxis !== 'y') {
                                    group[l].x += layer.dx;
                                }
                                if (layer.restrictDragToAxis !== 'x' && group[l].restrictDragToAxis !== 'x') {
                                    group[l].y += layer.dy;
                                }
                            }
                        }

                    }

                }

            }

        } else if (eventType === 'mouseup' || eventType === 'touchend') {
            // Detect when user stops dragging layer

            if (drag.dragging) {
                layer.dragging = false;
                drag.dragging = false;
                data.redrawOnMousemove = data.originalRedrawOnMousemove;
                // Trigger dragstop event
                _triggerLayerEvent($canvas, data, layer, 'dragstop');
            }

            // Cancel dragging
            data.drag = {};

        }
    }


// List of CSS3 cursors that need to be prefixed
    css.cursors = ['grab', 'grabbing', 'zoom-in', 'zoom-out'];

// Function to detect vendor prefix
// Modified version of David Walsh's implementation
// https://davidwalsh.name/vendor-prefix
    css.prefix = (function () {
        var styles = getComputedStyle(document.documentElement, ''),
            pre = (arraySlice
                    .call(styles)
                    .join('')
                    .match(/-(moz|webkit|ms)-/) || (styles.OLink === '' && ['', 'o'])
            )[1];
        return '-' + pre + '-';
    })();

// Set cursor on canvas
    function _setCursor($canvas, layer, eventType) {
        var cursor;
        if (layer.cursors) {
            // Retrieve cursor from cursors object if it exists
            cursor = layer.cursors[eventType];
        }
        // Prefix any CSS3 cursor
        if ($.inArray(cursor, css.cursors) !== -1) {
            cursor = css.prefix + cursor;
        }
        // If cursor is defined
        if (cursor) {
            // Set canvas cursor
            $canvas.css({
                cursor: cursor
            });
        }
    }

// Reset cursor on canvas
    function _resetCursor($canvas, data) {
        $canvas.css({
            cursor: data.cursor
        });
    }

// Run the given event callback with the given arguments
    function _runEventCallback($canvas, layer, eventType, callbacks, arg) {
        // Prevent callback from firing recursively
        if (callbacks[eventType] && layer._running && !layer._running[eventType]) {
            // Signify the start of callback execution for this event
            layer._running[eventType] = true;
            // Run event callback with the given arguments
            callbacks[eventType].call($canvas[0], layer, arg);
            // Signify the end of callback execution for this event
            layer._running[eventType] = false;
        }
    }

// Determine if the given layer can "legally" fire the given event
    function _layerCanFireEvent(layer, eventType) {
        // If events are disable and if
        // layer is tangible or event is not tangible
        return (!layer.disableEvents &&
        (!layer.intangible || $.inArray(eventType, tangibleEvents) === -1));
    }

// Trigger the given event on the given layer
    function _triggerLayerEvent($canvas, data, layer, eventType, arg) {
        // If layer can legally fire this event type
        if (_layerCanFireEvent(layer, eventType)) {

            // Do not set a custom cursor on layer mouseout
            if (eventType !== 'mouseout') {
                // Update cursor if one is defined for this event
                _setCursor($canvas, layer, eventType);
            }

            // Trigger the user-defined event callback
            _runEventCallback($canvas, layer, eventType, layer, arg);
            // Trigger the canvas-bound event hook
            _runEventCallback($canvas, layer, eventType, data.eventHooks, arg);
            // Trigger the global event hook
            _runEventCallback($canvas, layer, eventType, jCanvas.eventHooks, arg);

        }
    }

// Manually trigger a layer event
    $.fn.triggerLayerEvent = function (layer, eventType) {
        var $canvases = this, $canvas, e,
            data;

        for (e = 0; e < $canvases.length; e += 1) {
            $canvas = $($canvases[e]);
            data = _getCanvasData($canvases[e]);
            layer = $canvas.getLayer(layer);
            if (layer) {
                _triggerLayerEvent($canvas, data, layer, eventType);
            }
        }
        return $canvases;
    };

// Draw layer with the given ID
    $.fn.drawLayer = function drawLayer(layerId) {
        var $canvases = this, e, ctx,
            $canvas, layer;

        for (e = 0; e < $canvases.length; e += 1) {
            $canvas = $($canvases[e]);
            ctx = _getContext($canvases[e]);
            if (ctx) {
                layer = $canvas.getLayer(layerId);
                _drawLayer($canvas, ctx, layer);
            }
        }
        return $canvases;
    };

// Draw all layers (or, if given, only layers starting at an index)
    $.fn.drawLayers = function drawLayers(args) {
        var $canvases = this, $canvas, e, ctx,
            // Internal parameters for redrawing the canvas
            params = args || {},
            // Other variables
            layers, layer, lastLayer, l, index, lastIndex,
            data, eventCache, eventType, isImageLayer;

        // The layer index from which to start redrawing the canvas
        index = params.index;
        if (!index) {
            index = 0;
        }

        for (e = 0; e < $canvases.length; e += 1) {
            $canvas = $($canvases[e]);
            ctx = _getContext($canvases[e]);
            if (ctx) {

                data = _getCanvasData($canvases[e]);

                // Clear canvas first unless otherwise directed
                if (params.clear !== false) {
                    $canvas.clearCanvas();
                }

                // Cache the layers array
                layers = data.layers;

                // Draw layers from first to last (bottom to top)
                for (l = index; l < layers.length; l += 1) {
                    layer = layers[l];

                    // Ensure layer index is up-to-date
                    layer.index = l;

                    // Prevent any one event from firing excessively
                    if (params.resetFire) {
                        layer._fired = false;
                    }
                    // Draw layer
                    _drawLayer($canvas, ctx, layer, l + 1);
                    // Store list of previous masks for each layer
                    layer._masks = data.transforms.masks.slice(0);

                    // Allow image layers to load before drawing successive layers
                    if (layer._method === $.fn.drawImage && layer.visible) {
                        isImageLayer = true;
                        break;
                    }

                }

                // If layer is an image layer
                if (isImageLayer) {
                    // Stop and wait for drawImage() to resume drawLayers()
                    break;
                }

                // Store the latest
                lastIndex = l;

                // Get first layer that intersects with event coordinates
                layer = _getIntersectingLayer(data);

                eventCache = data.event;
                eventType = eventCache.type;

                // If jCanvas has detected a dragstart
                if (data.drag.layer) {
                    // Handle dragging of layer
                    _handleLayerDrag($canvas, data, eventType);
                }

                // Manage mouseout event
                lastLayer = data.lastIntersected;
                if (lastLayer !== null && layer !== lastLayer && lastLayer._hovered && !lastLayer._fired && !data.drag.dragging) {

                    data.lastIntersected = null;
                    lastLayer._fired = true;
                    lastLayer._hovered = false;
                    _triggerLayerEvent($canvas, data, lastLayer, 'mouseout');
                    _resetCursor($canvas, data);

                }

                if (layer) {

                    // Use mouse event callbacks if no touch event callbacks are given
                    if (!layer[eventType]) {
                        eventType = _getMouseEventName(eventType);
                    }

                    // Check events for intersecting layer
                    if (layer._event && layer.intersects) {

                        data.lastIntersected = layer;

                        // Detect mouseover events
                        if ((layer.mouseover || layer.mouseout || layer.cursors) && !data.drag.dragging) {

                            if (!layer._hovered && !layer._fired) {

                                // Prevent events from firing excessively
                                layer._fired = true;
                                layer._hovered = true;
                                _triggerLayerEvent($canvas, data, layer, 'mouseover');

                            }

                        }

                        // Detect any other mouse event
                        if (!layer._fired) {

                            // Prevent event from firing twice unintentionally
                            layer._fired = true;
                            eventCache.type = null;

                            _triggerLayerEvent($canvas, data, layer, eventType);

                        }

                        // Use the mousedown event to start drag
                        if (layer.draggable && !layer.disableEvents && (eventType === 'mousedown' || eventType === 'touchstart')) {

                            // Keep track of drag state
                            data.drag.layer = layer;
                            data.originalRedrawOnMousemove = data.redrawOnMousemove;
                            data.redrawOnMousemove = true;

                        }

                    }

                }

                // If cursor is not intersecting with any layer
                if (layer === null && !data.drag.dragging) {
                    // Reset cursor to previous state
                    _resetCursor($canvas, data);
                }

                // If the last layer has been drawn
                if (lastIndex === layers.length) {

                    // Reset list of intersecting layers
                    data.intersecting.length = 0;
                    // Reset transformation stack
                    data.transforms = _cloneTransforms(baseTransforms);
                    data.savedTransforms.length = 0;

                }

            }
        }
        return $canvases;
    };

// Add a jCanvas layer (internal)
    function _addLayer(canvas, params, args, method) {
        var $canvas, data,
            layers, layer = (params._layer ? args : params);

        // Store arguments object for later use
        params._args = args;

        // Convert all draggable drawings into jCanvas layers
        if (params.draggable || params.dragGroups) {
            params.layer = true;
            params.draggable = true;
        }

        // Determine the layer's type using the available information
        if (!params._method) {
            if (method) {
                params._method = method;
            } else if (params.method) {
                params._method = $.fn[params.method];
            } else if (params.type) {
                params._method = $.fn[maps.drawings[params.type]];
            }
        }

        // If layer hasn't been added yet
        if (params.layer && !params._layer) {
            // Add layer to canvas

            $canvas = $(canvas);

            data = _getCanvasData(canvas);
            layers = data.layers;

            // Do not add duplicate layers of same name
            if (layer.name === null || (isString(layer.name) && data.layer.names[layer.name] === undefined)) {

                // Convert number properties to numbers
                _coerceNumericProps(params);

                // Ensure layers are unique across canvases by cloning them
                layer = new jCanvasObject(params);
                layer.canvas = canvas;
                // Indicate that this is a layer for future checks
                layer.layer = true;
                layer._layer = true;
                layer._running = {};
                // If layer stores user-defined data
                if (layer.data !== null) {
                    // Clone object
                    layer.data = extendObject({}, layer.data);
                } else {
                    // Otherwise, create data object
                    layer.data = {};
                }
                // If layer stores a list of associated groups
                if (layer.groups !== null) {
                    // Clone list
                    layer.groups = layer.groups.slice(0);
                } else {
                    // Otherwise, create empty list
                    layer.groups = [];
                }

                // Update layer group maps
                _updateLayerName($canvas, data, layer);
                _updateLayerGroups($canvas, data, layer);

                // Check for any associated jCanvas events and enable them
                _addLayerEvents($canvas, data, layer);

                // Optionally enable drag-and-drop support and cursor support
                _enableDrag($canvas, data, layer);

                // Copy _event property to parameters object
                params._event = layer._event;

                // Calculate width/height for text layers
                if (layer._method === $.fn.drawText) {
                    $canvas.measureText(layer);
                }

                // Add layer to end of array if no index is specified
                if (layer.index === null) {
                    layer.index = layers.length;
                }

                // Add layer to layers array at specified index
                layers.splice(layer.index, 0, layer);

                // Store layer on parameters object
                params._args = layer;

                // Trigger an 'add' event
                _triggerLayerEvent($canvas, data, layer, 'add');

            }

        } else if (!params.layer) {
            _coerceNumericProps(params);
        }

        return layer;
    }

// Add a jCanvas layer
    $.fn.addLayer = function addLayer(args) {
        var $canvases = this, e, ctx,
            params;

        for (e = 0; e < $canvases.length; e += 1) {
            ctx = _getContext($canvases[e]);
            if (ctx) {

                params = new jCanvasObject(args);
                params.layer = true;
                _addLayer($canvases[e], params, args);

            }
        }
        return $canvases;
    };

    /* Animation API */

// Define properties used in both CSS and jCanvas
    css.props = [
        'width',
        'height',
        'opacity',
        'lineHeight'
    ];
    css.propsObj = {};

// Hide/show jCanvas/CSS properties so they can be animated using jQuery
    function _showProps(obj) {
        var cssProp, p;
        for (p = 0; p < css.props.length; p += 1) {
            cssProp = css.props[p];
            obj[cssProp] = obj['_' + cssProp];
        }
    }
    function _hideProps(obj, reset) {
        var cssProp, p;
        for (p = 0; p < css.props.length; p += 1) {
            cssProp = css.props[p];
            // Hide property using same name with leading underscore
            if (obj[cssProp] !== undefined) {
                obj['_' + cssProp] = obj[cssProp];
                css.propsObj[cssProp] = true;
                if (reset) {
                    delete obj[cssProp];
                }
            }
        }
    }

// Evaluate property values that are functions
    function _parseEndValues(canvas, layer, endValues) {
        var propName, propValue,
            subPropName, subPropValue;
        // Loop through all properties in map of end values
        for (propName in endValues) {
            if (Object.prototype.hasOwnProperty.call(endValues, propName)) {
                propValue = endValues[propName];
                // If end value is function
                if (isFunction(propValue)) {
                    // Call function and use its value as the end value
                    endValues[propName] = propValue.call(canvas, layer, propName);
                }
                // If end value is an object
                if (typeOf(propValue) === 'object' && isPlainObject(propValue)) {
                    // Prepare to animate properties in object
                    for (subPropName in propValue) {
                        if (Object.prototype.hasOwnProperty.call(propValue, subPropName)) {
                            subPropValue = propValue[subPropName];
                            // Store property's start value at top-level of layer
                            if (layer[propName] !== undefined) {
                                layer[propName + '.' + subPropName] = layer[propName][subPropName];
                                // Store property's end value at top-level of end values map
                                endValues[propName + '.' + subPropName] = subPropValue;
                            }
                        }
                    }
                    // Delete sub-property of object as it's no longer needed
                    delete endValues[propName];
                }
            }
        }
        return endValues;
    }

// Remove sub-property aliases from layer object
    function _removeSubPropAliases(layer) {
        var propName;
        for (propName in layer) {
            if (Object.prototype.hasOwnProperty.call(layer, propName)) {
                if (propName.indexOf('.') !== -1) {
                    delete layer[propName];
                }
            }
        }
    }

// Convert a color value to an array of RGB values
    function _colorToRgbArray(color) {
        var originalColor, elem,
            rgb = [],
            multiple = 1;
        /*******************************************************
         * Justselling FIX
         * ****************************************************/
        if(color._rgba) {
            color = 'rgba(' + color._rgba.join(',') + ')';
        }
        /*******************************************************
         * Justselling FIX END
         * ****************************************************/
        // Deal with complete transparency
        if (color === 'transparent') {
            color = 'rgba(0, 0, 0, 0)';
        } else if (color.match(/^([a-z]+|#[0-9a-f]+)$/gi)) {
            // Deal with hexadecimal colors and color names
            elem = document.head;
            originalColor = elem.style.color;
            elem.style.color = color;
            color = $.css(elem, 'color');
            elem.style.color = originalColor;
        }
        // Parse RGB string
        if (color.match(/^rgb/gi)) {
            rgb = color.match(/(\d+(\.\d+)?)/gi);
            // Deal with RGB percentages
            if (color.match(/%/gi)) {
                multiple = 2.55;
            }
            rgb[0] *= multiple;
            rgb[1] *= multiple;
            rgb[2] *= multiple;
            // Ad alpha channel if given
            if (rgb[3] !== undefined) {
                rgb[3] = parseFloat(rgb[3]);
            } else {
                rgb[3] = 1;
            }
        }
        return rgb;
    }

// Animate a hex or RGB color
    function _animateColor(fx) {
        var n = 3,
            i;
        // Only parse start and end colors once
        if (typeOf(fx.start) !== 'array') {
            fx.start = _colorToRgbArray(fx.start);
            fx.end = _colorToRgbArray(fx.end);
        }
        fx.now = [];

        // If colors are RGBA, animate transparency
        if (fx.start[3] !== 1 || fx.end[3] !== 1) {
            n = 4;
        }

        // Calculate current frame for red, green, blue, and alpha
        for (i = 0; i < n; i += 1) {
            fx.now[i] = fx.start[i] + ((fx.end[i] - fx.start[i]) * fx.pos);
            // Only the red, green, and blue values must be integers
            if (i < 3) {
                fx.now[i] = round(fx.now[i]);
            }
        }
        if (fx.start[3] !== 1 || fx.end[3] !== 1) {
            // Only use RGBA if RGBA colors are given
            fx.now = 'rgba(' + fx.now.join(',') + ')';
        } else {
            // Otherwise, animate as solid colors
            fx.now.slice(0, 3);
            fx.now = 'rgb(' + fx.now.join(',') + ')';
        }
        // Animate colors for both canvas layers and DOM elements
        if (fx.elem.nodeName) {
            fx.elem.style[fx.prop] = fx.now;
        } else {
            fx.elem[fx.prop] = fx.now;
        }
    }

// Animate jCanvas layer
    $.fn.animateLayer = function animateLayer() {
        var $canvases = this, $canvas, e, ctx,
            args = arraySlice.call(arguments, 0),
            data, layer, props;

        // Deal with all cases of argument placement
        /*
         0. layer name/index
         1. properties
         2. duration/options
         3. easing
         4. complete function
         5. step function
         */

        if (typeOf(args[2]) === 'object') {

            // Accept an options object for animation
            args.splice(2, 0, args[2].duration || null);
            args.splice(3, 0, args[3].easing || null);
            args.splice(4, 0, args[4].complete || null);
            args.splice(5, 0, args[5].step || null);

        } else {

            if (args[2] === undefined) {
                // If object is the last argument
                args.splice(2, 0, null);
                args.splice(3, 0, null);
                args.splice(4, 0, null);
            } else if (isFunction(args[2])) {
                // If callback comes after object
                args.splice(2, 0, null);
                args.splice(3, 0, null);
            }
            if (args[3] === undefined) {
                // If duration is the last argument
                args[3] = null;
                args.splice(4, 0, null);
            } else if (isFunction(args[3])) {
                // If callback comes after duration
                args.splice(3, 0, null);
            }

        }

        // Run callback function when animation completes
        function complete($canvas, data, layer) {

            return function () {

                _showProps(layer);
                _removeSubPropAliases(layer);

                // Prevent multiple redraw loops
                if (!data.animating || data.animated === layer) {
                    // Redraw layers on last frame
                    $canvas.drawLayers();
                }

                // Signify the end of an animation loop
                layer._animating = false;
                data.animating = false;
                data.animated = null;

                // If callback is defined
                if (args[4]) {
                    // Run callback at the end of the animation
                    args[4].call($canvas[0], layer);
                }

                _triggerLayerEvent($canvas, data, layer, 'animateend');

            };

        }

        // Redraw layers on every frame of the animation
        function step($canvas, data, layer) {

            return function (now, fx) {
                var parts, propName, subPropName,
                    hidden = false;

                // If animated property has been hidden
                if (fx.prop[0] === '_') {
                    hidden = true;
                    // Unhide property temporarily
                    fx.prop = fx.prop.replace('_', '');
                    layer[fx.prop] = layer['_' + fx.prop];
                }

                // If animating property of sub-object
                if (fx.prop.indexOf('.') !== -1) {
                    parts = fx.prop.split('.');
                    propName = parts[0];
                    subPropName = parts[1];
                    if (layer[propName]) {
                        layer[propName][subPropName] = fx.now;
                    }
                }

                // Throttle animation to improve efficiency
                if (layer._pos !== fx.pos) {

                    layer._pos = fx.pos;

                    // Signify the start of an animation loop
                    if (!layer._animating && !data.animating) {
                        layer._animating = true;
                        data.animating = true;
                        data.animated = layer;
                    }

                    // Prevent multiple redraw loops
                    if (!data.animating || data.animated === layer) {
                        // Redraw layers for every frame
                        $canvas.drawLayers();
                    }

                }

                // If callback is defined
                if (args[5]) {
                    // Run callback for each step of animation
                    args[5].call($canvas[0], now, fx, layer);
                }

                _triggerLayerEvent($canvas, data, layer, 'animate', fx);

                // If property should be hidden during animation
                if (hidden) {
                    // Hide property again
                    fx.prop = '_' + fx.prop;
                }

            };

        }

        for (e = 0; e < $canvases.length; e += 1) {
            $canvas = $($canvases[e]);
            ctx = _getContext($canvases[e]);
            if (ctx) {

                data = _getCanvasData($canvases[e]);

                // If a layer object was passed, use it the layer to be animated
                layer = $canvas.getLayer(args[0]);

                // Ignore layers that are functions
                if (layer && layer._method !== $.fn.draw) {

                    // Do not modify original object
                    props = extendObject({}, args[1]);

                    props = _parseEndValues($canvases[e], layer, props);

                    // Bypass jQuery CSS Hooks for CSS properties (width, opacity, etc.)
                    _hideProps(props, true);
                    _hideProps(layer);

                    // Fix for jQuery's vendor prefixing support, which affects how width/height/opacity are animated
                    layer.style = css.propsObj;

                    // Animate layer
                    $(layer).animate(props, {
                        duration: args[2],
                        easing: ($.easing[args[3]] ? args[3] : null),
                        // When animation completes
                        complete: complete($canvas, data, layer),
                        // Redraw canvas for every animation frame
                        step: step($canvas, data, layer)
                    });
                    _triggerLayerEvent($canvas, data, layer, 'animatestart');
                }

            }
        }
        return $canvases;
    };

// Animate all layers in a layer group
    $.fn.animateLayerGroup = function animateLayerGroup(groupId) {
        var $canvases = this, $canvas, e,
            args = arraySlice.call(arguments, 0),
            group, l;
        for (e = 0; e < $canvases.length; e += 1) {
            $canvas = $($canvases[e]);
            group = $canvas.getLayerGroup(groupId);
            if (group) {

                // Animate all layers in the group
                for (l = 0; l < group.length; l += 1) {

                    // Replace first argument with layer
                    args[0] = group[l];
                    $canvas.animateLayer.apply($canvas, args);

                }

            }
        }
        return $canvases;
    };

// Delay layer animation by a given number of milliseconds
    $.fn.delayLayer = function delayLayer(layerId, duration) {
        var $canvases = this, $canvas, e,
            data, layer;
        duration = duration || 0;

        for (e = 0; e < $canvases.length; e += 1) {
            $canvas = $($canvases[e]);
            data = _getCanvasData($canvases[e]);
            layer = $canvas.getLayer(layerId);
            // If layer exists
            if (layer) {
                // Delay animation
                $(layer).delay(duration);
                _triggerLayerEvent($canvas, data, layer, 'delay');
            }
        }
        return $canvases;
    };

// Delay animation all layers in a layer group
    $.fn.delayLayerGroup = function delayLayerGroup(groupId, duration) {
        var $canvases = this, $canvas, e,
            group, layer, l;
        duration = duration || 0;

        for (e = 0; e < $canvases.length; e += 1) {
            $canvas = $($canvases[e]);

            group = $canvas.getLayerGroup(groupId);
            // Delay all layers in the group
            if (group) {

                for (l = 0; l < group.length; l += 1) {
                    // Delay each layer in the group
                    layer = group[l];
                    $canvas.delayLayer(layer, duration);
                }

            }
        }
        return $canvases;
    };

// Stop layer animation
    $.fn.stopLayer = function stopLayer(layerId, clearQueue) {
        var $canvases = this, $canvas, e,
            data, layer;

        for (e = 0; e < $canvases.length; e += 1) {
            $canvas = $($canvases[e]);
            data = _getCanvasData($canvases[e]);
            layer = $canvas.getLayer(layerId);
            // If layer exists
            if (layer) {
                // Stop animation
                $(layer).stop(clearQueue);
                _triggerLayerEvent($canvas, data, layer, 'stop');
            }
        }
        return $canvases;
    };

// Stop animation of all layers in a layer group
    $.fn.stopLayerGroup = function stopLayerGroup(groupId, clearQueue) {
        var $canvases = this, $canvas, e,
            group, layer, l;

        for (e = 0; e < $canvases.length; e += 1) {
            $canvas = $($canvases[e]);

            group = $canvas.getLayerGroup(groupId);
            // Stop all layers in the group
            if (group) {

                for (l = 0; l < group.length; l += 1) {
                    // Stop each layer in the group
                    layer = group[l];
                    $canvas.stopLayer(layer, clearQueue);
                }

            }
        }
        return $canvases;
    };

// Enable animation for color properties
    function _supportColorProps(props) {
        var p;
        for (p = 0; p < props.length; p += 1) {
            $.fx.step[props[p]] = _animateColor;
        }
    }

// Enable animation for color properties
    _supportColorProps([
        'color',
        'backgroundColor',
        'borderColor',
        'borderTopColor',
        'borderRightColor',
        'borderBottomColor',
        'borderLeftColor',
        'fillStyle',
        'outlineColor',
        'strokeStyle',
        'shadowColor'
    ]);

    /* Event API */

// Map standard mouse events to touch events
    maps.touchEvents = {
        'mousedown': 'touchstart',
        'mouseup': 'touchend',
        'mousemove': 'touchmove'
    };
// Map standard touch events to mouse events
    maps.mouseEvents = {
        'touchstart': 'mousedown',
        'touchend': 'mouseup',
        'touchmove': 'mousemove'
    };

// Convert mouse event name to a corresponding touch event name (if possible)
    function _getTouchEventName(eventName) {
        // Detect touch event support
        if (maps.touchEvents[eventName]) {
            eventName = maps.touchEvents[eventName];
        }
        return eventName;
    }
// Convert touch event name to a corresponding mouse event name
    function _getMouseEventName(eventName) {
        if (maps.mouseEvents[eventName]) {
            eventName = maps.mouseEvents[eventName];
        }
        return eventName;
    }

// Bind event to jCanvas layer using standard jQuery events
    function _createEvent(eventName) {

        jCanvas.events[eventName] = function ($canvas, data) {
            var helperEventName, touchEventName, eventCache;

            // Retrieve canvas's event cache
            eventCache = data.event;

            // Both mouseover/mouseout events will be managed by a single mousemove event
            helperEventName = (eventName === 'mouseover' || eventName === 'mouseout') ? 'mousemove' : eventName;
            touchEventName = _getTouchEventName(helperEventName);

            function eventCallback(event) {
                // Cache current mouse position and redraw layers
                eventCache.x = event.offsetX;
                eventCache.y = event.offsetY;
                eventCache.type = helperEventName;
                eventCache.event = event;
                // Redraw layers on every trigger of the event; don't redraw if at
                // least one layer is draggable and there are no layers with
                // explicit mouseover/mouseout/mousemove events
                if (event.type !== 'mousemove' || data.redrawOnMousemove || data.drag.dragging) {
                    $canvas.drawLayers({
                        resetFire: true
                    });
                }
                // Prevent default event behavior
                event.preventDefault();
            }

            // Ensure the event is not bound more than once
            if (!data.events[helperEventName]) {
                // Bind one canvas event which handles all layer events of that type
                if (touchEventName !== helperEventName) {
                    $canvas.bind(helperEventName + '.jCanvas ' + touchEventName + '.jCanvas', eventCallback);
                } else {
                    $canvas.bind(helperEventName + '.jCanvas', eventCallback);
                }
                // Prevent this event from being bound twice
                data.events[helperEventName] = true;
            }
        };
    }
    function _createEvents(eventNames) {
        var n;
        for (n = 0; n < eventNames.length; n += 1) {
            _createEvent(eventNames[n]);
        }
    }
// Populate jCanvas events object with some standard events
    _createEvents([
        'click',
        'dblclick',
        'mousedown',
        'mouseup',
        'mousemove',
        'mouseover',
        'mouseout',
        'touchstart',
        'touchmove',
        'touchend',
        'pointerdown',
        'pointermove',
        'pointerup',
        'contextmenu'
    ]);

// Check if event fires when a drawing is drawn
    function _detectEvents(canvas, ctx, params) {
        var layer, data, eventCache, intersects,
            transforms, x, y, angle;

        // Use the layer object stored by the given parameters object
        layer = params._args;
        // Canvas must have event bindings
        if (layer) {

            data = _getCanvasData(canvas);
            eventCache = data.event;
            if (eventCache.x !== null && eventCache.y !== null) {
                // Respect user-defined pixel ratio
                x = eventCache.x * data.pixelRatio;
                y = eventCache.y * data.pixelRatio;
                // Determine if the given coordinates are in the current path
                intersects = ctx.isPointInPath(x, y) || (ctx.isPointInStroke && ctx.isPointInStroke(x, y));
            }
            transforms = data.transforms;

            // Allow callback functions to retrieve the mouse coordinates
            layer.eventX = eventCache.x;
            layer.eventY = eventCache.y;
            layer.event = eventCache.event;

            // Adjust coordinates to match current canvas transformation

            // Keep track of some transformation values
            angle = data.transforms.rotate;
            x = layer.eventX;
            y = layer.eventY;

            if (angle !== 0) {
                // Rotate coordinates if coordinate space has been rotated
                layer._eventX = (x * cos(-angle)) - (y * sin(-angle));
                layer._eventY = (y * cos(-angle)) + (x * sin(-angle));
            } else {
                // Otherwise, no calculations need to be made
                layer._eventX = x;
                layer._eventY = y;
            }

            // Scale coordinates
            layer._eventX /= transforms.scaleX;
            layer._eventY /= transforms.scaleY;

            // If layer intersects with cursor
            if (intersects) {
                // Add it to a list of layers that intersect with cursor
                data.intersecting.push(layer);
            }
            layer.intersects = Boolean(intersects);
        }
    }

// Normalize offsetX and offsetY for all browsers
    $.event.fix = function (event) {
        var offset, originalEvent, touches;

        event = jQueryEventFix.call($.event, event);
        originalEvent = event.originalEvent;

        // originalEvent does not exist for manually-triggered events
        if (originalEvent) {

            touches = originalEvent.changedTouches;

            // If offsetX and offsetY are not supported, define them
            if (event.pageX !== undefined && event.offsetX === undefined) {
                try {
                    offset = $(event.currentTarget).offset();
                    if (offset) {
                        event.offsetX = event.pageX - offset.left;
                        event.offsetY = event.pageY - offset.top;
                    }
                } catch (error) {
                    // Fail silently
                }
            } else if (touches) {
                try {
                    // Enable offsetX and offsetY for mobile devices
                    offset = $(event.currentTarget).offset();
                    if (offset) {
                        event.offsetX = touches[0].pageX - offset.left;
                        event.offsetY = touches[0].pageY - offset.top;
                    }
                } catch (error) {
                    // Fail silently
                }
            }

        }
        return event;
    };

    /* Drawing API */

// Map drawing names with their respective method names
    maps.drawings = {
        'arc': 'drawArc',
        'bezier': 'drawBezier',
        'ellipse': 'drawEllipse',
        'function': 'draw',
        'image': 'drawImage',
        'line': 'drawLine',
        'path': 'drawPath',
        'polygon': 'drawPolygon',
        'slice': 'drawSlice',
        'quadratic': 'drawQuadratic',
        'rectangle': 'drawRect',
        'text': 'drawText',
        'vector': 'drawVector',
        'save': 'saveCanvas',
        'restore': 'restoreCanvas',
        'rotate': 'rotateCanvas',
        'scale': 'scaleCanvas',
        'translate': 'translateCanvas'
    };

// Draws on canvas using a function
    $.fn.draw = function draw(args) {
        var $canvases = this, e, ctx,
            params = new jCanvasObject(args);

        // Draw using any other method
        if (maps.drawings[params.type] && params.type !== 'function') {

            $canvases[maps.drawings[params.type]](args);

        } else {

            for (e = 0; e < $canvases.length; e += 1) {
                ctx = _getContext($canvases[e]);
                if (ctx) {

                    params = new jCanvasObject(args);
                    _addLayer($canvases[e], params, args, draw);
                    if (params.visible) {

                        if (params.fn) {
                            // Call the given user-defined function
                            params.fn.call($canvases[e], ctx, params);
                        }

                    }

                }
            }

        }
        return $canvases;
    };

// Clears canvas
    $.fn.clearCanvas = function clearCanvas(args) {
        var $canvases = this, e, ctx,
            params = new jCanvasObject(args);

        for (e = 0; e < $canvases.length; e += 1) {
            ctx = _getContext($canvases[e]);
            if (ctx) {

                if (params.width === null || params.height === null) {
                    // Clear entire canvas if width/height is not given

                    // Reset current transformation temporarily to ensure that the entire canvas is cleared
                    ctx.save();
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                    ctx.clearRect(0, 0, $canvases[e].width, $canvases[e].height);
                    ctx.restore();

                } else {
                    // Otherwise, clear the defined section of the canvas

                    // Transform clear rectangle
                    _addLayer($canvases[e], params, args, clearCanvas);
                    _transformShape($canvases[e], ctx, params, params.width, params.height);
                    ctx.clearRect(params.x - (params.width / 2), params.y - (params.height / 2), params.width, params.height);
                    // Restore previous transformation
                    _restoreTransform(ctx, params);

                }

            }
        }
        return $canvases;
    };

    /* Transformation API */

// Restores canvas
    $.fn.saveCanvas = function saveCanvas(args) {
        var $canvases = this, e, ctx,
            params, data, i;

        for (e = 0; e < $canvases.length; e += 1) {
            ctx = _getContext($canvases[e]);
            if (ctx) {

                data = _getCanvasData($canvases[e]);

                params = new jCanvasObject(args);
                _addLayer($canvases[e], params, args, saveCanvas);

                // Restore a number of times using the given count
                for (i = 0; i < params.count; i += 1) {
                    _saveCanvas(ctx, data);
                }

            }
        }
        return $canvases;
    };

// Restores canvas
    $.fn.restoreCanvas = function restoreCanvas(args) {
        var $canvases = this, e, ctx,
            params, data, i;

        for (e = 0; e < $canvases.length; e += 1) {
            ctx = _getContext($canvases[e]);
            if (ctx) {

                data = _getCanvasData($canvases[e]);

                params = new jCanvasObject(args);
                _addLayer($canvases[e], params, args, restoreCanvas);

                // Restore a number of times using the given count
                for (i = 0; i < params.count; i += 1) {
                    _restoreCanvas(ctx, data);
                }

            }
        }
        return $canvases;
    };

// Rotates canvas (internal)
    function _rotateCanvas(ctx, params, transforms) {

        // Get conversion factor for radians
        params._toRad = (params.inDegrees ? (PI / 180) : 1);

        // Rotate canvas using shape as center of rotation
        ctx.translate(params.x, params.y);
        ctx.rotate(params.rotate * params._toRad);
        ctx.translate(-params.x, -params.y);

        // If transformation data was given
        if (transforms) {
            // Update transformation data
            transforms.rotate += (params.rotate * params._toRad);
        }
    }

// Scales canvas (internal)
    function _scaleCanvas(ctx, params, transforms) {

        // Scale both the x- and y- axis using the 'scale' property
        if (params.scale !== 1) {
            params.scaleX = params.scaleY = params.scale;
        }

        // Scale canvas using shape as center of rotation
        ctx.translate(params.x, params.y);
        ctx.scale(params.scaleX, params.scaleY);
        ctx.translate(-params.x, -params.y);

        // If transformation data was given
        if (transforms) {
            // Update transformation data
            transforms.scaleX *= params.scaleX;
            transforms.scaleY *= params.scaleY;
        }
    }

// Translates canvas (internal)
    function _translateCanvas(ctx, params, transforms) {

        // Translate both the x- and y-axis using the 'translate' property
        if (params.translate) {
            params.translateX = params.translateY = params.translate;
        }

        // Translate canvas
        ctx.translate(params.translateX, params.translateY);

        // If transformation data was given
        if (transforms) {
            // Update transformation data
            transforms.translateX += params.translateX;
            transforms.translateY += params.translateY;
        }
    }

// Rotates canvas
    $.fn.rotateCanvas = function rotateCanvas(args) {
        var $canvases = this, e, ctx,
            params, data;

        for (e = 0; e < $canvases.length; e += 1) {
            ctx = _getContext($canvases[e]);
            if (ctx) {

                data = _getCanvasData($canvases[e]);

                params = new jCanvasObject(args);
                _addLayer($canvases[e], params, args, rotateCanvas);

                // Autosave transformation state by default
                if (params.autosave) {
                    // Automatically save transformation state by default
                    _saveCanvas(ctx, data);
                }
                _rotateCanvas(ctx, params, data.transforms);
            }

        }
        return $canvases;
    };

// Scales canvas
    $.fn.scaleCanvas = function scaleCanvas(args) {
        var $canvases = this, e, ctx,
            params, data;

        for (e = 0; e < $canvases.length; e += 1) {
            ctx = _getContext($canvases[e]);
            if (ctx) {

                data = _getCanvasData($canvases[e]);

                params = new jCanvasObject(args);
                _addLayer($canvases[e], params, args, scaleCanvas);

                // Autosave transformation state by default
                if (params.autosave) {
                    // Automatically save transformation state by default
                    _saveCanvas(ctx, data);
                }
                _scaleCanvas(ctx, params, data.transforms);

            }
        }
        return $canvases;
    };

// Translates canvas
    $.fn.translateCanvas = function translateCanvas(args) {
        var $canvases = this, e, ctx,
            params, data;

        for (e = 0; e < $canvases.length; e += 1) {
            ctx = _getContext($canvases[e]);
            if (ctx) {

                data = _getCanvasData($canvases[e]);

                params = new jCanvasObject(args);
                _addLayer($canvases[e], params, args, translateCanvas);

                // Autosave transformation state by default
                if (params.autosave) {
                    // Automatically save transformation state by default
                    _saveCanvas(ctx, data);
                }
                _translateCanvas(ctx, params, data.transforms);

            }
        }
        return $canvases;
    };

    /* Shape API */

// Draws rectangle
    $.fn.drawRect = function drawRect(args) {
        var $canvases = this, e, ctx,
            params,
            x1, y1,
            x2, y2,
            r, temp;

        for (e = 0; e < $canvases.length; e += 1) {
            ctx = _getContext($canvases[e]);
            if (ctx) {

                params = new jCanvasObject(args);
                _addLayer($canvases[e], params, args, drawRect);
                if (params.visible) {

                    _transformShape($canvases[e], ctx, params, params.width, params.height);
                    _setGlobalProps($canvases[e], ctx, params);

                    ctx.beginPath();
                    if (params.width && params.height) {
                        x1 = params.x - (params.width / 2);
                        y1 = params.y - (params.height / 2);
                        r = abs(params.cornerRadius);
                        // If corner radius is defined and is not zero
                        if (r) {
                            // Draw rectangle with rounded corners if cornerRadius is defined

                            x2 = params.x + (params.width / 2);
                            y2 = params.y + (params.height / 2);

                            // Handle negative width
                            if (params.width < 0) {
                                temp = x1;
                                x1 = x2;
                                x2 = temp;
                            }
                            // Handle negative height
                            if (params.height < 0) {
                                temp = y1;
                                y1 = y2;
                                y2 = temp;
                            }

                            // Prevent over-rounded corners
                            if ((x2 - x1) - (2 * r) < 0) {
                                r = (x2 - x1) / 2;
                            }
                            if ((y2 - y1) - (2 * r) < 0) {
                                r = (y2 - y1) / 2;
                            }

                            // Draw rectangle
                            ctx.moveTo(x1 + r, y1);
                            ctx.lineTo(x2 - r, y1);
                            ctx.arc(x2 - r, y1 + r, r, 3 * PI / 2, PI * 2, false);
                            ctx.lineTo(x2, y2 - r);
                            ctx.arc(x2 - r, y2 - r, r, 0, PI / 2, false);
                            ctx.lineTo(x1 + r, y2);
                            ctx.arc(x1 + r, y2 - r, r, PI / 2, PI, false);
                            ctx.lineTo(x1, y1 + r);
                            ctx.arc(x1 + r, y1 + r, r, PI, 3 * PI / 2, false);
                            // Always close path
                            params.closed = true;

                        } else {

                            // Otherwise, draw rectangle with square corners
                            ctx.rect(x1, y1, params.width, params.height);

                        }
                    }
                    // Check for jCanvas events
                    _detectEvents($canvases[e], ctx, params);
                    // Close rectangle path
                    _closePath($canvases[e], ctx, params);
                }
            }
        }
        return $canvases;
    };

// Retrieves a coterminal angle between 0 and 2pi for the given angle
    function _getCoterminal(angle) {
        while (angle < 0) {
            angle += (2 * PI);
        }
        return angle;
    }

// Retrieves the x-coordinate for the given angle in a circle
    function _getArcX(params, angle) {
        return params.x + (params.radius * cos(angle));
    }
// Retrieves the y-coordinate for the given angle in a circle
    function _getArcY(params, angle) {
        return params.y + (params.radius * sin(angle));
    }

// Draws arc (internal)
    function _drawArc(canvas, ctx, params, path) {
        var x1, y1, x2, y2,
            x3, y3, x4, y4,
            offsetX, offsetY,
            diff;

        // Determine offset from dragging
        if (params === path) {
            offsetX = 0;
            offsetY = 0;
        } else {
            offsetX = params.x;
            offsetY = params.y;
        }

        // Convert default end angle to radians
        if (!path.inDegrees && path.end === 360) {
            path.end = PI * 2;
        }

        // Convert angles to radians
        path.start *= params._toRad;
        path.end *= params._toRad;
        // Consider 0deg due north of arc
        path.start -= (PI / 2);
        path.end -= (PI / 2);

        // Ensure arrows are pointed correctly for CCW arcs
        diff = PI / 180;
        if (path.ccw) {
            diff *= -1;
        }

        // Calculate coordinates for start arrow
        x1 = _getArcX(path, path.start + diff);
        y1 = _getArcY(path, path.start + diff);
        x2 = _getArcX(path, path.start);
        y2 = _getArcY(path, path.start);

        _addStartArrow(
            canvas, ctx,
            params, path,
            x1, y1,
            x2, y2
        );

        // Draw arc
        ctx.arc(path.x + offsetX, path.y + offsetY, path.radius, path.start, path.end, path.ccw);

        // Calculate coordinates for end arrow
        x3 = _getArcX(path, path.end + diff);
        y3 = _getArcY(path, path.end + diff);
        x4 = _getArcX(path, path.end);
        y4 = _getArcY(path, path.end);

        _addEndArrow(
            canvas, ctx,
            params, path,
            x4, y4,
            x3, y3
        );
    }

// Draws arc or circle
    $.fn.drawArc = function drawArc(args) {
        var $canvases = this, e, ctx,
            params;

        for (e = 0; e < $canvases.length; e += 1) {
            ctx = _getContext($canvases[e]);
            if (ctx) {

                params = new jCanvasObject(args);
                _addLayer($canvases[e], params, args, drawArc);
                if (params.visible) {

                    _transformShape($canvases[e], ctx, params, params.radius * 2);
                    _setGlobalProps($canvases[e], ctx, params);

                    ctx.beginPath();
                    _drawArc($canvases[e], ctx, params, params);
                    // Check for jCanvas events
                    _detectEvents($canvases[e], ctx, params);
                    // Optionally close path
                    _closePath($canvases[e], ctx, params);

                }

            }
        }
        return $canvases;
    };

// Draws ellipse
    $.fn.drawEllipse = function drawEllipse(args) {
        var $canvases = this, e, ctx,
            params,
            controlW,
            controlH;

        for (e = 0; e < $canvases.length; e += 1) {
            ctx = _getContext($canvases[e]);
            if (ctx) {

                params = new jCanvasObject(args);
                _addLayer($canvases[e], params, args, drawEllipse);
                if (params.visible) {

                    _transformShape($canvases[e], ctx, params, params.width, params.height);
                    _setGlobalProps($canvases[e], ctx, params);

                    // Calculate control width and height
                    controlW = params.width * (4 / 3);
                    controlH = params.height;

                    // Create ellipse using curves
                    ctx.beginPath();
                    ctx.moveTo(params.x, params.y - (controlH / 2));
                    // Left side
                    ctx.bezierCurveTo(params.x - (controlW / 2), params.y - (controlH / 2), params.x - (controlW / 2), params.y + (controlH / 2), params.x, params.y + (controlH / 2));
                    // Right side
                    ctx.bezierCurveTo(params.x + (controlW / 2), params.y + (controlH / 2), params.x + (controlW / 2), params.y - (controlH / 2), params.x, params.y - (controlH / 2));
                    // Check for jCanvas events
                    _detectEvents($canvases[e], ctx, params);
                    // Always close path
                    params.closed = true;
                    _closePath($canvases[e], ctx, params);

                }
            }
        }
        return $canvases;
    };

// Draws a regular (equal-angled) polygon
    $.fn.drawPolygon = function drawPolygon(args) {
        var $canvases = this, e, ctx,
            params,
            theta, dtheta, hdtheta,
            apothem,
            x, y, i;

        for (e = 0; e < $canvases.length; e += 1) {
            ctx = _getContext($canvases[e]);
            if (ctx) {

                params = new jCanvasObject(args);
                _addLayer($canvases[e], params, args, drawPolygon);
                if (params.visible) {

                    _transformShape($canvases[e], ctx, params, params.radius * 2);
                    _setGlobalProps($canvases[e], ctx, params);

                    // Polygon's central angle
                    dtheta = (2 * PI) / params.sides;
                    // Half of dtheta
                    hdtheta = dtheta / 2;
                    // Polygon's starting angle
                    theta = hdtheta + (PI / 2);
                    // Distance from polygon's center to the middle of its side
                    apothem = params.radius * cos(hdtheta);

                    // Calculate path and draw
                    ctx.beginPath();
                    for (i = 0; i < params.sides; i += 1) {

                        // Draw side of polygon
                        x = params.x + (params.radius * cos(theta));
                        y = params.y + (params.radius * sin(theta));

                        // Plot point on polygon
                        ctx.lineTo(x, y);

                        // Project side if chosen
                        if (params.concavity) {
                            // Sides are projected from the polygon's apothem
                            x = params.x + ((apothem + (-apothem * params.concavity)) * cos(theta + hdtheta));
                            y = params.y + ((apothem + (-apothem * params.concavity)) * sin(theta + hdtheta));
                            ctx.lineTo(x, y);
                        }

                        // Increment theta by delta theta
                        theta += dtheta;

                    }
                    // Check for jCanvas events
                    _detectEvents($canvases[e], ctx, params);
                    // Always close path
                    params.closed = true;
                    _closePath($canvases[e], ctx, params);

                }
            }
        }
        return $canvases;
    };

// Draws pie-shaped slice
    $.fn.drawSlice = function drawSlice(args) {
        var $canvases = this, e, ctx,
            params,
            angle, dx, dy;

        for (e = 0; e < $canvases.length; e += 1) {
            ctx = _getContext($canvases[e]);
            if (ctx) {

                params = new jCanvasObject(args);
                _addLayer($canvases[e], params, args, drawSlice);
                if (params.visible) {

                    _transformShape($canvases[e], ctx, params, params.radius * 2);
                    _setGlobalProps($canvases[e], ctx, params);

                    // Perform extra calculations

                    // Convert angles to radians
                    params.start *= params._toRad;
                    params.end *= params._toRad;
                    // Consider 0deg at north of arc
                    params.start -= (PI / 2);
                    params.end -= (PI / 2);

                    // Find positive equivalents of angles
                    params.start = _getCoterminal(params.start);
                    params.end = _getCoterminal(params.end);
                    // Ensure start angle is less than end angle
                    if (params.end < params.start) {
                        params.end += (2 * PI);
                    }

                    // Calculate angular position of slice
                    angle = ((params.start + params.end) / 2);

                    // Calculate ratios for slice's angle
                    dx = (params.radius * params.spread * cos(angle));
                    dy = (params.radius * params.spread * sin(angle));

                    // Adjust position of slice
                    params.x += dx;
                    params.y += dy;

                    // Draw slice
                    ctx.beginPath();
                    ctx.arc(params.x, params.y, params.radius, params.start, params.end, params.ccw);
                    ctx.lineTo(params.x, params.y);
                    // Check for jCanvas events
                    _detectEvents($canvases[e], ctx, params);
                    // Always close path
                    params.closed = true;
                    _closePath($canvases[e], ctx, params);

                }

            }
        }
        return $canvases;
    };

    /* Path API */

// Adds arrow to path using the given properties
    function _addArrow(canvas, ctx, params, path, x1, y1, x2, y2) {
        var leftX, leftY,
            rightX, rightY,
            offsetX, offsetY,
            angle;

        // If arrow radius is given and path is not closed
        if (path.arrowRadius && !params.closed) {

            // Calculate angle
            angle = atan2((y2 - y1), (x2 - x1));
            // Adjust angle correctly
            angle -= PI;
            // Calculate offset to place arrow at edge of path
            offsetX = (params.strokeWidth * cos(angle));
            offsetY = (params.strokeWidth * sin(angle));

            // Calculate coordinates for left half of arrow
            leftX = x2 + (path.arrowRadius * cos(angle + (path.arrowAngle / 2)));
            leftY = y2 + (path.arrowRadius * sin(angle + (path.arrowAngle / 2)));
            // Calculate coordinates for right half of arrow
            rightX = x2 + (path.arrowRadius * cos(angle - (path.arrowAngle / 2)));
            rightY = y2 + (path.arrowRadius * sin(angle - (path.arrowAngle / 2)));

            // Draw left half of arrow
            ctx.moveTo(leftX - offsetX, leftY - offsetY);
            ctx.lineTo(x2 - offsetX, y2 - offsetY);
            // Draw right half of arrow
            ctx.lineTo(rightX - offsetX, rightY - offsetY);

            // Visually connect arrow to path
            ctx.moveTo(x2 - offsetX, y2 - offsetY);
            ctx.lineTo(x2 + offsetX, y2 + offsetY);
            // Move back to end of path
            ctx.moveTo(x2, y2);

        }
    }

// Optionally adds arrow to start of path
    function _addStartArrow(canvas, ctx, params, path, x1, y1, x2, y2) {
        if (!path._arrowAngleConverted) {
            path.arrowAngle *= params._toRad;
            path._arrowAngleConverted = true;
        }
        if (path.startArrow) {
            _addArrow(canvas, ctx, params, path, x1, y1, x2, y2);
        }
    }

// Optionally adds arrow to end of path
    function _addEndArrow(canvas, ctx, params, path, x1, y1, x2, y2) {
        if (!path._arrowAngleConverted) {
            path.arrowAngle *= params._toRad;
            path._arrowAngleConverted = true;
        }
        if (path.endArrow) {
            _addArrow(canvas, ctx, params, path, x1, y1, x2, y2);
        }
    }

// Draws line (internal)
    function _drawLine(canvas, ctx, params, path) {
        var l,
            lx, ly;
        l = 2;
        _addStartArrow(
            canvas, ctx,
            params, path,
            path.x2 + params.x,
            path.y2 + params.y,
            path.x1 + params.x,
            path.y1 + params.y
        );
        if (path.x1 !== undefined && path.y1 !== undefined) {
            ctx.moveTo(path.x1 + params.x, path.y1 + params.y);
        }
        while (true) {
            // Calculate next coordinates
            lx = path['x' + l];
            ly = path['y' + l];
            // If coordinates are given
            if (lx !== undefined && ly !== undefined) {
                // Draw next line
                ctx.lineTo(lx + params.x, ly + params.y);
                l += 1;
            } else {
                // Otherwise, stop drawing
                break;
            }
        }
        l -= 1;
        // Optionally add arrows to path
        _addEndArrow(
            canvas, ctx,
            params,
            path,
            path['x' + (l - 1)] + params.x,
            path['y' + (l - 1)] + params.y,
            path['x' + l] + params.x,
            path['y' + l] + params.y
        );
    }

// Draws line
    $.fn.drawLine = function drawLine(args) {
        var $canvases = this, e, ctx,
            params;

        for (e = 0; e < $canvases.length; e += 1) {
            ctx = _getContext($canvases[e]);
            if (ctx) {

                params = new jCanvasObject(args);
                _addLayer($canvases[e], params, args, drawLine);
                if (params.visible) {

                    _transformShape($canvases[e], ctx, params);
                    _setGlobalProps($canvases[e], ctx, params);

                    // Draw each point
                    ctx.beginPath();
                    _drawLine($canvases[e], ctx, params, params);
                    // Check for jCanvas events
                    _detectEvents($canvases[e], ctx, params);
                    // Optionally close path
                    _closePath($canvases[e], ctx, params);

                }

            }
        }
        return $canvases;
    };

// Draws quadratic curve (internal)
    function _drawQuadratic(canvas, ctx, params, path) {
        var l,
            lx, ly,
            lcx, lcy;

        l = 2;

        _addStartArrow(
            canvas,
            ctx,
            params,
            path,
            path.cx1 + params.x,
            path.cy1 + params.y,
            path.x1 + params.x,
            path.y1 + params.y
        );

        if (path.x1 !== undefined && path.y1 !== undefined) {
            ctx.moveTo(path.x1 + params.x, path.y1 + params.y);
        }
        while (true) {
            // Calculate next coordinates
            lx = path['x' + l];
            ly = path['y' + l];
            lcx = path['cx' + (l - 1)];
            lcy = path['cy' + (l - 1)];
            // If coordinates are given
            if (lx !== undefined && ly !== undefined && lcx !== undefined && lcy !== undefined) {
                // Draw next curve
                ctx.quadraticCurveTo(lcx + params.x, lcy + params.y, lx + params.x, ly + params.y);
                l += 1;
            } else {
                // Otherwise, stop drawing
                break;
            }
        }
        l -= 1;
        _addEndArrow(
            canvas,
            ctx,
            params,
            path,
            path['cx' + (l - 1)] + params.x,
            path['cy' + (l - 1)] + params.y,
            path['x' + l] + params.x,
            path['y' + l] + params.y
        );
    }

// Draws quadratic curve
    $.fn.drawQuadratic = function drawQuadratic(args) {
        var $canvases = this, e, ctx,
            params;

        for (e = 0; e < $canvases.length; e += 1) {
            ctx = _getContext($canvases[e]);
            if (ctx) {

                params = new jCanvasObject(args);
                _addLayer($canvases[e], params, args, drawQuadratic);
                if (params.visible) {

                    _transformShape($canvases[e], ctx, params);
                    _setGlobalProps($canvases[e], ctx, params);

                    // Draw each point
                    ctx.beginPath();
                    _drawQuadratic($canvases[e], ctx, params, params);
                    // Check for jCanvas events
                    _detectEvents($canvases[e], ctx, params);
                    // Optionally close path
                    _closePath($canvases[e], ctx, params);

                }
            }
        }
        return $canvases;
    };

// Draws Bezier curve (internal)
    function _drawBezier(canvas, ctx, params, path) {
        var l, lc,
            lx, ly,
            lcx1, lcy1,
            lcx2, lcy2;

        l = 2;
        lc = 1;

        _addStartArrow(
            canvas,
            ctx,
            params,
            path,
            path.cx1 + params.x,
            path.cy1 + params.y,
            path.x1 + params.x,
            path.y1 + params.y
        );

        if (path.x1 !== undefined && path.y1 !== undefined) {
            ctx.moveTo(path.x1 + params.x, path.y1 + params.y);
        }
        while (true) {
            // Calculate next coordinates
            lx = path['x' + l];
            ly = path['y' + l];
            lcx1 = path['cx' + lc];
            lcy1 = path['cy' + lc];
            lcx2 = path['cx' + (lc + 1)];
            lcy2 = path['cy' + (lc + 1)];
            // If next coordinates are given
            if (lx !== undefined && ly !== undefined && lcx1 !== undefined && lcy1 !== undefined && lcx2 !== undefined && lcy2 !== undefined) {
                // Draw next curve
                ctx.bezierCurveTo(lcx1 + params.x, lcy1 + params.y, lcx2 + params.x, lcy2 + params.y, lx + params.x, ly + params.y);
                l += 1;
                lc += 2;
            } else {
                // Otherwise, stop drawing
                break;
            }
        }
        l -= 1;
        lc -= 2;
        _addEndArrow(
            canvas,
            ctx,
            params,
            path,
            path['cx' + (lc + 1)] + params.x,
            path['cy' + (lc + 1)] + params.y,
            path['x' + l] + params.x,
            path['y' + l] + params.y
        );
    }

// Draws Bezier curve
    $.fn.drawBezier = function drawBezier(args) {
        var $canvases = this, e, ctx,
            params;

        for (e = 0; e < $canvases.length; e += 1) {
            ctx = _getContext($canvases[e]);
            if (ctx) {

                params = new jCanvasObject(args);
                _addLayer($canvases[e], params, args, drawBezier);
                if (params.visible) {

                    _transformShape($canvases[e], ctx, params);
                    _setGlobalProps($canvases[e], ctx, params);

                    // Draw each point
                    ctx.beginPath();
                    _drawBezier($canvases[e], ctx, params, params);
                    // Check for jCanvas events
                    _detectEvents($canvases[e], ctx, params);
                    // Optionally close path
                    _closePath($canvases[e], ctx, params);

                }
            }
        }
        return $canvases;
    };

// Retrieves the x-coordinate for the given vector angle and length
    function _getVectorX(params, angle, length) {
        angle *= params._toRad;
        angle -= (PI / 2);
        return (length * cos(angle));
    }
// Retrieves the y-coordinate for the given vector angle and length
    function _getVectorY(params, angle, length) {
        angle *= params._toRad;
        angle -= (PI / 2);
        return (length * sin(angle));
    }

// Draws vector (internal) #2
    function _drawVector(canvas, ctx, params, path) {
        var l, angle, length,
            offsetX, offsetY,
            x, y,
            x3, y3,
            x4, y4;

        // Determine offset from dragging
        if (params === path) {
            offsetX = 0;
            offsetY = 0;
        } else {
            offsetX = params.x;
            offsetY = params.y;
        }

        l = 1;
        x = x3 = x4 = path.x + offsetX;
        y = y3 = y4 = path.y + offsetY;

        _addStartArrow(
            canvas, ctx,
            params, path,
            x + _getVectorX(params, path.a1, path.l1),
            y + _getVectorY(params, path.a1, path.l1),
            x,
            y
        );

        // The vector starts at the given (x, y) coordinates
        if (path.x !== undefined && path.y !== undefined) {
            ctx.moveTo(x, y);
        }
        while (true) {

            angle = path['a' + l];
            length = path['l' + l];

            if (angle !== undefined && length !== undefined) {
                // Convert the angle to radians with 0 degrees starting at north
                // Keep track of last two coordinates
                x3 = x4;
                y3 = y4;
                // Compute (x, y) coordinates from angle and length
                x4 += _getVectorX(params, angle, length);
                y4 += _getVectorY(params, angle, length);
                ctx.lineTo(x4, y4);
                l += 1;
            } else {
                // Otherwise, stop drawing
                break;
            }

        }
        _addEndArrow(
            canvas, ctx,
            params, path,
            x3, y3,
            x4, y4
        );
    }

// Draws vector
    $.fn.drawVector = function drawVector(args) {
        var $canvases = this, e, ctx,
            params;

        for (e = 0; e < $canvases.length; e += 1) {
            ctx = _getContext($canvases[e]);
            if (ctx) {

                params = new jCanvasObject(args);
                _addLayer($canvases[e], params, args, drawVector);
                if (params.visible) {

                    _transformShape($canvases[e], ctx, params);
                    _setGlobalProps($canvases[e], ctx, params);

                    // Draw each point
                    ctx.beginPath();
                    _drawVector($canvases[e], ctx, params, params);
                    // Check for jCanvas events
                    _detectEvents($canvases[e], ctx, params);
                    // Optionally close path
                    _closePath($canvases[e], ctx, params);

                }
            }
        }
        return $canvases;
    };

// Draws a path consisting of one or more subpaths
    $.fn.drawPath = function drawPath(args) {
        var $canvases = this, e, ctx,
            params,
            l, lp;

        for (e = 0; e < $canvases.length; e += 1) {
            ctx = _getContext($canvases[e]);
            if (ctx) {

                params = new jCanvasObject(args);
                _addLayer($canvases[e], params, args, drawPath);
                if (params.visible) {

                    _transformShape($canvases[e], ctx, params);
                    _setGlobalProps($canvases[e], ctx, params);

                    ctx.beginPath();
                    l = 1;
                    while (true) {
                        lp = params['p' + l];
                        if (lp !== undefined) {
                            lp = new jCanvasObject(lp);
                            if (lp.type === 'line') {
                                _drawLine($canvases[e], ctx, params, lp);
                            } else if (lp.type === 'quadratic') {
                                _drawQuadratic($canvases[e], ctx, params, lp);
                            } else if (lp.type === 'bezier') {
                                _drawBezier($canvases[e], ctx, params, lp);
                            } else if (lp.type === 'vector') {
                                _drawVector($canvases[e], ctx, params, lp);
                            } else if (lp.type === 'arc') {
                                _drawArc($canvases[e], ctx, params, lp);
                            }
                            l += 1;
                        } else {
                            break;
                        }
                    }

                    // Check for jCanvas events
                    _detectEvents($canvases[e], ctx, params);
                    // Optionally close path
                    _closePath($canvases[e], ctx, params);

                }

            }
        }
        return $canvases;
    };

    /* Text API */

// Calculates font string and set it as the canvas font
    function _setCanvasFont(canvas, ctx, params) {
        // Otherwise, use the given font attributes
        if (!isNaN(Number(params.fontSize))) {
            // Give font size units if it doesn't have any
            params.fontSize += 'px';
        }
        // Set font using given font properties
        ctx.font = params.fontStyle + ' ' + params.fontSize + ' ' + params.fontFamily;
    }

// Measures canvas text
    function _measureText(canvas, ctx, params, lines) {
        var originalSize, curWidth, l,
            propCache = caches.propCache;

        // Used cached width/height if possible
        if (propCache.text === params.text && propCache.fontStyle === params.fontStyle && propCache.fontSize === params.fontSize && propCache.fontFamily === params.fontFamily && propCache.maxWidth === params.maxWidth && propCache.lineHeight === params.lineHeight) {

            params.width = propCache.width;
            params.height = propCache.height;

        } else {
            // Calculate text dimensions only once

            // Calculate width of first line (for comparison)
            params.width = ctx.measureText(lines[0]).width;

            // Get width of longest line
            for (l = 1; l < lines.length; l += 1) {

                curWidth = ctx.measureText(lines[l]).width;
                // Ensure text's width is the width of its longest line
                if (curWidth > params.width) {
                    params.width = curWidth;
                }

            }

            // Save original font size
            originalSize = canvas.style.fontSize;
            // Temporarily set canvas font size to retrieve size in pixels
            canvas.style.fontSize = params.fontSize;
            // Save text width and height in parameters object
            params.height = parseFloat($.css(canvas, 'fontSize')) * lines.length * params.lineHeight;
            // Reset font size to original size
            canvas.style.fontSize = originalSize;
        }
    }

// Wraps a string of text within a defined width
    function _wrapText(ctx, params) {
        var allText = String(params.text),
            // Maximum line width (optional)
            maxWidth = params.maxWidth,
            // Lines created by manual line breaks (\n)
            manualLines = allText.split('\n'),
            // All lines created manually and by wrapping
            allLines = [],
            // Other variables
            lines, line, l,
            text, words, w;

        // Loop through manually-broken lines
        for (l = 0; l < manualLines.length; l += 1) {

            text = manualLines[l];
            // Split line into list of words
            words = text.split(' ');
            lines = [];
            line = '';

            // If text is short enough initially
            // Or, if the text consists of only one word
            if (words.length === 1 || ctx.measureText(text).width < maxWidth) {

                // No need to wrap text
                lines = [text];

            } else {

                // Wrap lines
                for (w = 0; w < words.length; w += 1) {

                    // Once line gets too wide, push word to next line
                    if (ctx.measureText(line + words[w]).width > maxWidth) {
                        // This check prevents empty lines from being created
                        if (line !== '') {
                            lines.push(line);
                        }
                        // Start new line and repeat process
                        line = '';
                    }
                    // Add words to line until the line is too wide
                    line += words[w];
                    // Do not add a space after the last word
                    if (w !== (words.length - 1)) {
                        line += ' ';
                    }
                }
                // The last word should always be pushed
                lines.push(line);

            }
            // Remove extra space at the end of each line
            allLines = allLines.concat(
                lines
                    .join('\n')
                    .replace(/((\n))|($)/gi, '$2')
                    .split('\n')
            );

        }

        return allLines;
    }

// Draws text on canvas
    $.fn.drawText = function drawText(args) {
        var $canvases = this, e, ctx,
            params, layer,
            lines, line, l,
            fontSize, constantCloseness = 500,
            nchars, chars, ch, c,
            x, y;

        for (e = 0; e < $canvases.length; e += 1) {
            ctx = _getContext($canvases[e]);
            if (ctx) {

                params = new jCanvasObject(args);
                _addLayer($canvases[e], params, args, drawText);
                if (params.visible) {

                    // Set text-specific properties
                    ctx.textBaseline = params.baseline;
                    ctx.textAlign = params.align;

                    // Set canvas font using given properties
                    _setCanvasFont($canvases[e], ctx, params);

                    if (params.maxWidth !== null) {
                        // Wrap text using an internal function
                        lines = _wrapText(ctx, params);
                    } else {
                        // Convert string of text to list of lines
                        lines = params.text
                            .toString()
                            .split('\n');
                    }

                    // Calculate text's width and height
                    _measureText($canvases[e], ctx, params, lines);

                    // If text is a layer
                    if (layer) {
                        // Copy calculated width/height to layer object
                        layer.width = params.width;
                        layer.height = params.height;
                    }

                    _transformShape($canvases[e], ctx, params, params.width, params.height);
                    _setGlobalProps($canvases[e], ctx, params);

                    // Adjust text position to accomodate different horizontal alignments
                    x = params.x;
                    if (params.align === 'left') {
                        if (params.respectAlign) {
                            // Realign text to the left if chosen
                            params.x += params.width / 2;
                        } else {
                            // Center text block by default
                            x -= params.width / 2;
                        }
                    } else if (params.align === 'right') {
                        if (params.respectAlign) {
                            // Realign text to the right if chosen
                            params.x -= params.width / 2;
                        } else {
                            // Center text block by default
                            x += params.width / 2;
                        }
                    }

                    if (params.radius) {

                        fontSize = parseFloat(params.fontSize);

                        // Greater values move clockwise
                        if (params.letterSpacing === null) {
                            params.letterSpacing = fontSize / constantCloseness;
                        }

                        // Loop through each line of text
                        for (l = 0; l < lines.length; l += 1) {
                            ctx.save();
                            ctx.translate(params.x, params.y);
                            line = lines[l];
                            if (params.flipArcText) {
                                chars = line.split('');
                                chars.reverse();
                                line = chars.join('');
                            }
                            nchars = line.length;
                            ctx.rotate(-(PI * params.letterSpacing * (nchars - 1)) / 2);
                            // Loop through characters on each line
                            for (c = 0; c < nchars; c += 1) {
                                ch = line[c];
                                // If character is not the first character
                                if (c !== 0) {
                                    // Rotate character onto arc
                                    ctx.rotate(PI * params.letterSpacing);
                                }
                                ctx.save();
                                ctx.translate(0, -params.radius);
                                if (params.flipArcText) {
                                    ctx.scale(-1, -1);
                                }
                                ctx.fillText(ch, 0, 0);
                                // Prevent extra shadow created by stroke (but only when fill is present)
                                if (params.fillStyle !== 'transparent') {
                                    ctx.shadowColor = 'transparent';
                                }
                                if (params.strokeWidth !== 0) {
                                    // Only stroke if the stroke is not 0
                                    ctx.strokeText(ch, 0, 0);
                                }
                                ctx.restore();
                            }
                            params.radius -= fontSize;
                            params.letterSpacing += fontSize / (constantCloseness * 2 * PI);
                            ctx.restore();
                        }

                    } else {

                        // Draw each line of text separately
                        for (l = 0; l < lines.length; l += 1) {
                            line = lines[l];
                            // Add line offset to center point, but subtract some to center everything
                            y = params.y + (l * params.height / lines.length) - (((lines.length - 1) * params.height / lines.length) / 2);

                            ctx.shadowColor = params.shadowColor;

                            // Fill & stroke text
                            ctx.fillText(line, x, y);
                            // Prevent extra shadow created by stroke (but only when fill is present)
                            if (params.fillStyle !== 'transparent') {
                                ctx.shadowColor = 'transparent';
                            }
                            if (params.strokeWidth !== 0) {
                                // Only stroke if the stroke is not 0
                                ctx.strokeText(line, x, y);
                            }

                        }

                    }

                    // Adjust bounding box according to text baseline
                    y = 0;
                    if (params.baseline === 'top') {
                        y += params.height / 2;
                    } else if (params.baseline === 'bottom') {
                        y -= params.height / 2;
                    }

                    // Detect jCanvas events
                    if (params._event) {
                        ctx.beginPath();
                        ctx.rect(
                            params.x - (params.width / 2),
                            params.y - (params.height / 2) + y,
                            params.width,
                            params.height
                        );
                        _detectEvents($canvases[e], ctx, params);
                        // Close path and configure masking
                        ctx.closePath();
                    }
                    _restoreTransform(ctx, params);

                }
            }
        }
        // Cache jCanvas parameters object for efficiency
        caches.propCache = params;
        return $canvases;
    };

// Measures text width/height using the given parameters
    $.fn.measureText = function measureText(args) {
        var $canvases = this, ctx,
            params, lines;

        // Attempt to retrieve layer
        params = $canvases.getLayer(args);
        // If layer does not exist or if returned object is not a jCanvas layer
        if (!params || (params && !params._layer)) {
            params = new jCanvasObject(args);
        }

        ctx = _getContext($canvases[0]);
        if (ctx) {

            // Set canvas font using given properties
            _setCanvasFont($canvases[0], ctx, params);
            // Calculate width and height of text
            lines = _wrapText(ctx, params);
            _measureText($canvases[0], ctx, params, lines);


        }

        return params;
    };

    /* Image API */

// Draws image on canvas
    $.fn.drawImage = function drawImage(args) {
        var $canvases = this, canvas, e, ctx, data,
            params, layer,
            img, imgCtx, source,
            imageCache = caches.imageCache;

        // Draw image function
        function draw(canvas, ctx, data, params, layer) {

            // If width and sWidth are not defined, use image width
            if (params.width === null && params.sWidth === null) {
                params.width = params.sWidth = img.width;
            }
            // If width and sHeight are not defined, use image height
            if (params.height === null && params.sHeight === null) {
                params.height = params.sHeight = img.height;
            }

            // Ensure image layer's width and height are accurate
            if (layer) {
                layer.width = params.width;
                layer.height = params.height;
            }

            // Only crop image if all cropping properties are given
            if (params.sWidth !== null && params.sHeight !== null && params.sx !== null && params.sy !== null) {

                // If width is not defined, use the given sWidth
                if (params.width === null) {
                    params.width = params.sWidth;
                }
                // If height is not defined, use the given sHeight
                if (params.height === null) {
                    params.height = params.sHeight;
                }

                // Optionally crop from top-left corner of region
                if (params.cropFromCenter) {
                    params.sx += params.sWidth / 2;
                    params.sy += params.sHeight / 2;
                }

                // Ensure cropped region does not escape image boundaries

                // Top
                if ((params.sy - (params.sHeight / 2)) < 0) {
                    params.sy = (params.sHeight / 2);
                }
                // Bottom
                if ((params.sy + (params.sHeight / 2)) > img.height) {
                    params.sy = img.height - (params.sHeight / 2);
                }
                // Left
                if ((params.sx - (params.sWidth / 2)) < 0) {
                    params.sx = (params.sWidth / 2);
                }
                // Right
                if ((params.sx + (params.sWidth / 2)) > img.width) {
                    params.sx = img.width - (params.sWidth / 2);
                }

                _transformShape(canvas, ctx, params, params.width, params.height);
                _setGlobalProps(canvas, ctx, params);

                // Draw image
                ctx.drawImage(
                    img,
                    params.sx - (params.sWidth / 2),
                    params.sy - (params.sHeight / 2),
                    params.sWidth,
                    params.sHeight,
                    params.x - (params.width / 2),
                    params.y - (params.height / 2),
                    params.width,
                    params.height
                );

            } else {
                // Show entire image if no crop region is defined

                _transformShape(canvas, ctx, params, params.width, params.height);
                _setGlobalProps(canvas, ctx, params);

                // Draw image on canvas
                ctx.drawImage(
                    img,
                    params.x - (params.width / 2),
                    params.y - (params.height / 2),
                    params.width,
                    params.height
                );

            }

            // Draw invisible rectangle to allow for events and masking
            ctx.beginPath();
            ctx.rect(
                params.x - (params.width / 2),
                params.y - (params.height / 2),
                params.width,
                params.height
            );
            // Check for jCanvas events
            _detectEvents(canvas, ctx, params);
            // Close path and configure masking
            ctx.closePath();
            _restoreTransform(ctx, params);
            _enableMasking(ctx, data, params);
        }
        // On load function
        function onload(canvas, ctx, data, params, layer) {
            return function () {
                var $canvas = $(canvas);
                draw(canvas, ctx, data, params, layer);
                if (params.layer) {
                    // Trigger 'load' event for layers
                    _triggerLayerEvent($canvas, data, layer, 'load');
                } else if (params.load) {
                    // Run 'load' callback for non-layers
                    params.load.call($canvas[0], layer);
                }
                // Continue drawing successive layers after this image layer has loaded
                if (params.layer) {
                    // Store list of previous masks for each layer
                    layer._masks = data.transforms.masks.slice(0);
                    if (params._next) {
                        // Draw successive layers
                        $canvas.drawLayers({
                            clear: false,
                            resetFire: true,
                            index: params._next
                        });
                    }
                }
            };
        }
        for (e = 0; e < $canvases.length; e += 1) {
            canvas = $canvases[e];
            ctx = _getContext($canvases[e]);
            if (ctx) {

                data = _getCanvasData($canvases[e]);
                params = new jCanvasObject(args);
                layer = _addLayer($canvases[e], params, args, drawImage);
                if (params.visible) {

                    // Cache the given source
                    source = params.source;

                    imgCtx = source.getContext;
                    if (source.src || imgCtx) {
                        // Use image or canvas element if given
                        img = source;
                    } else if (source) {
                        if (imageCache[source] && imageCache[source].complete) {
                            // Get the image element from the cache if possible
                            img = imageCache[source];
                        } else {
                            // Otherwise, get the image from the given source URL
                            img = new Image();
                            // If source URL is not a data URL
                            if (!source.match(/^data:/i)) {
                                // Set crossOrigin for this image
                                img.crossOrigin = params.crossOrigin;
                            }
                            img.src = source;
                            // Save image in cache for improved performance
                            imageCache[source] = img;
                        }
                    }

                    if (img) {
                        if (img.complete || imgCtx) {
                            // Draw image if already loaded
                            onload(canvas, ctx, data, params, layer)();
                        } else {
                            // Otherwise, draw image when it loads
                            img.onload = onload(canvas, ctx, data, params, layer);
                            // Fix onload() bug in IE9
                            img.src = img.src;
                        }
                    }

                }
            }
        }
        return $canvases;
    };

// Creates a canvas pattern object
    $.fn.createPattern = function createPattern(args) {
        var $canvases = this, ctx,
            params,
            img, imgCtx,
            pattern, source;

        // Function to be called when pattern loads
        function onload() {
            // Create pattern
            pattern = ctx.createPattern(img, params.repeat);
            // Run callback function if defined
            if (params.load) {
                params.load.call($canvases[0], pattern);
            }
        }

        ctx = _getContext($canvases[0]);
        if (ctx) {

            params = new jCanvasObject(args);

            // Cache the given source
            source = params.source;

            // Draw when image is loaded (if load() callback function is defined)

            if (isFunction(source)) {
                // Draw pattern using function if given

                img = $('<canvas />')[0];
                img.width = params.width;
                img.height = params.height;
                imgCtx = _getContext(img);
                source.call(img, imgCtx);
                onload();

            } else {
                // Otherwise, draw pattern using source image

                imgCtx = source.getContext;
                if (source.src || imgCtx) {
                    // Use image element if given
                    img = source;
                } else {
                    // Use URL if given to get the image
                    img = new Image();
                    // If source URL is not a data URL
                    if (!source.match(/^data:/i)) {
                        // Set crossOrigin for this image
                        img.crossOrigin = params.crossOrigin;
                    }
                    img.src = source;
                }

                // Create pattern if already loaded
                if (img.complete || imgCtx) {
                    onload();
                } else {
                    img.onload = onload;
                    // Fix onload() bug in IE9
                    img.src = img.src;
                }

            }

        } else {

            pattern = null;

        }
        return pattern;
    };

// Creates a canvas gradient object
    $.fn.createGradient = function createGradient(args) {
        var $canvases = this, ctx,
            params,
            gradient,
            stops = [], nstops,
            start, end,
            i, a, n, p;

        params = new jCanvasObject(args);
        ctx = _getContext($canvases[0]);
        if (ctx) {

            // Gradient coordinates must be defined
            params.x1 = params.x1 || 0;
            params.y1 = params.y1 || 0;
            params.x2 = params.x2 || 0;
            params.y2 = params.y2 || 0;

            if (params.r1 !== null && params.r2 !== null) {
                // Create radial gradient if chosen
                gradient = ctx.createRadialGradient(params.x1, params.y1, params.r1, params.x2, params.y2, params.r2);
            } else {
                // Otherwise, create a linear gradient by default
                gradient = ctx.createLinearGradient(params.x1, params.y1, params.x2, params.y2);
            }

            // Count number of color stops
            for (i = 1; params['c' + i] !== undefined; i += 1) {
                if (params['s' + i] !== undefined) {
                    stops.push(params['s' + i]);
                } else {
                    stops.push(null);
                }
            }
            nstops = stops.length;

            // Define start stop if not already defined
            if (stops[0] === null) {
                stops[0] = 0;
            }
            // Define end stop if not already defined
            if (stops[nstops - 1] === null) {
                stops[nstops - 1] = 1;
            }

            // Loop through color stops to fill in the blanks
            for (i = 0; i < nstops; i += 1) {
                // A progression, in this context, is defined as all of the color stops between and including two known color stops

                if (stops[i] !== null) {
                    // Start a new progression if stop is a number

                    // Number of stops in current progression
                    n = 1;
                    // Current iteration in current progression
                    p = 0;
                    start = stops[i];

                    // Look ahead to find end stop
                    for (a = (i + 1); a < nstops; a += 1) {
                        if (stops[a] !== null) {
                            // If this future stop is a number, make it the end stop for this progression
                            end = stops[a];
                            break;
                        } else {
                            // Otherwise, keep looking ahead
                            n += 1;
                        }
                    }

                    // Ensure start stop is not greater than end stop
                    if (start > end) {
                        stops[a] = stops[i];
                    }

                } else if (stops[i] === null) {
                    // Calculate stop if not initially given
                    p += 1;
                    stops[i] = start + (p * ((end - start) / n));
                }
                // Add color stop to gradient object
                gradient.addColorStop(stops[i], params['c' + (i + 1)]);
            }

        } else {
            gradient = null;
        }
        return gradient;
    };

// Manipulates pixels on the canvas
    $.fn.setPixels = function setPixels(args) {
        var $canvases = this,
            canvas, e, ctx, canvasData,
            params,
            px,
            imgData, pixelData, i, len;

        for (e = 0; e < $canvases.length; e += 1) {
            canvas = $canvases[e];
            ctx = _getContext(canvas);
            canvasData = _getCanvasData($canvases[e]);
            if (ctx) {

                params = new jCanvasObject(args);
                _addLayer(canvas, params, args, setPixels);
                _transformShape($canvases[e], ctx, params, params.width, params.height);

                // Use entire canvas of x, y, width, or height is not defined
                if (params.width === null || params.height === null) {
                    params.width = canvas.width;
                    params.height = canvas.height;
                    params.x = params.width / 2;
                    params.y = params.height / 2;
                }

                if (params.width !== 0 && params.height !== 0) {
                    // Only set pixels if width and height are not zero

                    imgData = ctx.getImageData(
                        (params.x - (params.width / 2)) * canvasData.pixelRatio,
                        (params.y - (params.height / 2)) * canvasData.pixelRatio,
                        params.width * canvasData.pixelRatio,
                        params.height * canvasData.pixelRatio
                    );
                    pixelData = imgData.data;
                    len = pixelData.length;

                    // Loop through pixels with the "each" callback function
                    if (params.each) {
                        for (i = 0; i < len; i += 4) {
                            px = {
                                r: pixelData[i],
                                g: pixelData[i + 1],
                                b: pixelData[i + 2],
                                a: pixelData[i + 3]
                            };
                            params.each.call(canvas, px, params);
                            pixelData[i] = px.r;
                            pixelData[i + 1] = px.g;
                            pixelData[i + 2] = px.b;
                            pixelData[i + 3] = px.a;
                        }
                    }
                    // Put pixels on canvas
                    ctx.putImageData(
                        imgData,
                        (params.x - (params.width / 2)) * canvasData.pixelRatio,
                        (params.y - (params.height / 2)) * canvasData.pixelRatio
                    );
                    // Restore transformation
                    ctx.restore();

                }

            }
        }
        return $canvases;
    };

// Retrieves canvas image as data URL
    $.fn.getCanvasImage = function getCanvasImage(type, quality) {
        var $canvases = this, canvas,
            dataURL = null;
        if ($canvases.length !== 0) {
            canvas = $canvases[0];
            if (canvas.toDataURL) {
                // JPEG quality defaults to 1
                if (quality === undefined) {
                    quality = 1;
                }
                dataURL = canvas.toDataURL('image/' + type, quality);
            }
        }
        return dataURL;
    };

// Scales canvas based on the device's pixel ratio
    $.fn.detectPixelRatio = function detectPixelRatio(callback) {
        var $canvases = this,
            canvas, e, ctx,
            devicePixelRatio, backingStoreRatio, ratio,
            oldWidth, oldHeight,
            data;

        for (e = 0; e < $canvases.length; e += 1) {
            // Get canvas and its associated data
            canvas = $canvases[e];
            ctx = _getContext(canvas);
            data = _getCanvasData($canvases[e]);

            // If canvas has not already been scaled with this method
            if (!data.scaled) {

                // Determine device pixel ratios
                devicePixelRatio = window.devicePixelRatio || 1;
                backingStoreRatio = ctx.webkitBackingStorePixelRatio ||
                    ctx.mozBackingStorePixelRatio ||
                    ctx.msBackingStorePixelRatio ||
                    ctx.oBackingStorePixelRatio ||
                    ctx.backingStorePixelRatio || 1;

                // Calculate general ratio based on the two given ratios
                ratio = devicePixelRatio / backingStoreRatio;

                if (ratio !== 1) {
                    // Scale canvas relative to ratio

                    // Get the current canvas dimensions for future use
                    oldWidth = canvas.width;
                    oldHeight = canvas.height;

                    // Resize canvas relative to the determined ratio
                    canvas.width = oldWidth * ratio;
                    canvas.height = oldHeight * ratio;

                    // Scale canvas back to original dimensions via CSS
                    canvas.style.width = oldWidth + 'px';
                    canvas.style.height = oldHeight + 'px';

                    // Scale context to counter the manual scaling of canvas
                    ctx.scale(ratio, ratio);

                }

                // Set pixel ratio on canvas data object
                data.pixelRatio = ratio;
                // Ensure that this method can only be called once for any given canvas
                data.scaled = true;

                // Call the given callback function with the ratio as its only argument
                if (callback) {
                    callback.call(canvas, ratio);
                }

            }

        }
        return $canvases;
    };

// Clears the jCanvas cache
    jCanvas.clearCache = function clearCache() {
        var cacheName;
        for (cacheName in caches) {
            if (Object.prototype.hasOwnProperty.call(caches, cacheName)) {
                caches[cacheName] = {};
            }
        }
    };

// Enable canvas feature detection with $.support
    $.support.canvas = ($('<canvas />')[0].getContext !== undefined);

// Export jCanvas functions
    extendObject(jCanvas, {
        defaults: defaults,
        setGlobalProps: _setGlobalProps,
        transformShape: _transformShape,
        detectEvents: _detectEvents,
        closePath: _closePath,
        setCanvasFont: _setCanvasFont,
        measureText: _measureText
    });
    $.jCanvas = jCanvas;
    $.jCanvasObject = jCanvasObject;

}));
//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.
(function(){function n(n){function t(t,r,e,u,i,o){for(;i>=0&&o>i;i+=n){var a=u?u[i]:i;e=r(e,t[a],a,t)}return e}return function(r,e,u,i){e=b(e,i,4);var o=!k(r)&&m.keys(r),a=(o||r).length,c=n>0?0:a-1;return arguments.length<3&&(u=r[o?o[c]:c],c+=n),t(r,e,u,o,c,a)}}function t(n){return function(t,r,e){r=x(r,e);for(var u=O(t),i=n>0?0:u-1;i>=0&&u>i;i+=n)if(r(t[i],i,t))return i;return-1}}function r(n,t,r){return function(e,u,i){var o=0,a=O(e);if("number"==typeof i)n>0?o=i>=0?i:Math.max(i+a,o):a=i>=0?Math.min(i+1,a):i+a+1;else if(r&&i&&a)return i=r(e,u),e[i]===u?i:-1;if(u!==u)return i=t(l.call(e,o,a),m.isNaN),i>=0?i+o:-1;for(i=n>0?o:a-1;i>=0&&a>i;i+=n)if(e[i]===u)return i;return-1}}function e(n,t){var r=I.length,e=n.constructor,u=m.isFunction(e)&&e.prototype||a,i="constructor";for(m.has(n,i)&&!m.contains(t,i)&&t.push(i);r--;)i=I[r],i in n&&n[i]!==u[i]&&!m.contains(t,i)&&t.push(i)}var u=this,i=u._,o=Array.prototype,a=Object.prototype,c=Function.prototype,f=o.push,l=o.slice,s=a.toString,p=a.hasOwnProperty,h=Array.isArray,v=Object.keys,g=c.bind,y=Object.create,d=function(){},m=function(n){return n instanceof m?n:this instanceof m?void(this._wrapped=n):new m(n)};"undefined"!=typeof exports?("undefined"!=typeof module&&module.exports&&(exports=module.exports=m),exports._=m):u._=m,m.VERSION="1.8.3";var b=function(n,t,r){if(t===void 0)return n;switch(null==r?3:r){case 1:return function(r){return n.call(t,r)};case 2:return function(r,e){return n.call(t,r,e)};case 3:return function(r,e,u){return n.call(t,r,e,u)};case 4:return function(r,e,u,i){return n.call(t,r,e,u,i)}}return function(){return n.apply(t,arguments)}},x=function(n,t,r){return null==n?m.identity:m.isFunction(n)?b(n,t,r):m.isObject(n)?m.matcher(n):m.property(n)};m.iteratee=function(n,t){return x(n,t,1/0)};var _=function(n,t){return function(r){var e=arguments.length;if(2>e||null==r)return r;for(var u=1;e>u;u++)for(var i=arguments[u],o=n(i),a=o.length,c=0;a>c;c++){var f=o[c];t&&r[f]!==void 0||(r[f]=i[f])}return r}},j=function(n){if(!m.isObject(n))return{};if(y)return y(n);d.prototype=n;var t=new d;return d.prototype=null,t},w=function(n){return function(t){return null==t?void 0:t[n]}},A=Math.pow(2,53)-1,O=w("length"),k=function(n){var t=O(n);return"number"==typeof t&&t>=0&&A>=t};m.each=m.forEach=function(n,t,r){t=b(t,r);var e,u;if(k(n))for(e=0,u=n.length;u>e;e++)t(n[e],e,n);else{var i=m.keys(n);for(e=0,u=i.length;u>e;e++)t(n[i[e]],i[e],n)}return n},m.map=m.collect=function(n,t,r){t=x(t,r);for(var e=!k(n)&&m.keys(n),u=(e||n).length,i=Array(u),o=0;u>o;o++){var a=e?e[o]:o;i[o]=t(n[a],a,n)}return i},m.reduce=m.foldl=m.inject=n(1),m.reduceRight=m.foldr=n(-1),m.find=m.detect=function(n,t,r){var e;return e=k(n)?m.findIndex(n,t,r):m.findKey(n,t,r),e!==void 0&&e!==-1?n[e]:void 0},m.filter=m.select=function(n,t,r){var e=[];return t=x(t,r),m.each(n,function(n,r,u){t(n,r,u)&&e.push(n)}),e},m.reject=function(n,t,r){return m.filter(n,m.negate(x(t)),r)},m.every=m.all=function(n,t,r){t=x(t,r);for(var e=!k(n)&&m.keys(n),u=(e||n).length,i=0;u>i;i++){var o=e?e[i]:i;if(!t(n[o],o,n))return!1}return!0},m.some=m.any=function(n,t,r){t=x(t,r);for(var e=!k(n)&&m.keys(n),u=(e||n).length,i=0;u>i;i++){var o=e?e[i]:i;if(t(n[o],o,n))return!0}return!1},m.contains=m.includes=m.include=function(n,t,r,e){return k(n)||(n=m.values(n)),("number"!=typeof r||e)&&(r=0),m.indexOf(n,t,r)>=0},m.invoke=function(n,t){var r=l.call(arguments,2),e=m.isFunction(t);return m.map(n,function(n){var u=e?t:n[t];return null==u?u:u.apply(n,r)})},m.pluck=function(n,t){return m.map(n,m.property(t))},m.where=function(n,t){return m.filter(n,m.matcher(t))},m.findWhere=function(n,t){return m.find(n,m.matcher(t))},m.max=function(n,t,r){var e,u,i=-1/0,o=-1/0;if(null==t&&null!=n){n=k(n)?n:m.values(n);for(var a=0,c=n.length;c>a;a++)e=n[a],e>i&&(i=e)}else t=x(t,r),m.each(n,function(n,r,e){u=t(n,r,e),(u>o||u===-1/0&&i===-1/0)&&(i=n,o=u)});return i},m.min=function(n,t,r){var e,u,i=1/0,o=1/0;if(null==t&&null!=n){n=k(n)?n:m.values(n);for(var a=0,c=n.length;c>a;a++)e=n[a],i>e&&(i=e)}else t=x(t,r),m.each(n,function(n,r,e){u=t(n,r,e),(o>u||1/0===u&&1/0===i)&&(i=n,o=u)});return i},m.shuffle=function(n){for(var t,r=k(n)?n:m.values(n),e=r.length,u=Array(e),i=0;e>i;i++)t=m.random(0,i),t!==i&&(u[i]=u[t]),u[t]=r[i];return u},m.sample=function(n,t,r){return null==t||r?(k(n)||(n=m.values(n)),n[m.random(n.length-1)]):m.shuffle(n).slice(0,Math.max(0,t))},m.sortBy=function(n,t,r){return t=x(t,r),m.pluck(m.map(n,function(n,r,e){return{value:n,index:r,criteria:t(n,r,e)}}).sort(function(n,t){var r=n.criteria,e=t.criteria;if(r!==e){if(r>e||r===void 0)return 1;if(e>r||e===void 0)return-1}return n.index-t.index}),"value")};var F=function(n){return function(t,r,e){var u={};return r=x(r,e),m.each(t,function(e,i){var o=r(e,i,t);n(u,e,o)}),u}};m.groupBy=F(function(n,t,r){m.has(n,r)?n[r].push(t):n[r]=[t]}),m.indexBy=F(function(n,t,r){n[r]=t}),m.countBy=F(function(n,t,r){m.has(n,r)?n[r]++:n[r]=1}),m.toArray=function(n){return n?m.isArray(n)?l.call(n):k(n)?m.map(n,m.identity):m.values(n):[]},m.size=function(n){return null==n?0:k(n)?n.length:m.keys(n).length},m.partition=function(n,t,r){t=x(t,r);var e=[],u=[];return m.each(n,function(n,r,i){(t(n,r,i)?e:u).push(n)}),[e,u]},m.first=m.head=m.take=function(n,t,r){return null==n?void 0:null==t||r?n[0]:m.initial(n,n.length-t)},m.initial=function(n,t,r){return l.call(n,0,Math.max(0,n.length-(null==t||r?1:t)))},m.last=function(n,t,r){return null==n?void 0:null==t||r?n[n.length-1]:m.rest(n,Math.max(0,n.length-t))},m.rest=m.tail=m.drop=function(n,t,r){return l.call(n,null==t||r?1:t)},m.compact=function(n){return m.filter(n,m.identity)};var S=function(n,t,r,e){for(var u=[],i=0,o=e||0,a=O(n);a>o;o++){var c=n[o];if(k(c)&&(m.isArray(c)||m.isArguments(c))){t||(c=S(c,t,r));var f=0,l=c.length;for(u.length+=l;l>f;)u[i++]=c[f++]}else r||(u[i++]=c)}return u};m.flatten=function(n,t){return S(n,t,!1)},m.without=function(n){return m.difference(n,l.call(arguments,1))},m.uniq=m.unique=function(n,t,r,e){m.isBoolean(t)||(e=r,r=t,t=!1),null!=r&&(r=x(r,e));for(var u=[],i=[],o=0,a=O(n);a>o;o++){var c=n[o],f=r?r(c,o,n):c;t?(o&&i===f||u.push(c),i=f):r?m.contains(i,f)||(i.push(f),u.push(c)):m.contains(u,c)||u.push(c)}return u},m.union=function(){return m.uniq(S(arguments,!0,!0))},m.intersection=function(n){for(var t=[],r=arguments.length,e=0,u=O(n);u>e;e++){var i=n[e];if(!m.contains(t,i)){for(var o=1;r>o&&m.contains(arguments[o],i);o++);o===r&&t.push(i)}}return t},m.difference=function(n){var t=S(arguments,!0,!0,1);return m.filter(n,function(n){return!m.contains(t,n)})},m.zip=function(){return m.unzip(arguments)},m.unzip=function(n){for(var t=n&&m.max(n,O).length||0,r=Array(t),e=0;t>e;e++)r[e]=m.pluck(n,e);return r},m.object=function(n,t){for(var r={},e=0,u=O(n);u>e;e++)t?r[n[e]]=t[e]:r[n[e][0]]=n[e][1];return r},m.findIndex=t(1),m.findLastIndex=t(-1),m.sortedIndex=function(n,t,r,e){r=x(r,e,1);for(var u=r(t),i=0,o=O(n);o>i;){var a=Math.floor((i+o)/2);r(n[a])<u?i=a+1:o=a}return i},m.indexOf=r(1,m.findIndex,m.sortedIndex),m.lastIndexOf=r(-1,m.findLastIndex),m.range=function(n,t,r){null==t&&(t=n||0,n=0),r=r||1;for(var e=Math.max(Math.ceil((t-n)/r),0),u=Array(e),i=0;e>i;i++,n+=r)u[i]=n;return u};var E=function(n,t,r,e,u){if(!(e instanceof t))return n.apply(r,u);var i=j(n.prototype),o=n.apply(i,u);return m.isObject(o)?o:i};m.bind=function(n,t){if(g&&n.bind===g)return g.apply(n,l.call(arguments,1));if(!m.isFunction(n))throw new TypeError("Bind must be called on a function");var r=l.call(arguments,2),e=function(){return E(n,e,t,this,r.concat(l.call(arguments)))};return e},m.partial=function(n){var t=l.call(arguments,1),r=function(){for(var e=0,u=t.length,i=Array(u),o=0;u>o;o++)i[o]=t[o]===m?arguments[e++]:t[o];for(;e<arguments.length;)i.push(arguments[e++]);return E(n,r,this,this,i)};return r},m.bindAll=function(n){var t,r,e=arguments.length;if(1>=e)throw new Error("bindAll must be passed function names");for(t=1;e>t;t++)r=arguments[t],n[r]=m.bind(n[r],n);return n},m.memoize=function(n,t){var r=function(e){var u=r.cache,i=""+(t?t.apply(this,arguments):e);return m.has(u,i)||(u[i]=n.apply(this,arguments)),u[i]};return r.cache={},r},m.delay=function(n,t){var r=l.call(arguments,2);return setTimeout(function(){return n.apply(null,r)},t)},m.defer=m.partial(m.delay,m,1),m.throttle=function(n,t,r){var e,u,i,o=null,a=0;r||(r={});var c=function(){a=r.leading===!1?0:m.now(),o=null,i=n.apply(e,u),o||(e=u=null)};return function(){var f=m.now();a||r.leading!==!1||(a=f);var l=t-(f-a);return e=this,u=arguments,0>=l||l>t?(o&&(clearTimeout(o),o=null),a=f,i=n.apply(e,u),o||(e=u=null)):o||r.trailing===!1||(o=setTimeout(c,l)),i}},m.debounce=function(n,t,r){var e,u,i,o,a,c=function(){var f=m.now()-o;t>f&&f>=0?e=setTimeout(c,t-f):(e=null,r||(a=n.apply(i,u),e||(i=u=null)))};return function(){i=this,u=arguments,o=m.now();var f=r&&!e;return e||(e=setTimeout(c,t)),f&&(a=n.apply(i,u),i=u=null),a}},m.wrap=function(n,t){return m.partial(t,n)},m.negate=function(n){return function(){return!n.apply(this,arguments)}},m.compose=function(){var n=arguments,t=n.length-1;return function(){for(var r=t,e=n[t].apply(this,arguments);r--;)e=n[r].call(this,e);return e}},m.after=function(n,t){return function(){return--n<1?t.apply(this,arguments):void 0}},m.before=function(n,t){var r;return function(){return--n>0&&(r=t.apply(this,arguments)),1>=n&&(t=null),r}},m.once=m.partial(m.before,2);var M=!{toString:null}.propertyIsEnumerable("toString"),I=["valueOf","isPrototypeOf","toString","propertyIsEnumerable","hasOwnProperty","toLocaleString"];m.keys=function(n){if(!m.isObject(n))return[];if(v)return v(n);var t=[];for(var r in n)m.has(n,r)&&t.push(r);return M&&e(n,t),t},m.allKeys=function(n){if(!m.isObject(n))return[];var t=[];for(var r in n)t.push(r);return M&&e(n,t),t},m.values=function(n){for(var t=m.keys(n),r=t.length,e=Array(r),u=0;r>u;u++)e[u]=n[t[u]];return e},m.mapObject=function(n,t,r){t=x(t,r);for(var e,u=m.keys(n),i=u.length,o={},a=0;i>a;a++)e=u[a],o[e]=t(n[e],e,n);return o},m.pairs=function(n){for(var t=m.keys(n),r=t.length,e=Array(r),u=0;r>u;u++)e[u]=[t[u],n[t[u]]];return e},m.invert=function(n){for(var t={},r=m.keys(n),e=0,u=r.length;u>e;e++)t[n[r[e]]]=r[e];return t},m.functions=m.methods=function(n){var t=[];for(var r in n)m.isFunction(n[r])&&t.push(r);return t.sort()},m.extend=_(m.allKeys),m.extendOwn=m.assign=_(m.keys),m.findKey=function(n,t,r){t=x(t,r);for(var e,u=m.keys(n),i=0,o=u.length;o>i;i++)if(e=u[i],t(n[e],e,n))return e},m.pick=function(n,t,r){var e,u,i={},o=n;if(null==o)return i;m.isFunction(t)?(u=m.allKeys(o),e=b(t,r)):(u=S(arguments,!1,!1,1),e=function(n,t,r){return t in r},o=Object(o));for(var a=0,c=u.length;c>a;a++){var f=u[a],l=o[f];e(l,f,o)&&(i[f]=l)}return i},m.omit=function(n,t,r){if(m.isFunction(t))t=m.negate(t);else{var e=m.map(S(arguments,!1,!1,1),String);t=function(n,t){return!m.contains(e,t)}}return m.pick(n,t,r)},m.defaults=_(m.allKeys,!0),m.create=function(n,t){var r=j(n);return t&&m.extendOwn(r,t),r},m.clone=function(n){return m.isObject(n)?m.isArray(n)?n.slice():m.extend({},n):n},m.tap=function(n,t){return t(n),n},m.isMatch=function(n,t){var r=m.keys(t),e=r.length;if(null==n)return!e;for(var u=Object(n),i=0;e>i;i++){var o=r[i];if(t[o]!==u[o]||!(o in u))return!1}return!0};var N=function(n,t,r,e){if(n===t)return 0!==n||1/n===1/t;if(null==n||null==t)return n===t;n instanceof m&&(n=n._wrapped),t instanceof m&&(t=t._wrapped);var u=s.call(n);if(u!==s.call(t))return!1;switch(u){case"[object RegExp]":case"[object String]":return""+n==""+t;case"[object Number]":return+n!==+n?+t!==+t:0===+n?1/+n===1/t:+n===+t;case"[object Date]":case"[object Boolean]":return+n===+t}var i="[object Array]"===u;if(!i){if("object"!=typeof n||"object"!=typeof t)return!1;var o=n.constructor,a=t.constructor;if(o!==a&&!(m.isFunction(o)&&o instanceof o&&m.isFunction(a)&&a instanceof a)&&"constructor"in n&&"constructor"in t)return!1}r=r||[],e=e||[];for(var c=r.length;c--;)if(r[c]===n)return e[c]===t;if(r.push(n),e.push(t),i){if(c=n.length,c!==t.length)return!1;for(;c--;)if(!N(n[c],t[c],r,e))return!1}else{var f,l=m.keys(n);if(c=l.length,m.keys(t).length!==c)return!1;for(;c--;)if(f=l[c],!m.has(t,f)||!N(n[f],t[f],r,e))return!1}return r.pop(),e.pop(),!0};m.isEqual=function(n,t){return N(n,t)},m.isEmpty=function(n){return null==n?!0:k(n)&&(m.isArray(n)||m.isString(n)||m.isArguments(n))?0===n.length:0===m.keys(n).length},m.isElement=function(n){return!(!n||1!==n.nodeType)},m.isArray=h||function(n){return"[object Array]"===s.call(n)},m.isObject=function(n){var t=typeof n;return"function"===t||"object"===t&&!!n},m.each(["Arguments","Function","String","Number","Date","RegExp","Error"],function(n){m["is"+n]=function(t){return s.call(t)==="[object "+n+"]"}}),m.isArguments(arguments)||(m.isArguments=function(n){return m.has(n,"callee")}),"function"!=typeof/./&&"object"!=typeof Int8Array&&(m.isFunction=function(n){return"function"==typeof n||!1}),m.isFinite=function(n){return isFinite(n)&&!isNaN(parseFloat(n))},m.isNaN=function(n){return m.isNumber(n)&&n!==+n},m.isBoolean=function(n){return n===!0||n===!1||"[object Boolean]"===s.call(n)},m.isNull=function(n){return null===n},m.isUndefined=function(n){return n===void 0},m.has=function(n,t){return null!=n&&p.call(n,t)},m.noConflict=function(){return u._=i,this},m.identity=function(n){return n},m.constant=function(n){return function(){return n}},m.noop=function(){},m.property=w,m.propertyOf=function(n){return null==n?function(){}:function(t){return n[t]}},m.matcher=m.matches=function(n){return n=m.extendOwn({},n),function(t){return m.isMatch(t,n)}},m.times=function(n,t,r){var e=Array(Math.max(0,n));t=b(t,r,1);for(var u=0;n>u;u++)e[u]=t(u);return e},m.random=function(n,t){return null==t&&(t=n,n=0),n+Math.floor(Math.random()*(t-n+1))},m.now=Date.now||function(){return(new Date).getTime()};var B={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"},T=m.invert(B),R=function(n){var t=function(t){return n[t]},r="(?:"+m.keys(n).join("|")+")",e=RegExp(r),u=RegExp(r,"g");return function(n){return n=null==n?"":""+n,e.test(n)?n.replace(u,t):n}};m.escape=R(B),m.unescape=R(T),m.result=function(n,t,r){var e=null==n?void 0:n[t];return e===void 0&&(e=r),m.isFunction(e)?e.call(n):e};var q=0;m.uniqueId=function(n){var t=++q+"";return n?n+t:t},m.templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};var K=/(.)^/,z={"'":"'","\\":"\\","\r":"r","\n":"n","\u2028":"u2028","\u2029":"u2029"},D=/\\|'|\r|\n|\u2028|\u2029/g,L=function(n){return"\\"+z[n]};m.template=function(n,t,r){!t&&r&&(t=r),t=m.defaults({},t,m.templateSettings);var e=RegExp([(t.escape||K).source,(t.interpolate||K).source,(t.evaluate||K).source].join("|")+"|$","g"),u=0,i="__p+='";n.replace(e,function(t,r,e,o,a){return i+=n.slice(u,a).replace(D,L),u=a+t.length,r?i+="'+\n((__t=("+r+"))==null?'':_.escape(__t))+\n'":e?i+="'+\n((__t=("+e+"))==null?'':__t)+\n'":o&&(i+="';\n"+o+"\n__p+='"),t}),i+="';\n",t.variable||(i="with(obj||{}){\n"+i+"}\n"),i="var __t,__p='',__j=Array.prototype.join,"+"print=function(){__p+=__j.call(arguments,'');};\n"+i+"return __p;\n";try{var o=new Function(t.variable||"obj","_",i)}catch(a){throw a.source=i,a}var c=function(n){return o.call(this,n,m)},f=t.variable||"obj";return c.source="function("+f+"){\n"+i+"}",c},m.chain=function(n){var t=m(n);return t._chain=!0,t};var P=function(n,t){return n._chain?m(t).chain():t};m.mixin=function(n){m.each(m.functions(n),function(t){var r=m[t]=n[t];m.prototype[t]=function(){var n=[this._wrapped];return f.apply(n,arguments),P(this,r.apply(m,n))}})},m.mixin(m),m.each(["pop","push","reverse","shift","sort","splice","unshift"],function(n){var t=o[n];m.prototype[n]=function(){var r=this._wrapped;return t.apply(r,arguments),"shift"!==n&&"splice"!==n||0!==r.length||delete r[0],P(this,r)}}),m.each(["concat","join","slice"],function(n){var t=o[n];m.prototype[n]=function(){return P(this,t.apply(this._wrapped,arguments))}}),m.prototype.value=function(){return this._wrapped},m.prototype.valueOf=m.prototype.toJSON=m.prototype.value,m.prototype.toString=function(){return""+this._wrapped},"function"==typeof define&&define.amd&&define("underscore",[],function(){return m})}).call(this);
//# sourceMappingURL=underscore-min.map
/* JSONPath 0.8.0 - XPath for JSON
 *
 * Copyright (c) 2007 Stefan Goessner (goessner.net)
 * Licensed under the MIT (MIT-LICENSE.txt) licence.
 */
function jsonPath(obj, expr, arg) {
    var P = {
        resultType: arg && arg.resultType || "VALUE",
        result: [],
        normalize: function(expr) {
            var subx = [];
            return expr.replace(/[\['](\??\(.*?\))[\]']/g, function($0,$1){return "[#"+(subx.push($1)-1)+"]";})
                .replace(/'?\.'?|\['?/g, ";")
                .replace(/;;;|;;/g, ";..;")
                .replace(/;$|'?\]|'$/g, "")
                .replace(/#([0-9]+)/g, function($0,$1){return subx[$1];});
        },
        asPath: function(path) {
            var x = path.split(";"), p = "$";
            for (var i=1,n=x.length; i<n; i++)
                p += /^[0-9*]+$/.test(x[i]) ? ("["+x[i]+"]") : ("['"+x[i]+"']");
            return p;
        },
        store: function(p, v) {
            if (p) P.result[P.result.length] = P.resultType == "PATH" ? P.asPath(p) : v;
            return !!p;
        },
        trace: function(expr, val, path) {
            if (expr) {
                var x = expr.split(";"), loc = x.shift();
                x = x.join(";");
                if (val && val.hasOwnProperty(loc))
                    P.trace(x, val[loc], path + ";" + loc);
                else if (loc === "*")
                    P.walk(loc, x, val, path, function(m,l,x,v,p) { P.trace(m+";"+x,v,p); });
                else if (loc === "..") {
                    P.trace(x, val, path);
                    P.walk(loc, x, val, path, function(m,l,x,v,p) { typeof v[m] === "object" && P.trace("..;"+x,v[m],p+";"+m); });
                }
                else if (/,/.test(loc)) { // [name1,name2,...]
                    for (var s=loc.split(/'?,'?/),i=0,n=s.length; i<n; i++)
                        P.trace(s[i]+";"+x, val, path);
                }
                else if (/^\(.*?\)$/.test(loc)) // [(expr)]
                    P.trace(P.eval(loc, val, path.substr(path.lastIndexOf(";")+1))+";"+x, val, path);
                else if (/^\?\(.*?\)$/.test(loc)) // [?(expr)]
                    P.walk(loc, x, val, path, function(m,l,x,v,p) { if (P.eval(l.replace(/^\?\((.*?)\)$/,"$1"),v[m],m)) P.trace(m+";"+x,v,p); });
                else if (/^(-?[0-9]*):(-?[0-9]*):?([0-9]*)$/.test(loc)) // [start:end:step]  phyton slice syntax
                    P.slice(loc, x, val, path);
            }
            else
                P.store(path, val);
        },
        walk: function(loc, expr, val, path, f) {
            if (val instanceof Array) {
                for (var i=0,n=val.length; i<n; i++)
                    if (i in val)
                        f(i,loc,expr,val,path);
            }
            else if (typeof val === "object") {
                for (var m in val)
                    if (val.hasOwnProperty(m))
                        f(m,loc,expr,val,path);
            }
        },
        slice: function(loc, expr, val, path) {
            if (val instanceof Array) {
                var len=val.length, start=0, end=len, step=1;
                loc.replace(/^(-?[0-9]*):(-?[0-9]*):?(-?[0-9]*)$/g, function($0,$1,$2,$3){start=parseInt($1||start);end=parseInt($2||end);step=parseInt($3||step);});
                start = (start < 0) ? Math.max(0,start+len) : Math.min(len,start);
                end   = (end < 0)   ? Math.max(0,end+len)   : Math.min(len,end);
                for (var i=start; i<end; i+=step)
                    P.trace(i+";"+expr, val, path);
            }
        },
        eval: function(x, _v, _vname) {
            try { return $ && _v && eval(x.replace(/@/g, "_v")); }
            catch(e) { throw new SyntaxError("jsonPath: " + e.message + ": " + x.replace(/@/g, "_v").replace(/\^/g, "_a")); }
        }
    };

    var $ = obj;
    if (expr && obj && (P.resultType == "VALUE" || P.resultType == "PATH")) {
        P.trace(P.normalize(expr).replace(/^\$;/,""), obj, "$");
        return P.result.length ? P.result : false;
    }
}


/*!
 * FormValidation (http://formvalidation.io)
 * The best jQuery plugin to validate form fields. Support Bootstrap, Foundation, Pure, SemanticUI, UIKit and custom frameworks
 *
 * @version     v0.7.0, built on 2015-08-01 4:57:18 PM
 * @author      https://twitter.com/formvalidation
 * @copyright   (c) 2013 - 2015 Nguyen Huu Phuoc
 * @license     http://formvalidation.io/license/
 */
/*
if (window.FormValidation = {
        AddOn: {},
        Framework: {},
        I18n: {},
        Validator: {}
    }, "undefined" == typeof jQuery) throw new Error("FormValidation requires jQuery");
! function(a) {
    var b = a.fn.jquery.split(" ")[0].split(".");
    if (+b[0] < 2 && +b[1] < 9 || 1 === +b[0] && 9 === +b[1] && +b[2] < 1) throw new Error("FormValidation requires jQuery version 1.9.1 or higher")
}(jQuery),
    function(a) {
        FormValidation.Base = function(b, c, d) {
            this.$form = a(b), this.options = a.extend({}, a.fn.formValidation.DEFAULT_OPTIONS, c), this._namespace = d || "fv", this.$invalidFields = a([]), this.$submitButton = null, this.$hiddenButton = null, this.STATUS_NOT_VALIDATED = "NOT_VALIDATED", this.STATUS_VALIDATING = "VALIDATING", this.STATUS_INVALID = "INVALID", this.STATUS_VALID = "VALID", this.STATUS_IGNORED = "IGNORED", this.DEFAULT_MESSAGE = a.fn.formValidation.DEFAULT_MESSAGE, this._ieVersion = function() {
                for (var a = 3, b = document.createElement("div"), c = b.all || []; b.innerHTML = "<!--[if gt IE " + ++a + "]><br><![endif]-->", c[0];);
                return a > 4 ? a : document.documentMode
            }();
            var e = document.createElement("div");
            this._changeEvent = 9 !== this._ieVersion && "oninput" in e ? "input" : "keyup", this._submitIfValid = null, this._cacheFields = {}, this._init()
        }, FormValidation.Base.prototype = {
            constructor: FormValidation.Base,
            _exceedThreshold: function(b) {
                var c = this._namespace,
                    d = b.attr("data-" + c + "-field");
                /!* justselling part, we just check if this.options.fields is not undefined, prevent js fall *!/
                var optionsFieldsD = typeof this.options.fields[d] !== 'undefined' ? this.options.fields[d].threshold : false;
                var e = optionsFieldsD || this.options.threshold;
                if (!e) return !0;
                var f = -1 !== a.inArray(b.attr("type"), ["button", "checkbox", "file", "hidden", "image", "radio", "reset", "submit"]);
                return f || b.val().length >= e
            },
            _init: function() {
                var b = this,
                    c = this._namespace,
                    d = {
                        addOns: {},
                        autoFocus: this.$form.attr("data-" + c + "-autofocus"),
                        button: {
                            selector: this.$form.attr("data-" + c + "-button-selector") || this.$form.attr("data-" + c + "-submitbuttons"),
                            disabled: this.$form.attr("data-" + c + "-button-disabled")
                        },
                        control: {
                            valid: this.$form.attr("data-" + c + "-control-valid"),
                            invalid: this.$form.attr("data-" + c + "-control-invalid")
                        },
                        err: {
                            clazz: this.$form.attr("data-" + c + "-err-clazz"),
                            container: this.$form.attr("data-" + c + "-err-container") || this.$form.attr("data-" + c + "-container"),
                            parent: this.$form.attr("data-" + c + "-err-parent")
                        },
                        events: {
                            formInit: this.$form.attr("data-" + c + "-events-form-init"),
                            formPreValidate: this.$form.attr("data-" + c + "-events-form-prevalidate"),
                            formError: this.$form.attr("data-" + c + "-events-form-error"),
                            formSuccess: this.$form.attr("data-" + c + "-events-form-success"),
                            fieldAdded: this.$form.attr("data-" + c + "-events-field-added"),
                            fieldRemoved: this.$form.attr("data-" + c + "-events-field-removed"),
                            fieldInit: this.$form.attr("data-" + c + "-events-field-init"),
                            fieldError: this.$form.attr("data-" + c + "-events-field-error"),
                            fieldSuccess: this.$form.attr("data-" + c + "-events-field-success"),
                            fieldStatus: this.$form.attr("data-" + c + "-events-field-status"),
                            localeChanged: this.$form.attr("data-" + c + "-events-locale-changed"),
                            validatorError: this.$form.attr("data-" + c + "-events-validator-error"),
                            validatorSuccess: this.$form.attr("data-" + c + "-events-validator-success"),
                            validatorIgnored: this.$form.attr("data-" + c + "-events-validator-ignored")
                        },
                        excluded: this.$form.attr("data-" + c + "-excluded"),
                        icon: {
                            valid: this.$form.attr("data-" + c + "-icon-valid") || this.$form.attr("data-" + c + "-feedbackicons-valid"),
                            invalid: this.$form.attr("data-" + c + "-icon-invalid") || this.$form.attr("data-" + c + "-feedbackicons-invalid"),
                            validating: this.$form.attr("data-" + c + "-icon-validating") || this.$form.attr("data-" + c + "-feedbackicons-validating"),
                            feedback: this.$form.attr("data-" + c + "-icon-feedback")
                        },
                        live: this.$form.attr("data-" + c + "-live"),
                        locale: this.$form.attr("data-" + c + "-locale"),
                        message: this.$form.attr("data-" + c + "-message"),
                        onPreValidate: this.$form.attr("data-" + c + "-onprevalidate"),
                        onError: this.$form.attr("data-" + c + "-onerror"),
                        onSuccess: this.$form.attr("data-" + c + "-onsuccess"),
                        row: {
                            selector: this.$form.attr("data-" + c + "-row-selector") || this.$form.attr("data-" + c + "-group"),
                            valid: this.$form.attr("data-" + c + "-row-valid"),
                            invalid: this.$form.attr("data-" + c + "-row-invalid"),
                            feedback: this.$form.attr("data-" + c + "-row-feedback")
                        },
                        threshold: this.$form.attr("data-" + c + "-threshold"),
                        trigger: this.$form.attr("data-" + c + "-trigger"),
                        verbose: this.$form.attr("data-" + c + "-verbose"),
                        fields: {}
                    };
                this.$form.attr("novalidate", "novalidate").addClass(this.options.elementClass).on("submit." + c, function(a) {
                    a.preventDefault(), b.validate()
                }).on("click." + c, this.options.button.selector, function() {
                    b.$submitButton = a(this), b._submitIfValid = !0
                }), (this.options.declarative === !0 || "true" === this.options.declarative) && this.$form.find("[name], [data-" + c + "-field]").each(function() {
                    var e = a(this),
                        f = e.attr("name") || e.attr("data-" + c + "-field"),
                        g = b._parseOptions(e);
                    g && (e.attr("data-" + c + "-field", f), d.fields[f] = a.extend({}, g, d.fields[f]))
                }), this.options = a.extend(!0, this.options, d), "string" == typeof this.options.err.parent && (this.options.err.parent = new RegExp(this.options.err.parent)), this.options.container && (this.options.err.container = this.options.container, delete this.options.container), this.options.feedbackIcons && (this.options.icon = a.extend(!0, this.options.icon, this.options.feedbackIcons), delete this.options.feedbackIcons), this.options.group && (this.options.row.selector = this.options.group, delete this.options.group), this.options.submitButtons && (this.options.button.selector = this.options.submitButtons, delete this.options.submitButtons), FormValidation.I18n[this.options.locale] || (this.options.locale = a.fn.formValidation.DEFAULT_OPTIONS.locale), (this.options.declarative === !0 || "true" === this.options.declarative) && (this.options = a.extend(!0, this.options, {
                    addOns: this._parseAddOnOptions()
                })), this.$hiddenButton = a("<button/>").attr("type", "submit").prependTo(this.$form).addClass("fv-hidden-submit").css({
                    display: "none",
                    width: 0,
                    height: 0
                }), this.$form.on("click." + this._namespace, '[type="submit"]', function(c) {
                    if (!c.isDefaultPrevented()) {
                        var d = a(c.target),
                            e = d.is('[type="submit"]') ? d.eq(0) : d.parent('[type="submit"]').eq(0);
                        !b.options.button.selector || e.is(b.options.button.selector) || e.is(b.$hiddenButton) || b.$form.off("submit." + b._namespace).submit()
                    }
                });
                for (var e in this.options.fields) this._initField(e);
                for (var f in this.options.addOns) "function" == typeof FormValidation.AddOn[f].init && FormValidation.AddOn[f].init(this, this.options.addOns[f]);
                this.$form.trigger(a.Event(this.options.events.formInit), {
                    bv: this,
                    fv: this,
                    options: this.options
                }), this.options.onPreValidate && this.$form.on(this.options.events.formPreValidate, function(a) {
                    FormValidation.Helper.call(b.options.onPreValidate, [a])
                }), this.options.onSuccess && this.$form.on(this.options.events.formSuccess, function(a) {
                    FormValidation.Helper.call(b.options.onSuccess, [a])
                }), this.options.onError && this.$form.on(this.options.events.formError, function(a) {
                    FormValidation.Helper.call(b.options.onError, [a])
                })
            },
            _initField: function(b) {
                var c = this._namespace,
                    d = a([]);
                switch (typeof b) {
                    case "object":
                        d = b, b = b.attr("data-" + c + "-field");
                        break;
                    case "string":
                        d = this.getFieldElements(b), d.attr("data-" + c + "-field", b)
                }
                if (0 !== d.length && null !== this.options.fields[b] && null !== this.options.fields[b].validators) {
                    var e, f, g = this.options.fields[b].validators;
                    for (e in g) f = g[e].alias || e, FormValidation.Validator[f] || delete this.options.fields[b].validators[e];
                    null === this.options.fields[b].enabled && (this.options.fields[b].enabled = !0);
                    for (var h = this, i = d.length, j = d.attr("type"), k = 1 === i || "radio" === j || "checkbox" === j, l = this._getFieldTrigger(d.eq(0)), m = a.map(l, function(a) {
                        return a + ".update." + c
                    }).join(" "), n = 0; i > n; n++) {
                        var o = d.eq(n),
                            p = this.options.fields[b].row || this.options.row.selector,
                            q = o.closest(p),
                            r = "function" == typeof(this.options.fields[b].container || this.options.fields[b].err || this.options.err.container) ? (this.options.fields[b].container || this.options.fields[b].err || this.options.err.container).call(this, o, this) : this.options.fields[b].container || this.options.fields[b].err || this.options.err.container,
                            s = r && "tooltip" !== r && "popover" !== r ? a(r) : this._getMessageContainer(o, p);
                        r && "tooltip" !== r && "popover" !== r && s.addClass(this.options.err.clazz), s.find("." + this.options.err.clazz.split(" ").join(".") + "[data-" + c + "-validator][data-" + c + '-for="' + b + '"]').remove(), q.find("i[data-" + c + '-icon-for="' + b + '"]').remove(), o.off(m).on(m, function() {
                            h.updateStatus(a(this), h.STATUS_NOT_VALIDATED)
                        }), o.data(c + ".messages", s);
                        for (e in g) o.data(c + ".result." + e, this.STATUS_NOT_VALIDATED), k && n !== i - 1 || a("<small/>").css("display", "none").addClass(this.options.err.clazz).attr("data-" + c + "-validator", e).attr("data-" + c + "-for", b).attr("data-" + c + "-result", this.STATUS_NOT_VALIDATED).html(this._getMessage(b, e)).appendTo(s), f = g[e].alias || e, "function" == typeof FormValidation.Validator[f].init && FormValidation.Validator[f].init(this, o, this.options.fields[b].validators[e], e);
                        if (this.options.fields[b].icon !== !1 && "false" !== this.options.fields[b].icon && this.options.icon && this.options.icon.valid && this.options.icon.invalid && this.options.icon.validating && (!k || n === i - 1)) {
                            q.addClass(this.options.row.feedback);
                            var t = a("<i/>").css("display", "none").addClass(this.options.icon.feedback).attr("data-" + c + "-icon-for", b).insertAfter(o);
                            (k ? d : o).data(c + ".icon", t), ("tooltip" === r || "popover" === r) && ((k ? d : o).on(this.options.events.fieldError, function() {
                                q.addClass("fv-has-tooltip")
                            }).on(this.options.events.fieldSuccess, function() {
                                q.removeClass("fv-has-tooltip")
                            }), o.off("focus.container." + c).on("focus.container." + c, function() {
                                h._showTooltip(a(this), r)
                            }).off("blur.container." + c).on("blur.container." + c, function() {
                                h._hideTooltip(a(this), r)
                            })), "string" == typeof this.options.fields[b].icon && "true" !== this.options.fields[b].icon ? t.appendTo(a(this.options.fields[b].icon)) : this._fixIcon(o, t)
                        }
                    }
                    d.on(this.options.events.fieldSuccess, function(a, b) {
                        var c = h.getOptions(b.field, null, "onSuccess");
                        c && FormValidation.Helper.call(c, [a, b])
                    }).on(this.options.events.fieldError, function(a, b) {
                        var c = h.getOptions(b.field, null, "onError");
                        c && FormValidation.Helper.call(c, [a, b])
                    }).on(this.options.events.fieldStatus, function(a, b) {
                        var c = h.getOptions(b.field, null, "onStatus");
                        c && FormValidation.Helper.call(c, [a, b])
                    }).on(this.options.events.validatorError, function(a, b) {
                        var c = h.getOptions(b.field, b.validator, "onError");
                        c && FormValidation.Helper.call(c, [a, b])
                    }).on(this.options.events.validatorIgnored, function(a, b) {
                        var c = h.getOptions(b.field, b.validator, "onIgnored");
                        c && FormValidation.Helper.call(c, [a, b])
                    }).on(this.options.events.validatorSuccess, function(a, b) {
                        var c = h.getOptions(b.field, b.validator, "onSuccess");
                        c && FormValidation.Helper.call(c, [a, b])
                    }), this.onLiveChange(d, "live", function() {
                        h._exceedThreshold(a(this)) && h.validateField(a(this))
                    }), d.trigger(a.Event(this.options.events.fieldInit), {
                        bv: this,
                        fv: this,
                        field: b,
                        element: d
                    })
                }
            },
            _isExcluded: function(b) {
                var c = this._namespace,
                    d = b.attr("data-" + c + "-excluded"),
                    e = b.attr("data-" + c + "-field") || b.attr("name");
                switch (!0) {
                    case !!e && this.options.fields && this.options.fields[e] && ("true" === this.options.fields[e].excluded || this.options.fields[e].excluded === !0):
                    case "true" === d:
                    case "" === d:
                        return !0;
                    case !!e && this.options.fields && this.options.fields[e] && ("false" === this.options.fields[e].excluded || this.options.fields[e].excluded === !1):
                    case "false" === d:
                        return !1;
                    case !!e && this.options.fields && this.options.fields[e] && "function" == typeof this.options.fields[e].excluded:
                        return this.options.fields[e].excluded.call(this, b, this);
                    case !!e && this.options.fields && this.options.fields[e] && "string" == typeof this.options.fields[e].excluded:
                    case d:
                        return FormValidation.Helper.call(this.options.fields[e].excluded, [b, this]);
                    default:
                        if (this.options.excluded) {
                            "string" == typeof this.options.excluded && (this.options.excluded = a.map(this.options.excluded.split(","), function(b) {
                                return a.trim(b)
                            }));
                            for (var f = this.options.excluded.length, g = 0; f > g; g++)
                                if ("string" == typeof this.options.excluded[g] && b.is(this.options.excluded[g]) || "function" == typeof this.options.excluded[g] && this.options.excluded[g].call(this, b, this) === !0) return !0
                        }
                        return !1
                }
            },
            _getFieldTrigger: function(a) {
                var b = this._namespace,
                    c = a.data(b + ".trigger");
                if (c) return c;
                var d = a.attr("type"),
                    e = a.attr("data-" + b + "-field"),
                    f = "radio" === d || "checkbox" === d || "file" === d || "SELECT" === a.get(0).tagName ? "change" : this._ieVersion >= 10 && a.attr("placeholder") ? "keyup" : this._changeEvent;
                return c = ((this.options.fields[e] ? this.options.fields[e].trigger : null) || this.options.trigger || f).split(" "), a.data(b + ".trigger", c), c
            },
            _getMessage: function(a, b) {
                if (!this.options.fields[a] || !this.options.fields[a].validators) return "";
                var c = this.options.fields[a].validators,
                    d = c[b] && c[b].alias ? c[b].alias : b;
                if (!FormValidation.Validator[d]) return "";
                switch (!0) {
                    case !!c[b].message:
                        return c[b].message;
                    case !!this.options.fields[a].message:
                        return this.options.fields[a].message;
                    case !!this.options.message:
                        return this.options.message;
                    case !!FormValidation.I18n[this.options.locale] && !!FormValidation.I18n[this.options.locale][d] && !!FormValidation.I18n[this.options.locale][d]["default"]:
                        return FormValidation.I18n[this.options.locale][d]["default"];
                    default:
                        return this.DEFAULT_MESSAGE
                }
            },
            _getMessageContainer: function(a, b) {
                if (!this.options.err.parent) throw new Error("The err.parent option is not defined");
                var c = a.parent();
                if (c.is(b)) return c;
                var d = c.attr("class");
                return d && this.options.err.parent.test(d) ? c : this._getMessageContainer(c, b)
            },
            _parseAddOnOptions: function() {
                var a = this._namespace,
                    b = this.$form.attr("data-" + a + "-addons"),
                    c = this.options.addOns || {};
                if (b) {
                    b = b.replace(/\s/g, "").split(",");
                    for (var d = 0; d < b.length; d++) c[b[d]] || (c[b[d]] = {})
                }
                var e, f, g, h;
                for (e in c)
                    if (FormValidation.AddOn[e]) {
                        if (f = FormValidation.AddOn[e].html5Attributes)
                            for (g in f) h = this.$form.attr("data-" + a + "-addons-" + e.toLowerCase() + "-" + g.toLowerCase()), h && (c[e][f[g]] = h)
                    } else delete c[e];
                return c
            },
            _parseOptions: function(b) {
                var c, d, e, f, g, h, i, j, k, l = this._namespace,
                    m = b.attr("name") || b.attr("data-" + l + "-field"),
                    n = {},
                    o = new RegExp("^data-" + l + "-([a-z]+)-alias$"),
                    p = a.extend({}, FormValidation.Validator);
                a.each(b.get(0).attributes, function(a, b) {
                    b.value && o.test(b.name) && (d = b.name.split("-")[2], p[b.value] && (p[d] = p[b.value], p[d].alias = b.value))
                });
                for (d in p)
                    if (c = p[d], e = "data-" + l + "-" + d.toLowerCase(), f = b.attr(e) + "", k = "function" == typeof c.enableByHtml5 ? c.enableByHtml5(b) : null, k && "false" !== f || k !== !0 && ("" === f || "true" === f || e === f.toLowerCase())) {
                        c.html5Attributes = a.extend({}, {
                            message: "message",
                            onerror: "onError",
                            onsuccess: "onSuccess",
                            transformer: "transformer"
                        }, c.html5Attributes), n[d] = a.extend({}, k === !0 ? {} : k, n[d]), c.alias && (n[d].alias = c.alias);
                        for (j in c.html5Attributes) g = c.html5Attributes[j], h = "data-" + l + "-" + d.toLowerCase() + "-" + j, i = b.attr(h), i && ("true" === i || h === i.toLowerCase() ? i = !0 : "false" === i && (i = !1), n[d][g] = i)
                    }
                var q = {
                        autoFocus: b.attr("data-" + l + "-autofocus"),
                        err: b.attr("data-" + l + "-err-container") || b.attr("data-" + l + "-container"),
                        enabled: b.attr("data-" + l + "-enabled"),
                        excluded: b.attr("data-" + l + "-excluded"),
                        icon: b.attr("data-" + l + "-icon") || b.attr("data-" + l + "-feedbackicons") || (this.options.fields && this.options.fields[m] ? this.options.fields[m].feedbackIcons : null),
                        message: b.attr("data-" + l + "-message"),
                        onError: b.attr("data-" + l + "-onerror"),
                        onStatus: b.attr("data-" + l + "-onstatus"),
                        onSuccess: b.attr("data-" + l + "-onsuccess"),
                        row: b.attr("data-" + l + "-row") || b.attr("data-" + l + "-group") || (this.options.fields && this.options.fields[m] ? this.options.fields[m].group : null),
                        selector: b.attr("data-" + l + "-selector"),
                        threshold: b.attr("data-" + l + "-threshold"),
                        transformer: b.attr("data-" + l + "-transformer"),
                        trigger: b.attr("data-" + l + "-trigger"),
                        verbose: b.attr("data-" + l + "-verbose"),
                        validators: n
                    },
                    r = a.isEmptyObject(q),
                    s = a.isEmptyObject(n);
                return !s || !r && this.options.fields && this.options.fields[m] ? q : null
            },
            _submit: function() {
                var b = this.isValid();
                if (null !== b) {
                    var c = b ? this.options.events.formSuccess : this.options.events.formError,
                        d = a.Event(c);
                    this.$form.trigger(d), this.$submitButton && (b ? this._onSuccess(d) : this._onError(d))
                }
            },
            _onError: function(b) {
                if (!b.isDefaultPrevented()) {
                    if ("submitted" === this.options.live) {
                        this.options.live = "enabled";
                        var c = this;
                        for (var d in this.options.fields) ! function(b) {
                            var d = c.getFieldElements(b);
                            d.length && c.onLiveChange(d, "live", function() {
                                c._exceedThreshold(a(this)) && c.validateField(a(this))
                            })
                        }(d)
                    }
                    for (var e = this._namespace, f = 0; f < this.$invalidFields.length; f++) {
                        var g = this.$invalidFields.eq(f),
                            h = this.isOptionEnabled(g.attr("data-" + e + "-field"), "autoFocus");
                        if (h) {
                            g.focus();
                            break
                        }
                    }
                }
            },
            _onFieldValidated: function(b, c) {
                var d = this._namespace,
                    e = b.attr("data-" + d + "-field"),
                    f = this.options.fields[e].validators,
                    g = {},
                    h = 0,
                    i = {
                        bv: this,
                        fv: this,
                        field: e,
                        element: b,
                        validator: c,
                        result: b.data(d + ".response." + c)
                    };
                if (c) switch (b.data(d + ".result." + c)) {
                    case this.STATUS_INVALID:
                        b.trigger(a.Event(this.options.events.validatorError), i);
                        break;
                    case this.STATUS_VALID:
                        b.trigger(a.Event(this.options.events.validatorSuccess), i);
                        break;
                    case this.STATUS_IGNORED:
                        b.trigger(a.Event(this.options.events.validatorIgnored), i)
                }
                g[this.STATUS_NOT_VALIDATED] = 0, g[this.STATUS_VALIDATING] = 0, g[this.STATUS_INVALID] = 0, g[this.STATUS_VALID] = 0, g[this.STATUS_IGNORED] = 0;
                for (var j in f)
                    if (f[j].enabled !== !1) {
                        h++;
                        var k = b.data(d + ".result." + j);
                        k && g[k]++
                    }
                g[this.STATUS_VALID] + g[this.STATUS_IGNORED] === h ? (this.$invalidFields = this.$invalidFields.not(b), b.trigger(a.Event(this.options.events.fieldSuccess), i)) : (0 === g[this.STATUS_NOT_VALIDATED] || !this.isOptionEnabled(e, "verbose")) && 0 === g[this.STATUS_VALIDATING] && g[this.STATUS_INVALID] > 0 && (this.$invalidFields = this.$invalidFields.add(b), b.trigger(a.Event(this.options.events.fieldError), i))
            },
            _onSuccess: function(a) {
                a.isDefaultPrevented() || this.disableSubmitButtons(!0).defaultSubmit()
            },
            _fixIcon: function(a, b) {},
            _createTooltip: function(a, b, c) {},
            _destroyTooltip: function(a, b) {},
            _hideTooltip: function(a, b) {},
            _showTooltip: function(a, b) {},
            defaultSubmit: function() {
                var b = this._namespace;
                this.$submitButton && a("<input/>").attr({
                    type: "hidden",
                    name: this.$submitButton.attr("name")
                }).attr("data-" + b + "-submit-hidden", "").val(this.$submitButton.val()).appendTo(this.$form), this.$form.off("submit." + b).submit()
            },
            disableSubmitButtons: function(a) {
                return a ? "disabled" !== this.options.live && this.$form.find(this.options.button.selector).attr("disabled", "disabled").addClass(this.options.button.disabled) : this.$form.find(this.options.button.selector).removeAttr("disabled").removeClass(this.options.button.disabled), this
            },
            getFieldElements: function(b) {
                if (!this._cacheFields[b])
                    if (this.options.fields[b] && this.options.fields[b].selector) {
                        var c = this.$form.find(this.options.fields[b].selector);
                        this._cacheFields[b] = c.length ? c : a(this.options.fields[b].selector)
                    } else this._cacheFields[b] = this.$form.find('[name="' + b + '"]');
                return this._cacheFields[b]
            },
            getFieldValue: function(a, b) {
                var c, d = this._namespace;
                if ("string" == typeof a) {
                    if (c = this.getFieldElements(a), 0 === c.length) return null
                } else c = a, a = c.attr("data-" + d + "-field");
                if (!a || !this.options.fields[a]) return c.val();
                var e = (this.options.fields[a].validators && this.options.fields[a].validators[b] ? this.options.fields[a].validators[b].transformer : null) || this.options.fields[a].transformer;
                return e ? FormValidation.Helper.call(e, [c, b, this]) : c.val()
            },
            getNamespace: function() {
                return this._namespace
            },
            getOptions: function(a, b, c) {
                var d = this._namespace;
                if (!a) return c ? this.options[c] : this.options;
                if ("object" == typeof a && (a = a.attr("data-" + d + "-field")), !this.options.fields[a]) return null;
                var e = this.options.fields[a];
                return b ? e.validators && e.validators[b] ? c ? e.validators[b][c] : e.validators[b] : null : c ? e[c] : e
            },
            getStatus: function(a, b) {
                var c = this._namespace;
                switch (typeof a) {
                    case "object":
                        return a.data(c + ".result." + b);
                    case "string":
                    default:
                        return this.getFieldElements(a).eq(0).data(c + ".result." + b)
                }
            },
            isOptionEnabled: function(a, b) {
                return !this.options.fields[a] || "true" !== this.options.fields[a][b] && this.options.fields[a][b] !== !0 ? !this.options.fields[a] || "false" !== this.options.fields[a][b] && this.options.fields[a][b] !== !1 ? "true" === this.options[b] || this.options[b] === !0 : !1 : !0
            },
            isValid: function() {
                for (var a in this.options.fields) {
                    var b = this.isValidField(a);
                    if (null === b) return null;
                    if (b === !1) return !1
                }
                return !0
            },
            isValidContainer: function(b) {
                var c = this,
                    d = this._namespace,
                    e = [],
                    f = "string" == typeof b ? a(b) : b;
                if (0 === f.length) return !0;
                f.find("[data-" + d + "-field]").each(function() {
                    var b = a(this);
                    c._isExcluded(b) || e.push(b)
                });
                for (var g = e.length, h = 0; g > h; h++) {
                    var i = e[h],
                        j = i.attr("data-" + d + "-field"),
                        k = i.data(d + ".messages").find("." + this.options.err.clazz.split(" ").join(".") + "[data-" + d + "-validator][data-" + d + '-for="' + j + '"]');
                    if (!this.options.fields || !this.options.fields[j] || "false" !== this.options.fields[j].enabled && this.options.fields[j].enabled !== !1) {
                        if (k.filter("[data-" + d + '-result="' + this.STATUS_INVALID + '"]').length > 0) return !1;
                        if (k.filter("[data-" + d + '-result="' + this.STATUS_NOT_VALIDATED + '"]').length > 0 || k.filter("[data-" + d + '-result="' + this.STATUS_VALIDATING + '"]').length > 0) return null
                    }
                }
                return !0
            },
            isValidField: function(b) {
                var c = this._namespace,
                    d = a([]);
                switch (typeof b) {
                    case "object":
                        d = b, b = b.attr("data-" + c + "-field");
                        break;
                    case "string":
                        d = this.getFieldElements(b)
                }
                if (0 === d.length || !this.options.fields[b] || "false" === this.options.fields[b].enabled || this.options.fields[b].enabled === !1) return !0;
                for (var e, f, g, h = d.attr("type"), i = "radio" === h || "checkbox" === h ? 1 : d.length, j = 0; i > j; j++)
                    if (e = d.eq(j), !this._isExcluded(e))
                        for (f in this.options.fields[b].validators)
                            if (this.options.fields[b].validators[f].enabled !== !1) {
                                if (g = e.data(c + ".result." + f), g === this.STATUS_VALIDATING || g === this.STATUS_NOT_VALIDATED) return null;
                                if (g === this.STATUS_INVALID) return !1
                            }
                return !0
            },
            offLiveChange: function(b, c) {
                if (null === b || 0 === b.length) return this;
                var d = this._namespace,
                    e = this._getFieldTrigger(b.eq(0)),
                    f = a.map(e, function(a) {
                        return a + "." + c + "." + d
                    }).join(" ");
                return b.off(f), this
            },
            onLiveChange: function(b, c, d) {
                if (null === b || 0 === b.length) return this;
                var e = this._namespace,
                    f = this._getFieldTrigger(b.eq(0)),
                    g = a.map(f, function(a) {
                        return a + "." + c + "." + e
                    }).join(" ");
                switch (this.options.live) {
                    case "submitted":
                        break;
                    case "disabled":
                        b.off(g);
                        break;
                    case "enabled":
                    default:
                        b.off(g).on(g, function(a) {
                            d.apply(this, arguments)
                        })
                }
                return this
            },
            updateMessage: function(b, c, d) {
                var e = this,
                    f = this._namespace,
                    g = a([]);
                switch (typeof b) {
                    case "object":
                        g = b, b = b.attr("data-" + f + "-field");
                        break;
                    case "string":
                        g = this.getFieldElements(b)
                }
                return g.each(function() {
                    a(this).data(f + ".messages").find("." + e.options.err.clazz + "[data-" + f + '-validator="' + c + '"][data-' + f + '-for="' + b + '"]').html(d)
                }), this
            },
            updateStatus: function(b, c, d) {
                var e = this._namespace,
                    f = a([]);
                switch (typeof b) {
                    case "object":
                        f = b, b = b.attr("data-" + e + "-field");
                        break;
                    case "string":
                        f = this.getFieldElements(b)
                }
                if (!b || !this.options.fields[b]) return this;
                c === this.STATUS_NOT_VALIDATED && (this._submitIfValid = !1);
                for (var g = this, h = f.attr("type"), i = this.options.fields[b].row || this.options.row.selector, j = "radio" === h || "checkbox" === h ? 1 : f.length, k = 0; j > k; k++) {
                    var l = f.eq(k);
                    if (!this._isExcluded(l)) {
                        var m, n, o = l.closest(i),
                            p = l.data(e + ".messages"),
                            q = p.find("." + this.options.err.clazz.split(" ").join(".") + "[data-" + e + "-validator][data-" + e + '-for="' + b + '"]'),
                            r = d ? q.filter("[data-" + e + '-validator="' + d + '"]') : q,
                            s = l.data(e + ".icon"),
                            t = "function" == typeof(this.options.fields[b].container || this.options.fields[b].err || this.options.err.container) ? (this.options.fields[b].container || this.options.fields[b].err || this.options.err.container).call(this, l, this) : this.options.fields[b].container || this.options.fields[b].err || this.options.err.container,
                            u = null;
                        if (d) l.data(e + ".result." + d, c);
                        else
                            for (var v in this.options.fields[b].validators) l.data(e + ".result." + v, c);
                        switch (r.attr("data-" + e + "-result", c), c) {
                            case this.STATUS_VALIDATING:
                                u = null, this.disableSubmitButtons(!0), l.removeClass(this.options.control.valid).removeClass(this.options.control.invalid), o.removeClass(this.options.row.valid).removeClass(this.options.row.invalid), s && s.removeClass(this.options.icon.valid).removeClass(this.options.icon.invalid).addClass(this.options.icon.validating).show();
                                break;
                            case this.STATUS_INVALID:
                                u = !1, this.disableSubmitButtons(!0), l.removeClass(this.options.control.valid).addClass(this.options.control.invalid), o.removeClass(this.options.row.valid).addClass(this.options.row.invalid), s && s.removeClass(this.options.icon.valid).removeClass(this.options.icon.validating).addClass(this.options.icon.invalid).show();
                                break;
                            case this.STATUS_IGNORED:
                            case this.STATUS_VALID:
                                m = q.filter("[data-" + e + '-result="' + this.STATUS_VALIDATING + '"]').length > 0, n = q.filter("[data-" + e + '-result="' + this.STATUS_NOT_VALIDATED + '"]').length > 0;
                                var w = q.filter("[data-" + e + '-result="' + this.STATUS_IGNORED + '"]').length;
                                u = m || n ? null : q.filter("[data-" + e + '-result="' + this.STATUS_VALID + '"]').length + w === q.length, l.removeClass(this.options.control.valid).removeClass(this.options.control.invalid), u === !0 ? (this.disableSubmitButtons(this.isValid() === !1), c === this.STATUS_VALID && l.addClass(this.options.control.valid)) : u === !1 && (this.disableSubmitButtons(!0), c === this.STATUS_VALID && l.addClass(this.options.control.invalid)), s && (s.removeClass(this.options.icon.invalid).removeClass(this.options.icon.validating).removeClass(this.options.icon.valid), (c === this.STATUS_VALID || w !== q.length) && s.addClass(m ? this.options.icon.validating : null === u ? "" : u ? this.options.icon.valid : this.options.icon.invalid).show());
                                var x = this.isValidContainer(o);
                                null !== x && (o.removeClass(this.options.row.valid).removeClass(this.options.row.invalid), (c === this.STATUS_VALID || w !== q.length) && o.addClass(x ? this.options.row.valid : this.options.row.invalid));
                                break;
                            case this.STATUS_NOT_VALIDATED:
                            default:
                                u = null, this.disableSubmitButtons(!1), l.removeClass(this.options.control.valid).removeClass(this.options.control.invalid), o.removeClass(this.options.row.valid).removeClass(this.options.row.invalid), s && s.removeClass(this.options.icon.valid).removeClass(this.options.icon.invalid).removeClass(this.options.icon.validating).hide()
                        }!s || "tooltip" !== t && "popover" !== t ? c === this.STATUS_INVALID ? r.show() : r.hide() : u === !1 ? this._createTooltip(l, q.filter("[data-" + e + '-result="' + g.STATUS_INVALID + '"]').eq(0).html(), t) : this._destroyTooltip(l, t), l.trigger(a.Event(this.options.events.fieldStatus), {
                            bv: this,
                            fv: this,
                            field: b,
                            element: l,
                            status: c
                        }), this._onFieldValidated(l, d)
                    }
                }
                return this
            },
            validate: function() {
                if (a.isEmptyObject(this.options.fields)) return this._submit(), this;
                this.$form.trigger(a.Event(this.options.events.formPreValidate)), this.disableSubmitButtons(!0), this._submitIfValid = !1;
                for (var b in this.options.fields) this.validateField(b);
                return this._submit(), this._submitIfValid = !0, this
            },
            validateField: function(b) {
                var c = this._namespace,
                    d = a([]);
                switch (typeof b) {
                    case "object":
                        d = b, b = b.attr("data-" + c + "-field");
                        break;
                    case "string":
                        d = this.getFieldElements(b)
                }
                if (0 === d.length || !this.options.fields[b] || "false" === this.options.fields[b].enabled || this.options.fields[b].enabled === !1) return this;
                for (var e, f, g, h = this, i = d.attr("type"), j = "radio" === i || "checkbox" === i ? 1 : d.length, k = "radio" === i || "checkbox" === i, l = this.options.fields[b].validators, m = this.isOptionEnabled(b, "verbose"), n = 0; j > n; n++) {
                    var o = d.eq(n);
                    if (!this._isExcluded(o)) {
                        var p = !1;
                        for (e in l) {
                            if (o.data(c + ".dfs." + e) && o.data(c + ".dfs." + e).reject(), p) break;
                            var q = o.data(c + ".result." + e);
                            if (q !== this.STATUS_VALID && q !== this.STATUS_INVALID)
                                if (l[e].enabled !== !1)
                                    if (o.data(c + ".result." + e, this.STATUS_VALIDATING), f = l[e].alias || e, g = FormValidation.Validator[f].validate(this, o, l[e], e), "object" == typeof g && g.resolve) this.updateStatus(k ? b : o, this.STATUS_VALIDATING, e), o.data(c + ".dfs." + e, g), g.done(function(a, b, d) {
                                        a.removeData(c + ".dfs." + b).data(c + ".response." + b, d), d.message && h.updateMessage(a, b, d.message), h.updateStatus(k ? a.attr("data-" + c + "-field") : a, d.valid === !0 ? h.STATUS_VALID : d.valid === !1 ? h.STATUS_INVALID : h.STATUS_IGNORED, b), d.valid && h._submitIfValid === !0 ? h._submit() : d.valid !== !1 || m || (p = !0)
                                    });
                                    else if ("object" == typeof g && void 0 !== g.valid) {
                                        if (o.data(c + ".response." + e, g), g.message && this.updateMessage(k ? b : o, e, g.message), this.updateStatus(k ? b : o, g.valid === !0 ? this.STATUS_VALID : g.valid === !1 ? this.STATUS_INVALID : this.STATUS_IGNORED, e), g.valid === !1 && !m) break
                                    } else if ("boolean" == typeof g) {
                                        if (o.data(c + ".response." + e, g), this.updateStatus(k ? b : o, g ? this.STATUS_VALID : this.STATUS_INVALID, e), !g && !m) break
                                    } else null === g && (o.data(c + ".response." + e, g), this.updateStatus(k ? b : o, this.STATUS_IGNORED, e));
                                else this.updateStatus(k ? b : o, this.STATUS_IGNORED, e);
                            else this._onFieldValidated(o, e)
                        }
                    }
                }
                return this
            },
            addField: function(b, c) {
                var d = this._namespace,
                    e = a([]);
                switch (typeof b) {
                    case "object":
                        e = b, b = b.attr("data-" + d + "-field") || b.attr("name");
                        break;
                    case "string":
                        delete this._cacheFields[b], e = this.getFieldElements(b)
                }
                e.attr("data-" + d + "-field", b);
                for (var f = e.attr("type"), g = "radio" === f || "checkbox" === f ? 1 : e.length, h = 0; g > h; h++) {
                    var i = e.eq(h),
                        j = this._parseOptions(i);
                    j = null === j ? c : a.extend(!0, j, c), this.options.fields[b] = a.extend(!0, this.options.fields[b], j), this._cacheFields[b] = this._cacheFields[b] ? this._cacheFields[b].add(i) : i, this._initField("checkbox" === f || "radio" === f ? b : i)
                }
                return this.disableSubmitButtons(!1), this.$form.trigger(a.Event(this.options.events.fieldAdded), {
                    field: b,
                    element: e,
                    options: this.options.fields[b]
                }), this
            },
            destroy: function() {
                var a, b, c, d, e, f, g, h, i = this._namespace;
                for (b in this.options.fields)
                    for (c = this.getFieldElements(b), a = 0; a < c.length; a++) {
                        d = c.eq(a);
                        for (e in this.options.fields[b].validators) d.data(i + ".dfs." + e) && d.data(i + ".dfs." + e).reject(), d.removeData(i + ".result." + e).removeData(i + ".response." + e).removeData(i + ".dfs." + e), h = this.options.fields[b].validators[e].alias || e, "function" == typeof FormValidation.Validator[h].destroy && FormValidation.Validator[h].destroy(this, d, this.options.fields[b].validators[e], e)
                    }
                for (b in this.options.fields)
                    for (c = this.getFieldElements(b), g = this.options.fields[b].row || this.options.row.selector, a = 0; a < c.length; a++) {
                        d = c.eq(a), d.data(i + ".messages").find("." + this.options.err.clazz.split(" ").join(".") + "[data-" + i + "-validator][data-" + i + '-for="' + b + '"]').remove().end().end().removeData(i + ".messages").closest(g).removeClass(this.options.row.valid).removeClass(this.options.row.invalid).removeClass(this.options.row.feedback).end().off("." + i).removeAttr("data-" + i + "-field");
                        var j = "function" == typeof(this.options.fields[b].container || this.options.fields[b].err || this.options.err.container) ? (this.options.fields[b].container || this.options.fields[b].err || this.options.err.container).call(this, d, this) : this.options.fields[b].container || this.options.fields[b].err || this.options.err.container;
                        ("tooltip" === j || "popover" === j) && this._destroyTooltip(d, j), f = d.data(i + ".icon"), f && f.remove(), d.removeData(i + ".icon").removeData(i + ".trigger")
                    }
                for (var k in this.options.addOns) "function" == typeof FormValidation.AddOn[k].destroy && FormValidation.AddOn[k].destroy(this, this.options.addOns[k]);
                this.disableSubmitButtons(!1), this.$hiddenButton.remove(), this.$form.removeClass(this.options.elementClass).off("." + i).removeData("bootstrapValidator").removeData("formValidation").find("[data-" + i + "-submit-hidden]").remove().end().find('[type="submit"]').off("click." + i)
            },
            enableFieldValidators: function(a, b, c) {
                var d = this.options.fields[a].validators;
                if (c && d && d[c] && d[c].enabled !== b) this.options.fields[a].validators[c].enabled = b, this.updateStatus(a, this.STATUS_NOT_VALIDATED, c);
                else if (!c && this.options.fields[a].enabled !== b) {
                    this.options.fields[a].enabled = b;
                    for (var e in d) this.enableFieldValidators(a, b, e)
                }
                return this
            },
            getDynamicOption: function(a, b) {
                var c = "string" == typeof a ? this.getFieldElements(a) : a,
                    d = c.val();
                if ("function" == typeof b) return FormValidation.Helper.call(b, [d, this, c]);
                if ("string" == typeof b) {
                    var e = this.getFieldElements(b);
                    return e.length ? e.val() : FormValidation.Helper.call(b, [d, this, c]) || b
                }
                return null
            },
            getForm: function() {
                return this.$form
            },
            getInvalidFields: function() {
                return this.$invalidFields
            },
            getLocale: function() {
                return this.options.locale
            },
            getMessages: function(b, c) {
                var d = this,
                    e = this._namespace,
                    f = [],
                    g = a([]);
                switch (!0) {
                    case b && "object" == typeof b:
                        g = b;
                        break;
                    case b && "string" == typeof b:
                        var h = this.getFieldElements(b);
                        if (h.length > 0) {
                            var i = h.attr("type");
                            g = "radio" === i || "checkbox" === i ? h.eq(0) : h
                        }
                        break;
                    default:
                        g = this.$invalidFields
                }
                var j = c ? "[data-" + e + '-validator="' + c + '"]' : "";
                return g.each(function() {
                    f = f.concat(a(this).data(e + ".messages").find("." + d.options.err.clazz + "[data-" + e + '-for="' + a(this).attr("data-" + e + "-field") + '"][data-' + e + '-result="' + d.STATUS_INVALID + '"]' + j).map(function() {
                        var b = a(this).attr("data-" + e + "-validator"),
                            c = a(this).attr("data-" + e + "-for");
                        return d.options.fields[c].validators[b].enabled === !1 ? "" : a(this).html()
                    }).get())
                }), f
            },
            getSubmitButton: function() {
                return this.$submitButton
            },
            removeField: function(b) {
                var c = this._namespace,
                    d = a([]);
                switch (typeof b) {
                    case "object":
                        d = b, b = b.attr("data-" + c + "-field") || b.attr("name"), d.attr("data-" + c + "-field", b);
                        break;
                    case "string":
                        d = this.getFieldElements(b)
                }
                if (0 === d.length) return this;
                for (var e = d.attr("type"), f = "radio" === e || "checkbox" === e ? 1 : d.length, g = 0; f > g; g++) {
                    var h = d.eq(g);
                    this.$invalidFields = this.$invalidFields.not(h), this._cacheFields[b] = this._cacheFields[b].not(h)
                }
                return this._cacheFields[b] && 0 !== this._cacheFields[b].length || delete this.options.fields[b], ("checkbox" === e || "radio" === e) && this._initField(b), this.disableSubmitButtons(!1), this.$form.trigger(a.Event(this.options.events.fieldRemoved), {
                    field: b,
                    element: d
                }), this
            },
            resetField: function(b, c) {
                var d = this._namespace,
                    e = a([]);
                switch (typeof b) {
                    case "object":
                        e = b, b = b.attr("data-" + d + "-field");
                        break;
                    case "string":
                        e = this.getFieldElements(b)
                }
                var f = e.length;
                if (this.options.fields[b])
                    for (var g = 0; f > g; g++)
                        for (var h in this.options.fields[b].validators) e.eq(g).removeData(d + ".dfs." + h);
                if (c) {
                    var i = e.attr("type");
                    "radio" === i || "checkbox" === i ? e.prop("checked", !1).removeAttr("selected") : e.val("")
                }
                return this.updateStatus(b, this.STATUS_NOT_VALIDATED), this
            },
            resetForm: function(b) {
                for (var c in this.options.fields) this.resetField(c, b);
                return this.$invalidFields = a([]), this.$submitButton = null, this.disableSubmitButtons(!1), this
            },
            revalidateField: function(a) {
                return this.updateStatus(a, this.STATUS_NOT_VALIDATED).validateField(a), this
            },
            setLocale: function(b) {
                return this.options.locale = b, this.$form.trigger(a.Event(this.options.events.localeChanged), {
                    locale: b,
                    bv: this,
                    fv: this
                }), this
            },
            updateOption: function(a, b, c, d) {
                var e = this._namespace;
                return "object" == typeof a && (a = a.attr("data-" + e + "-field")), this.options.fields[a] && this.options.fields[a].validators[b] && (this.options.fields[a].validators[b][c] = d, this.updateStatus(a, this.STATUS_NOT_VALIDATED, b)), this
            },
            validateContainer: function(b) {
                var c = this,
                    d = this._namespace,
                    e = [],
                    f = "string" == typeof b ? a(b) : b;
                if (0 === f.length) return this;
                f.find("[data-" + d + "-field]").each(function() {
                    var b = a(this);
                    c._isExcluded(b) || e.push(b)
                });
                for (var g = e.length, h = 0; g > h; h++) this.validateField(e[h]);
                return this
            }
        }, a.fn.formValidation = function(b) {
            var c = arguments;
            return this.each(function() {
                var d = a(this),
                    e = d.data("formValidation"),
                    f = "object" == typeof b && b;
                if (!e) {
                    var g = (f.framework || d.attr("data-fv-framework") || "bootstrap").toLowerCase(),
                        h = g.substr(0, 1).toUpperCase() + g.substr(1);
                    if ("undefined" == typeof FormValidation.Framework[h]) throw new Error("The class FormValidation.Framework." + h + " is not implemented");
                    e = new FormValidation.Framework[h](this, f), d.addClass("fv-form-" + g).data("formValidation", e)
                }
                "string" == typeof b && e[b].apply(e, Array.prototype.slice.call(c, 1))
            })
        }, a.fn.formValidation.Constructor = FormValidation.Base, a.fn.formValidation.DEFAULT_MESSAGE = "This value is not valid", a.fn.formValidation.DEFAULT_OPTIONS = {
            autoFocus: !0,
            declarative: !0,
            elementClass: "fv-form",
            events: {
                formInit: "init.form.fv",
                formPreValidate: "prevalidate.form.fv",
                formError: "err.form.fv",
                formSuccess: "success.form.fv",
                fieldAdded: "added.field.fv",
                fieldRemoved: "removed.field.fv",
                fieldInit: "init.field.fv",
                fieldError: "err.field.fv",
                fieldSuccess: "success.field.fv",
                fieldStatus: "status.field.fv",
                localeChanged: "changed.locale.fv",
                validatorError: "err.validator.fv",
                validatorSuccess: "success.validator.fv",
                validatorIgnored: "ignored.validator.fv"
            },
            excluded: [":disabled", ":hidden", ":not(:visible)"],
            fields: null,
            live: "enabled",
            locale: "en_US",
            message: null,
            threshold: null,
            verbose: !0,
            button: {
                selector: '[type="submit"]:not([formnovalidate])',
                disabled: ""
            },
            control: {
                valid: "",
                invalid: ""
            },
            err: {
                clazz: "",
                container: null,
                parent: null
            },
            icon: {
                valid: null,
                invalid: null,
                validating: null,
                feedback: ""
            },
            row: {
                selector: null,
                valid: "",
                invalid: "",
                feedback: ""
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.Helper = {
            call: function(a, b) {
                if ("function" == typeof a) return a.apply(this, b);
                if ("string" == typeof a) {
                    "()" === a.substring(a.length - 2) && (a = a.substring(0, a.length - 2));
                    for (var c = a.split("."), d = c.pop(), e = window, f = 0; f < c.length; f++) e = e[c[f]];
                    return "undefined" == typeof e[d] ? null : e[d].apply(this, b)
                }
            },
            date: function(a, b, c, d) {
                if (isNaN(a) || isNaN(b) || isNaN(c)) return !1;
                if (c.length > 2 || b.length > 2 || a.length > 4) return !1;
                if (c = parseInt(c, 10), b = parseInt(b, 10), a = parseInt(a, 10), 1e3 > a || a > 9999 || 0 >= b || b > 12) return !1;
                var e = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
                if ((a % 400 === 0 || a % 100 !== 0 && a % 4 === 0) && (e[1] = 29), 0 >= c || c > e[b - 1]) return !1;
                if (d === !0) {
                    var f = new Date,
                        g = f.getFullYear(),
                        h = f.getMonth(),
                        i = f.getDate();
                    return g > a || a === g && h > b - 1 || a === g && b - 1 === h && i > c
                }
                return !0
            },
            format: function(b, c) {
                a.isArray(c) || (c = [c]);
                for (var d in c) b = b.replace("%s", c[d]);
                return b
            },
            luhn: function(a) {
                for (var b = a.length, c = 0, d = [
                    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
                    [0, 2, 4, 6, 8, 1, 3, 5, 7, 9]
                ], e = 0; b--;) e += d[c][parseInt(a.charAt(b), 10)], c ^= 1;
                return e % 10 === 0 && e > 0
            },
            mod11And10: function(a) {
                for (var b = 5, c = a.length, d = 0; c > d; d++) b = (2 * (b || 10) % 11 + parseInt(a.charAt(d), 10)) % 10;
                return 1 === b
            },
            mod37And36: function(a, b) {
                b = b || "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                for (var c = b.length, d = a.length, e = Math.floor(c / 2), f = 0; d > f; f++) e = (2 * (e || c) % (c + 1) + b.indexOf(a.charAt(f))) % c;
                return 1 === e
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                base64: {
                    "default": "Please enter a valid base 64 encoded"
                }
            }
        }), FormValidation.Validator.base64 = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                return "" === e ? !0 : /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$/.test(e)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                between: {
                    "default": "Please enter a value between %s and %s",
                    notInclusive: "Please enter a value between %s and %s strictly"
                }
            }
        }), FormValidation.Validator.between = {
            html5Attributes: {
                message: "message",
                min: "min",
                max: "max",
                inclusive: "inclusive"
            },
            enableByHtml5: function(a) {
                return "range" === a.attr("type") ? {
                    min: a.attr("min"),
                    max: a.attr("max")
                } : !1
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                f = this._format(f);
                var g = b.getLocale(),
                    h = a.isNumeric(d.min) ? d.min : b.getDynamicOption(c, d.min),
                    i = a.isNumeric(d.max) ? d.max : b.getDynamicOption(c, d.max),
                    j = this._format(h),
                    k = this._format(i);
                return d.inclusive === !0 || void 0 === d.inclusive ? {
                    valid: a.isNumeric(f) && parseFloat(f) >= j && parseFloat(f) <= k,
                    message: FormValidation.Helper.format(d.message || FormValidation.I18n[g].between["default"], [h, i])
                } : {
                    valid: a.isNumeric(f) && parseFloat(f) > j && parseFloat(f) < k,
                    message: FormValidation.Helper.format(d.message || FormValidation.I18n[g].between.notInclusive, [h, i])
                }
            },
            _format: function(a) {
                return (a + "").replace(",", ".")
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                bic: {
                    "default": "Please enter a valid BIC number"
                }
            }
        }), FormValidation.Validator.bic = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                return "" === e ? !0 : /^[a-zA-Z]{6}[a-zA-Z0-9]{2}([a-zA-Z0-9]{3})?$/.test(e)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.Validator.blank = {
            validate: function(a, b, c, d) {
                return !0
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                callback: {
                    "default": "Please enter a valid value"
                }
            }
        }), FormValidation.Validator.callback = {
            html5Attributes: {
                message: "message",
                callback: "callback"
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e),
                    g = new a.Deferred,
                    h = {
                        valid: !0
                    };
                if (d.callback) {
                    var i = FormValidation.Helper.call(d.callback, [f, b, c]);
                    h = "boolean" == typeof i || null === i ? {
                        valid: i
                    } : i
                }
                return g.resolve(c, e, h), g
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                choice: {
                    "default": "Please enter a valid value",
                    less: "Please choose %s options at minimum",
                    more: "Please choose %s options at maximum",
                    between: "Please choose %s - %s options"
                }
            }
        }), FormValidation.Validator.choice = {
            html5Attributes: {
                message: "message",
                min: "min",
                max: "max"
            },
            validate: function(b, c, d, e) {
                var f = b.getLocale(),
                    g = b.getNamespace(),
                    h = c.is("select") ? b.getFieldElements(c.attr("data-" + g + "-field")).find("option").filter(":selected").length : b.getFieldElements(c.attr("data-" + g + "-field")).filter(":checked").length,
                    i = d.min ? a.isNumeric(d.min) ? d.min : b.getDynamicOption(c, d.min) : null,
                    j = d.max ? a.isNumeric(d.max) ? d.max : b.getDynamicOption(c, d.max) : null,
                    k = !0,
                    l = d.message || FormValidation.I18n[f].choice["default"];
                switch ((i && h < parseInt(i, 10) || j && h > parseInt(j, 10)) && (k = !1), !0) {
                    case !!i && !!j:
                        l = FormValidation.Helper.format(d.message || FormValidation.I18n[f].choice.between, [parseInt(i, 10), parseInt(j, 10)]);
                        break;
                    case !!i:
                        l = FormValidation.Helper.format(d.message || FormValidation.I18n[f].choice.less, parseInt(i, 10));
                        break;
                    case !!j:
                        l = FormValidation.Helper.format(d.message || FormValidation.I18n[f].choice.more, parseInt(j, 10))
                }
                return {
                    valid: k,
                    message: l
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                color: {
                    "default": "Please enter a valid color"
                }
            }
        }), FormValidation.Validator.color = {
            html5Attributes: {
                message: "message",
                type: "type"
            },
            enableByHtml5: function(a) {
                return "color" === a.attr("type")
            },
            SUPPORTED_TYPES: ["hex", "rgb", "rgba", "hsl", "hsla", "keyword"],
            KEYWORD_COLORS: ["aliceblue", "antiquewhite", "aqua", "aquamarine", "azure", "beige", "bisque", "black", "blanchedalmond", "blue", "blueviolet", "brown", "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue", "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod", "darkgray", "darkgreen", "darkgrey", "darkkhaki", "darkmagenta", "darkolivegreen", "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen", "darkslateblue", "darkslategray", "darkslategrey", "darkturquoise", "darkviolet", "deeppink", "deepskyblue", "dimgray", "dimgrey", "dodgerblue", "firebrick", "floralwhite", "forestgreen", "fuchsia", "gainsboro", "ghostwhite", "gold", "goldenrod", "gray", "green", "greenyellow", "grey", "honeydew", "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender", "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral", "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightgrey", "lightpink", "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray", "lightslategrey", "lightsteelblue", "lightyellow", "lime", "limegreen", "linen", "magenta", "maroon", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple", "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise", "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin", "navajowhite", "navy", "oldlace", "olive", "olivedrab", "orange", "orangered", "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred", "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue", "purple", "red", "rosybrown", "royalblue", "saddlebrown", "salmon", "sandybrown", "seagreen", "seashell", "sienna", "silver", "skyblue", "slateblue", "slategray", "slategrey", "snow", "springgreen", "steelblue", "tan", "teal", "thistle", "tomato", "transparent", "turquoise", "violet", "wheat", "white", "whitesmoke", "yellow", "yellowgreen"],
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                if (this.enableByHtml5(c)) return /^#[0-9A-F]{6}$/i.test(f);
                var g = d.type || this.SUPPORTED_TYPES;
                a.isArray(g) || (g = g.replace(/s/g, "").split(","));
                for (var h, i, j = !1, k = 0; k < g.length; k++)
                    if (i = g[k], h = "_" + i.toLowerCase(), j = j || this[h](f)) return !0;
                return !1
            },
            _hex: function(a) {
                return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a)
            },
            _hsl: function(a) {
                return /^hsl\((\s*(-?\d+)\s*,)(\s*(\b(0?\d{1,2}|100)\b%)\s*,)(\s*(\b(0?\d{1,2}|100)\b%)\s*)\)$/.test(a)
            },
            _hsla: function(a) {
                return /^hsla\((\s*(-?\d+)\s*,)(\s*(\b(0?\d{1,2}|100)\b%)\s*,){2}(\s*(0?(\.\d+)?|1(\.0+)?)\s*)\)$/.test(a)
            },
            _keyword: function(b) {
                return a.inArray(b, this.KEYWORD_COLORS) >= 0
            },
            _rgb: function(a) {
                var b = /^rgb\((\s*(\b([01]?\d{1,2}|2[0-4]\d|25[0-5])\b)\s*,){2}(\s*(\b([01]?\d{1,2}|2[0-4]\d|25[0-5])\b)\s*)\)$/,
                    c = /^rgb\((\s*(\b(0?\d{1,2}|100)\b%)\s*,){2}(\s*(\b(0?\d{1,2}|100)\b%)\s*)\)$/;
                return b.test(a) || c.test(a)
            },
            _rgba: function(a) {
                var b = /^rgba\((\s*(\b([01]?\d{1,2}|2[0-4]\d|25[0-5])\b)\s*,){3}(\s*(0?(\.\d+)?|1(\.0+)?)\s*)\)$/,
                    c = /^rgba\((\s*(\b(0?\d{1,2}|100)\b%)\s*,){3}(\s*(0?(\.\d+)?|1(\.0+)?)\s*)\)$/;
                return b.test(a) || c.test(a)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                creditCard: {
                    "default": "Please enter a valid credit card number"
                }
            }
        }), FormValidation.Validator.creditCard = {
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                if (/[^0-9-\s]+/.test(f)) return !1;
                if (f = f.replace(/\D/g, ""), !FormValidation.Helper.luhn(f)) return !1;
                var g, h, i = {
                    AMERICAN_EXPRESS: {
                        length: [15],
                        prefix: ["34", "37"]
                    },
                    DINERS_CLUB: {
                        length: [14],
                        prefix: ["300", "301", "302", "303", "304", "305", "36"]
                    },
                    DINERS_CLUB_US: {
                        length: [16],
                        prefix: ["54", "55"]
                    },
                    DISCOVER: {
                        length: [16],
                        prefix: ["6011", "622126", "622127", "622128", "622129", "62213", "62214", "62215", "62216", "62217", "62218", "62219", "6222", "6223", "6224", "6225", "6226", "6227", "6228", "62290", "62291", "622920", "622921", "622922", "622923", "622924", "622925", "644", "645", "646", "647", "648", "649", "65"]
                    },
                    JCB: {
                        length: [16],
                        prefix: ["3528", "3529", "353", "354", "355", "356", "357", "358"]
                    },
                    LASER: {
                        length: [16, 17, 18, 19],
                        prefix: ["6304", "6706", "6771", "6709"]
                    },
                    MAESTRO: {
                        length: [12, 13, 14, 15, 16, 17, 18, 19],
                        prefix: ["5018", "5020", "5038", "6304", "6759", "6761", "6762", "6763", "6764", "6765", "6766"]
                    },
                    MASTERCARD: {
                        length: [16],
                        prefix: ["51", "52", "53", "54", "55"]
                    },
                    SOLO: {
                        length: [16, 18, 19],
                        prefix: ["6334", "6767"]
                    },
                    UNIONPAY: {
                        length: [16, 17, 18, 19],
                        prefix: ["622126", "622127", "622128", "622129", "62213", "62214", "62215", "62216", "62217", "62218", "62219", "6222", "6223", "6224", "6225", "6226", "6227", "6228", "62290", "62291", "622920", "622921", "622922", "622923", "622924", "622925"]
                    },
                    VISA: {
                        length: [16],
                        prefix: ["4"]
                    }
                };
                for (g in i)
                    for (h in i[g].prefix)
                        if (f.substr(0, i[g].prefix[h].length) === i[g].prefix[h] && -1 !== a.inArray(f.length, i[g].length)) return {
                            valid: !0,
                            type: g
                        };
                return !1
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                cusip: {
                    "default": "Please enter a valid CUSIP number"
                }
            }
        }), FormValidation.Validator.cusip = {
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                if (f = f.toUpperCase(), !/^[0-9A-Z]{9}$/.test(f)) return !1;
                for (var g = a.map(f.split(""), function(a) {
                    var b = a.charCodeAt(0);
                    return b >= "A".charCodeAt(0) && b <= "Z".charCodeAt(0) ? b - "A".charCodeAt(0) + 10 : a
                }), h = g.length, i = 0, j = 0; h - 1 > j; j++) {
                    var k = parseInt(g[j], 10);
                    j % 2 !== 0 && (k *= 2), k > 9 && (k -= 9), i += k
                }
                return i = (10 - i % 10) % 10, i === parseInt(g[h - 1], 10)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                cvv: {
                    "default": "Please enter a valid CVV number"
                }
            }
        }), FormValidation.Validator.cvv = {
            html5Attributes: {
                message: "message",
                ccfield: "creditCardField"
            },
            init: function(a, b, c, d) {
                if (c.creditCardField) {
                    var e = a.getFieldElements(c.creditCardField);
                    a.onLiveChange(e, "live_" + d, function() {
                        var c = a.getStatus(b, d);
                        c !== a.STATUS_NOT_VALIDATED && a.revalidateField(b)
                    })
                }
            },
            destroy: function(a, b, c, d) {
                if (c.creditCardField) {
                    var e = a.getFieldElements(c.creditCardField);
                    a.offLiveChange(e, "live_" + d)
                }
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                if (!/^[0-9]{3,4}$/.test(f)) return !1;
                if (!d.creditCardField) return !0;
                var g = b.getFieldElements(d.creditCardField).val();
                if ("" === g) return !0;
                g = g.replace(/\D/g, "");
                var h, i, j = {
                        AMERICAN_EXPRESS: {
                            length: [15],
                            prefix: ["34", "37"]
                        },
                        DINERS_CLUB: {
                            length: [14],
                            prefix: ["300", "301", "302", "303", "304", "305", "36"]
                        },
                        DINERS_CLUB_US: {
                            length: [16],
                            prefix: ["54", "55"]
                        },
                        DISCOVER: {
                            length: [16],
                            prefix: ["6011", "622126", "622127", "622128", "622129", "62213", "62214", "62215", "62216", "62217", "62218", "62219", "6222", "6223", "6224", "6225", "6226", "6227", "6228", "62290", "62291", "622920", "622921", "622922", "622923", "622924", "622925", "644", "645", "646", "647", "648", "649", "65"]
                        },
                        JCB: {
                            length: [16],
                            prefix: ["3528", "3529", "353", "354", "355", "356", "357", "358"]
                        },
                        LASER: {
                            length: [16, 17, 18, 19],
                            prefix: ["6304", "6706", "6771", "6709"]
                        },
                        MAESTRO: {
                            length: [12, 13, 14, 15, 16, 17, 18, 19],
                            prefix: ["5018", "5020", "5038", "6304", "6759", "6761", "6762", "6763", "6764", "6765", "6766"]
                        },
                        MASTERCARD: {
                            length: [16],
                            prefix: ["51", "52", "53", "54", "55"]
                        },
                        SOLO: {
                            length: [16, 18, 19],
                            prefix: ["6334", "6767"]
                        },
                        UNIONPAY: {
                            length: [16, 17, 18, 19],
                            prefix: ["622126", "622127", "622128", "622129", "62213", "62214", "62215", "62216", "62217", "62218", "62219", "6222", "6223", "6224", "6225", "6226", "6227", "6228", "62290", "62291", "622920", "622921", "622922", "622923", "622924", "622925"]
                        },
                        VISA: {
                            length: [16],
                            prefix: ["4"]
                        }
                    },
                    k = null;
                for (h in j)
                    for (i in j[h].prefix)
                        if (g.substr(0, j[h].prefix[i].length) === j[h].prefix[i] && -1 !== a.inArray(g.length, j[h].length)) {
                            k = h;
                            break
                        }
                return null === k ? !1 : "AMERICAN_EXPRESS" === k ? 4 === f.length : 3 === f.length
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                date: {
                    "default": "Please enter a valid date",
                    min: "Please enter a date after %s",
                    max: "Please enter a date before %s",
                    range: "Please enter a date in the range %s - %s"
                }
            }
        }), FormValidation.Validator.date = {
            html5Attributes: {
                message: "message",
                format: "format",
                min: "min",
                max: "max",
                separator: "separator"
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                d.format = d.format || "MM/DD/YYYY", "date" === c.attr("type") && (d.format = "YYYY-MM-DD");
                var g = b.getLocale(),
                    h = d.message || FormValidation.I18n[g].date["default"],
                    i = d.format.split(" "),
                    j = i[0],
                    k = i.length > 1 ? i[1] : null,
                    l = i.length > 2 ? i[2] : null,
                    m = f.split(" "),
                    n = m[0],
                    o = m.length > 1 ? m[1] : null;
                if (i.length !== m.length) return {
                    valid: !1,
                    message: h
                };
                var p = d.separator;
                if (p || (p = -1 !== n.indexOf("/") ? "/" : -1 !== n.indexOf("-") ? "-" : -1 !== n.indexOf(".") ? "." : null), null === p || -1 === n.indexOf(p)) return {
                    valid: !1,
                    message: h
                };
                if (n = n.split(p), j = j.split(p), n.length !== j.length) return {
                    valid: !1,
                    message: h
                };
                var q = n[a.inArray("YYYY", j)],
                    r = n[a.inArray("MM", j)],
                    s = n[a.inArray("DD", j)];
                if (!q || !r || !s || 4 !== q.length) return {
                    valid: !1,
                    message: h
                };
                var t = null,
                    u = null,
                    v = null;
                if (k) {
                    if (k = k.split(":"), o = o.split(":"), k.length !== o.length) return {
                        valid: !1,
                        message: h
                    };
                    if (u = o.length > 0 ? o[0] : null, t = o.length > 1 ? o[1] : null, v = o.length > 2 ? o[2] : null, "" === u || "" === t || "" === v) return {
                        valid: !1,
                        message: h
                    };
                    if (v) {
                        if (isNaN(v) || v.length > 2) return {
                            valid: !1,
                            message: h
                        };
                        if (v = parseInt(v, 10), 0 > v || v > 60) return {
                            valid: !1,
                            message: h
                        }
                    }
                    if (u) {
                        if (isNaN(u) || u.length > 2) return {
                            valid: !1,
                            message: h
                        };
                        if (u = parseInt(u, 10), 0 > u || u >= 24 || l && u > 12) return {
                            valid: !1,
                            message: h
                        }
                    }
                    if (t) {
                        if (isNaN(t) || t.length > 2) return {
                            valid: !1,
                            message: h
                        };
                        if (t = parseInt(t, 10), 0 > t || t > 59) return {
                            valid: !1,
                            message: h
                        }
                    }
                }
                var w = FormValidation.Helper.date(q, r, s),
                    x = null,
                    y = null,
                    z = d.min,
                    A = d.max;
                switch (z && (isNaN(Date.parse(z)) && (z = b.getDynamicOption(c, z)), x = z instanceof Date ? z : this._parseDate(z, j, p), z = z instanceof Date ? this._formatDate(z, d.format) : z), A && (isNaN(Date.parse(A)) && (A = b.getDynamicOption(c, A)), y = A instanceof Date ? A : this._parseDate(A, j, p), A = A instanceof Date ? this._formatDate(A, d.format) : A), n = new Date(q, r - 1, s, u, t, v), !0) {
                    case z && !A && w:
                        w = n.getTime() >= x.getTime(), h = d.message || FormValidation.Helper.format(FormValidation.I18n[g].date.min, z);
                        break;
                    case A && !z && w:
                        w = n.getTime() <= y.getTime(), h = d.message || FormValidation.Helper.format(FormValidation.I18n[g].date.max, A);
                        break;
                    case A && z && w:
                        w = n.getTime() <= y.getTime() && n.getTime() >= x.getTime(), h = d.message || FormValidation.Helper.format(FormValidation.I18n[g].date.range, [z, A])
                }
                return {
                    valid: w,
                    date: n,
                    message: h
                }
            },
            _parseDate: function(b, c, d) {
                var e = 0,
                    f = 0,
                    g = 0,
                    h = b.split(" "),
                    i = h[0],
                    j = h.length > 1 ? h[1] : null;
                i = i.split(d);
                var k = i[a.inArray("YYYY", c)],
                    l = i[a.inArray("MM", c)],
                    m = i[a.inArray("DD", c)];
                return j && (j = j.split(":"), f = j.length > 0 ? j[0] : null, e = j.length > 1 ? j[1] : null, g = j.length > 2 ? j[2] : null), new Date(k, l - 1, m, f, e, g)
            },
            _formatDate: function(a, b) {
                b = b.replace(/Y/g, "y").replace(/M/g, "m").replace(/D/g, "d").replace(/:m/g, ":M").replace(/:mm/g, ":MM").replace(/:S/, ":s").replace(/:SS/, ":ss");
                var c = {
                    d: function(a) {
                        return a.getDate()
                    },
                    dd: function(a) {
                        var b = a.getDate();
                        return 10 > b ? "0" + b : b
                    },
                    m: function(a) {
                        return a.getMonth() + 1
                    },
                    mm: function(a) {
                        var b = a.getMonth() + 1;
                        return 10 > b ? "0" + b : b
                    },
                    yy: function(a) {
                        return ("" + a.getFullYear()).substr(2)
                    },
                    yyyy: function(a) {
                        return a.getFullYear()
                    },
                    h: function(a) {
                        return a.getHours() % 12 || 12
                    },
                    hh: function(a) {
                        var b = a.getHours() % 12 || 12;
                        return 10 > b ? "0" + b : b
                    },
                    H: function(a) {
                        return a.getHours()
                    },
                    HH: function(a) {
                        var b = a.getHours();
                        return 10 > b ? "0" + b : b
                    },
                    M: function(a) {
                        return a.getMinutes()
                    },
                    MM: function(a) {
                        var b = a.getMinutes();
                        return 10 > b ? "0" + b : b
                    },
                    s: function(a) {
                        return a.getSeconds()
                    },
                    ss: function(a) {
                        var b = a.getSeconds();
                        return 10 > b ? "0" + b : b
                    }
                };
                return b.replace(/d{1,4}|m{1,4}|yy(?:yy)?|([HhMs])\1?|"[^"]*"|'[^']*'/g, function(b) {
                    return c[b] ? c[b](a) : b.slice(1, b.length - 1)
                })
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                different: {
                    "default": "Please enter a different value"
                }
            }
        }), FormValidation.Validator.different = {
            html5Attributes: {
                message: "message",
                field: "field"
            },
            init: function(a, b, c, d) {
                for (var e = c.field.split(","), f = 0; f < e.length; f++) {
                    var g = a.getFieldElements(e[f]);
                    a.onLiveChange(g, "live_" + d, function() {
                        var c = a.getStatus(b, d);
                        c !== a.STATUS_NOT_VALIDATED && a.revalidateField(b)
                    })
                }
            },
            destroy: function(a, b, c, d) {
                for (var e = c.field.split(","), f = 0; f < e.length; f++) {
                    var g = a.getFieldElements(e[f]);
                    a.offLiveChange(g, "live_" + d)
                }
            },
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                for (var f = c.field.split(","), g = !0, h = 0; h < f.length; h++) {
                    var i = a.getFieldElements(f[h]);
                    if (null != i && 0 !== i.length) {
                        var j = a.getFieldValue(i, d);
                        e === j ? g = !1 : "" !== j && a.updateStatus(i, a.STATUS_VALID, d)
                    }
                }
                return g
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                digits: {
                    "default": "Please enter only digits"
                }
            }
        }), FormValidation.Validator.digits = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                return "" === e ? !0 : /^\d+$/.test(e)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                ean: {
                    "default": "Please enter a valid EAN number"
                }
            }
        }), FormValidation.Validator.ean = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                if (!/^(\d{8}|\d{12}|\d{13})$/.test(e)) return !1;
                for (var f = e.length, g = 0, h = 8 === f ? [3, 1] : [1, 3], i = 0; f - 1 > i; i++) g += parseInt(e.charAt(i), 10) * h[i % 2];
                return g = (10 - g % 10) % 10, g + "" === e.charAt(f - 1)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                ein: {
                    "default": "Please enter a valid EIN number"
                }
            }
        }), FormValidation.Validator.ein = {
            CAMPUS: {
                ANDOVER: ["10", "12"],
                ATLANTA: ["60", "67"],
                AUSTIN: ["50", "53"],
                BROOKHAVEN: ["01", "02", "03", "04", "05", "06", "11", "13", "14", "16", "21", "22", "23", "25", "34", "51", "52", "54", "55", "56", "57", "58", "59", "65"],
                CINCINNATI: ["30", "32", "35", "36", "37", "38", "61"],
                FRESNO: ["15", "24"],
                KANSAS_CITY: ["40", "44"],
                MEMPHIS: ["94", "95"],
                OGDEN: ["80", "90"],
                PHILADELPHIA: ["33", "39", "41", "42", "43", "46", "48", "62", "63", "64", "66", "68", "71", "72", "73", "74", "75", "76", "77", "81", "82", "83", "84", "85", "86", "87", "88", "91", "92", "93", "98", "99"],
                INTERNET: ["20", "26", "27", "45", "46"],
                SMALL_BUSINESS_ADMINISTRATION: ["31"]
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                if (!/^[0-9]{2}-?[0-9]{7}$/.test(f)) return !1;
                var g = f.substr(0, 2) + "";
                for (var h in this.CAMPUS)
                    if (-1 !== a.inArray(g, this.CAMPUS[h])) return {
                        valid: !0,
                        campus: h
                    };
                return !1
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                emailAddress: {
                    "default": "Please enter a valid email address"
                }
            }
        }), FormValidation.Validator.emailAddress = {
            html5Attributes: {
                message: "message",
                multiple: "multiple",
                separator: "separator"
            },
            enableByHtml5: function(a) {
                return "email" === a.attr("type")
            },
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                var f = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
                    g = c.multiple === !0 || "true" === c.multiple;
                if (g) {
                    for (var h = c.separator || /[,;]/, i = this._splitEmailAddresses(e, h), j = 0; j < i.length; j++)
                        if (!f.test(i[j])) return !1;
                    return !0
                }
                return f.test(e)
            },
            _splitEmailAddresses: function(a, b) {
                for (var c = a.split(/"/), d = c.length, e = [], f = "", g = 0; d > g; g++)
                    if (g % 2 === 0) {
                        var h = c[g].split(b),
                            i = h.length;
                        if (1 === i) f += h[0];
                        else {
                            e.push(f + h[0]);
                            for (var j = 1; i - 1 > j; j++) e.push(h[j]);
                            f = h[i - 1]
                        }
                    } else f += '"' + c[g], d - 1 > g && (f += '"');
                return e.push(f), e
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                file: {
                    "default": "Please choose a valid file"
                }
            }
        }), FormValidation.Validator.file = {
            html5Attributes: {
                extension: "extension",
                maxfiles: "maxFiles",
                minfiles: "minFiles",
                maxsize: "maxSize",
                minsize: "minSize",
                maxtotalsize: "maxTotalSize",
                mintotalsize: "minTotalSize",
                message: "message",
                type: "type"
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                var g, h = d.extension ? d.extension.toLowerCase().split(",") : null,
                    i = d.type ? d.type.toLowerCase().split(",") : null,
                    j = window.File && window.FileList && window.FileReader;
                if (j) {
                    var k = c.get(0).files,
                        l = k.length,
                        m = 0;
                    if (d.maxFiles && l > parseInt(d.maxFiles, 10) || d.minFiles && l < parseInt(d.minFiles, 10)) return !1;
                    for (var n = 0; l > n; n++)
                        if (m += k[n].size, g = k[n].name.substr(k[n].name.lastIndexOf(".") + 1), d.minSize && k[n].size < parseInt(d.minSize, 10) || d.maxSize && k[n].size > parseInt(d.maxSize, 10) || h && -1 === a.inArray(g.toLowerCase(), h) || k[n].type && i && -1 === a.inArray(k[n].type.toLowerCase(), i)) return !1;
                    if (d.maxTotalSize && m > parseInt(d.maxTotalSize, 10) || d.minTotalSize && m < parseInt(d.minTotalSize, 10)) return !1
                } else if (g = f.substr(f.lastIndexOf(".") + 1), h && -1 === a.inArray(g.toLowerCase(), h)) return !1;
                return !0
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                greaterThan: {
                    "default": "Please enter a value greater than or equal to %s",
                    notInclusive: "Please enter a value greater than %s"
                }
            }
        }), FormValidation.Validator.greaterThan = {
            html5Attributes: {
                message: "message",
                value: "value",
                inclusive: "inclusive"
            },
            enableByHtml5: function(a) {
                var b = a.attr("type"),
                    c = a.attr("min");
                return c && "date" !== b ? {
                    value: c
                } : !1
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                f = this._format(f);
                var g = b.getLocale(),
                    h = a.isNumeric(d.value) ? d.value : b.getDynamicOption(c, d.value),
                    i = this._format(h);
                return d.inclusive === !0 || void 0 === d.inclusive ? {
                    valid: a.isNumeric(f) && parseFloat(f) >= i,
                    message: FormValidation.Helper.format(d.message || FormValidation.I18n[g].greaterThan["default"], h)
                } : {
                    valid: a.isNumeric(f) && parseFloat(f) > i,
                    message: FormValidation.Helper.format(d.message || FormValidation.I18n[g].greaterThan.notInclusive, h)
                }
            },
            _format: function(a) {
                return (a + "").replace(",", ".")
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                grid: {
                    "default": "Please enter a valid GRId number"
                }
            }
        }), FormValidation.Validator.grid = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                return "" === e ? !0 : (e = e.toUpperCase(), /^[GRID:]*([0-9A-Z]{2})[-\s]*([0-9A-Z]{5})[-\s]*([0-9A-Z]{10})[-\s]*([0-9A-Z]{1})$/g.test(e) ? (e = e.replace(/\s/g, "").replace(/-/g, ""), "GRID:" === e.substr(0, 5) && (e = e.substr(5)), FormValidation.Helper.mod37And36(e)) : !1)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                hex: {
                    "default": "Please enter a valid hexadecimal number"
                }
            }
        }), FormValidation.Validator.hex = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                return "" === e ? !0 : /^[0-9a-fA-F]+$/.test(e)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                iban: {
                    "default": "Please enter a valid IBAN number",
                    country: "Please enter a valid IBAN number in %s",
                    countries: {
                        AD: "Andorra",
                        AE: "United Arab Emirates",
                        AL: "Albania",
                        AO: "Angola",
                        AT: "Austria",
                        AZ: "Azerbaijan",
                        BA: "Bosnia and Herzegovina",
                        BE: "Belgium",
                        BF: "Burkina Faso",
                        BG: "Bulgaria",
                        BH: "Bahrain",
                        BI: "Burundi",
                        BJ: "Benin",
                        BR: "Brazil",
                        CH: "Switzerland",
                        CI: "Ivory Coast",
                        CM: "Cameroon",
                        CR: "Costa Rica",
                        CV: "Cape Verde",
                        CY: "Cyprus",
                        CZ: "Czech Republic",
                        DE: "Germany",
                        DK: "Denmark",
                        DO: "Dominican Republic",
                        DZ: "Algeria",
                        EE: "Estonia",
                        ES: "Spain",
                        FI: "Finland",
                        FO: "Faroe Islands",
                        FR: "France",
                        GB: "United Kingdom",
                        GE: "Georgia",
                        GI: "Gibraltar",
                        GL: "Greenland",
                        GR: "Greece",
                        GT: "Guatemala",
                        HR: "Croatia",
                        HU: "Hungary",
                        IE: "Ireland",
                        IL: "Israel",
                        IR: "Iran",
                        IS: "Iceland",
                        IT: "Italy",
                        JO: "Jordan",
                        KW: "Kuwait",
                        KZ: "Kazakhstan",
                        LB: "Lebanon",
                        LI: "Liechtenstein",
                        LT: "Lithuania",
                        LU: "Luxembourg",
                        LV: "Latvia",
                        MC: "Monaco",
                        MD: "Moldova",
                        ME: "Montenegro",
                        MG: "Madagascar",
                        MK: "Macedonia",
                        ML: "Mali",
                        MR: "Mauritania",
                        MT: "Malta",
                        MU: "Mauritius",
                        MZ: "Mozambique",
                        NL: "Netherlands",
                        NO: "Norway",
                        PK: "Pakistan",
                        PL: "Poland",
                        PS: "Palestine",
                        PT: "Portugal",
                        QA: "Qatar",
                        RO: "Romania",
                        RS: "Serbia",
                        SA: "Saudi Arabia",
                        SE: "Sweden",
                        SI: "Slovenia",
                        SK: "Slovakia",
                        SM: "San Marino",
                        SN: "Senegal",
                        TL: "East Timor",
                        TN: "Tunisia",
                        TR: "Turkey",
                        VG: "Virgin Islands, British",
                        XK: "Republic of Kosovo"
                    }
                }
            }
        }), FormValidation.Validator.iban = {
            html5Attributes: {
                message: "message",
                country: "country",
                sepa: "sepa"
            },
            REGEX: {
                AD: "AD[0-9]{2}[0-9]{4}[0-9]{4}[A-Z0-9]{12}",
                AE: "AE[0-9]{2}[0-9]{3}[0-9]{16}",
                AL: "AL[0-9]{2}[0-9]{8}[A-Z0-9]{16}",
                AO: "AO[0-9]{2}[0-9]{21}",
                AT: "AT[0-9]{2}[0-9]{5}[0-9]{11}",
                AZ: "AZ[0-9]{2}[A-Z]{4}[A-Z0-9]{20}",
                BA: "BA[0-9]{2}[0-9]{3}[0-9]{3}[0-9]{8}[0-9]{2}",
                BE: "BE[0-9]{2}[0-9]{3}[0-9]{7}[0-9]{2}",
                BF: "BF[0-9]{2}[0-9]{23}",
                BG: "BG[0-9]{2}[A-Z]{4}[0-9]{4}[0-9]{2}[A-Z0-9]{8}",
                BH: "BH[0-9]{2}[A-Z]{4}[A-Z0-9]{14}",
                BI: "BI[0-9]{2}[0-9]{12}",
                BJ: "BJ[0-9]{2}[A-Z]{1}[0-9]{23}",
                BR: "BR[0-9]{2}[0-9]{8}[0-9]{5}[0-9]{10}[A-Z][A-Z0-9]",
                CH: "CH[0-9]{2}[0-9]{5}[A-Z0-9]{12}",
                CI: "CI[0-9]{2}[A-Z]{1}[0-9]{23}",
                CM: "CM[0-9]{2}[0-9]{23}",
                CR: "CR[0-9]{2}[0-9]{3}[0-9]{14}",
                CV: "CV[0-9]{2}[0-9]{21}",
                CY: "CY[0-9]{2}[0-9]{3}[0-9]{5}[A-Z0-9]{16}",
                CZ: "CZ[0-9]{2}[0-9]{20}",
                DE: "DE[0-9]{2}[0-9]{8}[0-9]{10}",
                DK: "DK[0-9]{2}[0-9]{14}",
                DO: "DO[0-9]{2}[A-Z0-9]{4}[0-9]{20}",
                DZ: "DZ[0-9]{2}[0-9]{20}",
                EE: "EE[0-9]{2}[0-9]{2}[0-9]{2}[0-9]{11}[0-9]{1}",
                ES: "ES[0-9]{2}[0-9]{4}[0-9]{4}[0-9]{1}[0-9]{1}[0-9]{10}",
                FI: "FI[0-9]{2}[0-9]{6}[0-9]{7}[0-9]{1}",
                FO: "FO[0-9]{2}[0-9]{4}[0-9]{9}[0-9]{1}",
                FR: "FR[0-9]{2}[0-9]{5}[0-9]{5}[A-Z0-9]{11}[0-9]{2}",
                GB: "GB[0-9]{2}[A-Z]{4}[0-9]{6}[0-9]{8}",
                GE: "GE[0-9]{2}[A-Z]{2}[0-9]{16}",
                GI: "GI[0-9]{2}[A-Z]{4}[A-Z0-9]{15}",
                GL: "GL[0-9]{2}[0-9]{4}[0-9]{9}[0-9]{1}",
                GR: "GR[0-9]{2}[0-9]{3}[0-9]{4}[A-Z0-9]{16}",
                GT: "GT[0-9]{2}[A-Z0-9]{4}[A-Z0-9]{20}",
                HR: "HR[0-9]{2}[0-9]{7}[0-9]{10}",
                HU: "HU[0-9]{2}[0-9]{3}[0-9]{4}[0-9]{1}[0-9]{15}[0-9]{1}",
                IE: "IE[0-9]{2}[A-Z]{4}[0-9]{6}[0-9]{8}",
                IL: "IL[0-9]{2}[0-9]{3}[0-9]{3}[0-9]{13}",
                IR: "IR[0-9]{2}[0-9]{22}",
                IS: "IS[0-9]{2}[0-9]{4}[0-9]{2}[0-9]{6}[0-9]{10}",
                IT: "IT[0-9]{2}[A-Z]{1}[0-9]{5}[0-9]{5}[A-Z0-9]{12}",
                JO: "JO[0-9]{2}[A-Z]{4}[0-9]{4}[0]{8}[A-Z0-9]{10}",
                KW: "KW[0-9]{2}[A-Z]{4}[0-9]{22}",
                KZ: "KZ[0-9]{2}[0-9]{3}[A-Z0-9]{13}",
                LB: "LB[0-9]{2}[0-9]{4}[A-Z0-9]{20}",
                LI: "LI[0-9]{2}[0-9]{5}[A-Z0-9]{12}",
                LT: "LT[0-9]{2}[0-9]{5}[0-9]{11}",
                LU: "LU[0-9]{2}[0-9]{3}[A-Z0-9]{13}",
                LV: "LV[0-9]{2}[A-Z]{4}[A-Z0-9]{13}",
                MC: "MC[0-9]{2}[0-9]{5}[0-9]{5}[A-Z0-9]{11}[0-9]{2}",
                MD: "MD[0-9]{2}[A-Z0-9]{20}",
                ME: "ME[0-9]{2}[0-9]{3}[0-9]{13}[0-9]{2}",
                MG: "MG[0-9]{2}[0-9]{23}",
                MK: "MK[0-9]{2}[0-9]{3}[A-Z0-9]{10}[0-9]{2}",
                ML: "ML[0-9]{2}[A-Z]{1}[0-9]{23}",
                MR: "MR13[0-9]{5}[0-9]{5}[0-9]{11}[0-9]{2}",
                MT: "MT[0-9]{2}[A-Z]{4}[0-9]{5}[A-Z0-9]{18}",
                MU: "MU[0-9]{2}[A-Z]{4}[0-9]{2}[0-9]{2}[0-9]{12}[0-9]{3}[A-Z]{3}",
                MZ: "MZ[0-9]{2}[0-9]{21}",
                NL: "NL[0-9]{2}[A-Z]{4}[0-9]{10}",
                NO: "NO[0-9]{2}[0-9]{4}[0-9]{6}[0-9]{1}",
                PK: "PK[0-9]{2}[A-Z]{4}[A-Z0-9]{16}",
                PL: "PL[0-9]{2}[0-9]{8}[0-9]{16}",
                PS: "PS[0-9]{2}[A-Z]{4}[A-Z0-9]{21}",
                PT: "PT[0-9]{2}[0-9]{4}[0-9]{4}[0-9]{11}[0-9]{2}",
                QA: "QA[0-9]{2}[A-Z]{4}[A-Z0-9]{21}",
                RO: "RO[0-9]{2}[A-Z]{4}[A-Z0-9]{16}",
                RS: "RS[0-9]{2}[0-9]{3}[0-9]{13}[0-9]{2}",
                SA: "SA[0-9]{2}[0-9]{2}[A-Z0-9]{18}",
                SE: "SE[0-9]{2}[0-9]{3}[0-9]{16}[0-9]{1}",
                SI: "SI[0-9]{2}[0-9]{5}[0-9]{8}[0-9]{2}",
                SK: "SK[0-9]{2}[0-9]{4}[0-9]{6}[0-9]{10}",
                SM: "SM[0-9]{2}[A-Z]{1}[0-9]{5}[0-9]{5}[A-Z0-9]{12}",
                SN: "SN[0-9]{2}[A-Z]{1}[0-9]{23}",
                TL: "TL38[0-9]{3}[0-9]{14}[0-9]{2}",
                TN: "TN59[0-9]{2}[0-9]{3}[0-9]{13}[0-9]{2}",
                TR: "TR[0-9]{2}[0-9]{5}[A-Z0-9]{1}[A-Z0-9]{16}",
                VG: "VG[0-9]{2}[A-Z]{4}[0-9]{16}",
                XK: "XK[0-9]{2}[0-9]{4}[0-9]{10}[0-9]{2}"
            },
            SEPA_COUNTRIES: ["AT", "BE", "BG", "CH", "CY", "CZ", "DE", "DK", "EE", "ES", "FI", "FR", "GB", "GI", "GR", "HR", "HU", "IE", "IS", "IT", "LI", "LT", "LU", "LV", "MC", "MT", "NL", "NO", "PL", "PT", "RO", "SE", "SI", "SK", "SM"],
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                f = f.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
                var g = d.country;
                g ? "string" == typeof g && this.REGEX[g] || (g = b.getDynamicOption(c, g)) : g = f.substr(0, 2);
                var h = b.getLocale();
                if (!this.REGEX[g]) return !1;
                if (void 0 !== typeof d.sepa) {
                    var i = -1 !== a.inArray(g, this.SEPA_COUNTRIES);
                    if (("true" === d.sepa || d.sepa === !0) && !i || ("false" === d.sepa || d.sepa === !1) && i) return !1
                }
                if (!new RegExp("^" + this.REGEX[g] + "$").test(f)) return {
                    valid: !1,
                    message: FormValidation.Helper.format(d.message || FormValidation.I18n[h].iban.country, FormValidation.I18n[h].iban.countries[g])
                };
                f = f.substr(4) + f.substr(0, 4), f = a.map(f.split(""), function(a) {
                    var b = a.charCodeAt(0);
                    return b >= "A".charCodeAt(0) && b <= "Z".charCodeAt(0) ? b - "A".charCodeAt(0) + 10 : a
                }), f = f.join("");
                for (var j = parseInt(f.substr(0, 1), 10), k = f.length, l = 1; k > l; ++l) j = (10 * j + parseInt(f.substr(l, 1), 10)) % 97;
                return {
                    valid: 1 === j,
                    message: FormValidation.Helper.format(d.message || FormValidation.I18n[h].iban.country, FormValidation.I18n[h].iban.countries[g])
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                id: {
                    "default": "Please enter a valid identification number",
                    country: "Please enter a valid identification number in %s",
                    countries: {
                        BA: "Bosnia and Herzegovina",
                        BG: "Bulgaria",
                        BR: "Brazil",
                        CH: "Switzerland",
                        CL: "Chile",
                        CN: "China",
                        CZ: "Czech Republic",
                        DK: "Denmark",
                        EE: "Estonia",
                        ES: "Spain",
                        FI: "Finland",
                        HR: "Croatia",
                        IE: "Ireland",
                        IS: "Iceland",
                        LT: "Lithuania",
                        LV: "Latvia",
                        ME: "Montenegro",
                        MK: "Macedonia",
                        NL: "Netherlands",
                        PL: "Poland",
                        RO: "Romania",
                        RS: "Serbia",
                        SE: "Sweden",
                        SI: "Slovenia",
                        SK: "Slovakia",
                        SM: "San Marino",
                        TH: "Thailand",
                        ZA: "South Africa"
                    }
                }
            }
        }), FormValidation.Validator.id = {
            html5Attributes: {
                message: "message",
                country: "country"
            },
            COUNTRY_CODES: ["BA", "BG", "BR", "CH", "CL", "CN", "CZ", "DK", "EE", "ES", "FI", "HR", "IE", "IS", "LT", "LV", "ME", "MK", "NL", "PL", "RO", "RS", "SE", "SI", "SK", "SM", "TH", "ZA"],
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                var g = b.getLocale(),
                    h = d.country;
                if (h ? ("string" != typeof h || -1 === a.inArray(h.toUpperCase(), this.COUNTRY_CODES)) && (h = b.getDynamicOption(c, h)) : h = f.substr(0, 2), -1 === a.inArray(h, this.COUNTRY_CODES)) return !0;
                var i = ["_", h.toLowerCase()].join(""),
                    j = this[i](f);
                return j = j === !0 || j === !1 ? {
                    valid: j
                } : j, j.message = FormValidation.Helper.format(d.message || FormValidation.I18n[g].id.country, FormValidation.I18n[g].id.countries[h.toUpperCase()]), j
            },
            _validateJMBG: function(a, b) {
                if (!/^\d{13}$/.test(a)) return !1;
                var c = parseInt(a.substr(0, 2), 10),
                    d = parseInt(a.substr(2, 2), 10),
                    e = (parseInt(a.substr(4, 3), 10), parseInt(a.substr(7, 2), 10)),
                    f = parseInt(a.substr(12, 1), 10);
                if (c > 31 || d > 12) return !1;
                for (var g = 0, h = 0; 6 > h; h++) g += (7 - h) * (parseInt(a.charAt(h), 10) + parseInt(a.charAt(h + 6), 10));
                if (g = 11 - g % 11, (10 === g || 11 === g) && (g = 0), g !== f) return !1;
                switch (b.toUpperCase()) {
                    case "BA":
                        return e >= 10 && 19 >= e;
                    case "MK":
                        return e >= 41 && 49 >= e;
                    case "ME":
                        return e >= 20 && 29 >= e;
                    case "RS":
                        return e >= 70 && 99 >= e;
                    case "SI":
                        return e >= 50 && 59 >= e;
                    default:
                        return !0
                }
            },
            _ba: function(a) {
                return this._validateJMBG(a, "BA")
            },
            _mk: function(a) {
                return this._validateJMBG(a, "MK")
            },
            _me: function(a) {
                return this._validateJMBG(a, "ME")
            },
            _rs: function(a) {
                return this._validateJMBG(a, "RS")
            },
            _si: function(a) {
                return this._validateJMBG(a, "SI")
            },
            _bg: function(a) {
                if (!/^\d{10}$/.test(a) && !/^\d{6}\s\d{3}\s\d{1}$/.test(a)) return !1;
                a = a.replace(/\s/g, "");
                var b = parseInt(a.substr(0, 2), 10) + 1900,
                    c = parseInt(a.substr(2, 2), 10),
                    d = parseInt(a.substr(4, 2), 10);
                if (c > 40 ? (b += 100, c -= 40) : c > 20 && (b -= 100, c -= 20), !FormValidation.Helper.date(b, c, d)) return !1;
                for (var e = 0, f = [2, 4, 8, 5, 10, 9, 7, 3, 6], g = 0; 9 > g; g++) e += parseInt(a.charAt(g), 10) * f[g];
                return e = e % 11 % 10, e + "" === a.substr(9, 1)
            },
            _br: function(a) {
                if (a = a.replace(/\D/g, ""), !/^\d{11}$/.test(a) || /^1{11}|2{11}|3{11}|4{11}|5{11}|6{11}|7{11}|8{11}|9{11}|0{11}$/.test(a)) return !1;
                for (var b = 0, c = 0; 9 > c; c++) b += (10 - c) * parseInt(a.charAt(c), 10);
                if (b = 11 - b % 11, (10 === b || 11 === b) && (b = 0), b + "" !== a.charAt(9)) return !1;
                var d = 0;
                for (c = 0; 10 > c; c++) d += (11 - c) * parseInt(a.charAt(c), 10);
                return d = 11 - d % 11, (10 === d || 11 === d) && (d = 0), d + "" === a.charAt(10)
            },
            _ch: function(a) {
                if (!/^756[\.]{0,1}[0-9]{4}[\.]{0,1}[0-9]{4}[\.]{0,1}[0-9]{2}$/.test(a)) return !1;
                a = a.replace(/\D/g, "").substr(3);
                for (var b = a.length, c = 0, d = 8 === b ? [3, 1] : [1, 3], e = 0; b - 1 > e; e++) c += parseInt(a.charAt(e), 10) * d[e % 2];
                return c = 10 - c % 10, c + "" === a.charAt(b - 1)
            },
            _cl: function(a) {
                if (!/^\d{7,8}[-]{0,1}[0-9K]$/i.test(a)) return !1;
                for (a = a.replace(/\-/g, ""); a.length < 9;) a = "0" + a;
                for (var b = 0, c = [3, 2, 7, 6, 5, 4, 3, 2], d = 0; 8 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b = 11 - b % 11, 11 === b ? b = 0 : 10 === b && (b = "K"), b + "" === a.charAt(8).toUpperCase()
            },
            _cn: function(b) {
                if (b = b.trim(), !/^\d{15}$/.test(b) && !/^\d{17}[\dXx]{1}$/.test(b)) return !1;
                var c = {
                        11: {
                            0: [0],
                            1: [
                                [0, 9],
                                [11, 17]
                            ],
                            2: [0, 28, 29]
                        },
                        12: {
                            0: [0],
                            1: [
                                [0, 16]
                            ],
                            2: [0, 21, 23, 25]
                        },
                        13: {
                            0: [0],
                            1: [
                                [0, 5], 7, 8, 21, [23, 33],
                                [81, 85]
                            ],
                            2: [
                                [0, 5],
                                [7, 9],
                                [23, 25], 27, 29, 30, 81, 83
                            ],
                            3: [
                                [0, 4],
                                [21, 24]
                            ],
                            4: [
                                [0, 4], 6, 21, [23, 35], 81
                            ],
                            5: [
                                [0, 3],
                                [21, 35], 81, 82
                            ],
                            6: [
                                [0, 4],
                                [21, 38],
                                [81, 84]
                            ],
                            7: [
                                [0, 3], 5, 6, [21, 33]
                            ],
                            8: [
                                [0, 4],
                                [21, 28]
                            ],
                            9: [
                                [0, 3],
                                [21, 30],
                                [81, 84]
                            ],
                            10: [
                                [0, 3],
                                [22, 26], 28, 81, 82
                            ],
                            11: [
                                [0, 2],
                                [21, 28], 81, 82
                            ]
                        },
                        14: {
                            0: [0],
                            1: [0, 1, [5, 10],
                                [21, 23], 81
                            ],
                            2: [
                                [0, 3], 11, 12, [21, 27]
                            ],
                            3: [
                                [0, 3], 11, 21, 22
                            ],
                            4: [
                                [0, 2], 11, 21, [23, 31], 81
                            ],
                            5: [
                                [0, 2], 21, 22, 24, 25, 81
                            ],
                            6: [
                                [0, 3],
                                [21, 24]
                            ],
                            7: [
                                [0, 2],
                                [21, 29], 81
                            ],
                            8: [
                                [0, 2],
                                [21, 30], 81, 82
                            ],
                            9: [
                                [0, 2],
                                [21, 32], 81
                            ],
                            10: [
                                [0, 2],
                                [21, 34], 81, 82
                            ],
                            11: [
                                [0, 2],
                                [21, 30], 81, 82
                            ],
                            23: [
                                [0, 3], 22, 23, [25, 30], 32, 33
                            ]
                        },
                        15: {
                            0: [0],
                            1: [
                                [0, 5],
                                [21, 25]
                            ],
                            2: [
                                [0, 7],
                                [21, 23]
                            ],
                            3: [
                                [0, 4]
                            ],
                            4: [
                                [0, 4],
                                [21, 26],
                                [28, 30]
                            ],
                            5: [
                                [0, 2],
                                [21, 26], 81
                            ],
                            6: [
                                [0, 2],
                                [21, 27]
                            ],
                            7: [
                                [0, 3],
                                [21, 27],
                                [81, 85]
                            ],
                            8: [
                                [0, 2],
                                [21, 26]
                            ],
                            9: [
                                [0, 2],
                                [21, 29], 81
                            ],
                            22: [
                                [0, 2],
                                [21, 24]
                            ],
                            25: [
                                [0, 2],
                                [22, 31]
                            ],
                            26: [
                                [0, 2],
                                [24, 27],
                                [29, 32], 34
                            ],
                            28: [0, 1, [22, 27]],
                            29: [0, [21, 23]]
                        },
                        21: {
                            0: [0],
                            1: [
                                [0, 6],
                                [11, 14],
                                [22, 24], 81
                            ],
                            2: [
                                [0, 4],
                                [11, 13], 24, [81, 83]
                            ],
                            3: [
                                [0, 4], 11, 21, 23, 81
                            ],
                            4: [
                                [0, 4], 11, [21, 23]
                            ],
                            5: [
                                [0, 5], 21, 22
                            ],
                            6: [
                                [0, 4], 24, 81, 82
                            ],
                            7: [
                                [0, 3], 11, 26, 27, 81, 82
                            ],
                            8: [
                                [0, 4], 11, 81, 82
                            ],
                            9: [
                                [0, 5], 11, 21, 22
                            ],
                            10: [
                                [0, 5], 11, 21, 81
                            ],
                            11: [
                                [0, 3], 21, 22
                            ],
                            12: [
                                [0, 2], 4, 21, 23, 24, 81, 82
                            ],
                            13: [
                                [0, 3], 21, 22, 24, 81, 82
                            ],
                            14: [
                                [0, 4], 21, 22, 81
                            ]
                        },
                        22: {
                            0: [0],
                            1: [
                                [0, 6], 12, 22, [81, 83]
                            ],
                            2: [
                                [0, 4], 11, 21, [81, 84]
                            ],
                            3: [
                                [0, 3], 22, 23, 81, 82
                            ],
                            4: [
                                [0, 3], 21, 22
                            ],
                            5: [
                                [0, 3], 21, 23, 24, 81, 82
                            ],
                            6: [
                                [0, 2], 4, 5, [21, 23], 25, 81
                            ],
                            7: [
                                [0, 2],
                                [21, 24], 81
                            ],
                            8: [
                                [0, 2], 21, 22, 81, 82
                            ],
                            24: [
                                [0, 6], 24, 26
                            ]
                        },
                        23: {
                            0: [0],
                            1: [
                                [0, 12], 21, [23, 29],
                                [81, 84]
                            ],
                            2: [
                                [0, 8], 21, [23, 25], 27, [29, 31], 81
                            ],
                            3: [
                                [0, 7], 21, 81, 82
                            ],
                            4: [
                                [0, 7], 21, 22
                            ],
                            5: [
                                [0, 3], 5, 6, [21, 24]
                            ],
                            6: [
                                [0, 6],
                                [21, 24]
                            ],
                            7: [
                                [0, 16], 22, 81
                            ],
                            8: [
                                [0, 5], 11, 22, 26, 28, 33, 81, 82
                            ],
                            9: [
                                [0, 4], 21
                            ],
                            10: [
                                [0, 5], 24, 25, 81, [83, 85]
                            ],
                            11: [
                                [0, 2], 21, 23, 24, 81, 82
                            ],
                            12: [
                                [0, 2],
                                [21, 26],
                                [81, 83]
                            ],
                            27: [
                                [0, 4],
                                [21, 23]
                            ]
                        },
                        31: {
                            0: [0],
                            1: [0, 1, [3, 10],
                                [12, 20]
                            ],
                            2: [0, 30]
                        },
                        32: {
                            0: [0],
                            1: [
                                [0, 7], 11, [13, 18], 24, 25
                            ],
                            2: [
                                [0, 6], 11, 81, 82
                            ],
                            3: [
                                [0, 5], 11, 12, [21, 24], 81, 82
                            ],
                            4: [
                                [0, 2], 4, 5, 11, 12, 81, 82
                            ],
                            5: [
                                [0, 9],
                                [81, 85]
                            ],
                            6: [
                                [0, 2], 11, 12, 21, 23, [81, 84]
                            ],
                            7: [0, 1, 3, 5, 6, [21, 24]],
                            8: [
                                [0, 4], 11, 26, [29, 31]
                            ],
                            9: [
                                [0, 3],
                                [21, 25], 28, 81, 82
                            ],
                            10: [
                                [0, 3], 11, 12, 23, 81, 84, 88
                            ],
                            11: [
                                [0, 2], 11, 12, [81, 83]
                            ],
                            12: [
                                [0, 4],
                                [81, 84]
                            ],
                            13: [
                                [0, 2], 11, [21, 24]
                            ]
                        },
                        33: {
                            0: [0],
                            1: [
                                [0, 6],
                                [8, 10], 22, 27, 82, 83, 85
                            ],
                            2: [0, 1, [3, 6], 11, 12, 25, 26, [81, 83]],
                            3: [
                                [0, 4], 22, 24, [26, 29], 81, 82
                            ],
                            4: [
                                [0, 2], 11, 21, 24, [81, 83]
                            ],
                            5: [
                                [0, 3],
                                [21, 23]
                            ],
                            6: [
                                [0, 2], 21, 24, [81, 83]
                            ],
                            7: [
                                [0, 3], 23, 26, 27, [81, 84]
                            ],
                            8: [
                                [0, 3], 22, 24, 25, 81
                            ],
                            9: [
                                [0, 3], 21, 22
                            ],
                            10: [
                                [0, 4],
                                [21, 24], 81, 82
                            ],
                            11: [
                                [0, 2],
                                [21, 27], 81
                            ]
                        },
                        34: {
                            0: [0],
                            1: [
                                [0, 4], 11, [21, 24], 81
                            ],
                            2: [
                                [0, 4], 7, 8, [21, 23], 25
                            ],
                            3: [
                                [0, 4], 11, [21, 23]
                            ],
                            4: [
                                [0, 6], 21
                            ],
                            5: [
                                [0, 4], 6, [21, 23]
                            ],
                            6: [
                                [0, 4], 21
                            ],
                            7: [
                                [0, 3], 11, 21
                            ],
                            8: [
                                [0, 3], 11, [22, 28], 81
                            ],
                            10: [
                                [0, 4],
                                [21, 24]
                            ],
                            11: [
                                [0, 3], 22, [24, 26], 81, 82
                            ],
                            12: [
                                [0, 4], 21, 22, 25, 26, 82
                            ],
                            13: [
                                [0, 2],
                                [21, 24]
                            ],
                            14: [
                                [0, 2],
                                [21, 24]
                            ],
                            15: [
                                [0, 3],
                                [21, 25]
                            ],
                            16: [
                                [0, 2],
                                [21, 23]
                            ],
                            17: [
                                [0, 2],
                                [21, 23]
                            ],
                            18: [
                                [0, 2],
                                [21, 25], 81
                            ]
                        },
                        35: {
                            0: [0],
                            1: [
                                [0, 5], 11, [21, 25], 28, 81, 82
                            ],
                            2: [
                                [0, 6],
                                [11, 13]
                            ],
                            3: [
                                [0, 5], 22
                            ],
                            4: [
                                [0, 3], 21, [23, 30], 81
                            ],
                            5: [
                                [0, 5], 21, [24, 27],
                                [81, 83]
                            ],
                            6: [
                                [0, 3],
                                [22, 29], 81
                            ],
                            7: [
                                [0, 2],
                                [21, 25],
                                [81, 84]
                            ],
                            8: [
                                [0, 2],
                                [21, 25], 81
                            ],
                            9: [
                                [0, 2],
                                [21, 26], 81, 82
                            ]
                        },
                        36: {
                            0: [0],
                            1: [
                                [0, 5], 11, [21, 24]
                            ],
                            2: [
                                [0, 3], 22, 81
                            ],
                            3: [
                                [0, 2], 13, [21, 23]
                            ],
                            4: [
                                [0, 3], 21, [23, 30], 81, 82
                            ],
                            5: [
                                [0, 2], 21
                            ],
                            6: [
                                [0, 2], 22, 81
                            ],
                            7: [
                                [0, 2],
                                [21, 35], 81, 82
                            ],
                            8: [
                                [0, 3],
                                [21, 30], 81
                            ],
                            9: [
                                [0, 2],
                                [21, 26],
                                [81, 83]
                            ],
                            10: [
                                [0, 2],
                                [21, 30]
                            ],
                            11: [
                                [0, 2],
                                [21, 30], 81
                            ]
                        },
                        37: {
                            0: [0],
                            1: [
                                [0, 5], 12, 13, [24, 26], 81
                            ],
                            2: [
                                [0, 3], 5, [11, 14],
                                [81, 85]
                            ],
                            3: [
                                [0, 6],
                                [21, 23]
                            ],
                            4: [
                                [0, 6], 81
                            ],
                            5: [
                                [0, 3],
                                [21, 23]
                            ],
                            6: [
                                [0, 2],
                                [11, 13], 34, [81, 87]
                            ],
                            7: [
                                [0, 5], 24, 25, [81, 86]
                            ],
                            8: [
                                [0, 2], 11, [26, 32],
                                [81, 83]
                            ],
                            9: [
                                [0, 3], 11, 21, 23, 82, 83
                            ],
                            10: [
                                [0, 2],
                                [81, 83]
                            ],
                            11: [
                                [0, 3], 21, 22
                            ],
                            12: [
                                [0, 3]
                            ],
                            13: [
                                [0, 2], 11, 12, [21, 29]
                            ],
                            14: [
                                [0, 2],
                                [21, 28], 81, 82
                            ],
                            15: [
                                [0, 2],
                                [21, 26], 81
                            ],
                            16: [
                                [0, 2],
                                [21, 26]
                            ],
                            17: [
                                [0, 2],
                                [21, 28]
                            ]
                        },
                        41: {
                            0: [0],
                            1: [
                                [0, 6], 8, 22, [81, 85]
                            ],
                            2: [
                                [0, 5], 11, [21, 25]
                            ],
                            3: [
                                [0, 7], 11, [22, 29], 81
                            ],
                            4: [
                                [0, 4], 11, [21, 23], 25, 81, 82
                            ],
                            5: [
                                [0, 3], 5, 6, 22, 23, 26, 27, 81
                            ],
                            6: [
                                [0, 3], 11, 21, 22
                            ],
                            7: [
                                [0, 4], 11, 21, [24, 28], 81, 82
                            ],
                            8: [
                                [0, 4], 11, [21, 23], 25, [81, 83]
                            ],
                            9: [
                                [0, 2], 22, 23, [26, 28]
                            ],
                            10: [
                                [0, 2],
                                [23, 25], 81, 82
                            ],
                            11: [
                                [0, 4],
                                [21, 23]
                            ],
                            12: [
                                [0, 2], 21, 22, 24, 81, 82
                            ],
                            13: [
                                [0, 3],
                                [21, 30], 81
                            ],
                            14: [
                                [0, 3],
                                [21, 26], 81
                            ],
                            15: [
                                [0, 3],
                                [21, 28]
                            ],
                            16: [
                                [0, 2],
                                [21, 28], 81
                            ],
                            17: [
                                [0, 2],
                                [21, 29]
                            ],
                            90: [0, 1]
                        },
                        42: {
                            0: [0],
                            1: [
                                [0, 7],
                                [11, 17]
                            ],
                            2: [
                                [0, 5], 22, 81
                            ],
                            3: [
                                [0, 3],
                                [21, 25], 81
                            ],
                            5: [
                                [0, 6],
                                [25, 29],
                                [81, 83]
                            ],
                            6: [
                                [0, 2], 6, 7, [24, 26],
                                [82, 84]
                            ],
                            7: [
                                [0, 4]
                            ],
                            8: [
                                [0, 2], 4, 21, 22, 81
                            ],
                            9: [
                                [0, 2],
                                [21, 23], 81, 82, 84
                            ],
                            10: [
                                [0, 3],
                                [22, 24], 81, 83, 87
                            ],
                            11: [
                                [0, 2],
                                [21, 27], 81, 82
                            ],
                            12: [
                                [0, 2],
                                [21, 24], 81
                            ],
                            13: [
                                [0, 3], 21, 81
                            ],
                            28: [
                                [0, 2], 22, 23, [25, 28]
                            ],
                            90: [0, [4, 6], 21]
                        },
                        43: {
                            0: [0],
                            1: [
                                [0, 5], 11, 12, 21, 22, 24, 81
                            ],
                            2: [
                                [0, 4], 11, 21, [23, 25], 81
                            ],
                            3: [
                                [0, 2], 4, 21, 81, 82
                            ],
                            4: [0, 1, [5, 8], 12, [21, 24], 26, 81, 82],
                            5: [
                                [0, 3], 11, [21, 25],
                                [27, 29], 81
                            ],
                            6: [
                                [0, 3], 11, 21, 23, 24, 26, 81, 82
                            ],
                            7: [
                                [0, 3],
                                [21, 26], 81
                            ],
                            8: [
                                [0, 2], 11, 21, 22
                            ],
                            9: [
                                [0, 3],
                                [21, 23], 81
                            ],
                            10: [
                                [0, 3],
                                [21, 28], 81
                            ],
                            11: [
                                [0, 3],
                                [21, 29]
                            ],
                            12: [
                                [0, 2],
                                [21, 30], 81
                            ],
                            13: [
                                [0, 2], 21, 22, 81, 82
                            ],
                            31: [0, 1, [22, 27], 30]
                        },
                        44: {
                            0: [0],
                            1: [
                                [0, 7],
                                [11, 16], 83, 84
                            ],
                            2: [
                                [0, 5], 21, 22, 24, 29, 32, 33, 81, 82
                            ],
                            3: [0, 1, [3, 8]],
                            4: [
                                [0, 4]
                            ],
                            5: [0, 1, [6, 15], 23, 82, 83],
                            6: [0, 1, [4, 8]],
                            7: [0, 1, [3, 5], 81, [83, 85]],
                            8: [
                                [0, 4], 11, 23, 25, [81, 83]
                            ],
                            9: [
                                [0, 3], 23, [81, 83]
                            ],
                            12: [
                                [0, 3],
                                [23, 26], 83, 84
                            ],
                            13: [
                                [0, 3],
                                [22, 24], 81
                            ],
                            14: [
                                [0, 2],
                                [21, 24], 26, 27, 81
                            ],
                            15: [
                                [0, 2], 21, 23, 81
                            ],
                            16: [
                                [0, 2],
                                [21, 25]
                            ],
                            17: [
                                [0, 2], 21, 23, 81
                            ],
                            18: [
                                [0, 3], 21, 23, [25, 27], 81, 82
                            ],
                            19: [0],
                            20: [0],
                            51: [
                                [0, 3], 21, 22
                            ],
                            52: [
                                [0, 3], 21, 22, 24, 81
                            ],
                            53: [
                                [0, 2],
                                [21, 23], 81
                            ]
                        },
                        45: {
                            0: [0],
                            1: [
                                [0, 9],
                                [21, 27]
                            ],
                            2: [
                                [0, 5],
                                [21, 26]
                            ],
                            3: [
                                [0, 5], 11, 12, [21, 32]
                            ],
                            4: [0, 1, [3, 6], 11, [21, 23], 81],
                            5: [
                                [0, 3], 12, 21
                            ],
                            6: [
                                [0, 3], 21, 81
                            ],
                            7: [
                                [0, 3], 21, 22
                            ],
                            8: [
                                [0, 4], 21, 81
                            ],
                            9: [
                                [0, 3],
                                [21, 24], 81
                            ],
                            10: [
                                [0, 2],
                                [21, 31]
                            ],
                            11: [
                                [0, 2],
                                [21, 23]
                            ],
                            12: [
                                [0, 2],
                                [21, 29], 81
                            ],
                            13: [
                                [0, 2],
                                [21, 24], 81
                            ],
                            14: [
                                [0, 2],
                                [21, 25], 81
                            ]
                        },
                        46: {
                            0: [0],
                            1: [0, 1, [5, 8]],
                            2: [0, 1],
                            3: [0, [21, 23]],
                            90: [
                                [0, 3],
                                [5, 7],
                                [21, 39]
                            ]
                        },
                        50: {
                            0: [0],
                            1: [
                                [0, 19]
                            ],
                            2: [0, [22, 38],
                                [40, 43]
                            ],
                            3: [0, [81, 84]]
                        },
                        51: {
                            0: [0],
                            1: [0, 1, [4, 8],
                                [12, 15],
                                [21, 24], 29, 31, 32, [81, 84]
                            ],
                            3: [
                                [0, 4], 11, 21, 22
                            ],
                            4: [
                                [0, 3], 11, 21, 22
                            ],
                            5: [
                                [0, 4], 21, 22, 24, 25
                            ],
                            6: [0, 1, 3, 23, 26, [81, 83]],
                            7: [0, 1, 3, 4, [22, 27], 81],
                            8: [
                                [0, 2], 11, 12, [21, 24]
                            ],
                            9: [
                                [0, 4],
                                [21, 23]
                            ],
                            10: [
                                [0, 2], 11, 24, 25, 28
                            ],
                            11: [
                                [0, 2],
                                [11, 13], 23, 24, 26, 29, 32, 33, 81
                            ],
                            13: [
                                [0, 4],
                                [21, 25], 81
                            ],
                            14: [
                                [0, 2],
                                [21, 25]
                            ],
                            15: [
                                [0, 3],
                                [21, 29]
                            ],
                            16: [
                                [0, 3],
                                [21, 23], 81
                            ],
                            17: [
                                [0, 3],
                                [21, 25], 81
                            ],
                            18: [
                                [0, 3],
                                [21, 27]
                            ],
                            19: [
                                [0, 3],
                                [21, 23]
                            ],
                            20: [
                                [0, 2], 21, 22, 81
                            ],
                            32: [0, [21, 33]],
                            33: [0, [21, 38]],
                            34: [0, 1, [22, 37]]
                        },
                        52: {
                            0: [0],
                            1: [
                                [0, 3],
                                [11, 15],
                                [21, 23], 81
                            ],
                            2: [0, 1, 3, 21, 22],
                            3: [
                                [0, 3],
                                [21, 30], 81, 82
                            ],
                            4: [
                                [0, 2],
                                [21, 25]
                            ],
                            5: [
                                [0, 2],
                                [21, 27]
                            ],
                            6: [
                                [0, 3],
                                [21, 28]
                            ],
                            22: [0, 1, [22, 30]],
                            23: [0, 1, [22, 28]],
                            24: [0, 1, [22, 28]],
                            26: [0, 1, [22, 36]],
                            27: [
                                [0, 2], 22, 23, [25, 32]
                            ]
                        },
                        53: {
                            0: [0],
                            1: [
                                [0, 3],
                                [11, 14], 21, 22, [24, 29], 81
                            ],
                            3: [
                                [0, 2],
                                [21, 26], 28, 81
                            ],
                            4: [
                                [0, 2],
                                [21, 28]
                            ],
                            5: [
                                [0, 2],
                                [21, 24]
                            ],
                            6: [
                                [0, 2],
                                [21, 30]
                            ],
                            7: [
                                [0, 2],
                                [21, 24]
                            ],
                            8: [
                                [0, 2],
                                [21, 29]
                            ],
                            9: [
                                [0, 2],
                                [21, 27]
                            ],
                            23: [0, 1, [22, 29], 31],
                            25: [
                                [0, 4],
                                [22, 32]
                            ],
                            26: [0, 1, [21, 28]],
                            27: [0, 1, [22, 30]],
                            28: [0, 1, 22, 23],
                            29: [0, 1, [22, 32]],
                            31: [0, 2, 3, [22, 24]],
                            34: [0, [21, 23]],
                            33: [0, 21, [23, 25]],
                            35: [0, [21, 28]]
                        },
                        54: {
                            0: [0],
                            1: [
                                [0, 2],
                                [21, 27]
                            ],
                            21: [0, [21, 29], 32, 33],
                            22: [0, [21, 29],
                                [31, 33]
                            ],
                            23: [0, 1, [22, 38]],
                            24: [0, [21, 31]],
                            25: [0, [21, 27]],
                            26: [0, [21, 27]]
                        },
                        61: {
                            0: [0],
                            1: [
                                [0, 4],
                                [11, 16], 22, [24, 26]
                            ],
                            2: [
                                [0, 4], 22
                            ],
                            3: [
                                [0, 4],
                                [21, 24],
                                [26, 31]
                            ],
                            4: [
                                [0, 4],
                                [22, 31], 81
                            ],
                            5: [
                                [0, 2],
                                [21, 28], 81, 82
                            ],
                            6: [
                                [0, 2],
                                [21, 32]
                            ],
                            7: [
                                [0, 2],
                                [21, 30]
                            ],
                            8: [
                                [0, 2],
                                [21, 31]
                            ],
                            9: [
                                [0, 2],
                                [21, 29]
                            ],
                            10: [
                                [0, 2],
                                [21, 26]
                            ]
                        },
                        62: {
                            0: [0],
                            1: [
                                [0, 5], 11, [21, 23]
                            ],
                            2: [0, 1],
                            3: [
                                [0, 2], 21
                            ],
                            4: [
                                [0, 3],
                                [21, 23]
                            ],
                            5: [
                                [0, 3],
                                [21, 25]
                            ],
                            6: [
                                [0, 2],
                                [21, 23]
                            ],
                            7: [
                                [0, 2],
                                [21, 25]
                            ],
                            8: [
                                [0, 2],
                                [21, 26]
                            ],
                            9: [
                                [0, 2],
                                [21, 24], 81, 82
                            ],
                            10: [
                                [0, 2],
                                [21, 27]
                            ],
                            11: [
                                [0, 2],
                                [21, 26]
                            ],
                            12: [
                                [0, 2],
                                [21, 28]
                            ],
                            24: [0, 21, [24, 29]],
                            26: [0, 21, [23, 30]],
                            29: [0, 1, [21, 27]],
                            30: [0, 1, [21, 27]]
                        },
                        63: {
                            0: [0],
                            1: [
                                [0, 5],
                                [21, 23]
                            ],
                            2: [0, 2, [21, 25]],
                            21: [0, [21, 23],
                                [26, 28]
                            ],
                            22: [0, [21, 24]],
                            23: [0, [21, 24]],
                            25: [0, [21, 25]],
                            26: [0, [21, 26]],
                            27: [0, 1, [21, 26]],
                            28: [
                                [0, 2],
                                [21, 23]
                            ]
                        },
                        64: {
                            0: [0],
                            1: [0, 1, [4, 6], 21, 22, 81],
                            2: [
                                [0, 3], 5, [21, 23]
                            ],
                            3: [
                                [0, 3],
                                [21, 24], 81
                            ],
                            4: [
                                [0, 2],
                                [21, 25]
                            ],
                            5: [
                                [0, 2], 21, 22
                            ]
                        },
                        65: {
                            0: [0],
                            1: [
                                [0, 9], 21
                            ],
                            2: [
                                [0, 5]
                            ],
                            21: [0, 1, 22, 23],
                            22: [0, 1, 22, 23],
                            23: [
                                [0, 3],
                                [23, 25], 27, 28
                            ],
                            28: [0, 1, [22, 29]],
                            29: [0, 1, [22, 29]],
                            30: [0, 1, [22, 24]],
                            31: [0, 1, [21, 31]],
                            32: [0, 1, [21, 27]],
                            40: [0, 2, 3, [21, 28]],
                            42: [
                                [0, 2], 21, [23, 26]
                            ],
                            43: [0, 1, [21, 26]],
                            90: [
                                [0, 4]
                            ],
                            27: [
                                [0, 2], 22, 23
                            ]
                        },
                        71: {
                            0: [0]
                        },
                        81: {
                            0: [0]
                        },
                        82: {
                            0: [0]
                        }
                    },
                    d = parseInt(b.substr(0, 2), 10),
                    e = parseInt(b.substr(2, 2), 10),
                    f = parseInt(b.substr(4, 2), 10);
                if (!c[d] || !c[d][e]) return !1;
                for (var g = !1, h = c[d][e], i = 0; i < h.length; i++)
                    if (a.isArray(h[i]) && h[i][0] <= f && f <= h[i][1] || !a.isArray(h[i]) && f === h[i]) {
                        g = !0;
                        break
                    }
                if (!g) return !1;
                var j;
                j = 18 === b.length ? b.substr(6, 8) : "19" + b.substr(6, 6);
                var k = parseInt(j.substr(0, 4), 10),
                    l = parseInt(j.substr(4, 2), 10),
                    m = parseInt(j.substr(6, 2), 10);
                if (!FormValidation.Helper.date(k, l, m)) return !1;
                if (18 === b.length) {
                    var n = 0,
                        o = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
                    for (i = 0; 17 > i; i++) n += parseInt(b.charAt(i), 10) * o[i];
                    n = (12 - n % 11) % 11;
                    var p = "X" !== b.charAt(17).toUpperCase() ? parseInt(b.charAt(17), 10) : 10;
                    return p === n
                }
                return !0
            },
            _cz: function(a) {
                if (!/^\d{9,10}$/.test(a)) return !1;
                var b = 1900 + parseInt(a.substr(0, 2), 10),
                    c = parseInt(a.substr(2, 2), 10) % 50 % 20,
                    d = parseInt(a.substr(4, 2), 10);
                if (9 === a.length) {
                    if (b >= 1980 && (b -= 100), b > 1953) return !1
                } else 1954 > b && (b += 100);
                if (!FormValidation.Helper.date(b, c, d)) return !1;
                if (10 === a.length) {
                    var e = parseInt(a.substr(0, 9), 10) % 11;
                    return 1985 > b && (e %= 10), e + "" === a.substr(9, 1)
                }
                return !0
            },
            _dk: function(a) {
                if (!/^[0-9]{6}[-]{0,1}[0-9]{4}$/.test(a)) return !1;
                a = a.replace(/-/g, "");
                var b = parseInt(a.substr(0, 2), 10),
                    c = parseInt(a.substr(2, 2), 10),
                    d = parseInt(a.substr(4, 2), 10);
                switch (!0) {
                    case -1 !== "5678".indexOf(a.charAt(6)) && d >= 58:
                        d += 1800;
                        break;
                    case -1 !== "0123".indexOf(a.charAt(6)):
                    case -1 !== "49".indexOf(a.charAt(6)) && d >= 37:
                        d += 1900;
                        break;
                    default:
                        d += 2e3
                }
                return FormValidation.Helper.date(d, c, b)
            },
            _ee: function(a) {
                return this._lt(a)
            },
            _es: function(a) {
                var b = /^[0-9]{8}[-]{0,1}[A-HJ-NP-TV-Z]$/.test(a),
                    c = /^[XYZ][-]{0,1}[0-9]{7}[-]{0,1}[A-HJ-NP-TV-Z]$/.test(a),
                    d = /^[A-HNPQS][-]{0,1}[0-9]{7}[-]{0,1}[0-9A-J]$/.test(a);
                if (!b && !c && !d) return !1;
                a = a.replace(/-/g, "");
                var e, f, g = !0;
                if (b || c) {
                    f = "DNI";
                    var h = "XYZ".indexOf(a.charAt(0));
                    return -1 !== h && (a = h + a.substr(1) + "", f = "NIE"), e = parseInt(a.substr(0, 8), 10), e = "TRWAGMYFPDXBNJZSQVHLCKE" [e % 23], {
                        valid: e === a.substr(8, 1),
                        type: f
                    }
                }
                e = a.substr(1, 7), f = "CIF";
                for (var i = a[0], j = a.substr(-1), k = 0, l = 0; l < e.length; l++)
                    if (l % 2 !== 0) k += parseInt(e[l], 10);
                    else {
                        var m = "" + 2 * parseInt(e[l], 10);
                        k += parseInt(m[0], 10), 2 === m.length && (k += parseInt(m[1], 10))
                    }
                var n = k - 10 * Math.floor(k / 10);
                return 0 !== n && (n = 10 - n), g = -1 !== "KQS".indexOf(i) ? j === "JABCDEFGHI" [n] : -1 !== "ABEH".indexOf(i) ? j === "" + n : j === "" + n || j === "JABCDEFGHI" [n], {
                    valid: g,
                    type: f
                }
            },
            _fi: function(a) {
                if (!/^[0-9]{6}[-+A][0-9]{3}[0-9ABCDEFHJKLMNPRSTUVWXY]$/.test(a)) return !1;
                var b = parseInt(a.substr(0, 2), 10),
                    c = parseInt(a.substr(2, 2), 10),
                    d = parseInt(a.substr(4, 2), 10),
                    e = {
                        "+": 1800,
                        "-": 1900,
                        A: 2e3
                    };
                if (d = e[a.charAt(6)] + d, !FormValidation.Helper.date(d, c, b)) return !1;
                var f = parseInt(a.substr(7, 3), 10);
                if (2 > f) return !1;
                var g = a.substr(0, 6) + a.substr(7, 3) + "";
                return g = parseInt(g, 10), "0123456789ABCDEFHJKLMNPRSTUVWXY".charAt(g % 31) === a.charAt(10)
            },
            _hr: function(a) {
                return /^[0-9]{11}$/.test(a) ? FormValidation.Helper.mod11And10(a) : !1
            },
            _ie: function(a) {
                if (!/^\d{7}[A-W][AHWTX]?$/.test(a)) return !1;
                var b = function(a) {
                    for (; a.length < 7;) a = "0" + a;
                    for (var b = "WABCDEFGHIJKLMNOPQRSTUV", c = 0, d = 0; 7 > d; d++) c += parseInt(a.charAt(d), 10) * (8 - d);
                    return c += 9 * b.indexOf(a.substr(7)), b[c % 23]
                };
                return 9 !== a.length || "A" !== a.charAt(8) && "H" !== a.charAt(8) ? a.charAt(7) === b(a.substr(0, 7)) : a.charAt(7) === b(a.substr(0, 7) + a.substr(8) + "")
            },
            _is: function(a) {
                if (!/^[0-9]{6}[-]{0,1}[0-9]{4}$/.test(a)) return !1;
                a = a.replace(/-/g, "");
                var b = parseInt(a.substr(0, 2), 10),
                    c = parseInt(a.substr(2, 2), 10),
                    d = parseInt(a.substr(4, 2), 10),
                    e = parseInt(a.charAt(9), 10);
                if (d = 9 === e ? 1900 + d : 100 * (20 + e) + d, !FormValidation.Helper.date(d, c, b, !0)) return !1;
                for (var f = 0, g = [3, 2, 7, 6, 5, 4, 3, 2], h = 0; 8 > h; h++) f += parseInt(a.charAt(h), 10) * g[h];
                return f = 11 - f % 11, f + "" === a.charAt(8)
            },
            _lt: function(a) {
                if (!/^[0-9]{11}$/.test(a)) return !1;
                var b = parseInt(a.charAt(0), 10),
                    c = parseInt(a.substr(1, 2), 10),
                    d = parseInt(a.substr(3, 2), 10),
                    e = parseInt(a.substr(5, 2), 10),
                    f = b % 2 === 0 ? 17 + b / 2 : 17 + (b + 1) / 2;
                if (c = 100 * f + c, !FormValidation.Helper.date(c, d, e, !0)) return !1;
                for (var g = 0, h = [1, 2, 3, 4, 5, 6, 7, 8, 9, 1], i = 0; 10 > i; i++) g += parseInt(a.charAt(i), 10) * h[i];
                if (g %= 11, 10 !== g) return g + "" === a.charAt(10);
                for (g = 0, h = [3, 4, 5, 6, 7, 8, 9, 1, 2, 3], i = 0; 10 > i; i++) g += parseInt(a.charAt(i), 10) * h[i];
                return g %= 11, 10 === g && (g = 0), g + "" === a.charAt(10)
            },
            _lv: function(a) {
                if (!/^[0-9]{6}[-]{0,1}[0-9]{5}$/.test(a)) return !1;
                a = a.replace(/\D/g, "");
                var b = parseInt(a.substr(0, 2), 10),
                    c = parseInt(a.substr(2, 2), 10),
                    d = parseInt(a.substr(4, 2), 10);
                if (d = d + 1800 + 100 * parseInt(a.charAt(6), 10), !FormValidation.Helper.date(d, c, b, !0)) return !1;
                for (var e = 0, f = [10, 5, 8, 4, 2, 1, 6, 3, 7, 9], g = 0; 10 > g; g++) e += parseInt(a.charAt(g), 10) * f[g];
                return e = (e + 1) % 11 % 10, e + "" === a.charAt(10)
            },
            _nl: function(a) {
                if (a.length < 8) return !1;
                if (8 === a.length && (a = "0" + a), !/^[0-9]{4}[.]{0,1}[0-9]{2}[.]{0,1}[0-9]{3}$/.test(a)) return !1;
                if (a = a.replace(/\./g, ""), 0 === parseInt(a, 10)) return !1;
                for (var b = 0, c = a.length, d = 0; c - 1 > d; d++) b += (9 - d) * parseInt(a.charAt(d), 10);
                return b %= 11, 10 === b && (b = 0), b + "" === a.charAt(c - 1)
            },
            _pl: function(a) {
                if (!/^[0-9]{11}$/.test(a)) return !1;
                for (var b = 0, c = a.length, d = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3, 7], e = 0; c - 1 > e; e++) b += d[e] * parseInt(a.charAt(e), 10);
                return b %= 10, 0 === b && (b = 10), b = 10 - b, b + "" === a.charAt(c - 1)
            },
            _ro: function(a) {
                if (!/^[0-9]{13}$/.test(a)) return !1;
                var b = parseInt(a.charAt(0), 10);
                if (0 === b || 7 === b || 8 === b) return !1;
                var c = parseInt(a.substr(1, 2), 10),
                    d = parseInt(a.substr(3, 2), 10),
                    e = parseInt(a.substr(5, 2), 10),
                    f = {
                        1: 1900,
                        2: 1900,
                        3: 1800,
                        4: 1800,
                        5: 2e3,
                        6: 2e3
                    };
                if (e > 31 && d > 12) return !1;
                if (9 !== b && (c = f[b + ""] + c, !FormValidation.Helper.date(c, d, e))) return !1;
                for (var g = 0, h = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9], i = a.length, j = 0; i - 1 > j; j++) g += parseInt(a.charAt(j), 10) * h[j];
                return g %= 11, 10 === g && (g = 1), g + "" === a.charAt(i - 1)
            },
            _se: function(a) {
                if (!/^[0-9]{10}$/.test(a) && !/^[0-9]{6}[-|+][0-9]{4}$/.test(a)) return !1;
                a = a.replace(/[^0-9]/g, "");
                var b = parseInt(a.substr(0, 2), 10) + 1900,
                    c = parseInt(a.substr(2, 2), 10),
                    d = parseInt(a.substr(4, 2), 10);
                return FormValidation.Helper.date(b, c, d) ? FormValidation.Helper.luhn(a) : !1
            },
            _sk: function(a) {
                return this._cz(a)
            },
            _sm: function(a) {
                return /^\d{5}$/.test(a)
            },
            _th: function(a) {
                if (13 !== a.length) return !1;
                for (var b = 0, c = 0; 12 > c; c++) b += parseInt(a.charAt(c), 10) * (13 - c);
                return (11 - b % 11) % 10 === parseInt(a.charAt(12), 10)
            },
            _za: function(a) {
                if (!/^[0-9]{10}[0|1][8|9][0-9]$/.test(a)) return !1;
                var b = parseInt(a.substr(0, 2), 10),
                    c = (new Date).getFullYear() % 100,
                    d = parseInt(a.substr(2, 2), 10),
                    e = parseInt(a.substr(4, 2), 10);
                return b = b >= c ? b + 1900 : b + 2e3, FormValidation.Helper.date(b, d, e) ? FormValidation.Helper.luhn(a) : !1
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                identical: {
                    "default": "Please enter the same value"
                }
            }
        }), FormValidation.Validator.identical = {
            html5Attributes: {
                message: "message",
                field: "field"
            },
            init: function(a, b, c, d) {
                var e = a.getFieldElements(c.field);
                a.onLiveChange(e, "live_" + d, function() {
                    var c = a.getStatus(b, d);
                    c !== a.STATUS_NOT_VALIDATED && a.revalidateField(b)
                })
            },
            destroy: function(a, b, c, d) {
                var e = a.getFieldElements(c.field);
                a.offLiveChange(e, "live_" + d)
            },
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d),
                    f = a.getFieldElements(c.field);
                if (null === f || 0 === f.length) return !0;
                var g = a.getFieldValue(f, d);
                return e === g ? (a.updateStatus(f, a.STATUS_VALID, d), !0) : !1
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                imei: {
                    "default": "Please enter a valid IMEI number"
                }
            }
        }), FormValidation.Validator.imei = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                switch (!0) {
                    case /^\d{15}$/.test(e):
                    case /^\d{2}-\d{6}-\d{6}-\d{1}$/.test(e):
                    case /^\d{2}\s\d{6}\s\d{6}\s\d{1}$/.test(e):
                        return e = e.replace(/[^0-9]/g, ""), FormValidation.Helper.luhn(e);
                    case /^\d{14}$/.test(e):
                    case /^\d{16}$/.test(e):
                    case /^\d{2}-\d{6}-\d{6}(|-\d{2})$/.test(e):
                    case /^\d{2}\s\d{6}\s\d{6}(|\s\d{2})$/.test(e):
                        return !0;
                    default:
                        return !1
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                imo: {
                    "default": "Please enter a valid IMO number"
                }
            }
        }), FormValidation.Validator.imo = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                if (!/^IMO \d{7}$/i.test(e)) return !1;
                for (var f = 0, g = e.replace(/^.*(\d{7})$/, "$1"), h = 6; h >= 1; h--) f += g.slice(6 - h, -h) * (h + 1);
                return f % 10 === parseInt(g.charAt(6), 10)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                integer: {
                    "default": "Please enter a valid number"
                }
            }
        }), FormValidation.Validator.integer = {
            html5Attributes: {
                message: "message",
                thousandsseparator: "thousandsSeparator",
                decimalseparator: "decimalSeparator"
            },
            enableByHtml5: function(a) {
                return "number" === a.attr("type") && (void 0 === a.attr("step") || a.attr("step") % 1 === 0)
            },
            validate: function(a, b, c, d) {
                if (this.enableByHtml5(b) && b.get(0).validity && b.get(0).validity.badInput === !0) return !1;
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                var f = c.decimalSeparator || ".",
                    g = c.thousandsSeparator || "";
                f = "." === f ? "\\." : f, g = "." === g ? "\\." : g;
                var h = new RegExp("^-?[0-9]{1,3}(" + g + "[0-9]{3})*(" + f + "[0-9]+)?$"),
                    i = new RegExp(g, "g");
                return h.test(e) ? (g && (e = e.replace(i, "")), f && (e = e.replace(f, ".")), isNaN(e) || !isFinite(e) ? !1 : (e = parseFloat(e), Math.floor(e) === e)) : !1
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                ip: {
                    "default": "Please enter a valid IP address",
                    ipv4: "Please enter a valid IPv4 address",
                    ipv6: "Please enter a valid IPv6 address"
                }
            }
        }), FormValidation.Validator.ip = {
            html5Attributes: {
                message: "message",
                ipv4: "ipv4",
                ipv6: "ipv6"
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                d = a.extend({}, {
                    ipv4: !0,
                    ipv6: !0
                }, d);
                var g, h = b.getLocale(),
                    i = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
                    j = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/,
                    k = !1;
                switch (!0) {
                    case d.ipv4 && !d.ipv6:
                        k = i.test(f), g = d.message || FormValidation.I18n[h].ip.ipv4;
                        break;
                    case !d.ipv4 && d.ipv6:
                        k = j.test(f), g = d.message || FormValidation.I18n[h].ip.ipv6;
                        break;
                    case d.ipv4 && d.ipv6:
                    default:
                        k = i.test(f) || j.test(f), g = d.message || FormValidation.I18n[h].ip["default"]
                }
                return {
                    valid: k,
                    message: g
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                isbn: {
                    "default": "Please enter a valid ISBN number"
                }
            }
        }), FormValidation.Validator.isbn = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                var f;
                switch (!0) {
                    case /^\d{9}[\dX]$/.test(e):
                    case 13 === e.length && /^(\d+)-(\d+)-(\d+)-([\dX])$/.test(e):
                    case 13 === e.length && /^(\d+)\s(\d+)\s(\d+)\s([\dX])$/.test(e):
                        f = "ISBN10";
                        break;
                    case /^(978|979)\d{9}[\dX]$/.test(e):
                    case 17 === e.length && /^(978|979)-(\d+)-(\d+)-(\d+)-([\dX])$/.test(e):
                    case 17 === e.length && /^(978|979)\s(\d+)\s(\d+)\s(\d+)\s([\dX])$/.test(e):
                        f = "ISBN13";
                        break;
                    default:
                        return !1
                }
                e = e.replace(/[^0-9X]/gi, "");
                var g, h, i = e.split(""),
                    j = i.length,
                    k = 0;
                switch (f) {
                    case "ISBN10":
                        for (k = 0, g = 0; j - 1 > g; g++) k += parseInt(i[g], 10) * (10 - g);
                        return h = 11 - k % 11, 11 === h ? h = 0 : 10 === h && (h = "X"), {
                            type: f,
                            valid: h + "" === i[j - 1]
                        };
                    case "ISBN13":
                        for (k = 0, g = 0; j - 1 > g; g++) k += g % 2 === 0 ? parseInt(i[g], 10) : 3 * parseInt(i[g], 10);
                        return h = 10 - k % 10, 10 === h && (h = "0"), {
                            type: f,
                            valid: h + "" === i[j - 1]
                        };
                    default:
                        return !1
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                isin: {
                    "default": "Please enter a valid ISIN number"
                }
            }
        }), FormValidation.Validator.isin = {
            COUNTRY_CODES: "AF|AX|AL|DZ|AS|AD|AO|AI|AQ|AG|AR|AM|AW|AU|AT|AZ|BS|BH|BD|BB|BY|BE|BZ|BJ|BM|BT|BO|BQ|BA|BW|BV|BR|IO|BN|BG|BF|BI|KH|CM|CA|CV|KY|CF|TD|CL|CN|CX|CC|CO|KM|CG|CD|CK|CR|CI|HR|CU|CW|CY|CZ|DK|DJ|DM|DO|EC|EG|SV|GQ|ER|EE|ET|FK|FO|FJ|FI|FR|GF|PF|TF|GA|GM|GE|DE|GH|GI|GR|GL|GD|GP|GU|GT|GG|GN|GW|GY|HT|HM|VA|HN|HK|HU|IS|IN|ID|IR|IQ|IE|IM|IL|IT|JM|JP|JE|JO|KZ|KE|KI|KP|KR|KW|KG|LA|LV|LB|LS|LR|LY|LI|LT|LU|MO|MK|MG|MW|MY|MV|ML|MT|MH|MQ|MR|MU|YT|MX|FM|MD|MC|MN|ME|MS|MA|MZ|MM|NA|NR|NP|NL|NC|NZ|NI|NE|NG|NU|NF|MP|NO|OM|PK|PW|PS|PA|PG|PY|PE|PH|PN|PL|PT|PR|QA|RE|RO|RU|RW|BL|SH|KN|LC|MF|PM|VC|WS|SM|ST|SA|SN|RS|SC|SL|SG|SX|SK|SI|SB|SO|ZA|GS|SS|ES|LK|SD|SR|SJ|SZ|SE|CH|SY|TW|TJ|TZ|TH|TL|TG|TK|TO|TT|TN|TR|TM|TC|TV|UG|UA|AE|GB|US|UM|UY|UZ|VU|VE|VN|VG|VI|WF|EH|YE|ZM|ZW",
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                e = e.toUpperCase();
                var f = new RegExp("^(" + this.COUNTRY_CODES + ")[0-9A-Z]{10}$");
                if (!f.test(e)) return !1;
                for (var g = "", h = e.length, i = 0; h - 1 > i; i++) {
                    var j = e.charCodeAt(i);
                    g += j > 57 ? (j - 55).toString() : e.charAt(i)
                }
                var k = "",
                    l = g.length,
                    m = l % 2 !== 0 ? 0 : 1;
                for (i = 0; l > i; i++) k += parseInt(g[i], 10) * (i % 2 === m ? 2 : 1) + "";
                var n = 0;
                for (i = 0; i < k.length; i++) n += parseInt(k.charAt(i), 10);
                return n = (10 - n % 10) % 10, n + "" === e.charAt(h - 1)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                ismn: {
                    "default": "Please enter a valid ISMN number"
                }
            }
        }), FormValidation.Validator.ismn = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                var f;
                switch (!0) {
                    case /^M\d{9}$/.test(e):
                    case /^M-\d{4}-\d{4}-\d{1}$/.test(e):
                    case /^M\s\d{4}\s\d{4}\s\d{1}$/.test(e):
                        f = "ISMN10";
                        break;
                    case /^9790\d{9}$/.test(e):
                    case /^979-0-\d{4}-\d{4}-\d{1}$/.test(e):
                    case /^979\s0\s\d{4}\s\d{4}\s\d{1}$/.test(e):
                        f = "ISMN13";
                        break;
                    default:
                        return !1
                }
                "ISMN10" === f && (e = "9790" + e.substr(1)), e = e.replace(/[^0-9]/gi, "");
                for (var g = e.length, h = 0, i = [1, 3], j = 0; g - 1 > j; j++) h += parseInt(e.charAt(j), 10) * i[j % 2];
                return h = 10 - h % 10, {
                    type: f,
                    valid: h + "" === e.charAt(g - 1)
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                issn: {
                    "default": "Please enter a valid ISSN number"
                }
            }
        }), FormValidation.Validator.issn = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                if (!/^\d{4}\-\d{3}[\dX]$/.test(e)) return !1;
                e = e.replace(/[^0-9X]/gi, "");
                var f = e.split(""),
                    g = f.length,
                    h = 0;
                "X" === f[7] && (f[7] = 10);
                for (var i = 0; g > i; i++) h += parseInt(f[i], 10) * (8 - i);
                return h % 11 === 0
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                lessThan: {
                    "default": "Please enter a value less than or equal to %s",
                    notInclusive: "Please enter a value less than %s"
                }
            }
        }), FormValidation.Validator.lessThan = {
            html5Attributes: {
                message: "message",
                value: "value",
                inclusive: "inclusive"
            },
            enableByHtml5: function(a) {
                var b = a.attr("type"),
                    c = a.attr("max");
                return c && "date" !== b ? {
                    value: c
                } : !1
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                f = this._format(f);
                var g = b.getLocale(),
                    h = a.isNumeric(d.value) ? d.value : b.getDynamicOption(c, d.value),
                    i = this._format(h);
                return d.inclusive === !0 || void 0 === d.inclusive ? {
                    valid: a.isNumeric(f) && parseFloat(f) <= i,
                    message: FormValidation.Helper.format(d.message || FormValidation.I18n[g].lessThan["default"], h)
                } : {
                    valid: a.isNumeric(f) && parseFloat(f) < i,
                    message: FormValidation.Helper.format(d.message || FormValidation.I18n[g].lessThan.notInclusive, h)
                }
            },
            _format: function(a) {
                return (a + "").replace(",", ".")
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                mac: {
                    "default": "Please enter a valid MAC address"
                }
            }
        }), FormValidation.Validator.mac = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                return "" === e ? !0 : /^([0-9A-F]{2}[:-]){5}([0-9A-F]{2})$/.test(e)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                meid: {
                    "default": "Please enter a valid MEID number"
                }
            }
        }), FormValidation.Validator.meid = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                switch (!0) {
                    case /^[0-9A-F]{15}$/i.test(e):
                    case /^[0-9A-F]{2}[- ][0-9A-F]{6}[- ][0-9A-F]{6}[- ][0-9A-F]$/i.test(e):
                    case /^\d{19}$/.test(e):
                    case /^\d{5}[- ]\d{5}[- ]\d{4}[- ]\d{4}[- ]\d$/.test(e):
                        var f = e.charAt(e.length - 1);
                        if (e = e.replace(/[- ]/g, ""), e.match(/^\d*$/i)) return FormValidation.Helper.luhn(e);
                        e = e.slice(0, -1);
                        for (var g = "", h = 1; 13 >= h; h += 2) g += (2 * parseInt(e.charAt(h), 16)).toString(16);
                        var i = 0;
                        for (h = 0; h < g.length; h++) i += parseInt(g.charAt(h), 16);
                        return i % 10 === 0 ? "0" === f : f === (2 * (10 * Math.floor((i + 10) / 10) - i)).toString(16);
                    case /^[0-9A-F]{14}$/i.test(e):
                    case /^[0-9A-F]{2}[- ][0-9A-F]{6}[- ][0-9A-F]{6}$/i.test(e):
                    case /^\d{18}$/.test(e):
                    case /^\d{5}[- ]\d{5}[- ]\d{4}[- ]\d{4}$/.test(e):
                        return !0;
                    default:
                        return !1
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                notEmpty: {
                    "default": "Please enter a value"
                }
            }
        }), FormValidation.Validator.notEmpty = {
            enableByHtml5: function(a) {
                var b = a.attr("required") + "";
                return "required" === b || "true" === b
            },
            validate: function(b, c, d, e) {
                var f = c.attr("type");
                if ("radio" === f || "checkbox" === f) {
                    var g = b.getNamespace();
                    return b.getFieldElements(c.attr("data-" + g + "-field")).filter(":checked").length > 0
                }
                if ("number" === f && c.get(0).validity && c.get(0).validity.badInput === !0) return !0;
                var h = b.getFieldValue(c, e);
                return "" !== a.trim(h)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                numeric: {
                    "default": "Please enter a valid float number"
                }
            }
        }), FormValidation.Validator.numeric = {
            html5Attributes: {
                message: "message",
                separator: "separator",
                thousandsseparator: "thousandsSeparator",
                decimalseparator: "decimalSeparator"
            },
            enableByHtml5: function(a) {
                return "number" === a.attr("type") && void 0 !== a.attr("step") && a.attr("step") % 1 !== 0
            },
            validate: function(a, b, c, d) {
                if (this.enableByHtml5(b) && b.get(0).validity && b.get(0).validity.badInput === !0) return !1;
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                var f = c.separator || c.decimalSeparator || ".",
                    g = c.thousandsSeparator || "";
                f = "." === f ? "\\." : f, g = "." === g ? "\\." : g;
                var h = new RegExp("^-?[0-9]{1,3}(" + g + "[0-9]{3})*(" + f + "[0-9]+)?$"),
                    i = new RegExp(g, "g");
                return h.test(e) ? (g && (e = e.replace(i, "")), f && (e = e.replace(f, ".")), !isNaN(parseFloat(e)) && isFinite(e)) : !1
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                phone: {
                    "default": "Please enter a valid phone number",
                    country: "Please enter a valid phone number in %s",
                    countries: {
                        AE: "United Arab Emirates",
                        BG: "Bulgaria",
                        BR: "Brazil",
                        CN: "China",
                        CZ: "Czech Republic",
                        DE: "Germany",
                        DK: "Denmark",
                        ES: "Spain",
                        FR: "France",
                        GB: "United Kingdom",
                        IN: "India",
                        MA: "Morocco",
                        NL: "Netherlands",
                        PK: "Pakistan",
                        RO: "Romania",
                        RU: "Russia",
                        SK: "Slovakia",
                        TH: "Thailand",
                        US: "USA",
                        VE: "Venezuela"
                    }
                }
            }
        }), FormValidation.Validator.phone = {
            html5Attributes: {
                message: "message",
                country: "country"
            },
            COUNTRY_CODES: ["AE", "BG", "BR", "CN", "CZ", "DE", "DK", "ES", "FR", "GB", "IN", "MA", "NL", "PK", "RO", "RU", "SK", "TH", "US", "VE"],
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                var g = b.getLocale(),
                    h = d.country;
                if (("string" != typeof h || -1 === a.inArray(h, this.COUNTRY_CODES)) && (h = b.getDynamicOption(c, h)), !h || -1 === a.inArray(h.toUpperCase(), this.COUNTRY_CODES)) return !0;
                var i = !0;
                switch (h.toUpperCase()) {
                    case "AE":
                        f = a.trim(f), i = /^(((\+|00)?971[\s\.-]?(\(0\)[\s\.-]?)?|0)(\(5(0|2|5|6)\)|5(0|2|5|6)|2|3|4|6|7|9)|60)([\s\.-]?[0-9]){7}$/.test(f);
                        break;
                    case "BG":
                        f = f.replace(/\+|\s|-|\/|\(|\)/gi, ""), i = /^(0|359|00)(((700|900)[0-9]{5}|((800)[0-9]{5}|(800)[0-9]{4}))|(87|88|89)([0-9]{7})|((2[0-9]{7})|(([3-9][0-9])(([0-9]{6})|([0-9]{5})))))$/.test(f);
                        break;
                    case "BR":
                        f = a.trim(f), i = /^(([\d]{4}[-.\s]{1}[\d]{2,3}[-.\s]{1}[\d]{2}[-.\s]{1}[\d]{2})|([\d]{4}[-.\s]{1}[\d]{3}[-.\s]{1}[\d]{4})|((\(?\+?[0-9]{2}\)?\s?)?(\(?\d{2}\)?\s?)?\d{4,5}[-.\s]?\d{4}))$/.test(f);
                        break;
                    case "CN":
                        f = a.trim(f), i = /^((00|\+)?(86(?:-| )))?((\d{11})|(\d{3}[- ]{1}\d{4}[- ]{1}\d{4})|((\d{2,4}[- ]){1}(\d{7,8}|(\d{3,4}[- ]{1}\d{4}))([- ]{1}\d{1,4})?))$/.test(f);
                        break;
                    case "CZ":
                        i = /^(((00)([- ]?)|\+)(420)([- ]?))?((\d{3})([- ]?)){2}(\d{3})$/.test(f);
                        break;
                    case "DE":
                        f = a.trim(f), i = /^(((((((00|\+)49[ \-/]?)|0)[1-9][0-9]{1,4})[ \-/]?)|((((00|\+)49\()|\(0)[1-9][0-9]{1,4}\)[ \-/]?))[0-9]{1,7}([ \-/]?[0-9]{1,5})?)$/.test(f);
                        break;
                    case "DK":
                        f = a.trim(f), i = /^(\+45|0045|\(45\))?\s?[2-9](\s?\d){7}$/.test(f);
                        break;
                    case "ES":
                        f = a.trim(f), i = /^(?:(?:(?:\+|00)34\D?))?(?:5|6|7|8|9)(?:\d\D?){8}$/.test(f);
                        break;
                    case "FR":
                        f = a.trim(f), i = /^(?:(?:(?:\+|00)33[ ]?(?:\(0\)[ ]?)?)|0){1}[1-9]{1}([ .-]?)(?:\d{2}\1?){3}\d{2}$/.test(f);
                        break;
                    case "GB":
                        f = a.trim(f), i = /^\(?(?:(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?\(?(?:0\)?[\s-]?\(?)?|0)(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}|\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4}|\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3})|\d{5}\)?[\s-]?\d{4,5}|8(?:00[\s-]?11[\s-]?11|45[\s-]?46[\s-]?4\d))(?:(?:[\s-]?(?:x|ext\.?\s?|\#)\d+)?)$/.test(f);
                        break;
                    case "IN":
                        f = a.trim(f), i = /((\+?)((0[ -]+)*|(91 )*)(\d{12}|\d{10}))|\d{5}([- ]*)\d{6}/.test(f);
                        break;
                    case "MA":
                        f = a.trim(f), i = /^(?:(?:(?:\+|00)212[\s]?(?:[\s]?\(0\)[\s]?)?)|0){1}(?:5[\s.-]?[2-3]|6[\s.-]?[13-9]){1}[0-9]{1}(?:[\s.-]?\d{2}){3}$/.test(f);
                        break;
                    case "NL":
                        f = a.trim(f), i = /^((\+|00(\s|\s?\-\s?)?)31(\s|\s?\-\s?)?(\(0\)[\-\s]?)?|0)[1-9]((\s|\s?\-\s?)?[0-9])((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]$/gm.test(f);
                        break;
                    case "PK":
                        f = a.trim(f), i = /^0?3[0-9]{2}[0-9]{7}$/.test(f);
                        break;
                    case "RO":
                        i = /^(\+4|)?(07[0-8]{1}[0-9]{1}|02[0-9]{2}|03[0-9]{2}){1}?(\s|\.|\-)?([0-9]{3}(\s|\.|\-|)){2}$/g.test(f);
                        break;
                    case "RU":
                        i = /^((8|\+7|007)[\-\.\/ ]?)?([\(\/\.]?\d{3}[\)\/\.]?[\-\.\/ ]?)?[\d\-\.\/ ]{7,10}$/g.test(f);
                        break;
                    case "SK":
                        i = /^(((00)([- ]?)|\+)(421)([- ]?))?((\d{3})([- ]?)){2}(\d{3})$/.test(f);
                        break;
                    case "TH":
                        i = /^0\(?([6|8-9]{2})*-([0-9]{3})*-([0-9]{4})$/.test(f);
                        break;
                    case "VE":
                        f = a.trim(f), i = /^0(?:2(?:12|4[0-9]|5[1-9]|6[0-9]|7[0-8]|8[1-35-8]|9[1-5]|3[45789])|4(?:1[246]|2[46]))\d{7}$/.test(f);
                        break;
                    case "US":
                    default:
                        i = /^(?:(1\-?)|(\+1 ?))?\(?(\d{3})[\)\-\.]?(\d{3})[\-\.]?(\d{4})$/.test(f)
                }
                return {
                    valid: i,
                    message: FormValidation.Helper.format(d.message || FormValidation.I18n[g].phone.country, FormValidation.I18n[g].phone.countries[h])
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                promise: {
                    "default": "Please enter a valid value"
                }
            }
        }), FormValidation.Validator.promise = {
            html5Attributes: {
                message: "message",
                promise: "promise"
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e),
                    g = new a.Deferred,
                    h = FormValidation.Helper.call(d.promise, [f, b, c]);
                return h.done(function(a) {
                    g.resolve(c, e, a)
                }).fail(function(a) {
                    a = a || {}, a.valid = !1, g.resolve(c, e, a)
                }), g
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                regexp: {
                    "default": "Please enter a value matching the pattern"
                }
            }
        }), FormValidation.Validator.regexp = {
            html5Attributes: {
                message: "message",
                regexp: "regexp"
            },
            enableByHtml5: function(a) {
                var b = a.attr("pattern");
                return b ? {
                    regexp: b
                } : !1
            },
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                var f = "string" == typeof c.regexp ? new RegExp(c.regexp) : c.regexp;
                return f.test(e)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                remote: {
                    "default": "Please enter a valid value"
                }
            }
        }), FormValidation.Validator.remote = {
            html5Attributes: {
                crossdomain: "crossDomain",
                data: "data",
                datatype: "dataType",
                delay: "delay",
                message: "message",
                name: "name",
                type: "type",
                url: "url",
                validkey: "validKey"
            },
            destroy: function(a, b, c, d) {
                var e = a.getNamespace(),
                    f = b.data(e + "." + d + ".timer");
                f && (clearTimeout(f), b.removeData(e + "." + d + ".timer"))
            },
            validate: function(b, c, d, e) {
                function f() {
                    var b = a.ajax(n);
                    return b.success(function(a) {
                        a.valid = a[m] === !0 || "true" === a[m] ? !0 : a[m] === !1 || "false" === a[m] ? !1 : null, i.resolve(c, e, a)
                    }).error(function(a) {
                        i.resolve(c, e, {
                            valid: !1
                        })
                    }), i.fail(function() {
                        b.abort()
                    }), i
                }
                var g = b.getNamespace(),
                    h = b.getFieldValue(c, e),
                    i = new a.Deferred;
                if ("" === h) return i.resolve(c, e, {
                    valid: !0
                }), i;
                var j = c.attr("data-" + g + "-field"),
                    k = d.data || {},
                    l = d.url,
                    m = d.validKey || "valid";
                "function" == typeof k && (k = k.call(this, b, c, h)), "string" == typeof k && (k = JSON.parse(k)), "function" == typeof l && (l = l.call(this, b, c, h)), k[d.name || j] = h;
                var n = {
                    data: k,
                    dataType: d.dataType || "json",
                    headers: d.headers || {},
                    type: d.type || "GET",
                    url: l
                };
                return null !== d.crossDomain && (n.crossDomain = d.crossDomain === !0 || "true" === d.crossDomain), d.delay ? (c.data(g + "." + e + ".timer") && clearTimeout(c.data(g + "." + e + ".timer")), c.data(g + "." + e + ".timer", setTimeout(f, d.delay)), i) : f()
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                rtn: {
                    "default": "Please enter a valid RTN number"
                }
            }
        }), FormValidation.Validator.rtn = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                if (!/^\d{9}$/.test(e)) return !1;
                for (var f = 0, g = 0; g < e.length; g += 3) f += 3 * parseInt(e.charAt(g), 10) + 7 * parseInt(e.charAt(g + 1), 10) + parseInt(e.charAt(g + 2), 10);
                return 0 !== f && f % 10 === 0
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                sedol: {
                    "default": "Please enter a valid SEDOL number"
                }
            }
        }), FormValidation.Validator.sedol = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                if (e = e.toUpperCase(), !/^[0-9A-Z]{7}$/.test(e)) return !1;
                for (var f = 0, g = [1, 3, 1, 7, 3, 9, 1], h = e.length, i = 0; h - 1 > i; i++) f += g[i] * parseInt(e.charAt(i), 36);
                return f = (10 - f % 10) % 10, f + "" === e.charAt(h - 1)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                siren: {
                    "default": "Please enter a valid SIREN number"
                }
            }
        }), FormValidation.Validator.siren = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                return "" === e ? !0 : /^\d{9}$/.test(e) ? FormValidation.Helper.luhn(e) : !1
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                siret: {
                    "default": "Please enter a valid SIRET number"
                }
            }
        }), FormValidation.Validator.siret = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                for (var f, g = 0, h = e.length, i = 0; h > i; i++) f = parseInt(e.charAt(i), 10), i % 2 === 0 && (f = 2 * f, f > 9 && (f -= 9)), g += f;
                return g % 10 === 0
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                step: {
                    "default": "Please enter a valid step of %s"
                }
            }
        }), FormValidation.Validator.step = {
            html5Attributes: {
                message: "message",
                base: "baseValue",
                step: "step"
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                if (d = a.extend({}, {
                        baseValue: 0,
                        step: 1
                    }, d), f = parseFloat(f), !a.isNumeric(f)) return !1;
                var g = function(a, b) {
                        var c = Math.pow(10, b);
                        a *= c;
                        var d = a > 0 | -(0 > a),
                            e = a % 1 === .5 * d;
                        return e ? (Math.floor(a) + (d > 0)) / c : Math.round(a) / c
                    },
                    h = function(a, b) {
                        if (0 === b) return 1;
                        var c = (a + "").split("."),
                            d = (b + "").split("."),
                            e = (1 === c.length ? 0 : c[1].length) + (1 === d.length ? 0 : d[1].length);
                        return g(a - b * Math.floor(a / b), e)
                    },
                    i = b.getLocale(),
                    j = h(f - d.baseValue, d.step);
                return {
                    valid: 0 === j || j === d.step,
                    message: FormValidation.Helper.format(d.message || FormValidation.I18n[i].step["default"], [d.step])
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                stringCase: {
                    "default": "Please enter only lowercase characters",
                    upper: "Please enter only uppercase characters"
                }
            }
        }), FormValidation.Validator.stringCase = {
            html5Attributes: {
                message: "message",
                "case": "case"
            },
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                var f = a.getLocale(),
                    g = (c["case"] || "lower").toLowerCase();
                return {
                    valid: "upper" === g ? e === e.toUpperCase() : e === e.toLowerCase(),
                    message: c.message || ("upper" === g ? FormValidation.I18n[f].stringCase.upper : FormValidation.I18n[f].stringCase["default"])
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                stringLength: {
                    "default": "Please enter a value with valid length",
                    less: "Please enter less than %s characters",
                    more: "Please enter more than %s characters",
                    between: "Please enter value between %s and %s characters long"
                }
            }
        }), FormValidation.Validator.stringLength = {
            html5Attributes: {
                message: "message",
                min: "min",
                max: "max",
                trim: "trim",
                utf8bytes: "utf8Bytes"
            },
            enableByHtml5: function(b) {
                var c = {},
                    d = b.attr("maxlength"),
                    e = b.attr("minlength");
                return d && (c.max = parseInt(d, 10)), e && (c.min = parseInt(e, 10)), a.isEmptyObject(c) ? !1 : c
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ((d.trim === !0 || "true" === d.trim) && (f = a.trim(f)), "" === f) return !0;
                var g = b.getLocale(),
                    h = a.isNumeric(d.min) ? d.min : b.getDynamicOption(c, d.min),
                    i = a.isNumeric(d.max) ? d.max : b.getDynamicOption(c, d.max),
                    j = function(a) {
                        for (var b = a.length, c = a.length - 1; c >= 0; c--) {
                            var d = a.charCodeAt(c);
                            d > 127 && 2047 >= d ? b++ : d > 2047 && 65535 >= d && (b += 2), d >= 56320 && 57343 >= d && c--
                        }
                        return b
                    },
                    k = d.utf8Bytes ? j(f) : f.length,
                    l = !0,
                    m = d.message || FormValidation.I18n[g].stringLength["default"];
                switch ((h && k < parseInt(h, 10) || i && k > parseInt(i, 10)) && (l = !1), !0) {
                    case !!h && !!i:
                        m = FormValidation.Helper.format(d.message || FormValidation.I18n[g].stringLength.between, [parseInt(h, 10), parseInt(i, 10)]);
                        break;
                    case !!h:
                        m = FormValidation.Helper.format(d.message || FormValidation.I18n[g].stringLength.more, parseInt(h, 10) - 1);
                        break;
                    case !!i:
                        m = FormValidation.Helper.format(d.message || FormValidation.I18n[g].stringLength.less, parseInt(i, 10) + 1)
                }
                return {
                    valid: l,
                    message: m
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                uri: {
                    "default": "Please enter a valid URI"
                }
            }
        }), FormValidation.Validator.uri = {
            html5Attributes: {
                message: "message",
                allowlocal: "allowLocal",
                allowemptyprotocol: "allowEmptyProtocol",
                protocol: "protocol"
            },
            enableByHtml5: function(a) {
                return "url" === a.attr("type")
            },
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                var f = c.allowLocal === !0 || "true" === c.allowLocal,
                    g = c.allowEmptyProtocol === !0 || "true" === c.allowEmptyProtocol,
                    h = (c.protocol || "http, https, ftp").split(",").join("|").replace(/\s/g, ""),
                    i = new RegExp("^(?:(?:" + h + ")://)" + (g ? "?" : "") + "(?:\\S+(?::\\S*)?@)?(?:" + (f ? "" : "(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})") + "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-?)*[a-z\\u00a1-\\uffff0-9])*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" + (f ? "?" : "") + ")(?::\\d{2,5})?(?:/[^\\s]*)?$", "i");
                return i.test(e)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                uuid: {
                    "default": "Please enter a valid UUID number",
                    version: "Please enter a valid UUID version %s number"
                }
            }
        }), FormValidation.Validator.uuid = {
            html5Attributes: {
                message: "message",
                version: "version"
            },
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                var f = a.getLocale(),
                    g = {
                        3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
                        4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
                        5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
                        all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
                    },
                    h = c.version ? c.version + "" : "all";
                return {
                    valid: null === g[h] ? !0 : g[h].test(e),
                    message: c.version ? FormValidation.Helper.format(c.message || FormValidation.I18n[f].uuid.version, c.version) : c.message || FormValidation.I18n[f].uuid["default"]
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                vat: {
                    "default": "Please enter a valid VAT number",
                    country: "Please enter a valid VAT number in %s",
                    countries: {
                        AT: "Austria",
                        BE: "Belgium",
                        BG: "Bulgaria",
                        BR: "Brazil",
                        CH: "Switzerland",
                        CY: "Cyprus",
                        CZ: "Czech Republic",
                        DE: "Germany",
                        DK: "Denmark",
                        EE: "Estonia",
                        ES: "Spain",
                        FI: "Finland",
                        FR: "France",
                        GB: "United Kingdom",
                        GR: "Greek",
                        EL: "Greek",
                        HU: "Hungary",
                        HR: "Croatia",
                        IE: "Ireland",
                        IS: "Iceland",
                        IT: "Italy",
                        LT: "Lithuania",
                        LU: "Luxembourg",
                        LV: "Latvia",
                        MT: "Malta",
                        NL: "Netherlands",
                        NO: "Norway",
                        PL: "Poland",
                        PT: "Portugal",
                        RO: "Romania",
                        RU: "Russia",
                        RS: "Serbia",
                        SE: "Sweden",
                        SI: "Slovenia",
                        SK: "Slovakia",
                        VE: "Venezuela",
                        ZA: "South Africa"
                    }
                }
            }
        }), FormValidation.Validator.vat = {
            html5Attributes: {
                message: "message",
                country: "country"
            },
            COUNTRY_CODES: ["AT", "BE", "BG", "BR", "CH", "CY", "CZ", "DE", "DK", "EE", "EL", "ES", "FI", "FR", "GB", "GR", "HR", "HU", "IE", "IS", "IT", "LT", "LU", "LV", "MT", "NL", "NO", "PL", "PT", "RO", "RU", "RS", "SE", "SK", "SI", "VE", "ZA"],
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                var g = b.getLocale(),
                    h = d.country;
                if (h ? ("string" != typeof h || -1 === a.inArray(h.toUpperCase(), this.COUNTRY_CODES)) && (h = b.getDynamicOption(c, h)) : h = f.substr(0, 2), -1 === a.inArray(h, this.COUNTRY_CODES)) return !0;
                var i = ["_", h.toLowerCase()].join(""),
                    j = this[i](f);
                return j = j === !0 || j === !1 ? {
                    valid: j
                } : j, j.message = FormValidation.Helper.format(d.message || FormValidation.I18n[g].vat.country, FormValidation.I18n[g].vat.countries[h.toUpperCase()]), j
            },
            _at: function(a) {
                if (/^ATU[0-9]{8}$/.test(a) && (a = a.substr(2)), !/^U[0-9]{8}$/.test(a)) return !1;
                a = a.substr(1);
                for (var b = 0, c = [1, 2, 1, 2, 1, 2, 1], d = 0, e = 0; 7 > e; e++) d = parseInt(a.charAt(e), 10) * c[e], d > 9 && (d = Math.floor(d / 10) + d % 10), b += d;
                return b = 10 - (b + 4) % 10, 10 === b && (b = 0), b + "" === a.substr(7, 1)
            },
            _be: function(a) {
                if (/^BE[0]{0,1}[0-9]{9}$/.test(a) && (a = a.substr(2)), !/^[0]{0,1}[0-9]{9}$/.test(a)) return !1;
                if (9 === a.length && (a = "0" + a), "0" === a.substr(1, 1)) return !1;
                var b = parseInt(a.substr(0, 8), 10) + parseInt(a.substr(8, 2), 10);
                return b % 97 === 0
            },
            _bg: function(a) {
                if (/^BG[0-9]{9,10}$/.test(a) && (a = a.substr(2)), !/^[0-9]{9,10}$/.test(a)) return !1;
                var b = 0,
                    c = 0;
                if (9 === a.length) {
                    for (c = 0; 8 > c; c++) b += parseInt(a.charAt(c), 10) * (c + 1);
                    if (b %= 11, 10 === b)
                        for (b = 0, c = 0; 8 > c; c++) b += parseInt(a.charAt(c), 10) * (c + 3);
                    return b %= 10, b + "" === a.substr(8)
                }
                if (10 === a.length) {
                    var d = function(a) {
                            var b = parseInt(a.substr(0, 2), 10) + 1900,
                                c = parseInt(a.substr(2, 2), 10),
                                d = parseInt(a.substr(4, 2), 10);
                            if (c > 40 ? (b += 100, c -= 40) : c > 20 && (b -= 100, c -= 20), !FormValidation.Helper.date(b, c, d)) return !1;
                            for (var e = 0, f = [2, 4, 8, 5, 10, 9, 7, 3, 6], g = 0; 9 > g; g++) e += parseInt(a.charAt(g), 10) * f[g];
                            return e = e % 11 % 10, e + "" === a.substr(9, 1)
                        },
                        e = function(a) {
                            for (var b = 0, c = [21, 19, 17, 13, 11, 9, 7, 3, 1], d = 0; 9 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                            return b %= 10, b + "" === a.substr(9, 1)
                        },
                        f = function(a) {
                            for (var b = 0, c = [4, 3, 2, 7, 6, 5, 4, 3, 2], d = 0; 9 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                            return b = 11 - b % 11, 10 === b ? !1 : (11 === b && (b = 0), b + "" === a.substr(9, 1))
                        };
                    return d(a) || e(a) || f(a)
                }
                return !1
            },
            _br: function(a) {
                if ("" === a) return !0;
                var b = a.replace(/[^\d]+/g, "");
                if ("" === b || 14 !== b.length) return !1;
                if ("00000000000000" === b || "11111111111111" === b || "22222222222222" === b || "33333333333333" === b || "44444444444444" === b || "55555555555555" === b || "66666666666666" === b || "77777777777777" === b || "88888888888888" === b || "99999999999999" === b) return !1;
                for (var c = b.length - 2, d = b.substring(0, c), e = b.substring(c), f = 0, g = c - 7, h = c; h >= 1; h--) f += parseInt(d.charAt(c - h), 10) * g--, 2 > g && (g = 9);
                var i = 2 > f % 11 ? 0 : 11 - f % 11;
                if (i !== parseInt(e.charAt(0), 10)) return !1;
                for (c += 1, d = b.substring(0, c), f = 0, g = c - 7, h = c; h >= 1; h--) f += parseInt(d.charAt(c - h), 10) * g--, 2 > g && (g = 9);
                return i = 2 > f % 11 ? 0 : 11 - f % 11, i === parseInt(e.charAt(1), 10)
            },
            _ch: function(a) {
                if (/^CHE[0-9]{9}(MWST)?$/.test(a) && (a = a.substr(2)), !/^E[0-9]{9}(MWST)?$/.test(a)) return !1;
                a = a.substr(1);
                for (var b = 0, c = [5, 4, 3, 2, 7, 6, 5, 4], d = 0; 8 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b = 11 - b % 11, 10 === b ? !1 : (11 === b && (b = 0), b + "" === a.substr(8, 1))
            },
            _cy: function(a) {
                if (/^CY[0-5|9]{1}[0-9]{7}[A-Z]{1}$/.test(a) && (a = a.substr(2)), !/^[0-5|9]{1}[0-9]{7}[A-Z]{1}$/.test(a)) return !1;
                if ("12" === a.substr(0, 2)) return !1;
                for (var b = 0, c = {
                    0: 1,
                    1: 0,
                    2: 5,
                    3: 7,
                    4: 9,
                    5: 13,
                    6: 15,
                    7: 17,
                    8: 19,
                    9: 21
                }, d = 0; 8 > d; d++) {
                    var e = parseInt(a.charAt(d), 10);
                    d % 2 === 0 && (e = c[e + ""]), b += e
                }
                return b = "ABCDEFGHIJKLMNOPQRSTUVWXYZ" [b % 26], b + "" === a.substr(8, 1)
            },
            _cz: function(a) {
                if (/^CZ[0-9]{8,10}$/.test(a) && (a = a.substr(2)), !/^[0-9]{8,10}$/.test(a)) return !1;
                var b = 0,
                    c = 0;
                if (8 === a.length) {
                    if (a.charAt(0) + "" == "9") return !1;
                    for (b = 0, c = 0; 7 > c; c++) b += parseInt(a.charAt(c), 10) * (8 - c);
                    return b = 11 - b % 11, 10 === b && (b = 0), 11 === b && (b = 1), b + "" === a.substr(7, 1)
                }
                if (9 === a.length && a.charAt(0) + "" == "6") {
                    for (b = 0, c = 0; 7 > c; c++) b += parseInt(a.charAt(c + 1), 10) * (8 - c);
                    return b = 11 - b % 11, 10 === b && (b = 0), 11 === b && (b = 1), b = [8, 7, 6, 5, 4, 3, 2, 1, 0, 9, 10][b - 1], b + "" === a.substr(8, 1)
                }
                if (9 === a.length || 10 === a.length) {
                    var d = 1900 + parseInt(a.substr(0, 2), 10),
                        e = parseInt(a.substr(2, 2), 10) % 50 % 20,
                        f = parseInt(a.substr(4, 2), 10);
                    if (9 === a.length) {
                        if (d >= 1980 && (d -= 100), d > 1953) return !1
                    } else 1954 > d && (d += 100);
                    if (!FormValidation.Helper.date(d, e, f)) return !1;
                    if (10 === a.length) {
                        var g = parseInt(a.substr(0, 9), 10) % 11;
                        return 1985 > d && (g %= 10), g + "" === a.substr(9, 1)
                    }
                    return !0
                }
                return !1
            },
            _de: function(a) {
                return /^DE[0-9]{9}$/.test(a) && (a = a.substr(2)), /^[0-9]{9}$/.test(a) ? FormValidation.Helper.mod11And10(a) : !1
            },
            _dk: function(a) {
                if (/^DK[0-9]{8}$/.test(a) && (a = a.substr(2)), !/^[0-9]{8}$/.test(a)) return !1;
                for (var b = 0, c = [2, 7, 6, 5, 4, 3, 2, 1], d = 0; 8 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b % 11 === 0
            },
            _ee: function(a) {
                if (/^EE[0-9]{9}$/.test(a) && (a = a.substr(2)), !/^[0-9]{9}$/.test(a)) return !1;
                for (var b = 0, c = [3, 7, 1, 3, 7, 1, 3, 7, 1], d = 0; 9 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b % 10 === 0
            },
            _es: function(a) {
                if (/^ES[0-9A-Z][0-9]{7}[0-9A-Z]$/.test(a) && (a = a.substr(2)), !/^[0-9A-Z][0-9]{7}[0-9A-Z]$/.test(a)) return !1;
                var b = function(a) {
                        var b = parseInt(a.substr(0, 8), 10);
                        return b = "TRWAGMYFPDXBNJZSQVHLCKE" [b % 23], b + "" === a.substr(8, 1)
                    },
                    c = function(a) {
                        var b = ["XYZ".indexOf(a.charAt(0)), a.substr(1)].join("");
                        return b = parseInt(b, 10), b = "TRWAGMYFPDXBNJZSQVHLCKE" [b % 23], b + "" === a.substr(8, 1)
                    },
                    d = function(a) {
                        var b, c = a.charAt(0);
                        if (-1 !== "KLM".indexOf(c)) return b = parseInt(a.substr(1, 8), 10), b = "TRWAGMYFPDXBNJZSQVHLCKE" [b % 23], b + "" === a.substr(8, 1);
                        if (-1 !== "ABCDEFGHJNPQRSUVW".indexOf(c)) {
                            for (var d = 0, e = [2, 1, 2, 1, 2, 1, 2], f = 0, g = 0; 7 > g; g++) f = parseInt(a.charAt(g + 1), 10) * e[g], f > 9 && (f = Math.floor(f / 10) + f % 10), d += f;
                            return d = 10 - d % 10, 10 === d && (d = 0), d + "" === a.substr(8, 1) || "JABCDEFGHI" [d] === a.substr(8, 1)
                        }
                        return !1
                    },
                    e = a.charAt(0);
                return /^[0-9]$/.test(e) ? {
                    valid: b(a),
                    type: "DNI"
                } : /^[XYZ]$/.test(e) ? {
                    valid: c(a),
                    type: "NIE"
                } : {
                    valid: d(a),
                    type: "CIF"
                }
            },
            _fi: function(a) {
                if (/^FI[0-9]{8}$/.test(a) && (a = a.substr(2)), !/^[0-9]{8}$/.test(a)) return !1;
                for (var b = 0, c = [7, 9, 10, 5, 8, 4, 2, 1], d = 0; 8 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b % 11 === 0
            },
            _fr: function(a) {
                if (/^FR[0-9A-Z]{2}[0-9]{9}$/.test(a) && (a = a.substr(2)), !/^[0-9A-Z]{2}[0-9]{9}$/.test(a)) return !1;
                if (!FormValidation.Helper.luhn(a.substr(2))) return !1;
                if (/^[0-9]{2}$/.test(a.substr(0, 2))) return a.substr(0, 2) === parseInt(a.substr(2) + "12", 10) % 97 + "";
                var b, c = "0123456789ABCDEFGHJKLMNPQRSTUVWXYZ";
                return b = /^[0-9]{1}$/.test(a.charAt(0)) ? 24 * c.indexOf(a.charAt(0)) + c.indexOf(a.charAt(1)) - 10 : 34 * c.indexOf(a.charAt(0)) + c.indexOf(a.charAt(1)) - 100, (parseInt(a.substr(2), 10) + 1 + Math.floor(b / 11)) % 11 === b % 11
            },
            _gb: function(a) {
                if ((/^GB[0-9]{9}$/.test(a) || /^GB[0-9]{12}$/.test(a) || /^GBGD[0-9]{3}$/.test(a) || /^GBHA[0-9]{3}$/.test(a) || /^GB(GD|HA)8888[0-9]{5}$/.test(a)) && (a = a.substr(2)), !(/^[0-9]{9}$/.test(a) || /^[0-9]{12}$/.test(a) || /^GD[0-9]{3}$/.test(a) || /^HA[0-9]{3}$/.test(a) || /^(GD|HA)8888[0-9]{5}$/.test(a))) return !1;
                var b = a.length;
                if (5 === b) {
                    var c = a.substr(0, 2),
                        d = parseInt(a.substr(2), 10);
                    return "GD" === c && 500 > d || "HA" === c && d >= 500
                }
                if (11 === b && ("GD8888" === a.substr(0, 6) || "HA8888" === a.substr(0, 6))) return "GD" === a.substr(0, 2) && parseInt(a.substr(6, 3), 10) >= 500 || "HA" === a.substr(0, 2) && parseInt(a.substr(6, 3), 10) < 500 ? !1 : parseInt(a.substr(6, 3), 10) % 97 === parseInt(a.substr(9, 2), 10);
                if (9 === b || 12 === b) {
                    for (var e = 0, f = [8, 7, 6, 5, 4, 3, 2, 10, 1], g = 0; 9 > g; g++) e += parseInt(a.charAt(g), 10) * f[g];
                    return e %= 97, parseInt(a.substr(0, 3), 10) >= 100 ? 0 === e || 42 === e || 55 === e : 0 === e
                }
                return !0
            },
            _gr: function(a) {
                if (/^(GR|EL)[0-9]{9}$/.test(a) && (a = a.substr(2)), !/^[0-9]{9}$/.test(a)) return !1;
                8 === a.length && (a = "0" + a);
                for (var b = 0, c = [256, 128, 64, 32, 16, 8, 4, 2], d = 0; 8 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b = b % 11 % 10, b + "" === a.substr(8, 1)
            },
            _el: function(a) {
                return this._gr(a)
            },
            _hu: function(a) {
                if (/^HU[0-9]{8}$/.test(a) && (a = a.substr(2)), !/^[0-9]{8}$/.test(a)) return !1;
                for (var b = 0, c = [9, 7, 3, 1, 9, 7, 3, 1], d = 0; 8 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b % 10 === 0
            },
            _hr: function(a) {
                return /^HR[0-9]{11}$/.test(a) && (a = a.substr(2)), /^[0-9]{11}$/.test(a) ? FormValidation.Helper.mod11And10(a) : !1
            },
            _ie: function(a) {
                if (/^IE[0-9]{1}[0-9A-Z\*\+]{1}[0-9]{5}[A-Z]{1,2}$/.test(a) && (a = a.substr(2)), !/^[0-9]{1}[0-9A-Z\*\+]{1}[0-9]{5}[A-Z]{1,2}$/.test(a)) return !1;
                var b = function(a) {
                    for (; a.length < 7;) a = "0" + a;
                    for (var b = "WABCDEFGHIJKLMNOPQRSTUV", c = 0, d = 0; 7 > d; d++) c += parseInt(a.charAt(d), 10) * (8 - d);
                    return c += 9 * b.indexOf(a.substr(7)), b[c % 23]
                };
                return /^[0-9]+$/.test(a.substr(0, 7)) ? a.charAt(7) === b(a.substr(0, 7) + a.substr(8) + "") : -1 !== "ABCDEFGHIJKLMNOPQRSTUVWXYZ+*".indexOf(a.charAt(1)) ? a.charAt(7) === b(a.substr(2, 5) + a.substr(0, 1) + "") : !0
            },
            _is: function(a) {
                return /^IS[0-9]{5,6}$/.test(a) && (a = a.substr(2)), /^[0-9]{5,6}$/.test(a)
            },
            _it: function(a) {
                if (/^IT[0-9]{11}$/.test(a) && (a = a.substr(2)), !/^[0-9]{11}$/.test(a)) return !1;
                if (0 === parseInt(a.substr(0, 7), 10)) return !1;
                var b = parseInt(a.substr(7, 3), 10);
                return 1 > b || b > 201 && 999 !== b && 888 !== b ? !1 : FormValidation.Helper.luhn(a)
            },
            _lt: function(a) {
                if (/^LT([0-9]{7}1[0-9]{1}|[0-9]{10}1[0-9]{1})$/.test(a) && (a = a.substr(2)), !/^([0-9]{7}1[0-9]{1}|[0-9]{10}1[0-9]{1})$/.test(a)) return !1;
                var b, c = a.length,
                    d = 0;
                for (b = 0; c - 1 > b; b++) d += parseInt(a.charAt(b), 10) * (1 + b % 9);
                var e = d % 11;
                if (10 === e)
                    for (d = 0, b = 0; c - 1 > b; b++) d += parseInt(a.charAt(b), 10) * (1 + (b + 2) % 9);
                return e = e % 11 % 10, e + "" === a.charAt(c - 1)
            },
            _lu: function(a) {
                return /^LU[0-9]{8}$/.test(a) && (a = a.substr(2)), /^[0-9]{8}$/.test(a) ? parseInt(a.substr(0, 6), 10) % 89 + "" === a.substr(6, 2) : !1
            },
            _lv: function(a) {
                if (/^LV[0-9]{11}$/.test(a) && (a = a.substr(2)), !/^[0-9]{11}$/.test(a)) return !1;
                var b, c = parseInt(a.charAt(0), 10),
                    d = 0,
                    e = [],
                    f = a.length;
                if (c > 3) {
                    for (d = 0, e = [9, 1, 4, 8, 3, 10, 2, 5, 7, 6, 1], b = 0; f > b; b++) d += parseInt(a.charAt(b), 10) * e[b];
                    return d %= 11, 3 === d
                }
                var g = parseInt(a.substr(0, 2), 10),
                    h = parseInt(a.substr(2, 2), 10),
                    i = parseInt(a.substr(4, 2), 10);
                if (i = i + 1800 + 100 * parseInt(a.charAt(6), 10), !FormValidation.Helper.date(i, h, g)) return !1;
                for (d = 0, e = [10, 5, 8, 4, 2, 1, 6, 3, 7, 9], b = 0; f - 1 > b; b++) d += parseInt(a.charAt(b), 10) * e[b];
                return d = (d + 1) % 11 % 10, d + "" === a.charAt(f - 1)
            },
            _mt: function(a) {
                if (/^MT[0-9]{8}$/.test(a) && (a = a.substr(2)), !/^[0-9]{8}$/.test(a)) return !1;
                for (var b = 0, c = [3, 4, 6, 7, 8, 9, 10, 1], d = 0; 8 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b % 37 === 0
            },
            _nl: function(a) {
                if (/^NL[0-9]{9}B[0-9]{2}$/.test(a) && (a = a.substr(2)), !/^[0-9]{9}B[0-9]{2}$/.test(a)) return !1;
                for (var b = 0, c = [9, 8, 7, 6, 5, 4, 3, 2], d = 0; 8 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b %= 11, b > 9 && (b = 0), b + "" === a.substr(8, 1)
            },
            _no: function(a) {
                if (/^NO[0-9]{9}$/.test(a) && (a = a.substr(2)), !/^[0-9]{9}$/.test(a)) return !1;
                for (var b = 0, c = [3, 2, 7, 6, 5, 4, 3, 2], d = 0; 8 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b = 11 - b % 11, 11 === b && (b = 0), b + "" === a.substr(8, 1)
            },
            _pl: function(a) {
                if (/^PL[0-9]{10}$/.test(a) && (a = a.substr(2)), !/^[0-9]{10}$/.test(a)) return !1;
                for (var b = 0, c = [6, 5, 7, 2, 3, 4, 5, 6, 7, -1], d = 0; 10 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b % 11 === 0
            },
            _pt: function(a) {
                if (/^PT[0-9]{9}$/.test(a) && (a = a.substr(2)), !/^[0-9]{9}$/.test(a)) return !1;
                for (var b = 0, c = [9, 8, 7, 6, 5, 4, 3, 2], d = 0; 8 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b = 11 - b % 11, b > 9 && (b = 0), b + "" === a.substr(8, 1)
            },
            _ro: function(a) {
                if (/^RO[1-9][0-9]{1,9}$/.test(a) && (a = a.substr(2)), !/^[1-9][0-9]{1,9}$/.test(a)) return !1;
                for (var b = a.length, c = [7, 5, 3, 2, 1, 7, 5, 3, 2].slice(10 - b), d = 0, e = 0; b - 1 > e; e++) d += parseInt(a.charAt(e), 10) * c[e];
                return d = 10 * d % 11 % 10, d + "" === a.substr(b - 1, 1)
            },
            _ru: function(a) {
                if (/^RU([0-9]{10}|[0-9]{12})$/.test(a) && (a = a.substr(2)), !/^([0-9]{10}|[0-9]{12})$/.test(a)) return !1;
                var b = 0;
                if (10 === a.length) {
                    var c = 0,
                        d = [2, 4, 10, 3, 5, 9, 4, 6, 8, 0];
                    for (b = 0; 10 > b; b++) c += parseInt(a.charAt(b), 10) * d[b];
                    return c %= 11, c > 9 && (c %= 10), c + "" === a.substr(9, 1)
                }
                if (12 === a.length) {
                    var e = 0,
                        f = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8, 0],
                        g = 0,
                        h = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8, 0];
                    for (b = 0; 11 > b; b++) e += parseInt(a.charAt(b), 10) * f[b], g += parseInt(a.charAt(b), 10) * h[b];
                    return e %= 11, e > 9 && (e %= 10), g %= 11, g > 9 && (g %= 10), e + "" === a.substr(10, 1) && g + "" === a.substr(11, 1)
                }
                return !1
            },
            _rs: function(a) {
                if (/^RS[0-9]{9}$/.test(a) && (a = a.substr(2)), !/^[0-9]{9}$/.test(a)) return !1;
                for (var b = 10, c = 0, d = 0; 8 > d; d++) c = (parseInt(a.charAt(d), 10) + b) % 10, 0 === c && (c = 10), b = 2 * c % 11;
                return (b + parseInt(a.substr(8, 1), 10)) % 10 === 1
            },
            _se: function(a) {
                return /^SE[0-9]{10}01$/.test(a) && (a = a.substr(2)), /^[0-9]{10}01$/.test(a) ? (a = a.substr(0, 10), FormValidation.Helper.luhn(a)) : !1
            },
            _si: function(a) {
                var b = a.match(/^(SI)?([1-9][0-9]{7})$/);
                if (!b) return !1;
                b[1] && (a = a.substr(2));
                for (var c = 0, d = [8, 7, 6, 5, 4, 3, 2], e = 0; 7 > e; e++) c += parseInt(a.charAt(e), 10) * d[e];
                return c = 11 - c % 11, 10 === c && (c = 0), c + "" === a.substr(7, 1)
            },
            _sk: function(a) {
                return /^SK[1-9][0-9][(2-4)|(6-9)][0-9]{7}$/.test(a) && (a = a.substr(2)), /^[1-9][0-9][(2-4)|(6-9)][0-9]{7}$/.test(a) ? parseInt(a, 10) % 11 === 0 : !1
            },
            _ve: function(a) {
                if (/^VE[VEJPG][0-9]{9}$/.test(a) && (a = a.substr(2)), !/^[VEJPG][0-9]{9}$/.test(a)) return !1;
                for (var b = {
                    V: 4,
                    E: 8,
                    J: 12,
                    P: 16,
                    G: 20
                }, c = b[a.charAt(0)], d = [3, 2, 7, 6, 5, 4, 3, 2], e = 0; 8 > e; e++) c += parseInt(a.charAt(e + 1), 10) * d[e];
                return c = 11 - c % 11, (11 === c || 10 === c) && (c = 0), c + "" === a.substr(9, 1)
            },
            _za: function(a) {
                return /^ZA4[0-9]{9}$/.test(a) && (a = a.substr(2)), /^4[0-9]{9}$/.test(a)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                vin: {
                    "default": "Please enter a valid VIN number"
                }
            }
        }), FormValidation.Validator.vin = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                if (!/^[a-hj-npr-z0-9]{8}[0-9xX][a-hj-npr-z0-9]{8}$/i.test(e)) return !1;
                e = e.toUpperCase();
                for (var f = {
                    A: 1,
                    B: 2,
                    C: 3,
                    D: 4,
                    E: 5,
                    F: 6,
                    G: 7,
                    H: 8,
                    J: 1,
                    K: 2,
                    L: 3,
                    M: 4,
                    N: 5,
                    P: 7,
                    R: 9,
                    S: 2,
                    T: 3,
                    U: 4,
                    V: 5,
                    W: 6,
                    X: 7,
                    Y: 8,
                    Z: 9,
                    1: 1,
                    2: 2,
                    3: 3,
                    4: 4,
                    5: 5,
                    6: 6,
                    7: 7,
                    8: 8,
                    9: 9,
                    0: 0
                }, g = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2], h = 0, i = e.length, j = 0; i > j; j++) h += f[e.charAt(j) + ""] * g[j];
                var k = h % 11;
                return 10 === k && (k = "X"), k + "" === e.charAt(8)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                zipCode: {
                    "default": "Please enter a valid postal code",
                    country: "Please enter a valid postal code in %s",
                    countries: {
                        AT: "Austria",
                        BG: "Bulgaria",
                        BR: "Brazil",
                        CA: "Canada",
                        CH: "Switzerland",
                        CZ: "Czech Republic",
                        DE: "Germany",
                        DK: "Denmark",
                        ES: "Spain",
                        FR: "France",
                        GB: "United Kingdom",
                        IE: "Ireland",
                        IN: "India",
                        IT: "Italy",
                        MA: "Morocco",
                        NL: "Netherlands",
                        PL: "Poland",
                        PT: "Portugal",
                        RO: "Romania",
                        RU: "Russia",
                        SE: "Sweden",
                        SG: "Singapore",
                        SK: "Slovakia",
                        US: "USA"
                    }
                }
            }
        }), FormValidation.Validator.zipCode = {
            html5Attributes: {
                message: "message",
                country: "country"
            },
            COUNTRY_CODES: ["AT", "BG", "BR", "CA", "CH", "CZ", "DE", "DK", "ES", "FR", "GB", "IE", "IN", "IT", "MA", "NL", "PL", "PT", "RO", "RU", "SE", "SG", "SK", "US"],
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f || !d.country) return !0;
                var g = b.getLocale(),
                    h = d.country;
                if (("string" != typeof h || -1 === a.inArray(h, this.COUNTRY_CODES)) && (h = b.getDynamicOption(c, h)), !h || -1 === a.inArray(h.toUpperCase(), this.COUNTRY_CODES)) return !0;
                var i = !1;
                switch (h = h.toUpperCase()) {
                    case "AT":
                        i = /^([1-9]{1})(\d{3})$/.test(f);
                        break;
                    case "BG":
                        i = /^([1-9]{1}[0-9]{3})$/.test(a.trim(f));
                        break;
                    case "BR":
                        i = /^(\d{2})([\.]?)(\d{3})([\-]?)(\d{3})$/.test(f);
                        break;
                    case "CA":
                        i = /^(?:A|B|C|E|G|H|J|K|L|M|N|P|R|S|T|V|X|Y){1}[0-9]{1}(?:A|B|C|E|G|H|J|K|L|M|N|P|R|S|T|V|W|X|Y|Z){1}\s?[0-9]{1}(?:A|B|C|E|G|H|J|K|L|M|N|P|R|S|T|V|W|X|Y|Z){1}[0-9]{1}$/i.test(f);
                        break;
                    case "CH":
                        i = /^([1-9]{1})(\d{3})$/.test(f);
                        break;
                    case "CZ":
                        i = /^(\d{3})([ ]?)(\d{2})$/.test(f);
                        break;
                    case "DE":
                        i = /^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/.test(f);
                        break;
                    case "DK":
                        i = /^(DK(-|\s)?)?\d{4}$/i.test(f);
                        break;
                    case "ES":
                        i = /^(?:0[1-9]|[1-4][0-9]|5[0-2])\d{3}$/.test(f);
                        break;
                    case "FR":
                        i = /^[0-9]{5}$/i.test(f);
                        break;
                    case "GB":
                        i = this._gb(f);
                        break;
                    case "IN":
                        i = /^\d{3}\s?\d{3}$/.test(f);
                        break;
                    case "IE":
                        i = /^(D6W|[ACDEFHKNPRTVWXY]\d{2})\s[0-9ACDEFHKNPRTVWXY]{4}$/.test(f);
                        break;
                    case "IT":
                        i = /^(I-|IT-)?\d{5}$/i.test(f);
                        break;
                    case "MA":
                        i = /^[1-9][0-9]{4}$/i.test(f);
                        break;
                    case "NL":
                        i = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i.test(f);
                        break;
                    case "PL":
                        i = /^[0-9]{2}\-[0-9]{3}$/.test(f);
                        break;
                    case "PT":
                        i = /^[1-9]\d{3}-\d{3}$/.test(f);
                        break;
                    case "RO":
                        i = /^(0[1-8]{1}|[1-9]{1}[0-5]{1})?[0-9]{4}$/i.test(f);
                        break;
                    case "RU":
                        i = /^[0-9]{6}$/i.test(f);
                        break;
                    case "SE":
                        i = /^(S-)?\d{3}\s?\d{2}$/i.test(f);
                        break;
                    case "SG":
                        i = /^([0][1-9]|[1-6][0-9]|[7]([0-3]|[5-9])|[8][0-2])(\d{4})$/i.test(f);
                        break;
                    case "SK":
                        i = /^(\d{3})([ ]?)(\d{2})$/.test(f);
                        break;
                    case "US":
                    default:
                        i = /^\d{4,5}([\-]?\d{4})?$/.test(f)
                }
                return {
                    valid: i,
                    message: FormValidation.Helper.format(d.message || FormValidation.I18n[g].zipCode.country, FormValidation.I18n[g].zipCode.countries[h])
                }
            },
            _gb: function(a) {
                for (var b = "[ABCDEFGHIJKLMNOPRSTUWYZ]", c = "[ABCDEFGHKLMNOPQRSTUVWXY]", d = "[ABCDEFGHJKPMNRSTUVWXY]", e = "[ABEHMNPRVWXY]", f = "[ABDEFGHJLNPQRSTUWXYZ]", g = [new RegExp("^(" + b + "{1}" + c + "?[0-9]{1,2})(\\s*)([0-9]{1}" + f + "{2})$", "i"), new RegExp("^(" + b + "{1}[0-9]{1}" + d + "{1})(\\s*)([0-9]{1}" + f + "{2})$", "i"), new RegExp("^(" + b + "{1}" + c + "{1}?[0-9]{1}" + e + "{1})(\\s*)([0-9]{1}" + f + "{2})$", "i"), new RegExp("^(BF1)(\\s*)([0-6]{1}[ABDEFGHJLNPQRST]{1}[ABDEFGHJLNPQRSTUWZYZ]{1})$", "i"), /^(GIR)(\s*)(0AA)$/i, /^(BFPO)(\s*)([0-9]{1,4})$/i, /^(BFPO)(\s*)(c\/o\s*[0-9]{1,3})$/i, /^([A-Z]{4})(\s*)(1ZZ)$/i, /^(AI-2640)$/i], h = 0; h < g.length; h++)
                    if (g[h].test(a)) return !0;
                return !1
            }
        }
    }(jQuery);*/

/* new wersion 0.8.1 */
if (window.FormValidation = {
    AddOn: {},
    Framework: {},
    I18n: {},
    Validator: {}
}, "undefined" == typeof jQuery) throw new Error("FormValidation requires jQuery");
! function(a) {
    var b = a.fn.jquery.split(" ")[0].split(".");
    if (+b[0] < 2 && +b[1] < 9 || 1 === +b[0] && 9 === +b[1] && +b[2] < 1) throw new Error("FormValidation requires jQuery version 1.9.1 or higher")
}(jQuery),
    function(a) {
        FormValidation.Base = function(b, c, d) {
            this.$form = a(b), this.options = a.extend({}, a.fn.formValidation.DEFAULT_OPTIONS, c), this._namespace = d || "fv", this.$invalidFields = a([]), this.$submitButton = null, this.$hiddenButton = null, this.STATUS_NOT_VALIDATED = "NOT_VALIDATED", this.STATUS_VALIDATING = "VALIDATING", this.STATUS_INVALID = "INVALID", this.STATUS_VALID = "VALID", this.STATUS_IGNORED = "IGNORED", this.DEFAULT_MESSAGE = a.fn.formValidation.DEFAULT_MESSAGE, this._ieVersion = function() {
                for (var a = 3, b = document.createElement("div"), c = b.all || []; b.innerHTML = "<!--[if gt IE " + ++a + "]><br><![endif]-->", c[0];);
                return a > 4 ? a : document.documentMode
            }();
            var e = document.createElement("div");
            this._changeEvent = 9 !== this._ieVersion && "oninput" in e ? "input" : "keyup", this._submitIfValid = null, this._cacheFields = {}, this._init()
        }, FormValidation.Base.prototype = {
            constructor: FormValidation.Base,
            _exceedThreshold: function(b) {
                var c = this._namespace,
                    d = b.attr("data-" + c + "-field");
                    /*e = this.options.fields[d].threshold || this.options.threshold;*/
                    /* justselling part, we just check if this.options.fields is not undefined, prevent js fall */
                var optionsFieldsD = typeof this.options.fields[d] !== 'undefined' ? this.options.fields[d].threshold : false;
                var e = optionsFieldsD || this.options.threshold;
                if (!e) return !0;
                var f = -1 !== a.inArray(b.attr("type"), ["button", "checkbox", "file", "hidden", "image", "radio", "reset", "submit"]);
                return f || b.val().length >= e
            },
            _init: function() {
                var b = this,
                    c = this._namespace,
                    d = {
                        addOns: {},
                        autoFocus: this.$form.attr("data-" + c + "-autofocus"),
                        button: {
                            selector: this.$form.attr("data-" + c + "-button-selector") || this.$form.attr("data-" + c + "-submitbuttons"),
                            disabled: this.$form.attr("data-" + c + "-button-disabled")
                        },
                        control: {
                            valid: this.$form.attr("data-" + c + "-control-valid"),
                            invalid: this.$form.attr("data-" + c + "-control-invalid")
                        },
                        err: {
                            clazz: this.$form.attr("data-" + c + "-err-clazz"),
                            container: this.$form.attr("data-" + c + "-err-container") || this.$form.attr("data-" + c + "-container"),
                            parent: this.$form.attr("data-" + c + "-err-parent")
                        },
                        events: {
                            formInit: this.$form.attr("data-" + c + "-events-form-init"),
                            formPreValidate: this.$form.attr("data-" + c + "-events-form-prevalidate"),
                            formError: this.$form.attr("data-" + c + "-events-form-error"),
                            formReset: this.$form.attr("data-" + c + "-events-form-reset"),
                            formSuccess: this.$form.attr("data-" + c + "-events-form-success"),
                            fieldAdded: this.$form.attr("data-" + c + "-events-field-added"),
                            fieldRemoved: this.$form.attr("data-" + c + "-events-field-removed"),
                            fieldInit: this.$form.attr("data-" + c + "-events-field-init"),
                            fieldError: this.$form.attr("data-" + c + "-events-field-error"),
                            fieldReset: this.$form.attr("data-" + c + "-events-field-reset"),
                            fieldSuccess: this.$form.attr("data-" + c + "-events-field-success"),
                            fieldStatus: this.$form.attr("data-" + c + "-events-field-status"),
                            localeChanged: this.$form.attr("data-" + c + "-events-locale-changed"),
                            validatorError: this.$form.attr("data-" + c + "-events-validator-error"),
                            validatorSuccess: this.$form.attr("data-" + c + "-events-validator-success"),
                            validatorIgnored: this.$form.attr("data-" + c + "-events-validator-ignored")
                        },
                        excluded: this.$form.attr("data-" + c + "-excluded"),
                        icon: {
                            valid: this.$form.attr("data-" + c + "-icon-valid") || this.$form.attr("data-" + c + "-feedbackicons-valid"),
                            invalid: this.$form.attr("data-" + c + "-icon-invalid") || this.$form.attr("data-" + c + "-feedbackicons-invalid"),
                            validating: this.$form.attr("data-" + c + "-icon-validating") || this.$form.attr("data-" + c + "-feedbackicons-validating"),
                            feedback: this.$form.attr("data-" + c + "-icon-feedback")
                        },
                        live: this.$form.attr("data-" + c + "-live"),
                        locale: this.$form.attr("data-" + c + "-locale"),
                        message: this.$form.attr("data-" + c + "-message"),
                        onPreValidate: this.$form.attr("data-" + c + "-onprevalidate"),
                        onError: this.$form.attr("data-" + c + "-onerror"),
                        onReset: this.$form.attr("data-" + c + "-onreset"),
                        onSuccess: this.$form.attr("data-" + c + "-onsuccess"),
                        row: {
                            selector: this.$form.attr("data-" + c + "-row-selector") || this.$form.attr("data-" + c + "-group"),
                            valid: this.$form.attr("data-" + c + "-row-valid"),
                            invalid: this.$form.attr("data-" + c + "-row-invalid"),
                            feedback: this.$form.attr("data-" + c + "-row-feedback")
                        },
                        threshold: this.$form.attr("data-" + c + "-threshold"),
                        trigger: this.$form.attr("data-" + c + "-trigger"),
                        verbose: this.$form.attr("data-" + c + "-verbose"),
                        fields: {}
                    };
                this.$form.attr("novalidate", "novalidate").addClass(this.options.elementClass).on("submit." + c, function(a) {
                    a.preventDefault(), b.validate()
                }).on("click." + c, this.options.button.selector, function() {
                    b.$submitButton = a(this), b._submitIfValid = !0
                }), (this.options.declarative === !0 || "true" === this.options.declarative) && this.$form.find("[name], [data-" + c + "-field]").each(function() {
                    var e = a(this),
                        f = e.attr("name") || e.attr("data-" + c + "-field"),
                        g = b._parseOptions(e);
                    g && (e.attr("data-" + c + "-field", f), d.fields[f] = a.extend({}, g, d.fields[f]))
                }), this.options = a.extend(!0, this.options, d), "string" == typeof this.options.err.parent && (this.options.err.parent = new RegExp(this.options.err.parent)), this.options.container && (this.options.err.container = this.options.container, delete this.options.container), this.options.feedbackIcons && (this.options.icon = a.extend(!0, this.options.icon, this.options.feedbackIcons), delete this.options.feedbackIcons), this.options.group && (this.options.row.selector = this.options.group, delete this.options.group), this.options.submitButtons && (this.options.button.selector = this.options.submitButtons, delete this.options.submitButtons), FormValidation.I18n[this.options.locale] || (this.options.locale = a.fn.formValidation.DEFAULT_OPTIONS.locale), (this.options.declarative === !0 || "true" === this.options.declarative) && (this.options = a.extend(!0, this.options, {
                    addOns: this._parseAddOnOptions()
                })), this.$hiddenButton = a("<button/>").attr("type", "submit").prependTo(this.$form).addClass("fv-hidden-submit").css({
                    display: "none",
                    width: 0,
                    height: 0
                }), this.$form.on("click." + this._namespace, '[type="submit"]', function(c) {
                    if (!c.isDefaultPrevented()) {
                        var d = a(c.target),
                            e = d.is('[type="submit"]') ? d.eq(0) : d.parent('[type="submit"]').eq(0);
                        if (b.options.button.selector && !e.is(b.options.button.selector) && !e.is(b.$hiddenButton)) return b.$form.off("submit." + b._namespace).submit(), !1
                    }
                });
                for (var e in this.options.fields) this._initField(e);
                for (var f in this.options.addOns) "function" == typeof FormValidation.AddOn[f].init && FormValidation.AddOn[f].init(this, this.options.addOns[f]);
                this.$form.trigger(a.Event(this.options.events.formInit), {
                    bv: this,
                    fv: this,
                    options: this.options
                }), this.options.onPreValidate && this.$form.on(this.options.events.formPreValidate, function(a) {
                    FormValidation.Helper.call(b.options.onPreValidate, [a])
                }), this.options.onSuccess && this.$form.on(this.options.events.formSuccess, function(a) {
                    FormValidation.Helper.call(b.options.onSuccess, [a])
                }), this.options.onError && this.$form.on(this.options.events.formError, function(a) {
                    FormValidation.Helper.call(b.options.onError, [a])
                }), this.options.onReset && this.$form.on(this.options.events.formReset, function(a) {
                    FormValidation.Helper.call(b.options.onReset, [a])
                })
            },
            _initField: function(b) {
                var c = this._namespace,
                    d = a([]);
                switch (typeof b) {
                    case "object":
                        d = b, b = b.attr("data-" + c + "-field");
                        break;
                    case "string":
                        d = this.getFieldElements(b), d.attr("data-" + c + "-field", b)
                }
                if (0 !== d.length && null !== this.options.fields[b] && null !== this.options.fields[b].validators) {
                    var e, f, g = this.options.fields[b].validators;
                    for (e in g) f = g[e].alias || e, FormValidation.Validator[f] || delete this.options.fields[b].validators[e];
                    null === this.options.fields[b].enabled && (this.options.fields[b].enabled = !0);
                    for (var h = this, i = d.length, j = d.attr("type"), k = 1 === i || "radio" === j || "checkbox" === j, l = this._getFieldTrigger(d.eq(0)), m = this.options.err.clazz.split(" ").join("."), n = a.map(l, function(a) {
                        return a + ".update." + c
                    }).join(" "), o = 0; i > o; o++) {
                        var p = d.eq(o),
                            q = this.options.fields[b].row || this.options.row.selector,
                            r = p.closest(q),
                            s = "function" == typeof(this.options.fields[b].container || this.options.fields[b].err || this.options.err.container) ? (this.options.fields[b].container || this.options.fields[b].err || this.options.err.container).call(this, p, this) : this.options.fields[b].container || this.options.fields[b].err || this.options.err.container,
                            t = s && "tooltip" !== s && "popover" !== s ? a(s) : this._getMessageContainer(p, q);
                        s && "tooltip" !== s && "popover" !== s && t.addClass(this.options.err.clazz), t.find("." + m + "[data-" + c + "-validator][data-" + c + '-for="' + b + '"]').remove(), r.find("i[data-" + c + '-icon-for="' + b + '"]').remove(), p.off(n).on(n, function() {
                            h.updateStatus(a(this), h.STATUS_NOT_VALIDATED)
                        }), p.data(c + ".messages", t);
                        for (e in g) p.data(c + ".result." + e, this.STATUS_NOT_VALIDATED), k && o !== i - 1 || a("<small/>").css("display", "none").addClass(this.options.err.clazz).attr("data-" + c + "-validator", e).attr("data-" + c + "-for", b).attr("data-" + c + "-result", this.STATUS_NOT_VALIDATED).html(this._getMessage(b, e)).appendTo(t), f = g[e].alias || e, "function" == typeof FormValidation.Validator[f].init && FormValidation.Validator[f].init(this, p, this.options.fields[b].validators[e], e);
                        if (this.options.fields[b].icon !== !1 && "false" !== this.options.fields[b].icon && this.options.icon && this.options.icon.valid && this.options.icon.invalid && this.options.icon.validating && (!k || o === i - 1)) {
                            r.addClass(this.options.row.feedback);
                            var u = a("<i/>").css("display", "none").addClass(this.options.icon.feedback).attr("data-" + c + "-icon-for", b).insertAfter(p);
                            (k ? d : p).data(c + ".icon", u), ("tooltip" === s || "popover" === s) && ((k ? d : p).on(this.options.events.fieldError, function() {
                                r.addClass("fv-has-tooltip")
                            }).on(this.options.events.fieldSuccess, function() {
                                r.removeClass("fv-has-tooltip")
                            }), p.off("focus.container." + c).on("focus.container." + c, function() {
                                h._showTooltip(a(this), s)
                            }).off("blur.container." + c).on("blur.container." + c, function() {
                                h._hideTooltip(a(this), s)
                            })), "string" == typeof this.options.fields[b].icon && "true" !== this.options.fields[b].icon ? u.appendTo(a(this.options.fields[b].icon)) : this._fixIcon(p, u)
                        }
                    }
                    var v = [];
                    for (e in g) f = g[e].alias || e, g[e].priority = parseInt(g[e].priority || FormValidation.Validator[f].priority || 1, 10), v.push({
                        validator: e,
                        priority: g[e].priority
                    });
                    v = v.sort(function(a, b) {
                        return a.priority - b.priority
                    }), d.data(c + ".validators", v).on(this.options.events.fieldSuccess, function(a, b) {
                        var c = h.getOptions(b.field, null, "onSuccess");
                        c && FormValidation.Helper.call(c, [a, b])
                    }).on(this.options.events.fieldError, function(a, b) {
                        var c = h.getOptions(b.field, null, "onError");
                        c && FormValidation.Helper.call(c, [a, b])
                    }).on(this.options.events.fieldReset, function(a, b) {
                        var c = h.getOptions(b.field, null, "onReset");
                        c && FormValidation.Helper.call(c, [a, b])
                    }).on(this.options.events.fieldStatus, function(a, b) {
                        var c = h.getOptions(b.field, null, "onStatus");
                        c && FormValidation.Helper.call(c, [a, b])
                    }).on(this.options.events.validatorError, function(a, b) {
                        var c = h.getOptions(b.field, b.validator, "onError");
                        c && FormValidation.Helper.call(c, [a, b])
                    }).on(this.options.events.validatorIgnored, function(a, b) {
                        var c = h.getOptions(b.field, b.validator, "onIgnored");
                        c && FormValidation.Helper.call(c, [a, b])
                    }).on(this.options.events.validatorSuccess, function(a, b) {
                        var c = h.getOptions(b.field, b.validator, "onSuccess");
                        c && FormValidation.Helper.call(c, [a, b])
                    }), this.onLiveChange(d, "live", function() {
                        h._exceedThreshold(a(this)) && h.validateField(a(this))
                    }), d.trigger(a.Event(this.options.events.fieldInit), {
                        bv: this,
                        fv: this,
                        field: b,
                        element: d
                    })
                }
            },
            _isExcluded: function(b) {
                var c = this._namespace,
                    d = b.attr("data-" + c + "-excluded"),
                    e = b.attr("data-" + c + "-field") || b.attr("name");
                switch (!0) {
                    case !!e && this.options.fields && this.options.fields[e] && ("true" === this.options.fields[e].excluded || this.options.fields[e].excluded === !0):
                    case "true" === d:
                    case "" === d:
                        return !0;
                    case !!e && this.options.fields && this.options.fields[e] && ("false" === this.options.fields[e].excluded || this.options.fields[e].excluded === !1):
                    case "false" === d:
                        return !1;
                    case !!e && this.options.fields && this.options.fields[e] && "function" == typeof this.options.fields[e].excluded:
                        return this.options.fields[e].excluded.call(this, b, this);
                    case !!e && this.options.fields && this.options.fields[e] && "string" == typeof this.options.fields[e].excluded:
                    case d:
                        return FormValidation.Helper.call(this.options.fields[e].excluded, [b, this]);
                    default:
                        if (this.options.excluded) {
                            "string" == typeof this.options.excluded && (this.options.excluded = a.map(this.options.excluded.split(","), function(b) {
                                return a.trim(b)
                            }));
                            for (var f = this.options.excluded.length, g = 0; f > g; g++)
                                if ("string" == typeof this.options.excluded[g] && b.is(this.options.excluded[g]) || "function" == typeof this.options.excluded[g] && this.options.excluded[g].call(this, b, this) === !0) return !0
                        }
                        return !1
                }
            },
            _getFieldTrigger: function(a) {
                var b = this._namespace,
                    c = a.data(b + ".trigger");
                if (c) return c;
                var d = a.attr("type"),
                    e = a.attr("data-" + b + "-field"),
                    f = "radio" === d || "checkbox" === d || "file" === d || "SELECT" === a.get(0).tagName ? "change" : this._ieVersion >= 10 && a.attr("placeholder") ? "keyup" : this._changeEvent;
                return c = ((this.options.fields[e] ? this.options.fields[e].trigger : null) || this.options.trigger || f).split(" "), a.data(b + ".trigger", c), c
            },
            _getMessage: function(a, b) {
                if (!this.options.fields[a] || !this.options.fields[a].validators) return "";
                var c = this.options.fields[a].validators,
                    d = c[b] && c[b].alias ? c[b].alias : b;
                if (!FormValidation.Validator[d]) return "";
                switch (!0) {
                    case !!c[b].message:
                        return c[b].message;
                    case !!this.options.fields[a].message:
                        return this.options.fields[a].message;
                    case !!this.options.message:
                        return this.options.message;
                    case !!FormValidation.I18n[this.options.locale] && !!FormValidation.I18n[this.options.locale][d] && !!FormValidation.I18n[this.options.locale][d]["default"]:
                        return FormValidation.I18n[this.options.locale][d]["default"];
                    default:
                        return this.DEFAULT_MESSAGE
                }
            },
            _getMessageContainer: function(a, b) {
                if (!this.options.err.parent) throw new Error("The err.parent option is not defined");
                var c = a.parent();
                if (c.is(b)) return c;
                var d = c.attr("class");
                return d && this.options.err.parent.test(d) ? c : this._getMessageContainer(c, b)
            },
            _parseAddOnOptions: function() {
                var a = this._namespace,
                    b = this.$form.attr("data-" + a + "-addons"),
                    c = this.options.addOns || {};
                if (b) {
                    b = b.replace(/\s/g, "").split(",");
                    for (var d = 0; d < b.length; d++) c[b[d]] || (c[b[d]] = {})
                }
                var e, f, g, h;
                for (e in c)
                    if (FormValidation.AddOn[e]) {
                        if (f = FormValidation.AddOn[e].html5Attributes)
                            for (g in f) h = this.$form.attr("data-" + a + "-addons-" + e.toLowerCase() + "-" + g.toLowerCase()), h && (c[e][f[g]] = h)
                    } else delete c[e];
                return c
            },
            _parseOptions: function(b) {
                var c, d, e, f, g, h, i, j, k, l = this._namespace,
                    m = b.attr("name") || b.attr("data-" + l + "-field"),
                    n = {},
                    o = new RegExp("^data-" + l + "-([a-z]+)-alias$"),
                    p = a.extend({}, FormValidation.Validator);
                a.each(b.get(0).attributes, function(a, b) {
                    b.value && o.test(b.name) && (d = b.name.split("-")[2], p[b.value] && (p[d] = p[b.value], p[d].alias = b.value))
                });
                for (d in p)
                    if (c = p[d], e = "data-" + l + "-" + d.toLowerCase(), f = b.attr(e) + "", k = "function" == typeof c.enableByHtml5 ? c.enableByHtml5(b) : null, k && "false" !== f || k !== !0 && ("" === f || "true" === f || e === f.toLowerCase())) {
                        c.html5Attributes = a.extend({}, {
                            message: "message",
                            onerror: "onError",
                            onreset: "onReset",
                            onsuccess: "onSuccess",
                            priority: "priority",
                            transformer: "transformer"
                        }, c.html5Attributes), n[d] = a.extend({}, k === !0 ? {} : k, n[d]), c.alias && (n[d].alias = c.alias);
                        for (j in c.html5Attributes) g = c.html5Attributes[j], h = "data-" + l + "-" + d.toLowerCase() + "-" + j, i = b.attr(h), i && ("true" === i || h === i.toLowerCase() ? i = !0 : "false" === i && (i = !1), n[d][g] = i)
                    } var q = {
                        autoFocus: b.attr("data-" + l + "-autofocus"),
                        err: b.attr("data-" + l + "-err-container") || b.attr("data-" + l + "-container"),
                        enabled: b.attr("data-" + l + "-enabled"),
                        excluded: b.attr("data-" + l + "-excluded"),
                        icon: b.attr("data-" + l + "-icon") || b.attr("data-" + l + "-feedbackicons") || (this.options.fields && this.options.fields[m] ? this.options.fields[m].feedbackIcons : null),
                        message: b.attr("data-" + l + "-message"),
                        onError: b.attr("data-" + l + "-onerror"),
                        onReset: b.attr("data-" + l + "-onreset"),
                        onStatus: b.attr("data-" + l + "-onstatus"),
                        onSuccess: b.attr("data-" + l + "-onsuccess"),
                        row: b.attr("data-" + l + "-row") || b.attr("data-" + l + "-group") || (this.options.fields && this.options.fields[m] ? this.options.fields[m].group : null),
                        selector: b.attr("data-" + l + "-selector"),
                        threshold: b.attr("data-" + l + "-threshold"),
                        transformer: b.attr("data-" + l + "-transformer"),
                        trigger: b.attr("data-" + l + "-trigger"),
                        verbose: b.attr("data-" + l + "-verbose"),
                        validators: n
                    },
                    r = a.isEmptyObject(q),
                    s = a.isEmptyObject(n);
                return !s || !r && this.options.fields && this.options.fields[m] ? q : null
            },
            _submit: function() {
                var b = this.isValid();
                if (null !== b) {
                    var c = b ? this.options.events.formSuccess : this.options.events.formError,
                        d = a.Event(c);
                    this.$form.trigger(d), this.$submitButton && (b ? this._onSuccess(d) : this._onError(d))
                }
            },
            _onError: function(b) {
                if (!b.isDefaultPrevented()) {
                    if ("submitted" === this.options.live) {
                        this.options.live = "enabled";
                        var c = this;
                        for (var d in this.options.fields) ! function(b) {
                            var d = c.getFieldElements(b);
                            d.length && c.onLiveChange(d, "live", function() {
                                c._exceedThreshold(a(this)) && c.validateField(a(this))
                            })
                        }(d)
                    }
                    for (var e = this._namespace, f = 0; f < this.$invalidFields.length; f++) {
                        var g = this.$invalidFields.eq(f),
                            h = this.isOptionEnabled(g.attr("data-" + e + "-field"), "autoFocus");
                        if (h) {
                            g.focus();
                            break
                        }
                    }
                }
            },
            _onFieldValidated: function(b, c) {
                var d = this._namespace,
                    e = b.attr("data-" + d + "-field"),
                    f = this.options.fields[e].validators,
                    g = {},
                    h = 0,
                    i = {
                        bv: this,
                        fv: this,
                        field: e,
                        element: b,
                        validator: c,
                        result: b.data(d + ".response." + c)
                    };
                if (c) switch (b.data(d + ".result." + c)) {
                    case this.STATUS_INVALID:
                        b.trigger(a.Event(this.options.events.validatorError), i);
                        break;
                    case this.STATUS_VALID:
                        b.trigger(a.Event(this.options.events.validatorSuccess), i);
                        break;
                    case this.STATUS_IGNORED:
                        b.trigger(a.Event(this.options.events.validatorIgnored), i)
                }
                g[this.STATUS_NOT_VALIDATED] = 0, g[this.STATUS_VALIDATING] = 0, g[this.STATUS_INVALID] = 0, g[this.STATUS_VALID] = 0, g[this.STATUS_IGNORED] = 0;
                for (var j in f)
                    if (f[j].enabled !== !1) {
                        h++;
                        var k = b.data(d + ".result." + j);
                        k && g[k]++
                    } g[this.STATUS_VALID] + g[this.STATUS_IGNORED] === h ? (this.$invalidFields = this.$invalidFields.not(b), b.trigger(a.Event(this.options.events.fieldSuccess), i)) : (0 === g[this.STATUS_NOT_VALIDATED] || !this.isOptionEnabled(e, "verbose")) && 0 === g[this.STATUS_VALIDATING] && g[this.STATUS_INVALID] > 0 && (this.$invalidFields = this.$invalidFields.add(b), b.trigger(a.Event(this.options.events.fieldError), i))
            },
            _onSuccess: function(a) {
                a.isDefaultPrevented() || this.disableSubmitButtons(!0).defaultSubmit()
            },
            _fixIcon: function(a, b) {},
            _createTooltip: function(a, b, c) {},
            _destroyTooltip: function(a, b) {},
            _hideTooltip: function(a, b) {},
            _showTooltip: function(a, b) {},
            defaultSubmit: function() {
                var b = this._namespace;
                this.$submitButton && a("<input/>").attr({
                    type: "hidden",
                    name: this.$submitButton.attr("name")
                }).attr("data-" + b + "-submit-hidden", "").val(this.$submitButton.val()).appendTo(this.$form), this.$form.off("submit." + b).submit()
            },
            disableSubmitButtons: function(a) {
                return a ? "disabled" !== this.options.live && this.$form.find(this.options.button.selector).attr("disabled", "disabled").addClass(this.options.button.disabled) : this.$form.find(this.options.button.selector).removeAttr("disabled").removeClass(this.options.button.disabled), this
            },
            getFieldElements: function(b) {
                if (!this._cacheFields[b])
                    if (this.options.fields[b] && this.options.fields[b].selector) {
                        var c = this.$form.find(this.options.fields[b].selector);
                        this._cacheFields[b] = c.length ? c : a(this.options.fields[b].selector)
                    } else this._cacheFields[b] = this.$form.find('[name="' + b + '"]');
                return this._cacheFields[b]
            },
            getFieldValue: function(a, b) {
                var c, d = this._namespace;
                if ("string" == typeof a) {
                    if (c = this.getFieldElements(a), 0 === c.length) return null
                } else c = a, a = c.attr("data-" + d + "-field");
                if (!a || !this.options.fields[a]) return c.val();
                var e = (this.options.fields[a].validators && this.options.fields[a].validators[b] ? this.options.fields[a].validators[b].transformer : null) || this.options.fields[a].transformer;
                return e ? FormValidation.Helper.call(e, [c, b, this]) : c.val()
            },
            getNamespace: function() {
                return this._namespace
            },
            getOptions: function(a, b, c) {
                var d = this._namespace;
                if (!a) return c ? this.options[c] : this.options;
                if ("object" == typeof a && (a = a.attr("data-" + d + "-field")), !this.options.fields[a]) return null;
                var e = this.options.fields[a];
                return b ? e.validators && e.validators[b] ? c ? e.validators[b][c] : e.validators[b] : null : c ? e[c] : e
            },
            getStatus: function(a, b) {
                var c = this._namespace;
                switch (typeof a) {
                    case "object":
                        return a.data(c + ".result." + b);
                    case "string":
                    default:
                        return this.getFieldElements(a).eq(0).data(c + ".result." + b)
                }
            },
            isOptionEnabled: function(a, b) {
                return !this.options.fields[a] || "true" !== this.options.fields[a][b] && this.options.fields[a][b] !== !0 ? !this.options.fields[a] || "false" !== this.options.fields[a][b] && this.options.fields[a][b] !== !1 ? "true" === this.options[b] || this.options[b] === !0 : !1 : !0
            },
            isValid: function() {
                for (var a in this.options.fields) {
                    var b = this.isValidField(a);
                    if (null === b) return null;
                    if (b === !1) return !1
                }
                return !0
            },
            isValidContainer: function(b) {
                var c = this,
                    d = this._namespace,
                    e = [],
                    f = "string" == typeof b ? a(b) : b;
                if (0 === f.length) return !0;
                f.find("[data-" + d + "-field]").each(function() {
                    var b = a(this);
                    c._isExcluded(b) || e.push(b)
                });
                for (var g = e.length, h = this.options.err.clazz.split(" ").join("."), i = 0; g > i; i++) {
                    var j = e[i],
                        k = j.attr("data-" + d + "-field"),
                        l = j.data(d + ".messages").find("." + h + "[data-" + d + "-validator][data-" + d + '-for="' + k + '"]');
                    if (!this.options.fields || !this.options.fields[k] || "false" !== this.options.fields[k].enabled && this.options.fields[k].enabled !== !1) {
                        if (l.filter("[data-" + d + '-result="' + this.STATUS_INVALID + '"]').length > 0) return !1;
                        if (l.filter("[data-" + d + '-result="' + this.STATUS_NOT_VALIDATED + '"]').length > 0 || l.filter("[data-" + d + '-result="' + this.STATUS_VALIDATING + '"]').length > 0) return null
                    }
                }
                return !0
            },
            isValidField: function(b) {
                var c = this._namespace,
                    d = a([]);
                switch (typeof b) {
                    case "object":
                        d = b, b = b.attr("data-" + c + "-field");
                        break;
                    case "string":
                        d = this.getFieldElements(b)
                }
                if (0 === d.length || !this.options.fields[b] || "false" === this.options.fields[b].enabled || this.options.fields[b].enabled === !1) return !0;
                for (var e, f, g, h = d.attr("type"), i = "radio" === h || "checkbox" === h ? 1 : d.length, j = 0; i > j; j++)
                    if (e = d.eq(j), !this._isExcluded(e))
                        for (f in this.options.fields[b].validators)
                            if (this.options.fields[b].validators[f].enabled !== !1) {
                                if (g = e.data(c + ".result." + f), g === this.STATUS_VALIDATING || g === this.STATUS_NOT_VALIDATED) return null;
                                if (g === this.STATUS_INVALID) return !1
                            } return !0
            },
            offLiveChange: function(b, c) {
                if (null === b || 0 === b.length) return this;
                var d = this._namespace,
                    e = this._getFieldTrigger(b.eq(0)),
                    f = a.map(e, function(a) {
                        return a + "." + c + "." + d
                    }).join(" ");
                return b.off(f), this
            },
            onLiveChange: function(b, c, d) {
                if (null === b || 0 === b.length) return this;
                var e = this._namespace,
                    f = this._getFieldTrigger(b.eq(0)),
                    g = a.map(f, function(a) {
                        return a + "." + c + "." + e
                    }).join(" ");
                switch (this.options.live) {
                    case "submitted":
                        break;
                    case "disabled":
                        b.off(g);
                        break;
                    case "enabled":
                    default:
                        b.off(g).on(g, function(a) {
                            d.apply(this, arguments)
                        })
                }
                return this
            },
            updateMessage: function(b, c, d) {
                var e = this._namespace,
                    f = a([]);
                switch (typeof b) {
                    case "object":
                        f = b, b = b.attr("data-" + e + "-field");
                        break;
                    case "string":
                        f = this.getFieldElements(b)
                }
                var g = this.options.err.clazz.split(" ").join(".");
                return f.each(function() {
                    a(this).data(e + ".messages").find("." + g + "[data-" + e + '-validator="' + c + '"][data-' + e + '-for="' + b + '"]').html(d)
                }), this
            },
            updateStatus: function(b, c, d) {
                var e = this._namespace,
                    f = a([]);
                switch (typeof b) {
                    case "object":
                        f = b, b = b.attr("data-" + e + "-field");
                        break;
                    case "string":
                        f = this.getFieldElements(b)
                }
                if (!b || !this.options.fields[b]) return this;
                c === this.STATUS_NOT_VALIDATED && (this._submitIfValid = !1);
                for (var g = this, h = f.attr("type"), i = this.options.fields[b].row || this.options.row.selector, j = "radio" === h || "checkbox" === h ? 1 : f.length, k = this.options.err.clazz.split(" ").join("."), l = 0; j > l; l++) {
                    var m = f.eq(l);
                    if (!this._isExcluded(m)) {
                        var n, o, p = m.closest(i),
                            q = m.data(e + ".messages"),
                            r = q.find("." + k + "[data-" + e + "-validator][data-" + e + '-for="' + b + '"]'),
                            s = d ? r.filter("[data-" + e + '-validator="' + d + '"]') : r,
                            t = m.data(e + ".icon"),
                            u = "function" == typeof(this.options.fields[b].container || this.options.fields[b].err || this.options.err.container) ? (this.options.fields[b].container || this.options.fields[b].err || this.options.err.container).call(this, m, this) : this.options.fields[b].container || this.options.fields[b].err || this.options.err.container,
                            v = null;
                        if (d) m.data(e + ".result." + d, c);
                        else
                            for (var w in this.options.fields[b].validators) m.data(e + ".result." + w, c);
                        switch (s.attr("data-" + e + "-result", c), c) {
                            case this.STATUS_VALIDATING:
                                v = null, this.disableSubmitButtons(!0), m.removeClass(this.options.control.valid).removeClass(this.options.control.invalid), p.removeClass(this.options.row.valid).removeClass(this.options.row.invalid), t && t.removeClass(this.options.icon.valid).removeClass(this.options.icon.invalid).addClass(this.options.icon.validating).show();
                                break;
                            case this.STATUS_INVALID:
                                v = !1, this.disableSubmitButtons(!0), m.removeClass(this.options.control.valid).addClass(this.options.control.invalid), p.removeClass(this.options.row.valid).addClass(this.options.row.invalid), t && t.removeClass(this.options.icon.valid).removeClass(this.options.icon.validating).addClass(this.options.icon.invalid).show();
                                break;
                            case this.STATUS_IGNORED:
                            case this.STATUS_VALID:
                                n = r.filter("[data-" + e + '-result="' + this.STATUS_VALIDATING + '"]').length > 0, o = r.filter("[data-" + e + '-result="' + this.STATUS_NOT_VALIDATED + '"]').length > 0;
                                var x = r.filter("[data-" + e + '-result="' + this.STATUS_IGNORED + '"]').length;
                                v = n || o ? null : r.filter("[data-" + e + '-result="' + this.STATUS_VALID + '"]').length + x === r.length, m.removeClass(this.options.control.valid).removeClass(this.options.control.invalid), v === !0 ? (this.disableSubmitButtons(this.isValid() === !1), c === this.STATUS_VALID && m.addClass(this.options.control.valid)) : v === !1 && (this.disableSubmitButtons(!0), c === this.STATUS_VALID && m.addClass(this.options.control.invalid)), t && (t.removeClass(this.options.icon.invalid).removeClass(this.options.icon.validating).removeClass(this.options.icon.valid), (c === this.STATUS_VALID || x !== r.length) && t.addClass(n ? this.options.icon.validating : null === v ? "" : v ? this.options.icon.valid : this.options.icon.invalid).show());
                                var y = this.isValidContainer(p);
                                null !== y && (p.removeClass(this.options.row.valid).removeClass(this.options.row.invalid), (c === this.STATUS_VALID || x !== r.length) && p.addClass(y ? this.options.row.valid : this.options.row.invalid));
                                break;
                            case this.STATUS_NOT_VALIDATED:
                            default:
                                v = null, this.disableSubmitButtons(!1), m.removeClass(this.options.control.valid).removeClass(this.options.control.invalid), p.removeClass(this.options.row.valid).removeClass(this.options.row.invalid), t && t.removeClass(this.options.icon.valid).removeClass(this.options.icon.invalid).removeClass(this.options.icon.validating).hide()
                        }!t || "tooltip" !== u && "popover" !== u ? c === this.STATUS_INVALID ? s.show() : s.hide() : v === !1 ? this._createTooltip(m, r.filter("[data-" + e + '-result="' + g.STATUS_INVALID + '"]').eq(0).html(), u) : this._destroyTooltip(m, u), m.trigger(a.Event(this.options.events.fieldStatus), {
                            bv: this,
                            fv: this,
                            field: b,
                            element: m,
                            status: c,
                            validator: d
                        }), this._onFieldValidated(m, d)
                    }
                }
                return this
            },
            validate: function() {
                if (a.isEmptyObject(this.options.fields)) return this._submit(), this;
                this.$form.trigger(a.Event(this.options.events.formPreValidate)), this.disableSubmitButtons(!0), this._submitIfValid = !1;
                for (var b in this.options.fields) this.validateField(b);
                return this._submit(), this._submitIfValid = !0, this
            },
            validateField: function(b) {
                var c = this._namespace,
                    d = a([]);
                switch (typeof b) {
                    case "object":
                        d = b, b = b.attr("data-" + c + "-field");
                        break;
                    case "string":
                        d = this.getFieldElements(b)
                }
                if (0 === d.length || !this.options.fields[b] || "false" === this.options.fields[b].enabled || this.options.fields[b].enabled === !1) return this;
                for (var e, f, g, h = this, i = d.attr("type"), j = "radio" !== i && "checkbox" !== i || "disabled" === this.options.live ? d.length : 1, k = "radio" === i || "checkbox" === i, l = this.options.fields[b].validators, m = this.isOptionEnabled(b, "verbose"), n = 0; j > n; n++) {
                    var o = d.eq(n);
                    if (!this._isExcluded(o)) {
                        /* justselling  part, just added additional check for validated option (check for undefined) */
                        if (typeof o.data(c + ".validators") !== 'undefined') {
                            for (var p = !1, q = o.data(c + ".validators"), r = q.length, s = 0; r > s && (e = q[s].validator, o.data(c + ".dfs." + e) && o.data(c + ".dfs." + e).reject(), !p); s++) {
                                var t = o.data(c + ".result." + e);
                                if (t !== this.STATUS_VALID && t !== this.STATUS_INVALID)
                                    if (l[e].enabled !== !1)
                                        if (o.data(c + ".result." + e, this.STATUS_VALIDATING), f = l[e].alias || e, g = FormValidation.Validator[f].validate(this, o, l[e], e), "object" == typeof g && g.resolve) this.updateStatus(k ? b : o, this.STATUS_VALIDATING, e), o.data(c + ".dfs." + e, g), g.done(function (a, b, d) {
                                            a.removeData(c + ".dfs." + b).data(c + ".response." + b, d), d.message && h.updateMessage(a, b, d.message), h.updateStatus(k ? a.attr("data-" + c + "-field") : a, d.valid === !0 ? h.STATUS_VALID : d.valid === !1 ? h.STATUS_INVALID : h.STATUS_IGNORED, b), d.valid && h._submitIfValid === !0 ? h._submit() : d.valid !== !1 || m || (p = !0)
                                        });
                                        else if ("object" == typeof g && void 0 !== g.valid) {
                                            if (o.data(c + ".response." + e, g), g.message && this.updateMessage(k ? b : o, e, g.message), this.updateStatus(k ? b : o, g.valid === !0 ? this.STATUS_VALID : g.valid === !1 ? this.STATUS_INVALID : this.STATUS_IGNORED, e), g.valid === !1 && !m) break
                                        } else if ("boolean" == typeof g) {
                                            if (o.data(c + ".response." + e, g), this.updateStatus(k ? b : o, g ? this.STATUS_VALID : this.STATUS_INVALID, e), !g && !m) break
                                        } else null === g && (o.data(c + ".response." + e, g), this.updateStatus(k ? b : o, this.STATUS_IGNORED, e));
                                    else this.updateStatus(k ? b : o, this.STATUS_IGNORED, e);
                                else this._onFieldValidated(o, e)
                            }
                        } else {
                            Justselling_Configento_App_Debug.addDebug("Validation Problem, some of option is removed from cache!");
                        }
                    }
                }
                return this
            },
            addField: function(b, c) {
                var d = this._namespace,
                    e = a([]);
                switch (typeof b) {
                    case "object":
                        e = b, b = b.attr("data-" + d + "-field") || b.attr("name");
                        break;
                    case "string":
                        delete this._cacheFields[b], e = this.getFieldElements(b)
                }
                e.attr("data-" + d + "-field", b);
                for (var f = e.attr("type"), g = "radio" === f || "checkbox" === f ? 1 : e.length, h = 0; g > h; h++) {
                    var i = e.eq(h),
                        j = this._parseOptions(i);
                    j = null === j ? c : a.extend(!0, j, c), this.options.fields[b] = a.extend(!0, this.options.fields[b], j), this._cacheFields[b] = this._cacheFields[b] ? this._cacheFields[b].add(i) : i, this._initField("checkbox" === f || "radio" === f ? b : i)
                }
                return this.disableSubmitButtons(!1), this.$form.trigger(a.Event(this.options.events.fieldAdded), {
                    field: b,
                    element: e,
                    options: this.options.fields[b]
                }), this
            },
            destroy: function() {
                var a, b, c, d, e, f, g, h, i = this._namespace;
                for (b in this.options.fields)
                    for (c = this.getFieldElements(b), a = 0; a < c.length; a++) {
                        d = c.eq(a);
                        for (e in this.options.fields[b].validators) d.data(i + ".dfs." + e) && d.data(i + ".dfs." + e).reject(), d.removeData(i + ".result." + e).removeData(i + ".response." + e).removeData(i + ".dfs." + e), h = this.options.fields[b].validators[e].alias || e, "function" == typeof FormValidation.Validator[h].destroy && FormValidation.Validator[h].destroy(this, d, this.options.fields[b].validators[e], e)
                    }
                var j = this.options.err.clazz.split(" ").join(".");
                for (b in this.options.fields)
                    for (c = this.getFieldElements(b), g = this.options.fields[b].row || this.options.row.selector, a = 0; a < c.length; a++) {
                        d = c.eq(a);
                        var k = d.data(i + ".messages");
                        k && k.find("." + j + "[data-" + i + "-validator][data-" + i + '-for="' + b + '"]').remove(), d.removeData(i + ".messages").removeData(i + ".validators").closest(g).removeClass(this.options.row.valid).removeClass(this.options.row.invalid).removeClass(this.options.row.feedback).end().off("." + i).removeAttr("data-" + i + "-field");
                        var l = "function" == typeof(this.options.fields[b].container || this.options.fields[b].err || this.options.err.container) ? (this.options.fields[b].container || this.options.fields[b].err || this.options.err.container).call(this, d, this) : this.options.fields[b].container || this.options.fields[b].err || this.options.err.container;
                        ("tooltip" === l || "popover" === l) && this._destroyTooltip(d, l), f = d.data(i + ".icon"), f && f.remove(), d.removeData(i + ".icon").removeData(i + ".trigger")
                    }
                for (var m in this.options.addOns) "function" == typeof FormValidation.AddOn[m].destroy && FormValidation.AddOn[m].destroy(this, this.options.addOns[m]);
                this.disableSubmitButtons(!1), this.$hiddenButton.remove(), this.$form.removeClass(this.options.elementClass).off("." + i).removeData("bootstrapValidator").removeData("formValidation").find("[data-" + i + "-submit-hidden]").remove().end().find('[type="submit"]').off("click." + i)
            },
            enableFieldValidators: function(a, b, c) {
                var d = this.options.fields[a].validators;
                if (c && d && d[c] && d[c].enabled !== b) this.options.fields[a].validators[c].enabled = b, this.updateStatus(a, this.STATUS_NOT_VALIDATED, c);
                else if (!c && this.options.fields[a].enabled !== b) {
                    this.options.fields[a].enabled = b;
                    for (var e in d) this.enableFieldValidators(a, b, e)
                }
                return this
            },
            getDynamicOption: function(a, b) {
                var c = "string" == typeof a ? this.getFieldElements(a) : a,
                    d = c.val();
                if ("function" == typeof b) return FormValidation.Helper.call(b, [d, this, c]);
                if ("string" == typeof b) {
                    var e = this.getFieldElements(b);
                    return e.length ? e.val() : FormValidation.Helper.call(b, [d, this, c]) || b
                }
                return null
            },
            getForm: function() {
                return this.$form
            },
            getInvalidFields: function() {
                return this.$invalidFields
            },
            getLocale: function() {
                return this.options.locale
            },
            getMessages: function(b, c) {
                var d = this,
                    e = this._namespace,
                    f = [],
                    g = a([]);
                switch (!0) {
                    case b && "object" == typeof b:
                        g = b;
                        break;
                    case b && "string" == typeof b:
                        var h = this.getFieldElements(b);
                        if (h.length > 0) {
                            var i = h.attr("type");
                            g = "radio" === i || "checkbox" === i ? h.eq(0) : h
                        }
                        break;
                    default:
                        g = this.$invalidFields
                }
                var j = c ? "[data-" + e + '-validator="' + c + '"]' : "",
                    k = this.options.err.clazz.split(" ").join(".");
                return g.each(function() {
                    f = f.concat(a(this).data(e + ".messages").find("." + k + "[data-" + e + '-for="' + a(this).attr("data-" + e + "-field") + '"][data-' + e + '-result="' + d.STATUS_INVALID + '"]' + j).map(function() {
                        var b = a(this).attr("data-" + e + "-validator"),
                            c = a(this).attr("data-" + e + "-for");
                        return d.options.fields[c].validators[b].enabled === !1 ? "" : a(this).html()
                    }).get())
                }), f
            },
            getSubmitButton: function() {
                return this.$submitButton
            },
            removeField: function(b) {
                var c = this._namespace,
                    d = a([]);
                switch (typeof b) {
                    case "object":
                        d = b, b = b.attr("data-" + c + "-field") || b.attr("name"), d.attr("data-" + c + "-field", b);
                        break;
                    case "string":
                        d = this.getFieldElements(b)
                }
                if (0 === d.length) return this;
                for (var e = d.attr("type"), f = "radio" === e || "checkbox" === e ? 1 : d.length, g = 0; f > g; g++) {
                    var h = d.eq(g);
                    this.$invalidFields = this.$invalidFields.not(h), this._cacheFields[b] = this._cacheFields[b].not(h)
                }
                return this._cacheFields[b] && 0 !== this._cacheFields[b].length || delete this.options.fields[b], ("checkbox" === e || "radio" === e) && this._initField(b), this.disableSubmitButtons(!1), this.$form.trigger(a.Event(this.options.events.fieldRemoved), {
                    field: b,
                    element: d
                }), this
            },
            resetField: function(b, c) {
                var d = this._namespace,
                    e = a([]);
                switch (typeof b) {
                    case "object":
                        e = b, b = b.attr("data-" + d + "-field");
                        break;
                    case "string":
                        e = this.getFieldElements(b)
                }
                var f = 0,
                    g = e.length;
                if (this.options.fields[b])
                    for (f = 0; g > f; f++)
                        for (var h in this.options.fields[b].validators) e.eq(f).removeData(d + ".dfs." + h);
                if (c) {
                    var i = e.attr("type");
                    "radio" === i || "checkbox" === i ? e.prop("checked", !1).removeAttr("selected") : e.val("")
                }
                for (this.updateStatus(b, this.STATUS_NOT_VALIDATED), f = 0; g > f; f++) e.eq(f).trigger(a.Event(this.options.events.fieldReset), {
                    fv: this,
                    field: b,
                    element: e.eq(f),
                    resetValue: c
                });
                return this
            },
            resetForm: function(b) {
                for (var c in this.options.fields) this.resetField(c, b);
                return this.$invalidFields = a([]), this.$submitButton = null, this.disableSubmitButtons(!1), this.$form.trigger(a.Event(this.options.events.formReset), {
                    fv: this,
                    resetValue: b
                }), this
            },
            revalidateField: function(a) {
                return this.updateStatus(a, this.STATUS_NOT_VALIDATED).validateField(a), this
            },
            setLocale: function(b) {
                return this.options.locale = b, this.$form.trigger(a.Event(this.options.events.localeChanged), {
                    locale: b,
                    bv: this,
                    fv: this
                }), this
            },
            updateOption: function(a, b, c, d) {
                var e = this._namespace;
                return "object" == typeof a && (a = a.attr("data-" + e + "-field")), this.options.fields[a] && this.options.fields[a].validators[b] && (this.options.fields[a].validators[b][c] = d, this.updateStatus(a, this.STATUS_NOT_VALIDATED, b)), this
            },
            validateContainer: function(b) {
                var c = this,
                    d = this._namespace,
                    e = [],
                    f = "string" == typeof b ? a(b) : b;
                if (0 === f.length) return this;
                f.find("[data-" + d + "-field]").each(function() {
                    var b = a(this);
                    c._isExcluded(b) || e.push(b)
                });
                for (var g = e.length, h = 0; g > h; h++) this.validateField(e[h]);
                return this
            }
        }, a.fn.formValidation = function(b) {
            var c = arguments;
            return this.each(function() {
                var d = a(this),
                    e = d.data("formValidation"),
                    f = "object" == typeof b && b;
                if (!e) {
                    var g = (f.framework || d.attr("data-fv-framework") || "bootstrap").toLowerCase(),
                        h = g.substr(0, 1).toUpperCase() + g.substr(1);
                    if ("undefined" == typeof FormValidation.Framework[h]) throw new Error("The class FormValidation.Framework." + h + " is not implemented");
                    e = new FormValidation.Framework[h](this, f), d.addClass("fv-form-" + g).data("formValidation", e)
                }
                "string" == typeof b && e[b].apply(e, Array.prototype.slice.call(c, 1))
            })
        }, a.fn.formValidation.Constructor = FormValidation.Base, a.fn.formValidation.DEFAULT_MESSAGE = "This value is not valid", a.fn.formValidation.DEFAULT_OPTIONS = {
            autoFocus: !0,
            declarative: !0,
            elementClass: "fv-form",
            events: {
                formInit: "init.form.fv",
                formPreValidate: "prevalidate.form.fv",
                formError: "err.form.fv",
                formReset: "rst.form.fv",
                formSuccess: "success.form.fv",
                fieldAdded: "added.field.fv",
                fieldRemoved: "removed.field.fv",
                fieldInit: "init.field.fv",
                fieldError: "err.field.fv",
                fieldReset: "rst.field.fv",
                fieldSuccess: "success.field.fv",
                fieldStatus: "status.field.fv",
                localeChanged: "changed.locale.fv",
                validatorError: "err.validator.fv",
                validatorSuccess: "success.validator.fv",
                validatorIgnored: "ignored.validator.fv"
            },
            excluded: [":disabled", ":hidden", ":not(:visible)"],
            fields: null,
            live: "enabled",
            locale: "en_US",
            message: null,
            threshold: null,
            verbose: !0,
            button: {
                selector: '[type="submit"]:not([formnovalidate])',
                disabled: ""
            },
            control: {
                valid: "",
                invalid: ""
            },
            err: {
                clazz: "",
                container: null,
                parent: null
            },
            icon: {
                valid: null,
                invalid: null,
                validating: null,
                feedback: ""
            },
            row: {
                selector: null,
                valid: "",
                invalid: "",
                feedback: ""
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.Helper = {
            call: function(a, b) {
                if ("function" == typeof a) return a.apply(this, b);
                if ("string" == typeof a) {
                    "()" === a.substring(a.length - 2) && (a = a.substring(0, a.length - 2));
                    for (var c = a.split("."), d = c.pop(), e = window, f = 0; f < c.length; f++) e = e[c[f]];
                    return "undefined" == typeof e[d] ? null : e[d].apply(this, b)
                }
            },
            date: function(a, b, c, d) {
                if (isNaN(a) || isNaN(b) || isNaN(c)) return !1;
                if (c.length > 2 || b.length > 2 || a.length > 4) return !1;
                if (c = parseInt(c, 10), b = parseInt(b, 10), a = parseInt(a, 10), 1e3 > a || a > 9999 || 0 >= b || b > 12) return !1;
                var e = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
                if ((a % 400 === 0 || a % 100 !== 0 && a % 4 === 0) && (e[1] = 29), 0 >= c || c > e[b - 1]) return !1;
                if (d === !0) {
                    var f = new Date,
                        g = f.getFullYear(),
                        h = f.getMonth(),
                        i = f.getDate();
                    return g > a || a === g && h > b - 1 || a === g && b - 1 === h && i > c
                }
                return !0
            },
            format: function(b, c) {
                a.isArray(c) || (c = [c]);
                for (var d in c) b = b.replace("%s", c[d]);
                return b
            },
            luhn: function(a) {
                for (var b = a.length, c = 0, d = [
                    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
                    [0, 2, 4, 6, 8, 1, 3, 5, 7, 9]
                ], e = 0; b--;) e += d[c][parseInt(a.charAt(b), 10)], c ^= 1;
                return e % 10 === 0 && e > 0
            },
            mod11And10: function(a) {
                for (var b = 5, c = a.length, d = 0; c > d; d++) b = (2 * (b || 10) % 11 + parseInt(a.charAt(d), 10)) % 10;
                return 1 === b
            },
            mod37And36: function(a, b) {
                b = b || "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                for (var c = b.length, d = a.length, e = Math.floor(c / 2), f = 0; d > f; f++) e = (2 * (e || c) % (c + 1) + b.indexOf(a.charAt(f))) % c;
                return 1 === e
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                base64: {
                    "default": "Please enter a valid base 64 encoded"
                }
            }
        }), FormValidation.Validator.base64 = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                return "" === e ? !0 : /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$/.test(e)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                between: {
                    "default": "Please enter a value between %s and %s",
                    notInclusive: "Please enter a value between %s and %s strictly"
                },
                exact: {
                    "default": "Only valid value is %s",
                    notInclusive: "Please enter a value between x56 %s and %s strictly"
                }
            }
        }), FormValidation.Validator.between = {
            html5Attributes: {
                message: "message",
                min: "min",
                max: "max",
                inclusive: "inclusive"
            },
            enableByHtml5: function(a) {
                return "range" === a.attr("type") ? {
                    min: a.attr("min"),
                    max: a.attr("max")
                } : !1
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                f = this._format(f);
                var g = b.getLocale(),
                    h = a.isNumeric(d.min) ? d.min : b.getDynamicOption(c, d.min),
                    i = a.isNumeric(d.max) ? d.max : b.getDynamicOption(c, d.max),
                    j = this._format(h),
                    k = this._format(i);
                if (h === i) { // justselling exact
                    return d.inclusive === !0 || void 0 === d.inclusive ? {
                        valid: a.isNumeric(f) && parseFloat(f) >= j && parseFloat(f) <= k,
                        message: FormValidation.Helper.format(d.message || FormValidation.I18n[g].exact["default"], [h, i])
                    } : {
                        valid: a.isNumeric(f) && parseFloat(f) > j && parseFloat(f) < k,
                        message: FormValidation.Helper.format(d.message || FormValidation.I18n[g].between.notInclusive, [h, i])
                    }
                }
                return d.inclusive === !0 || void 0 === d.inclusive ? {
                    valid: a.isNumeric(f) && parseFloat(f) >= j && parseFloat(f) <= k,
                    message: FormValidation.Helper.format(d.message || FormValidation.I18n[g].between["default"], [h, i])
                } : {
                    valid: a.isNumeric(f) && parseFloat(f) > j && parseFloat(f) < k,
                    message: FormValidation.Helper.format(d.message || FormValidation.I18n[g].between.notInclusive, [h, i])
                }
            },
            _format: function(a) {
                return (a + "").replace(",", ".")
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                bic: {
                    "default": "Please enter a valid BIC number"
                }
            }
        }), FormValidation.Validator.bic = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                return "" === e ? !0 : /^[a-zA-Z]{6}[a-zA-Z0-9]{2}([a-zA-Z0-9]{3})?$/.test(e)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.Validator.blank = {
            validate: function(a, b, c, d) {
                return !0
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                callback: {
                    "default": "Please enter a valid value"
                }
            }
        }), FormValidation.Validator.callback = {
            priority: 999,
            html5Attributes: {
                message: "message",
                callback: "callback"
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e),
                    g = new a.Deferred,
                    h = {
                        valid: !0
                    };
                if (d.callback) {
                    var i = FormValidation.Helper.call(d.callback, [f, b, c]);
                    h = "boolean" == typeof i || null === i ? {
                        valid: i
                    } : i
                }
                return g.resolve(c, e, h), g
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                choice: {
                    "default": "Please enter a valid value",
                    less: "Please choose %s options at minimum",
                    more: "Please choose %s options at maximum",
                    between: "Please choose %s - %s options"
                }
            }
        }), FormValidation.Validator.choice = {
            html5Attributes: {
                message: "message",
                min: "min",
                max: "max"
            },
            validate: function(b, c, d, e) {
                var f = b.getLocale(),
                    g = b.getNamespace(),
                    h = c.is("select") ? b.getFieldElements(c.attr("data-" + g + "-field")).find("option").filter(":selected").length : b.getFieldElements(c.attr("data-" + g + "-field")).filter(":checked").length,
                    i = d.min ? a.isNumeric(d.min) ? d.min : b.getDynamicOption(c, d.min) : null,
                    j = d.max ? a.isNumeric(d.max) ? d.max : b.getDynamicOption(c, d.max) : null,
                    k = !0,
                    l = d.message || FormValidation.I18n[f].choice["default"];
                switch ((i && h < parseInt(i, 10) || j && h > parseInt(j, 10)) && (k = !1), !0) {
                    case !!i && !!j:
                        l = FormValidation.Helper.format(d.message || FormValidation.I18n[f].choice.between, [parseInt(i, 10), parseInt(j, 10)]);
                        break;
                    case !!i:
                        l = FormValidation.Helper.format(d.message || FormValidation.I18n[f].choice.less, parseInt(i, 10));
                        break;
                    case !!j:
                        l = FormValidation.Helper.format(d.message || FormValidation.I18n[f].choice.more, parseInt(j, 10))
                }
                return {
                    valid: k,
                    message: l
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                color: {
                    "default": "Please enter a valid color"
                }
            }
        }), FormValidation.Validator.color = {
            html5Attributes: {
                message: "message",
                type: "type"
            },
            enableByHtml5: function(a) {
                return "color" === a.attr("type")
            },
            SUPPORTED_TYPES: ["hex", "rgb", "rgba", "hsl", "hsla", "keyword"],
            KEYWORD_COLORS: ["aliceblue", "antiquewhite", "aqua", "aquamarine", "azure", "beige", "bisque", "black", "blanchedalmond", "blue", "blueviolet", "brown", "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue", "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod", "darkgray", "darkgreen", "darkgrey", "darkkhaki", "darkmagenta", "darkolivegreen", "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen", "darkslateblue", "darkslategray", "darkslategrey", "darkturquoise", "darkviolet", "deeppink", "deepskyblue", "dimgray", "dimgrey", "dodgerblue", "firebrick", "floralwhite", "forestgreen", "fuchsia", "gainsboro", "ghostwhite", "gold", "goldenrod", "gray", "green", "greenyellow", "grey", "honeydew", "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender", "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral", "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightgrey", "lightpink", "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray", "lightslategrey", "lightsteelblue", "lightyellow", "lime", "limegreen", "linen", "magenta", "maroon", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple", "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise", "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin", "navajowhite", "navy", "oldlace", "olive", "olivedrab", "orange", "orangered", "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred", "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue", "purple", "red", "rosybrown", "royalblue", "saddlebrown", "salmon", "sandybrown", "seagreen", "seashell", "sienna", "silver", "skyblue", "slateblue", "slategray", "slategrey", "snow", "springgreen", "steelblue", "tan", "teal", "thistle", "tomato", "transparent", "turquoise", "violet", "wheat", "white", "whitesmoke", "yellow", "yellowgreen"],
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                if (this.enableByHtml5(c)) return /^#[0-9A-F]{6}$/i.test(f);
                var g = d.type || this.SUPPORTED_TYPES;
                a.isArray(g) || (g = g.replace(/s/g, "").split(","));
                for (var h, i, j = !1, k = 0; k < g.length; k++)
                    if (i = g[k], h = "_" + i.toLowerCase(), j = j || this[h](f)) return !0;
                return !1
            },
            _hex: function(a) {
                return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a)
            },
            _hsl: function(a) {
                return /^hsl\((\s*(-?\d+)\s*,)(\s*(\b(0?\d{1,2}|100)\b%)\s*,)(\s*(\b(0?\d{1,2}|100)\b%)\s*)\)$/.test(a)
            },
            _hsla: function(a) {
                return /^hsla\((\s*(-?\d+)\s*,)(\s*(\b(0?\d{1,2}|100)\b%)\s*,){2}(\s*(0?(\.\d+)?|1(\.0+)?)\s*)\)$/.test(a)
            },
            _keyword: function(b) {
                return a.inArray(b, this.KEYWORD_COLORS) >= 0
            },
            _rgb: function(a) {
                var b = /^rgb\((\s*(\b([01]?\d{1,2}|2[0-4]\d|25[0-5])\b)\s*,){2}(\s*(\b([01]?\d{1,2}|2[0-4]\d|25[0-5])\b)\s*)\)$/,
                    c = /^rgb\((\s*(\b(0?\d{1,2}|100)\b%)\s*,){2}(\s*(\b(0?\d{1,2}|100)\b%)\s*)\)$/;
                return b.test(a) || c.test(a)
            },
            _rgba: function(a) {
                var b = /^rgba\((\s*(\b([01]?\d{1,2}|2[0-4]\d|25[0-5])\b)\s*,){3}(\s*(0?(\.\d+)?|1(\.0+)?)\s*)\)$/,
                    c = /^rgba\((\s*(\b(0?\d{1,2}|100)\b%)\s*,){3}(\s*(0?(\.\d+)?|1(\.0+)?)\s*)\)$/;
                return b.test(a) || c.test(a)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                creditCard: {
                    "default": "Please enter a valid credit card number"
                }
            }
        }), FormValidation.Validator.creditCard = {
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                if (/[^0-9-\s]+/.test(f)) return !1;
                if (f = f.replace(/\D/g, ""), !FormValidation.Helper.luhn(f)) return !1;
                var g, h, i = {
                    AMERICAN_EXPRESS: {
                        length: [15],
                        prefix: ["34", "37"]
                    },
                    DANKORT: {
                        length: [16],
                        prefix: ["5019"]
                    },
                    DINERS_CLUB: {
                        length: [14],
                        prefix: ["300", "301", "302", "303", "304", "305", "36"]
                    },
                    DINERS_CLUB_US: {
                        length: [16],
                        prefix: ["54", "55"]
                    },
                    DISCOVER: {
                        length: [16],
                        prefix: ["6011", "622126", "622127", "622128", "622129", "62213", "62214", "62215", "62216", "62217", "62218", "62219", "6222", "6223", "6224", "6225", "6226", "6227", "6228", "62290", "62291", "622920", "622921", "622922", "622923", "622924", "622925", "644", "645", "646", "647", "648", "649", "65"]
                    },
                    ELO: {
                        length: [16],
                        prefix: ["4011", "4312", "4389", "4514", "4573", "4576", "5041", "5066", "5067", "509", "6277", "6362", "6363", "650", "6516", "6550"]
                    },
                    FORBRUGSFORENINGEN: {
                        length: [16],
                        prefix: ["600722"]
                    },
                    JCB: {
                        length: [16],
                        prefix: ["3528", "3529", "353", "354", "355", "356", "357", "358"]
                    },
                    LASER: {
                        length: [16, 17, 18, 19],
                        prefix: ["6304", "6706", "6771", "6709"]
                    },
                    MAESTRO: {
                        length: [12, 13, 14, 15, 16, 17, 18, 19],
                        prefix: ["5018", "5020", "5038", "5868", "6304", "6759", "6761", "6762", "6763", "6764", "6765", "6766"]
                    },
                    MASTERCARD: {
                        length: [16],
                        prefix: ["51", "52", "53", "54", "55"]
                    },
                    SOLO: {
                        length: [16, 18, 19],
                        prefix: ["6334", "6767"]
                    },
                    UNIONPAY: {
                        length: [16, 17, 18, 19],
                        prefix: ["622126", "622127", "622128", "622129", "62213", "62214", "62215", "62216", "62217", "62218", "62219", "6222", "6223", "6224", "6225", "6226", "6227", "6228", "62290", "62291", "622920", "622921", "622922", "622923", "622924", "622925"]
                    },
                    VISA_ELECTRON: {
                        length: [16],
                        prefix: ["4026", "417500", "4405", "4508", "4844", "4913", "4917"]
                    },
                    VISA: {
                        length: [16],
                        prefix: ["4"]
                    }
                };
                for (g in i)
                    for (h in i[g].prefix)
                        if (f.substr(0, i[g].prefix[h].length) === i[g].prefix[h] && -1 !== a.inArray(f.length, i[g].length)) return {
                            valid: !0,
                            type: g
                        };
                return !1
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                cusip: {
                    "default": "Please enter a valid CUSIP number"
                }
            }
        }), FormValidation.Validator.cusip = {
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                if (f = f.toUpperCase(), !/^[0-9A-Z]{9}$/.test(f)) return !1;
                for (var g = a.map(f.split(""), function(a) {
                    var b = a.charCodeAt(0);
                    return b >= "A".charCodeAt(0) && b <= "Z".charCodeAt(0) ? b - "A".charCodeAt(0) + 10 : a
                }), h = g.length, i = 0, j = 0; h - 1 > j; j++) {
                    var k = parseInt(g[j], 10);
                    j % 2 !== 0 && (k *= 2), k > 9 && (k -= 9), i += k
                }
                return i = (10 - i % 10) % 10, i === parseInt(g[h - 1], 10)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                cvv: {
                    "default": "Please enter a valid CVV number"
                }
            }
        }), FormValidation.Validator.cvv = {
            html5Attributes: {
                message: "message",
                ccfield: "creditCardField"
            },
            init: function(a, b, c, d) {
                if (c.creditCardField) {
                    var e = a.getFieldElements(c.creditCardField);
                    a.onLiveChange(e, "live_" + d, function() {
                        var c = a.getStatus(b, d);
                        c !== a.STATUS_NOT_VALIDATED && a.revalidateField(b)
                    })
                }
            },
            destroy: function(a, b, c, d) {
                if (c.creditCardField) {
                    var e = a.getFieldElements(c.creditCardField);
                    a.offLiveChange(e, "live_" + d)
                }
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                if (!/^[0-9]{3,4}$/.test(f)) return !1;
                if (!d.creditCardField) return !0;
                var g = b.getFieldValue(d.creditCardField, "creditCard");
                if (null === g || "" === g) return !0;
                g = g.replace(/\D/g, "");
                var h, i, j = {
                        AMERICAN_EXPRESS: {
                            length: [15],
                            prefix: ["34", "37"]
                        },
                        DANKORT: {
                            length: [16],
                            prefix: ["5019"]
                        },
                        DINERS_CLUB: {
                            length: [14],
                            prefix: ["300", "301", "302", "303", "304", "305", "36"]
                        },
                        DINERS_CLUB_US: {
                            length: [16],
                            prefix: ["54", "55"]
                        },
                        DISCOVER: {
                            length: [16],
                            prefix: ["6011", "622126", "622127", "622128", "622129", "62213", "62214", "62215", "62216", "62217", "62218", "62219", "6222", "6223", "6224", "6225", "6226", "6227", "6228", "62290", "62291", "622920", "622921", "622922", "622923", "622924", "622925", "644", "645", "646", "647", "648", "649", "65"]
                        },
                        ELO: {
                            length: [16],
                            prefix: ["4011", "4312", "4389", "4514", "4573", "4576", "5041", "5066", "5067", "509", "6277", "6362", "6363", "650", "6516", "6550"]
                        },
                        FORBRUGSFORENINGEN: {
                            length: [16],
                            prefix: ["600722"]
                        },
                        JCB: {
                            length: [16],
                            prefix: ["3528", "3529", "353", "354", "355", "356", "357", "358"]
                        },
                        LASER: {
                            length: [16, 17, 18, 19],
                            prefix: ["6304", "6706", "6771", "6709"]
                        },
                        MAESTRO: {
                            length: [12, 13, 14, 15, 16, 17, 18, 19],
                            prefix: ["5018", "5020", "5038", "5868", "6304", "6759", "6761", "6762", "6763", "6764", "6765", "6766"]
                        },
                        MASTERCARD: {
                            length: [16],
                            prefix: ["51", "52", "53", "54", "55"]
                        },
                        SOLO: {
                            length: [16, 18, 19],
                            prefix: ["6334", "6767"]
                        },
                        UNIONPAY: {
                            length: [16, 17, 18, 19],
                            prefix: ["622126", "622127", "622128", "622129", "62213", "62214", "62215", "62216", "62217", "62218", "62219", "6222", "6223", "6224", "6225", "6226", "6227", "6228", "62290", "62291", "622920", "622921", "622922", "622923", "622924", "622925"]
                        },
                        VISA_ELECTRON: {
                            length: [16],
                            prefix: ["4026", "417500", "4405", "4508", "4844", "4913", "4917"]
                        },
                        VISA: {
                            length: [16],
                            prefix: ["4"]
                        }
                    },
                    k = null;
                for (h in j)
                    for (i in j[h].prefix)
                        if (g.substr(0, j[h].prefix[i].length) === j[h].prefix[i] && -1 !== a.inArray(g.length, j[h].length)) {
                            k = h;
                            break
                        } return null === k ? !1 : "AMERICAN_EXPRESS" === k ? 4 === f.length : 3 === f.length
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                date: {
                    "default": "Please enter a valid date",
                    min: "Please enter a date after %s",
                    max: "Please enter a date before %s",
                    range: "Please enter a date in the range %s - %s"
                }
            }
        }), FormValidation.Validator.date = {
            html5Attributes: {
                message: "message",
                format: "format",
                min: "min",
                max: "max",
                separator: "separator"
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                d.format = d.format || "MM/DD/YYYY", "date" === c.attr("type") && (d.format = "YYYY-MM-DD");
                var g = b.getLocale(),
                    h = d.message || FormValidation.I18n[g].date["default"],
                    i = d.format.split(" "),
                    j = i[0],
                    k = i.length > 1 ? i[1] : null,
                    l = i.length > 2 ? i[2] : null,
                    m = f.split(" "),
                    n = m[0],
                    o = m.length > 1 ? m[1] : null;
                if (i.length !== m.length) return {
                    valid: !1,
                    message: h
                };
                var p = d.separator;
                if (p || (p = -1 !== n.indexOf("/") ? "/" : -1 !== n.indexOf("-") ? "-" : -1 !== n.indexOf(".") ? "." : null), null === p || -1 === n.indexOf(p)) return {
                    valid: !1,
                    message: h
                };
                if (n = n.split(p), j = j.split(p), n.length !== j.length) return {
                    valid: !1,
                    message: h
                };
                var q = n[a.inArray("YYYY", j)],
                    r = n[a.inArray("MM", j)],
                    s = n[a.inArray("DD", j)];
                if (!q || !r || !s || 4 !== q.length) return {
                    valid: !1,
                    message: h
                };
                var t = null,
                    u = null,
                    v = null;
                if (k) {
                    if (k = k.split(":"), o = o.split(":"), k.length !== o.length) return {
                        valid: !1,
                        message: h
                    };
                    if (u = o.length > 0 ? o[0] : null, t = o.length > 1 ? o[1] : null, v = o.length > 2 ? o[2] : null, "" === u || "" === t || "" === v) return {
                        valid: !1,
                        message: h
                    };
                    if (v) {
                        if (isNaN(v) || v.length > 2) return {
                            valid: !1,
                            message: h
                        };
                        if (v = parseInt(v, 10), 0 > v || v > 60) return {
                            valid: !1,
                            message: h
                        }
                    }
                    if (u) {
                        if (isNaN(u) || u.length > 2) return {
                            valid: !1,
                            message: h
                        };
                        if (u = parseInt(u, 10), 0 > u || u >= 24 || l && u > 12) return {
                            valid: !1,
                            message: h
                        }
                    }
                    if (t) {
                        if (isNaN(t) || t.length > 2) return {
                            valid: !1,
                            message: h
                        };
                        if (t = parseInt(t, 10), 0 > t || t > 59) return {
                            valid: !1,
                            message: h
                        }
                    }
                }
                var w = FormValidation.Helper.date(q, r, s),
                    x = null,
                    y = null,
                    z = d.min,
                    A = d.max;
                switch (z && (x = z instanceof Date ? z : this._parseDate(z, j, p) || this._parseDate(b.getDynamicOption(c, z), j, p), z = this._formatDate(x, d.format)), A && (y = A instanceof Date ? A : this._parseDate(A, j, p) || this._parseDate(b.getDynamicOption(c, A), j, p), A = this._formatDate(y, d.format)), n = new Date(q, r - 1, s, u, t, v), !0) {
                    case z && !A && w:
                        w = n.getTime() >= x.getTime(), h = d.message || FormValidation.Helper.format(FormValidation.I18n[g].date.min, z);
                        break;
                    case A && !z && w:
                        w = n.getTime() <= y.getTime(), h = d.message || FormValidation.Helper.format(FormValidation.I18n[g].date.max, A);
                        break;
                    case A && z && w:
                        w = n.getTime() <= y.getTime() && n.getTime() >= x.getTime(), h = d.message || FormValidation.Helper.format(FormValidation.I18n[g].date.range, [z, A])
                }
                return {
                    valid: w,
                    date: n,
                    message: h
                }
            },
            _parseDate: function(b, c, d) {
                if (b instanceof Date) return b;
                if ("string" != typeof b) return null;
                var e = a.inArray("YYYY", c),
                    f = a.inArray("MM", c),
                    g = a.inArray("DD", c);
                if (-1 === e || -1 === f || -1 === g) return null;
                var h = 0,
                    i = 0,
                    j = 0,
                    k = b.split(" "),
                    l = k[0].split(d);
                if (l.length < 3) return null;
                if (k.length > 1) {
                    var m = k[1].split(":");
                    i = m.length > 0 ? m[0] : null, h = m.length > 1 ? m[1] : null, j = m.length > 2 ? m[2] : null
                }
                return new Date(l[e], l[f] - 1, l[g], i, h, j)
            },
            _formatDate: function(a, b) {
                b = b.replace(/Y/g, "y").replace(/M/g, "m").replace(/D/g, "d").replace(/:m/g, ":M").replace(/:mm/g, ":MM").replace(/:S/, ":s").replace(/:SS/, ":ss");
                var c = {
                    d: function(a) {
                        return a.getDate()
                    },
                    dd: function(a) {
                        var b = a.getDate();
                        return 10 > b ? "0" + b : b
                    },
                    m: function(a) {
                        return a.getMonth() + 1
                    },
                    mm: function(a) {
                        var b = a.getMonth() + 1;
                        return 10 > b ? "0" + b : b
                    },
                    yy: function(a) {
                        return ("" + a.getFullYear()).substr(2)
                    },
                    yyyy: function(a) {
                        return a.getFullYear()
                    },
                    h: function(a) {
                        return a.getHours() % 12 || 12
                    },
                    hh: function(a) {
                        var b = a.getHours() % 12 || 12;
                        return 10 > b ? "0" + b : b
                    },
                    H: function(a) {
                        return a.getHours()
                    },
                    HH: function(a) {
                        var b = a.getHours();
                        return 10 > b ? "0" + b : b
                    },
                    M: function(a) {
                        return a.getMinutes()
                    },
                    MM: function(a) {
                        var b = a.getMinutes();
                        return 10 > b ? "0" + b : b
                    },
                    s: function(a) {
                        return a.getSeconds()
                    },
                    ss: function(a) {
                        var b = a.getSeconds();
                        return 10 > b ? "0" + b : b
                    }
                };
                return b.replace(/d{1,4}|m{1,4}|yy(?:yy)?|([HhMs])\1?|"[^"]*"|'[^']*'/g, function(b) {
                    return c[b] ? c[b](a) : b.slice(1, b.length - 1)
                })
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                different: {
                    "default": "Please enter a different value"
                }
            }
        }), FormValidation.Validator.different = {
            html5Attributes: {
                message: "message",
                field: "field"
            },
            init: function(b, c, d, e) {
                for (var f = d.field.split(","), g = 0; g < f.length; g++) {
                    var h = b.getFieldElements(a.trim(f[g]));
                    b.onLiveChange(h, "live_" + e, function() {
                        var a = b.getStatus(c, e);
                        a !== b.STATUS_NOT_VALIDATED && b.revalidateField(c)
                    })
                }
            },
            destroy: function(b, c, d, e) {
                for (var f = d.field.split(","), g = 0; g < f.length; g++) {
                    var h = b.getFieldElements(a.trim(f[g]));
                    b.offLiveChange(h, "live_" + e)
                }
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                for (var g = d.field.split(","), h = !0, i = 0; i < g.length; i++) {
                    var j = b.getFieldElements(a.trim(g[i]));
                    if (null != j && 0 !== j.length) {
                        var k = b.getFieldValue(j, e);
                        f === k ? h = !1 : "" !== k && b.updateStatus(j, b.STATUS_VALID, e)
                    }
                }
                return h
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                digits: {
                    "default": "Please enter only digits"
                }
            }
        }), FormValidation.Validator.digits = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                return "" === e ? !0 : /^\d+$/.test(e)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                ean: {
                    "default": "Please enter a valid EAN number"
                }
            }
        }), FormValidation.Validator.ean = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                if (!/^(\d{8}|\d{12}|\d{13})$/.test(e)) return !1;
                for (var f = e.length, g = 0, h = 8 === f ? [3, 1] : [1, 3], i = 0; f - 1 > i; i++) g += parseInt(e.charAt(i), 10) * h[i % 2];
                return g = (10 - g % 10) % 10, g + "" === e.charAt(f - 1)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                ein: {
                    "default": "Please enter a valid EIN number"
                }
            }
        }), FormValidation.Validator.ein = {
            CAMPUS: {
                ANDOVER: ["10", "12"],
                ATLANTA: ["60", "67"],
                AUSTIN: ["50", "53"],
                BROOKHAVEN: ["01", "02", "03", "04", "05", "06", "11", "13", "14", "16", "21", "22", "23", "25", "34", "51", "52", "54", "55", "56", "57", "58", "59", "65"],
                CINCINNATI: ["30", "32", "35", "36", "37", "38", "61"],
                FRESNO: ["15", "24"],
                KANSAS_CITY: ["40", "44"],
                MEMPHIS: ["94", "95"],
                OGDEN: ["80", "90"],
                PHILADELPHIA: ["33", "39", "41", "42", "43", "48", "62", "63", "64", "66", "68", "71", "72", "73", "74", "75", "76", "77", "81", "82", "83", "84", "85", "86", "87", "88", "91", "92", "93", "98", "99"],
                INTERNET: ["20", "26", "27", "45", "46", "47"],
                SMALL_BUSINESS_ADMINISTRATION: ["31"]
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                if (!/^[0-9]{2}-?[0-9]{7}$/.test(f)) return !1;
                var g = f.substr(0, 2) + "";
                for (var h in this.CAMPUS)
                    if (-1 !== a.inArray(g, this.CAMPUS[h])) return {
                        valid: !0,
                        campus: h
                    };
                return !1
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                emailAddress: {
                    "default": "Please enter a valid email address"
                }
            }
        }), FormValidation.Validator.emailAddress = {
            html5Attributes: {
                message: "message",
                multiple: "multiple",
                separator: "separator"
            },
            enableByHtml5: function(a) {
                return "email" === a.attr("type")
            },
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                var f = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
                    g = c.multiple === !0 || "true" === c.multiple;
                if (g) {
                    for (var h = c.separator || /[,;]/, i = this._splitEmailAddresses(e, h), j = 0; j < i.length; j++)
                        if (!f.test(i[j])) return !1;
                    return !0
                }
                return f.test(e)
            },
            _splitEmailAddresses: function(a, b) {
                for (var c = a.split(/"/), d = c.length, e = [], f = "", g = 0; d > g; g++)
                    if (g % 2 === 0) {
                        var h = c[g].split(b),
                            i = h.length;
                        if (1 === i) f += h[0];
                        else {
                            e.push(f + h[0]);
                            for (var j = 1; i - 1 > j; j++) e.push(h[j]);
                            f = h[i - 1]
                        }
                    } else f += '"' + c[g], d - 1 > g && (f += '"');
                return e.push(f), e
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                file: {
                    "default": "Please choose a valid file"
                }
            }
        }), FormValidation.Validator.file = {
            Error: {
                EXTENSION: "EXTENSION",
                MAX_FILES: "MAX_FILES",
                MAX_SIZE: "MAX_SIZE",
                MAX_TOTAL_SIZE: "MAX_TOTAL_SIZE",
                MIN_FILES: "MIN_FILES",
                MIN_SIZE: "MIN_SIZE",
                MIN_TOTAL_SIZE: "MIN_TOTAL_SIZE",
                TYPE: "TYPE"
            },
            html5Attributes: {
                extension: "extension",
                maxfiles: "maxFiles",
                minfiles: "minFiles",
                maxsize: "maxSize",
                minsize: "minSize",
                maxtotalsize: "maxTotalSize",
                mintotalsize: "minTotalSize",
                message: "message",
                type: "type"
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                var g, h = d.extension ? d.extension.toLowerCase().split(",") : null,
                    i = d.type ? d.type.toLowerCase().split(",") : null,
                    j = window.File && window.FileList && window.FileReader;
                if (j) {
                    var k = c.get(0).files,
                        l = k.length,
                        m = 0;
                    if (d.maxFiles && l > parseInt(d.maxFiles, 10)) return {
                        valid: !1,
                        error: this.Error.MAX_FILES
                    };
                    if (d.minFiles && l < parseInt(d.minFiles, 10)) return {
                        valid: !1,
                        error: this.Error.MIN_FILES
                    };
                    for (var n = {}, o = 0; l > o; o++) {
                        if (m += k[o].size, g = k[o].name.substr(k[o].name.lastIndexOf(".") + 1), n = {
                            file: k[o],
                            size: k[o].size,
                            ext: g,
                            type: k[o].type
                        }, d.minSize && k[o].size < parseInt(d.minSize, 10)) return {
                            valid: !1,
                            error: this.Error.MIN_SIZE,
                            metaData: n
                        };
                        if (d.maxSize && k[o].size > parseInt(d.maxSize, 10)) return {
                            valid: !1,
                            error: this.Error.MAX_SIZE,
                            metaData: n
                        };
                        if (h && -1 === a.inArray(g.toLowerCase(), h)) return {
                            valid: !1,
                            error: this.Error.EXTENSION,
                            metaData: n
                        };
                        if (k[o].type && i && -1 === a.inArray(k[o].type.toLowerCase(), i)) return {
                            valid: !1,
                            error: this.Error.TYPE,
                            metaData: n
                        }
                    }
                    if (d.maxTotalSize && m > parseInt(d.maxTotalSize, 10)) return {
                        valid: !1,
                        error: this.Error.MAX_TOTAL_SIZE,
                        metaData: {
                            totalSize: m
                        }
                    };
                    if (d.minTotalSize && m < parseInt(d.minTotalSize, 10)) return {
                        valid: !1,
                        error: this.Error.MIN_TOTAL_SIZE,
                        metaData: {
                            totalSize: m
                        }
                    }
                } else if (g = f.substr(f.lastIndexOf(".") + 1), h && -1 === a.inArray(g.toLowerCase(), h)) return {
                    valid: !1,
                    error: this.Error.EXTENSION,
                    metaData: {
                        ext: g
                    }
                };
                return !0
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                greaterThan: {
                    "default": "Please enter a value greater than or equal to %s",
                    notInclusive: "Please enter a value greater than %s"
                }
            }
        }), FormValidation.Validator.greaterThan = {
            html5Attributes: {
                message: "message",
                value: "value",
                inclusive: "inclusive"
            },
            enableByHtml5: function(a) {
                var b = a.attr("type"),
                    c = a.attr("min");
                return c && "date" !== b ? {
                    value: c
                } : !1
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                f = this._format(f);
                var g = b.getLocale(),
                    h = a.isNumeric(d.value) ? d.value : b.getDynamicOption(c, d.value),
                    i = this._format(h);
                return d.inclusive === !0 || void 0 === d.inclusive ? {
                    valid: a.isNumeric(f) && parseFloat(f) >= i,
                    message: FormValidation.Helper.format(d.message || FormValidation.I18n[g].greaterThan["default"], h)
                } : {
                    valid: a.isNumeric(f) && parseFloat(f) > i,
                    message: FormValidation.Helper.format(d.message || FormValidation.I18n[g].greaterThan.notInclusive, h)
                }
            },
            _format: function(a) {
                return (a + "").replace(",", ".")
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                grid: {
                    "default": "Please enter a valid GRId number"
                }
            }
        }), FormValidation.Validator.grid = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                return "" === e ? !0 : (e = e.toUpperCase(), /^[GRID:]*([0-9A-Z]{2})[-\s]*([0-9A-Z]{5})[-\s]*([0-9A-Z]{10})[-\s]*([0-9A-Z]{1})$/g.test(e) ? (e = e.replace(/\s/g, "").replace(/-/g, ""), "GRID:" === e.substr(0, 5) && (e = e.substr(5)), FormValidation.Helper.mod37And36(e)) : !1)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                hex: {
                    "default": "Please enter a valid hexadecimal number"
                }
            }
        }), FormValidation.Validator.hex = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                return "" === e ? !0 : /^[0-9a-fA-F]+$/.test(e)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                iban: {
                    "default": "Please enter a valid IBAN number",
                    country: "Please enter a valid IBAN number in %s",
                    countries: {
                        AD: "Andorra",
                        AE: "United Arab Emirates",
                        AL: "Albania",
                        AO: "Angola",
                        AT: "Austria",
                        AZ: "Azerbaijan",
                        BA: "Bosnia and Herzegovina",
                        BE: "Belgium",
                        BF: "Burkina Faso",
                        BG: "Bulgaria",
                        BH: "Bahrain",
                        BI: "Burundi",
                        BJ: "Benin",
                        BR: "Brazil",
                        CH: "Switzerland",
                        CI: "Ivory Coast",
                        CM: "Cameroon",
                        CR: "Costa Rica",
                        CV: "Cape Verde",
                        CY: "Cyprus",
                        CZ: "Czech Republic",
                        DE: "Germany",
                        DK: "Denmark",
                        DO: "Dominican Republic",
                        DZ: "Algeria",
                        EE: "Estonia",
                        ES: "Spain",
                        FI: "Finland",
                        FO: "Faroe Islands",
                        FR: "France",
                        GB: "United Kingdom",
                        GE: "Georgia",
                        GI: "Gibraltar",
                        GL: "Greenland",
                        GR: "Greece",
                        GT: "Guatemala",
                        HR: "Croatia",
                        HU: "Hungary",
                        IE: "Ireland",
                        IL: "Israel",
                        IR: "Iran",
                        IS: "Iceland",
                        IT: "Italy",
                        JO: "Jordan",
                        KW: "Kuwait",
                        KZ: "Kazakhstan",
                        LB: "Lebanon",
                        LI: "Liechtenstein",
                        LT: "Lithuania",
                        LU: "Luxembourg",
                        LV: "Latvia",
                        MC: "Monaco",
                        MD: "Moldova",
                        ME: "Montenegro",
                        MG: "Madagascar",
                        MK: "Macedonia",
                        ML: "Mali",
                        MR: "Mauritania",
                        MT: "Malta",
                        MU: "Mauritius",
                        MZ: "Mozambique",
                        NL: "Netherlands",
                        NO: "Norway",
                        PK: "Pakistan",
                        PL: "Poland",
                        PS: "Palestine",
                        PT: "Portugal",
                        QA: "Qatar",
                        RO: "Romania",
                        RS: "Serbia",
                        SA: "Saudi Arabia",
                        SE: "Sweden",
                        SI: "Slovenia",
                        SK: "Slovakia",
                        SM: "San Marino",
                        SN: "Senegal",
                        TL: "East Timor",
                        TN: "Tunisia",
                        TR: "Turkey",
                        VG: "Virgin Islands, British",
                        XK: "Republic of Kosovo"
                    }
                }
            }
        }), FormValidation.Validator.iban = {
            html5Attributes: {
                message: "message",
                country: "country",
                sepa: "sepa"
            },
            REGEX: {
                AD: "AD[0-9]{2}[0-9]{4}[0-9]{4}[A-Z0-9]{12}",
                AE: "AE[0-9]{2}[0-9]{3}[0-9]{16}",
                AL: "AL[0-9]{2}[0-9]{8}[A-Z0-9]{16}",
                AO: "AO[0-9]{2}[0-9]{21}",
                AT: "AT[0-9]{2}[0-9]{5}[0-9]{11}",
                AZ: "AZ[0-9]{2}[A-Z]{4}[A-Z0-9]{20}",
                BA: "BA[0-9]{2}[0-9]{3}[0-9]{3}[0-9]{8}[0-9]{2}",
                BE: "BE[0-9]{2}[0-9]{3}[0-9]{7}[0-9]{2}",
                BF: "BF[0-9]{2}[0-9]{23}",
                BG: "BG[0-9]{2}[A-Z]{4}[0-9]{4}[0-9]{2}[A-Z0-9]{8}",
                BH: "BH[0-9]{2}[A-Z]{4}[A-Z0-9]{14}",
                BI: "BI[0-9]{2}[0-9]{12}",
                BJ: "BJ[0-9]{2}[A-Z]{1}[0-9]{23}",
                BR: "BR[0-9]{2}[0-9]{8}[0-9]{5}[0-9]{10}[A-Z][A-Z0-9]",
                CH: "CH[0-9]{2}[0-9]{5}[A-Z0-9]{12}",
                CI: "CI[0-9]{2}[A-Z]{1}[0-9]{23}",
                CM: "CM[0-9]{2}[0-9]{23}",
                CR: "CR[0-9]{2}[0-9]{3}[0-9]{14}",
                CV: "CV[0-9]{2}[0-9]{21}",
                CY: "CY[0-9]{2}[0-9]{3}[0-9]{5}[A-Z0-9]{16}",
                CZ: "CZ[0-9]{2}[0-9]{20}",
                DE: "DE[0-9]{2}[0-9]{8}[0-9]{10}",
                DK: "DK[0-9]{2}[0-9]{14}",
                DO: "DO[0-9]{2}[A-Z0-9]{4}[0-9]{20}",
                DZ: "DZ[0-9]{2}[0-9]{20}",
                EE: "EE[0-9]{2}[0-9]{2}[0-9]{2}[0-9]{11}[0-9]{1}",
                ES: "ES[0-9]{2}[0-9]{4}[0-9]{4}[0-9]{1}[0-9]{1}[0-9]{10}",
                FI: "FI[0-9]{2}[0-9]{6}[0-9]{7}[0-9]{1}",
                FO: "FO[0-9]{2}[0-9]{4}[0-9]{9}[0-9]{1}",
                FR: "FR[0-9]{2}[0-9]{5}[0-9]{5}[A-Z0-9]{11}[0-9]{2}",
                GB: "GB[0-9]{2}[A-Z]{4}[0-9]{6}[0-9]{8}",
                GE: "GE[0-9]{2}[A-Z]{2}[0-9]{16}",
                GI: "GI[0-9]{2}[A-Z]{4}[A-Z0-9]{15}",
                GL: "GL[0-9]{2}[0-9]{4}[0-9]{9}[0-9]{1}",
                GR: "GR[0-9]{2}[0-9]{3}[0-9]{4}[A-Z0-9]{16}",
                GT: "GT[0-9]{2}[A-Z0-9]{4}[A-Z0-9]{20}",
                HR: "HR[0-9]{2}[0-9]{7}[0-9]{10}",
                HU: "HU[0-9]{2}[0-9]{3}[0-9]{4}[0-9]{1}[0-9]{15}[0-9]{1}",
                IE: "IE[0-9]{2}[A-Z]{4}[0-9]{6}[0-9]{8}",
                IL: "IL[0-9]{2}[0-9]{3}[0-9]{3}[0-9]{13}",
                IR: "IR[0-9]{2}[0-9]{22}",
                IS: "IS[0-9]{2}[0-9]{4}[0-9]{2}[0-9]{6}[0-9]{10}",
                IT: "IT[0-9]{2}[A-Z]{1}[0-9]{5}[0-9]{5}[A-Z0-9]{12}",
                JO: "JO[0-9]{2}[A-Z]{4}[0-9]{4}[0]{8}[A-Z0-9]{10}",
                KW: "KW[0-9]{2}[A-Z]{4}[0-9]{22}",
                KZ: "KZ[0-9]{2}[0-9]{3}[A-Z0-9]{13}",
                LB: "LB[0-9]{2}[0-9]{4}[A-Z0-9]{20}",
                LI: "LI[0-9]{2}[0-9]{5}[A-Z0-9]{12}",
                LT: "LT[0-9]{2}[0-9]{5}[0-9]{11}",
                LU: "LU[0-9]{2}[0-9]{3}[A-Z0-9]{13}",
                LV: "LV[0-9]{2}[A-Z]{4}[A-Z0-9]{13}",
                MC: "MC[0-9]{2}[0-9]{5}[0-9]{5}[A-Z0-9]{11}[0-9]{2}",
                MD: "MD[0-9]{2}[A-Z0-9]{20}",
                ME: "ME[0-9]{2}[0-9]{3}[0-9]{13}[0-9]{2}",
                MG: "MG[0-9]{2}[0-9]{23}",
                MK: "MK[0-9]{2}[0-9]{3}[A-Z0-9]{10}[0-9]{2}",
                ML: "ML[0-9]{2}[A-Z]{1}[0-9]{23}",
                MR: "MR13[0-9]{5}[0-9]{5}[0-9]{11}[0-9]{2}",
                MT: "MT[0-9]{2}[A-Z]{4}[0-9]{5}[A-Z0-9]{18}",
                MU: "MU[0-9]{2}[A-Z]{4}[0-9]{2}[0-9]{2}[0-9]{12}[0-9]{3}[A-Z]{3}",
                MZ: "MZ[0-9]{2}[0-9]{21}",
                NL: "NL[0-9]{2}[A-Z]{4}[0-9]{10}",
                NO: "NO[0-9]{2}[0-9]{4}[0-9]{6}[0-9]{1}",
                PK: "PK[0-9]{2}[A-Z]{4}[A-Z0-9]{16}",
                PL: "PL[0-9]{2}[0-9]{8}[0-9]{16}",
                PS: "PS[0-9]{2}[A-Z]{4}[A-Z0-9]{21}",
                PT: "PT[0-9]{2}[0-9]{4}[0-9]{4}[0-9]{11}[0-9]{2}",
                QA: "QA[0-9]{2}[A-Z]{4}[A-Z0-9]{21}",
                RO: "RO[0-9]{2}[A-Z]{4}[A-Z0-9]{16}",
                RS: "RS[0-9]{2}[0-9]{3}[0-9]{13}[0-9]{2}",
                SA: "SA[0-9]{2}[0-9]{2}[A-Z0-9]{18}",
                SE: "SE[0-9]{2}[0-9]{3}[0-9]{16}[0-9]{1}",
                SI: "SI[0-9]{2}[0-9]{5}[0-9]{8}[0-9]{2}",
                SK: "SK[0-9]{2}[0-9]{4}[0-9]{6}[0-9]{10}",
                SM: "SM[0-9]{2}[A-Z]{1}[0-9]{5}[0-9]{5}[A-Z0-9]{12}",
                SN: "SN[0-9]{2}[A-Z]{1}[0-9]{23}",
                TL: "TL38[0-9]{3}[0-9]{14}[0-9]{2}",
                TN: "TN59[0-9]{2}[0-9]{3}[0-9]{13}[0-9]{2}",
                TR: "TR[0-9]{2}[0-9]{5}[A-Z0-9]{1}[A-Z0-9]{16}",
                VG: "VG[0-9]{2}[A-Z]{4}[0-9]{16}",
                XK: "XK[0-9]{2}[0-9]{4}[0-9]{10}[0-9]{2}"
            },
            SEPA_COUNTRIES: ["AT", "BE", "BG", "CH", "CY", "CZ", "DE", "DK", "EE", "ES", "FI", "FR", "GB", "GI", "GR", "HR", "HU", "IE", "IS", "IT", "LI", "LT", "LU", "LV", "MC", "MT", "NL", "NO", "PL", "PT", "RO", "SE", "SI", "SK", "SM"],
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                f = f.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
                var g = d.country;
                g ? "string" == typeof g && this.REGEX[g] || (g = b.getDynamicOption(c, g)) : g = f.substr(0, 2);
                var h = b.getLocale();
                if (!this.REGEX[g]) return !1;
                if (void 0 !== typeof d.sepa) {
                    var i = -1 !== a.inArray(g, this.SEPA_COUNTRIES);
                    if (("true" === d.sepa || d.sepa === !0) && !i || ("false" === d.sepa || d.sepa === !1) && i) return !1
                }
                if (!new RegExp("^" + this.REGEX[g] + "$").test(f)) return {
                    valid: !1,
                    message: FormValidation.Helper.format(d.message || FormValidation.I18n[h].iban.country, FormValidation.I18n[h].iban.countries[g])
                };
                f = f.substr(4) + f.substr(0, 4), f = a.map(f.split(""), function(a) {
                    var b = a.charCodeAt(0);
                    return b >= "A".charCodeAt(0) && b <= "Z".charCodeAt(0) ? b - "A".charCodeAt(0) + 10 : a
                }), f = f.join("");
                for (var j = parseInt(f.substr(0, 1), 10), k = f.length, l = 1; k > l; ++l) j = (10 * j + parseInt(f.substr(l, 1), 10)) % 97;
                return {
                    valid: 1 === j,
                    message: FormValidation.Helper.format(d.message || FormValidation.I18n[h].iban.country, FormValidation.I18n[h].iban.countries[g])
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                id: {
                    "default": "Please enter a valid identification number",
                    country: "Please enter a valid identification number in %s",
                    countries: {
                        BA: "Bosnia and Herzegovina",
                        BG: "Bulgaria",
                        BR: "Brazil",
                        CH: "Switzerland",
                        CL: "Chile",
                        CN: "China",
                        CZ: "Czech Republic",
                        DK: "Denmark",
                        EE: "Estonia",
                        ES: "Spain",
                        FI: "Finland",
                        HR: "Croatia",
                        IE: "Ireland",
                        IS: "Iceland",
                        LT: "Lithuania",
                        LV: "Latvia",
                        ME: "Montenegro",
                        MK: "Macedonia",
                        NL: "Netherlands",
                        PL: "Poland",
                        RO: "Romania",
                        RS: "Serbia",
                        SE: "Sweden",
                        SI: "Slovenia",
                        SK: "Slovakia",
                        SM: "San Marino",
                        TH: "Thailand",
                        TR: "Turkey",
                        ZA: "South Africa"
                    }
                }
            }
        }), FormValidation.Validator.id = {
            html5Attributes: {
                message: "message",
                country: "country"
            },
            COUNTRY_CODES: ["BA", "BG", "BR", "CH", "CL", "CN", "CZ", "DK", "EE", "ES", "FI", "HR", "IE", "IS", "LT", "LV", "ME", "MK", "NL", "PL", "RO", "RS", "SE", "SI", "SK", "SM", "TH", "TR", "ZA"],
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                var g = b.getLocale(),
                    h = d.country;
                if (h ? ("string" != typeof h || -1 === a.inArray(h.toUpperCase(), this.COUNTRY_CODES)) && (h = b.getDynamicOption(c, h)) : h = f.substr(0, 2), -1 === a.inArray(h, this.COUNTRY_CODES)) return !0;
                var i = ["_", h.toLowerCase()].join(""),
                    j = this[i](f);
                return j = j === !0 || j === !1 ? {
                    valid: j
                } : j, j.message = FormValidation.Helper.format(d.message || FormValidation.I18n[g].id.country, FormValidation.I18n[g].id.countries[h.toUpperCase()]), j
            },
            _validateJMBG: function(a, b) {
                if (!/^\d{13}$/.test(a)) return !1;
                var c = parseInt(a.substr(0, 2), 10),
                    d = parseInt(a.substr(2, 2), 10),
                    e = (parseInt(a.substr(4, 3), 10), parseInt(a.substr(7, 2), 10)),
                    f = parseInt(a.substr(12, 1), 10);
                if (c > 31 || d > 12) return !1;
                for (var g = 0, h = 0; 6 > h; h++) g += (7 - h) * (parseInt(a.charAt(h), 10) + parseInt(a.charAt(h + 6), 10));
                if (g = 11 - g % 11, (10 === g || 11 === g) && (g = 0), g !== f) return !1;
                switch (b.toUpperCase()) {
                    case "BA":
                        return e >= 10 && 19 >= e;
                    case "MK":
                        return e >= 41 && 49 >= e;
                    case "ME":
                        return e >= 20 && 29 >= e;
                    case "RS":
                        return e >= 70 && 99 >= e;
                    case "SI":
                        return e >= 50 && 59 >= e;
                    default:
                        return !0
                }
            },
            _ba: function(a) {
                return this._validateJMBG(a, "BA")
            },
            _mk: function(a) {
                return this._validateJMBG(a, "MK")
            },
            _me: function(a) {
                return this._validateJMBG(a, "ME")
            },
            _rs: function(a) {
                return this._validateJMBG(a, "RS")
            },
            _si: function(a) {
                return this._validateJMBG(a, "SI")
            },
            _bg: function(a) {
                if (!/^\d{10}$/.test(a) && !/^\d{6}\s\d{3}\s\d{1}$/.test(a)) return !1;
                a = a.replace(/\s/g, "");
                var b = parseInt(a.substr(0, 2), 10) + 1900,
                    c = parseInt(a.substr(2, 2), 10),
                    d = parseInt(a.substr(4, 2), 10);
                if (c > 40 ? (b += 100, c -= 40) : c > 20 && (b -= 100, c -= 20), !FormValidation.Helper.date(b, c, d)) return !1;
                for (var e = 0, f = [2, 4, 8, 5, 10, 9, 7, 3, 6], g = 0; 9 > g; g++) e += parseInt(a.charAt(g), 10) * f[g];
                return e = e % 11 % 10, e + "" === a.substr(9, 1)
            },
            _br: function(a) {
                if (a = a.replace(/\D/g, ""), !/^\d{11}$/.test(a) || /^1{11}|2{11}|3{11}|4{11}|5{11}|6{11}|7{11}|8{11}|9{11}|0{11}$/.test(a)) return !1;
                for (var b = 0, c = 0; 9 > c; c++) b += (10 - c) * parseInt(a.charAt(c), 10);
                if (b = 11 - b % 11, (10 === b || 11 === b) && (b = 0), b + "" !== a.charAt(9)) return !1;
                var d = 0;
                for (c = 0; 10 > c; c++) d += (11 - c) * parseInt(a.charAt(c), 10);
                return d = 11 - d % 11, (10 === d || 11 === d) && (d = 0), d + "" === a.charAt(10)
            },
            _ch: function(a) {
                if (!/^756[\.]{0,1}[0-9]{4}[\.]{0,1}[0-9]{4}[\.]{0,1}[0-9]{2}$/.test(a)) return !1;
                a = a.replace(/\D/g, "").substr(3);
                for (var b = a.length, c = 0, d = 8 === b ? [3, 1] : [1, 3], e = 0; b - 1 > e; e++) c += parseInt(a.charAt(e), 10) * d[e % 2];
                return c = 10 - c % 10, c + "" === a.charAt(b - 1)
            },
            _cl: function(a) {
                if (!/^\d{7,8}[-]{0,1}[0-9K]$/i.test(a)) return !1;
                for (a = a.replace(/\-/g, ""); a.length < 9;) a = "0" + a;
                for (var b = 0, c = [3, 2, 7, 6, 5, 4, 3, 2], d = 0; 8 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b = 11 - b % 11, 11 === b ? b = 0 : 10 === b && (b = "K"), b + "" === a.charAt(8).toUpperCase()
            },
            _cn: function(b) {
                if (b = b.trim(), !/^\d{15}$/.test(b) && !/^\d{17}[\dXx]{1}$/.test(b)) return !1;
                var c = {
                        11: {
                            0: [0],
                            1: [
                                [0, 9],
                                [11, 17]
                            ],
                            2: [0, 28, 29]
                        },
                        12: {
                            0: [0],
                            1: [
                                [0, 16]
                            ],
                            2: [0, 21, 23, 25]
                        },
                        13: {
                            0: [0],
                            1: [
                                [0, 5], 7, 8, 21, [23, 33],
                                [81, 85]
                            ],
                            2: [
                                [0, 5],
                                [7, 9],
                                [23, 25], 27, 29, 30, 81, 83
                            ],
                            3: [
                                [0, 4],
                                [21, 24]
                            ],
                            4: [
                                [0, 4], 6, 21, [23, 35], 81
                            ],
                            5: [
                                [0, 3],
                                [21, 35], 81, 82
                            ],
                            6: [
                                [0, 4],
                                [21, 38],
                                [81, 84]
                            ],
                            7: [
                                [0, 3], 5, 6, [21, 33]
                            ],
                            8: [
                                [0, 4],
                                [21, 28]
                            ],
                            9: [
                                [0, 3],
                                [21, 30],
                                [81, 84]
                            ],
                            10: [
                                [0, 3],
                                [22, 26], 28, 81, 82
                            ],
                            11: [
                                [0, 2],
                                [21, 28], 81, 82
                            ]
                        },
                        14: {
                            0: [0],
                            1: [0, 1, [5, 10],
                                [21, 23], 81
                            ],
                            2: [
                                [0, 3], 11, 12, [21, 27]
                            ],
                            3: [
                                [0, 3], 11, 21, 22
                            ],
                            4: [
                                [0, 2], 11, 21, [23, 31], 81
                            ],
                            5: [
                                [0, 2], 21, 22, 24, 25, 81
                            ],
                            6: [
                                [0, 3],
                                [21, 24]
                            ],
                            7: [
                                [0, 2],
                                [21, 29], 81
                            ],
                            8: [
                                [0, 2],
                                [21, 30], 81, 82
                            ],
                            9: [
                                [0, 2],
                                [21, 32], 81
                            ],
                            10: [
                                [0, 2],
                                [21, 34], 81, 82
                            ],
                            11: [
                                [0, 2],
                                [21, 30], 81, 82
                            ],
                            23: [
                                [0, 3], 22, 23, [25, 30], 32, 33
                            ]
                        },
                        15: {
                            0: [0],
                            1: [
                                [0, 5],
                                [21, 25]
                            ],
                            2: [
                                [0, 7],
                                [21, 23]
                            ],
                            3: [
                                [0, 4]
                            ],
                            4: [
                                [0, 4],
                                [21, 26],
                                [28, 30]
                            ],
                            5: [
                                [0, 2],
                                [21, 26], 81
                            ],
                            6: [
                                [0, 2],
                                [21, 27]
                            ],
                            7: [
                                [0, 3],
                                [21, 27],
                                [81, 85]
                            ],
                            8: [
                                [0, 2],
                                [21, 26]
                            ],
                            9: [
                                [0, 2],
                                [21, 29], 81
                            ],
                            22: [
                                [0, 2],
                                [21, 24]
                            ],
                            25: [
                                [0, 2],
                                [22, 31]
                            ],
                            26: [
                                [0, 2],
                                [24, 27],
                                [29, 32], 34
                            ],
                            28: [0, 1, [22, 27]],
                            29: [0, [21, 23]]
                        },
                        21: {
                            0: [0],
                            1: [
                                [0, 6],
                                [11, 14],
                                [22, 24], 81
                            ],
                            2: [
                                [0, 4],
                                [11, 13], 24, [81, 83]
                            ],
                            3: [
                                [0, 4], 11, 21, 23, 81
                            ],
                            4: [
                                [0, 4], 11, [21, 23]
                            ],
                            5: [
                                [0, 5], 21, 22
                            ],
                            6: [
                                [0, 4], 24, 81, 82
                            ],
                            7: [
                                [0, 3], 11, 26, 27, 81, 82
                            ],
                            8: [
                                [0, 4], 11, 81, 82
                            ],
                            9: [
                                [0, 5], 11, 21, 22
                            ],
                            10: [
                                [0, 5], 11, 21, 81
                            ],
                            11: [
                                [0, 3], 21, 22
                            ],
                            12: [
                                [0, 2], 4, 21, 23, 24, 81, 82
                            ],
                            13: [
                                [0, 3], 21, 22, 24, 81, 82
                            ],
                            14: [
                                [0, 4], 21, 22, 81
                            ]
                        },
                        22: {
                            0: [0],
                            1: [
                                [0, 6], 12, 22, [81, 83]
                            ],
                            2: [
                                [0, 4], 11, 21, [81, 84]
                            ],
                            3: [
                                [0, 3], 22, 23, 81, 82
                            ],
                            4: [
                                [0, 3], 21, 22
                            ],
                            5: [
                                [0, 3], 21, 23, 24, 81, 82
                            ],
                            6: [
                                [0, 2], 4, 5, [21, 23], 25, 81
                            ],
                            7: [
                                [0, 2],
                                [21, 24], 81
                            ],
                            8: [
                                [0, 2], 21, 22, 81, 82
                            ],
                            24: [
                                [0, 6], 24, 26
                            ]
                        },
                        23: {
                            0: [0],
                            1: [
                                [0, 12], 21, [23, 29],
                                [81, 84]
                            ],
                            2: [
                                [0, 8], 21, [23, 25], 27, [29, 31], 81
                            ],
                            3: [
                                [0, 7], 21, 81, 82
                            ],
                            4: [
                                [0, 7], 21, 22
                            ],
                            5: [
                                [0, 3], 5, 6, [21, 24]
                            ],
                            6: [
                                [0, 6],
                                [21, 24]
                            ],
                            7: [
                                [0, 16], 22, 81
                            ],
                            8: [
                                [0, 5], 11, 22, 26, 28, 33, 81, 82
                            ],
                            9: [
                                [0, 4], 21
                            ],
                            10: [
                                [0, 5], 24, 25, 81, [83, 85]
                            ],
                            11: [
                                [0, 2], 21, 23, 24, 81, 82
                            ],
                            12: [
                                [0, 2],
                                [21, 26],
                                [81, 83]
                            ],
                            27: [
                                [0, 4],
                                [21, 23]
                            ]
                        },
                        31: {
                            0: [0],
                            1: [0, 1, [3, 10],
                                [12, 20]
                            ],
                            2: [0, 30]
                        },
                        32: {
                            0: [0],
                            1: [
                                [0, 7], 11, [13, 18], 24, 25
                            ],
                            2: [
                                [0, 6], 11, 81, 82
                            ],
                            3: [
                                [0, 5], 11, 12, [21, 24], 81, 82
                            ],
                            4: [
                                [0, 2], 4, 5, 11, 12, 81, 82
                            ],
                            5: [
                                [0, 9],
                                [81, 85]
                            ],
                            6: [
                                [0, 2], 11, 12, 21, 23, [81, 84]
                            ],
                            7: [0, 1, 3, 5, 6, [21, 24]],
                            8: [
                                [0, 4], 11, 26, [29, 31]
                            ],
                            9: [
                                [0, 3],
                                [21, 25], 28, 81, 82
                            ],
                            10: [
                                [0, 3], 11, 12, 23, 81, 84, 88
                            ],
                            11: [
                                [0, 2], 11, 12, [81, 83]
                            ],
                            12: [
                                [0, 4],
                                [81, 84]
                            ],
                            13: [
                                [0, 2], 11, [21, 24]
                            ]
                        },
                        33: {
                            0: [0],
                            1: [
                                [0, 6],
                                [8, 10], 22, 27, 82, 83, 85
                            ],
                            2: [0, 1, [3, 6], 11, 12, 25, 26, [81, 83]],
                            3: [
                                [0, 4], 22, 24, [26, 29], 81, 82
                            ],
                            4: [
                                [0, 2], 11, 21, 24, [81, 83]
                            ],
                            5: [
                                [0, 3],
                                [21, 23]
                            ],
                            6: [
                                [0, 2], 21, 24, [81, 83]
                            ],
                            7: [
                                [0, 3], 23, 26, 27, [81, 84]
                            ],
                            8: [
                                [0, 3], 22, 24, 25, 81
                            ],
                            9: [
                                [0, 3], 21, 22
                            ],
                            10: [
                                [0, 4],
                                [21, 24], 81, 82
                            ],
                            11: [
                                [0, 2],
                                [21, 27], 81
                            ]
                        },
                        34: {
                            0: [0],
                            1: [
                                [0, 4], 11, [21, 24], 81
                            ],
                            2: [
                                [0, 4], 7, 8, [21, 23], 25
                            ],
                            3: [
                                [0, 4], 11, [21, 23]
                            ],
                            4: [
                                [0, 6], 21
                            ],
                            5: [
                                [0, 4], 6, [21, 23]
                            ],
                            6: [
                                [0, 4], 21
                            ],
                            7: [
                                [0, 3], 11, 21
                            ],
                            8: [
                                [0, 3], 11, [22, 28], 81
                            ],
                            10: [
                                [0, 4],
                                [21, 24]
                            ],
                            11: [
                                [0, 3], 22, [24, 26], 81, 82
                            ],
                            12: [
                                [0, 4], 21, 22, 25, 26, 82
                            ],
                            13: [
                                [0, 2],
                                [21, 24]
                            ],
                            14: [
                                [0, 2],
                                [21, 24]
                            ],
                            15: [
                                [0, 3],
                                [21, 25]
                            ],
                            16: [
                                [0, 2],
                                [21, 23]
                            ],
                            17: [
                                [0, 2],
                                [21, 23]
                            ],
                            18: [
                                [0, 2],
                                [21, 25], 81
                            ]
                        },
                        35: {
                            0: [0],
                            1: [
                                [0, 5], 11, [21, 25], 28, 81, 82
                            ],
                            2: [
                                [0, 6],
                                [11, 13]
                            ],
                            3: [
                                [0, 5], 22
                            ],
                            4: [
                                [0, 3], 21, [23, 30], 81
                            ],
                            5: [
                                [0, 5], 21, [24, 27],
                                [81, 83]
                            ],
                            6: [
                                [0, 3],
                                [22, 29], 81
                            ],
                            7: [
                                [0, 2],
                                [21, 25],
                                [81, 84]
                            ],
                            8: [
                                [0, 2],
                                [21, 25], 81
                            ],
                            9: [
                                [0, 2],
                                [21, 26], 81, 82
                            ]
                        },
                        36: {
                            0: [0],
                            1: [
                                [0, 5], 11, [21, 24]
                            ],
                            2: [
                                [0, 3], 22, 81
                            ],
                            3: [
                                [0, 2], 13, [21, 23]
                            ],
                            4: [
                                [0, 3], 21, [23, 30], 81, 82
                            ],
                            5: [
                                [0, 2], 21
                            ],
                            6: [
                                [0, 2], 22, 81
                            ],
                            7: [
                                [0, 2],
                                [21, 35], 81, 82
                            ],
                            8: [
                                [0, 3],
                                [21, 30], 81
                            ],
                            9: [
                                [0, 2],
                                [21, 26],
                                [81, 83]
                            ],
                            10: [
                                [0, 2],
                                [21, 30]
                            ],
                            11: [
                                [0, 2],
                                [21, 30], 81
                            ]
                        },
                        37: {
                            0: [0],
                            1: [
                                [0, 5], 12, 13, [24, 26], 81
                            ],
                            2: [
                                [0, 3], 5, [11, 14],
                                [81, 85]
                            ],
                            3: [
                                [0, 6],
                                [21, 23]
                            ],
                            4: [
                                [0, 6], 81
                            ],
                            5: [
                                [0, 3],
                                [21, 23]
                            ],
                            6: [
                                [0, 2],
                                [11, 13], 34, [81, 87]
                            ],
                            7: [
                                [0, 5], 24, 25, [81, 86]
                            ],
                            8: [
                                [0, 2], 11, [26, 32],
                                [81, 83]
                            ],
                            9: [
                                [0, 3], 11, 21, 23, 82, 83
                            ],
                            10: [
                                [0, 2],
                                [81, 83]
                            ],
                            11: [
                                [0, 3], 21, 22
                            ],
                            12: [
                                [0, 3]
                            ],
                            13: [
                                [0, 2], 11, 12, [21, 29]
                            ],
                            14: [
                                [0, 2],
                                [21, 28], 81, 82
                            ],
                            15: [
                                [0, 2],
                                [21, 26], 81
                            ],
                            16: [
                                [0, 2],
                                [21, 26]
                            ],
                            17: [
                                [0, 2],
                                [21, 28]
                            ]
                        },
                        41: {
                            0: [0],
                            1: [
                                [0, 6], 8, 22, [81, 85]
                            ],
                            2: [
                                [0, 5], 11, [21, 25]
                            ],
                            3: [
                                [0, 7], 11, [22, 29], 81
                            ],
                            4: [
                                [0, 4], 11, [21, 23], 25, 81, 82
                            ],
                            5: [
                                [0, 3], 5, 6, 22, 23, 26, 27, 81
                            ],
                            6: [
                                [0, 3], 11, 21, 22
                            ],
                            7: [
                                [0, 4], 11, 21, [24, 28], 81, 82
                            ],
                            8: [
                                [0, 4], 11, [21, 23], 25, [81, 83]
                            ],
                            9: [
                                [0, 2], 22, 23, [26, 28]
                            ],
                            10: [
                                [0, 2],
                                [23, 25], 81, 82
                            ],
                            11: [
                                [0, 4],
                                [21, 23]
                            ],
                            12: [
                                [0, 2], 21, 22, 24, 81, 82
                            ],
                            13: [
                                [0, 3],
                                [21, 30], 81
                            ],
                            14: [
                                [0, 3],
                                [21, 26], 81
                            ],
                            15: [
                                [0, 3],
                                [21, 28]
                            ],
                            16: [
                                [0, 2],
                                [21, 28], 81
                            ],
                            17: [
                                [0, 2],
                                [21, 29]
                            ],
                            90: [0, 1]
                        },
                        42: {
                            0: [0],
                            1: [
                                [0, 7],
                                [11, 17]
                            ],
                            2: [
                                [0, 5], 22, 81
                            ],
                            3: [
                                [0, 3],
                                [21, 25], 81
                            ],
                            5: [
                                [0, 6],
                                [25, 29],
                                [81, 83]
                            ],
                            6: [
                                [0, 2], 6, 7, [24, 26],
                                [82, 84]
                            ],
                            7: [
                                [0, 4]
                            ],
                            8: [
                                [0, 2], 4, 21, 22, 81
                            ],
                            9: [
                                [0, 2],
                                [21, 23], 81, 82, 84
                            ],
                            10: [
                                [0, 3],
                                [22, 24], 81, 83, 87
                            ],
                            11: [
                                [0, 2],
                                [21, 27], 81, 82
                            ],
                            12: [
                                [0, 2],
                                [21, 24], 81
                            ],
                            13: [
                                [0, 3], 21, 81
                            ],
                            28: [
                                [0, 2], 22, 23, [25, 28]
                            ],
                            90: [0, [4, 6], 21]
                        },
                        43: {
                            0: [0],
                            1: [
                                [0, 5], 11, 12, 21, 22, 24, 81
                            ],
                            2: [
                                [0, 4], 11, 21, [23, 25], 81
                            ],
                            3: [
                                [0, 2], 4, 21, 81, 82
                            ],
                            4: [0, 1, [5, 8], 12, [21, 24], 26, 81, 82],
                            5: [
                                [0, 3], 11, [21, 25],
                                [27, 29], 81
                            ],
                            6: [
                                [0, 3], 11, 21, 23, 24, 26, 81, 82
                            ],
                            7: [
                                [0, 3],
                                [21, 26], 81
                            ],
                            8: [
                                [0, 2], 11, 21, 22
                            ],
                            9: [
                                [0, 3],
                                [21, 23], 81
                            ],
                            10: [
                                [0, 3],
                                [21, 28], 81
                            ],
                            11: [
                                [0, 3],
                                [21, 29]
                            ],
                            12: [
                                [0, 2],
                                [21, 30], 81
                            ],
                            13: [
                                [0, 2], 21, 22, 81, 82
                            ],
                            31: [0, 1, [22, 27], 30]
                        },
                        44: {
                            0: [0],
                            1: [
                                [0, 7],
                                [11, 16], 83, 84
                            ],
                            2: [
                                [0, 5], 21, 22, 24, 29, 32, 33, 81, 82
                            ],
                            3: [0, 1, [3, 8]],
                            4: [
                                [0, 4]
                            ],
                            5: [0, 1, [6, 15], 23, 82, 83],
                            6: [0, 1, [4, 8]],
                            7: [0, 1, [3, 5], 81, [83, 85]],
                            8: [
                                [0, 4], 11, 23, 25, [81, 83]
                            ],
                            9: [
                                [0, 3], 23, [81, 83]
                            ],
                            12: [
                                [0, 3],
                                [23, 26], 83, 84
                            ],
                            13: [
                                [0, 3],
                                [22, 24], 81
                            ],
                            14: [
                                [0, 2],
                                [21, 24], 26, 27, 81
                            ],
                            15: [
                                [0, 2], 21, 23, 81
                            ],
                            16: [
                                [0, 2],
                                [21, 25]
                            ],
                            17: [
                                [0, 2], 21, 23, 81
                            ],
                            18: [
                                [0, 3], 21, 23, [25, 27], 81, 82
                            ],
                            19: [0],
                            20: [0],
                            51: [
                                [0, 3], 21, 22
                            ],
                            52: [
                                [0, 3], 21, 22, 24, 81
                            ],
                            53: [
                                [0, 2],
                                [21, 23], 81
                            ]
                        },
                        45: {
                            0: [0],
                            1: [
                                [0, 9],
                                [21, 27]
                            ],
                            2: [
                                [0, 5],
                                [21, 26]
                            ],
                            3: [
                                [0, 5], 11, 12, [21, 32]
                            ],
                            4: [0, 1, [3, 6], 11, [21, 23], 81],
                            5: [
                                [0, 3], 12, 21
                            ],
                            6: [
                                [0, 3], 21, 81
                            ],
                            7: [
                                [0, 3], 21, 22
                            ],
                            8: [
                                [0, 4], 21, 81
                            ],
                            9: [
                                [0, 3],
                                [21, 24], 81
                            ],
                            10: [
                                [0, 2],
                                [21, 31]
                            ],
                            11: [
                                [0, 2],
                                [21, 23]
                            ],
                            12: [
                                [0, 2],
                                [21, 29], 81
                            ],
                            13: [
                                [0, 2],
                                [21, 24], 81
                            ],
                            14: [
                                [0, 2],
                                [21, 25], 81
                            ]
                        },
                        46: {
                            0: [0],
                            1: [0, 1, [5, 8]],
                            2: [0, 1],
                            3: [0, [21, 23]],
                            90: [
                                [0, 3],
                                [5, 7],
                                [21, 39]
                            ]
                        },
                        50: {
                            0: [0],
                            1: [
                                [0, 19]
                            ],
                            2: [0, [22, 38],
                                [40, 43]
                            ],
                            3: [0, [81, 84]]
                        },
                        51: {
                            0: [0],
                            1: [0, 1, [4, 8],
                                [12, 15],
                                [21, 24], 29, 31, 32, [81, 84]
                            ],
                            3: [
                                [0, 4], 11, 21, 22
                            ],
                            4: [
                                [0, 3], 11, 21, 22
                            ],
                            5: [
                                [0, 4], 21, 22, 24, 25
                            ],
                            6: [0, 1, 3, 23, 26, [81, 83]],
                            7: [0, 1, 3, 4, [22, 27], 81],
                            8: [
                                [0, 2], 11, 12, [21, 24]
                            ],
                            9: [
                                [0, 4],
                                [21, 23]
                            ],
                            10: [
                                [0, 2], 11, 24, 25, 28
                            ],
                            11: [
                                [0, 2],
                                [11, 13], 23, 24, 26, 29, 32, 33, 81
                            ],
                            13: [
                                [0, 4],
                                [21, 25], 81
                            ],
                            14: [
                                [0, 2],
                                [21, 25]
                            ],
                            15: [
                                [0, 3],
                                [21, 29]
                            ],
                            16: [
                                [0, 3],
                                [21, 23], 81
                            ],
                            17: [
                                [0, 3],
                                [21, 25], 81
                            ],
                            18: [
                                [0, 3],
                                [21, 27]
                            ],
                            19: [
                                [0, 3],
                                [21, 23]
                            ],
                            20: [
                                [0, 2], 21, 22, 81
                            ],
                            32: [0, [21, 33]],
                            33: [0, [21, 38]],
                            34: [0, 1, [22, 37]]
                        },
                        52: {
                            0: [0],
                            1: [
                                [0, 3],
                                [11, 15],
                                [21, 23], 81
                            ],
                            2: [0, 1, 3, 21, 22],
                            3: [
                                [0, 3],
                                [21, 30], 81, 82
                            ],
                            4: [
                                [0, 2],
                                [21, 25]
                            ],
                            5: [
                                [0, 2],
                                [21, 27]
                            ],
                            6: [
                                [0, 3],
                                [21, 28]
                            ],
                            22: [0, 1, [22, 30]],
                            23: [0, 1, [22, 28]],
                            24: [0, 1, [22, 28]],
                            26: [0, 1, [22, 36]],
                            27: [
                                [0, 2], 22, 23, [25, 32]
                            ]
                        },
                        53: {
                            0: [0],
                            1: [
                                [0, 3],
                                [11, 14], 21, 22, [24, 29], 81
                            ],
                            3: [
                                [0, 2],
                                [21, 26], 28, 81
                            ],
                            4: [
                                [0, 2],
                                [21, 28]
                            ],
                            5: [
                                [0, 2],
                                [21, 24]
                            ],
                            6: [
                                [0, 2],
                                [21, 30]
                            ],
                            7: [
                                [0, 2],
                                [21, 24]
                            ],
                            8: [
                                [0, 2],
                                [21, 29]
                            ],
                            9: [
                                [0, 2],
                                [21, 27]
                            ],
                            23: [0, 1, [22, 29], 31],
                            25: [
                                [0, 4],
                                [22, 32]
                            ],
                            26: [0, 1, [21, 28]],
                            27: [0, 1, [22, 30]],
                            28: [0, 1, 22, 23],
                            29: [0, 1, [22, 32]],
                            31: [0, 2, 3, [22, 24]],
                            34: [0, [21, 23]],
                            33: [0, 21, [23, 25]],
                            35: [0, [21, 28]]
                        },
                        54: {
                            0: [0],
                            1: [
                                [0, 2],
                                [21, 27]
                            ],
                            21: [0, [21, 29], 32, 33],
                            22: [0, [21, 29],
                                [31, 33]
                            ],
                            23: [0, 1, [22, 38]],
                            24: [0, [21, 31]],
                            25: [0, [21, 27]],
                            26: [0, [21, 27]]
                        },
                        61: {
                            0: [0],
                            1: [
                                [0, 4],
                                [11, 16], 22, [24, 26]
                            ],
                            2: [
                                [0, 4], 22
                            ],
                            3: [
                                [0, 4],
                                [21, 24],
                                [26, 31]
                            ],
                            4: [
                                [0, 4],
                                [22, 31], 81
                            ],
                            5: [
                                [0, 2],
                                [21, 28], 81, 82
                            ],
                            6: [
                                [0, 2],
                                [21, 32]
                            ],
                            7: [
                                [0, 2],
                                [21, 30]
                            ],
                            8: [
                                [0, 2],
                                [21, 31]
                            ],
                            9: [
                                [0, 2],
                                [21, 29]
                            ],
                            10: [
                                [0, 2],
                                [21, 26]
                            ]
                        },
                        62: {
                            0: [0],
                            1: [
                                [0, 5], 11, [21, 23]
                            ],
                            2: [0, 1],
                            3: [
                                [0, 2], 21
                            ],
                            4: [
                                [0, 3],
                                [21, 23]
                            ],
                            5: [
                                [0, 3],
                                [21, 25]
                            ],
                            6: [
                                [0, 2],
                                [21, 23]
                            ],
                            7: [
                                [0, 2],
                                [21, 25]
                            ],
                            8: [
                                [0, 2],
                                [21, 26]
                            ],
                            9: [
                                [0, 2],
                                [21, 24], 81, 82
                            ],
                            10: [
                                [0, 2],
                                [21, 27]
                            ],
                            11: [
                                [0, 2],
                                [21, 26]
                            ],
                            12: [
                                [0, 2],
                                [21, 28]
                            ],
                            24: [0, 21, [24, 29]],
                            26: [0, 21, [23, 30]],
                            29: [0, 1, [21, 27]],
                            30: [0, 1, [21, 27]]
                        },
                        63: {
                            0: [0],
                            1: [
                                [0, 5],
                                [21, 23]
                            ],
                            2: [0, 2, [21, 25]],
                            21: [0, [21, 23],
                                [26, 28]
                            ],
                            22: [0, [21, 24]],
                            23: [0, [21, 24]],
                            25: [0, [21, 25]],
                            26: [0, [21, 26]],
                            27: [0, 1, [21, 26]],
                            28: [
                                [0, 2],
                                [21, 23]
                            ]
                        },
                        64: {
                            0: [0],
                            1: [0, 1, [4, 6], 21, 22, 81],
                            2: [
                                [0, 3], 5, [21, 23]
                            ],
                            3: [
                                [0, 3],
                                [21, 24], 81
                            ],
                            4: [
                                [0, 2],
                                [21, 25]
                            ],
                            5: [
                                [0, 2], 21, 22
                            ]
                        },
                        65: {
                            0: [0],
                            1: [
                                [0, 9], 21
                            ],
                            2: [
                                [0, 5]
                            ],
                            21: [0, 1, 22, 23],
                            22: [0, 1, 22, 23],
                            23: [
                                [0, 3],
                                [23, 25], 27, 28
                            ],
                            28: [0, 1, [22, 29]],
                            29: [0, 1, [22, 29]],
                            30: [0, 1, [22, 24]],
                            31: [0, 1, [21, 31]],
                            32: [0, 1, [21, 27]],
                            40: [0, 2, 3, [21, 28]],
                            42: [
                                [0, 2], 21, [23, 26]
                            ],
                            43: [0, 1, [21, 26]],
                            90: [
                                [0, 4]
                            ],
                            27: [
                                [0, 2], 22, 23
                            ]
                        },
                        71: {
                            0: [0]
                        },
                        81: {
                            0: [0]
                        },
                        82: {
                            0: [0]
                        }
                    },
                    d = parseInt(b.substr(0, 2), 10),
                    e = parseInt(b.substr(2, 2), 10),
                    f = parseInt(b.substr(4, 2), 10);
                if (!c[d] || !c[d][e]) return !1;
                for (var g = !1, h = c[d][e], i = 0; i < h.length; i++)
                    if (a.isArray(h[i]) && h[i][0] <= f && f <= h[i][1] || !a.isArray(h[i]) && f === h[i]) {
                        g = !0;
                        break
                    } if (!g) return !1;
                var j;
                j = 18 === b.length ? b.substr(6, 8) : "19" + b.substr(6, 6);
                var k = parseInt(j.substr(0, 4), 10),
                    l = parseInt(j.substr(4, 2), 10),
                    m = parseInt(j.substr(6, 2), 10);
                if (!FormValidation.Helper.date(k, l, m)) return !1;
                if (18 === b.length) {
                    var n = 0,
                        o = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
                    for (i = 0; 17 > i; i++) n += parseInt(b.charAt(i), 10) * o[i];
                    n = (12 - n % 11) % 11;
                    var p = "X" !== b.charAt(17).toUpperCase() ? parseInt(b.charAt(17), 10) : 10;
                    return p === n
                }
                return !0
            },
            _cz: function(a) {
                if (!/^\d{9,10}$/.test(a)) return !1;
                var b = 1900 + parseInt(a.substr(0, 2), 10),
                    c = parseInt(a.substr(2, 2), 10) % 50 % 20,
                    d = parseInt(a.substr(4, 2), 10);
                if (9 === a.length) {
                    if (b >= 1980 && (b -= 100), b > 1953) return !1
                } else 1954 > b && (b += 100);
                if (!FormValidation.Helper.date(b, c, d)) return !1;
                if (10 === a.length) {
                    var e = parseInt(a.substr(0, 9), 10) % 11;
                    return 1985 > b && (e %= 10), e + "" === a.substr(9, 1)
                }
                return !0
            },
            _dk: function(a) {
                if (!/^[0-9]{6}[-]{0,1}[0-9]{4}$/.test(a)) return !1;
                a = a.replace(/-/g, "");
                var b = parseInt(a.substr(0, 2), 10),
                    c = parseInt(a.substr(2, 2), 10),
                    d = parseInt(a.substr(4, 2), 10);
                switch (!0) {
                    case -1 !== "5678".indexOf(a.charAt(6)) && d >= 58:
                        d += 1800;
                        break;
                    case -1 !== "0123".indexOf(a.charAt(6)):
                    case -1 !== "49".indexOf(a.charAt(6)) && d >= 37:
                        d += 1900;
                        break;
                    default:
                        d += 2e3
                }
                return FormValidation.Helper.date(d, c, b)
            },
            _ee: function(a) {
                return this._lt(a)
            },
            _es: function(a) {
                var b = /^[0-9]{8}[-]{0,1}[A-HJ-NP-TV-Z]$/.test(a),
                    c = /^[XYZ][-]{0,1}[0-9]{7}[-]{0,1}[A-HJ-NP-TV-Z]$/.test(a),
                    d = /^[A-HNPQS][-]{0,1}[0-9]{7}[-]{0,1}[0-9A-J]$/.test(a);
                if (!b && !c && !d) return !1;
                a = a.replace(/-/g, "");
                var e, f, g = !0;
                if (b || c) {
                    f = "DNI";
                    var h = "XYZ".indexOf(a.charAt(0));
                    return -1 !== h && (a = h + a.substr(1) + "", f = "NIE"), e = parseInt(a.substr(0, 8), 10), e = "TRWAGMYFPDXBNJZSQVHLCKE" [e % 23], {
                        valid: e === a.substr(8, 1),
                        type: f
                    }
                }
                e = a.substr(1, 7), f = "CIF";
                for (var i = a[0], j = a.substr(-1), k = 0, l = 0; l < e.length; l++)
                    if (l % 2 !== 0) k += parseInt(e[l], 10);
                    else {
                        var m = "" + 2 * parseInt(e[l], 10);
                        k += parseInt(m[0], 10), 2 === m.length && (k += parseInt(m[1], 10))
                    } var n = k - 10 * Math.floor(k / 10);
                return 0 !== n && (n = 10 - n), g = -1 !== "KQS".indexOf(i) ? j === "JABCDEFGHI" [n] : -1 !== "ABEH".indexOf(i) ? j === "" + n : j === "" + n || j === "JABCDEFGHI" [n], {
                    valid: g,
                    type: f
                }
            },
            _fi: function(a) {
                if (!/^[0-9]{6}[-+A][0-9]{3}[0-9ABCDEFHJKLMNPRSTUVWXY]$/.test(a)) return !1;
                var b = parseInt(a.substr(0, 2), 10),
                    c = parseInt(a.substr(2, 2), 10),
                    d = parseInt(a.substr(4, 2), 10),
                    e = {
                        "+": 1800,
                        "-": 1900,
                        A: 2e3
                    };
                if (d = e[a.charAt(6)] + d, !FormValidation.Helper.date(d, c, b)) return !1;
                var f = parseInt(a.substr(7, 3), 10);
                if (2 > f) return !1;
                var g = a.substr(0, 6) + a.substr(7, 3) + "";
                return g = parseInt(g, 10), "0123456789ABCDEFHJKLMNPRSTUVWXY".charAt(g % 31) === a.charAt(10)
            },
            _hr: function(a) {
                return /^[0-9]{11}$/.test(a) ? FormValidation.Helper.mod11And10(a) : !1
            },
            _ie: function(a) {
                if (!/^\d{7}[A-W][AHWTX]?$/.test(a)) return !1;
                var b = function(a) {
                    for (; a.length < 7;) a = "0" + a;
                    for (var b = "WABCDEFGHIJKLMNOPQRSTUV", c = 0, d = 0; 7 > d; d++) c += parseInt(a.charAt(d), 10) * (8 - d);
                    return c += 9 * b.indexOf(a.substr(7)), b[c % 23]
                };
                return 9 !== a.length || "A" !== a.charAt(8) && "H" !== a.charAt(8) ? a.charAt(7) === b(a.substr(0, 7)) : a.charAt(7) === b(a.substr(0, 7) + a.substr(8) + "")
            },
            _is: function(a) {
                if (!/^[0-9]{6}[-]{0,1}[0-9]{4}$/.test(a)) return !1;
                a = a.replace(/-/g, "");
                var b = parseInt(a.substr(0, 2), 10),
                    c = parseInt(a.substr(2, 2), 10),
                    d = parseInt(a.substr(4, 2), 10),
                    e = parseInt(a.charAt(9), 10);
                if (d = 9 === e ? 1900 + d : 100 * (20 + e) + d, !FormValidation.Helper.date(d, c, b, !0)) return !1;
                for (var f = 0, g = [3, 2, 7, 6, 5, 4, 3, 2], h = 0; 8 > h; h++) f += parseInt(a.charAt(h), 10) * g[h];
                return f = 11 - f % 11, f + "" === a.charAt(8)
            },
            _lt: function(a) {
                if (!/^[0-9]{11}$/.test(a)) return !1;
                var b = parseInt(a.charAt(0), 10),
                    c = parseInt(a.substr(1, 2), 10),
                    d = parseInt(a.substr(3, 2), 10),
                    e = parseInt(a.substr(5, 2), 10),
                    f = b % 2 === 0 ? 17 + b / 2 : 17 + (b + 1) / 2;
                if (c = 100 * f + c, !FormValidation.Helper.date(c, d, e, !0)) return !1;
                for (var g = 0, h = [1, 2, 3, 4, 5, 6, 7, 8, 9, 1], i = 0; 10 > i; i++) g += parseInt(a.charAt(i), 10) * h[i];
                if (g %= 11, 10 !== g) return g + "" === a.charAt(10);
                for (g = 0, h = [3, 4, 5, 6, 7, 8, 9, 1, 2, 3], i = 0; 10 > i; i++) g += parseInt(a.charAt(i), 10) * h[i];
                return g %= 11, 10 === g && (g = 0), g + "" === a.charAt(10)
            },
            _lv: function(a) {
                if (!/^[0-9]{6}[-]{0,1}[0-9]{5}$/.test(a)) return !1;
                a = a.replace(/\D/g, "");
                var b = parseInt(a.substr(0, 2), 10),
                    c = parseInt(a.substr(2, 2), 10),
                    d = parseInt(a.substr(4, 2), 10);
                if (d = d + 1800 + 100 * parseInt(a.charAt(6), 10), !FormValidation.Helper.date(d, c, b, !0)) return !1;
                for (var e = 0, f = [10, 5, 8, 4, 2, 1, 6, 3, 7, 9], g = 0; 10 > g; g++) e += parseInt(a.charAt(g), 10) * f[g];
                return e = (e + 1) % 11 % 10, e + "" === a.charAt(10)
            },
            _nl: function(a) {
                if (a.length < 8) return !1;
                if (8 === a.length && (a = "0" + a), !/^[0-9]{4}[.]{0,1}[0-9]{2}[.]{0,1}[0-9]{3}$/.test(a)) return !1;
                if (a = a.replace(/\./g, ""), 0 === parseInt(a, 10)) return !1;
                for (var b = 0, c = a.length, d = 0; c - 1 > d; d++) b += (9 - d) * parseInt(a.charAt(d), 10);
                return b %= 11, 10 === b && (b = 0), b + "" === a.charAt(c - 1)
            },
            _pl: function(a) {
                if (!/^[0-9]{11}$/.test(a)) return !1;
                for (var b = 0, c = a.length, d = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3, 7], e = 0; c - 1 > e; e++) b += d[e] * parseInt(a.charAt(e), 10);
                return b %= 10, 0 === b && (b = 10), b = 10 - b, b + "" === a.charAt(c - 1)
            },
            _ro: function(a) {
                if (!/^[0-9]{13}$/.test(a)) return !1;
                var b = parseInt(a.charAt(0), 10);
                if (0 === b || 7 === b || 8 === b) return !1;
                var c = parseInt(a.substr(1, 2), 10),
                    d = parseInt(a.substr(3, 2), 10),
                    e = parseInt(a.substr(5, 2), 10),
                    f = {
                        1: 1900,
                        2: 1900,
                        3: 1800,
                        4: 1800,
                        5: 2e3,
                        6: 2e3
                    };
                if (e > 31 && d > 12) return !1;
                if (9 !== b && (c = f[b + ""] + c, !FormValidation.Helper.date(c, d, e))) return !1;
                for (var g = 0, h = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9], i = a.length, j = 0; i - 1 > j; j++) g += parseInt(a.charAt(j), 10) * h[j];
                return g %= 11, 10 === g && (g = 1), g + "" === a.charAt(i - 1)
            },
            _se: function(a) {
                if (!/^[0-9]{10}$/.test(a) && !/^[0-9]{6}[-|+][0-9]{4}$/.test(a)) return !1;
                a = a.replace(/[^0-9]/g, "");
                var b = parseInt(a.substr(0, 2), 10) + 1900,
                    c = parseInt(a.substr(2, 2), 10),
                    d = parseInt(a.substr(4, 2), 10);
                return FormValidation.Helper.date(b, c, d) ? FormValidation.Helper.luhn(a) : !1
            },
            _sk: function(a) {
                return this._cz(a)
            },
            _sm: function(a) {
                return /^\d{5}$/.test(a)
            },
            _th: function(a) {
                if (13 !== a.length) return !1;
                for (var b = 0, c = 0; 12 > c; c++) b += parseInt(a.charAt(c), 10) * (13 - c);
                return (11 - b % 11) % 10 === parseInt(a.charAt(12), 10)
            },
            _tr: function(a) {
                if (11 !== a.length) return !1;
                for (var b = 0, c = 0; 10 > c; c++) b += parseInt(a.charAt(c), 10);
                return b % 10 === parseInt(a.charAt(10), 10)
            },
            _za: function(a) {
                if (!/^[0-9]{10}[0|1][8|9][0-9]$/.test(a)) return !1;
                var b = parseInt(a.substr(0, 2), 10),
                    c = (new Date).getFullYear() % 100,
                    d = parseInt(a.substr(2, 2), 10),
                    e = parseInt(a.substr(4, 2), 10);
                return b = b >= c ? b + 1900 : b + 2e3, FormValidation.Helper.date(b, d, e) ? FormValidation.Helper.luhn(a) : !1
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                identical: {
                    "default": "Please enter the same value"
                }
            }
        }), FormValidation.Validator.identical = {
            html5Attributes: {
                message: "message",
                field: "field"
            },
            init: function(a, b, c, d) {
                var e = a.getFieldElements(c.field);
                a.onLiveChange(e, "live_" + d, function() {
                    var c = a.getStatus(b, d);
                    c !== a.STATUS_NOT_VALIDATED && a.revalidateField(b)
                })
            },
            destroy: function(a, b, c, d) {
                var e = a.getFieldElements(c.field);
                a.offLiveChange(e, "live_" + d)
            },
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d),
                    f = a.getFieldElements(c.field);
                if (null === f || 0 === f.length) return !0;
                var g = a.getFieldValue(f, d);
                return e === g ? (a.updateStatus(f, a.STATUS_VALID, d), !0) : !1
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                imei: {
                    "default": "Please enter a valid IMEI number"
                }
            }
        }), FormValidation.Validator.imei = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                switch (!0) {
                    case /^\d{15}$/.test(e):
                    case /^\d{2}-\d{6}-\d{6}-\d{1}$/.test(e):
                    case /^\d{2}\s\d{6}\s\d{6}\s\d{1}$/.test(e):
                        return e = e.replace(/[^0-9]/g, ""), FormValidation.Helper.luhn(e);
                    case /^\d{14}$/.test(e):
                    case /^\d{16}$/.test(e):
                    case /^\d{2}-\d{6}-\d{6}(|-\d{2})$/.test(e):
                    case /^\d{2}\s\d{6}\s\d{6}(|\s\d{2})$/.test(e):
                        return !0;
                    default:
                        return !1
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                imo: {
                    "default": "Please enter a valid IMO number"
                }
            }
        }), FormValidation.Validator.imo = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                if (!/^IMO \d{7}$/i.test(e)) return !1;
                for (var f = 0, g = e.replace(/^.*(\d{7})$/, "$1"), h = 6; h >= 1; h--) f += g.slice(6 - h, -h) * (h + 1);
                return f % 10 === parseInt(g.charAt(6), 10)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                integer: {
                    "default": "Please enter a valid number"
                }
            }
        }), FormValidation.Validator.integer = {
            html5Attributes: {
                message: "message",
                thousandsseparator: "thousandsSeparator",
                decimalseparator: "decimalSeparator"
            },
            enableByHtml5: function(a) {
                return "number" === a.attr("type") && (void 0 === a.attr("step") || a.attr("step") % 1 === 0)
            },
            validate: function(a, b, c, d) {
                if (this.enableByHtml5(b) && b.get(0).validity && b.get(0).validity.badInput === !0) return !1;
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                var f = c.decimalSeparator || ".",
                    g = c.thousandsSeparator || "";
                f = "." === f ? "\\." : f, g = "." === g ? "\\." : g;
                var h = new RegExp("^-?[0-9]{1,3}(" + g + "[0-9]{3})*(" + f + "[0-9]+)?$"),
                    i = new RegExp(g, "g");
                return h.test(e) ? (g && (e = e.replace(i, "")), f && (e = e.replace(f, ".")), isNaN(e) || !isFinite(e) ? !1 : (e = parseFloat(e), Math.floor(e) === e)) : !1
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                ip: {
                    "default": "Please enter a valid IP address",
                    ipv4: "Please enter a valid IPv4 address",
                    ipv6: "Please enter a valid IPv6 address"
                }
            }
        }), FormValidation.Validator.ip = {
            html5Attributes: {
                message: "message",
                ipv4: "ipv4",
                ipv6: "ipv6"
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                d = a.extend({}, {
                    ipv4: !0,
                    ipv6: !0
                }, d);
                var g, h = b.getLocale(),
                    i = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\/([0-9]|[1-2][0-9]|3[0-2]))?$/,
                    j = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*(\/(\d|\d\d|1[0-1]\d|12[0-8]))?$/,
                    k = !1;
                switch (!0) {
                    case d.ipv4 && !d.ipv6:
                        k = i.test(f), g = d.message || FormValidation.I18n[h].ip.ipv4;
                        break;
                    case !d.ipv4 && d.ipv6:
                        k = j.test(f), g = d.message || FormValidation.I18n[h].ip.ipv6;
                        break;
                    case d.ipv4 && d.ipv6:
                    default:
                        k = i.test(f) || j.test(f), g = d.message || FormValidation.I18n[h].ip["default"]
                }
                return {
                    valid: k,
                    message: g
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                isbn: {
                    "default": "Please enter a valid ISBN number"
                }
            }
        }), FormValidation.Validator.isbn = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                var f;
                switch (!0) {
                    case /^\d{9}[\dX]$/.test(e):
                    case 13 === e.length && /^(\d+)-(\d+)-(\d+)-([\dX])$/.test(e):
                    case 13 === e.length && /^(\d+)\s(\d+)\s(\d+)\s([\dX])$/.test(e):
                        f = "ISBN10";
                        break;
                    case /^(978|979)\d{9}[\dX]$/.test(e):
                    case 17 === e.length && /^(978|979)-(\d+)-(\d+)-(\d+)-([\dX])$/.test(e):
                    case 17 === e.length && /^(978|979)\s(\d+)\s(\d+)\s(\d+)\s([\dX])$/.test(e):
                        f = "ISBN13";
                        break;
                    default:
                        return !1
                }
                e = e.replace(/[^0-9X]/gi, "");
                var g, h, i = e.split(""),
                    j = i.length,
                    k = 0;
                switch (f) {
                    case "ISBN10":
                        for (k = 0, g = 0; j - 1 > g; g++) k += parseInt(i[g], 10) * (10 - g);
                        return h = 11 - k % 11, 11 === h ? h = 0 : 10 === h && (h = "X"), {
                            type: f,
                            valid: h + "" === i[j - 1]
                        };
                    case "ISBN13":
                        for (k = 0, g = 0; j - 1 > g; g++) k += g % 2 === 0 ? parseInt(i[g], 10) : 3 * parseInt(i[g], 10);
                        return h = 10 - k % 10, 10 === h && (h = "0"), {
                            type: f,
                            valid: h + "" === i[j - 1]
                        };
                    default:
                        return !1
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                isin: {
                    "default": "Please enter a valid ISIN number"
                }
            }
        }), FormValidation.Validator.isin = {
            COUNTRY_CODES: "AF|AX|AL|DZ|AS|AD|AO|AI|AQ|AG|AR|AM|AW|AU|AT|AZ|BS|BH|BD|BB|BY|BE|BZ|BJ|BM|BT|BO|BQ|BA|BW|BV|BR|IO|BN|BG|BF|BI|KH|CM|CA|CV|KY|CF|TD|CL|CN|CX|CC|CO|KM|CG|CD|CK|CR|CI|HR|CU|CW|CY|CZ|DK|DJ|DM|DO|EC|EG|SV|GQ|ER|EE|ET|FK|FO|FJ|FI|FR|GF|PF|TF|GA|GM|GE|DE|GH|GI|GR|GL|GD|GP|GU|GT|GG|GN|GW|GY|HT|HM|VA|HN|HK|HU|IS|IN|ID|IR|IQ|IE|IM|IL|IT|JM|JP|JE|JO|KZ|KE|KI|KP|KR|KW|KG|LA|LV|LB|LS|LR|LY|LI|LT|LU|MO|MK|MG|MW|MY|MV|ML|MT|MH|MQ|MR|MU|YT|MX|FM|MD|MC|MN|ME|MS|MA|MZ|MM|NA|NR|NP|NL|NC|NZ|NI|NE|NG|NU|NF|MP|NO|OM|PK|PW|PS|PA|PG|PY|PE|PH|PN|PL|PT|PR|QA|RE|RO|RU|RW|BL|SH|KN|LC|MF|PM|VC|WS|SM|ST|SA|SN|RS|SC|SL|SG|SX|SK|SI|SB|SO|ZA|GS|SS|ES|LK|SD|SR|SJ|SZ|SE|CH|SY|TW|TJ|TZ|TH|TL|TG|TK|TO|TT|TN|TR|TM|TC|TV|UG|UA|AE|GB|US|UM|UY|UZ|VU|VE|VN|VG|VI|WF|EH|YE|ZM|ZW",
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                e = e.toUpperCase();
                var f = new RegExp("^(" + this.COUNTRY_CODES + ")[0-9A-Z]{10}$");
                if (!f.test(e)) return !1;
                for (var g = "", h = e.length, i = 0; h - 1 > i; i++) {
                    var j = e.charCodeAt(i);
                    g += j > 57 ? (j - 55).toString() : e.charAt(i)
                }
                var k = "",
                    l = g.length,
                    m = l % 2 !== 0 ? 0 : 1;
                for (i = 0; l > i; i++) k += parseInt(g[i], 10) * (i % 2 === m ? 2 : 1) + "";
                var n = 0;
                for (i = 0; i < k.length; i++) n += parseInt(k.charAt(i), 10);
                return n = (10 - n % 10) % 10, n + "" === e.charAt(h - 1)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                ismn: {
                    "default": "Please enter a valid ISMN number"
                }
            }
        }), FormValidation.Validator.ismn = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                var f;
                switch (!0) {
                    case /^M\d{9}$/.test(e):
                    case /^M-\d{4}-\d{4}-\d{1}$/.test(e):
                    case /^M\s\d{4}\s\d{4}\s\d{1}$/.test(e):
                        f = "ISMN10";
                        break;
                    case /^9790\d{9}$/.test(e):
                    case /^979-0-\d{4}-\d{4}-\d{1}$/.test(e):
                    case /^979\s0\s\d{4}\s\d{4}\s\d{1}$/.test(e):
                        f = "ISMN13";
                        break;
                    default:
                        return !1
                }
                "ISMN10" === f && (e = "9790" + e.substr(1)), e = e.replace(/[^0-9]/gi, "");
                for (var g = e.length, h = 0, i = [1, 3], j = 0; g - 1 > j; j++) h += parseInt(e.charAt(j), 10) * i[j % 2];
                return h = 10 - h % 10, {
                    type: f,
                    valid: h + "" === e.charAt(g - 1)
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                issn: {
                    "default": "Please enter a valid ISSN number"
                }
            }
        }), FormValidation.Validator.issn = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                if (!/^\d{4}\-\d{3}[\dX]$/.test(e)) return !1;
                e = e.replace(/[^0-9X]/gi, "");
                var f = e.split(""),
                    g = f.length,
                    h = 0;
                "X" === f[7] && (f[7] = 10);
                for (var i = 0; g > i; i++) h += parseInt(f[i], 10) * (8 - i);
                return h % 11 === 0
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                lessThan: {
                    "default": "Please enter a value less than or equal to %s",
                    notInclusive: "Please enter a value less than %s"
                }
            }
        }), FormValidation.Validator.lessThan = {
            html5Attributes: {
                message: "message",
                value: "value",
                inclusive: "inclusive"
            },
            enableByHtml5: function(a) {
                var b = a.attr("type"),
                    c = a.attr("max");
                return c && "date" !== b ? {
                    value: c
                } : !1
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                f = this._format(f);
                var g = b.getLocale(),
                    h = a.isNumeric(d.value) ? d.value : b.getDynamicOption(c, d.value),
                    i = this._format(h);
                return d.inclusive === !0 || void 0 === d.inclusive ? {
                    valid: a.isNumeric(f) && parseFloat(f) <= i,
                    message: FormValidation.Helper.format(d.message || FormValidation.I18n[g].lessThan["default"], h)
                } : {
                    valid: a.isNumeric(f) && parseFloat(f) < i,
                    message: FormValidation.Helper.format(d.message || FormValidation.I18n[g].lessThan.notInclusive, h)
                }
            },
            _format: function(a) {
                return (a + "").replace(",", ".")
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                mac: {
                    "default": "Please enter a valid MAC address"
                }
            }
        }), FormValidation.Validator.mac = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                return "" === e ? !0 : /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/.test(e) || /^([0-9A-Fa-f]{4}\.){2}([0-9A-Fa-f]{4})$/.test(e)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                meid: {
                    "default": "Please enter a valid MEID number"
                }
            }
        }), FormValidation.Validator.meid = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                switch (!0) {
                    case /^[0-9A-F]{15}$/i.test(e):
                    case /^[0-9A-F]{2}[- ][0-9A-F]{6}[- ][0-9A-F]{6}[- ][0-9A-F]$/i.test(e):
                    case /^\d{19}$/.test(e):
                    case /^\d{5}[- ]\d{5}[- ]\d{4}[- ]\d{4}[- ]\d$/.test(e):
                        var f = e.charAt(e.length - 1);
                        if (e = e.replace(/[- ]/g, ""), e.match(/^\d*$/i)) return FormValidation.Helper.luhn(e);
                        e = e.slice(0, -1);
                        for (var g = "", h = 1; 13 >= h; h += 2) g += (2 * parseInt(e.charAt(h), 16)).toString(16);
                        var i = 0;
                        for (h = 0; h < g.length; h++) i += parseInt(g.charAt(h), 16);
                        return i % 10 === 0 ? "0" === f : f === (2 * (10 * Math.floor((i + 10) / 10) - i)).toString(16);
                    case /^[0-9A-F]{14}$/i.test(e):
                    case /^[0-9A-F]{2}[- ][0-9A-F]{6}[- ][0-9A-F]{6}$/i.test(e):
                    case /^\d{18}$/.test(e):
                    case /^\d{5}[- ]\d{5}[- ]\d{4}[- ]\d{4}$/.test(e):
                        return !0;
                    default:
                        return !1
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                notEmpty: {
                    "default": "Please enter a value"
                }
            }
        }), FormValidation.Validator.notEmpty = {
            enableByHtml5: function(a) {
                var b = a.attr("required") + "";
                return "required" === b || "true" === b
            },
            validate: function(b, c, d, e) {
                var f = c.attr("type");
                if ("radio" === f || "checkbox" === f) {
                    var g = b.getNamespace();
                    return b.getFieldElements(c.attr("data-" + g + "-field")).filter(":checked").length > 0
                }
                if ("number" === f && c.get(0).validity && c.get(0).validity.badInput === !0) return !0;
                var h = b.getFieldValue(c, e);
                return "" !== a.trim(h)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                numeric: {
                    "default": "Please enter a valid float number"
                }
            }
        }), FormValidation.Validator.numeric = {
            html5Attributes: {
                message: "message",
                separator: "separator",
                thousandsseparator: "thousandsSeparator",
                decimalseparator: "decimalSeparator"
            },
            enableByHtml5: function(a) {
                return "number" === a.attr("type") && void 0 !== a.attr("step") && a.attr("step") % 1 !== 0
            },
            validate: function(a, b, c, d) {
                if (this.enableByHtml5(b) && b.get(0).validity && b.get(0).validity.badInput === !0) return !1;
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                var f = c.separator || c.decimalSeparator || ".",
                    g = c.thousandsSeparator || "";
                e.substr(0, 1) === f ? e = "0" + f + e.substr(1) : e.substr(0, 2) === "-" + f && (e = "-0" + f + e.substr(2)), f = "." === f ? "\\." : f, g = "." === g ? "\\." : g;
                var h = new RegExp("^-?[0-9]{1,3}(" + g + "[0-9]{3})*(" + f + "[0-9]+)?$"),
                    i = new RegExp(g, "g");
                return h.test(e) ? (g && (e = e.replace(i, "")), f && (e = e.replace(f, ".")), !isNaN(parseFloat(e)) && isFinite(e)) : !1
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                phone: {
                    "default": "Please enter a valid phone number",
                    country: "Please enter a valid phone number in %s",
                    countries: {
                        AE: "United Arab Emirates",
                        BG: "Bulgaria",
                        BR: "Brazil",
                        CN: "China",
                        CZ: "Czech Republic",
                        DE: "Germany",
                        DK: "Denmark",
                        ES: "Spain",
                        FR: "France",
                        GB: "United Kingdom",
                        IN: "India",
                        MA: "Morocco",
                        NL: "Netherlands",
                        PK: "Pakistan",
                        RO: "Romania",
                        RU: "Russia",
                        SK: "Slovakia",
                        TH: "Thailand",
                        US: "USA",
                        VE: "Venezuela"
                    }
                }
            }
        }), FormValidation.Validator.phone = {
            html5Attributes: {
                message: "message",
                country: "country"
            },
            COUNTRY_CODES: ["AE", "BG", "BR", "CN", "CZ", "DE", "DK", "ES", "FR", "GB", "IN", "MA", "NL", "PK", "RO", "RU", "SK", "TH", "US", "VE"],
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                var g = b.getLocale(),
                    h = d.country;
                if (("string" != typeof h || -1 === a.inArray(h, this.COUNTRY_CODES)) && (h = b.getDynamicOption(c, h)), !h || -1 === a.inArray(h.toUpperCase(), this.COUNTRY_CODES)) return !0;
                var i = !0;
                switch (h.toUpperCase()) {
                    case "AE":
                        f = a.trim(f), i = /^(((\+|00)?971[\s\.-]?(\(0\)[\s\.-]?)?|0)(\(5(0|2|5|6)\)|5(0|2|5|6)|2|3|4|6|7|9)|60)([\s\.-]?[0-9]){7}$/.test(f);
                        break;
                    case "BG":
                        f = f.replace(/\+|\s|-|\/|\(|\)/gi, ""), i = /^(0|359|00)(((700|900)[0-9]{5}|((800)[0-9]{5}|(800)[0-9]{4}))|(87|88|89)([0-9]{7})|((2[0-9]{7})|(([3-9][0-9])(([0-9]{6})|([0-9]{5})))))$/.test(f);
                        break;
                    case "BR":
                        f = a.trim(f), i = /^(([\d]{4}[-.\s]{1}[\d]{2,3}[-.\s]{1}[\d]{2}[-.\s]{1}[\d]{2})|([\d]{4}[-.\s]{1}[\d]{3}[-.\s]{1}[\d]{4})|((\(?\+?[0-9]{2}\)?\s?)?(\(?\d{2}\)?\s?)?\d{4,5}[-.\s]?\d{4}))$/.test(f);
                        break;
                    case "CN":
                        f = a.trim(f), i = /^((00|\+)?(86(?:-| )))?((\d{11})|(\d{3}[- ]{1}\d{4}[- ]{1}\d{4})|((\d{2,4}[- ]){1}(\d{7,8}|(\d{3,4}[- ]{1}\d{4}))([- ]{1}\d{1,4})?))$/.test(f);
                        break;
                    case "CZ":
                        i = /^(((00)([- ]?)|\+)(420)([- ]?))?((\d{3})([- ]?)){2}(\d{3})$/.test(f);
                        break;
                    case "DE":
                        f = a.trim(f), i = /^(((((((00|\+)49[ \-/]?)|0)[1-9][0-9]{1,4})[ \-/]?)|((((00|\+)49\()|\(0)[1-9][0-9]{1,4}\)[ \-/]?))[0-9]{1,7}([ \-/]?[0-9]{1,5})?)$/.test(f);
                        break;
                    case "DK":
                        f = a.trim(f), i = /^(\+45|0045|\(45\))?\s?[2-9](\s?\d){7}$/.test(f);
                        break;
                    case "ES":
                        f = a.trim(f), i = /^(?:(?:(?:\+|00)34\D?))?(?:5|6|7|8|9)(?:\d\D?){8}$/.test(f);
                        break;
                    case "FR":
                        f = a.trim(f), i = /^(?:(?:(?:\+|00)33[ ]?(?:\(0\)[ ]?)?)|0){1}[1-9]{1}([ .-]?)(?:\d{2}\1?){3}\d{2}$/.test(f);
                        break;
                    case "GB":
                        f = a.trim(f), i = /^\(?(?:(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?\(?(?:0\)?[\s-]?\(?)?|0)(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}|\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4}|\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3})|\d{5}\)?[\s-]?\d{4,5}|8(?:00[\s-]?11[\s-]?11|45[\s-]?46[\s-]?4\d))(?:(?:[\s-]?(?:x|ext\.?\s?|\#)\d+)?)$/.test(f);
                        break;
                    case "IN":
                        f = a.trim(f), i = /((\+?)((0[ -]+)*|(91 )*)(\d{12}|\d{10}))|\d{5}([- ]*)\d{6}/.test(f);
                        break;
                    case "MA":
                        f = a.trim(f), i = /^(?:(?:(?:\+|00)212[\s]?(?:[\s]?\(0\)[\s]?)?)|0){1}(?:5[\s.-]?[2-3]|6[\s.-]?[13-9]){1}[0-9]{1}(?:[\s.-]?\d{2}){3}$/.test(f);
                        break;
                    case "NL":
                        f = a.trim(f), i = /^((\+|00(\s|\s?\-\s?)?)31(\s|\s?\-\s?)?(\(0\)[\-\s]?)?|0)[1-9]((\s|\s?\-\s?)?[0-9])((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]$/gm.test(f);
                        break;
                    case "PK":
                        f = a.trim(f), i = /^0?3[0-9]{2}[0-9]{7}$/.test(f);
                        break;
                    case "RO":
                        i = /^(\+4|)?(07[0-8]{1}[0-9]{1}|02[0-9]{2}|03[0-9]{2}){1}?(\s|\.|\-)?([0-9]{3}(\s|\.|\-|)){2}$/g.test(f);
                        break;
                    case "RU":
                        i = /^((8|\+7|007)[\-\.\/ ]?)?([\(\/\.]?\d{3}[\)\/\.]?[\-\.\/ ]?)?[\d\-\.\/ ]{7,10}$/g.test(f);
                        break;
                    case "SK":
                        i = /^(((00)([- ]?)|\+)(421)([- ]?))?((\d{3})([- ]?)){2}(\d{3})$/.test(f);
                        break;
                    case "TH":
                        i = /^0\(?([6|8-9]{2})*-([0-9]{3})*-([0-9]{4})$/.test(f);
                        break;
                    case "VE":
                        f = a.trim(f), i = /^0(?:2(?:12|4[0-9]|5[1-9]|6[0-9]|7[0-8]|8[1-35-8]|9[1-5]|3[45789])|4(?:1[246]|2[46]))\d{7}$/.test(f);
                        break;
                    case "US":
                    default:
                        i = /^(?:(1\-?)|(\+1 ?))?\(?\d{3}\)?[\-\.\s]?\d{3}[\-\.\s]?\d{4}$/.test(f)
                }
                return {
                    valid: i,
                    message: FormValidation.Helper.format(d.message || FormValidation.I18n[g].phone.country, FormValidation.I18n[g].phone.countries[h])
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                promise: {
                    "default": "Please enter a valid value"
                }
            }
        }), FormValidation.Validator.promise = {
            priority: 999,
            html5Attributes: {
                message: "message",
                promise: "promise"
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e),
                    g = new a.Deferred,
                    h = FormValidation.Helper.call(d.promise, [f, b, c]);
                return h.done(function(a) {
                    g.resolve(c, e, a)
                }).fail(function(a) {
                    a = a || {}, a.valid = !1, g.resolve(c, e, a)
                }), g
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                regexp: {
                    "default": "Please enter a value matching the pattern"
                }
            }
        }), FormValidation.Validator.regexp = {
            html5Attributes: {
                message: "message",
                flags: "flags",
                regexp: "regexp"
            },
            enableByHtml5: function(a) {
                var b = a.attr("pattern");
                return b ? {
                    regexp: b
                } : !1
            },
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                var f = "string" == typeof c.regexp ? c.flags ? new RegExp(c.regexp, c.flags) : new RegExp(c.regexp) : c.regexp;
                return f.test(e)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                remote: {
                    "default": "Please enter a valid value"
                }
            }
        }), FormValidation.Validator.remote = {
            priority: 1e3,
            html5Attributes: {
                async: "async",
                crossdomain: "crossDomain",
                data: "data",
                datatype: "dataType",
                delay: "delay",
                message: "message",
                name: "name",
                type: "type",
                url: "url",
                validkey: "validKey"
            },
            destroy: function(a, b, c, d) {
                var e = a.getNamespace(),
                    f = b.data(e + "." + d + ".timer");
                f && (clearTimeout(f), b.removeData(e + "." + d + ".timer"))
            },
            validate: function(b, c, d, e) {
                function f() {
                    var b = a.ajax(n);
                    return b.success(function(a) {
                        a.valid = a[m] === !0 || "true" === a[m] ? !0 : a[m] === !1 || "false" === a[m] ? !1 : null, i.resolve(c, e, a)
                    }).error(function(a) {
                        i.resolve(c, e, {
                            valid: !1
                        })
                    }), i.fail(function() {
                        b.abort()
                    }), i
                }
                var g = b.getNamespace(),
                    h = b.getFieldValue(c, e),
                    i = new a.Deferred;
                if ("" === h) return i.resolve(c, e, {
                    valid: !0
                }), i;
                var j = c.attr("data-" + g + "-field"),
                    k = d.data || {},
                    l = d.url,
                    m = d.validKey || "valid";
                "function" == typeof k && (k = k.call(this, b, c, h)), "string" == typeof k && (k = JSON.parse(k)), "function" == typeof l && (l = l.call(this, b, c, h)), k[d.name || j] = h;
                var n = {
                    async: null === d.async || d.async === !0 || "true" === d.async,
                    data: k,
                    dataType: d.dataType || "json",
                    headers: d.headers || {},
                    type: d.type || "GET",
                    url: l
                };
                return null !== d.crossDomain && (n.crossDomain = d.crossDomain === !0 || "true" === d.crossDomain), d.delay ? (c.data(g + "." + e + ".timer") && clearTimeout(c.data(g + "." + e + ".timer")), c.data(g + "." + e + ".timer", setTimeout(f, d.delay)), i) : f()
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                rtn: {
                    "default": "Please enter a valid RTN number"
                }
            }
        }), FormValidation.Validator.rtn = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                if (!/^\d{9}$/.test(e)) return !1;
                for (var f = 0, g = 0; g < e.length; g += 3) f += 3 * parseInt(e.charAt(g), 10) + 7 * parseInt(e.charAt(g + 1), 10) + parseInt(e.charAt(g + 2), 10);
                return 0 !== f && f % 10 === 0
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                sedol: {
                    "default": "Please enter a valid SEDOL number"
                }
            }
        }), FormValidation.Validator.sedol = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                if (e = e.toUpperCase(), !/^[0-9A-Z]{7}$/.test(e)) return !1;
                for (var f = 0, g = [1, 3, 1, 7, 3, 9, 1], h = e.length, i = 0; h - 1 > i; i++) f += g[i] * parseInt(e.charAt(i), 36);
                return f = (10 - f % 10) % 10, f + "" === e.charAt(h - 1)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                siren: {
                    "default": "Please enter a valid SIREN number"
                }
            }
        }), FormValidation.Validator.siren = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                return "" === e ? !0 : /^\d{9}$/.test(e) ? FormValidation.Helper.luhn(e) : !1
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                siret: {
                    "default": "Please enter a valid SIRET number"
                }
            }
        }), FormValidation.Validator.siret = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                for (var f, g = 0, h = e.length, i = 0; h > i; i++) f = parseInt(e.charAt(i), 10), i % 2 === 0 && (f = 2 * f, f > 9 && (f -= 9)), g += f;
                return g % 10 === 0
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                step: {
                    "default": "Please enter a valid step of %s"
                }
            }
        }), FormValidation.Validator.step = {
            html5Attributes: {
                message: "message",
                base: "baseValue",
                step: "step"
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                if (d = a.extend({}, {
                    baseValue: 0,
                    step: 1
                }, d), f = parseFloat(f), !a.isNumeric(f)) return !1;
                var g = function(a, b) {
                        var c = Math.pow(10, b);
                        a *= c;
                        var d = a > 0 | -(0 > a),
                            e = a % 1 === .5 * d;
                        return e ? (Math.floor(a) + (d > 0)) / c : Math.round(a) / c
                    },
                    h = function(a, b) {
                        if (0 === b) return 1;
                        var c = (a + "").split("."),
                            d = (b + "").split("."),
                            e = (1 === c.length ? 0 : c[1].length) + (1 === d.length ? 0 : d[1].length);
                        return g(a - b * Math.floor(a / b), e)
                    },
                    i = b.getLocale(),
                    j = h(f - d.baseValue, d.step);
                return {
                    valid: 0 === j || j === d.step,
                    message: FormValidation.Helper.format(d.message || FormValidation.I18n[i].step["default"], [d.step])
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                stringCase: {
                    "default": "Please enter only lowercase characters",
                    upper: "Please enter only uppercase characters"
                }
            }
        }), FormValidation.Validator.stringCase = {
            html5Attributes: {
                message: "message",
                "case": "case"
            },
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                var f = a.getLocale(),
                    g = (c["case"] || "lower").toLowerCase();
                return {
                    valid: "upper" === g ? e === e.toUpperCase() : e === e.toLowerCase(),
                    message: c.message || ("upper" === g ? FormValidation.I18n[f].stringCase.upper : FormValidation.I18n[f].stringCase["default"])
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                stringLength: {
                    "default": "Please enter a value with valid length",
                    less: "Please enter less than %s characters",
                    more: "Please enter more than %s characters",
                    between: "Please enter value between %s and %s characters long"
                }
            }
        }), FormValidation.Validator.stringLength = {
            html5Attributes: {
                message: "message",
                min: "min",
                max: "max",
                trim: "trim",
                utf8bytes: "utf8Bytes"
            },
            enableByHtml5: function(b) {
                var c = {},
                    d = b.attr("maxlength"),
                    e = b.attr("minlength");
                return d && (c.max = parseInt(d, 10)), e && (c.min = parseInt(e, 10)), a.isEmptyObject(c) ? !1 : c
            },
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ((d.trim === !0 || "true" === d.trim) && (f = a.trim(f)), "" === f) return !0;
                var g = b.getLocale(),
                    h = a.isNumeric(d.min) ? d.min : b.getDynamicOption(c, d.min),
                    i = a.isNumeric(d.max) ? d.max : b.getDynamicOption(c, d.max),
                    j = function(a) {
                        for (var b = a.length, c = a.length - 1; c >= 0; c--) {
                            var d = a.charCodeAt(c);
                            d > 127 && 2047 >= d ? b++ : d > 2047 && 65535 >= d && (b += 2), d >= 56320 && 57343 >= d && c--
                        }
                        return b
                    },
                    k = d.utf8Bytes ? j(f) : f.length,
                    l = !0,
                    m = d.message || FormValidation.I18n[g].stringLength["default"];
                switch ((h && k < parseInt(h, 10) || i && k > parseInt(i, 10)) && (l = !1), !0) {
                    case !!h && !!i:
                        m = FormValidation.Helper.format(d.message || FormValidation.I18n[g].stringLength.between, [parseInt(h, 10), parseInt(i, 10)]);
                        break;
                    case !!h:
                        m = FormValidation.Helper.format(d.message || FormValidation.I18n[g].stringLength.more, parseInt(h, 10) - 1);
                        break;
                    case !!i:
                        m = FormValidation.Helper.format(d.message || FormValidation.I18n[g].stringLength.less, parseInt(i, 10) + 1)
                }
                return {
                    valid: l,
                    message: m
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                uri: {
                    "default": "Please enter a valid URI"
                }
            }
        }), FormValidation.Validator.uri = {
            html5Attributes: {
                message: "message",
                allowlocal: "allowLocal",
                allowemptyprotocol: "allowEmptyProtocol",
                protocol: "protocol"
            },
            enableByHtml5: function(a) {
                return "url" === a.attr("type")
            },
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                var f = c.allowLocal === !0 || "true" === c.allowLocal,
                    g = c.allowEmptyProtocol === !0 || "true" === c.allowEmptyProtocol,
                    h = (c.protocol || "http, https, ftp").split(",").join("|").replace(/\s/g, ""),
                    i = new RegExp("^(?:(?:" + h + ")://)" + (g ? "?" : "") + "(?:\\S+(?::\\S*)?@)?(?:" + (f ? "" : "(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})") + "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-?)*[a-z\\u00a1-\\uffff0-9])*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" + (f ? "?" : "") + ")(?::\\d{2,5})?(?:/[^\\s]*)?$", "i");
                return i.test(e)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                uuid: {
                    "default": "Please enter a valid UUID number",
                    version: "Please enter a valid UUID version %s number"
                }
            }
        }), FormValidation.Validator.uuid = {
            html5Attributes: {
                message: "message",
                version: "version"
            },
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                var f = a.getLocale(),
                    g = {
                        3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
                        4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
                        5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
                        all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
                    },
                    h = c.version ? c.version + "" : "all";
                return {
                    valid: null === g[h] ? !0 : g[h].test(e),
                    message: c.version ? FormValidation.Helper.format(c.message || FormValidation.I18n[f].uuid.version, c.version) : c.message || FormValidation.I18n[f].uuid["default"]
                }
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                vat: {
                    "default": "Please enter a valid VAT number",
                    country: "Please enter a valid VAT number in %s",
                    countries: {
                        AT: "Austria",
                        BE: "Belgium",
                        BG: "Bulgaria",
                        BR: "Brazil",
                        CH: "Switzerland",
                        CY: "Cyprus",
                        CZ: "Czech Republic",
                        DE: "Germany",
                        DK: "Denmark",
                        EE: "Estonia",
                        ES: "Spain",
                        FI: "Finland",
                        FR: "France",
                        GB: "United Kingdom",
                        GR: "Greek",
                        EL: "Greek",
                        HU: "Hungary",
                        HR: "Croatia",
                        IE: "Ireland",
                        IS: "Iceland",
                        IT: "Italy",
                        LT: "Lithuania",
                        LU: "Luxembourg",
                        LV: "Latvia",
                        MT: "Malta",
                        NL: "Netherlands",
                        NO: "Norway",
                        PL: "Poland",
                        PT: "Portugal",
                        RO: "Romania",
                        RU: "Russia",
                        RS: "Serbia",
                        SE: "Sweden",
                        SI: "Slovenia",
                        SK: "Slovakia",
                        VE: "Venezuela",
                        ZA: "South Africa"
                    }
                }
            }
        }), FormValidation.Validator.vat = {
            html5Attributes: {
                message: "message",
                country: "country"
            },
            COUNTRY_CODES: ["AT", "BE", "BG", "BR", "CH", "CY", "CZ", "DE", "DK", "EE", "EL", "ES", "FI", "FR", "GB", "GR", "HR", "HU", "IE", "IS", "IT", "LT", "LU", "LV", "MT", "NL", "NO", "PL", "PT", "RO", "RU", "RS", "SE", "SK", "SI", "VE", "ZA"],
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f) return !0;
                var g = b.getLocale(),
                    h = d.country;
                if (h ? ("string" != typeof h || -1 === a.inArray(h.toUpperCase(), this.COUNTRY_CODES)) && (h = b.getDynamicOption(c, h)) : h = f.substr(0, 2), -1 === a.inArray(h, this.COUNTRY_CODES)) return !0;
                var i = ["_", h.toLowerCase()].join(""),
                    j = this[i](f);
                return j = j === !0 || j === !1 ? {
                    valid: j
                } : j, j.message = FormValidation.Helper.format(d.message || FormValidation.I18n[g].vat.country, FormValidation.I18n[g].vat.countries[h.toUpperCase()]), j
            },
            _at: function(a) {
                if (/^ATU[0-9]{8}$/.test(a) && (a = a.substr(2)), !/^U[0-9]{8}$/.test(a)) return !1;
                a = a.substr(1);
                for (var b = 0, c = [1, 2, 1, 2, 1, 2, 1], d = 0, e = 0; 7 > e; e++) d = parseInt(a.charAt(e), 10) * c[e], d > 9 && (d = Math.floor(d / 10) + d % 10), b += d;
                return b = 10 - (b + 4) % 10, 10 === b && (b = 0), b + "" === a.substr(7, 1)
            },
            _be: function(a) {
                if (/^BE[0]{0,1}[0-9]{9}$/.test(a) && (a = a.substr(2)), !/^[0]{0,1}[0-9]{9}$/.test(a)) return !1;
                if (9 === a.length && (a = "0" + a), "0" === a.substr(1, 1)) return !1;
                var b = parseInt(a.substr(0, 8), 10) + parseInt(a.substr(8, 2), 10);
                return b % 97 === 0
            },
            _bg: function(a) {
                if (/^BG[0-9]{9,10}$/.test(a) && (a = a.substr(2)), !/^[0-9]{9,10}$/.test(a)) return !1;
                var b = 0,
                    c = 0;
                if (9 === a.length) {
                    for (c = 0; 8 > c; c++) b += parseInt(a.charAt(c), 10) * (c + 1);
                    if (b %= 11, 10 === b)
                        for (b = 0, c = 0; 8 > c; c++) b += parseInt(a.charAt(c), 10) * (c + 3);
                    return b %= 10, b + "" === a.substr(8)
                }
                if (10 === a.length) {
                    var d = function(a) {
                            var b = parseInt(a.substr(0, 2), 10) + 1900,
                                c = parseInt(a.substr(2, 2), 10),
                                d = parseInt(a.substr(4, 2), 10);
                            if (c > 40 ? (b += 100, c -= 40) : c > 20 && (b -= 100, c -= 20), !FormValidation.Helper.date(b, c, d)) return !1;
                            for (var e = 0, f = [2, 4, 8, 5, 10, 9, 7, 3, 6], g = 0; 9 > g; g++) e += parseInt(a.charAt(g), 10) * f[g];
                            return e = e % 11 % 10, e + "" === a.substr(9, 1)
                        },
                        e = function(a) {
                            for (var b = 0, c = [21, 19, 17, 13, 11, 9, 7, 3, 1], d = 0; 9 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                            return b %= 10, b + "" === a.substr(9, 1)
                        },
                        f = function(a) {
                            for (var b = 0, c = [4, 3, 2, 7, 6, 5, 4, 3, 2], d = 0; 9 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                            return b = 11 - b % 11, 10 === b ? !1 : (11 === b && (b = 0), b + "" === a.substr(9, 1))
                        };
                    return d(a) || e(a) || f(a)
                }
                return !1
            },
            _br: function(a) {
                if ("" === a) return !0;
                var b = a.replace(/[^\d]+/g, "");
                if ("" === b || 14 !== b.length) return !1;
                if ("00000000000000" === b || "11111111111111" === b || "22222222222222" === b || "33333333333333" === b || "44444444444444" === b || "55555555555555" === b || "66666666666666" === b || "77777777777777" === b || "88888888888888" === b || "99999999999999" === b) return !1;
                for (var c = b.length - 2, d = b.substring(0, c), e = b.substring(c), f = 0, g = c - 7, h = c; h >= 1; h--) f += parseInt(d.charAt(c - h), 10) * g--, 2 > g && (g = 9);
                var i = 2 > f % 11 ? 0 : 11 - f % 11;
                if (i !== parseInt(e.charAt(0), 10)) return !1;
                for (c += 1, d = b.substring(0, c), f = 0, g = c - 7, h = c; h >= 1; h--) f += parseInt(d.charAt(c - h), 10) * g--, 2 > g && (g = 9);
                return i = 2 > f % 11 ? 0 : 11 - f % 11, i === parseInt(e.charAt(1), 10)
            },
            _ch: function(a) {
                if (/^CHE[0-9]{9}(MWST)?$/.test(a) && (a = a.substr(2)), !/^E[0-9]{9}(MWST)?$/.test(a)) return !1;
                a = a.substr(1);
                for (var b = 0, c = [5, 4, 3, 2, 7, 6, 5, 4], d = 0; 8 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b = 11 - b % 11, 10 === b ? !1 : (11 === b && (b = 0), b + "" === a.substr(8, 1))
            },
            _cy: function(a) {
                if (/^CY[0-5|9]{1}[0-9]{7}[A-Z]{1}$/.test(a) && (a = a.substr(2)), !/^[0-5|9]{1}[0-9]{7}[A-Z]{1}$/.test(a)) return !1;
                if ("12" === a.substr(0, 2)) return !1;
                for (var b = 0, c = {
                    0: 1,
                    1: 0,
                    2: 5,
                    3: 7,
                    4: 9,
                    5: 13,
                    6: 15,
                    7: 17,
                    8: 19,
                    9: 21
                }, d = 0; 8 > d; d++) {
                    var e = parseInt(a.charAt(d), 10);
                    d % 2 === 0 && (e = c[e + ""]), b += e
                }
                return b = "ABCDEFGHIJKLMNOPQRSTUVWXYZ" [b % 26], b + "" === a.substr(8, 1)
            },
            _cz: function(a) {
                if (/^CZ[0-9]{8,10}$/.test(a) && (a = a.substr(2)), !/^[0-9]{8,10}$/.test(a)) return !1;
                var b = 0,
                    c = 0;
                if (8 === a.length) {
                    if (a.charAt(0) + "" == "9") return !1;
                    for (b = 0, c = 0; 7 > c; c++) b += parseInt(a.charAt(c), 10) * (8 - c);
                    return b = 11 - b % 11, 10 === b && (b = 0), 11 === b && (b = 1), b + "" === a.substr(7, 1)
                }
                if (9 === a.length && a.charAt(0) + "" == "6") {
                    for (b = 0, c = 0; 7 > c; c++) b += parseInt(a.charAt(c + 1), 10) * (8 - c);
                    return b = 11 - b % 11, 10 === b && (b = 0), 11 === b && (b = 1), b = [8, 7, 6, 5, 4, 3, 2, 1, 0, 9, 10][b - 1], b + "" === a.substr(8, 1)
                }
                if (9 === a.length || 10 === a.length) {
                    var d = 1900 + parseInt(a.substr(0, 2), 10),
                        e = parseInt(a.substr(2, 2), 10) % 50 % 20,
                        f = parseInt(a.substr(4, 2), 10);
                    if (9 === a.length) {
                        if (d >= 1980 && (d -= 100), d > 1953) return !1
                    } else 1954 > d && (d += 100);
                    if (!FormValidation.Helper.date(d, e, f)) return !1;
                    if (10 === a.length) {
                        var g = parseInt(a.substr(0, 9), 10) % 11;
                        return 1985 > d && (g %= 10), g + "" === a.substr(9, 1)
                    }
                    return !0
                }
                return !1
            },
            _de: function(a) {
                return /^DE[0-9]{9}$/.test(a) && (a = a.substr(2)), /^[0-9]{9}$/.test(a) ? FormValidation.Helper.mod11And10(a) : !1
            },
            _dk: function(a) {
                if (/^DK[0-9]{8}$/.test(a) && (a = a.substr(2)), !/^[0-9]{8}$/.test(a)) return !1;
                for (var b = 0, c = [2, 7, 6, 5, 4, 3, 2, 1], d = 0; 8 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b % 11 === 0
            },
            _ee: function(a) {
                if (/^EE[0-9]{9}$/.test(a) && (a = a.substr(2)), !/^[0-9]{9}$/.test(a)) return !1;
                for (var b = 0, c = [3, 7, 1, 3, 7, 1, 3, 7, 1], d = 0; 9 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b % 10 === 0
            },
            _es: function(a) {
                if (/^ES[0-9A-Z][0-9]{7}[0-9A-Z]$/.test(a) && (a = a.substr(2)), !/^[0-9A-Z][0-9]{7}[0-9A-Z]$/.test(a)) return !1;
                var b = function(a) {
                        var b = parseInt(a.substr(0, 8), 10);
                        return b = "TRWAGMYFPDXBNJZSQVHLCKE" [b % 23], b + "" === a.substr(8, 1)
                    },
                    c = function(a) {
                        var b = ["XYZ".indexOf(a.charAt(0)), a.substr(1)].join("");
                        return b = parseInt(b, 10), b = "TRWAGMYFPDXBNJZSQVHLCKE" [b % 23], b + "" === a.substr(8, 1)
                    },
                    d = function(a) {
                        var b, c = a.charAt(0);
                        if (-1 !== "KLM".indexOf(c)) return b = parseInt(a.substr(1, 8), 10), b = "TRWAGMYFPDXBNJZSQVHLCKE" [b % 23], b + "" === a.substr(8, 1);
                        if (-1 !== "ABCDEFGHJNPQRSUVW".indexOf(c)) {
                            for (var d = 0, e = [2, 1, 2, 1, 2, 1, 2], f = 0, g = 0; 7 > g; g++) f = parseInt(a.charAt(g + 1), 10) * e[g], f > 9 && (f = Math.floor(f / 10) + f % 10), d += f;
                            return d = 10 - d % 10, 10 === d && (d = 0), d + "" === a.substr(8, 1) || "JABCDEFGHI" [d] === a.substr(8, 1)
                        }
                        return !1
                    },
                    e = a.charAt(0);
                return /^[0-9]$/.test(e) ? {
                    valid: b(a),
                    type: "DNI"
                } : /^[XYZ]$/.test(e) ? {
                    valid: c(a),
                    type: "NIE"
                } : {
                    valid: d(a),
                    type: "CIF"
                }
            },
            _fi: function(a) {
                if (/^FI[0-9]{8}$/.test(a) && (a = a.substr(2)), !/^[0-9]{8}$/.test(a)) return !1;
                for (var b = 0, c = [7, 9, 10, 5, 8, 4, 2, 1], d = 0; 8 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b % 11 === 0
            },
            _fr: function(a) {
                if (/^FR[0-9A-Z]{2}[0-9]{9}$/.test(a) && (a = a.substr(2)), !/^[0-9A-Z]{2}[0-9]{9}$/.test(a)) return !1;
                if (!FormValidation.Helper.luhn(a.substr(2))) return !1;
                if (/^[0-9]{2}$/.test(a.substr(0, 2))) return a.substr(0, 2) === parseInt(a.substr(2) + "12", 10) % 97 + "";
                var b, c = "0123456789ABCDEFGHJKLMNPQRSTUVWXYZ";
                return b = /^[0-9]{1}$/.test(a.charAt(0)) ? 24 * c.indexOf(a.charAt(0)) + c.indexOf(a.charAt(1)) - 10 : 34 * c.indexOf(a.charAt(0)) + c.indexOf(a.charAt(1)) - 100, (parseInt(a.substr(2), 10) + 1 + Math.floor(b / 11)) % 11 === b % 11
            },
            _gb: function(a) {
                if ((/^GB[0-9]{9}$/.test(a) || /^GB[0-9]{12}$/.test(a) || /^GBGD[0-9]{3}$/.test(a) || /^GBHA[0-9]{3}$/.test(a) || /^GB(GD|HA)8888[0-9]{5}$/.test(a)) && (a = a.substr(2)), !(/^[0-9]{9}$/.test(a) || /^[0-9]{12}$/.test(a) || /^GD[0-9]{3}$/.test(a) || /^HA[0-9]{3}$/.test(a) || /^(GD|HA)8888[0-9]{5}$/.test(a))) return !1;
                var b = a.length;
                if (5 === b) {
                    var c = a.substr(0, 2),
                        d = parseInt(a.substr(2), 10);
                    return "GD" === c && 500 > d || "HA" === c && d >= 500
                }
                if (11 === b && ("GD8888" === a.substr(0, 6) || "HA8888" === a.substr(0, 6))) return "GD" === a.substr(0, 2) && parseInt(a.substr(6, 3), 10) >= 500 || "HA" === a.substr(0, 2) && parseInt(a.substr(6, 3), 10) < 500 ? !1 : parseInt(a.substr(6, 3), 10) % 97 === parseInt(a.substr(9, 2), 10);
                if (9 === b || 12 === b) {
                    for (var e = 0, f = [8, 7, 6, 5, 4, 3, 2, 10, 1], g = 0; 9 > g; g++) e += parseInt(a.charAt(g), 10) * f[g];
                    return e %= 97, parseInt(a.substr(0, 3), 10) >= 100 ? 0 === e || 42 === e || 55 === e : 0 === e
                }
                return !0
            },
            _gr: function(a) {
                if (/^(GR|EL)[0-9]{9}$/.test(a) && (a = a.substr(2)), !/^[0-9]{9}$/.test(a)) return !1;
                8 === a.length && (a = "0" + a);
                for (var b = 0, c = [256, 128, 64, 32, 16, 8, 4, 2], d = 0; 8 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b = b % 11 % 10, b + "" === a.substr(8, 1)
            },
            _el: function(a) {
                return this._gr(a)
            },
            _hu: function(a) {
                if (/^HU[0-9]{8}$/.test(a) && (a = a.substr(2)), !/^[0-9]{8}$/.test(a)) return !1;
                for (var b = 0, c = [9, 7, 3, 1, 9, 7, 3, 1], d = 0; 8 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b % 10 === 0
            },
            _hr: function(a) {
                return /^HR[0-9]{11}$/.test(a) && (a = a.substr(2)), /^[0-9]{11}$/.test(a) ? FormValidation.Helper.mod11And10(a) : !1
            },
            _ie: function(a) {
                if (/^IE[0-9]{1}[0-9A-Z\*\+]{1}[0-9]{5}[A-Z]{1,2}$/.test(a) && (a = a.substr(2)), !/^[0-9]{1}[0-9A-Z\*\+]{1}[0-9]{5}[A-Z]{1,2}$/.test(a)) return !1;
                var b = function(a) {
                    for (; a.length < 7;) a = "0" + a;
                    for (var b = "WABCDEFGHIJKLMNOPQRSTUV", c = 0, d = 0; 7 > d; d++) c += parseInt(a.charAt(d), 10) * (8 - d);
                    return c += 9 * b.indexOf(a.substr(7)), b[c % 23]
                };
                return /^[0-9]+$/.test(a.substr(0, 7)) ? a.charAt(7) === b(a.substr(0, 7) + a.substr(8) + "") : -1 !== "ABCDEFGHIJKLMNOPQRSTUVWXYZ+*".indexOf(a.charAt(1)) ? a.charAt(7) === b(a.substr(2, 5) + a.substr(0, 1) + "") : !0
            },
            _is: function(a) {
                return /^IS[0-9]{5,6}$/.test(a) && (a = a.substr(2)), /^[0-9]{5,6}$/.test(a)
            },
            _it: function(a) {
                if (/^IT[0-9]{11}$/.test(a) && (a = a.substr(2)), !/^[0-9]{11}$/.test(a)) return !1;
                if (0 === parseInt(a.substr(0, 7), 10)) return !1;
                var b = parseInt(a.substr(7, 3), 10);
                return 1 > b || b > 201 && 999 !== b && 888 !== b ? !1 : FormValidation.Helper.luhn(a)
            },
            _lt: function(a) {
                if (/^LT([0-9]{7}1[0-9]{1}|[0-9]{10}1[0-9]{1})$/.test(a) && (a = a.substr(2)), !/^([0-9]{7}1[0-9]{1}|[0-9]{10}1[0-9]{1})$/.test(a)) return !1;
                var b, c = a.length,
                    d = 0;
                for (b = 0; c - 1 > b; b++) d += parseInt(a.charAt(b), 10) * (1 + b % 9);
                var e = d % 11;
                if (10 === e)
                    for (d = 0, b = 0; c - 1 > b; b++) d += parseInt(a.charAt(b), 10) * (1 + (b + 2) % 9);
                return e = e % 11 % 10, e + "" === a.charAt(c - 1)
            },
            _lu: function(a) {
                return /^LU[0-9]{8}$/.test(a) && (a = a.substr(2)), /^[0-9]{8}$/.test(a) ? parseInt(a.substr(0, 6), 10) % 89 + "" === a.substr(6, 2) : !1
            },
            _lv: function(a) {
                if (/^LV[0-9]{11}$/.test(a) && (a = a.substr(2)), !/^[0-9]{11}$/.test(a)) return !1;
                var b, c = parseInt(a.charAt(0), 10),
                    d = 0,
                    e = [],
                    f = a.length;
                if (c > 3) {
                    for (d = 0, e = [9, 1, 4, 8, 3, 10, 2, 5, 7, 6, 1], b = 0; f > b; b++) d += parseInt(a.charAt(b), 10) * e[b];
                    return d %= 11, 3 === d
                }
                var g = parseInt(a.substr(0, 2), 10),
                    h = parseInt(a.substr(2, 2), 10),
                    i = parseInt(a.substr(4, 2), 10);
                if (i = i + 1800 + 100 * parseInt(a.charAt(6), 10), !FormValidation.Helper.date(i, h, g)) return !1;
                for (d = 0, e = [10, 5, 8, 4, 2, 1, 6, 3, 7, 9], b = 0; f - 1 > b; b++) d += parseInt(a.charAt(b), 10) * e[b];
                return d = (d + 1) % 11 % 10, d + "" === a.charAt(f - 1)
            },
            _mt: function(a) {
                if (/^MT[0-9]{8}$/.test(a) && (a = a.substr(2)), !/^[0-9]{8}$/.test(a)) return !1;
                for (var b = 0, c = [3, 4, 6, 7, 8, 9, 10, 1], d = 0; 8 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b % 37 === 0
            },
            _nl: function(a) {
                if (/^NL[0-9]{9}B[0-9]{2}$/.test(a) && (a = a.substr(2)), !/^[0-9]{9}B[0-9]{2}$/.test(a)) return !1;
                for (var b = 0, c = [9, 8, 7, 6, 5, 4, 3, 2], d = 0; 8 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b %= 11, b > 9 && (b = 0), b + "" === a.substr(8, 1)
            },
            _no: function(a) {
                if (/^NO[0-9]{9}$/.test(a) && (a = a.substr(2)), !/^[0-9]{9}$/.test(a)) return !1;
                for (var b = 0, c = [3, 2, 7, 6, 5, 4, 3, 2], d = 0; 8 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b = 11 - b % 11, 11 === b && (b = 0), b + "" === a.substr(8, 1)
            },
            _pl: function(a) {
                if (/^PL[0-9]{10}$/.test(a) && (a = a.substr(2)), !/^[0-9]{10}$/.test(a)) return !1;
                for (var b = 0, c = [6, 5, 7, 2, 3, 4, 5, 6, 7, -1], d = 0; 10 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b % 11 === 0
            },
            _pt: function(a) {
                if (/^PT[0-9]{9}$/.test(a) && (a = a.substr(2)), !/^[0-9]{9}$/.test(a)) return !1;
                for (var b = 0, c = [9, 8, 7, 6, 5, 4, 3, 2], d = 0; 8 > d; d++) b += parseInt(a.charAt(d), 10) * c[d];
                return b = 11 - b % 11, b > 9 && (b = 0), b + "" === a.substr(8, 1)
            },
            _ro: function(a) {
                if (/^RO[1-9][0-9]{1,9}$/.test(a) && (a = a.substr(2)), !/^[1-9][0-9]{1,9}$/.test(a)) return !1;
                for (var b = a.length, c = [7, 5, 3, 2, 1, 7, 5, 3, 2].slice(10 - b), d = 0, e = 0; b - 1 > e; e++) d += parseInt(a.charAt(e), 10) * c[e];
                return d = 10 * d % 11 % 10, d + "" === a.substr(b - 1, 1)
            },
            _ru: function(a) {
                if (/^RU([0-9]{10}|[0-9]{12})$/.test(a) && (a = a.substr(2)), !/^([0-9]{10}|[0-9]{12})$/.test(a)) return !1;
                var b = 0;
                if (10 === a.length) {
                    var c = 0,
                        d = [2, 4, 10, 3, 5, 9, 4, 6, 8, 0];
                    for (b = 0; 10 > b; b++) c += parseInt(a.charAt(b), 10) * d[b];
                    return c %= 11, c > 9 && (c %= 10), c + "" === a.substr(9, 1)
                }
                if (12 === a.length) {
                    var e = 0,
                        f = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8, 0],
                        g = 0,
                        h = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8, 0];
                    for (b = 0; 11 > b; b++) e += parseInt(a.charAt(b), 10) * f[b], g += parseInt(a.charAt(b), 10) * h[b];
                    return e %= 11, e > 9 && (e %= 10), g %= 11, g > 9 && (g %= 10), e + "" === a.substr(10, 1) && g + "" === a.substr(11, 1)
                }
                return !1
            },
            _rs: function(a) {
                if (/^RS[0-9]{9}$/.test(a) && (a = a.substr(2)), !/^[0-9]{9}$/.test(a)) return !1;
                for (var b = 10, c = 0, d = 0; 8 > d; d++) c = (parseInt(a.charAt(d), 10) + b) % 10, 0 === c && (c = 10), b = 2 * c % 11;
                return (b + parseInt(a.substr(8, 1), 10)) % 10 === 1
            },
            _se: function(a) {
                return /^SE[0-9]{10}01$/.test(a) && (a = a.substr(2)), /^[0-9]{10}01$/.test(a) ? (a = a.substr(0, 10), FormValidation.Helper.luhn(a)) : !1
            },
            _si: function(a) {
                var b = a.match(/^(SI)?([1-9][0-9]{7})$/);
                if (!b) return !1;
                b[1] && (a = a.substr(2));
                for (var c = 0, d = [8, 7, 6, 5, 4, 3, 2], e = 0; 7 > e; e++) c += parseInt(a.charAt(e), 10) * d[e];
                return c = 11 - c % 11, 10 === c && (c = 0), c + "" === a.substr(7, 1)
            },
            _sk: function(a) {
                return /^SK[1-9][0-9][(2-4)|(6-9)][0-9]{7}$/.test(a) && (a = a.substr(2)), /^[1-9][0-9][(2-4)|(6-9)][0-9]{7}$/.test(a) ? parseInt(a, 10) % 11 === 0 : !1
            },
            _ve: function(a) {
                if (/^VE[VEJPG][0-9]{9}$/.test(a) && (a = a.substr(2)), !/^[VEJPG][0-9]{9}$/.test(a)) return !1;
                for (var b = {
                    V: 4,
                    E: 8,
                    J: 12,
                    P: 16,
                    G: 20
                }, c = b[a.charAt(0)], d = [3, 2, 7, 6, 5, 4, 3, 2], e = 0; 8 > e; e++) c += parseInt(a.charAt(e + 1), 10) * d[e];
                return c = 11 - c % 11, (11 === c || 10 === c) && (c = 0), c + "" === a.substr(9, 1)
            },
            _za: function(a) {
                return /^ZA4[0-9]{9}$/.test(a) && (a = a.substr(2)), /^4[0-9]{9}$/.test(a)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                vin: {
                    "default": "Please enter a valid VIN number"
                }
            }
        }), FormValidation.Validator.vin = {
            validate: function(a, b, c, d) {
                var e = a.getFieldValue(b, d);
                if ("" === e) return !0;
                if (!/^[a-hj-npr-z0-9]{8}[0-9xX][a-hj-npr-z0-9]{8}$/i.test(e)) return !1;
                e = e.toUpperCase();
                for (var f = {
                    A: 1,
                    B: 2,
                    C: 3,
                    D: 4,
                    E: 5,
                    F: 6,
                    G: 7,
                    H: 8,
                    J: 1,
                    K: 2,
                    L: 3,
                    M: 4,
                    N: 5,
                    P: 7,
                    R: 9,
                    S: 2,
                    T: 3,
                    U: 4,
                    V: 5,
                    W: 6,
                    X: 7,
                    Y: 8,
                    Z: 9,
                    1: 1,
                    2: 2,
                    3: 3,
                    4: 4,
                    5: 5,
                    6: 6,
                    7: 7,
                    8: 8,
                    9: 9,
                    0: 0
                }, g = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2], h = 0, i = e.length, j = 0; i > j; j++) h += f[e.charAt(j) + ""] * g[j];
                var k = h % 11;
                return 10 === k && (k = "X"), k + "" === e.charAt(8)
            }
        }
    }(jQuery),
    function(a) {
        FormValidation.I18n = a.extend(!0, FormValidation.I18n || {}, {
            en_US: {
                zipCode: {
                    "default": "Please enter a valid postal code",
                    country: "Please enter a valid postal code in %s",
                    countries: {
                        AT: "Austria",
                        BG: "Bulgaria",
                        BR: "Brazil",
                        CA: "Canada",
                        CH: "Switzerland",
                        CZ: "Czech Republic",
                        DE: "Germany",
                        DK: "Denmark",
                        ES: "Spain",
                        FR: "France",
                        GB: "United Kingdom",
                        IE: "Ireland",
                        IN: "India",
                        IT: "Italy",
                        MA: "Morocco",
                        NL: "Netherlands",
                        PL: "Poland",
                        PT: "Portugal",
                        RO: "Romania",
                        RU: "Russia",
                        SE: "Sweden",
                        SG: "Singapore",
                        SK: "Slovakia",
                        US: "USA"
                    }
                }
            }
        }), FormValidation.Validator.zipCode = {
            html5Attributes: {
                message: "message",
                country: "country"
            },
            COUNTRY_CODES: ["AT", "BG", "BR", "CA", "CH", "CZ", "DE", "DK", "ES", "FR", "GB", "IE", "IN", "IT", "MA", "NL", "PL", "PT", "RO", "RU", "SE", "SG", "SK", "US"],
            validate: function(b, c, d, e) {
                var f = b.getFieldValue(c, e);
                if ("" === f || !d.country) return !0;
                var g = b.getLocale(),
                    h = d.country;
                if (("string" != typeof h || -1 === a.inArray(h, this.COUNTRY_CODES)) && (h = b.getDynamicOption(c, h)), !h || -1 === a.inArray(h.toUpperCase(), this.COUNTRY_CODES)) return !0;
                var i = !1;
                switch (h = h.toUpperCase()) {
                    case "AT":
                        i = /^([1-9]{1})(\d{3})$/.test(f);
                        break;
                    case "BG":
                        i = /^([1-9]{1}[0-9]{3})$/.test(a.trim(f));
                        break;
                    case "BR":
                        i = /^(\d{2})([\.]?)(\d{3})([\-]?)(\d{3})$/.test(f);
                        break;
                    case "CA":
                        i = /^(?:A|B|C|E|G|H|J|K|L|M|N|P|R|S|T|V|X|Y){1}[0-9]{1}(?:A|B|C|E|G|H|J|K|L|M|N|P|R|S|T|V|W|X|Y|Z){1}\s?[0-9]{1}(?:A|B|C|E|G|H|J|K|L|M|N|P|R|S|T|V|W|X|Y|Z){1}[0-9]{1}$/i.test(f);
                        break;
                    case "CH":
                        i = /^([1-9]{1})(\d{3})$/.test(f);
                        break;
                    case "CZ":
                        i = /^(\d{3})([ ]?)(\d{2})$/.test(f);
                        break;
                    case "DE":
                        i = /^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/.test(f);
                        break;
                    case "DK":
                        i = /^(DK(-|\s)?)?\d{4}$/i.test(f);
                        break;
                    case "ES":
                        i = /^(?:0[1-9]|[1-4][0-9]|5[0-2])\d{3}$/.test(f);
                        break;
                    case "FR":
                        i = /^[0-9]{5}$/i.test(f);
                        break;
                    case "GB":
                        i = this._gb(f);
                        break;
                    case "IN":
                        i = /^\d{3}\s?\d{3}$/.test(f);
                        break;
                    case "IE":
                        i = /^(D6W|[ACDEFHKNPRTVWXY]\d{2})\s[0-9ACDEFHKNPRTVWXY]{4}$/.test(f);
                        break;
                    case "IT":
                        i = /^(I-|IT-)?\d{5}$/i.test(f);
                        break;
                    case "MA":
                        i = /^[1-9][0-9]{4}$/i.test(f);
                        break;
                    case "NL":
                        i = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i.test(f);
                        break;
                    case "PL":
                        i = /^[0-9]{2}\-[0-9]{3}$/.test(f);
                        break;
                    case "PT":
                        i = /^[1-9]\d{3}-\d{3}$/.test(f);
                        break;
                    case "RO":
                        i = /^(0[1-8]{1}|[1-9]{1}[0-5]{1})?[0-9]{4}$/i.test(f);
                        break;
                    case "RU":
                        i = /^[0-9]{6}$/i.test(f);
                        break;
                    case "SE":
                        i = /^(S-)?\d{3}\s?\d{2}$/i.test(f);
                        break;
                    case "SG":
                        i = /^([0][1-9]|[1-6][0-9]|[7]([0-3]|[5-9])|[8][0-2])(\d{4})$/i.test(f);
                        break;
                    case "SK":
                        i = /^(\d{3})([ ]?)(\d{2})$/.test(f);
                        break;
                    case "US":
                    default:
                        i = /^\d{4,5}([\-]?\d{4})?$/.test(f)
                }
                return {
                    valid: i,
                    message: FormValidation.Helper.format(d.message || FormValidation.I18n[g].zipCode.country, FormValidation.I18n[g].zipCode.countries[h])
                }
            },
            _gb: function(a) {
                for (var b = "[ABCDEFGHIJKLMNOPRSTUWYZ]", c = "[ABCDEFGHKLMNOPQRSTUVWXY]", d = "[ABCDEFGHJKPMNRSTUVWXY]", e = "[ABEHMNPRVWXY]", f = "[ABDEFGHJLNPQRSTUWXYZ]", g = [new RegExp("^(" + b + "{1}" + c + "?[0-9]{1,2})(\\s*)([0-9]{1}" + f + "{2})$", "i"), new RegExp("^(" + b + "{1}[0-9]{1}" + d + "{1})(\\s*)([0-9]{1}" + f + "{2})$", "i"), new RegExp("^(" + b + "{1}" + c + "{1}?[0-9]{1}" + e + "{1})(\\s*)([0-9]{1}" + f + "{2})$", "i"), new RegExp("^(BF1)(\\s*)([0-6]{1}[ABDEFGHJLNPQRST]{1}[ABDEFGHJLNPQRSTUWZYZ]{1})$", "i"), /^(GIR)(\s*)(0AA)$/i, /^(BFPO)(\s*)([0-9]{1,4})$/i, /^(BFPO)(\s*)(c\/o\s*[0-9]{1,3})$/i, /^([A-Z]{4})(\s*)(1ZZ)$/i, /^(AI-2640)$/i], h = 0; h < g.length; h++)
                    if (g[h].test(a)) return !0;
                return !1
            }
        }
    }(jQuery);
/*!
 * FormValidation (http://formvalidation.io)
 * The best jQuery plugin to validate form fields. Support Bootstrap, Foundation, Pure, SemanticUI, UIKit and custom frameworks
 *
 * @version     v0.7.0, built on 2015-08-01 4:57:17 PM
 * @author      https://twitter.com/formvalidation
 * @copyright   (c) 2013 - 2015 Nguyen Huu Phuoc
 * @license     http://formvalidation.io/license/
 */
/**
 * This class supports validating Pure framework (http://purecss.io/)
 */
(function($) {
    FormValidation.Framework.Pure = function(element, options) {
        options = $.extend(true, {
            button: {
                selector: '[type="submit"]:not([formnovalidate])',
                // The class of disabled button
                // http://purecss.io/buttons/#disabled-buttons
                disabled: 'pure-button-disabled'
            },
            err: {
                clazz: 'fv-help-block',
                parent: '^.*pure-control-group.*$'
            },
            // Pure doesn't support feedback icon
            icon: {
                valid: null,
                invalid: null,
                validating: null,
                feedback: 'fv-control-feedback'
            },
            row: {
                // http://purecss.io/forms/#aligned-form
                selector: '.pure-control-group',
                valid: 'fv-has-success',
                invalid: 'fv-has-error',
                feedback: 'fv-has-feedback'
            }
        }, options);

        FormValidation.Base.apply(this, [element, options]);
    };

    FormValidation.Framework.Pure.prototype = $.extend({}, FormValidation.Base.prototype, {
        /**
         * Specific framework might need to adjust the icon position
         *
         * @param {jQuery} $field The field element
         * @param {jQuery} $icon The icon element
         */
        _fixIcon: function($field, $icon) {
            var ns      = this._namespace,
                type    = $field.attr('type'),
                field   = $field.attr('data-' + ns + '-field'),
                row     = this.options.fields[field].row || this.options.row.selector,
                $parent = $field.closest(row);

            if ($parent.find('label').length === 0) {
                $icon.addClass('fv-icon-no-label');
            }
        }
    });
}(jQuery));

var Justselling360 = {
    currentFrame: 0,
    autorotate: false,
    initLoadImage: false,
    newScope: true,
    showInOverlay: false,
    cssShowInOverlay: '',
    customOverlayContainer: false,
    turnOffShowOnlyOneFrame: false,
    clickRotate: false,
    stopLoading: false,

    setStopLoading: function(stop) {
        this.stopLoading = stop;
    },

    getStopLoading: function() {
        return this.stopLoading;
    },

    setClickRotate: function(setRotate) {
        this.clickRotate = setRotate;
    },

    getClickRotate: function() {
        return this.clickRotate;
    },

    setTurnOffShowOnlyOneFrame: function(state) {
        this.turnOffShowOnlyOneFrame = state;
    },

    getTurnOffShowOnlyOneFrame: function() {
        return this.turnOffShowOnlyOneFrame;
    },

    setCustomOverlayContainer: function(selector) {
        this.customOverlayContainer = selector;
    },

    getCustomOverlayContainer: function() {
        return this.customOverlayContainer;
    },

    setNewScope: function (scope) {
        this.newScope = scope;
    },

    getNewScope: function () {
        return this.newScope;
    },

    setInitLoadImage: function (img) {
        this.initLoadImage = img;
    },

    getInitLoadImage: function () {
        return this.initLoadImage;
    },

    setCurrentFrame: function (frame) {
        this.currentFrame = frame;
    },

    getCurrentFrame: function () {
        return this.currentFrame;
    },


    setAutorotate: function (frame) {
        this.autorotate = frame;
    },

    getAutorotate: function () {
        return this.autorotate;
    },

    isTouchDevice: function () {
        return 'ontouchstart' in window || 'onmsgesturechange' in window;
    },

    showInOverlayView: function() {
        if (Justselling360.getCustomOverlayContainer()) {
            jQuery('.justselling360combinedimage').appendTo(Justselling360.getCustomOverlayContainer());
        } else {
            jQuery('.canvas360InnerWrapper').appendTo(".show-in-overlay-360");
        }
    },

    restoreToDefaultView: function() {
        if (Justselling360.getCustomOverlayContainer()) {
            jQuery('.justselling360combinedimage').appendTo('.combined-image-container');
        } else {
            jQuery('.canvas360InnerWrapper').appendTo(".hold-temp-conf");
        }
    },

    setShowInOverlay: function (flag) {
        this.showInOverlay = flag;
    },

    getShowInOverlay: function () {
        return this.showInOverlay;
    },

    getCurrentImageStack: function () {
        var images = [];
        var options = Justselling_Configento_App_Helper.getConfigurator().getOptions();
        if (options) {
            for (var i = 0; i < options.length; i++) {
                var option = options[i];
                var choices;
                if (choices = option.getActiveChoice()) {
                    if(!_.isArray(choices)) {
                        choices = [choices];
                    }
                    _.each(choices, function (choice) {
                        if (Justselling_Configento_App_Helper.getBlacklistCombinedImages().indexOf(choice.originalValue) < 0) {
                            if (choice.getImage()) {
                                images.push({
                                    'id': option.getId(),
                                    'image': choice.getImage(),
                                    'choiceId': option.getId(),
                                    'optionInternalId': option.getInternalId(),
                                    'internalId': choice.getInternalId(),
                                    'top': choice.getImageTop(),
                                    'left': choice.getImageLeft(),
                                    'width': choice.getImageWidth(),
                                    'height': choice.getImageHeight()
                                });
                            }
                        }
                    });
                }
            }
        }

        return images;
    },

    activateLoader: function (color, animationSettings) {
        /* for any case, so we will see loader... */
        //jQuery('.justselling360combinedimage .part-element-360-rotate').css({'opacity': '0'});
        var galleryClass = Justselling_Configento_App_Helper.getGalleryClass();
        jQuery(galleryClass+' img').css({'opacity': '0'});
        if (jQuery('.loader360').length == 0) {
            var style = '';
            if (color) {
                style = 'style="border-top-color: '+color+'";';
            }
            if (jQuery('.canvas360Wrapper').length == 0) {
                jQuery(galleryClass)
                    .css('min-height', Justselling_Configento_App_Helper.getImageContainer360Size().height+'px')
                    .css('min-width', Justselling_Configento_App_Helper.getImageContainer360Size().width+'px')
                    .prepend('<div '+style+' class="loader360"></div>');
                if (animationSettings >= 2) {
                    jQuery('.rotate-3d-indicator').append('<div class="percent"></div>');
                }
            } else {
                jQuery('.canvas360Wrapper').prepend('<div '+style+' class="loader360"></div>');
                if (animationSettings >= 2) {
                    jQuery('.rotate-3d-indicator').append('<div class="percent"></div>');
                }
            }
        }
    },

    setCssShowInOverlay: function (css) {
        this.cssShowInOverlay = css;
    },

    getCssShowInOverlay: function () {
        return this.cssShowInOverlay;
    }
};

/**
 * Filename: canvas360.js
 *
 * Creates a 360 view using an array of images using a canvas element.
 */

function canvas360(params) {

    params = params || {};

    /**
     *
     * @type {Array}
     */
    params.images = params.images || [];

    params.maxImagesPerSet = params.maxImagesPerSet || 10;

    params.currentFrame = params.currentFrame || 0;

    params.autorotate = params.autorotate || false;

    /**
     * we can set settings for animation (turn on / off / combination)
     * @type {number}
     */
    params.animationSettings = params.animationSettings || 1;

    params.loadingAnimationColor = params.loadingAnimationColor || '#3498db';

    params.sequences360 = params.sequences360 || '';

    params.sequences360IconAfter = params.sequences360IconAfter || '';

    /**
     * if we have set in template start point than if car is not jet rotated, make this start point
     *
     */
    if (params.sequences360 > 0) {
        if (params.currentFrame == 0) {
            params.currentFrame = params.sequences360;
        }
    }

    /**
     *  Canvas ID should match the ID or class of the div where the canvas will be added.
     */
    params.canvasId = params.canvasId || false;
    /**
     *  canvasWidth is the width of the canvas element.
     */
    params.canvasWidth = params.canvasWidth || '100%';
    /**
     *  canvasHeight is the height of the canvas element.
     */
    params.canvasHeight = params.canvasHeight || '100%';
    /**
     *  framesPath is the location where the frames can be found.
     */
    params.framesPath = params.framesPath || 'img/360/';
    /**
     *  framesFile is the filenames array.
     */
    params.framesFile = params.framesFile || '';
    /**
     *  framesCount is the number of frames that will exist.
     */
    params.framesCount = params.framesCount || 48;
    /**
     *  Do we need to reverse the frame order?
     */
    params.framesReverse = params.framesReverse || false;
    /**
     *  logoImagePath is the url of the logo which will show up during loading.
     */
    params.logoImagePath = params.logoImagePath || 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHwAAAAXCAMAAAD+89sVAAAA2FBMVEUAAAD///////////////////z///////////////////////////////////////3//////////fj//////////////vn//////vf/////////++z//////////////////////////////////////////////////////////////////v7////////////////+3Vv9zwr////90SL+56391Db92FP+9NT++On8ywD+7a7+44H90y7+5ZT+44f+6Lv+4XD////9zhr8ygD9zRT8zA391CndTDoyAAAAQnRSTlMAPdnwKAxHHzIEQ51QTS83mBAVVKpXGiQIw70BekrTavdczciQfrCKYIFxhKW3ZOIrr8/rui6zkayn7q6hxG5jgKx0TLk6AAADaklEQVRIx8WU55KiQBCAG5YkUTIo4IquskY2XM6z6L3/G90Ey8F1rup+3X5VCjTNfDM9AZLUHQMjVdwMCGNpV9yvbP0UbvUTaQoYtW0TUFKd49LMd98/PD+///AjAELg6m0GDF0xfBCBEDL5bYMvd+jMzGBhzpMOS3yZoksAHn533fHl5dB13eEnAGxJOAXKLUJDgZq+8LjcBh0RbupcpjcLgNceGyE5vowtEmpmHI7d7zFYLJlSIbQWym8QMri8papiAARlj++3JMMCPwgC3y9xYC7hP1WytbIsNTUk+ZXXdS99uhdcP26vEbr/m1zlRQgi/AGfnyHx5Lg3cMLDvbFpm4yAVef55Ob2HzvE7biId2QpDU6whcXk1SLHbEc41SHzebkirKjXb3wfaVy+RJgVqN3hrD0cjkc8748TnOkj+WYJALuhVYSa6WiM0jQ1p5SovA+ZqQygP/SadCqXMVVFUhTpLN+TZxev8+OBTjXl8+Pjt4eH7461nQM8jdAIYCYo+3hwkuN603+xPEd9hrA7yYNzWd8x6bf3D1+/fPy0GdXV7eKOvlvSLypadvGcp3zOyXyG12WX74d0AclOArBiSrrbIiBkv6g0n8m35006YVkFvmh4CMu/yrkpWOA/shT4nPq47AV7zdYmaxZH+Sa9R6+RGiaHDXuei+UX+1yhihWrfFqTIZAMdkTQRtkhBBEaRZad2nEYhrHZvHbf0n4DYfbPcgfay0Mm759PNzQjlEcrU45mT9y1h0v3E9BDhn8lkIuP1zVvpPZYeHvOqJFETprl1fG66nWlBDYtwGCLQ4QimQNgeJLJzpukmUeRtTJY2DWMbAwDKYyLFPzYDjTT9SXP4Eg00w/XVrRZl6w53SRRhmmYiVBOUsdjEKD6KsvwE7eMp7HCHiHz8QvhByAOs10tguz+QhG8mEzMcAeZq8V2bLu9tua2t3PgmmJlOJPsOt6sATamUL5PPL0yruPlEFQ9r2JbauGCZOsGlmj9jCZ6nItGaE2LJQipXdPdpNfxzVAJXU+GKwJLc+/WIkfROmtd5KiGIKYiW1G6jPnStJnsyySJBCXRayXwqkww8saHKBRO7Q7EtOSX9cSKHcYhGcBUa4RrVIqdqSieTJ1GETr0AP6BwLAdR8rgTZgUtg9vhTM1VPh//AHAidcBf3YHngAAAABJRU5ErkJggg==';
    /**
     *  loaderBarColor should be an HTML color code matching the color you wish
     *  to be used to frame in the progress bar when loading images and data.
     */
    params.loaderBarColor = params.loaderBarColor || '#ffffff';
    /**
     *  loaderFillColor should be an HTML color code matching the color you
     *  wish to be used to fill the progress bar.
     */
    params.loaderFillColor = params.loaderFillColor || '#fecd18';
    /**
     *  loaderFillGradient set's canvas360 to use a gradient fill on the progress bar.
     *  If false it will use loaderFillColor. If true it will draw a gradient from
     *  loaderFillColor to loaderFillColor2.
     */
    params.loaderFillGradient = params.loaderFillGradient || false;
    /**
     *  loaderFillColor2 is the second color for the progressbar if loaderFillGradient
     *  is set to true.
     */
    params.loaderFillColor2 = params.loaderFillColor2 || '#ffffff';

    /**
     * if we want to add background in our element, transparent png
     * @type {boolean}
     */
    params.background = params.background || false;

    /**
     * we can turn on parent (wrapper) CSS of canvas
     * @type {boolean}
     */
    params.wrapperCSS = params.wrapperCSS || false;

    var frameImages = [];

    var strokeX = 0;
    var strokeY = 0;
    var strokeWidth = 0;
    var strokeHeight = 15;
    var loadPercent = 0;
    var curFrame = params.currentFrame;
    var frameCount = 0;
    var animDirection = 0;
    var countFrames = 0;
    var animatingFrames = false;

    var imagePositionX = 0;
    var imagePositionY = 0;

    //***** Swipe Detection Code

    var HORIZONTAL = 1;
    var VERTICAL = 2;
    var AXIS_THRESHOLD = 30;
    var GESTURE_DELTA = 50;

    var direction = HORIZONTAL;

    /** Extend the window with a custom function that works off of either the
     * new requestAnimationFrame functionality which is available in many modern
     * browsers or utilizes the setTimeout function where not available.
     */

    window.requestAnimFrame = (function() {
        return window.requestAnimationFrame || // Chromium
            window.webkitRequestAnimationFrame || // WebKit
            window.mozRequestAnimationFrame || // Mozilla
            window.oRequestAnimationFrame || // Opera
            window.msRequestAnimationFrame || // IE
            function(callback, element) {
                window.setTimeout(callback, 17);
            };
    })();

    var onswiperight = function(delta) {
        deltaDif = Math.ceil(delta / (GESTURE_DELTA / 2));
        countFrames += deltaDif;
        animDirection = 1;
        if (!animatingFrames) {
            animatingFrames = true;
            animateFrames();
        }
    }
    var onswipeleft = function(delta) {
        deltaDif = deltaDif = Math.ceil(delta / (GESTURE_DELTA / 2));
        countFrames += deltaDif;
        animDirection = 2;
        countFrames += deltaDif;

        if (!animatingFrames) {
            animatingFrames = true;
            animateFrames();
        }
    }

    window.inGesturex = false; // use global var, sometimes it not

    var _originalX = 0;
    var _originalY = 0;

    /**
     * enable rotate on click by frames...
     * half rotate left, when we click on other half rotate right
     * @param event
     */
    var mouseclick = function (event) {
        if(Justselling360.getClickRotate()) {
            var increment = Justselling360.getClickRotate();
            if(!jQuery.isNumeric(increment)) {
                increment = 1;
            }
            var windowWidth = jQuery(window).width();
            var half = windowWidth / 2;
            if (half < event.pageX) {
                curFrame=curFrame-increment;
            }

            if (half > event.pageX) {
                curFrame=curFrame+increment;
            }

            if (curFrame < 0) {
                curFrame = params.framesCount - 1;
            }
            if (curFrame > (params.framesCount - 1)) {
                curFrame = 0;
            }

            jQuery('.justselling360combinedimage .part-element-360-rotate').css({'opacity': '0'});
            jQuery('#rotate360part' + curFrame).css({'opacity': '1'});
            jQuery('.canvas360InnerWrapper').show();
            Justselling360.setCurrentFrame(curFrame);
        }
    };

    var mousedown = function(event) {
        if((/Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) && Justselling360.isTouchDevice() ) {
            // allow to scroll downl
        } else {
            event.preventDefault();
        }
        clearInterval(makeRotate);
       // Justselling360.setAutorotate(true);
        window.inGesturex = true;
        _originalX = (event.touches) ? event.touches[0].pageX : event.pageX;
        _originalY = (event.touches) ? event.touches[0].pageY : event.pageY;

        // Only iphone
        if (event.touches && event.touches.length != 1) {
            window.inGesturex = false;
        }

        if ((event.which != 1) && (!Justselling360.isTouchDevice())) { // only on left click
            window.inGesturex = false;
        }
    }
    var mouseup = function() {
        window.inGesturex = false;
    }
    var mousemove = function(event) {
        if((/Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) && Justselling360.isTouchDevice() ) {
            // allow to scroll downl
        } else {
            event.preventDefault();
        }
        var delta = 0;
        var currentX = (event.touches) ? event.touches[0].pageX : event.pageX;
        var currentY = (event.touches) ? event.touches[0].pageY : event.pageY;

        if (window.inGesturex) {

            if (direction == HORIZONTAL) {
                delta = Math.abs(currentY - _originalY);
            } else {
                delta = Math.abs(currentX - _originalX);
            }
            if (delta > AXIS_THRESHOLD) {
                //inGesture = false;
            }
        }

        if (window.inGesturex) {
            if (direction == HORIZONTAL && !params.framesReverse) {
                delta = Math.abs(currentX - _originalX);
                if (currentX > _originalX) {
                    vDirection = 0;
                } else {
                    vDirection = 1;
                }
            } else if (direction == HORIZONTAL && params.framesReverse) {
                delta = Math.abs(currentX - _originalX);
                if (currentX < _originalX) {
                    vDirection = 0;
                } else {
                    vDirection = 1;
                }
            }else{
                delta = Math.abs(currentY - _originalY);
                if (currentY > _originalY) {
                    vDirection = 2;
                } else {
                    vDirection = 3;
                }
            }

            if (delta >= GESTURE_DELTA) {

                var handler = null;
                switch(vDirection) {
                    case 0:
                        handler = onswipeleft;
                        break;
                    case 1:
                        handler = onswiperight;
                        break;
                }
                if (handler != null) {
                    handler(delta);
                }
                _originalX = (event.touches) ? event.touches[0].pageX : event.pageX;
                _originalY = (event.touches) ? event.touches[0].pageY : event.pageY;
                //inGesture = false;
            }
        }
    }
    //***** End swipe detection Code

    var canvas = null;
    var context = null;

    var self = this;

    var number_format = function(number, decimals) {

        number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
        var n = !isFinite(+number) ? 0 : +number, prec = !isFinite(+decimals) ? 0 : Math.abs(decimals), sep = ( typeof thousands_sep === 'undefined') ? ',' : thousands_sep, dec = ( typeof dec_point === 'undefined') ? '.' : dec_point, s = '', toFixedFix = function(n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        s = ( prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec);
    }

    startPreload = function() {
        if (Justselling_Configento_App_Helper.getSequences360TextLoading()) {
            jQuery('.rotate-3d-indicator svg').css({'opacity': '0.2'});
            jQuery('.rotation-text').html(Justselling_Configento_App_Helper.getSequences360TextLoading());
        } else {
            jQuery('.rotate-3d-indicator').remove();
        }


        if (Justselling360.getTurnOffShowOnlyOneFrame()) {
            // normal all loading will be used!
        } else {
            showOnlyOneFrame();
        }


        if (jQuery('.loader360').length == 0) {
            if (params.animationSettings != 0) {
                jQuery('.canvas360Wrapper')
                    .css('min-height', Justselling_Configento_App_Helper.getImageContainer360Size().height+'px')
                    .css('min-width', Justselling_Configento_App_Helper.getImageContainer360Size().width+'px');
                if (params.animationSettings != 3) {
                    jQuery('.canvas360Wrapper').prepend('<div class="loader360"></div>');
                }
                if (params.animationSettings >= 2) {
                    jQuery('.canvas360Wrapper').prepend('<div class="percent"></div>');
                }
                jQuery('.loader360').show();
            }

            if (params.loadingAnimationColor) {
                jQuery('.loader360').css({'border-top-color': params.loadingAnimationColor});
            }
        }
        if (Justselling_Configento_App_Helper.getOptionScopeDidChange()) {
            return false;
        }

        /* here we set first set of images, something like base */
        for ( i = 0; i < params.framesCount; i++) {
            frameImages[i] = new Image();
            frameImages[i].src = params.images[i];
        }
        var loader = 0;
        var percent = 100 / params.images.length;
        var layersContainer = [];
        /*(function (ondone) {
            var index = 0;
            nextStep();

            function nextStep() {
                if (index >= params.images.length) {
                    if (ondone)
                        ondone();
                    return;
                }

                var i = index++;
                var image = new Image();

                // todo: this is working, but we need to optimize to work on first image load | speed optimization needed
                /!*image.onChangeSize = function(loaded, total) {
                    var _l = parseInt((loaded / total) * 100);
                    jQuery('.percent').html(index+' / '+params.images.length+' | ' + _l+'  %');
                };*!/

                loader = parseFloat(loader) + parseFloat(percent);
                if (loader > 100) {
                    loader = 100;
                }
                //jQuery('.percent').html(Math.ceil(loader) + '%');
                //image.src = params.images[i];
                //image.load(params.images[i]);
                jQuery('.percent').html(Math.ceil(loader) + '%');
                image.src = params.images[i];
                image.onload = function () {
                    /!* when image is loaded, call itself again, until load all images *!/
                    nextStep();
                    console.log('ucitavam...', 1);
                };
                layersContainer.push(image);
            }
        })(function () {
            if (!Justselling_Configento_App_Helper.getOptionScopeDidChange()) {
                console.log('ucitano...', 3, layersContainer);
                console.log('def->', params.images);
                createRotateWithDivs(layersContainer);
                jQuery('#rotate360part' + curFrame + ', #rotate360part' + curFrame + ' img').css({'opacity': '1'});
                jQuery('.canvas360InnerWrapper').show();
                jQuery('.percent').hide();
            }
        });*/

        //console.log('def->', params.images);
        createRotateWithDivs(params.images);
        //jQuery('#rotate360part' + curFrame + ', #rotate360part' + curFrame + ' img').css({'opacity': '1'});
        jQuery('.canvas360InnerWrapper').show();
        jQuery('.percent').hide();

    };

    var create3Dicon = function (loadDone) {
        if (jQuery('.rotate-3d-indicator').length == 0) {
            var sequences360IconAfter = '.canvas360Wrapper';
            if (params.sequences360IconAfter) {
                sequences360IconAfter = params.sequences360IconAfter;
            }
            var cssIcon = '';
            var cssText = '';
            if (Justselling_Configento_App_Helper.getSequences360IconCSS()) {
                cssIcon = Justselling_Configento_App_Helper.getSequences360IconCSS();
                cssText = Justselling_Configento_App_Helper.getSequences360TextCSS();
            }

            jQuery(sequences360IconAfter).after('<div class="rotate-3d-indicator"><svg '+cssIcon+' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.52 21.48C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32zm.89-6.52c-.19 0-.37-.03-.52-.08-.16-.06-.29-.13-.4-.24-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72c.13-.29.2-.61.2-.97 0-.19-.02-.38-.07-.56-.05-.18-.12-.35-.23-.51-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31.2-.09.37-.2.52-.33.15-.13.27-.27.37-.42.1-.15.17-.3.22-.46.05-.16.07-.32.07-.48 0-.36-.06-.68-.18-.96-.12-.28-.29-.51-.51-.69-.2-.19-.47-.33-.77-.43C9.1 8.05 8.76 8 8.39 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34c.11-.09.23-.17.38-.22.15-.05.3-.08.48-.08.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49-.05.15-.14.27-.25.37-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09H7.5v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4.07.16.1.35.1.57 0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm8.55-5.92c-.32-.33-.7-.59-1.14-.77-.43-.18-.92-.27-1.46-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27.45-.18.84-.43 1.16-.76.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57-.18-.47-.43-.87-.75-1.2zm-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zM12 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.44 4.84 18.29 0 12 0z"/></svg>' +
                '<div class="rotation-text" '+cssText+'>'+Justselling_Configento_App_Helper.getSequences360TextLoading()+'</div></div>');
            jQuery('.rotate-3d-indicator svg').css({'opacity': '0.2'});

            if (params.animationSettings >= 2) {
                jQuery('.rotate-3d-indicator').append('<div class="percent"></div>');
            }
        } else {
            if (loadDone) {
                jQuery('.rotate-3d-indicator svg').css({'opacity': '1'});
                jQuery('.rotation-text').html(Justselling_Configento_App_Helper.getSequences360TextFinish());
            } else {
                jQuery('.rotate-3d-indicator svg').css({'opacity': '0.2'});
            }

        }
    };


    var animateFrames = function() {
        if (animDirection == 1) {
            curFrame++;
        }

        if (animDirection == 2) {
            curFrame--;
        }



        frameCount++;
        if (curFrame < 0) {
            curFrame = params.framesCount - 1;
        }
        if (curFrame > (params.framesCount - 1)) {
            curFrame = 0;
        }

        /* prevent to car rotate after we live mouse press... */
        if (window.inGesturex) {
            jQuery('.justselling360combinedimage .part-element-360-rotate').css({'opacity': '0'});
            jQuery('#rotate360part' + curFrame).css({'opacity': '1'});
            jQuery('.canvas360InnerWrapper').show();
            //jQuery('#rotate360part'+curFrame+', #rotate360part'+curFrame+' img').show();
            Justselling360.setCurrentFrame(curFrame);
        }


        /* uncomment this if you want old logic */
        //drawFrame();

        if (frameCount < countFrames) {

            requestAnimFrame(function() {
                animateFrames();
            });

        } else {
            animDirection = 0;
            countFrames = 0;
            frameCount = 0;
            animatingFrames = false;
        }

    }

    /**
     * This method will allow to show only one image in 2D state.
     * And will be later replaced with all 3D images, this is used so app is usable and customer can see results quick
     */
    var showOnlyOneFrame = function () {
        var collectImages = [];
        var numOfSet = params.images.length / params.maxImagesPerSet;
        if (params.images.length == 1) {
            collectImages.push(params.images[0]);
        } else {
            for (var j = 0; j < params.maxImagesPerSet; j++) {
                var index = (j * numOfSet) + parseInt(curFrame);
                /* check if we have maybe 2D image, in that case take first image */
                if (typeof params.images[index] === 'undefined') {
                    collectImages.push(params.images[0]);
                    curFrame = 0; // in this case we need to show first frame, it's only one image.
                } else {
                    collectImages.push(params.images[index]);
                }
            }
        }
        if (typeof collectImages[0] == 'undefined') {
            collectImages = params.images;
        }


        var loader = 0;
        var percent = 100 / collectImages.length;
        var layersContainer = [];
        /*(function (ondone) {
            var index = 0;
            nextStep();

            function nextStep() {
                if (index >= collectImages.length) {
                    if (ondone)
                        ondone();
                    return;
                }

                var i = index++;
                var image = new Image();

                loader = parseFloat(loader) + parseFloat(percent);
                if (loader > 100) {
                    loader = 100;
                }
                jQuery('.percent').html(Math.ceil(loader) + '%');
                image.src = collectImages[i];
                image.onload = function () {
                    /!* when image is loaded, call itself again, until load all images *!/
                    nextStep();
                };
                layersContainer.push(image);
            }
        })(function () {
            createRotateWithDivs(layersContainer, collectImages.length);
            //jQuery('#rotate360part'+curFrame+', #rotate360part'+curFrame+' img').show();
            //jQuery('.canvas360InnerWrapper').show();
        });*/
        createRotateWithDivs(collectImages, collectImages.length);

    };

    var imageHolder = null;
    var createRotateWithDivs = function (images, sequences360) {
        jQuery('.justselling360combinedimage').html('');
        var framesCountParam = parseFloat(params.framesCount);
        var maxImagesPerSetParam = params.maxImagesPerSet;
        Justselling360.activateLoader();
        /*if (sequences360) {
            framesCountParam = sequences360;
            maxImagesPerSetParam = 1;
            //jQuery('.rotate-3d-indicator').remove();
            if (params.framesCount != 1) {
                create3Dicon();
            } else {
                jQuery('.rotate-3d-indicator').remove();
            }
        } else {
            if (params.framesCount != 1) {
                create3Dicon('true');
            } else {
                jQuery('.rotate-3d-indicator').remove();
            }
        }*/
        if (sequences360) {
            framesCountParam = sequences360;
            maxImagesPerSetParam = 1;
            //jQuery('.rotate-3d-indicator').remove();
            if (params.framesCount != 1) {
                create3Dicon();
            } else {
                jQuery('.rotate-3d-indicator').remove();
            }
        }

        for (var j = 0; j < maxImagesPerSetParam; j++) {
            for (var i = 0; i < framesCountParam; i++) {
                var round = i;
                round = i+framesCountParam*j;

                /* webP structure */
                var pictureElement = document.createElement('picture');
                var sourceWebp = document.createElement('source');
                var sourcePng = document.createElement('source');

                sourcePng.type = 'image/png';
                sourcePng.srcset = images[round];

                sourceWebp.type = 'image/webp';
                sourceWebp.srcset = images[round].replace(".png", ".webp");


                var currentImage = document.createElement('img');
                currentImage.src = images[round];
                //var currentImage = images[round];
                var cWidth = params.canvasWidth;
                var cHeight = params.canvasHeight;
                if (params.canvasWidth != '100%') {
                    cWidth = params.canvasWidth + 'px';
                    cHeight = params.canvasHeight + 'px';
                }

                if (sequences360) {
                    if (i > 0) {
                        imageHolder = document.getElementById("rotate360part" + curFrame);
                    } else {
                        imageHolder = document.createElement('div');
                        imageHolder.style.cssText = 'position: absolute; width: '+cWidth+'; height: '+cHeight+';';
                        imageHolder.id = "rotate360part" + curFrame;

                        imageHolder.className = 'part-element-360-rotate';

                        elem.appendChild(imageHolder);
                    }
                } else {
                    if ((j > 0) && (document.getElementById("rotate360part" + i) !== null)) {
                        imageHolder = document.getElementById("rotate360part" + i);
                    } else {
                        imageHolder = document.createElement('div');
                        imageHolder.style.cssText = 'position: absolute; opacity: 0; width: ' + cWidth + ';height: ' + cHeight + ';';
                        imageHolder.id = "rotate360part" + i;
                        imageHolder.onmousedown = mousedown;
                        imageHolder.ontouchstart = mousedown;
                        imageHolder.onmousemove = mousemove;
                        imageHolder.ontouchmove = mousemove;
                        imageHolder.onclick = mouseclick;
                        imageHolder.className = 'part-element-360-rotate';

                        elem.appendChild(imageHolder);
                    }
                }



                if (Justselling_Configento_App_Helper.canvas360css.bottom > 0) {
                    imageHolder.style.cssText = 'bottom: '+Justselling_Configento_App_Helper.canvas360css.bottom+'%';
                }

                if (Justselling_Configento_App_Helper.getCustomContainerCanvasClass()) {
                    var bottomCss = ((params.canvasHeight / 2) - 70) * -1;

                    if (Justselling_Configento_App_Helper.canvas360css.correctionPosition != 0) {
                        bottomCss = parseFloat(bottomCss) + parseFloat(Justselling_Configento_App_Helper.canvas360css.correctionPosition);
                    }

                    if ((typeof Justselling_Configento_App_Helper.canvas360css.bottom !== 'undefined') && (Justselling_Configento_App_Helper.canvas360css.bottom != 0)) {
                        bottomCss = Justselling_Configento_App_Helper.canvas360css.bottom;
                    }

                    var leftCss = (params.canvasWidth / 2) * -1;

                    if ((typeof Justselling_Configento_App_Helper.canvas360css.left !== 'undefined') && (Justselling_Configento_App_Helper.canvas360css.left != 0)) {
                        //leftCss = Justselling_Configento_App_Helper.canvas360css.left;
                        leftCss = ((params.canvasWidth - parseFloat(Justselling_Configento_App_Helper.canvas360css.left)) / 2) * -1;
                    }
                    if (Justselling_Configento_App_Helper.getImageContainerInlineCss()) {
                        imageHolder.style.cssText = Justselling_Configento_App_Helper.getImageContainerInlineCss();
                    } else {
                        imageHolder.style.cssText = 'position: absolute; opacity: 0; width: '+params.canvasWidth+'px; height: '+params.canvasHeight+'px; '+'bottom: '+bottomCss+'px; ' + 'left: ' + leftCss + 'px';
                    }

                    if (Justselling_Configento_App_Helper.getCombineImageCss()) {
                        imageHolder.style.cssText = Justselling_Configento_App_Helper.getImageContainerInlineCss();
                        imageHolder.style.cssText += 'position: absolute; opacity: 0; width: '+params.canvasWidth+'px; height: '+params.canvasHeight+'px; ' + 'left: ' + leftCss + 'px';
                    }

                }

                if (Justselling_Configento_App_Helper.getImageInlineCSS()) {
                    currentImage.style.cssText = Justselling_Configento_App_Helper.getImageInlineCSS();
                    sourcePng.style.cssText = Justselling_Configento_App_Helper.getImageInlineCSS();
                    sourceWebp.style.cssText = Justselling_Configento_App_Helper.getImageInlineCSS();

                    if (Justselling_Configento_App_Helper.getImageLeftCenter() != 0) {
                        currentImage.style.cssText += 'position: absolute; left:'+Justselling_Configento_App_Helper.getImageLeftCenter()+'px';
                        sourcePng.style.cssText += 'position: absolute; left:'+Justselling_Configento_App_Helper.getImageLeftCenter()+'px';
                        sourceWebp.style.cssText += 'position: absolute; left:'+Justselling_Configento_App_Helper.getImageLeftCenter()+'px';
                    }

                    if (Justselling_Configento_App_Helper.getCalculateTopImage() != 0) {
                        currentImage.style.cssText += 'position: absolute; top:'+Justselling_Configento_App_Helper.getCalculateTopImage()+'px';
                        sourcePng.style.cssText += 'position: absolute; top:'+Justselling_Configento_App_Helper.getCalculateTopImage()+'px';
                        sourceWebp.style.cssText += 'position: absolute; top:'+Justselling_Configento_App_Helper.getCalculateTopImage()+'px';
                    }
                } else {
                    currentImage.style.cssText = 'position: absolute; top:0px; width: '+params.canvasWidth+'px !important; height: '+params.canvasHeight+'px !important';
                    sourcePng.style.cssText = 'position: absolute; top:0px; width: '+params.canvasWidth+'px !important; height: '+params.canvasHeight+'px !important';
                    sourceWebp.style.cssText = 'position: absolute; top:0px; width: '+params.canvasWidth+'px !important; height: '+params.canvasHeight+'px !important';
                }
                if (typeof Justselling_Configento_App_Helper.getLayerPosition()[j] !== 'undefined') {
                    currentImage.style.cssText += 'z-index:'+Justselling_Configento_App_Helper.getLayerPosition()[j];
                    sourcePng.style.cssText += 'z-index:'+Justselling_Configento_App_Helper.getLayerPosition()[j];
                    sourceWebp.style.cssText += 'z-index:'+Justselling_Configento_App_Helper.getLayerPosition()[j];
                }

                if (imageHolder !== null) {
                    var pictureWrapper = imageHolder.appendChild(pictureElement);
                    pictureWrapper.appendChild(sourceWebp);
                    pictureWrapper.appendChild(sourcePng);
                    pictureWrapper.appendChild(currentImage);
                }
            }
        }



        //jQuery('.loader360, #js-canvas-360, .percentx').hide();
        jQuery('.justselling360combinedimage').prevAll('img').css({'opacity': '0'});
        if (jQuery('.canvas360InnerWrapper').length == 0) {
            jQuery('.canvas360Wrapper').wrapInner("<div class='canvas360InnerWrapper'></div>");
        }

        /* placeholder to transform view in overlay */
        if (jQuery('.show-in-overlay-360').length == 0) {
            jQuery('.justselling360combinedimage').append('<div style="'+Justselling360.getCssShowInOverlay()+'" class="show-in-overlay-360"></div><div class="hold-temp-conf"></div>');
        }

        if (Justselling360.getShowInOverlay()) {
            Justselling360.showInOverlayView();
        }


        /* show 2D element */
        if (params.framesCount == 1) {
            setTimeout(function () {
                jQuery('#rotate360part0').css({'opacity': '1'});
                jQuery('.loader360').remove();
            }, 200);
        }

        /* this first part is used to load only one image (fist one), and also will check
        * for cached images */
        var deferredsOne = [];
        var flagComplete = true;
        jQuery('#rotate360part'+curFrame+' img').each(function(index) {
            if (!this.complete) {
                var deferred = jQuery.Deferred();
                jQuery(this).one('load', deferred.resolve);
                deferredsOne.push(deferred);
                index = -99; // set to -99 because we don't wont execute else if one image is still not loaded
                flagComplete = false;
            }
            setTimeout(function () {
                if (flagComplete) {
                    if (index + 1 == jQuery('#rotate360part' + curFrame + ' img').length) {
                        jQuery('#rotate360part' + curFrame).css({'opacity': '1'});
                    }
                }
            }, 10);

        });
        jQuery.when.apply(jQuery, deferredsOne).done(function() {
            jQuery('#rotate360part'+curFrame).css({'opacity': '1'});
        });

        var deferreds = [];
        jQuery('.canvas360InnerWrapper img').each(function() {
            if (!this.complete) {
                var deferred = jQuery.Deferred();
                jQuery(this).one('load', deferred.resolve);
                deferreds.push(deferred);
            }
        });
        jQuery.when.apply(jQuery, deferreds).done(function() {
            //alert('jesam');
            /* things to do when all images loaded */
            if (sequences360) {
                framesCountParam = sequences360;
                maxImagesPerSetParam = 1;
                //jQuery('.rotate-3d-indicator').remove();
                if (params.framesCount != 1) {
                    create3Dicon();
                } else {
                    jQuery('.rotate-3d-indicator').remove();
                }
            } else {
                if (params.framesCount != 1) {
                    create3Dicon('true');
                } else {
                    jQuery('.rotate-3d-indicator').remove();
                }
            }
            jQuery('.loader360').remove();
            setTimeout(function () {
                jQuery('#rotate360part'+curFrame).css({'opacity': '1'});
            }, 10);
        });
    };


    if (params.canvasId) {
        // Set the variable elem to the object with the specified params.canvasId
        var elem = document.querySelector(params.canvasId);

        // If the element is not an object then show a message letting the user know.
        if (!elem) {
            alert('Invalid element ID.');
            return;
        } else {
            // Add a class to the element where the canvas will be placed. | Add class only if not present already
            if (elem.className.indexOf('canvas360Wrapper') === -1) {
                elem.className += ' canvas360Wrapper';
            }

            if (params.wrapperCSS) {
                // Set the width of the div to match the width of the canvas. | TODO old value make this as pram ((canvas.width) + 'px');
                elem.style.width = ((canvas.width) + 'px');

                // Set the height of the div to match the height of the canvas.
                elem.style.height = ((canvas.height) + 'px');
            }

            // Remove the existing HTML in the container element.
            elem.innerHTML = '';


            // Set a keydown event on the canvas.
            window.onkeypress = function(event) {
                var k = event.keyCode || event.charCode;
                if (!k)
                    return;
                if (k == 37) {// left arrow
                    if(params.framesReverse) {
                        onswiperight();
                    } else {
                        onswipeleft();
                    }
                } else if (k == 39) {// right arrow
                    if(params.framesReverse) {
                        onswipeleft();
                    } else {
                        onswiperight();
                    }
                }
            }

            // Fix Andriod 4 Chrome bug.
            document.body.addEventListener('touchstart', function() {});

            // Set a mouseup event on the canvas.
            window.onmouseup = mouseup;

            // Start the preload method.
            startPreload();

           /* make product auto rotate */
           if (params.autorotate && !Justselling360.getAutorotate()) {
               var rotations = 0;
               var makeRotate = setInterval(function () {
                   onswiperight();
                   rotations++;
                   if (rotations == 40) {
                       clearInterval(makeRotate);
                       Justselling360.setAutorotate(true);
                   }
               }, 100);
           }

        }

    }

};

var CONFIGENTO = {
    /* Matrix option modes */
    MODE_NEXT_HEIGHER: 1,
    MODE_NEXT_LOWER: 2,
    MODE_MATCH: 3,

    /* Rule types */
    RULE_BLACKLIST: 1,
    RULE_PREDEFINE_QTY: 2,
    RULE_PREDEFINE_VALUE: 3,
    RULE_PREDEFINE_MINMAX: 4,
    RULE_ERROR: 5,

    RULE_TYPE_OPTION: 100,
    RULE_TYPE_CHOICE: 101,

    /* Option Visibility */
    OPTION_VISIBLE_FALSE: 0,
    OPTION_VISIBLE_TRUE: 1,
    OPTION_VISIBLE_SHOP: 2,
    OPTION_VISIBLE_BACKEND: 3,

    /* Thumb Option Style */
    OPTION_THUMB_STYLE_IMAGE_ONLY: 0,
    OPTION_THUMB_STYLE_IMAGE_AND_LABEL: 1,
}

var configentoRegistry = [];
var configurator;

var restoreConfigurator = function(data) {
    configurator = new Justselling_Configento_Configurator("configurator1");
    var tempConfigurator = JSON.parse(data);
    tempConfigurator = JSON.retrocycle(tempConfigurator);
    for(var k in tempConfigurator) configurator[k]=tempConfigurator[k];
    for(var g=0; g<configurator.groups.length;g++) {
        var group = configurator.groups[g];
        var tempGroup = new Justselling_Configento_Option_Group();
        for(var k in group) tempGroup[k]=group[k];
        configurator.groups[g] = tempGroup;
        configurator.groups[g].$domElement = null;
    }
    for(var o=0; o<configurator.options.length;o++) {
        var option = configurator.options[o];
        var tempOption = new Justselling_Configento_Option_Abstract();
        switch (option.optiontype) {
            case 'text':
                tempOption = new Justselling_Configento_Option_Type_Text();
                break;
            case 'area':
                tempOption = new Justselling_Configento_Option_Type_Area();
                break;
        }
        for(var k in option) tempOption[k]=option[k];
        configurator.options[o] = tempOption;
        configurator.options[o].$domElement = null;
        configurator.options[o].$domParentElement = null;
        configurator.options[o].configurator = (configurator);
        if (option.group) {
            configurator.options[o].group = configurator.getGroupByInternalId(option.group.internalId);
        }
        if (option.choices && option.choices.length >= 1) {
            for(var c=0; c<option.choices.length;c++) {
                var choice = option.choices[c];
                var tempChoice = new Justselling_Configento_Option_Choice();
                for(var k in choice) tempChoice[k]=choice[k];
                configurator.options[o].choices[c] = tempChoice;
                configurator.options[o].choices[c].option = (configurator.options[o]);
            }
        }
        if (option.activeChoice && option.activeChoice.internalId) {
            configurator.options[o].activeChoice = configurator.options[o].getChoiceByInternalId(option.activeChoice.internalId)
        }
    }
    for(var r=0; r<configurator.rules.length;r++) {
        var rule = configurator.rules[g];
        var tempRule = new Justselling_Configento_Rules_Rule();
        for(var k in rule) tempRule[k]=rule[k];
        configurator.rules[r] = tempRule;
        configurator.rules[r].configurator = (configurator);
        if (rule.expression) {
            configurator.rules[r].expression = configurator.getOptionByInternalId(rule.expression.internalId);
        }
        if (rule.dependencies) {
            /* TODO Create option object, when we have an option here */
            for(var d=0; d<rule.dependencies.length;d++) {
                var choice = rule.dependencies[d];
                var tempChoice = new Justselling_Configento_Option_Choice();
                for(var k in choice) tempChoice[k]=choice[k];
                configurator.rules[r].dependencies[d] = tempChoice;
            }
        }
    }
    /* TODO Create option object, when we have an option here */
    for(var b=0; b<configurator.blacklist.length;b++) {
        var choice = configurator.blacklist[b];
        var tempChoice = new Justselling_Configento_Option_Choice();
        for (var k in choice) tempChoice[k] = choice[k];
        configurator.blacklist[b] = tempChoice;
    }
    for(var b=0; b<configurator.tmpBlacklist.length;b++) {
        var choice = configurator.tmpBlacklist[b];
        var tempChoice = new Justselling_Configento_Option_Choice();
        for (var k in choice) tempChoice[k] = choice[k];
        configurator.tmpBlacklist[b] = tempChoice;
    }

    for(var o=0; o<configurator.options.length;o++) {
        var option = configurator.options[o];
        if (option.children && option.children.length >= 1) {
            for (var c = 0; c < option.children.length; c++) {
                configurator.options[o].children[c] = configurator.getOptionByInternalId(option.children[c].internalId);
            }
        }
    }

    configurator.isRestoreCompiled = true;
    configurator.$domElement = null;
    configurator.loadTemplate();
}

var Justselling_Configento_Configurator = function(id, predefinedValues, templateId, urlParams) {
    'use strict';
    var self = this;
    self.id = null;
    self.internalId = null;
    self.$domElement = null;
    self.options = [];
    self.optionsTitleToIndex = [];
    self.unparsedOptions = [];
    self.processList = [];
    self.processBlacklistingRules = false;
    self.groups = null;
    self.rules = [];
    self.blacklist = [];
    self.tmpBlacklist = [];
    self.config = [];
    self.$formValidation = null;
    self.combinedimage = null;
    self.eventHandler = false;
    self.noRenderByRules = true;
    self.isRestoreCompiled = false;
    self.processingUpdateOptionsInDOM = false;

    self.hideElements = false;
    self.showElements = false;

    self.internalId = templateId;
    self.urlParams = [];

    // self.choiceIndex = {};
    /*
     * Init configurator with default settings at startup
     * Settings can be customized via JSON config in backend
     */
    this.defaultConfig = function() {
        /* validation nad min/max patterns */
        self.config["showMinMax"] = true;
        self.config["minMaxPattern"] = "($min - $maxcm)";

        /* combined product image */
        self.config["combinedimage"] = true;

        /* how and if to show prices */
        self.config["displayPrice"] = true;
        self.config["displayPriceType"] = "absolute";
        self.config["displayPriceIfZero"] = false;
        self.config["displayPricePattern"] = " [$price]";

        /* tax configuration */
        self.config["priceIncludesTax"] = true;
        self.config["taxRate"] = 19.0;

        /* group / wizard */
        self.config["groupWizard"] = true;
        self.config["groupScrollOffset"] = 80;
        self.config["groupLayout"] = "tabs";
        self.config["optionImagePosition"] = "right";
    };
    this.getConfig = function(key) {
        if (self.config[key]) {
            return self.config[key];
        }
        return false;
    };
    this.setConfig = function(key, value) {
        if (key) {
            self.config[key] = value;
        }
    };


    this.setIsEventHandler = function(value) {
        self.eventHandler = value;
    };
    this.getIsEventHandler = function() {
        return self.eventHandler;
    };

    this.removeLastPartOfKey = function(key) {
        var start1 = new Date().getTime();

        var parts = key.split("-");
        var result = "";
        if (typeof parts == 'object') {
            for (var i = 0; i < parts.length - 1; i++) {
                if (i>0) {
                    result += "-";
                }
                result += parts[i];
            }
        }

        var end1 = new Date().getTime();
        var time1 = end1 - start1;
        Justselling_Configento_App_Profiler.addMeasuring("configuratoro ::removeLastPartOfKey ______ ", time1);

        return result;
    };
    this.setPredefinedValues = function(values) {
        this.predefinedValues = values;
    };
    this.getHasPredefinedValues = function() {
        if (this.predefinedValues) {
            return true;
        }
        return false;
    };

    this.setUrlParams = function (params) {
        if (Justselling_Configento_App_Helper.getDeepLinkByOptionsId()) {
            if (params) {
                _.each(params, function (key, param) {
                    /* don't set data if you are in deep link mode (toolbar, or you are having dl)*/
                    if ((param != 'tb' && key != 1) && (param != 'dl')) {
                        self.urlParams.push({'title': param, 'value': key});
                    }
                });
            }
        }
    };
    this.getUrlParams = function () {
        return this.urlParams;
    };

    this.getPredefinedValue = function(key) {
        var start1 = new Date().getTime();

      //  key = this.removeLastPartOfKey(key);
        if (this.predefinedValues && typeof this.predefinedValues == 'object') {
            for (var k in this.predefinedValues) {
           //     var cleanK = this.removeLastPartOfKey(k);
                if (k == key) {
                    return this.predefinedValues[k];
                }
            }
        }

        var end1 = new Date().getTime();
        var time1 = end1 - start1;
        Justselling_Configento_App_Profiler.addMeasuring("configuratoro ::getPredefinedValue ______ ", time1);


        return false;
    };

    this.addGroup = function(group) {
        var isActive = false;
        if (!jQuery.isArray(self.groups)) {
            self.groups = [];
            isActive = true;
        }
        var index = self.groups.length;
        self.groups.push(group);
        group.setIsActive(isActive);
        group.setIndex(index);
    };

    this.getNumberOfGroups = function() {
        if (self.groups && typeof self.groups == "object") {
            return self.groups.length;
        }
        return false;
    };
    this.getActiveGroup = function() {
        if (self.groups) {
            for (var i=0; i<self.groups.length; i++) {
                var group = self.groups[i];
                if (group.getIsActive()) {
                    return group;
                }
            }
        }
        return false;
    };
    this.setActiveGroup = function(group) {
        if (group && typeof group=="object") {
            return self.setActiveGroupByIndex(group.getIndex());
        }
        return false;
    };
    this.setActiveGroupByIndex = function(index) {
        if (self.groups) {
            /* Disable current active group */
            var currentActiveGroup = self.getActiveGroup();
            if (currentActiveGroup && typeof currentActiveGroup=="object") {
                currentActiveGroup.setIsActive(false);
                jQuery(document).trigger("configentoDeleteActiveGroupAfter", {
                    'group' : currentActiveGroup
                } );
            }

            /* activate new group */
            var group = self.groups[index];
            if (group && typeof group=="object") {
                // Rerender Chart when switching tab
                self.reRenderOptionInGroup(index);
                group.setIsActive(true);
                jQuery(document).trigger("configentoSetActiveGroupAfter", {
                    'group' : group,
                    'index': index
                } );
                return group;
            }
        }
    };
    this.getGroupByIndex = function(index) {
        if (self.groups) {
            for (var i=0; i<self.groups.length; i++) {
                var group = self.groups[i];
                if (group.getIndex() == index) {
                    return group;
                }
            }
        }
        return false;
    };
    this.reRenderOptionInGroup = function (groupIndex) {
        for(var i=0; i<self.options.length;i++) {
            var option = self.options[i];
            // Rerender only if chart option is in actual group
            if (option.getType() == "chart") {
                jQuery(document).trigger("reRenderChartInGroup", [option, groupIndex]);
                if(option.getGroup().getIndex()  == groupIndex) {
                    option.updateChart();
                }
            }
        }
    };

    /*
     * Add a new option to this configurator
     */
    this.addOption = function(option) {
        if (!jQuery.isArray(self.options)) {
            self.options = [];
        }
        var index  = self.options.push(option) - 1;
        this.optionsTitleToIndex[option.title] = index;
        return index;
    };

    /*
     * Add option ID´s of expressions which could not be parsed
     * This list will be parsed again when all options has been rendered
     */
    this.setUnparsedOption = function(unparsedOption) {
        self.unparsedOptions.push(unparsedOption);
    };

    this.getUnparsedOptions = function() {
        return self.unparsedOptions;
    };

    /*
     * Get option object by option-title
     */
    this.getOption = function(title) {
        if (title) {
            return self.options[self.optionsTitleToIndex[title]];
        }
        return false;
    };

    /*
     * Get option object by option-index
     */
    this.getOptionByIndex = function(optionIndex) {
        if (optionIndex >= 0) {
            return self.options[optionIndex];
        }
        return false;
    };

    /*
     * Get option object by option-title
     */
    this.getOptionIndex = function(title) {
        if (title) {
            for (var i = 0; i < self.options.length; i++) {
                var option = self.options[i];
                if (option.title === title) {
                    return i;
                }
            }
        }
        return -1;
    };

    /*
     * Get option object by internal-id
     */
    this.getOptionByInternalId = function(internalId) {
        if (internalId != undefined) {
            for (var i = 0; i < self.options.length; i++) {
                var option = self.options[i];
                if (option.getInternalId() == internalId) {
                    return option;
                }
            }
        }
        return false;
    };


  /* Is actually unused
    this.getOptionsByInternalIdArray = function(internalIdArray) {
        var foundOptions = [];
        _.each(self.options, function(option) {
            if(internalIdArray.length > 0) {
                var posArr = _.indexOf(internalIdArray, option.getInternalId());
                if (posArr >= 0) {
                    internalIdArray.splice(posArr, 1);
                    foundOptions.push(option);
                }
            }
        });
        return foundOptions;
    };
*/
    this.getOptions = function() {
        return self.options;
    };

    /*
     * Get choice object by internal-id
     * @param: internalId // string or number
     */
    this.getChoiceByInternalId = function(internalId) {
        var retChoice = false;
        _.each(self.options, function(option) {
            if(!retChoice) {
                var choice = option.getChoiceByInternalId(internalId);
                if (choice) {
                    retChoice = choice;
                }
            }
            /*var choices = option.getChoices();
            if (choices) {
                for (var n = 0; n < choices.length; n++) {
                    var choice = choices[n];
                    if (choice.internalId == internalId) {
                        return choice;
                    }
                }
            }*/
        });
        return retChoice;
    };
    this.isInternalIdFromPackage = function(internalId) {
        if (!internalId) return false;
        internalId = String(internalId);
        if (internalId.indexOf('PCK') == 0) return true;
        return false;
    };

    this.getChoicesByInternalIdArray = function(internalIdArray) {
        var foundChoices = [];
        var foundInternalIds = [];
        _.each(self.options, function(option) {
            if(internalIdArray.length > 0) {
                var choices = option.choices;
                if (_.isArray(choices) && choices.length > 0) {
                    _.each(internalIdArray, function (internalId) {
                        var index = option.choiceInternalIdToIndex[internalId];
                        if (index != null) {
                            foundInternalIds.push(internalId);
//                            internalIdArray.splice(internalIdArray.indexOf(internalId), 1);
                            foundChoices.push(choices[index]);
                        }
                    });
                    if(foundInternalIds.length > 0 ) {
                        internalIdArray = _.without(internalIdArray, foundInternalIds);
                        foundInternalIds = [];
                    }
                }
                /*var choices = option.getChoices();
                if (choices) {
                    _.each(choices, function(choice) {
                        if (internalIdArray.indexOf(choice.internalId) >= 0) {
                            internalIdArray.splice(posArr, 1);
                            foundChoices.push(choice);
                        }
                    });
                }*/
            }
        });
        return foundChoices;
    };
    /*
     * Get choice object by id
     */
    this.getChoice = function(id) {
        for(var i=0; i<self.options.length;i++) {
            var option = self.options[i];
            var choices = option.getChoices();
            if (choices) {
                for (var n = 0; n < choices.length; n++) {
                    var choice = choices[n];
                    if (choice.getId() == id) {
                        return choice;
                    }
                }
            }
        }
        return false;
    };

    /*
     * Get group object by group-label
     */
    this.getGroupByLabel = function(label) {
        for(var i=0; i<self.groups.length;i++) {
            var group = self.groups[i];
            if (group.getLabel() == label) {
                return group;
            }
        }
        return false;
    };
    /*
     * Get group object by internal-id
     */
    this.getGroupByInternalId = function(internalId) {
        for(var i=0; i<self.groups.length;i++) {
            var group = self.groups[i];
            if (group.getInternalId() == internalId) {
                return group;
            }
        }
        return false;
    };

    this.getGroups = function() {
        return this.groups;
    };

    /* Add new rule to configurator */
    this.addRule = function(rule) {
        if (!jQuery.isArray(self.rules)) {
            self.rules = [];
        }
        return self.rules.push(rule) - 1;
    };
    this.processRules = function(notWhitelist, recursion) {
        this.clearTmpBlacklist();
        this.clearTmpDateRestrictions();

        var rulesToProcess = self.processList;
        if(notWhitelist == null ) {
            rulesToProcess = self.rules;
        }
        self.processList = [];
        for(var i=0; i<rulesToProcess.length;i++) {
            rulesToProcess[i].process();
        }
        // Get the difference of all items with blacklisting and actually blacklisted items
        if(i > 0 && notWhitelist == null) {
            var whitelist = _.difference(this.blacklist, this.tmpBlacklist);
            _.each(whitelist, function (item) {
                item.setIsBlacklisted(false);
            });
        }

        self.checkDateRestrictionsChanges();

        if(self.processList.length > 0) {
            self.processRules(true);
        }
        if(self.processBlacklistingRules) {
            if (recursion != 'recursion') {
                self.setProcessBlacklistingRules(false);
                self.processRules(null, 'recursion');
            }

        }
    };
    this.addToProcessList = function (rule) {
        this.processList.push(rule);
    };
    this.setProcessBlacklistingRules = function (bool) {
        this.processBlacklistingRules = bool;
    };

    this.isMobile = function () {
        var mobileBreakpoint = 768;

        // Get the current viewport width
        var viewportWidth = jQuery(window).width();

        // Check if the viewport width is less than the mobile breakpoint
        if (viewportWidth < mobileBreakpoint) {
            return true;
        } else {
            //  desktop-specific
            return false
        }
    };

    this.hideEmptyGroups = function () {
        var self = this;
        var visibleGroupIds = [];
        var visibleGroups = [];
        _.each(this.getOptions(), function (option) {
            if(option.getGroup()) {
                var groupId = option.getGroup().getId();
                if (!option.getIsBlacklisted() && visibleGroupIds.indexOf(groupId) == -1) {
                    visibleGroupIds.push(groupId);
                    visibleGroups.push(option.getGroup());
                }
            }
        });

        var hideGroups = _.difference(this.getGroups(), visibleGroups);
        _.each(hideGroups, function (group) {
            if(group.getIsVisible() && !group.getIsBlacklisted()) {
                group.setIsBlacklisted(true);
                group.setIsVisible(false);
                group.getDomElement().addClass('state-hidden');
                self.getDomElement().find('.r-tabs-nav li a[href="#group-'+group.getId()+'"]').addClass('state-hidden');
                var targetHref = self.getDomElement().find('.r-tabs-nav li a[href="#group-'+group.getId()+'"]').attr('href');
                if (self.isMobile()) {
                    var accordionTitle = 'a[href="' + targetHref + '"]';
                    jQuery(accordionTitle).parent().addClass('state-hidden');
                } else {
                    var accordionTitle = '.r-tabs-nav a[href="' + targetHref + '"]';
                    jQuery(accordionTitle).parent().addClass('state-hidden');
                }
            }
        });
        _.each(visibleGroups, function (group) {
            if(!group.getIsVisible() && group.getIsBlacklisted()) {
                group.setIsBlacklisted(false);
                group.setIsVisible(true);
                group.getDomElement().removeClass('state-hidden');
                self.getDomElement().find('.r-tabs-nav li a[href="#group-'+group.getId()+'"]').removeClass('state-hidden');
                var targetHref = self.getDomElement().find('.r-tabs-nav li a[href="#group-'+group.getId()+'"]').attr('href');
                if (self.isMobile()) {
                    var accordionTitle = 'a[href="' + targetHref + '"]';
                    jQuery(accordionTitle).parent().removeClass('state-hidden');
                } else {
                    var accordionTitle = '.r-tabs-nav a[href="' + targetHref + '"]';
                    jQuery(accordionTitle).parent().removeClass('state-hidden').css('display', 'inline-block');
                }
            }
        });
        Justselling_Configento_App_Wizard.init = false;
        Justselling_Configento_App_Wizard.updateWizard();
    };

    /*
     * Get the value of an option (internal-value) by option-title
     */
    this.getOptionValue = function(title) {
        var option = _.find(self.options, function (option) {
            return option.getTitle() === title;
        });
        if(option) {
            option = option.getValue();
        }
        return option;
    };

    this.setId = function(id) {
        self.id =  id;
        self.register(id);
    };
    this.getId = function() {
        return self.id;
    };

    this.register = function(id) {
        if (!configentoRegistry || !typeof configentoRegistry == "object") {
            configentoRegistry = [];
        }
        configentoRegistry[id] = self;
    };

    this.setInternalId = function(internalId) {
        self.internalId =  internalId;
    };
    this.getInternalId = function() {
        return self.internalId;
    };

    this.setTemplateLabel = function(templateLabel) {
        self.templateLabel =  templateLabel;
    };
    this.getTemplateLabel = function() {
        return Justselling_Configento_App_Helper.getTranslatedLabel(self.templateLabel);
    };

    this.setCombinedImage = function(combinedimage) {
        self.combinedimage =  combinedimage;
    };
    this.getCombinedImage = function() {
        return self.combinedimage;
    };

    /**
     * take price from product by SKU
     * @param sku
     * @returns {*|null}
     */
    this.getPriceBySku = function (sku) {
         if (CONFIGENTO_PRODUCT.productPricesBySku) {
             var pricesBySku = CONFIGENTO_PRODUCT.productPricesBySku;

             for (var i = 0; i < pricesBySku.length; i++) {
                 var obj = pricesBySku[i];
                 if (obj.hasOwnProperty(sku)) {
                     return parseFloat(obj[sku].price);
                 }
             }
         }
         return null; // SKU not found
    };

    this.getPrice = function() {
        Justselling_Configento_App_Debug.addDebug("getPrice");

        var price = 0;
        for(var i=0; i<self.options.length;i++) {
            var option = self.options[i];
            var optionPrice = option.getPrice();

            /*  get price from active choices */
            if ((typeof option.getActiveChoice() != undefined) && (option.getActiveChoice() != null)) {
                optionPrice = 0;
                if (_.isArray(option.getActiveChoice())) {
                    _.each(option.getActiveChoice(), function (choice) {
                        var sku = choice.getSku();
                        if (sku) {
                            var priceBySku = self.getPriceBySku(sku);
                            if (priceBySku) {
                                choice.setPrice(priceBySku);
                            }
                        }
                        optionPrice += parseFloat(choice.getPrice());
                    })
                } else {
                    var sku = option.getActiveChoice().getSku();
                    if (sku) {
                        var priceBySku = self.getPriceBySku(sku);
                        if (priceBySku) {
                            option.getActiveChoice().setPrice(priceBySku);
                        }
                    }
                    optionPrice = option.getActiveChoice().getPrice();
                }
            }

            if (optionPrice != 0) {
                optionPrice = parseFloat(Justselling_Configento_App_Tax.convert(optionPrice));
                optionPrice = parseFloat(Justselling_Configento_App_Currency.convert(optionPrice));
                if (isNaN(optionPrice)) {
                    optionPrice = 0;
                }
                price += optionPrice;
                Justselling_Configento_App_Debug.addDebug(option.getTitle() + ": value=" + option.getValue() + " price=" + optionPrice);
            }
        }

        Justselling_Configento_App_Debug.addDebug("Total="+price+", done.");
        return price;
    };

    this.addItemToBlacklist = function(item) {
        if (item) {
            if ((this.blacklist.indexOf(item)) == -1) {
                this.blacklist.push(item);
            }
            if ((this.tmpBlacklist.indexOf(item)) == -1) {
                this.tmpBlacklist.push(item);
            }
            item.setIsBlacklisted(true);
        }
    };
   /* this.clearBlacklist = function() {
        for(var i=0; i<self.blacklist.length;i++) {
            self.blacklist[i].setIsBlacklisted(false);
        }
    };*/
    this.clearTmpBlacklist = function() {
        self.tmpBlacklist = [];
    };

    this.clearDateRestrictions = function() {
        var options = self.getOptions();

        for(var o = 0; o < options.length; o++) {
            if(options[o].clearDateRestrictions !== undefined) {
                options[o].clearDateRestrictions();
            }
        }
    };

    this.clearTmpDateRestrictions = function() {
        var options = self.getOptions();

        for(var o = 0; o < options.length; o++) {
            if(options[o].clearTmpDateRestrictions !== undefined) {
                options[o].clearTmpDateRestrictions();
            }
        }
    };

    this.checkDateRestrictionsChanges = function() {
        var options = self.getOptions();

        for(var o = 0; o < options.length; o++) {
            if(options[o].getType() == "text") {
                if (typeof options[o].dateRestrictions !== 'undefined') {
                    if (options[o].dateRestrictions.length) {
                        options[o].checkDateRestrictionsChanges();
                    }
                }
            }
            // var changes = _.difference(options[o].dateRestrictions, options[o].tmpDateRestrictions);
            // var changes2 = _.difference(options[o].tmpDateRestrictions, options[o].dateRestrictions);
            // if(changes.length > 0 || changes2.length > 0) {
            //     options[o].setHasChanged(true);
            //     options[o].dateRestrictions = options[o].tmpDateRestrictions;
            // }
        }
    };
/*

    this.addChoiceToIndex = function(choice) {
        var internalId = choice.getInternalId();
        if (internalId) {
            if (self.choiceIndex[internalId]) {
                Justselling_Configento_App_Debug.addDebug("EXCEPTION: Duplicate internal id for choice: "+internalId, true);
                Justselling_Configento_App_Debug.addDebug(choice, true);
                return false;
            }
            self.choiceIndex[internalId] = choice;
            return true;
        }
        return false;
    };
*/

    /*
     * Get DOM Element for the configurator.
     * If not set already get it from DOM now.
     */
    this.getDomElement = function() {
        if (!self.$domElement) {
            self.$domElement = jQuery('#'+this.getId());
        }
        return self.$domElement;
    };

    /*
     * Build Object with all header-values, make JSON and encode Base64
     */
    this.generateHeaderValue = function() {
        var value = {};

        for(var i=0; i<self.options.length;i++) {
            var option = self.options[i];
            if(((option.getType() !== 'expression') || (option.choice == null))
                && (option.visibility != CONFIGENTO.OPTION_VISIBLE_SHOP)) {
                var part = {};
                option.setPrice(option.calculatePrice());
                var optionPrice = option.getPrice();
                optionPrice = parseFloat(Justselling_Configento_App_Tax.convertToBase(optionPrice || 0));
                optionPrice = parseFloat(Justselling_Configento_App_Currency.convertToBase(optionPrice || 0));
                part.price = optionPrice;
                var optionValue = option.getValue();
                var valueLabel = "";
                var valueQty = "";
                var valuePrice = "";
                var activeChoice = option.getActiveChoice();
                if (activeChoice instanceof Justselling_Configento_Option_Choice) {
                    valueLabel = activeChoice.getLabel();
                    valueQty = activeChoice.getQty();
                    part.valueId = activeChoice.getInternalId();
                    part.choiceSku = activeChoice.getSku();
                    part.choiceCustomFields = activeChoice.getCustomFields();
                }
                else if (_.isArray(activeChoice)) {
                    valueLabel = _.map(activeChoice, function (choice) {
                        return choice.getLabel();
                    });
                    valueQty = _.map(activeChoice, function (choice) {
                        return choice.getQty();
                    });
                    valuePrice = _.map(activeChoice, function (choice) {
                        return choice.getPrice();
                    });
                    part.valueId = _.map(activeChoice, function (choice) {
                        return choice.getInternalId();
                    });
                    part.choiceSku = _.map(activeChoice, function (choice) {
                        return choice.getSku();
                    });
                }

                var visibility = option.visibility;
                if (option.getIsBlacklisted()) {
                    visibility = 0;
                }

                part.valuePrice = valuePrice;
                if(valueQty != null) {
                    part.valueQty = valueQty;
                }
                part.value = optionValue;
                if(valueLabel != null) {
                    part.valueLabel = valueLabel;
                }
                part.label = option.label;
                if(option.sku != null) {
                    part.sku = option.sku;
                }
                part.visibility = visibility;

                part.customFields = option.getCustomFields();

                value[option.getTitle()] = part;
            }
        }

        if (Justselling_Configento_App_CloudAsset.getAssets()) {
            value['assets'] = Justselling_Configento_App_CloudAsset.getAssets();
        }
        value['general'] = {
            configuratorPriceIncludesTax: Justselling_Configento_App_Tax.priceIncludesTax,
            configuratorTaxRate: Justselling_Configento_App_Tax.configuratorTaxRate,
            storeTaxRate: CONFIGENTO_PRODUCT.getTaxRate(),
            storeBaseTaxRate: CONFIGENTO_PRODUCT.getBaseTaxRate(),
            currencyRates: Justselling_Configento_App_Currency.config.rates,
            configuratorCurrency: self.getConfig('default_currency_code'),
            storeCurrency: CONFIGENTO_PRODUCT.getStoreCurrencyCode(),
            storeBaseCurrency: CONFIGENTO_PRODUCT.getBaseCurrencyCode(),
            storeCurrencySymbol: CONFIGENTO_PRODUCT.getCurrencySymbol()
        };

        var seen = [];
        var base64Value;
        try {
            var currentKey;
            var currentValue;
            var jsonValue = JSON.stringify(value, function(key, val) {
                if (val instanceof Node || val instanceof Window || (window.jQuery && val instanceof window.jQuery)) {
                    // Skip processing jQuery objects, Nodes, or Windows
                    return;
                }
                if (key !== "" && typeof this === 'object' &&
                    typeof this.hasOwnProperty === "function" &&
                    !this.hasOwnProperty(key)) return;
                if (val != null && typeof val === "object") {
                    if (seen.indexOf(val) !== -1) {
                        // Circular reference found, discard key
                        return;
                    }
                    seen.push(val);
                }
                currentKey = key;
                currentValue = val;
                return val;
            });
            base64Value = Base64.encode(jsonValue);
        } catch(err) {
            Justselling_Configento_App_Debug.addDebug("EXCEPTION generating header value: " + err.message, true);
            Justselling_Configento_App_Debug.addDebug(currentKey, true);
            Justselling_Configento_App_Debug.addDebug(currentValue, true);
            throw err;
        }

        jQuery(document).trigger("configentoUpdateHeaderInDomBefore");
        return base64Value;
    };

    /*
     * Generate Configurator header html from handlebars template
     */
    this.getHeaderHtml = function() {
        var template = "";
        var html = "";
        var source   = Justselling_Configento_App_Helper.$template.find("#header-template").html();
        if (source) {
            template = Handlebars.compile(source);
        }
        if (template) {
            var context = {
                id: self.getId()+"-header",
                value: self.generateHeaderValue(),
                name: "options["+CONFIGENTO_PRODUCT.getProductOptionId()+"]["+self.getId()+"-header]"
            };
            html = template(context);
        }
        return html;
    };

    /*
     * Update header in DOM
     */
    this.updateHeaderInDom = function() {
        var html = this.getHeaderHtml();
        var tagId = self.getId()+"-header";
        var $element = jQuery('#'+tagId);
        if ($element.length == 0) {
            if (self.getDomElement() && self.getDomElement().length == 1) {
                self.getDomElement().append(html);
            }
        } else {
            var headerValue = self.generateHeaderValue();
            if (headerValue) $element.val(headerValue);
        }
        jQuery(document).trigger("configentoUpdateHeaderInDomAfter");
    };

    /*
     * Trigger all options to update their DOM elements
     */
    this.updateOptionsInDom = function() {
        Justselling_Configento_App_Debug.addDebug("updateOptionsInDom");
        self.processingUpdateOptionsInDOM = true;

        var start = new Date().getTime();
        jQuery(document).trigger("configentoUpdateOptionsInDomBefore");

        if(self.noRenderByRules) {
            for(var i=0; i<self.options.length;i++) {
                self.options[i].render()
            }
        }

        var start1 = new Date().getTime();
        this.processRules();
        var end1 = new Date().getTime();
        var time1 = end1 - start1;
        Justselling_Configento_App_Profiler.addMeasuring("configurator::updateOptionsInDom.processRules", time1);

        self.noRenderByRules = false;

        var start1 = new Date().getTime();
        this.hideEmptyGroups();
        var end1 = new Date().getTime();
        var time1 = end1 - start1;
        Justselling_Configento_App_Profiler.addMeasuring("configurator::updateOptionsInDom.hideEmptyGroups", time1);

        var start1 = new Date().getTime();
        this.updateHeaderInDom();
        var end1 = new Date().getTime();
        var time1 = end1 - start1;
        Justselling_Configento_App_Profiler.addMeasuring("configurator::updateOptionsInDom.updateHeaderInDom", time1);

        var start1 = new Date().getTime();
        var count = 0;
        var numOptions = self.options.length;

        var splitFilters = Justselling_Configento_App_Helper.getFilterRequiredOptions().split(';');
        /* show percentage loader on init */
        if (Justselling_Configento_App_Helper.getInitOptionLoad() > 0) {
            var loaderContainerSelector = jQuery('.loader-main-pc');
            var i = 0;
            (function doUpdateProgress() {
                // update progress
                var option = self.options[i];
                if (option.updateValueInDom()) {
                    var percentage = i/(Justselling_Configento_App_Helper.getInitOptionLoad()) * 100;
                    if (jQuery('.percentage').length) {
                        loaderContainerSelector.show();
                        jQuery('.percentage').html(parseInt(percentage)+' %');
                        if (percentage > 98) {
                            if (self.getUrlParams().length > 0) {
                                Justselling_Configento_App_Api.setOptionValues(self.getUrlParams())
                            }
                            loaderContainerSelector.hide();
                            Justselling_Configento_App_Helper.setInitOptionLoad(0);
                        }
                    } else {
                        loaderContainerSelector.show().append('<div class="percentage" style="margin-left: 20px;left: 50%;position: absolute;top: 50%;margin-top: 65px;">'+percentage+' %</div>');
                    }
                }
                i++;
                if (i < numOptions) {
                    if ((!Justselling_Configento_App_Helper.getFilterRequiredOptions().includes('undefined') && splitFilters.length > 1) &&
                        (
                            (typeof option.customClass !== 'undefined') &&
                            (self.compareArrays(option.customClass.split(' '), splitFilters)) ||
                            (Justselling_Configento_App_Helper.getFilterRequiredOptions().includes(option.title))
                        )
                    ) {
                        setTimeout(doUpdateProgress, 0);
                    } else if (Justselling_Configento_App_Helper.getFilterRequiredOptions().includes('undefined') || !Justselling_Configento_App_Helper.getFilterRequiredOptions()) { // no filter
                        setTimeout(doUpdateProgress, 0);
                    } else {
                        loaderContainerSelector.hide()
                    }
                } else {
                    loaderContainerSelector.hide()
                }
            })();
        } else {
            for(var i=0; i<numOptions;i++) {
                var option = self.options[i];
                if ((!Justselling_Configento_App_Helper.getFilterRequiredOptions().includes('undefined') && splitFilters.length > 1) &&
                    (
                        (typeof option.customClass !== 'undefined') &&
                        (self.compareArrays(option.customClass.split(' '), splitFilters)) ||
                        (Justselling_Configento_App_Helper.getFilterRequiredOptions().includes(option.title))
                    )
                ) {
                    if (option.updateValueInDom()) {
                        count++;
                    }
                } else if (Justselling_Configento_App_Helper.getFilterRequiredOptions().includes('undefined') || !Justselling_Configento_App_Helper.getFilterRequiredOptions()) { // no filter
                    if (option.updateValueInDom()) {
                        count++;
                    }
                }
            }
        }
        var end1 = new Date().getTime();
        var time1 = end1 - start1;
        Justselling_Configento_App_Profiler.addMeasuring("configurator::updateOptionsInDom.updateValueInDom", time1);

        var start1 = new Date().getTime();
        var price = self.getPrice();
        CONFIGENTO_PRODUCT.setPrice(price);
        var end1 = new Date().getTime();
        var time1 = end1 - start1;
        Justselling_Configento_App_Profiler.addMeasuring("configurator::updateOptionsInDom.setPrice", time1);

        var start1 = new Date().getTime();
        Justselling_Configento_App_Summary.updateSummaryInDOM(self);
        if (self.getCombinedImage()) {
            self.getCombinedImage().render();
        }
        var end1 = new Date().getTime();
        var time1 = end1 - start1;
        Justselling_Configento_App_Profiler.addMeasuring("configurator::updateOptionsInDom.getCombinedImage", time1);

        jQuery("img.lazy").lazyload({
            skip_invisible : true
        });

        jQuery(document).trigger("configentoUpdateOptionsInDomAfter");
        var end = new Date().getTime();
        var time = end - start;
        Justselling_Configento_App_Profiler.addMeasuring("configurator::updateOptionsInDom", time);

        Justselling_Configento_App_Debug.addDebug("updateOptionsInDom done ["+time+"ms]["+count+"opt.]");
        if (self.getIsEventHandler()) {
            Justselling_Configento_App_Profiler.addMeasuring("total", time, 1);
            Justselling_Configento_App_Profiler.showProfiling();
        }

        self.processingUpdateOptionsInDOM = false;
    };

    this.getGroupContainerTagId = function() {
        var tagId = self.getId()+"-groups";
        return tagId;
    };
    this.getGroupContainer = function() {
        var tagId = self.getGroupContainerTagId();
        return jQuery("#"+tagId);
    };

    this.compareArrays = function (a,b) {
        var rez = false;
        a.forEach( function( value ) {
            if( b.indexOf( value ) != -1 ) {
                rez = true;
            }
        });
        return rez;
    };

    /*
     * Render all groups
     */
    this.render = function() {
        jQuery(document).trigger("configentoRenderBefore");

        /* Render loader animation */
        if (typeof jQuery === 'function'
            && typeof jQuery.fn.pleaseWait.defaults !== 'undefined'
        ) {
            jQuery.fn.pleaseWait.defaults = {
                image: 'https://cloud.justsellingapp.com/configento/js/justselling/configento/assets/images/animation.gif',
                height: 50,
                width: 100
            };
        }

        /* Render HTML for the groups based on handlebars template */
        var source   = Justselling_Configento_App_Helper.$template.find("#groups-template").html();
        var template = '';
        if (source) {
            template = Handlebars.compile(source);
        }

        var customCssConfig = self.getConfig('customCss') ? self.getConfig('customCss') : '';
        var activeColor = self.getConfig('activeColor');
        var customCSS = customCssConfig;

        if (activeColor) {
            customCSS += ' ul.thumbnails.image_picker_selector li .thumbnail.selected { background: ' + activeColor + '; }';
            customCSS += ' .r-tabs .r-tabs-nav .r-tabs-state-active .r-tabs-anchor { color: ' + activeColor + '; }';
            customCSS += ' .r-tabs .r-tabs-accordion-title.r-tabs-state-active .r-tabs-anchor { color: ' + activeColor + '; }';
        }

        var customJs = self.getConfig('customJavascript');

        if (template) {
            if(self.getConfig("groupLayout") === "no_groups") {
                self.setConfig("groupWizard", false);
            }
            var context = {
                id: self.getGroupContainerTagId(),
                headline: Justselling_Configento_App_Helper.getTranslatedLabel(self.getConfig("headline")),
                groupLayout: 'groupLayout-' + self.getConfig("groupLayout"),
                optionImagePosition: 'option-image-' + self.getConfig("optionImagePosition"),
                next: Justselling_Configento_App_Translate.translate("next"),
                previous: Justselling_Configento_App_Translate.translate("previous"),
                showWizard: self.getConfig("groupWizard"),
                groups: self.groups
            };
            var html = template(context);

            if (customJs) {
                html += '<script type="text/javascript">jQuery(document).on("configentoLoadTemplateAfter", function () {'+customJs+'});</script>';
            }

            if (customCSS) {
                html += '<style>'+customCSS+'</style>';
            }
        }

        /* insert rendered html into DOM */
        var $element = self.getGroupContainer();
        var $configurator = self.getDomElement();
        if ($element.length == 0) {
            if ($configurator && $configurator.length == 1) {
                $configurator.append(html);
            }
        } else {
            $element.remove();
            $configurator.append(html);
        }

        // Do not load responsive tabs plugin when the layout  `no_groups` is chosen
        if (self.getConfig("groupLayout") != "no_groups"){
            self.getDomElement().on('tabs-activate', function (e, activatedTab) {
                $configurator.off('tabs-activate');
                if(activatedTab.id > 0) {
                    var $activeGroup = self.getActiveGroup().getDomElement();
                    if($activeGroup.length == 1) {
                        var $tabItemA = $configurator.find('ul.r-tabs-nav a[href=#' + $activeGroup.attr('id') + ']');
                        $tabItemA.trigger('click');
                    }
                }
            });
            /* create tabs markup */
            if (Justselling_Configento_App_Helper.getCollapsedTabsOnInitLoad()) {
                self.getGroupContainer().responsiveTabs({startCollapsed: true});
            } else {
                self.getGroupContainer().responsiveTabs({startCollapsed: 'tabs'});
            }
            // Hide hidden accordion tabs
            self.getGroupContainer().find('.r-tabs-panel.state-hidden').prev('div.r-tabs-accordion-title').addClass('state-hidden');

            if (self.getConfig("groupWizard")) {
                Justselling_Configento_App_Wizard.showWizardButtons(true);
            }
        }

        jQuery(document).trigger("configentoRenderAfter");
        Justselling_Configento_App_Debug.addDebug("configurator render done.");
    };

    /*
     * Load the handlebars template with the templates for the options
     */
    this.loadTemplate = function() {
        var $templates = Justselling_Configento_App_Helper.$template;
        if ($templates.length == 0) {
            var xhr = new XMLHttpRequest();
            var baseUrl = CONFIGENTO_PRODUCT.getCloudBase();
            if (typeof CONFIGENTO_PRODUCT.getFrontendUrl === "function") {
                baseUrl = CONFIGENTO_PRODUCT.getFrontendUrl();
            }
            xhr.open('GET', baseUrl + "js/justselling/configento/templates/options.html");
            xhr.setRequestHeader('Access-Control-Allow-Origin', "*");
            xhr.onload = function(  ) {
                if (xhr.status === 200 && xhr.response) {
                    var virtualDOM = document.implementation.createHTMLDocument('virtual');
                    Justselling_Configento_App_Helper.$template = jQuery(jQuery.parseHTML(xhr.response, virtualDOM));
                    if(self.getInternalId() && !self.isRestoreCompiled) {
                        self.loadCloudTemplate();
                    }
                    if (self.isRestoreCompiled) {
                        self.render();
                        for(var i=0; i<self.options.length;i++) {
                            self.options[i].render()
                        }
                        jQuery(document).trigger("configentoLoadTemplateAfter");
                    }
                }
            };
            xhr.send();
        }
    };

    this.prepareFormValidation = function() {
        /* We have to exclude the magento qty-field from form validation */
        if (CONFIGENTO_PRODUCT.getWebShopCode().indexOf('magento') != -1) {
            jQuery("#qty").attr("data-fv-excluded", "true");
            jQuery("#qty").parent().addClass("pure-control-group");
        }
        // Fix for input groups withou pure-control-group
        jQuery(CONFIGENTO_PRODUCT.getForm()).addClass("pure-control-group");
        var head = (typeof(js_head) !== 'undefined' && js_head)?  js_head : window.head;
        var validatorLanguagePack = "js/justselling/configento/external/formValidation/language/" + CONFIGENTO_PRODUCT.getLocale()+".js";
        head.load(
            CONFIGENTO_PRODUCT.getCloudBase() + validatorLanguagePack,
            function() {
                var $validation = jQuery(CONFIGENTO_PRODUCT.getForm()).formValidation({
                    framework: 'pure',
                    button: {
                        selector: CONFIGENTO_PRODUCT.getSubmitButtonSelector()
                    },
                    icon: {
                        valid: 'fa fa-check',
                        invalid: 'fa fa-times',
                        validating: 'fa fa-refresh'
                    },
                    message:  Justselling_Configento_App_Translate.translate('This value is not valid'),
                    locale: CONFIGENTO_PRODUCT.getLocale()
                });
                Justselling_Configento_App_Debug.addDebug("prepareFormValidation done ");
            }
        );
    };

    this.initCombinedImage = function() {
        if ((self.getConfig("combinedimage") != 'no') && (self.getConfig("combinedimage") != 0)) {
            self.setCombinedImage(new Justselling_Configento_CombinedImage_CombinedImage(self));
        }
    };


    /*
     * @author: Michael Tjupalow
     */
    this.loadSettingsFromTemplate = function(template) {
        // array of config keys to identify, which vars should be parsed to boolean
        var parseBooleanConfig = ["showMinMax", "displayPrice", "displayPriceIfZero", "priceIncludesTax", "groupWizard"];
        // Prepare the request url for recieving settings
        if (typeof template == 'object') {
            try {
                jQuery.each(template, function(key, value) {
                    // assign config, if value is no object.
                    if(typeof value !== 'object' || key == "headline" || key == "customFields") {
                        // If the current key should be parsed to boolean
                        if(jQuery.inArray(key, parseBooleanConfig) >= 0){
                            value = JSON.parse(value);
                        }
                        self.setConfig(key, value);
                    }
                });
                if(template.hasOwnProperty('setting')) {
                    var parseSpecificSetting = ['priceIncludesTax', 'taxRate', 'matrix_delimiter', 'default_locale', 'default_currency_code'];
                    jQuery.each(template['setting'], function (key, value) {
                        if (jQuery.inArray(key, parseSpecificSetting) >= 0) {
                            // if key is priceIncludesTax parse it as boolean value
                            if (key == 'priceIncludesTax') {
                                value = JSON.parse(value);
                            }
                            self.setConfig(key, value);
                        }
                    });
                    Justselling_Configento_App_Tax.init();
                }
            } catch(err) {
                Justselling_Configento_App_Debug.addDebug("EXCEPTION parsing settings data: " + err.message);
                Justselling_Configento_App_Debug.addDebug(err);
            }
        }
    };

    this.processCloudData = function(data) {
        try {
            var start = new Date().getTime();
            jQuery(document).trigger("configentoLoadTemplateBefore");
            var start1 = new Date().getTime();

            // Init Tax rates
            var currencyRates = JSON.parse(CONFIGENTO_PRODUCT.getCurrencyRates());
            if(!_.isArray(currencyRates)) {
                Justselling_Configento_App_Currency.setRates(currencyRates);
            }

            var start1 = new Date().getTime();
            var template = JSON.parse(data['data']);
            self.setTemplateLabel(template['title']);        var end1 = new Date().getTime();
            var time1 = end1 - start1;
            Justselling_Configento_App_Profiler.addMeasuring("configurator::loadCloudTemplate.ajax-execute-JSONparse", time1);

            var start1 = new Date().getTime();
            self.loadSettingsFromTemplate(template);
            var end1 = new Date().getTime();
            var time1 = end1 - start1;
            Justselling_Configento_App_Profiler.addMeasuring("configurator::loadCloudTemplate.ajax-execute-loadSettings", time1);

            var start1 = new Date().getTime();
            Justselling_Configento_App_Storage.parseCloudTemplate(template, self);
            var end1 = new Date().getTime();
            var time1 = end1 - start1;
            Justselling_Configento_App_Profiler.addMeasuring("configurator::loadCloudTemplate.ajax-execute-parseJSON", time1);

            var start1 = new Date().getTime();
            self.initCombinedImage();
            var end1 = new Date().getTime();
            var time1 = end1 - start1;
            Justselling_Configento_App_Profiler.addMeasuring("configurator::loadCloudTemplate.ajax-execute-combinedimage", time1);

            var start1 = new Date().getTime();
            self.updateOptionsInDom();
            var end1 = new Date().getTime();
            var time1 = end1 - start1;
            Justselling_Configento_App_Profiler.addMeasuring("configurator::loadCloudTemplate.ajax-execute-updateOptionsInDom", time1);

            Justselling_Configento_App_Reporting.init();

            jQuery(document).trigger("configentoLoadTemplateAfter");
            var end = new Date().getTime();
            var time = end - start;
            Justselling_Configento_App_Profiler.addMeasuring("configurator::loadCloudTemplate.ajax-execute", time, true);

            self.prepareFormValidation();
            if (Justselling_Configento_App_Helper.getDeepLinkByOptionsId()) {
                if (self.getUrlParams().length > 0) {
                    Justselling_Configento_App_Api.setOptionValues(self.getUrlParams())
                }
            }

            if (CONFIGENTO_PRODUCT.productPricesBySku) {
                var collectSkus = [];
                for (var i = 0; i < self.options.length; i++) {
                    var option = self.options[i];
                    if (((option.getType() !== 'expression') || (option.choice == null))
                        && (option.visibility != CONFIGENTO.OPTION_VISIBLE_SHOP)) {
                        if (typeof option.getChoices() !== 'undefined' && option.getChoices()) {
                            for (var j = 0; j < option.getChoices().length; j++) {
                                var choice = option.getChoices()[j];
                                if (choice.getSku()) {
                                    collectSkus.push(choice.getSku())
                                }
                            }
                        }
                    }
                }
                CONFIGENTO_PRODUCT.getProductPricesBySku(collectSkus);
            }

            /*
            jQuery.get( "http://127.0.0.1/configento-admin/magento1/pc4backend/service/fk",  function() {
            })
            .done(function(response) {
                var json = JSON.decycle(self);
                var buffer = JSON.stringify(json);
                var storeCompildUrl = 'http://127.0.0.1/' + "configento-admin/magento1/pc4backend/service/storeconfigurator/";

                var data = new FormData();
                data.append('id', templateId);
                data.append('data', buffer);
                data.append('formkey', response);
                var xhr2 = new XMLHttpRequest();
                xhr2.open('POST', storeCompildUrl, true);
                xhr2.onload = function () { };
                xhr2.send(data);
            });
            */

        } catch(err) {
            Justselling_Configento_App_Debug.addDebug("EXCEPTION parsing cloud data: " + err.message, true);
            Justselling_Configento_App_Debug.addDebug(err, true);
            self.getDomElement().html("The product configurator can currently not be loaded. Please try again. <br/>If the error persists inform the webshop operator.");
        }

        CONFIGENTO_PRODUCT.hideLoadingAnimation();
        Justselling_Configento_App_Profiler.showProfiling();
    }

    /*
     * Load json template from cloud system and trigger parsing it to objects
     */
    this.loadCloudTemplate = function(templateId) {
        var self = this;
        if(templateId) {
            self.setInternalId(templateId);
        }
        templateId = self.getInternalId();
        if(!Justselling_Configento_App_Helper.$template) {
            return false;
        }

        var localData = ""; //Justselling_Configento_App_LocalStorage.get(templateId.toString());
        if (localData && !Justselling_Configento_App_LocalStorage.isOnline()) {
            this.processCloudData(localData);
        } else {
            var cloudBase = CONFIGENTO_PRODUCT.getCloudBase();
            var cloudToken = CONFIGENTO_PRODUCT.getCloudToken();

            if (cloudBase.search("configento") != -1) {
                cloudBase = cloudBase.replace(/\/configento\/$/, "");
            }

            var url =  cloudBase + "/pc/fe/template/get/" + templateId;

            var xhr = new XMLHttpRequest();
            xhr.open('GET', url);
            xhr.setRequestHeader('x-jscloud-tok', cloudToken);
            xhr.onload = function(  ) {
                if (xhr.status === 200 && xhr.response) {
                    var data = JSON.parse(xhr.response);
                    Justselling_Configento_App_LocalStorage.save(templateId.toString(), data);
                    self.processCloudData(data);
                }
                else {
                    Justselling_Configento_App_Debug.addDebug(xhr.status+' '+ xhr.responseText, true);
                    self.getDomElement().html("The product configurator can currently not be loaded. Please try again. <br/>If the error persists inform the webshop operator. <br> "+xhr.status+' '+ xhr.responseText);
                    CONFIGENTO_PRODUCT.hideLoadingAnimation();
                }
            };
            xhr.send();

            Justselling_Configento_App_Toolbar.render();
        }
    };

    // Disabling autoDiscover, otherwise Dropzone will try to attach twice.
    if(typeof Dropzone != "undefined" && Dropzone) {
        Dropzone.autoDiscover = false;
    }

    self.setId(id);
    self.defaultConfig();
    /* If we are in edit mode (comming from cart) we have predefined values for the options */
    if (predefinedValues && predefinedValues != "null") {
        var decodedValues = Base64.decode(predefinedValues);
        predefinedValues = JSON.parse(decodedValues);
        self.setPredefinedValues(predefinedValues);
    }
    if (templateId) {
        self.loadTemplate();
    }

    self.setUrlParams(urlParams);

    var fps = 20;
    var now;
    var then = Date.now();
    var interval = 10000/fps;
    var delta;

    function draw() {
        requestAnimationFrame(draw);
        now = Date.now();
        delta = now - then;

        if (delta > interval) {
            then = now - (delta % interval);

            if (self.hideElements && self.hideElements.length > 0) {
                try {
                    self.hideElements.hide(0);
                } catch(err) {}
                self.hideElements = false;
            }
            if (self.showElements && self.showElements.length > 0) {
                try {
                    self.showElements.show(0);
                } catch(err) {}
                self.showElements = false;
            }
        }
    }
    draw();
    return this;
};

(function($) {
    FormValidation.Validator.minfileupload = {
        validate: function(validator, $field, options) {
            var filesCtr = $field.attr('data-fileupload-files');
            var optionTitle = $field.attr('data-cf-title');
            var option = Justselling_Configento_App_Helper.getConfigurator().getOption(optionTitle);
            var minFiles = option.getMinFiles()?option.getMinFiles():1;

            if(option.getIsRequired() && ((filesCtr && parseInt(filesCtr) < minFiles) || !filesCtr )) {
                return {
                    valid: false,
                    message: Justselling_Configento_App_Translate.translate('Min %s Files must be selected').replace('%s', minFiles)
                };
            }
            if(!option.getIsRequired() && filesCtr && parseInt(filesCtr) !== 0 && parseInt(filesCtr) < minFiles ) {
                return {
                    valid: false,
                    message: Justselling_Configento_App_Translate.translate('Min %s Files must be selected').replace('%s', minFiles)
                };
            }



            return true;
        }
    };
    FormValidation.Validator.minmultiqty = {
        validate: function(validator, $field, options) {
            var optionTitle = $field.attr('data-cf-title');
            var option = Justselling_Configento_App_Helper.getConfigurator().getOption(optionTitle);
            var minQty = option.getMinQty()? parseInt(option.getMinQty()) :0;
            var wholeQty = option.getWholeQty()? parseInt(option.getWholeQty()) :0;

            if(option.getIsRequired() && ( wholeQty == 0 || ( minQty > wholeQty )  )) {
                return {
                    valid: false,
                    message: Justselling_Configento_App_Translate.translate('Min %s Files must be selected').replace('%s', minQty)
                };
            }
            if(!option.getIsRequired() && wholeQty > 0 && ( minQty > wholeQty ) ) {
                return {
                    valid: false,
                    message: Justselling_Configento_App_Translate.translate('Min %s Files must be selected').replace('%s', minQty)
                };
            }


            return true;
        }
    };

    FormValidation.Validator.requiredradiocheck = {
        validate: function(validator, $field) {
            var checkedInputs = $field.closest('.option.configento').find('input:checked');
            if(checkedInputs.length == 0) {
                return {
                    valid: false,
                    message: Justselling_Configento_App_Translate.translate('Please make a selection')
                }
            }
            return true;
        }
    };

}(window.jQuery));
// Fix by maikel for issue when providing floats with comma
var nativeParseFloat = parseFloat;
parseFloat = function(n) {
    if(typeof n == "string" && n.match(/\./g) == null && n.match(/\,/g) != null) {
        n = n.replace(/,/, '.')
    }
    return nativeParseFloat(n);
}

var Justselling_Configento_App_Helper = {
    lastRuleId : 0,
    formValidator : null,
    $template: '',
    clear360Array: [],
    canvas360css: {
        bottom: 0,
        width: 0,
        height: 0,
        containerWidth: 0,
        ContainerHeight: 0,
        correctionPosition: 0,
        left: 0,
        top: 0,
        margin: ''
    },
    customTooltip: false,
    backgroundImage: false,
    customContainerCanvasClass: false,
    canvasWidth: 0,
    canvasHeight: 0,
    store: false,
    sequences360IconAfter: false,
    multipleLAyers: [],
    optionScopeDidChange: false,
    sequences360IconCSS: false,
    sequences360TextCSS: false,
    sequences360TextLoading: '',
    sequences360TextFinish: '',
    cancelDownloadingImages: false,
    customCombinedImage: false,
    collapsedTabsOnInitLoad: false,
    canvasFinalImageSize: {
        width: 0,
        height: 0
    },
    imageInlineCss: '',
    imageContainerInlineCss: '',
    calculateCenter: {
        containerWidth: 0,
        containerHeight: 0,
        takeAsTheyAreSet: false
    },
    imageLeftCenter: 0,
    calculateTopImage: 0,
    combineImageCss: false,
    reverseImages: false,
    activeGroupLayer: false,
    responsive360preview: false,
    windowStopMaster: false,
    backgroundWidth: 0,
    backgroundHeight: 0,
    layerPosition: [],
    showTooltipInOverlay: false,
    deepLinkByOptionsId: true,
    dataCfInternalId: [],
    initOptionLoad: 0,
    forcePredefinedOptions: false,
    errorMessage: {
        html: '',
        message: ''
    },
    errorMessageHelper: '',
    errorMessageHelperIndex: '',
    errorMessageHelperHtml: '',
    filterRequiredOptions: '',

    pdfSize: {
        width: 0,
        height: 0
    },

    pdfInchToMetric: 0.000264583333333334, //m2

    setPdfInchToMetric: function (value) {
        this.pdfInchToMetric = value;
    },

    getPdfInchToMetric: function() {
       return this.pdfInchToMetric;
    },

    setPdfSize: function (width, height) {
        this.pdfSize.width = width;
        this.pdfSize.height = height;
    },

    getPdfSizeWidth: function () {
      return  this.pdfSize.width;
    },
    getPdfSizeHeight: function () {
        return  this.pdfSize.height;
    },

    setFilterRequiredOptions: function (options) {
        this.filterRequiredOptions = options;
    },

    getFilterRequiredOptions: function () {
        return this.filterRequiredOptions;
    },

    setForcePredefinedOptions: function (flag) {
        this.forcePredefinedOptions = flag;
    },

    getForcePredefinedOptions: function () {
        return this.forcePredefinedOptions;
    },

    setInitOptionLoad: function (numOfOptions) {
        this.initOptionLoad = numOfOptions;
    },

    getInitOptionLoad:function () {
        return this.initOptionLoad;
    },

    setDeepLinkByOptionsId: function(bool) {
        this.deepLinkByOptionsId = bool;
    },

    getDeepLinkByOptionsId: function() {
        return this.deepLinkByOptionsId;
    },

    checkDataCfInternalId: function(id) {
        this.dataCfInternalId.push(id);
    },

    setErrorPopupMessage: function (html, message, type, groupIndex) {
        this.errorMessage.html = html;
        this.errorMessage.message = message;
        this.errorMessage.type = type;
        this.errorMessage.groupIndex = groupIndex;
    },

    setErrorPopupMessageHelper: function (messageHelper) {
        this.errorMessageHelper = messageHelper;
    },

    getErrorPopupMessageHelper: function () {
        return this.errorMessageHelper;
    },

    setErrorPopupMessageHelperIndex: function (messageHelperIndex) {
        this.errorMessageHelperIndex = messageHelperIndex;
    },

    getErrorPopupMessageHelperIndex: function () {
        return this.errorMessageHelperIndex;
    },

    setErrorMessageHelperHtml: function (html) {
        this.errorMessageHelperHtml = html;
    },

    getErrorMessageHelperHtml: function () {
        return this.errorMessageHelperHtml;
    },



    getErrorPopupMessage: function () {
        return this.errorMessage;
    },

    checkForDuplicatesInternalId: function() {
        var duplicates_list = [];
        var unique_list = [];
        jQuery.each( Justselling_Configento_App_Helper.dataCfInternalId, function(key, value){
            if(jQuery.inArray(value, unique_list ) == -1){
                unique_list.push(value);
            }else{
                if(jQuery.inArray(value, duplicates_list ) == -1){
                    duplicates_list.push(value);
                }
            }
        });

        if (duplicates_list.length > 0) {
            console.log('%c ' + 'duplicated data-cf-internalid -> ', 'color: white; background-color: #b70707', duplicates_list + ' possible problem with rules!');
        } else {
            console.log('No duplicates');
        }
    },


    setShowTooltipInOverlay: function(overlay) {
        this.showTooltipInOverlay = overlay;
    },

    getShowTooltipInOverlay: function() {
        return this.showTooltipInOverlay;
    },

    setLayerPosition: function(position) {
        this.layerPosition = position;
    },

    getLayerPosition: function() {
        return this.layerPosition;
    },

    setBackgroundWidth: function(width) {
        this.backgroundWidth = width;
    },

    getBackgroundWidth: function() {
        return this.backgroundWidth;
    },
    setBackgroundHeight: function(height) {
        this.backgroundHeight = height;
    },

    getBackgroundHeight: function() {
        return this.backgroundHeight;
    },

    setWindowStopMaster: function(stop) {
        this.windowStopMaster = stop;
    },

    getWindowStopMaster: function() {
        return this.windowStopMaster;
    },

    getImageContainer360Size: function() {
        var heightOfImage = jQuery(Justselling_Configento_App_Helper.getGalleryClass() + ' img');
        var previewContainer = jQuery('#preview-image');
        var size = {
            width : 360,
            height: 360
        };

        /* with this we will secure to center rotation object vertical */
        jQuery('.js-360-ci-product-media').addClass('center-rotation');


        if (previewContainer.length > 0) {
            if (previewContainer.width() > 0) {
                size.width = previewContainer.width();
            }
            if (previewContainer.height() > 0) {
                size.height = previewContainer.height();
            }
        }

        if (heightOfImage.length > 0) {
            if (heightOfImage.width() > 0) {
                size.width = heightOfImage.width();
            }
            if (heightOfImage.height() > 0) {
                size.height = heightOfImage.height();
            }
        }
        /* if we have some special logic, e.g egomobile than don't set this default one */
        if (Justselling_Configento_App_Helper.getCustomContainerCanvasClass()) {
            size.width = '';
            size.height = '';
        }

        return size;
    },

    setResponsive360preview: function(responsive) {
        this.responsive360preview = responsive;
    },

    getResponsive360preview: function() {
        return this.responsive360preview;
    },

    setActiveGroupLayer: function(layer) {
        this.activeGroupLayer = layer;
    },
    getActiveGroupLayer: function() {
        return this.activeGroupLayer;
    },

    setReverseImages: function(reverse) {
        this.reverseImages = reverse;
    },

    getReverseImages: function() {
        return this.reverseImages;
    },

    setCombineImageCss: function(combine) {
        this.combineImageCss = combine;
    },

    getCombineImageCss: function() {
        return this.combineImageCss;
    },

    setImageLeftCenter: function(left) {
        this.imageLeftCenter = left;
    },

    getImageLeftCenter: function() {
        return this.imageLeftCenter;
    },

    setCalculateTopImage: function(top) {
        this.calculateTopImage = top;
    },

    getCalculateTopImage: function() {
        return this.calculateTopImage;
    },

    setCalculateCenter: function(width, height, takeAsTheyAreSet) {
        this.calculateCenter.containerWidth = width;
        this.calculateCenter.containerHeight = height;
        this.calculateCenter.takeAsTheyAreSet = takeAsTheyAreSet;
    },
    getCalculateCenter: function() {
        return this.calculateCenter;
    },

    setImageContainerInlineCss: function(css) {
        this.imageContainerInlineCss = css;
    },

    getImageContainerInlineCss: function() {
        return this.imageContainerInlineCss;
    },

    setImageInlineCss: function(css) {
        this.imageInlineCss = css;
    },

    getImageInlineCSS: function() {
        return this.imageInlineCss;
    },

    setCollapsedTabsOnInitLoad: function(state) {
        this.collapsedTabsOnInitLoad = state;
    },
    getCollapsedTabsOnInitLoad: function() {
        return this.collapsedTabsOnInitLoad;
    },

    setCanvasFinalImageSize: function(width, height) {
        this.canvasFinalImageSize.width = width;
        this.canvasFinalImageSize.height = height;
    },

    setCustomCombinedImage: function(custom) {
        this.customCombinedImage = custom;
    },

    getCustomCombinedImage: function() {
        return this.customCombinedImage;
    },

    setCancelDownloadingImages: function (flag) {
        this.cancelDownloadingImages = flag;
    },

    getCancelDownloadingImages: function () {
        return this.cancelDownloadingImages;
    },

    setSequences360TextLoading: function (text) {
        this.sequences360TextLoading = text;
    },

    getSequences360TextLoading: function () {
        return this.sequences360TextLoading;
    },

    setSequences360TextFinish: function (text) {
        this.sequences360TextFinish = text;
    },

    getSequences360TextFinish: function () {
        return this.sequences360TextFinish;
    },

    setSequences360TextCSS: function (css) {
        this.sequences360TextCSS = css;
    },

    getSequences360TextCSS: function () {
        return this.sequences360TextCSS;
    },

    setSequences360IconCSS: function (css) {
        this.sequences360IconCSS = css;
    },

    getSequences360IconCSS: function () {
        return this.sequences360IconCSS;
    },

    setOptionScopeDidChange: function (flag) {
        this.optionScopeDidChange = flag;
    },

    getOptionScopeDidChange: function () {
        return this.optionScopeDidChange;
    },

    setStore: function (store) {
        this.store = store;
    },

    getStore: function () {
        return this.store;
    },

    setCurrentCanvasWidth: function (width) {
        this.canvasWidth = width;
    },

    getCurrentCanvasWidth: function () {
        return this.canvasWidth;
    },


    setCurrentCanvasHeight: function (height) {
        this.canvasHeight = height;
    },

    getCurrentCanvasHeight: function () {
        return this.canvasHeight;
    },

    setCustomContainerCanvasClass: function (classContainer) {
        this.customContainerCanvasClass = classContainer;
    },

    getCustomContainerCanvasClass: function () {
        return this.customContainerCanvasClass;
    },

    setBackgroundImage: function (image) {
        this.backgroundImage = image;
    },

    getBackgroundImage: function () {
        return this.backgroundImage;
    },

    setCustomTooltip: function (tooltip) {
        this.customTooltip = tooltip;
    },

    getCustomTooltip: function () {
        return this.customTooltip;
    },


    setSequences360IconAfter: function (id_class) {
        this.sequences360IconAfter = id_class;
    },

    getSequences360IconAfter: function () {
        return this.sequences360IconAfter;
    },

    setCanvas360css: function (bottom, width, height, containerWidth, ContainerHeight, correctionPosition, left, top, margin) {
        this.canvas360css.bottom = bottom;
        this.canvas360css.width = width;
        this.canvas360css.height = height;
        this.canvas360css.containerWidth = containerWidth;
        this.canvas360css.ContainerHeight = ContainerHeight;
        this.canvas360css.correctionPosition = correctionPosition;
        this.canvas360css.left = left;
        this.canvas360css.top = top;
        this.canvas360css.margin = margin;
    },

    getCanvas360css: function () {
        return this.canvas360css.bottom;
    },

    setBlacklistCombinedImages: function (list, remove, clearAll) {
        if (clearAll) {
            this.clear360Array = [];
        }
        var foundIndexRemove = this.clear360Array.indexOf(remove);
        if (remove && (foundIndexRemove >= 0)) {
            this.clear360Array.splice(foundIndexRemove, 1);
        }
        if (list && (this.clear360Array.indexOf(list) < 0)) {
            this.clear360Array.push(list);
        }
    },

    getBlacklistCombinedImages: function () {
        return this.clear360Array;
    },

    setMultipleLayers: function (list, remove) {
        var foundIndexRemove = this.multipleLAyers.indexOf(remove);
        if (remove && (foundIndexRemove >= 0)) {
            this.multipleLAyers.splice(foundIndexRemove, 1);
        }
        if (list && (this.multipleLAyers.indexOf(list) < 0)) {
            this.multipleLAyers.push(list);
        }
    },

    getMultipleLayers: function () {
        return this.multipleLAyers;
    },

    getConfigurator : function() {
        var configurator = null;
        if (configentoRegistry && typeof configentoRegistry == "object") {
            var firstKey = Object.keys(configentoRegistry)[0];
            configurator = configentoRegistry[firstKey];
        }
        return configurator;
    },

    getBaseImage: function (images) {
        // return false;
        if (!images) return false;
        var getBaseName = '';
        if(_.isArray(images)) {
            for (var i = 0; i <= images.length; i++) {
                if (typeof images[i] !== 'undefined') {
                    var splitName = images[i].filelink.split('baseimage');
                    if (splitName.length > 1) {
                        getBaseName = splitName[0] + 'baseimage' + splitName[1];
                    } else if (splitName) {
                        getBaseName = images[i].filelink;
                    }
                }
            }
        } else {
            getBaseName = images;
        }
        return getBaseName;
    },

    /**
     * sort array with objects
     * @param property
     * @returns {Function}
     */
    dynamicSort: function (property) {
        var sortOrder = 1;
        if(property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a,b) {
            var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            return result * sortOrder;
        }
    },

    /*
     * Remove any special character from label to get clean Id
     */
    getIdFromLabel: function(label) {
        if (typeof label === 'string' || label instanceof String) {
            label = label.normalize('NFD') // Normalize Unicode to NFD (decomposes characters)
                .replace(/[\u0300-\u036f]/g, '') // Remove diacritical marks (accents)
                .trim() // Remove leading/trailing spaces
                .replace(/\s+/g, '') // Remove all spaces
                .replace(/[><]/g, '') // Remove '>' and '<'
                .replace(/[|,.\\]/g, '_') // Replace '|', ',', '.', and '\' with '_'
                .replace(/[()\/]/g, '') // Remove parentheses and slashes
                .replace(/[äöüÄÖÜß&§$%'"´`?=\)\(^°!+]/g, '') // Remove German special chars and other punctuation
                .replace(/:/g, '-') // Replace colons with dashes
                .replace(/[\*"'<>]/g, '') // Remove asterisk, quotes, and angle brackets
                .toLowerCase(); // Convert to lowercase
        }
        return label;
    },
    getUniqueId : function (size) {
        // Math.random should be unique because of its seeding algorithm.
        // Convert it to base 36 (numbers + letters), and grab the first 9 characters
        // after the decimal.
        size = size != null ? size : 9;
        return Math.random().toString(36).substr(2, size);
    },

    getCloudBase : function() {
        var cloudBase = CONFIGENTO_PRODUCT.getCloudBase();
        return cloudBase;
    },

    getFrontendUrl : function() {
        var frontendUrl;
        if (typeof CONFIGENTO_PRODUCT.getFrontendUrl === "function") {
            frontendUrl = CONFIGENTO_PRODUCT.getFrontendUrl();
        } else {
            frontendUrl = CONFIGENTO_PRODUCT.getCloudBase();
        }
        return frontendUrl;
    },
    getBackendUrl : function() {
        var backendUrl;
        if (typeof CONFIGENTO_PRODUCT.getBackendUrl === "function") {
            backendUrl = CONFIGENTO_PRODUCT.getBackendUrl();
        } else {
            backendUrl = CONFIGENTO_PRODUCT.getCloudBase();
        }
        return backendUrl;
    },

    getCloudCDN : function(id) {
        var cloudBase = CONFIGENTO_PRODUCT.getCloudBase();
        if (cloudBase.search("127.0.0.1") != -1 || cloudBase.search("localhost") != -1) {
            cloudBase = ('https:' == document.location.protocol ? 'https://' : 'http://') +"cloud99.justsellingapp.com/";
            cloudBase += "configentobe/media/";
            return cloudBase;
        }

        if (cloudBase.search("cloud99.justsellingapp.com") != -1) {
            cloudBase = 'https://cdn3.justsellingapp.com/';
            return cloudBase;
        }

        cloudBase = 'https://cdn.justsellingapp.com/';
        return cloudBase;
    },
    getAssetBasePath : function(id) {
        var cloudBase = this.getCloudCDN(id);
        if (cloudBase.search("127.0.0.1") != -1 || cloudBase.search("localhost") != -1) {
            cloudBase += "configurator/";
        }
        return cloudBase;
    },
    getAssetPath : function(id, internalId1, internalId2) {
        var path = Justselling_Configento_App_Helper.getAssetBasePath(id);
        //var path = 'http://127.0.0.1/configento-admin/media/configurator/';

        path += CONFIGENTO_PRODUCT.getCustomerId()+"/";
        path += CONFIGENTO_PRODUCT.getTemplateId()+"/";

        if (internalId1) {
            path += internalId1 + "/";
        }
        if (internalId2) {
            path += internalId2 + "/";
        }

        return path;
    },
    getGalleryClass : function() {
        if (Justselling_Configento_App_Helper.getCustomContainerCanvasClass()) {
            return '.gallery-placeholder';
        }
        var galleryClass = ".product-image .product-image-gallery";
        if(CONFIGENTO_PRODUCT.getWebShopCode() == 'magento2') {
            galleryClass = '.product.media .gallery-placeholder .fotorama__active';
        }
        // IF the CSS Path of the combined image container is provided use this.
        if(typeof CONFIGENTO_PRODUCT.getCssPathCombinedImageConainer === 'function'
            && CONFIGENTO_PRODUCT.getCssPathCombinedImageConainer()) {
            galleryClass = CONFIGENTO_PRODUCT.getCssPathCombinedImageConainer();
        }

        if(CONFIGENTO_PRODUCT.getWebShopCode() == 'woocommerce') {
            galleryClass = '.woocommerce-product-gallery__wrapper div';
        }

        return galleryClass
    },
    getBaseName : function(path) {
        /* TODO this should be removed later on, it's because we have wrong data in database for the moment */
        if (path && typeof path == "string") {
            if (path.indexOf(".jpg.jpg")) {
                path = path.replace(".jpg.jpg", ".jpg");
            }
        }

        if (path && typeof path == "string") {
            if (path.indexOf("/") != -1) {
                var parts = path.split("/");
                var baseName = parts[parts.length-1];
                return baseName;
            }
        }
        return path;
    },

    getRuleId : function() {
        this.lastRuleId = this.lastRuleId + 1;
        return this.lastRuleId;
    },

    valueIn : function(value, myObject) {
        var bool = false;
        var self = this;
        if(_.isArray(value)) {
            _.each(value, function (val) {
                if(_.contains(myObject, val) || _.contains(myObject, String(value)) ) {
                    bool = true;
                }
            });
            return bool;
        }
        else if (_.isArray(myObject)) {
            bool = _.contains(myObject, value);
            if(!bool) {
                bool = _.contains(myObject, String(value));
            }
            return bool;
        }
        return false;
    },

    getFormValidator : function() {
        if (Justselling_Configento_App_Helper.formValidator) {
            return Justselling_Configento_App_Helper.formValidator;
        }
        var $form = jQuery(CONFIGENTO_PRODUCT.getForm());
        if ($form && $form.length == 1) {
            var formValidator = $form.data('formValidation');
            Justselling_Configento_App_Helper.formValidator = formValidator;
            return formValidator;
        }
        return null;
    },
    getTranslatedLabel : function(labelObject) {
        var locale = CONFIGENTO_PRODUCT.getLocale();
        var default_locale = this.getConfigurator().getConfig('default_locale');
        if (typeof labelObject == 'object' && labelObject[locale]) {
            return labelObject[locale];
        } else if(typeof labelObject == 'object' && labelObject[default_locale] != null) {
            return labelObject[default_locale];
        }
        /* in case all fall down, use what you got. Prevent to configurator stop! */
        if (typeof labelObject[locale] === 'undefined') {
            var getLocaleInTemplate = ''; // if we have multiple values, take only one!
            for (var property in labelObject ) {
                getLocaleInTemplate = property;
            }
            return labelObject[getLocaleInTemplate];
        }
        return undefined;
    },

    ucfirst : function(string) {
        if(_.isNaN(string)) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }else {
            return '';
        }
    },

    qtyInputHtml: function(qty, minQty, maxQty, title) {
        // min qty can´t be higher than max qty
        if (minQty > maxQty) {
            minQty = maxQty;
        }
        var qtySelect = '<input class="qty" min="' + minQty + '"  max=' + maxQty + ' name="qty-' + title + '" value="' + qty + '" type="number" data-cf-title="' + title + '"' +
            'data-fv-between-min="' + minQty + '" data-fv-between-max="' + maxQty + '"  data-fv-between="true" ' +
            'data-fv-trigger="change keyup blur" >x ';
        return qtySelect;
    },
    qtySelectHtml: function(qty, minQty, maxQty, title) {
        if (minQty > maxQty) {
            minQty = maxQty;
        }
        var qtySelect = '<select class="qty" data-cf-title="' + title + '">';
        for (var startQty = minQty; startQty <= maxQty; startQty++) {
            var selected = qty == startQty ? 'selected="selected"' : '';
            qtySelect += '<option value="' + startQty + '" ' + selected + ' >' + startQty + '</option>';
        }
        qtySelect += '</select>x ';
        return qtySelect;
    },
    round: function(value, decimals) {
        return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
    },
    getCookie: function(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    setCookie: function(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getInfoTextForBlacklistedChoice: function(choice) {
        var html = '<p>'+Justselling_Configento_App_Translate.translate("This feature does not match your current selection.")+'</p>';
        return html;
    },

    /**
     * will allow us to track percent of loaded image
     */
    expandImageForMonitoring: function () {
        Image.prototype.onChangeSize;
        Image.prototype.load = function(url){
            var _this = this,
                req   = ((XMLHttpRequest) ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP"));
            req.open('GET', url, true);
            req.responseType = 'arraybuffer';
            req.onload = function(e) {
                if(req.response) {
                    var blob = new Blob([req.response]);
                    _this.src = window.URL.createObjectURL(blob);
                }
            };
            req.onprogress = function(e) {
                if(_this.onChangeSize) {
                    _this.onChangeSize(e.loaded, e.total);
                }
            };
            req.send();
        };
    }
};

var Justselling_Configento_App_Reporting = {
    gaId: null,
    page: '/pcc',
    templateLabel: null,
    cid: null,
    hideOptions: null,
    reportFull: false,

    init : function(value) {
        var configurator = Justselling_Configento_App_Helper.getConfigurator();
        if (configurator && typeof configurator == "object") {
            var reporting = configurator.getConfig('reporting_enabled');
            if (reporting == "1") {
                this.gaId = configurator.getConfig('reporting_ga_id');
                this.page = configurator.getConfig('reporting_page');
                this.reportFull = configurator.getConfig('reporting_full');
                if (configurator.getConfig('reporting_hide_options')) {
                    this.hideOptions = configurator.getConfig('reporting_hide_options').split(",");
                }
                this.templateLabel = configurator.getTemplateLabel().replace(/\//g, " ");

                this.cid = Justselling_Configento_App_Helper.getCookie('pcc-cid');
                if (!this.cid) {
                    this.cid = this.generateCid();
                    Justselling_Configento_App_Helper.setCookie('pcc-cid', this.cid, 30);
                }

                var self = this;
                jQuery(document).on('configentoOptionUpdateValueInDomAfter', function(event, params) {
                    var option = params['option'];
                    if (!option) return;
                    if (!self.hideOption(option.getTitle())) {
                        Justselling_Configento_App_Reporting.trackOption(option);
                    }
                    if (self.reportFull == "1") {
                        Justselling_Configento_App_Reporting.trackConfiguration(configurator);
                    }
                });
            }
        }
    },

    hideOption: function(optionId) {
        if (!this.hideOptions) return false;

        var indexInArray = this.hideOptions.indexOf(optionId);
        if (indexInArray != -1) return true;

        return false;
    },

    trackOption: function(option) {
        try {
            var title = this.templateLabel;
            var page = this.page + "/" + encodeURI(this.templateLabel.toString().toLowerCase()) + "/";
            var optionPath = option.getLabel();
            if (optionPath) {
                title += "-" + optionPath;
                page += encodeURI(optionPath.toString().toLowerCase().replace(/\//g, " ")) + "/";
            }

            var valuePath = option.getValue();
            if (option.getActiveChoice()) {
                var activeChoice = option.getActiveChoice();
                if (activeChoice) {
                    if (_.isArray(activeChoice)) {
                        for(var $i =0; $i<=activeChoice.length; $i++) {
                            if (typeof activeChoice[$i] !== 'undefined') {
                                valuePath += '-'+activeChoice[$i].getLabel();
                            }
                        }
                    } else {
                        valuePath = activeChoice.getLabel();
                    }
                }
            }
            if (valuePath) {
                title += "-" + valuePath;
                page += encodeURI(valuePath.toString().toLowerCase().replace(/\//g, " ")) + "/";
            }

            var settings = {
                "async": true,
                "crossDomain": true,
                "url": "https://www.google-analytics.com/collect",
                "method": "POST",
                "data": "v=1&tid=" + this.gaId + "&cid=" + this.cid + "&t=pageview&dp=" + page + "&dt=" + title
            }

            jQuery.ajax(settings).done(function (response) {
            });
        } catch(err) {
            console.log("Problem with reporting did occur");
            console.log(err);
        }
    },

    trackConfiguration : function(configurator) {
        var page = this.page + "-full/";
        var title = this.templateLabel;
        var options = configurator.getOptions();
        var isFirstOption = true;
        try {
            for (var n = 0; n < options.length; n++) {
                var option = options[n];
                if (!Justselling_Configento_App_Reporting.hideOption(option.getTitle())) {
                    if (!option.getIsBlacklisted() && (option.getVisibility() == CONFIGENTO.OPTION_VISIBLE_TRUE || option.getVisibility() == CONFIGENTO.OPTION_VISIBLE_BACKEND)) {
                        var optionPath = option.getLabel();
                        if (optionPath) {
                            title += "-" + optionPath;
                            if (!isFirstOption) page += "-";
                            page += encodeURI(optionPath.toString().toLowerCase().replace(/\//g, " ")) + ":";
                            isFirstOption = false;
                        }

                        var valuePath = option.getValue();
                        if (option.getActiveChoice()) {
                            var activeChoice = option.getActiveChoice();
                            if (activeChoice) {
                                var activeChoices = [activeChoice];
                                if (jQuery.isArray(activeChoice)) {
                                    activeChoices = activeChoice;
                                }
                                valuePath = "";
                                for (var c = 0; c < activeChoices.length; c++) {
                                    var choice = activeChoices[c];
                                    if (valuePath) valuePath += ",";
                                    valuePath += choice.getLabel();
                                }
                            }
                        }
                        if (!valuePath) valuePath = 'none';
                        if (valuePath) {
                            title += ":" + valuePath;
                            page += encodeURI(valuePath.toString().toLowerCase().replace(/\//g, " "));
                        }
                    }
                }
            }

            var settings = {
                "async": true,
                "crossDomain": true,
                "url": "https://www.google-analytics.com/collect",
                "method": "POST",
                "data": "v=1&tid=" + this.gaId + "&cid=" + this.cid + "&t=pageview&dp=" + page + "&dt=" + title
            }

            jQuery.ajax(settings).done(function (response) {
            });
        } catch (err) {
            Justselling_Configento_App_Debug.addDebug(err);
        }

        return true;
    },


    generateCid: function() {
        var ts = Math.round(+new Date() / 1000.0);
        var rand;

        try{
            var uu32 = new Uint32Array(1);
            rand = crypto.getRandomValues(uu32)[0];
        } catch(e) {
            rand = Math.round(Math.random() * 2147483647);
        }

        return [rand, ts].join('.');
    },
}
Handlebars.registerHelper('option', function (id,
                                              internalId,
                                              optionInternalId,
                                              actValue,
                                              value,
                                              myExpression,
                                              label,
                                              price,
                                              thumb,
                                              infoText,
                                              required,
                                              selectedValue,
                                              choiceGroup,
                                              isEmptyChoice,
                                              imageWidth,
                                              imageHeight,
                                              qtyType,
                                              qty,
                                              minQty,
                                              maxQty,
                                              optionMinQty,
                                              optionMaxQty) {
    var selectedProperty =  '';
    if(( _.isArray(selectedValue) && _.indexOf(selectedValue, id) >=0) || (id == selectedValue)) {
        selectedProperty = 'selected="selected"';
    }

    if(myExpression) {
        price = parseFloat(actValue) * parseFloat(price);
    }
    if(!qtyType && qty) {
            price = price * qty;
    }

    var priceHtml = Justselling_Configento_App_Price.renderPrice(price, optionInternalId);

    var thumbBaseName = Justselling_Configento_App_Helper.getBaseName(thumb);
    var thumbAttribute = "";
    if (thumb && thumbBaseName) {
        var assetsPath = Justselling_Configento_App_Helper.getAssetPath(id, optionInternalId, internalId);

        /* if we have array, that means that we have 360 plugin, and we show only first image, add */
        if (_.isArray(thumbBaseName)) {
            var checkthumb = thumb;
            if (typeof thumb[0] !== 'undefined') {
                checkthumb = thumb[0].filelink;
            }
            thumbAttribute = ' data-img-src="' + assetsPath + checkthumb + '" ';
        } else {
            thumbAttribute = ' data-img-src="' + assetsPath + thumbBaseName + '" ';
        }

        if(imageWidth != null) {
            thumbAttribute += ' data-img-width="' + imageWidth + '" ';
        }
        if(imageHeight != null) {
            thumbAttribute += ' data-img-height="' + imageHeight + '" ';
        }
    }

    var valueAttribute = "";
    if (value != undefined) {
        valueAttribute = ' value="' + value + '" ';
    }

    var internalIdAttribute = "";
    if (internalId) {
        Justselling_Configento_App_Helper.checkDataCfInternalId(internalId);
        internalIdAttribute = ' data-cf-internalid="' + internalId + '" ';
    }
    var choiceGroupAttribute = "";
    if (choiceGroup != null) {
        choiceGroupAttribute = ' data-cf-choicegroup="' + choiceGroup + '" ';
    }

    var infoTextAttribute = "";
    if (infoText) {
        infoTextAttribute = ' data-cf-infotext="' + _.escape(infoText)  + '" ';
    }

    var additionalInfo = "";
    if (typeof this.additionalInfo !== 'undefined') {
        additionalInfo = ' data-cf-additionalInfo="' + _.escape(this.additionalInfo)  + '" ';
    }

    var disabledAttribute = "";
    if (isEmptyChoice && required) {
        disabledAttribute = ' disabled="disabled" ';
    }
    var qtyAttributes = '';
    if (qtyType && selectedProperty != '') {
        qty = qty ? qty : 1;
        priceHtml = Justselling_Configento_App_Price.renderPrice(Number(price) * qty, optionInternalId);
        // if the option has min max qty´s we use them, else we take default values
        optionMaxQty = optionMaxQty ? optionMaxQty : 999;
        // Min qty for radiobuttons is 1
        optionMinQty = optionMinQty ? optionMinQty : 1;
        // if the choice has itself min max qty´s we us them instead of the option qty´s
        var qtyMax = maxQty ? maxQty : optionMaxQty;
        var qtyMin = minQty ? minQty : optionMinQty;

        qtyAttributes = ' data-qty-qty="'+qty+'" data-qty-min="'+qtyMin+'" data-qty-max="'+qtyMax+'" ';
    }

    return new Handlebars.SafeString(
        '<option id="' + id + '" data-cf-label="'+label+'"  data-cf-title="' + id + '"' + internalIdAttribute + thumbAttribute + valueAttribute +
        choiceGroupAttribute + infoTextAttribute + additionalInfo + selectedProperty + disabledAttribute + qtyAttributes + '>' +
        label + ' '+priceHtml +
        "</option>"
    );
});

Handlebars.registerHelper('radiobutton', function (choice,
                                                   optionInternalId,
                                                   qtyType,
                                                   optionMinQty,
                                                   optionMaxQty,
                                                   selectedValue,
                                                   name,
                                                   showAllChoiceImages) {

    var selectedProperty =  '';
    if(( _.isArray(selectedValue) && _.indexOf(selectedValue, choice.id) >=0) || (choice.id == selectedValue)) {
        selectedProperty = 'checked="checked"';
    }

    var disabledCssClass = 'choice-label';
    var isDisabled= '';
    if (choice.isBlacklisted) {
        isDisabled += ' disabled="disabled"';
        disabledCssClass += ' disabled ';
    }

    var price = choice.price;
    if(choice.myExpression) {
        price = parseFloat(choice.value) * parseFloat(price);
    }
    var priceHtml = Justselling_Configento_App_Price.renderPrice(price, optionInternalId);

    var choiceImage = "";
    if (showAllChoiceImages) {
        var imageBaseName = Justselling_Configento_App_Helper.getBaseName(choice.image);
        if (choice.image && imageBaseName) {
            var choiceInternalId = choice.internalId;
            var assetsPath = Justselling_Configento_App_Helper.getAssetPath(choice.id, optionInternalId, choiceInternalId);
            var passCheckImage = true;
            if (Array.isArray(choice.image) && !choice.image.length) {
                passCheckImage = false
            }
            if (choice.image && typeof choice.image !== "string" && passCheckImage) {
                if (typeof choice.image[0] !== 'undefined') {
                    var getBaseName = Justselling_Configento_App_Helper.getBaseImage(choice.image);
                    if (getBaseName) {
                        imageBaseName = getBaseName;
                    } else {
                        imageBaseName = choice.image[0].filelink;
                    }
                } else {
                    imageBaseName = choice.image;
                }
            }
            choiceImage = '<img class="choice-image '+disabledCssClass+'" src="' + assetsPath + imageBaseName + '" > ';
        }
        else {
            choiceImage = '<div '+disabledCssClass+'" class="choice-image" ></div> ';
        }
    }

    var valueAttribute = "";
    if (choice.originalValue != undefined) {
        valueAttribute = ' value="' + choice.originalValue + '" ';
    }
    var choiceGroupAttribute = "";
    if (choice.choiceGroup != null) {
        choiceGroupAttribute = ' data-cf-choicegroup="' + choice.choiceGroup + '" ';
    }

    var choiceGroupLayer = "";
    if (choice.groupLayer != null) {
        choiceGroupLayer = ' data-cf-grouplayer="' + choice.groupLayer + '" ';
    }

    var internalIdAttribute = "";
    if (choice.internalId) {
        Justselling_Configento_App_Helper.checkDataCfInternalId(choice.internalId);
        internalIdAttribute = ' data-cf-internalid="' + choice.internalId + '" ';
    }

    var infoTextDiv = "";
    if (choice.infoText) {
        infoTextDiv = '<div class="info-text">'+ choice.infoText +'</div>';
    }

    var infoTextDivAdditional = "";
    if (choice.additionalInfo) {
        infoTextDivAdditional = '<div class="infotext-additional">'+choice.additionalInfo+'</div>';
    }

    var qtyElement = '';
    if (qtyType && selectedProperty != '') {
        var qty = choice.qty ? choice.qty : 1;
        priceHtml = Justselling_Configento_App_Price.renderPrice(Number(price) * qty, optionInternalId);
        // if the option has min max qty´s we use them, else we take default values
        optionMaxQty = optionMaxQty ? optionMaxQty : 999;
        // Min qty for radiobuttons is 1
        optionMinQty = optionMinQty ? optionMinQty : 1;
        // if the choice has itself min max qty´s we us them instead of the option qty´s
        var qtyMax = choice.maxQty ? choice.maxQty : optionMaxQty;
        var qtyMin = choice.minQty ? choice.minQty : optionMinQty;

        if (qtyType == 1) {
            qtyElement = Justselling_Configento_App_Helper.qtyInputHtml(qty, qtyMin, qtyMax, choice.id);
        }
        else if (qtyType == 2) {
            qtyElement = Justselling_Configento_App_Helper.qtySelectHtml(qty, qtyMin, qtyMax, choice.id);
        }
    }
    return new Handlebars.SafeString(choiceImage +
        '<input type="radio" '+isDisabled+' id="' + choice.id + '" name="' + name + '" data-cf-title="' + choice.id + '"' + internalIdAttribute +
        choiceGroupAttribute + choiceGroupLayer + valueAttribute + selectedProperty + '>' +
        qtyElement +
        '<label class="'+disabledCssClass+'" '+isDisabled+' for="' + choice.id + '">' + choice.label + priceHtml + ' </label>' + infoTextDiv + infoTextDivAdditional);
});

Handlebars.registerHelper('package', function (option) {
    var disabledCssClass = 'choice-label';
    var isDisabled= '';
    if (option.isBlacklisted) {
        isDisabled += ' disabled="disabled"';
        disabledCssClass += ' disabled';
    }

    var internalIdAttribute = "";
    if (option.internalId) {
        Justselling_Configento_App_Helper.checkDataCfInternalId(option.internalId);
        internalIdAttribute = ' data-cf-internalid="PCK-' + option.internalId + '" ';
    }

    var priceHtml = Justselling_Configento_App_Price.renderPrice(option.price, option.internalId);

    var infoText = option.infotext2;
    var infoTextDiv = "";
    if (infoText) {
        infoTextDiv = '<div class="info-text">'+ infoText +'</div>';
    }

    var $html = '<label class="'+disabledCssClass+'" for="' + option.id + '-choice"> <input '+isDisabled+' type="checkbox" id="' + option.id + '-choice" name="' + name + '" data-cf-title="' + option.id + '"' + internalIdAttribute +' value="' + option.title + '">' +
        option.label + priceHtml + ' </label>' + infoTextDiv;
    return new Handlebars.SafeString($html);
});

Handlebars.registerHelper('checkbox', function (choice,
                                                   optionInternalId,
                                                   qtyType,
                                                   optionMinQty,
                                                   optionMaxQty,
                                                   wholeQty,
                                                   selectedValue,
                                                   name,
                                                   showAllChoiceImages) {

    var selectedProperty =  '';
    if(( _.isArray(selectedValue) && _.indexOf(selectedValue, choice.id) >=0) || (choice.id == selectedValue)) {
        selectedProperty = 'checked="checked"';
    }

    /* Get infotext by choice object, to make sure have current one */
    var configurator = Justselling_Configento_App_Helper.getConfigurator();
    var optionObject = configurator.getOptionByInternalId(optionInternalId);
    var choiceObject = optionObject.getChoiceByInternalId(choice.internalId);
    var infoText = choiceObject.getInfoText();
    var infoTextAdditional = choiceObject.getInfoTextAdditional();

    var isDisabled= '';
    var disabledCssClass = 'choice-label';
    if (choice.isBlacklisted) {
        isDisabled += ' disabled="disabled"';
        disabledCssClass += ' disabled';
    }

    var price = choice.price;
    if(choice.myExpression) {
        price = parseFloat(choice.actValue) * parseFloat(price);
    }
    var priceHtml = Justselling_Configento_App_Price.renderPrice(price, optionInternalId);

    var choiceImage = "";
    if (showAllChoiceImages) {
        var cssClass="choice-image";
        var imageBaseName = Justselling_Configento_App_Helper.getBaseName(choice.image);
        if (choice.image && imageBaseName) {
            if (choice.isBlacklisted) { cssClass += ' disabled'; }
            var assetsPath = Justselling_Configento_App_Helper.getAssetPath(choice.id, optionInternalId, choice.internalId);
            var passCheckImage = true;
            if (Array.isArray(choice.image) && !choice.image.length) {
                passCheckImage = false
            }
            if (choice.image && typeof choice.image !== "string" && passCheckImage) {
                var getBaseName = Justselling_Configento_App_Helper.getBaseImage(choice.image);
                if (getBaseName) {
                    imageBaseName = getBaseName;
                } else {
                    if (choice.image.length > 0)
                        imageBaseName = choice.image[0].filelink;
                }
            }
            choiceImage = '<img class="'+cssClass+'" src="' + assetsPath + imageBaseName + '" > ';
        }
        else {
            choiceImage = '<div class="'+cssClass+'" ></div> ';
        }
    }

    var valueAttribute = "";
    if (choice.value != undefined) {
        valueAttribute = ' value="' + choice.value + '" ';
    }
    var choiceGroupAttribute = "";
    if (choice.choiceGroup != null) {
        choiceGroupAttribute = ' data-cf-choicegroup="' + choice.choiceGroup + '" ';
    }

    var choiceGroupLayer = "";
    if (choice.groupLayer != null) {
        choiceGroupLayer = ' data-cf-grouplayer="' + choice.groupLayer + '" ';
    }

    var internalIdAttribute = "";
    if (choice.internalId) {
        Justselling_Configento_App_Helper.checkDataCfInternalId(choice.internalId);
        internalIdAttribute = ' data-cf-internalid="' + choice.internalId + '" ';
    }

    var infoTextDiv = "";
    var infoTextDivAdditional = "";
    if (infoText) {
        infoTextDiv = '<div class="info-text">'+ infoText +'</div>';
    }
    if (infoTextAdditional) {
        infoTextDivAdditional = '<div class="infotext-additional">'+infoTextAdditional+'</div>';
    }
    var qty = choice.qty;
    if( selectedProperty !== '' && qty == null) {
        qty = 1;
    }
    var qtyElement = '';
    // TODO make max qty with whole qty work together ()
    if (qtyType && selectedProperty != '') {
        qty = qty ? qty : 1;
        priceHtml = Justselling_Configento_App_Price.renderPrice(Number(price) * qty, optionInternalId);
        // if the option has min max qty´s we use them, else we take default values
        optionMaxQty = optionMaxQty ? optionMaxQty : 999;
        // Min qty for radiobuttons is 1
        optionMinQty = optionMinQty ? optionMinQty : 1;
        // if the choice has itself min max qty´s we us them instead of the option qty´s
        var qtyMax = choice.maxQty ? choice.maxQty : optionMaxQty;
        var qtyMin = choice.minQty ? choice.minQty : optionMinQty;

        // recalculate remaining qty Max val one qty is set already
        if(qty >= 0) {
            priceHtml = Justselling_Configento_App_Price.renderPrice(Number(price) * qty, optionInternalId);
            // first calc remaining qty for option
            var remainingMaxQty = Number(optionMaxQty) - Number(wholeQty) + Number(qty);
            if(!(choice.maxQty &&  choice.maxQty < remainingMaxQty)){
                qtyMax = remainingMaxQty;
            }
        }

        if (qtyType == 1) {
            qtyElement = Justselling_Configento_App_Helper.qtyInputHtml(qty, qtyMin, qtyMax, choice.id);
        }
        else if (qtyType == 2) {
            qtyElement = Justselling_Configento_App_Helper.qtySelectHtml(qty, qtyMin, qtyMax, choice.id);
        }
    }
    var result = choiceImage +
        '<label class="'+disabledCssClass+'" for="' + choice.id + '"> <input '+isDisabled+' type="checkbox" id="' + choice.id + '" name="' + name + '" data-cf-title="' + choice.id + '"' + internalIdAttribute +
        choiceGroupAttribute + choiceGroupLayer + valueAttribute + selectedProperty+ '>' +
        qtyElement +
        '' + choice.label + priceHtml + ' </label>' + infoTextDiv + infoTextDivAdditional;


    var newCheckboxHandler = new Handlebars.SafeString(result);

    /**
     * yes, we are using setTimeout, reason is that system need to load DOOM stuffs after action,
     * so we have this small delay, in case we have tooltip, we need to assign it again after each rendering!
     */
    setTimeout(function () {
            jQuery('.c-__option-choices-group .info-text').each(function () {
                var _this = jQuery(this);
                _this.children().css({'opacity': 0}); // avoid flickering effect
                if (_this.html() != '') {
                    if (_this.hasClass("tooltipstered")) _this.tooltipster('destroy');
                    _this.tooltipster({
                        content: _this.html(),
                        theme: 'tooltipster-light',
                        contentAsHTML: true,
                        maxWidth: 800,
                        interactive: true,
                        trigger: 'click'
                    }).on("click", function() {
                        setTimeout(function () {
                            jQuery('.tooltipster-content').children().css({'opacity': 1});
                        }, 200);
                    })
                }
                /* this code is now inside tooltip, so we don't need it any more! */
                setTimeout(function () {
                    if (Justselling_Configento_App_Helper.getShowTooltipInOverlay()) {
                        _this.children().hide();
                    } else {
                        _this.children().html('')
                    }
                },1);
            });
    }, 100);
    return newCheckboxHandler;
});

Handlebars.registerHelper('qtyChoice', function (id,
                                                   internalId,
                                                   optionInternalId,
                                                   actValue,
                                                   value,
                                                   myExpression,
                                                   label,
                                                   price,
                                                   image,
                                                   infoText,
                                                   qtyType,
                                                   qty,
                                                   minQty,
                                                   maxQty,
                                                   optionMinQty,
                                                   optionMaxQty,
                                                   wholeQty,
                                                   selectedValue,
                                                   choiceGroup,
                                                   name,
                                                   showAllChoiceImages,
                                                    groupLayer) {

    var selectedProperty =  '';
    if(( _.isArray(selectedValue) && _.indexOf(selectedValue, id) >=0) || (id == selectedValue)) {
        selectedProperty = 'selected="selected"';
    }

    if(myExpression) {
        price = parseFloat(actValue) * parseFloat(price);
    }
    var priceHtml = Justselling_Configento_App_Price.renderPrice(price, optionInternalId);

    var choiceImage = "";
    if (showAllChoiceImages) {
        var imageBaseName = Justselling_Configento_App_Helper.getBaseName(image);
        if (image && imageBaseName) {
            var assetsPath = Justselling_Configento_App_Helper.getAssetPath(id, optionInternalId, internalId);
            if (image && typeof image !== "string") {
                var getBaseName = Justselling_Configento_App_Helper.getBaseImage(image);
                if (getBaseName) {
                    imageBaseName = getBaseName;
                } else {
                    if (image )
                        imageBaseName = image[0].filelink;
                }
            }
            choiceImage = '<img class="choice-image" src="' + assetsPath + imageBaseName + '" > ';
        }
        else {
            choiceImage = '<div class="choice-image" ></div> ';
        }
    }

    var valueAttribute = "";
    if (value != undefined) {
        valueAttribute = ' value="' + value + '" ';
    }

    var choiceGroupLayer = "";
    if (groupLayer != null) {
        choiceGroupLayer = ' data-cf-grouplayer="' + groupLayer + '" ';
    }

    var choiceGroupAttribute = "";
    if (choiceGroup != null) {
        choiceGroupAttribute = ' data-cf-choicegroup="' + choiceGroup + '" ';
    }

    var internalIdAttribute = "";
    if (internalId) {
        Justselling_Configento_App_Helper.checkDataCfInternalId(internalId);
        internalIdAttribute = ' data-cf-internalid="' + internalId + '" ';
    }

    var infoTextAttribute = "";
    if (infoText) {
        infoTextAttribute = ' data-cf-infotext="' + infoText + '" ';
    }

    var qtyElement = '';

    if( selectedProperty !== '' && qty == null) {
        qty = 0;
    }
    // if the option has min max qty´s we use them, else we take default values
    optionMaxQty = optionMaxQty ? optionMaxQty : 999;
    // Min qty for radiobuttons is 1
    optionMinQty = optionMinQty ? optionMinQty : 0;
    // if the choice has itself min max qty´s we us them instead of the option qty´s
    var qtyMax = maxQty ? maxQty : optionMaxQty;
    var qtyMin = 0;
    //var qtyMin = minQty ? minQty : optionMinQty;

    // recalculate remaining qty Max val one qty is set already
    if(qty >= 0) {
        priceHtml = Justselling_Configento_App_Price.renderPrice(Number(price) * qty, optionInternalId);
        // first calc remaining qty for option
        var remainingMaxQty = Number(optionMaxQty) - Number(wholeQty) + Number(qty);
        if((qtyMax &&  qtyMax > remainingMaxQty)){
            qtyMax = remainingMaxQty;
        }
    }
    if (qtyType == 1) {
        qtyElement = Justselling_Configento_App_Helper.qtyInputHtml(qty, qtyMin, qtyMax, id);
    }
    else if (qtyType == 2) {
        qtyElement = Justselling_Configento_App_Helper.qtySelectHtml(qty, qtyMin, qtyMax, id);
    }

    return new Handlebars.SafeString(choiceImage +qtyElement+
        '<input type="hidden" id="' + id + '" name="' + name + '[]" data-cf-title="' + id + '"' + internalIdAttribute +
        choiceGroupAttribute + choiceGroupLayer + valueAttribute + infoTextAttribute + selectedProperty + '>' +
        '<label for="' + id + '">' + label + priceHtml + ' </label>');
});

Handlebars.registerHelper('optionImage', function (image, id, optionInternalId, container, customClass) {
    if (typeof image !== 'undefined' && image !== null) {
        if (container == 'undefined') container == true;

        var imageBaseName = Justselling_Configento_App_Helper.getBaseImage(image);

        var imagePath = "";
        if (image && imageBaseName) {
            imagePath = Justselling_Configento_App_Helper.getAssetPath(id, optionInternalId) + imageBaseName;
        }
        var optionInternalIdAttribute = "";
        if (optionInternalId) {
            Justselling_Configento_App_Helper.checkDataCfInternalId(optionInternalId);
            optionInternalIdAttribute = ' data-cf-internalid="' + optionInternalId + '" ';
        }

        var customClassHtml = "";
        if ((customClass != 'undefined') && (typeof customClass !== 'undefined')) {
            customClassHtml = 'class="'+customClass+'"';
        }
        var $html = '<img ' + customClassHtml + ' src="' + imagePath + '"' + optionInternalIdAttribute + '>';
        if (container) $html = '<div class="optionImage" >' + $html + '</div>';

        return new Handlebars.SafeString($html);
    }
    else {
        return '';
    }
});

Handlebars.registerHelper('choiceImage', function (choice, optionInternalId) {
    if (typeof choice == 'object') {

        var choiceImage = "";
        var imageBaseName = Justselling_Configento_App_Helper.getBaseName(choice.image);
        var passCheckImage = true;
        if (Array.isArray(choice.image) && !choice.image.length) {
            passCheckImage = false
        }
        if (choice.image && imageBaseName && passCheckImage) {
            var assetsPath = Justselling_Configento_App_Helper.getAssetPath(choice.id, optionInternalId ,choice.internalId);
            if (choice.image && typeof choice.image !== "string") {
                var getBaseName = Justselling_Configento_App_Helper.getBaseImage(choice.image);
                if (getBaseName) {
                    imageBaseName = getBaseName;
                } else {
                    imageBaseName = choice.image[0].filelink;
                }
            }
            choiceImage = '<img class="choice-image" src="' + assetsPath + imageBaseName + '" >';
        }
        else {
            choiceImage = '<div class="choice-image" ></div>';
        }
        return new Handlebars.SafeString(choiceImage);
    }
    else {
        return '';
    }
});

Handlebars.registerHelper('optionQty', function (qtyType, wholeQty, minQty, maxQty, title ) {
    if(minQty < 1) {
        minQty = 1;
    }
    if(wholeQty < minQty || wholeQty == null) {
        wholeQty = minQty;
    }
    var qtyElement = '<div class="optionQty">';
    if (qtyType == 1) {
        qtyElement += Justselling_Configento_App_Helper.qtyInputHtml(wholeQty, minQty, maxQty, title);
    }
    else if (qtyType == 2) {
        qtyElement += Justselling_Configento_App_Helper.qtySelectHtml(wholeQty, minQty, maxQty, title);
    }
    qtyElement += '</div>';
    return new Handlebars.SafeString(qtyElement);
});

Handlebars.registerHelper('optionheader', function (option, showPrice, hideMinMax, hideInfoText, showImage) {
    var priceEl = '';
    if(showPrice == true ) {
        priceEl = '<label class="price">' + (option.priceHtml ? option.priceHtml : '')  + '</label>';
    }
    var infotextEl = '';
    if(hideInfoText != true) {
        infotextEl = '<div class="infotext">' + (option.infotext ? option.infotext : '') + '</div>';
    }
    var minmaxEl = '';
    if(hideMinMax != true) {
        minmaxEl = '<label class="minmax"></label>';
    }

    var headerClasses = ["optionheader"];
    if(showImage !== undefined && showImage != true) {
        headerClasses.push("without-image");
    }

    var el =
        '<div class="' + headerClasses.join(' ') + '"> ' +
        '<div class="optionlabel"> ' +
        '<label class="label">' + option.label + '</label>' +
        minmaxEl +
        '<div class="infotext2"></div>' +
        priceEl +
        '</div>' +
        infotextEl +
        '</div>';
    return new Handlebars.SafeString(el);
});
var Justselling_Configento_App_Locale = {
    getLocale : function() {
        var locale = CONFIGENTO_PRODUCT.getLocale();
	locale = locale.replace(/\-/i, '_');
        return locale;
    },
    getLanguage : function() {
        // de_DE or de_AT -> get the first langugae code
        return CONFIGENTO_PRODUCT.getLocale().split("_")[0];
    },
    getCountry : function() {
        // get the country part of the locale
        return CONFIGENTO_PRODUCT.getLocale().split("_")[1];
    }
};

var Justselling_Configento_App_Translate = {
    TRANSLATE : {},

    translate : function(string) {
        var locale = Justselling_Configento_App_Locale.getLocale();
        var translate = Justselling_Configento_App_Translate.TRANSLATE[locale];
        if (translate && translate[string]) {
            string = translate[string];
        }
        return string;
    }
}
var Justselling_Configento_App_Currency = {
    config: {
        rates: []
    },

    /**
     * @method setRates
     * @param {String} Rates as json
     */
    setRates: function (rates) {
        this.config.rates = rates;
    },

    /**
     * Convert value from base currency to store currency
     *
     * @method convert
     * @param {String} Base Currency Code
     * @return {number} Converted value to store currency
     */
    convert: function (value) {
        var currency = CONFIGENTO_PRODUCT.getStoreCurrencyCode();
        var configuratorCurrency = Justselling_Configento_App_Helper.getConfigurator().getConfig('default_currency_code');
        if (this.config.rates[currency]) {
            if (this.config.rates[configuratorCurrency]) {
                value = value / parseFloat(this.config.rates[configuratorCurrency]);
            }
            var rate = this.config.rates[currency];
            return (value * parseFloat(rate));
        }
        return value;
    },

    convertToBase: function (value) {
        var currency = CONFIGENTO_PRODUCT.getBaseCurrencyCode();
        if(!currency) {
            currency = CONFIGENTO_PRODUCT.getStoreCurrencyCode();
        }
        var configuratorCurrency = Justselling_Configento_App_Helper.getConfigurator().getConfig('default_currency_code');
        if (this.config.rates[currency]) {
            if (this.config.rates[configuratorCurrency]) {
                value = value / parseFloat(this.config.rates[configuratorCurrency]);
            }
            var rate = this.config.rates[currency];
            return (value * parseFloat(rate));
        }
        return value;
    },

    format: function (value, myLocale) {
        if (isNaN(value)) {
            return false;
        }
        var formatedValue = null;

        /* convert to correct currency rate price */
        value = this.convert(value);

        /*
         * Use this as fallback, if INTL is not implemented in browser
         * We have german as default and support for USD/$
         */
        if (typeof Intl !== 'object') {
            var decimal = ",";
            var thousand = ".";
            var format = "%v%s";
            if (CONFIGENTO_PRODUCT.getCurrencySymbol() == "$") {
                var decimal = ".";
                var thousand = ",";
                var format = "%s%v";
            }

            formatedValue = accounting.formatMoney(
                value,
                {
                    symbol: CONFIGENTO_PRODUCT.getCurrencySymbol(),
                    format: format,
                    decimal: decimal,
                    thousand: thousand,
                    precision: 2
                },
                2,
                ",",
                "."
            );
        }

        /* Check if the browser does support the Intl object to fomrat currrency correctly for given locale */
        if (typeof Intl === 'object') {
            var locale = Justselling_Configento_App_Locale.getLocale();
            if (myLocale != undefined) locale = myLocale;
            locale = locale.replace("_","-");

            var formatter = new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: CONFIGENTO_PRODUCT.getStoreCurrencyCode(),
                minimumFractionDigits: 2
            });
            formatedValue = formatter.format(value);
            if(CONFIGENTO_PRODUCT.getCurrencySymbol()) {
                formatedValue = formatedValue.replace(CONFIGENTO_PRODUCT.getStoreCurrencyCode(), CONFIGENTO_PRODUCT.getCurrencySymbol());
            }
        }

        return formatedValue;
    }
};
var Justselling_Configento_App_Tax = {
    configuratorTaxRate: 0,
    priceIncludesTax: 1,
    /**
     * Convert a price from configurator tax-settings to store tax-settings
     *
     * @method convert
     * @param {configuratorTaxRate} Tax rate for configurator prices
     * @param {storeTaxRate} Tax rate for webshop prices
     * @param {value} price to be converted
     * @return {Number} Converted price
     */
    convert : function(value) {
        var netValue = value;
        var storeValue = value;

        var configuratorTaxRate = this.configuratorTaxRate; // TODO: We have to get this value from global config of the customer
        if (!this.configuratorTaxRate && CONFIGENTO_PRODUCT.getTaxRate())  {
            this.configuratorTaxRate = CONFIGENTO_PRODUCT.getTaxRate();
        }
        var storeTaxRate = CONFIGENTO_PRODUCT.getTaxRate();

        if (jQuery.isNumeric(storeTaxRate) && this.priceIncludesTax) {
            netValue = netValue / (1 + configuratorTaxRate/100);
        }
        if (jQuery.isNumeric(storeTaxRate)) {
            storeValue = netValue * (1 + storeTaxRate/100);
        }
        //storeValue = Math.round(storeValue*100)/100;
        storeValue = (storeValue*100)/100;
        return storeValue;
    },
    convertToBase : function(value) {
        var netValue = value;
        var storeValue = value;

        var configuratorTaxRate = this.configuratorTaxRate;
        if (!this.configuratorTaxRate && CONFIGENTO_PRODUCT.getBaseTaxRate())  {
            this.configuratorTaxRate = CONFIGENTO_PRODUCT.getBaseTaxRate();
        }
        var storeTaxRate = CONFIGENTO_PRODUCT.getBaseTaxRate();

        if (jQuery.isNumeric(storeTaxRate) && this.priceIncludesTax) {
            netValue = netValue / (1 + configuratorTaxRate/100);
        }
        if (jQuery.isNumeric(storeTaxRate)) {
            storeValue = netValue * (1 + storeTaxRate/100);
        }

        storeValue = Math.round(storeValue*100)/100;
        return storeValue;
    },
    init: function() {
        var configurator = Justselling_Configento_App_Helper.getConfigurator();
        var configuratorTaxRate = configurator.getConfig('taxRate');
        if(configuratorTaxRate == null) {
            // Default Taxrate to 0 if no configurationvalue was found
            configuratorTaxRate = 0;
        }
        this.configuratorTaxRate = configuratorTaxRate;
        var priceIncludesTax = configurator.getConfig('priceIncludesTax');
        if(priceIncludesTax == null) {
            // Default prices are including tax if no configuration value was found
            priceIncludesTax = 1;
        }
        this.priceIncludesTax = priceIncludesTax;
    }
}
var Justselling_Configento_App_Price = {

    renderPrice : function(price, optionId) {
        var html = "";
        var configurator = Justselling_Configento_App_Helper.getConfigurator();

        var displayPriceType = configurator.getConfig("displayPriceType");
        if (displayPriceType == 'relative' && optionId) {
            var option = configurator.getOptionByInternalId(optionId);
            if (option) {
                option.setPrice(option.calculatePrice());
                var currentPrice = option.getPrice();
                price = price - currentPrice;
            }
        }

        if (!configurator.getConfig("displayPrice") ||
            ((price == 0 || price == null) && !configurator.getConfig("displayPriceIfZero"))
        ) {
            return "";
        }

        // Parse also strings with comma´s
        if(_.isString(price) && /^\d+,\d+$/.test(price) && jQuery.isNumeric(parseFloat(price.replace(/,/, '.')))) {
            price = parseFloat(price.replace(/,/, '.'));
        }
        /* set correct tax value */
        price = Justselling_Configento_App_Tax.convert(price);

        var check = Number(price);
        if (isNaN(check)) return "";

        /* format price for given locale */
        var formattedPrice = Justselling_Configento_App_Currency.format(price);

        html = formattedPrice;
        if (price > 0) {
            html = "+"+html;
        }

        var pattern = configurator.getConfig("displayPricePattern");
        if (pattern && html !='') {
            html = pattern.replace("$price", html);
        }

        return html;
    }
}
var Justselling_Configento_App_Wizard = {
    init : false,
    lastTabId: 0,

    getGroupContainer: function () {
        var configurator = Justselling_Configento_App_Helper.getConfigurator();
        if (configurator && typeof configurator == "object") {
            var tagId = configurator.getId() + "-groups";
            var $container = jQuery("#" + tagId);
            return $container;
        }
        return false;
    },

    setActivateGroup: function (index) {
        if ( Justselling_Configento_App_Api.processEvent( 'configentSetActivateGroupBefore', [index] ) === false )
            return false;

        var $groupContainer = this.getGroupContainer();
        if ($groupContainer && $groupContainer.length == 1) {
            $groupContainer.responsiveTabs('activate', index);
        }

        if ( Justselling_Configento_App_Api.processEvent( 'configentoWizardScrollBefore', [index] ) === false )
            return false;
    },
    setDisableGroup: function (index) {
        var $groupContainer = this.getGroupContainer();
        if ($groupContainer && $groupContainer.length == 1) {
            $groupContainer.responsiveTabs('disable', index);
        }
    },
    setEnableGroup: function (index) {
        var $groupContainer = this.getGroupContainer();
        if ($groupContainer && $groupContainer.length == 1) {
            $groupContainer.responsiveTabs('enable', index);
        }
    },

    updateWizard: function() {
          Justselling_Configento_App_Wizard.showWizardButtons();
    },

    /*
     * Set hide/show status for the previous/next-buttons on
     * all tabs/groups. E.g. first tab does not need a previous-button.
     */
    showWizardButtons: function (isStartup) {
        if (!this.init) {
            var self = this;
            this.init = true;
            var configurator = Justselling_Configento_App_Helper.getConfigurator();
            for (var i = 0; i < configurator.getNumberOfGroups(); i++) {
                var group = configurator.getGroupByIndex(i);
                var $previousButton = jQuery("#button-previous-" + group.getId());
                $previousButton.unbind();
                var $nextButton = jQuery("#button-next-" + group.getId());
                $nextButton.unbind();

                /* Disable all group, only first one is active at start-up */
                if (isStartup && i > 0) {
                    this.setDisableGroup(i);
                }
                /* attach handler to click on tab/group header */
                configurator.getGroupContainer().on("tabs-activate", function (event, tab) {
                    if(tab.id !== Justselling_Configento_App_Wizard.lastTabId) {
                        var cancel = false;
                        var currentActiveGroup = configurator.getActiveGroup();
                        var groupIndex = currentActiveGroup ? currentActiveGroup.getIndex() : 0;
                        currentActiveGroup.getDomElement().show(0);
                        if (tab.id <= groupIndex) {
                            groupIndex = tab.id;
                        } else {
                            for (var tmpIndex = groupIndex; tmpIndex <= tab.id; tmpIndex++) {
                               if(cancel ===  false) {
                                   var tmpGroup = configurator.getGroupByIndex(tmpIndex);
                                   var $tmpGroup = tmpGroup.getDomElement();
                                   $tmpGroup.css('display', 'block');
                                   if (!Justselling_Configento_App_Wizard.checkValidationForGroup($tmpGroup) && tab.id > tmpIndex) {
                                       cancel = true;
                                   }
                                   if (Justselling_Configento_App_Helper.getErrorPopupMessage().message && (Justselling_Configento_App_Helper.getConfigurator().getActiveGroup().getIndex() === Justselling_Configento_App_Helper.getErrorPopupMessageHelperIndex())) {
                                       Justselling_Configento_App_Wizard.popUpMsg();
                                       cancel = true;
                                   }
                                   groupIndex = tmpIndex;
                                   $tmpGroup.css('display', 'none');
                               }
                            }
                        }
                        currentActiveGroup.getDomElement().hide(0);
                        Justselling_Configento_App_Wizard.lastTabId = groupIndex;
                        configurator.setActiveGroupByIndex(groupIndex);
                        self.setEnableGroup(groupIndex);
                        self.setActivateGroup(groupIndex);
                        if(cancel === true) {
                            self.validateForm();
                        }
                    }
                });

                /* attach click handler */
                $previousButton.on("click", function () {
                    Justselling_Configento_App_Wizard.wizardPreviousButtonHandler();
                });
                $nextButton.on("click", function () {
                    Justselling_Configento_App_Wizard.wizardNextButtonHandler();
                });

                if (this.isFirstGroupIndex(i)) { /* first */
                    $previousButton.hide(0);
                    // Check if it´ not last
                    if (this.isLastGroupIndex(i)) {
                        $nextButton.hide(0);
                    } else {
                        $nextButton.show();
                    }

                } else if (this.isLastGroupIndex(i)) { /* last */
                    $previousButton.show();
                    $nextButton.hide(0);
                } else {
                    $previousButton.show();
                    $nextButton.show();
                }
            }
        }
    },

    isFirstGroupIndex: function(index) { /* private */
        var configurator = Justselling_Configento_App_Helper.getConfigurator();
        if (!isNaN(index) && configurator) {
            var groups = configurator.getGroups();
            for (var i = index - 1; i >= 0 && i < groups.length; i++) {
                var newGroup = groups[i];
                if (newGroup.getIsVisible()) {
                    return false;
                }
            }
            return true;
        }
        return null;
    },

    isLastGroupIndex: function(index) { /* private */
        var configurator = Justselling_Configento_App_Helper.getConfigurator();
        if (!isNaN(index) && configurator) {
            var groups = configurator.getGroups();
            for (var i = index + 1; i < groups.length; i++) {
                var newGroup = groups[i];
                if (newGroup.getIsVisible()) {
                    return false;
                }
            }
            return true;
        }
        return null;
    },

    getNextVisibleGroup: function(group) { /* private */
        var configurator = Justselling_Configento_App_Helper.getConfigurator();
        if (group && configurator) {
            var currentIndex = group.getIndex();
            var groups = configurator.getGroups();
            for (var i=currentIndex+1; i<groups.length; i++) {
                var newGroup = groups[i];
                if (newGroup.getIsVisible()) {
                    return i;
                }
            }
        }
        return false;
    },

    getPreviousVisibleGroup: function(group) { /* private */
        var configurator = Justselling_Configento_App_Helper.getConfigurator();
        if (group && configurator) {
            var currentIndex = group.getIndex();
            var groups = configurator.getGroups();
            for (var i=currentIndex-1; i>=0; i--) {
                var newGroup = groups[i];
                if (newGroup.getIsVisible()) {
                    return i;
                }
            }
        }
        return false;
    },

    updateScrollView: function ($el) {
        var configurator = Justselling_Configento_App_Helper.getConfigurator();
        var isAutoScroll = configurator.config.groupWizardAutoscroll == 0 ? false : true;
        if (!isAutoScroll) return false;
        var groupPos = $el.offset().top;
        var scrollPos = document.documentElement.scrollTop + 40;
        var offset = configurator.getConfig('groupScrollOffset');
        if(scrollPos > (groupPos - offset + 40)) {
            if ( Justselling_Configento_App_Api.processEvent( 'configentoWizardScrollBefore', [true] ) === false )
                return false;

            jQuery("html, body").animate({ scrollTop: (groupPos - offset) + "px" });

            if ( Justselling_Configento_App_Api.processEvent( 'configentoWizardScrollAfter', [true] ) === false )
                return false;
        }

    },

    popUpMsg: function() {
        var popupHtml = Justselling_Configento_App_Helper.getErrorPopupMessage().html === '' ? Justselling_Configento_App_Helper.getErrorMessageHelperHtml() : Justselling_Configento_App_Helper.getErrorPopupMessage().html;
        var $popupHtmlContainer = jQuery('#pc__error-rule');
        // Create Popupbox if it´s not found in DOM
        if($popupHtmlContainer.length === 0) {
            $popupHtmlContainer = jQuery('<div id="pc__error-rule"></div>');
            jQuery('body').append($popupHtmlContainer);

            $popupHtmlContainer.on('click', '.pc__popup-close, .pc__popup-cancel', function () {
                jQuery('#pc__error-rule').fadeOut(400);
            })
        }
        var msg = Justselling_Configento_App_Helper.getErrorPopupMessage().message === '' ? Justselling_Configento_App_Helper.getErrorPopupMessageHelper() : Justselling_Configento_App_Helper.getErrorPopupMessage().message;
        $popupHtmlContainer.html(popupHtml).fadeIn(400).find('.pc__popup-content').html(msg);
    },

    /*
     * User wants to step to next group/tab. Check if everything is
     * ok with form validation. If yes, activate next group/tab
     */
    wizardNextButtonHandler: function() {
        const configurator = Justselling_Configento_App_Helper.getConfigurator();
        var isAutoScroll = configurator.config.groupWizardAutoscroll == 0 ? false : true;
        const currentActiveGroup = configurator.getActiveGroup();

        if ( Justselling_Configento_App_Api.processEvent( 'configentoWizardNextButtonBefore', [currentActiveGroup] ) === false )
            return false;
        if ( Justselling_Configento_App_Api.processEvent( 'configentoWizardButtonBefore', [currentActiveGroup] ) === false )
            return false;

        /* first check for error message! */
        if (Justselling_Configento_App_Helper.getErrorPopupMessage().message && (Justselling_Configento_App_Helper.getConfigurator().getActiveGroup().getIndex() === Justselling_Configento_App_Helper.getErrorPopupMessageHelperIndex())) {
            this.popUpMsg();
        } else {
            if (this.checkValidationForActiveGroup() || this.validateForm()) {
                if (currentActiveGroup && typeof currentActiveGroup == "object") {
                    var newActiveIndex = this.getNextVisibleGroup(currentActiveGroup);
                    if (newActiveIndex) {
                        if ( Justselling_Configento_App_Api.processEvent( 'configentoWizardNextButtonAfter', [newActiveIndex] ) === false )
                            return false;
                        if ( Justselling_Configento_App_Api.processEvent( 'configentoWizardButtonAfter', [newActiveIndex] ) === false )
                            return false;

                        this.setEnableGroup(newActiveIndex);
                        this.setActivateGroup(newActiveIndex);

                        var $currentGroup = currentActiveGroup.getDomElement();
                        if ($currentGroup && isAutoScroll) {
                            var group = configurator.getActiveGroup().getDomElement();
                            this.updateScrollView(group);

                            $currentGroup.addClass('visited');
                            $currentGroup.parent().find('.r-tabs-state-active').addClass('visited');
                        }

                        configurator.setActiveGroupByIndex(newActiveIndex);

                        // Active index +1 because index begins at pos 0 and tabId at pos 1
                        Justselling_Configento_App_Wizard.lastTabId = newActiveIndex;
                        var formValidator = Justselling_Configento_App_Helper.getFormValidator();
                        if (formValidator) {
                            formValidator.disableSubmitButtons(false);
                        }

                        if ( Justselling_Configento_App_Api.processEvent( 'configentoActiveGroupVisible', [newActiveIndex] ) === false )
                            return false;
                    }
                    return true;
                }
            }
        }
    },

    /*
     * User wants to step to previous group/tab. Don´t check formvalidation
     * because user wants a step back.  activate previous group/tab
     */
    wizardPreviousButtonHandler: function() {
            var configurator = Justselling_Configento_App_Helper.getConfigurator();
            var isAutoScroll = configurator.config.groupWizardAutoscroll == 0 ? false : true;
            var currentActiveGroup = configurator.getActiveGroup();

        if ( Justselling_Configento_App_Api.processEvent( 'configentoWizardPreviousButtonBefore', [currentActiveGroup] ) === false )
            return false;
        if ( Justselling_Configento_App_Api.processEvent( 'configentoWizardButtonBefore', [currentActiveGroup] ) === false )
            return false;

            if (currentActiveGroup && typeof currentActiveGroup == "object") {
                var newActiveIndex = this.getPreviousVisibleGroup(currentActiveGroup);
                if (newActiveIndex != null) { // newActiveIndex can be 0, and it's for first group!
                    if ( Justselling_Configento_App_Api.processEvent( 'configentoWizardPreviousButtonAfter', [newActiveIndex] ) === false )
                        return false;
                    if ( Justselling_Configento_App_Api.processEvent( 'configentoWizardButtonAfter', [newActiveIndex] ) === false )
                        return false;

                    configurator.setActiveGroupByIndex(newActiveIndex);
                    this.setEnableGroup(newActiveIndex);
                    this.setActivateGroup(newActiveIndex);

                    var $currentGroup = currentActiveGroup.getDomElement();
                    if($currentGroup && isAutoScroll) {
                        this.updateScrollView($currentGroup);
                    }

                    // Active index +1 because index begins at pos 0 and tabId at pos 1
                    Justselling_Configento_App_Wizard.lastTabId = newActiveIndex;

                    var formValidator = Justselling_Configento_App_Helper.getFormValidator();
                    if (formValidator) {
                        formValidator.disableSubmitButtons(false);
                    }

                    if ( Justselling_Configento_App_Api.processEvent( 'configentoActiveGroupVisible', [newActiveIndex] ) === false )
                        return false;
                }
            }

    },

    /*
     * Validate the form using form validation plugin
     */
    validateForm: function() {
        if ( Justselling_Configento_App_Api.processEvent( 'configentoValidateFormBefore') === false )
            return false;

        var formValidator = Justselling_Configento_App_Helper.getFormValidator();
        if (formValidator) {
            var validationResult = formValidator.validate();
            if(validationResult.$invalidFields.length === 0) {
                if ( Justselling_Configento_App_Api.processEvent( 'configentoValidateFormAfter', [true]) === false )
                    return false;
                return true;
            }

            if ( Justselling_Configento_App_Api.processEvent( 'configentoValidateFormAfter', [false]) === false )
                return false;
            return false;
        }

        if ( Justselling_Configento_App_Api.processEvent( 'configentoValidateFormAfter', [true]) === false )
            return false;
        return true;
    },

    /*
     * Check if all form elements (configurator options) have validation-passed status
     * on current active tab/group. If yes reset validation and return true to allow
     * to step to next or previous tab/group
     * Otherwise retunr false to stay in invalid-group.
     */
    checkValidationForActiveGroup: function() {
        var configurator = Justselling_Configento_App_Helper.getConfigurator();
        var $groupElement = configurator.getActiveGroup().getDomElement();
        return this.checkValidationForGroup($groupElement);
    },

    checkValidationForGroup: function ($group) {
        if ( Justselling_Configento_App_Api.processEvent( 'configentoValidateGroupBefore', [$group]) === false )
            return false;

        var formValidator = Justselling_Configento_App_Helper.getFormValidator();
        if (formValidator && $group && $group.length == 1) {
            if (formValidator.isValidContainer($group)) {
                formValidator.disableSubmitButtons(false);

                if ( Justselling_Configento_App_Api.processEvent( 'configentoValidateGroupAfter', [true]) === false )
                    return false;
                return true;
            }
            formValidator.disableSubmitButtons(true);

            if ( Justselling_Configento_App_Api.processEvent( 'configentoValidateGroupAfter', [false]) === false )
                return false;
            return false;
        }

        if ( Justselling_Configento_App_Api.processEvent( 'configentoValidateGroupAfter', [true]) === false )
            return false;
        return true;
    },

    checkValidationForAllGroups: function () {
        var self = this;
        var configurator = Justselling_Configento_App_Helper.getConfigurator();
        var groups = configurator.getGroups();
        var ret =  _.find(groups, function() {
            return !self.wizardNextButtonHandler();
        });
        if(ret === true || ret === undefined) {
            return true;
        }
        return false;
    }
};

var Justselling_Configento_App_Summary = {
    config : {
        mapping : null,
        summary_as_text: ''
    },
    setMapping : function(mapping) {
        Justselling_Configento_App_Summary.config.mapping = mapping;
    },
    getMapping : function(mapping) {
        if (!Justselling_Configento_App_Summary.config.mapping) {
            if (CONFIGENTO_PRODUCT.mapping) {
                Justselling_Configento_App_Summary.config.mapping = CONFIGENTO_PRODUCT.mapping;
            }
        }
        return Justselling_Configento_App_Summary.config.mapping;
    },
    doMap : function (optionLabel, valueLabel) {
        var result = new Array();
        result['optionLabel'] = optionLabel;
        result['valueLabel'] = valueLabel;

        if (Justselling_Configento_App_Summary.getMapping()) {
            var mappings = Justselling_Configento_App_Summary.getMapping();
            for (var key in mappings) {
                var mapping = mappings[key];
                if (mapping.source_option == optionLabel && mapping.source_value == valueLabel) {
                    result['optionLabel'] = mapping.target_option;
                    result['valueLabel'] = mapping.target_value;
                    return result;
                }
            }
        }

        return result;
    },
    renderSummary : function(configurator, id) {
        var $element = jQuery("#"+id);
        var html = "";
        if ($element.length == 1) {
            var options = configurator.getOptions();
            for (var n=0; n<options.length; n++) {
                var option = options[n];
                if (!option.getIsBlacklisted() && (option.getVisibility() == CONFIGENTO.OPTION_VISIBLE_TRUE ||  option.getVisibility() == CONFIGENTO.OPTION_VISIBLE_BACKEND)) {
                    var activeChoice = option.getActiveChoice();
                    if (_.isArray(activeChoice)) {
                        /* don't show default options like: 'Please select option' */
                        if (option.getValue() == null || option.getValue() == "" || option.activeChoice.length === 0) {
                            continue;
                        }
                        html += '<div class="item '+option.getCustomClass()+'" id="summary-item-'+option.getId()+'">' +
                            '<div class="title">' + option.getLabel() + ': </div>' +
                            '<div class="value">';

                        _.each(activeChoice, function (choice) {
                            value = choice.getLabel();
                            if (option.getQtyType()) {
                                value = choice.getQty() + 'x ' + value;
                            }
                            result = Justselling_Configento_App_Summary.doMap(option.getLabel(), value);
                            if (result.valueLabel) {
                                if (value != null && typeof value != 'object') {
                                    html += '<div class="choiceValue">' + result.valueLabel + '</div>';
                                }
                            }
                        });
                        html += '</div>' +
                        '</div>' + '<!-- NL -->';
                    }
                    else {
                        var value = '';
                        var result = '';
                        var label = option.getLabel();
                        if (activeChoice instanceof Justselling_Configento_Option_Choice) {
                            if (typeof activeChoice.packageOptions !== 'undefined') {
                                activeChoice.setValue(activeChoice.getLabel());
                                label = Justselling_Configento_App_Translate.translate('Package');
                            }

                            value = activeChoice.getLabel();
                            if (option.getQtyType()) {
                                value = activeChoice.getQty() + 'x ' + value;
                            }
                            if (activeChoice.getValue() == null || activeChoice.getValue() == "") {
                                continue;
                            }
                        }
                        if (option.getType() == 'package' && option.getActive()) {
                            value = option.getLabel();
                            label = Justselling_Configento_App_Translate.translate('Package');
                        }
                        if ((option.getType() == 'text') || (option.getType() == 'area') || (option.getType() == 'expression')) {
                            if (option.isRendered && option.isVisible) {
                                value = option.getValue();
                                label = option.getLabel();
                            }
                        }
                        result = Justselling_Configento_App_Summary.doMap(label, value);
                        if (result.optionLabel && result.valueLabel) {
                            if (value != null && typeof value != 'object') {
                                html += '<div class="item '+option.getCustomClass()+'" id="summary-item-'+option.getId()+'">' +
                                    '<div class="title">' + result.optionLabel + ': </div>' +
                                    '<div class="value">' + result.valueLabel + '</div>' +
                                    '</div>' +
                                    '<!-- NL-->';
                            }
                        }
                    }
                }
            }

            if ($element.find(".summary")) {
                $element.find(".summary").html(html);
                var asText = '';
                if (html) {
                    asText = html.replace(/<!-- NL-->/g, '\n');
                    asText = asText.replace(/<\/?[^>]+(>|$)/g, "");
                }
                Justselling_Configento_App_Summary.config.summary_as_text = asText;
            }

            jQuery(document).trigger("configentoRenderSummaryAfter", {
                'text' : Justselling_Configento_App_Summary.getSummaryAsText(),
                'html' : html
            });

            return true;
        }
        return false;
    },

    updateSummaryInDOM : function(configurator) {
        var id = "configento-summary-left";
        this.renderSummary(configurator, id);

        id = "configento-summary-right";
        this.renderSummary(configurator, id);

        id = "configento-summary-tab";
        this.renderSummary(configurator, id);
    },

    getSummaryAsText : function() {
        return Justselling_Configento_App_Summary.config.summary_as_text;
    }
}

var Justselling_Configento_App_Storage = {
    dontBlacklistThisChoice: '',

    setDontBlacklistThisChoice: function(choice) {
        this.dontBlacklistThisChoice = choice;
    },

    getDontBlacklistThisChoice: function() {
      return this.dontBlacklistThisChoice;
    },

    /*
     * Load and parse template from cloud server
     * create configurator and related objects from json template
     */
    parseConfiguratorOptionChoices : function(option, choicesTemplate) {
        var result = [];
        if (option && choicesTemplate) {
            var choiceQty;
            var self = this;
            // set default qty´s if the option has qty´s activated
            if(option.getQtyType() ) {
                choiceQty = 0;
                // each choice of a radiobutton must have at least qty = 1
                if(option.getType() === 'radiobutton' || option.getType() === 'checkbox' || option.getType() === 'select' ) {
                    choiceQty = 1;
                }
                var choiceMinQty = parseInt(option.getMinQty());
                // if we have a minimum qty set the choice qty at this minimum
                if(choiceMinQty) {
                    // Be sure that radiobuttons have a min qty of 1
                    if(choiceMinQty < 1 && ( option.getType() === 'radiobutton' || option.getType() === 'checkbox' || option.getType() === 'select')) {
                        option.setMinQty(1);
                    }
                    choiceQty = parseInt(option.getMinQty());
                    // if the minimum qty is higher than max qty -> set min qty to same value as max qty
                    // and update the chocie qty
                    if(parseInt(option.getMaxQty()) < choiceQty){
                        choiceQty = option.getMaxQty();
                        option.setMinQty(choiceQty);
                    }
                }

            }
            _.each(choicesTemplate, function (choiceTemplate) {


           //for (var i=0; i<choicesTemplate.length; i++) {
             //   var choiceTemplate = choicesTemplate[i];
                // if we get an object with array, then we have a choice group
                if(_.isArray(choiceTemplate.choices)) {
                    var choiceGroupId = option.addChoiceGroup(self.getLabel(choiceTemplate.title));
                    _.each(choiceTemplate.choices, function(choice) {
                        choice['group'] = choiceGroupId;
                        var resultTmp = self.parseChoice(option, choice, choiceQty);
                        if(resultTmp != null) {
                            result.push(resultTmp);
                        }
                    });
                }
                else {
                    var resultTmp = self.parseChoice(option, choiceTemplate, choiceQty);
                    if(resultTmp != null) {
                        result.push(resultTmp);
                    }
                }
        //    }
            });
        }
        if(result.length === 0) {
            result = null;
        }
        return result;
    },

    parsePackageOption: function(option, choiceTemplate) {
        this.parseChoice(option, choiceTemplate, 1);
    },

    parseChoice: function(option, choiceTemplate, choiceQty){
        var choice = new Justselling_Configento_Option_Choice(
            option,
            this.getLabel(choiceTemplate['title']),
            choiceTemplate['value'],
            choiceTemplate['price'],
            choiceTemplate['thumbnail'],
            null,
            choiceTemplate["id"],
            choiceTemplate["sort_order"]
        );
        var result = null;

        var tmpQty = choiceQty;
        if (choice) {
            /*if (choiceTemplate["id"]) {
                choice.setInternalId(choiceTemplate["id"]);
            }*/
            if(choiceQty != null && option.getType() === 'multiquantity' || option.getType() === 'checkbox') {
                tmpQty = 0;
            }
            // get Default value
            var optionDefaultValue = option.getDefaultValue();
            // Create Dafaultvalue array
            if(!_.isArray(optionDefaultValue)) {
                optionDefaultValue = [optionDefaultValue];
            }
            // For predefined options we check only internalId´ because values can be duplicate
            if(option.getIsPredefined()) {
                var preObj = option.getPredefinedObject();
                // If internal id´s are equal, be sure to pass next condtion for setting as selected value
                if((_.isArray(preObj.valueId) && _.indexOf(preObj.valueId, parseInt(choiceTemplate["id"])) )
                    || preObj.valueId == choiceTemplate["id"]) {
                    optionDefaultValue = [choice.getOriginalValue()];
                } else {
                    optionDefaultValue = [];
                }
            }
            // Check if choice value is equal to option defaultvalue
            if (_.indexOf(optionDefaultValue, choice.getOriginalValue()) >=0 ) {
                // Set result to current choice
                result = choice;
                // set default value to minimum 1 if qty is 0
                if(tmpQty == 0) {
                    tmpQty = 1;
                }
            }
            if(choiceQty != null){
                var forceSetWholeQty = false;
                var predefinedValue = option.getPredefinedObject();
                if (predefinedValue && typeof predefinedValue === 'object') {
                    if (predefinedValue['valueQty'] && predefinedValue['valueId']) {
                        if(_.isArray(predefinedValue['valueId'])) {
                            var indexQty = _.indexOf(predefinedValue['valueId'], choiceTemplate["id"]);
                            if(indexQty >= 0) {
                                tmpQty = predefinedValue['valueQty'][indexQty];
                            }
                        } else if(predefinedValue['valueId'] == choiceTemplate["id"]) {
                            tmpQty = predefinedValue['valueQty'];
                            forceSetWholeQty = true;
                        }

                    }
                }
                /*if(option.hasWholeQty === true && (option.getType() === 'multiquantity' || option.getType() === 'checkbox' || forceSetWholeQty )) {
                 var wholeQty = Number(tmpQty);
                 if(_.isNumber(option.getWholeQty())) {
                 wholeQty += option.getWholeQty();
                 }
                 option.setWholeQty(wholeQty);
                 }*/
                choice.setQty(tmpQty);
            }

            if (choiceTemplate['article_value']) {
                choice.articleValue = (choiceTemplate["article_value"]);
            }

            if (choiceTemplate["thumbnail_size_y"]) {
                choice.thumbHeight = (choiceTemplate["thumbnail_size_y"]);
            }
            if (choiceTemplate["thumbnail_size_x"]) {
                choice.thumbWidth = (choiceTemplate["thumbnail_size_x"]);
            }
            if (choiceTemplate["group"] != null)  {
                choice.choiceGroup = (choiceTemplate["group"]);
            }
            if (choiceTemplate["image"]) {
                choice.image = (choiceTemplate["image"]);
                option.hasChoiceWithImage = (true);
            }
            if (choiceTemplate["image_size_x"]) {
                choice.imageWidth = (choiceTemplate["image_size_x"]);
            }
            if (choiceTemplate["image_size_y"]) {
                choice.imageHeight = (choiceTemplate["image_size_y"]);
            }
            if (choiceTemplate["image_offset_x"]) {
                choice.imageLeft = (choiceTemplate["image_offset_x"]);
            }
            if (choiceTemplate["image_offset_y"]) {
                choice.imageTop = (choiceTemplate["image_offset_y"]);
            }
            if (choiceTemplate["sku"]) {
                choice.sku = (choiceTemplate["sku"]);
            }
            if (choiceTemplate['customFields']) {
                choice.customFields = choiceTemplate['customFields'];
            }
            if (choiceTemplate["group_layer"]) {
                choice.groupLayer = (choiceTemplate["group_layer"]);
            }
            if (choiceTemplate["layer_position"]) {
                choice.layerPosition = (choiceTemplate["layer_position"]);
            }
            /* if (choiceTemplate["min_qty"]) {
             choice.setMinQty(choiceTemplate["min_qty"]);
             }
             if (choiceTemplate["max_qty"]) {
             choice.setMaxQty(choiceTemplate["max_qty"]);
             }*/
            if (choiceTemplate["info"]) {
                var infoText = this.getLabel(choiceTemplate["info"]);
                infoText = this.parseContentBlocks(infoText);
                choice.infoText = (infoText);
            }
            if (choiceTemplate["packageOptions"]) {
                choice.packageOptions = choiceTemplate["packageOptions"];
            }
            if (choiceTemplate["additional_info"]) {
                choice.additionalInfo = this.getLabel(choiceTemplate["additional_info"]);
            }
        }
        return result;
    },

    getMatrixModeFromString: function(stringValue) {
        var mode = false;
        switch (stringValue) {
            case 'number higher':
                mode = CONFIGENTO.MODE_NEXT_HEIGHER;
                break;
            case 'match':
                mode = CONFIGENTO.MODE_MATCH;
                break;
            case 'number lower':
                mode = CONFIGENTO.MODE_NEXT_LOWER;
                break;
            default:
                mode = CONFIGENTO.MODE_MATCH;
        }
        return mode;
    },


    parseConfiguratorOptionMatrix : function(configurator, option, optionTemplate) {
        if (optionTemplate) {
            var matrix = optionTemplate["matrix"];

            if (matrix) {
                if (typeof matrix === 'string') { // Check if we still have json string here
                    matrix = JSON.parse(matrix);
                }
                if ((matrix["dimension_y"] === "pc_free_input") && matrix["free_input_y"] ) {
                    /* Get value from free input field, no option-value */
                    option.setMatrixValueSelectorRow(matrix["free_input_y"]);
                } else {
                    var selectorRowOption = configurator.getOption(matrix["dimension_y"]);
                    if (selectorRowOption) {
                        option.setMatrixValueSelectorRow(selectorRowOption);
                    } else {
                        option.setMatrixValueSelectorRow(matrix["dimension_y"]); // we have a string only
                    }
                }



                option.setModeRow(this.getMatrixModeFromString(matrix['operator_y']));

                if ((matrix["dimension_x"] === "pc_free_input") && matrix["free_input_x"] ) {
                    /* Get value from free input field, no option-value */
                    option.setMatrixValueSelectorColumn(matrix["free_input_x"]);
                } else {
                    var selectorColumnOption = configurator.getOption(matrix["dimension_x"]);
                    if (selectorColumnOption) {
                        option.setMatrixValueSelectorColumn(selectorColumnOption);
                    } else {
                        option.setMatrixValueSelectorColumn(matrix["dimension_x"]); // we have a string only
                    }
                }

                option.setModeColumn(this.getMatrixModeFromString(matrix['operator_x']));

                if (matrix["values"] && typeof matrix["values"] === 'object') {
                    for (var i = 0; i < matrix["values"].length; i++) {
                        var data = matrix["values"][i]["data"];
                        option.addMatrix(data);
                    }
                }
            }

            /* Get option to select active matrix */
            if (matrix["control_matrix"]) {
                var selectorMatrix = configurator.getOption(matrix["control_matrix"]);
                if (selectorMatrix) {
                    option.setMatrixSelector(selectorMatrix);
                } else {
                    option.calculate(true);
                }
            } else {
                option.calculate(true);
            }
        }
    },

    checkOptionIsVisible : function(params, optionTemplate) {
        if (optionTemplate["is_visible"]) {
            var visibility = parseInt(optionTemplate["is_visible"]);
            if (visibility === CONFIGENTO.OPTION_VISIBLE_TRUE ||
                visibility === CONFIGENTO.OPTION_VISIBLE_SHOP) {
                params["is_visible"] = true;
            } else {
                params["is_visible"] = false;
            }
            params['visibility'] = parseInt(optionTemplate["is_visible"]);
        }
        return params;
    },

    /*
     * Parse an option from the json template and
     * create option object out of it
     */
    parseConfiguratorOption : function(group, optionTemplate, configurator) {
        var option = false;
        var params = {};

        if (group && optionTemplate) {
            var start = new Date().getTime();

            params = this.checkOptionIsVisible(params, optionTemplate);
            if (optionTemplate["info"] && this.getLabel(optionTemplate["info"])) {
                var info_text = this.getLabel(optionTemplate["info"]);
                info_text = this.parseRelativeUrl(info_text);
                info_text = this.parseContentBlocks(info_text);
                params["info_text"] = info_text;
            }
            if (optionTemplate["more_info"] && this.getLabel(optionTemplate["more_info"])) {
                var info_text2 = this.getLabel(optionTemplate["more_info"]);
                info_text2 = this.parseRelativeUrl(info_text2);
                info_text2 = this.parseContentBlocks(info_text2);
                params["info_text2"] = info_text2;
            }
            if (optionTemplate["image"] ) {
                params["image"] = optionTemplate["image"];
            }
            /* handle only if we have set in template Calculate value prices from matrix set to yes */
            if (optionTemplate["choice_price_matrix"] > 0) {
                params["choice_matrix"] = optionTemplate["choice_matrix"];
            }
            if (optionTemplate["choiceImageVisibility"] ) {
                params["choiceImageVisibility"] = optionTemplate["choiceImageVisibility"];
            }
            if (optionTemplate["minMaxPattern"] ) {
                params["minMaxPattern"] = optionTemplate["minMaxPattern"];
            }
            if (optionTemplate["quantity"]) {
                params['quantity'] = optionTemplate["quantity"];
            }
            if (optionTemplate["min_qty"]) {
                params['min_qty'] = optionTemplate["min_qty"];
            }
            if (optionTemplate["max_qty"]) {
                params['max_qty'] = optionTemplate["max_qty"];
            }
            if (optionTemplate["sku"]) {
                params['sku'] = optionTemplate["sku"];
            }
            if (optionTemplate["min_value"]) {
                params['min_value'] = optionTemplate["min_value"];
            }
            if (optionTemplate["exact"]) {
                params['exact'] = optionTemplate["exact"];
            }
            if (optionTemplate["max_value"]) {
                params['max_value'] = optionTemplate["max_value"];
            }
            if (optionTemplate['combifields']) {
                params['combifields'] = optionTemplate['combifields'];
            }
            if (optionTemplate['expression']) {
                params['expression'] = optionTemplate['expression'];
            }
            if (optionTemplate['operator_value']) {
                params['operator_value'] = optionTemplate['operator_value'];
            }
            if (optionTemplate['combination']) {
                params['combination'] = optionTemplate['combination'];
            }
            if (optionTemplate['decimal_place']) {
                params['decimal_place'] = optionTemplate['decimal_place'];
            }
            if (optionTemplate['choiceTooltip']) {
                params['show_choice_tooltip'] = optionTemplate['choiceTooltip'];
            }
            if (optionTemplate['customFields']) {
                params['custom_fields'] = optionTemplate['customFields'];
            }
            if (optionTemplate["pricelist"] && optionTemplate["operator_value_price"] && !_.isEmpty(optionTemplate["operator_value_price"])) {
                params['operator_value_price'] = optionTemplate["operator_value_price"];
            }
            if (optionTemplate["frontend_type"]) {
                params['frontend_type'] = optionTemplate["frontend_type"];
            }
            if (optionTemplate["autocomplete_template"]) {
                params['autocomplete_template'] = optionTemplate["autocomplete_template"];
            }
            if (optionTemplate["autocomplete_searchby"]) {
                params['autocomplete_searchby'] = optionTemplate["autocomplete_searchby"];
            }
            if(optionTemplate["date_restriction"]) {
                params["date_restriction"] = optionTemplate["date_restriction"];
            }
            if(optionTemplate["quantity_per_item"]) {
                params["quantity_per_item"] = optionTemplate["quantity_per_item"];
            }
            switch (optionTemplate['type']) {
                case 'text':
                    option = new Justselling_Configento_Option_Type_Text(configurator, group, optionTemplate['id'], optionTemplate['alt_title'], this.getLabel(optionTemplate['title']), params);
                    if (optionTemplate["text_validate"]) {
                        option.setTextValidate(optionTemplate["text_validate"]);
                    }
                    if(optionTemplate["min_string_length"]) {
                        option.setMinStringLength(optionTemplate["min_string_length"]);
                    }
                    if(optionTemplate["max_string_length"]){
                        option.setMaxStringLength(optionTemplate["max_string_length"]);
                    }
                    if (optionTemplate["placeholder"] && optionTemplate["placeholder"] == '1' ) {
                        option.setPlaceholder(optionTemplate["default_value"]);
                        option.setIsPredefined(1);
                    }
                    if (optionTemplate["default_value"] && !option.getIsPredefined()) {
                        option.setDefaultValue(optionTemplate["default_value"]);
                    }
                    break;
                case 'area':
                    option = new Justselling_Configento_Option_Type_Area(configurator, group, optionTemplate['id'], optionTemplate['alt_title'], this.getLabel(optionTemplate['title']), params);

                    if(optionTemplate["min_string_length"]) {
                        option.setMinStringLength(optionTemplate["min_string_length"]);
                        option.setTextValidate(1);
                    }
                    if(optionTemplate["max_string_length"]){
                        option.setMaxStringLength(optionTemplate["max_string_length"]);
                        option.setTextValidate(1);
                    }
                    if (optionTemplate["placeholder"] && optionTemplate["placeholder"] == '1' ) {
                        option.setPlaceholder(optionTemplate["default_value"]);
                        option.setIsPredefined(1);
                    }
                    if (optionTemplate["default_value"] && !option.getIsPredefined()) {
                        option.setDefaultValue(optionTemplate["default_value"]);
                    }
                    break;
                case 'select':
                    params["render"] = false;
                    params["default_value"] = optionTemplate["default_value"];
                    option = new Justselling_Configento_Option_Type_Select(configurator, group, optionTemplate['id'], optionTemplate['alt_title'], this.getLabel(optionTemplate['title']), params);

                    var defaultChoice = this.parseConfiguratorOptionChoices(option, optionTemplate["choices"]);
                    if (defaultChoice) {
                        option.setDefaultValue(defaultChoice, true);
                        option.setIsPredefined(1);
                    }
                    else {
                        option.setDefaultValue(optionTemplate["default_value"]);
                    }
                    break;
                /*case 'selectcombi':
                    params["render"] = false;
                    option = new Justselling_Configento_Option_Type_SelectCombi(configurator, group, optionTemplate['id'], optionTemplate['alt_title'], this.getLabel(optionTemplate['title']), params);

                    var defaultChoice = this.parseConfiguratorOptionChoices(option, optionTemplate["choices"]);
                    if (defaultChoice) {
                        option.setDefaultValue(defaultChoice, true);
                        option.setIsPredefined(1);
                    }
                    else {
                        option.setDefaultValue(optionTemplate["default_value"]);
                    }
                    break;*/
                case 'listimage':
                    params["render"] = false;
                    option = new Justselling_Configento_Option_Type_Thumb(configurator, group, optionTemplate['id'], optionTemplate['alt_title'], this.getLabel(optionTemplate['title']), params);

                    var defaultChoice = this.parseConfiguratorOptionChoices(option, optionTemplate['choices']);
                    if (defaultChoice) {
                        option.setDefaultValue(defaultChoice, true);
                        option.setIsPredefined(1);
                    }
                    else {
                        option.setDefaultValue(optionTemplate["default_value"]);
                    }
                    if (optionTemplate["listimage_style"]) {
                        option.setStyle(parseInt(optionTemplate["listimage_style"]));
                    }
                    break;
                case 'expression':
                    option = new Justselling_Configento_Option_Type_Expression(configurator, group, optionTemplate['id'], optionTemplate['alt_title'], this.getLabel(optionTemplate['title']), params);
                    params["bind_to_dom"] = false;

                    //option.init("expression", configurator, group, optionTemplate['id'], optionTemplate['alt_title'], this.getLabel(optionTemplate['title']), params);

                    //option.setExpression(option.getExpression());
                    option.calculate();
                    break;
                case 'combi':
                    option = new Justselling_Configento_Option_Type_Combi(configurator, group, optionTemplate['id'], optionTemplate['alt_title'], this.getLabel(optionTemplate['title']), params);
                    option.initExpression();
                    break;
                case 'radiobuttons':
                    params["render"] = false;
                    option = new Justselling_Configento_Option_Type_RadioButtons(configurator, group, optionTemplate['id'], optionTemplate['alt_title'], this.getLabel(optionTemplate['title']), params);
                    var defaultChoice = this.parseConfiguratorOptionChoices(option, optionTemplate["choices"]);
                    if (defaultChoice) {
                        option.setDefaultValue(defaultChoice, true);
                    }
                    else {
                        option.setDefaultValue(optionTemplate["default_value"]);
                    }
                    break;
                case 'multiselect':
                    params["render"] = false;
                    option = new Justselling_Configento_Option_Type_MultiSelect(configurator, group, optionTemplate['id'], optionTemplate['alt_title'], this.getLabel(optionTemplate['title']), params);
                    var defaultChoice = this.parseConfiguratorOptionChoices(option, optionTemplate["choices"]);
                    if (defaultChoice) {
                        option.setDefaultValue(defaultChoice, true);
                    }
                    else {
                        option.setDefaultValue(optionTemplate["default_value"]);
                    }
                    break;
                case 'multiquantity':
                    params["render"] = false;
                    option = new Justselling_Configento_Option_Type_MultiQuantity(configurator, group, optionTemplate['id'], optionTemplate['alt_title'], this.getLabel(optionTemplate['title']), params);
                 /*   var grouped = [
                        {
                            title: 'test123',
                            choices:  [
                                optionTemplate["choices"][0],
                                optionTemplate["choices"][1],
                                optionTemplate["choices"][2]
                            ]
                        },
                        {
                            title: 'Wietere Gruppe',
                            choices:  [
                                optionTemplate["choices"][3],
                                optionTemplate["choices"][4],
                                optionTemplate["choices"][5]
                            ]
                        }
                    ];*/
                    var defaultChoice = this.parseConfiguratorOptionChoices(option, optionTemplate["choices"]);
                    if (defaultChoice) {
                        option.setDefaultValue(defaultChoice, true);
                    }
                    else {
                        option.setDefaultValue(optionTemplate["default_value"]);
                    }
                    break;
                case 'checkbox':
                    params["render"] = false;
                    option = new Justselling_Configento_Option_Type_Checkbox(configurator, group, optionTemplate['id'], optionTemplate['alt_title'], this.getLabel(optionTemplate['title']), params);
                   /* option.setOriginalPrice(parseFloat(optionTemplate['price']));
                    option.setPrice(parseFloat(optionTemplate['price']));*/
                    var defaultChoice = this.parseConfiguratorOptionChoices(option, optionTemplate["choices"]);
                    if (defaultChoice) {
                        option.setDefaultValue(defaultChoice, true);
                    }
                    else {
                        option.setDefaultValue(optionTemplate["default_value"]);
                    }
                    break;
                case 'matrixvalue':
                    var _self = this;
                    option = new Justselling_Configento_Option_Type_Matrix(configurator, group, optionTemplate['id'], optionTemplate['alt_title'], _self.getLabel(optionTemplate['title']), params);
                    _self.parseConfiguratorOptionMatrix(configurator, option, optionTemplate);
                    option.calculate();
                    break;
                case 'static':
                    option = new Justselling_Configento_Option_Type_Static(configurator, group, optionTemplate['id'], optionTemplate['alt_title'], this.getLabel(optionTemplate['title']), params);
                    if (optionTemplate["default_value"]) {
                        option.setDefaultValue(optionTemplate["default_value"]);
                        option.setValue(optionTemplate["default_value"]);
                    }
                    break;
                case 'productattribute':
                    option = new Justselling_Configento_Option_Type_Attribute(configurator, group, optionTemplate['id'], optionTemplate['alt_title'], this.getLabel(optionTemplate['title']), params);
                    option.setAttributeKey(optionTemplate['product_attribute']);
                    break;
                case 'chart':
                    option = new Justselling_Configento_Option_Type_Chart(configurator, group, optionTemplate['id'], optionTemplate['alt_title'], this.getLabel(optionTemplate['title']), params);
                    option.setAutomaticUpdate(optionTemplate['updateChartFromExpression']);
                    option.setChartType(optionTemplate['chartType']);
                    option.setAspectRatio(optionTemplate['chartAspectRatio']);
                    // assign expression title, which calculates the chart series data
                    option.setExpressionTitle(optionTemplate['chartSeries']);

                    option.setExtraOptions(optionTemplate['extraOptions']);
                    option.setResponsiveOptions(optionTemplate['responsiveOptions']);
                    option.setOnDrawOptions(optionTemplate['onDrawOptions']);
                    break;
                case 'savebutton':
                    params["render"] = false;
                    option = new Justselling_Configento_Option_Type_SaveButton(configurator, group, optionTemplate['id'], optionTemplate['alt_title'], this.getLabel(optionTemplate['title']), params);
                    if(optionTemplate['redirect_url'] != '') {
                        option.setRedirectUrl(optionTemplate['redirect_url']);
                    }
                    if(optionTemplate['post_url'] != '') {
                        option.setPostUrl(optionTemplate['post_url']);
                    }
                    break;
                case 'webservice':
                    params["render"] = false;
                    option = new Justselling_Configento_Option_Type_Webservice(configurator, group, optionTemplate['id'], optionTemplate['alt_title'], this.getLabel(optionTemplate['title']), params);
                    if(optionTemplate['webservice_url'] != '') {
                        option.setWebserviceUrl(optionTemplate['webservice_url']);
                    }
                    if(optionTemplate['webservice_return_type'] != '') {
                        option.setWebserviceReturnType(optionTemplate['webservice_return_type']);
                    }
                    if(optionTemplate['webservie_path'] != '') {
                        option.setWebservicePath(optionTemplate['webservie_path']);
                    }
                    option.setValueFromWebserviceUrl();

                    break;
                case 'fileupload':
                    params["render"] = false;
                    option = new Justselling_Configento_Option_Type_Fileupload(configurator, group, optionTemplate['id'], optionTemplate['alt_title'], this.getLabel(optionTemplate['title']), params);
                    if(optionTemplate['max_filesize']) {
                        option.addDropzoneConfig('maxFilesize', optionTemplate['max_filesize']);
                    }
                    if(optionTemplate['max_files']) {
                        option.addDropzoneConfig('maxFiles', optionTemplate['max_files']);
                    }
                    if(optionTemplate['min_files']) {
                        option.setMinFiles(optionTemplate['min_files']);
                    }
                    if(optionTemplate['accepted_files']) {
                        option.addDropzoneConfig('acceptedFiles', optionTemplate['accepted_files']);
                    }
                    if(optionTemplate['upload_url']) {
                        option.addDropzoneConfig('url', optionTemplate['upload_url']);
                    }

                    break;
                case 'package':
                    params["render"] = false;
                    params['package_options'] = optionTemplate["packageOptions"];
                    params['package_price'] = optionTemplate["package_price"];
                    option = new Justselling_Configento_Option_Type_Package(configurator, group, optionTemplate['id'], optionTemplate['alt_title'], this.getLabel(optionTemplate['title']), params);
                    break;
                default:
                    Justselling_Configento_App_Debug.addDebug("EXCEPTION: unkwon option type "+optionTemplate['type'], true);
                    break;
            }
            var end = new Date().getTime();
            var time = end - start;
            Justselling_Configento_App_Profiler.addMeasuring("storage::parseConfiguratorOption > "+optionTemplate['type'], time);

            start = new Date().getTime();
            /* here we parse general properties for all option types */
            if (option) {
                if (optionTemplate["css_class"]) {
                    option.setCustomClass(optionTemplate["css_class"]);
                }
                if (optionTemplate["sort_order_combiimage"]) {
                    option.setSortOrderCombiImage(optionTemplate["sort_order_combiimage"]);
                }

                if (optionTemplate["is_required"] && parseInt(optionTemplate["is_required"])) {
                    option.setIsRequired(true);
                }
                if (optionTemplate["thumbstyle"]) {
                    switch (optionTemplate["thumbstyle"]) {
                        case "collapse":
                            option.setCollapse(true);
                            break;
                        case "overlay":
                            option.setOverlay(true);
                            break;
                    }
                }
                if (optionTemplate["overlay"]) {
                    option.setOverlay(optionTemplate["overlay"]);
                }
                if (optionTemplate["pricelist"]) {
                    var pricelist = optionTemplate["pricelist"];
                    var tierPrice = [];

                    if (pricelist && typeof pricelist === 'object' && pricelist.length >0) {
                        for (var i=0;i<pricelist.length;i++) {
                            var item = pricelist[i];
                            tierPrice.push([parseFloat(item['value']), parseFloat(item['price'])]);
                        }
                        tierPrice.sort(function(a, b){return b[0]-a[0]});

                        option.setTierPrice(tierPrice);
                        option.setPrice(option.calculatePrice());
                    }
                }
            }
            end = new Date().getTime();
            time = end - start;
            Justselling_Configento_App_Profiler.addMeasuring("storage::parseConfiguratorOption.additional", time);
        }
        return option;
    },

    parseConfiguratorRuleConditionObject : function(configurator, conditionObject) {
        var expression = null;
        if (conditionObject && conditionObject['field'] ) {
            var field = "$"+conditionObject['field'];
            var conditionOperator = conditionObject['operator'];
            var operator = null;
            var patternStart = null;
            var patternEnd = null;
            var conditionValue = conditionObject['value'];
            switch (conditionOperator) {
                case 'equal':
                    operator = "==";
                    break;
                case 'not_equal':
                    operator = "!=";
                    break;
                case 'greater':
                    operator = ">";
                    break;
                case 'greater_or_equal':
                    operator = ">=";
                    break;
                case 'less':
                    operator = "<";
                    break;
                case 'less_or_equal':
                    operator = "<=";
                    break;
                case 'between':
                    operator = "between";
                    break;
                case 'not_between':
                    operator = "not_between";
                    break;
                case 'in': case 'not_in':
                    operator = "in";
                    var inArray = [];
                    for (var i = 0; i < conditionValue.length; i++) {
                        var choice = configurator.getChoiceByInternalId(conditionValue[i]);
                        if (typeof choice === "object") {
                            // Special case if value is empty string
                            var cValue = choice.getOriginalValue();
                            if(jQuery.isNumeric(cValue)) {
                                inArray.push(cValue);
                            }
                           inArray.push("'"+ (cValue ) +"'");
                        }
                    }
                    conditionValue = inArray.join();
                    break;
                case 'begins_with':
                    patternStart = '/^';
                    patternEnd = '/';
                    break;
                case 'not_begins_with':
                    patternStart = '! /^';
                    patternEnd = '/';
                    break;
                case 'contains':
                    patternStart = '/';
                    patternEnd = '/';
                    break;
                case 'not_contains':
                    patternStart = '! /';
                    patternEnd = '/';
                    break;
                case 'ends_with':
                    patternStart = '/';
                    patternEnd = '$/';
                    break;
                case 'not_ends_with':
                    patternStart = '! /';
                    patternEnd = '$/';
                    break;
                case 'is_null':
                    expression = "(" + field + '== null  || ' + field + " == 0 || " + field +" == '') ";
                    break;
                case 'is_not_null':
                    expression = "(" + field + '!= null  && ' + field + " != 0 && " + field +" != '') ";
                    break;
                case 'is_empty':
                    expression = "(" + field + " == 0 || " + field +" == '') ";
                    break;
                case 'is_not_empty':
                    expression = "(" + field + " != 0 && " + field +" != '') ";
                    break;
                default:
                    console.log('trying to parse Rule: '+ conditionOperator);
                    break;
            }
            // The check for conditionValue === "" is important to rules which depends on the empty choice "Please Choose"
            // this choice doesn´t have a value
            if (conditionValue || conditionValue === "" || conditionValue === 0) {
                if(operator) {
                    if (operator === 'in') {
                        expression = "(Justselling_Configento_App_Helper.valueIn(" + field + ",[" + conditionValue + "])) ";
                        // negate the in expression
                        if(conditionOperator === 'not_in') {
                            expression = '!' + expression;
                        }
                    }
                    else if(operator === 'between' || operator === 'not_between') {
                        expression = "(" + field + '>=' +  conditionValue[0] + '&&' + field + '<=' +  conditionValue[1] +  ") ";
                        if(operator === 'not_between') {
                            expression = '!'+expression;
                        }
                    }
                    else {
                        if (!jQuery.isNumeric(conditionValue) && conditionValue !== null) {
                            conditionValue = "'" + conditionValue + "'";
                        }
                        expression = "(" + field + operator + conditionValue + ") ";
                    }
                } else if(patternStart && patternEnd) {
                    expression = '(' + patternStart + conditionValue + patternEnd + '.test(' + field + ') ) ';
                }
            }
        }
        return expression;
    },

    parseConfiguratorRuleCondition : function(configurator, ruleConditionTemplate) {
        var condition = "";
        if (ruleConditionTemplate) {
            var operator = ruleConditionTemplate['condition'];
            switch (operator) {
                case "AND":
                    operator = " && ";
                    break;
                case "OR":
                default:
                    operator = " || ";
                    break;
            }
            var conditionObjects = ruleConditionTemplate['rules'];
            if (conditionObjects) {
                for (var i = 0; i < conditionObjects.length; i++) {
                    var conditionObject = conditionObjects[i];
                    if(conditionObject.rules && conditionObject.rules.length) {
                        condition += '&& (' + this.parseConfiguratorRuleCondition(configurator, conditionObject) + ') )';
                    } else {
                        if (condition) {
                            condition += operator;
                        }
                        if(conditionObjects[i+1] && conditionObjects[i+1].rules && conditionObjects[i+1].rules.length) {
                            condition += '( ';
                        }
                        condition += this.parseConfiguratorRuleConditionObject(configurator, conditionObject);
                    }
                }
            }
        }
        return condition;
    },

    parseConfiguratorRuleDependencies : function(optionsList, choicesList, configurator) {
        var dependencies = [];


        if (choicesList) {
            var start1 = new Date().getTime();
            var choicesArray = [];
            _.each(choicesList, function(internalChoiceId, index){
                if(_.isObject(internalChoiceId)) {
                    choicesArray.push(String(index));
                } else {
                    choicesArray.push(String(internalChoiceId));
                }
            });

            dependencies = configurator.getChoicesByInternalIdArray(choicesArray);
            var end1 = new Date().getTime();
            var time1 = end1 - start1;
            Justselling_Configento_App_Profiler.addMeasuring("parseConfiguratorRuleDependencies CHOCES", time1);

        }

        if (optionsList) {
            start1 = new Date().getTime();

            _.each(optionsList, function(obj, index){
                if(! obj.hasOwnProperty('condition') || obj.condition != 0) {
                    var internalOptionId = obj;
                    if (_.isObject(obj)) {
                        internalOptionId = index;
                    }
                    var option = configurator.getOptionByInternalId(String(internalOptionId));
                    if (option) {
                        if (_.isObject(obj)) {
                            obj.option = option;
                            option = obj;
                        }
                        dependencies.push(option);
                    }
                }
            });

            end1 = new Date().getTime();
            time1 = end1 - start1;
            Justselling_Configento_App_Profiler.addMeasuring("parseConfiguratorRuleDependencies OPTIONS", time1);


        }

        return dependencies;
    },

    /*
     * Parse a rule from the json template and
     * create rule object out of it
     */
    parseConfiguratorRule : function(ruleTemplate, configurator) {
        var rule = null;

        if (ruleTemplate) {
            var validationType = ruleTemplate['validation_type'];
            var condition, dependencies;
            switch(validationType) {
                case 'blacklist':
                    /* todo remove this, after intensive debug of blacklisting. */
                    if (typeof ruleTemplate['blacklist_choices'] !== 'undefined') {
                        if (Justselling_Configento_App_Storage.getDontBlacklistThisChoice() != '') {
                            var indexC = ruleTemplate['blacklist_choices'].indexOf(Justselling_Configento_App_Storage.getDontBlacklistThisChoice());
                            if (indexC !== -1) ruleTemplate['blacklist_choices'].splice(indexC, 1);
                        }
                    }
                    condition = this.parseConfiguratorRuleCondition(configurator, ruleTemplate['rule_item']);
                    dependencies = this.parseConfiguratorRuleDependencies(ruleTemplate['blacklist_options'], ruleTemplate['blacklist_choices'], configurator);
                    rule = new Justselling_Configento_Rules_Rule(configurator, condition, CONFIGENTO.RULE_BLACKLIST, dependencies, ruleTemplate["label"], undefined, ruleTemplate["date_restrictions"]);
                    break;
                case 'error':
                    condition = this.parseConfiguratorRuleCondition(configurator, ruleTemplate['rule_item']);
//                    var dependencies = this.parseConfiguratorRuleDependencies(ruleTemplate['error'], null, configurator);
                    var extra_config = {
                        "type": ruleTemplate['error_error_type'],
                        "execute": ruleTemplate['error_when_execute'],
                        "message": ruleTemplate['error_message']
                    };
                    rule = new Justselling_Configento_Rules_Rule(configurator, condition, CONFIGENTO.RULE_ERROR, [], ruleTemplate["label"], extra_config);
                    break;
                case 'predefine_qty':
                    condition = this.parseConfiguratorRuleCondition(configurator, ruleTemplate['rule_item']);
                    dependencies = this.parseConfiguratorRuleDependencies(ruleTemplate['predefine_qty'], null, configurator);
                    rule = new Justselling_Configento_Rules_Rule(configurator, condition, CONFIGENTO.RULE_PREDEFINE_QTY, dependencies, ruleTemplate["label"]);
                    break;
                case 'predefine_minmax':
                    condition = this.parseConfiguratorRuleCondition(configurator, ruleTemplate['rule_item']);
                    dependencies = this.parseConfiguratorRuleDependencies(ruleTemplate['predefine_minmax'], null, configurator);
                    rule = new Justselling_Configento_Rules_Rule(configurator, condition, CONFIGENTO.RULE_PREDEFINE_MINMAX, dependencies, ruleTemplate["label"]);
                    break;
                case 'predefine_values':
                    condition = this.parseConfiguratorRuleCondition(configurator, ruleTemplate['rule_item']);
                    dependencies = this.parseConfiguratorRuleDependencies(ruleTemplate['predefine_values'], null, configurator);
                    rule = new Justselling_Configento_Rules_Rule(configurator, condition, CONFIGENTO.RULE_PREDEFINE_VALUE, dependencies, ruleTemplate["label"]);

                    _.each(dependencies, function(dependency) {
                        if (parseInt(dependency.condition) === 1) {
                            if (dependency.value) {
                                if (dependency.dynamicValue == '1') {
                                    var preOption = configurator.getOption(dependency.value);
                                    if (preOption) {
                                        preOption.addChild(rule);
                                    }
                                }
                            }
                        }
                    });
                    break;
            }
        }

        return rule;
    },

    getLabel : function(labelObject) {
        return Justselling_Configento_App_Helper.getTranslatedLabel(labelObject);
    },
    parseContentBlocks : function(content) {
        if (typeof CONFIGENTO_PRODUCT.getContentBlock !== "function") return content;
        if (!content) return content;
        var variables = content.match(/\$content\[[0-9a-zA-Z_\-]+\]/g);
        if (variables) {
            variables.each(function (variable) {
                var id = variable.replace('$content[', '');
                id = id.replace(']', '');
                var block = CONFIGENTO_PRODUCT.getContentBlock(id);
                if (block) {
                    block = Base64.decode(block);
                    content = content.replace("$content[" + id + "]", block);
                }
            });
        }
        return content;
    },
    parseRelativeUrl : function (html) {

        var $html = jQuery.parseHTML( html );
        $html = jQuery($html);
        var baseUrl = Justselling_Configento_App_Helper.getCloudBase();
        baseUrl = baseUrl.replace("/configento/", '/configentobe/');

        var img = $html.find('img[src]');
        img.each(function() {
            var imgSrc = jQuery( this ).attr('src');
            if(imgSrc.search("https://") === -1 && imgSrc.search("http://") === -1) {
                jQuery( this ).attr('src', baseUrl + imgSrc);
            }
        });
        var ret= '';
        $html.each(function( index ) {
            ret += $html[index].outerHTML;
        });
        if(ret === "undefined" || ret == null) {
            if (typeof $html.text() !== 'undefined') {
                ret = '<p>' + $html.text() + '</p>';
            }
        }
        ret = ret.split("undefined").join("");
        return ret;
    },

    compareOptions : function(a,b) {
        if ((a === null) || (b === null)) {
            return 0;
        }

        if (a.sort_order < b.sort_order)
            return -1;
        else if (a.sort_order > b.sort_order)
            return 1;
        else
            return 0;
    },

    /**
     * will make Alphanumeric sort of array
     * @param a
     * @param b
     * @param prop
     */
    compareOptionsAlphanumeric: function (a, b, prop) {
        if (a[prop] && b[prop]) {
            function chunkify(t) {
                var tz = new Array();
                var x = 0, y = -1, n = 0, i, j;

                while (i = (j = t.charAt(x++)).charCodeAt(0)) {
                    var m = (i == 46 || (i >= 48 && i <= 57));
                    if (m !== n) {
                        tz[++y] = "";
                        n = m;
                    }
                    tz[y] += j;
                }
                return tz;
            }

            var aa = chunkify(a[prop].toLowerCase());
            var bb = chunkify(b[prop].toLowerCase());

            for (x = 0; aa[x] && bb[x]; x++) {
                if (aa[x] !== bb[x]) {
                    var c = Number(aa[x]), d = Number(bb[x]);
                    if (c == aa[x] && d == bb[x]) {
                        return c - d;
                    } else return (aa[x] > bb[x]) ? 1 : -1;
                }
            }
            return aa.length - bb.length;
        }
    },

    /*
     * Parse whole json template
     * Create group objects and trigger parsing the options
     */
    parseCloudTemplate : function(template, configurator) {
        if (typeof template === 'object') {
            var self = this;
            /*
             * First step
             * Create groups from json template
             */
            var start = new Date().getTime();
            var groupsTemplates = template['option_groups'];
            var groupTemplate, group;
            if (groupsTemplates && typeof groupsTemplates === "object") {
                for (var i = 0; i < groupsTemplates.length; i++) {
                    groupTemplate = groupsTemplates[i];
                    group = new Justselling_Configento_Option_Group(configurator, this.getLabel(groupTemplate['title']));
                    group.setInternalId(groupTemplate["id"]);
                    group.setOptions(groupTemplate.options);
                    if (groupTemplate['hide'] == "1") {
                        group.setIsVisible(false, true);
                    }
                }
                configurator.render();
                configurator.setActiveGroupByIndex(0);
            }
            var end = new Date().getTime();
            var time = end - start;
            Justselling_Configento_App_Profiler.addMeasuring("storage::parseCloudTemplate.groups", time);

            /*
             * Second step
             * create options and add choices
             */
            start = new Date().getTime();
            if (groupsTemplates && typeof groupsTemplates === "object") {
                for (var i = 0; i < groupsTemplates.length; i++) {
                    groupTemplate = groupsTemplates[i];
                    var groupInternalId = groupTemplate['id'];
                    group = configurator.getGroupByInternalId(groupInternalId);
                    var groupBy = '';
                    if ((typeof groupTemplate.sortby !== 'undefined') && (groupTemplate.sortby != 'default')) {
                        groupBy = groupTemplate.sortby;
                    }
                    var options = groupTemplate['options'];
                    if (options) {
                        if (groupBy) {
                            options.sort(function(a,b) {
                                return Justselling_Configento_App_Storage.compareOptionsAlphanumeric(a, b, 'css_class');
                            });
                        } else {
                            options.sort(this.compareOptions);
                        }
                        _.each(options, function (optionTemplate) {
                            /* make sort of choices */
                            if (typeof optionTemplate.choices !== 'undefined') {
                                optionTemplate.choices.sort(Justselling_Configento_App_Storage.compareOptions);
                            }

                        //for (var n = 0; n < options.length; n++) {
                          //  var optionTemplate = options[n];
                            self.parseConfiguratorOption(group, optionTemplate, configurator);
                        //}
                        });
                    }
                }
                /*
                 * @author: Michael Tjupalow
                 * AddChild´s to those expression which could not add Child´s while parsing
                 * removes issue with order of expression options
                 */
                (function () {
                    var unparsedOptions = configurator.getUnparsedOptions();
                    if(unparsedOptions) {
                        for (var n = 0; n < unparsedOptions.length; n++) {
                            var unparsedOption = unparsedOptions[n];
                            var parentOption = configurator.options[unparsedOption.optionIndex];
                            var title = unparsedOption.childTitle;
                            var type = unparsedOption.type;
                            var setType = unparsedOption.setType;
                            if ((title == 'Xcurrent_choice_valueX') || typeof title === 'undefined') continue;
                            var option;
                            if (option = configurator.getOption(title)) {
                                if (typeof parentOption === 'undefined') {
                                    if (type == 'matrixvalue') {
                                        var self = unparsedOption.self;
                                        option.addChild(self);
                                        switch (setType) {
                                            case 'setMatrixValueSelectorColumn':
                                                self.setMatrixValueSelectorColumn(option);
                                                break;
                                            case 'setMatrixValueSelectorRow':
                                                self.setMatrixValueSelectorRow(option);
                                                break;
                                            case 'setMatrixSelector':
                                                self.setMatrixSelector(option);
                                                break;
                                        }
                                        self.calculate(true);
                                    }
                                } else {
                                    if (type == 'choice_matrix') {
                                        if (typeof parentOption.addExpressionVariable === "function") {
                                            option.addChild(parentOption);
                                            switch (setType) {
                                                case 'setChoiceMatrixDim_x':
                                                    parentOption.setChoiceMatrixDim_x(option);
                                                    break;
                                                case 'setChoiceMatrixDim_y':
                                                    parentOption.setChoiceMatrixDim_y(option);
                                                    break;
                                            }
                                            parentOption.calculate();
                                        }
                                    } else {
                                        if (typeof parentOption.addExpressionVariable === "function") {
                                            parentOption.addExpressionVariable({
                                                title: unparsedOption.title,
                                                optionIndex: option.arrayIndex
                                            });
                                            option.addChild(parentOption);
                                            parentOption.calculate();
                                        }
                                    }
                                }
                            } else {
                                Justselling_Configento_App_Debug.addDebug("EXCEPTION: Trying to add a none existing child option SECOND TIME", true);
                                if (typeof parentOption !== 'undefined') { // when we have matrixvalue we don't have parent option!
                                    Justselling_Configento_App_Debug.addDebug("current option="+parentOption.getTitle(), true);
                                }
                                Justselling_Configento_App_Debug.addDebug("child option="+title, true);
                            }
                        }
                    }
                })();
            }
            end = new Date().getTime();
            time = end - start;
            Justselling_Configento_App_Profiler.addMeasuring("storage::parseCloudTemplate.options", time);

            /*
             * Third step
             * Create rules
             */
            start = new Date().getTime();
            var rulesTemplate = template['rules'];
            /* handle groups; if we have rules in groups, make groups linear and use old logic */
            var rulesgroups = template['rulesgroups'];
            if (typeof rulesgroups !== 'undefined') {
                for (var i = 0; i < rulesgroups.length; i++) {
                    if (typeof rulesgroups[i] !== 'undefined') {
                        for (var j = 0; j < rulesgroups[i].rules.length; j++) {
                            if (typeof rulesgroups[i].rules[j] !== 'undefined') {
                                rulesTemplate.push(rulesgroups[i].rules[j]);
                            }
                        }
                    }
                }
                /* make sort only if you have any of rules */
                if (typeof rulesTemplate !== 'undefined') {
                    rulesTemplate.sort(Justselling_Configento_App_Storage.compareOptions);
                }

            }
            if (rulesTemplate && typeof rulesTemplate === "object") {
           //     var rulesLength = rulesTemplate.length;
             /*   for (var i = 0; i < rulesLength; i++) {
                    if(rulesTemplate[i].validation_type === 'predefine_values' || rulesTemplate[i].validation_type === 'predefine_qty') {
                        rulesTemplate.push(rulesTemplate[i]);

                    }
                }*/

                for (var i = 0; i < rulesTemplate.length; i++) {
                    var ruleTemplate = rulesTemplate[i];
                    /* tu je problem */
                    this.parseConfiguratorRule(ruleTemplate, configurator);
                }
            }
            end = new Date().getTime();
            time = end - start;
            Justselling_Configento_App_Profiler.addMeasuring("storage::parseCloudTemplate.rules", time);
        }
    }
};

var Justselling_Configento_App_Message = {

    configurationChangeMessage: function(oldChoices, newChoices) {
        var message = Justselling_Configento_App_Translate.translate('Your action requires changes')+'\n\n';

        message += Justselling_Configento_App_Translate.translate('The following options will be dropped')+'\n';
        _.each(oldChoices, function(choice) {
            if (choice instanceof Justselling_Configento_Option_Abstract) {
                if (choice.getType() == 'package') {
                    message += ' - '+choice.getLabel()+'\n';
                    _.each(choice.getAllChoices(), function (packageChoice) {
                        message += '   - '+packageChoice.getLabel()+'\n';
                    });
                }
            }
            if (choice instanceof  Justselling_Configento_Option_Choice) {
                message += ' + '+choice.getLabel()+'\n';
            }
        });

        message += '\n'+Justselling_Configento_App_Translate.translate('The following options will be selected')+'\n';
        _.each(newChoices, function(choice) {
            if (choice instanceof  Justselling_Configento_Option_Abstract) {
                if (choice.getType() == 'package') {
                    message += ' - '+choice.getLabel()+'\n';
                    _.each(choice.getAllChoices(), function (packageChoice) {
                        message += '   - '+packageChoice.getLabel()+'\n';
                    });
                }
            }
            if (choice instanceof Justselling_Configento_Option_Choice) {
                message += ' + '+choice.getLabel()+'\n';
            }
        });

        return message;
    },

    confirm: function(message) {
        return confirm(message);
    },
}
var Justselling_Configento_App_LocalStorage = {

    enable : false,

    init : function() {
        if (!localStorage["configento-storage"]) localStorage["configento-storage"] = JSON.stringify({});
    },

    isOnline: function() {
        return navigator.onLine
    },

    save: function(key, data) {
        if (!Justselling_Configento_App_LocalStorage.enable) return false;

        this.init();
        try {
            var checkins = JSON.parse(localStorage["configento-storage"]);
            checkins[key] = data;
            localStorage["configento-storage"] = JSON.stringify(checkins);
        } catch (err)  {
            Justselling_Configento_App_Debug.addDebug("Problem when trying to store the component in local storage: "+err, true);
        }
    },

    get: function(key) {
        this.init();
        var allCheckins = JSON.parse(localStorage["configento-storage"]);
        var matchingCheckin = allCheckins[key];
        return matchingCheckin;
    },

    count: function() {
        this.init();
        return handler(JSON.parse(localStorage["configento-storage"]).length);
    }
}
var Justselling_Configento_App_Toolbar = {

    isActive : function() {
        try {
            var searchParams = new URLSearchParams(window.location.search);
            if (searchParams.has('tb')) return true;
            return false;
        } catch (exception) { // Use this in case you don't support URLSearchParams like in IE
            if (Justselling_Configento_App_Toolbar.urlParam('tb')) return true;
            return false;
        }
    },

    render : function(string) {
        if (Justselling_Configento_App_Toolbar.isActive()) {
            var label = Justselling_Configento_App_Translate.translate("Generate Deep Link");
            jQuery('<div id="configento-toolbar" class="configento-toolbar"><div class="toolbar-logo"><span class="toolbar-logo-lg" alt="justSelling">justSelling</span></div><div class="content"><button type="button" onclick="Justselling_Configento_App_Toolbar.generateDeepLinkAction();return false;" ><span>'+label+'</span></buton></div></div>').prependTo('body');
        }
    },

    generateDeepLinkAction : function() {
        var configurator = Justselling_Configento_App_Helper.getConfigurator();
        var configBase64 = configurator.generateHeaderValue();
        Justselling_Configento_App_CloudAsset.storeCloudAsset(configBase64, 'headerData', Justselling_Configento_App_Toolbar.generateDeepLinkDone,'data');
    },

    generateDeepLinkDone : function(id) {
        var url = location.protocol + '//' + location.host + location.pathname;
        url += '?dl='+id;
        alert(Justselling_Configento_App_Translate.translate("Your deep link URL is")+" "+url);
    },

    urlParam: function(name) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results==null){
            return null;
        }
        else{
            return decodeURI(results[1]) || 0;
        }
    }
}
var Justselling_Configento_App_Api = {

    eventHooks: {},

    setEventHook: function( event, hook ) {
        if (event && hook) {
            Justselling_Configento_App_Api.eventHooks[ event ] = hook;
            return hook;
        }

        return null;
    },

    deleteEventHook: function( event ) {
        if (event) {
            Justselling_Configento_App_Api.eventHooks[ event ] = null;
        }

        return null;
    },

    getEventHook: function( event ) {
        if (event) {
            return Justselling_Configento_App_Api.eventHooks[ event ];
        }

        return null;
    },

    processEvent: function( event, data ) {
        jQuery(document).trigger( event, data );

        const hook = Justselling_Configento_App_Api.getEventHook( event );
        if (hook && typeof hook === 'function') {
            return hook( data );
        }

        return true;
    },

    /*
     * Get the DOM id from a configento option by pasing a DOM Tag id
     * Can be either a single Id or an array of Ids
     */
    getOptionIdFromTitle  : function(title) {
        if (title && typeof title == "string") {
            var $options = jQuery("[data-cf-title=\"" + title + "\"]");
            if ($options.length == 1) {
                return $options.attr("id");
            }
            var idArray = [];
            for (var i = 0; i < $options.length; i++) {
                idArray.push(idArray, $options[i].attr("id"));
            }
            return idArray;
        }
        return false;
    },

    getOptionAsObject : function(id) {
        var configurator = Justselling_Configento_App_Helper.getConfigurator();
        if (configurator && typeof configurator == "object") {
            var option = configurator.getOption(id);
            return option;
        }
        return false;
    },

    getActiveGroup : function() {
        var configurator = Justselling_Configento_App_Helper.getConfigurator();
        if (configurator) {
            var group = configurator.getActiveGroup();
            if (group) {
                return group;
            }
        }
        return false;
    },

    /*
     * Get an option value from configento by parsing a Id
     */
    getOptionValue: function(id) {
        if (id) {
            var configurator = Justselling_Configento_App_Helper.getConfigurator();
            if (configurator && typeof configurator == "object") {
                var option = configurator.getOption(id);
                if(option != null) {
                    var value = option.getValue();
                    if (typeof value === 'string') {
                        return value;
                    }
                    if(value && (value instanceof Justselling_Configento_Option_Choice || value instanceof Justselling_Configento_Option_Abstract)) {
                        value = value.getValue();
                    }
                    return value;
                } else {
                    throw new Error('***** NO Option found with id: "' + id + '"');
                }
            }
        }
        return false;
    },


    getOptionValueByDomId: function(elementId) {
        if (elementId) {
            var $element = jQuery("#" + elementId);
            var value = false;
            if ($element.length == 1) {
                value = $element.val();
            }
            return value
        }
        return false;
    },


    /* Check if we are in mode with predefined values comin from cart of the webshop to change configuration */
    getIsConfigureMode: function() {
        var configurator = Justselling_Configento_App_Helper.getConfigurator();
        return configurator.getHasPredefinedValues();
    },

    setOptionValues: function(values) {
        var ret = {
            success: 0,
            error: 0
        };
        var self = this;
        if(values && values.length > 0) {
            _.each(values, function (value) {
                if (Justselling_Configento_App_Api.setOptionValue(value.title, value.value, true, true)) {
                    ret.success++;
                }
                else {
                    ret.error++;
                }
            });
            if (this.timeOutActive == null) {
                this.timeOutActive = true;
                setTimeout(function () {
                    Justselling_Configento_App_Helper.getConfigurator().updateOptionsInDom();
                    Justselling_Configento_App_Debug.addDebug("configurator update triggered by API ", true);
                    self.timeOutActive = null;
                }, 200);
            }
            CONFIGENTO_PRODUCT.setPrice(Justselling_Configento_App_Helper.getConfigurator().getPrice());
        }
        return ret;

    },

    /*
     * Set an option value from configento by parsing a DOM Tag Id and value
     */
    setOptionValueByDomId: function(elementId, value, doNotTriggerDomUpdate) {
        var $element = jQuery("#"+elementId);
        var title = $element.attr("data-cf-title");
        return Justselling_Configento_App_Api.setOptionValue(title, value, doNotTriggerDomUpdate);
    },

    setOptionValue: function(title, value, doNotTriggerDomUpdate, doNotUpdatePrice) {
        var option = Justselling_Configento_App_Api.getOptionAsObject(title);
        if (option && typeof option == "object" && !_.isNaN(value)) {
            var choice = option.getChoiceByValue(value);
            if (choice) {
                option.setActiveChoice(choice);
            }

            /* if we have null, than non of option is selected */
            if (choice == null) {
                option.setActiveChoice(null);
            }
            if(option.setValue(value, true)) {
                Justselling_Configento_App_Debug.addDebug("set option value by API " + option.getTitle() + " to " + value, true);

                var configurator = Justselling_Configento_App_Helper.getConfigurator();
                if (!doNotTriggerDomUpdate) {
                    Justselling_Configento_App_Debug.addDebug("configurator update triggered by API " + option.getTitle(), true);
                    configurator.updateOptionsInDom();
                }
                if (doNotUpdatePrice !== true) {
                    // Update product price when API call changes values
                    CONFIGENTO_PRODUCT.setPrice(configurator.getPrice());
                }

                jQuery(document).trigger("configentoApiSetOptionValueAfter", {
                    'option': option
                });
            }

            return true;
        }

        Justselling_Configento_App_Debug.addDebug("EXCEPTION: Trying to set a none existing option from API "+title, true);
        return false;
    },

    setMinMaxValueForOption: function(id, minValue, maxValue) {
        var option = Justselling_Configento_App_Api.getOptionAsObject(id);
        if (option && typeof option == "object") {
            option.setMinValue(minValue);
            option.setMaxValue(maxValue);
            jQuery(document).trigger("configentoApiSetMinMaxValueAfter", {
                'option': option
            });
            return true;
        }
        return false;
    },

    removeMinMaxValueForOption: function(id) {
        Justselling_Configento_App_Api.setMinMaxValueForOption(id, false, false);
    },

    setGroupIsVisibleByIndex: function(index, value) {
        var configurator = Justselling_Configento_App_Helper.getConfigurator();
        if (!isNaN(index) && configurator) {
            var group = configurator.getGroupByIndex(index);
            if (group && typeof group == "object") {
                group.setIsVisible(value);
            }
        }
    }
}
var Justselling_Configento_App_Debug = {

    addDebug: function(value, force) {
        if (CONFIGENTO_PRODUCT.getDebugMode() || force) {
            console.log("CONFIGENTO: ",value);
        }
    },
    getDebugMode: function() {
        return   CONFIGENTO_PRODUCT.getDebugMode();
    }
};
var Justselling_Configento_App_Profiler = {
    measure : [],
    called: [],
    additional: [],

    addMeasuring: function(profilerClass, value, relevantForTotal, additional) {
        if (CONFIGENTO_PRODUCT.getDebugMode()) {
            if (isNaN(this.measure[profilerClass])) {
                this.measure[profilerClass] = 0;
            }
            if (isNaN(this.called[profilerClass])) {
                this.called[profilerClass] = 0;
            }
            if ((this.additional[profilerClass]) == undefined) {
                this.additional[profilerClass] = '';
            }
            if (isNaN(this.measure["total"])) {
                this.measure["total"] = 0;
            }
            this.measure[profilerClass] += parseInt(value);
            this.called[profilerClass] += 1;
            this.additional[profilerClass] += additional + ' _ . _ ';
            if (relevantForTotal) {
                this.measure["total"] += parseInt(value);
            }
        }
    },
    showProfiling : function() {
        if (CONFIGENTO_PRODUCT.getDebugMode()) {
            console.log("PROFILER");
            console.log(">>>>>>>>> TOTAL: " + this.measure["total"] + "ms");
            for (var key in this.measure) {
                if (this.measure.hasOwnProperty(key)) {
                    var value = this.measure[key];
                    if (value && key != "total") {
                        var percentage = parseInt(value / (this.measure["total"] / 100));
                        var totalCalled = this.called[key];
                        if (percentage >= 1 || totalCalled >= 10) {
                            console.log(key + ": " + value + "ms (" + percentage + "%) | Times called: " + totalCalled);
                        }
                    }
                }
            }
            this.measure = [];
            this.called = [];
        }
    }

}
var Justselling_Configento_App_CloudAsset = {
    doneCallback : false,
    assets : [],
    assetsID: null,
    assetsStoreFolder: null,
    assetsType: null,
    assetsFile: null,
    combinedImage: null,

    getBasePath : function() {
        var base = Justselling_Configento_App_Helper.getBackendUrl();
        if (base.search("configento/")) {
            base = base.replace(/configento\/$/, "configentobe/");
        }
        base = base + "data/assets/";
        return base;
    },

    storeCloudAsset : function(assetsValue, assetsType, doneCallback, filename, url) {
        if(url == null) {
            url = Justselling_Configento_App_CloudAsset.getBasePath() + "storeasset.php";
        }
        Justselling_Configento_App_CloudAsset.doneCallback = doneCallback;

        var data = [{
            name : 'assetsType',
            value : assetsType
        },{
            name : 'assetsValue',
            value : assetsValue
        },{
            name : 'assetsFolder',
            value : '/' + CONFIGENTO_PRODUCT.getCustomerId() + '/' + CONFIGENTO_PRODUCT.getTemplateId() + '/'
        }];
        if(Justselling_Configento_App_CloudAsset.assetsID != null) {
            data.push({
                name: 'assetsId',
                value: Justselling_Configento_App_CloudAsset.assetsID
            });
        }
        if(filename != null) {
            data.push({
                name: 'filename',
                value: filename
            });
        }

        var segments = [];
        for (var i = data.length - 1; i >= 0; i--) {
            segments.push("Content-Disposition: form-data; name=\"" + data[i].name + "\"\r\n\r\n" + data[i].value + "\r\n");
        }
        var xhr = new XMLHttpRequest();
        xhr.open('POST', url);
        xhr.setRequestHeader('Access-Control-Allow-Origin', "*");
        if(!xhr.sendAsBinary){
            xhr.sendAsBinary = function (sData) {
                var nBytes = sData.length, ui8Data = new Uint8Array(nBytes);
                for (var nIdx = 0; nIdx < nBytes; nIdx++) {
                    ui8Data[nIdx] = sData.charCodeAt(nIdx) & 0xff;
                }
                this.send(ui8Data.buffer);
                /* ...or as ArrayBuffer (legacy)...: this.send(ui8Data.buffer); */
            };
        }
        /* enctype is multipart/form-data */
        var sBoundary = "---------------------------" + Date.now().toString(16);
        xhr.setRequestHeader("Content-Type", "multipart\/form-data; boundary=" + sBoundary);
        xhr.sendAsBinary("--" + sBoundary + "\r\n" + segments.join("--" + sBoundary + "\r\n") + "--" + sBoundary + "--\r\n");

        xhr.onload = function() {//Call a function when the state changes.
            if(xhr.readyState == 4 && xhr.status == 200 && xhr.response) {
                var result = JSON.parse(xhr.response);
                if(result.status == 'success') {
                    // Save assets ID to group assets of one user session
                    Justselling_Configento_App_CloudAsset.assetsID = result['id'];
                    Justselling_Configento_App_CloudAsset.assetsStoreFolder = result['folder'];
                    Justselling_Configento_App_CloudAsset.assetsType = result['type'];
                    Justselling_Configento_App_CloudAsset.assetsFile = result['file'];
                    Justselling_Configento_App_CloudAsset.assets.length = 0; // clear assets array
                    Justselling_Configento_App_CloudAsset.assets.push({
                        type: result['type'],
                        folder: result['folder'],
                        id: result['id'],
                        file: result['file']
                    });
                    var configurator = Justselling_Configento_App_Helper.getConfigurator();
                    configurator.updateHeaderInDom();

                    if (Justselling_Configento_App_CloudAsset.doneCallback) {
                        var fn = Justselling_Configento_App_CloudAsset.doneCallback;
                        if(typeof fn === 'function') {
                            fn(Justselling_Configento_App_CloudAsset.assetsID, Justselling_Configento_App_CloudAsset.assetsStoreFolder, Justselling_Configento_App_CloudAsset.assetsType, Justselling_Configento_App_CloudAsset.assetsFile);
                        }
                    }
                } else {
                    Justselling_Configento_App_Debug.addDebug("Asset "+assetsType+" not be sent to cloud server: ["+xhr.status+"] "+xhr.response, true);
                    // Call Callbackfunction only if it´s wasn´t a configData call (for configData call we need AssetsId for the redirect)
                    if (assetsType != 'configData') {
                        if (Justselling_Configento_App_CloudAsset.doneCallback) {
                            var fn = Justselling_Configento_App_CloudAsset.doneCallback;
                            if (typeof fn === 'function') {
                                fn();
                            }
                        }
                    }
                }
            } else {
                Justselling_Configento_App_Debug.addDebug("Asset "+assetsType+" not be sent to cloud server: ["+xhr.status+"] "+xhr.statusText, true);
                // Call Callbackfunction only if it´s wasn´t a configData call (for configData call we need AssetsId for the redirect)
                if (assetsType != 'configData') {
                    if (Justselling_Configento_App_CloudAsset.doneCallback) {
                        var fn = Justselling_Configento_App_CloudAsset.doneCallback;
                        if (typeof fn === 'function') {
                            fn();
                        }
                    }
                }
            }
        };
    },

    getAssets : function() {
        return Justselling_Configento_App_CloudAsset.assets;
    }
};
var Justselling_Configento_App_Webshop = {
    callback : false,
    doneCallback: false,
    doneCallbackParams : [],
    tmpCallback: false,
    tmpParams: false,


    finalizeAction : function(doneCallback, doneParams) {
        console.log("finalizeAction");
        var configurator = Justselling_Configento_App_Helper.getConfigurator();
        var self = this;

        // Check for error Rules
        doneCallback = doneCallback == null && self.tmpCallback ? self.tmpCallback : doneCallback ;
        doneParams = doneParams == null && self.tmpParams ? self.tmpParams : doneParams ;

        var continueProcessing = true;
        var cancel = false;
        _.each(configurator.rules, function (rule) {
            // When error rule returns true, An issue is occured and validation has to be stopped
            if(continueProcessing && rule.getType() === CONFIGENTO.RULE_ERROR && (rule.process(null, "cart") )) {
                cancel = true;
                // Save callback params for continuing checkout.
                if(rule.getExtraConfig().type === 'warning') {
                    self.tmpCallback = doneCallback;
                    self.tmpParams = doneParams;
                    cancel = false;
                } else {
                    // Stop processing other rules when an error rule failed
                    continueProcessing = false;
                }
            }
        });
        if(cancel) {
            return false;
        }

        Justselling_Configento_App_Wizard.validateForm();
        if (!Justselling_Configento_App_Wizard.checkValidationForActiveGroup()) {
            return false;
        }
        else if(!Justselling_Configento_App_Wizard.checkValidationForAllGroups()) {
            return false;
        }

        if (doneCallback) {
            Justselling_Configento_App_Webshop.setDoneCallback(doneCallback);
            jQuery('body').pleaseWait();
            jQuery('#pc__error-rule').hide();
        }
        if (doneParams) {
            Justselling_Configento_App_Webshop.setDoneCallbackParams(doneParams);
        }

        /* start callback function */
        // This part is never executed because the setCallback is never been called.
        if (Justselling_Configento_App_Webshop.getCallback()) {
            var fn = Justselling_Configento_App_Webshop.getCallback();
            if(typeof fn === 'function') {
                fn();
            }
        } else {
            if ((configurator.getConfig("combinedimage") == 'no') || (configurator.getConfig("combinedimage") == 0)) {
                Justselling_Configento_App_Webshop.finalizeActionDone();
            } else {
                /* start configurator post-processing */
                var galleryClass = Justselling_Configento_App_Helper.getGalleryClass();

                var $imgContainer = jQuery(galleryClass).eq(0);
                var totalWidth = $imgContainer.width();
                var totalHeight = $imgContainer.height();

                var $imgSize = jQuery(galleryClass).eq(0).find('img').first();
                if (typeof $imgSize !== 'undefined') {
                    if (totalHeight < $imgSize.height()) {
                        totalHeight = $imgSize.height();
                    }
                }

                /* try to take natural size of image */
                if (typeof $imgSize !== 'undefined') {
                    if (typeof $imgSize[0] !== 'undefined') {
                        $imgContainer.find('img').each(function () {
                            var _this = jQuery(this);
                            if (totalWidth < _this[0].naturalWidth) {
                                totalWidth = _this[0].naturalWidth;
                                totalHeight = _this[0].naturalHeight;
                            }
                        });
                    }
                }

                if (Justselling_Configento_App_Helper.canvasFinalImageSize.width > 0) {
                    totalWidth = Justselling_Configento_App_Helper.canvasFinalImageSize.width;
                    totalHeight = Justselling_Configento_App_Helper.canvasFinalImageSize.height;
                }

                var $productImageCanvas = jQuery('<canvas id="window-product-image" crossOrigin="Anonymous" width="' + totalWidth + '" height="' + totalHeight + '"></canvas>');
                $productImageCanvas.crossOrigin = "Anonymous";
                jQuery('body').append($productImageCanvas);
                $productImageCanvas = jQuery("#window-product-image");
                $productImageCanvas.drawRect({
                    fillStyle: '#fff',
                    x: 0, y: 0,
                    width: totalWidth,
                    height: totalHeight,
                    fromCenter: false
                });


                /* try to find only active images. speedup things. */
                var is360Images = false;
                var collectImages = [];
                if (Justselling_Configento_App_Helper.getCustomCombinedImage()) {
                    // use default
                } else {
                    jQuery('#rotate360part' + Justselling360.getCurrentFrame()).find('img').each(function () {
                        collectImages.push(jQuery(this).attr('src'));
                        is360Images = true;
                    });
                }

                var canvas = document.getElementById('window-product-image');
                var context = canvas.getContext('2d');
                $imgContainer.find('img').each(function () {
                    if (typeof jQuery(this).attr('src') !== 'undefined') {
                        if (!is360Images) {
                            collectImages.push(jQuery(this).attr('src'));
                        }
                    } else if (!jQuery(this).attr('src') && jQuery(this).attr('srcset')) {
                        var srcset = jQuery(this).attr('srcset');
                        var newSrc = srcset.split(",")[0].split(" ")[0].trim();
                        collectImages.push(newSrc);
                    }
                });


                var layersContainer = [];
                (function (ondone) {
                    var index = 0;
                    nextStep();

                    // add loader

                    function nextStep() {
                        if (index >= collectImages.length) {
                            if (ondone)
                                ondone();
                            return;
                        }

                        var i = index++;
                        var image = new Image();

                        image.crossOrigin = "Anonymous";
                        image.onload = function () {
                            /* when image is loaded, call itself again, until load all images */
                            nextStep();
                        };

                        image.src = collectImages[i];
                        layersContainer.push(image);
                    }
                })(function () {
                    for (var i = 0; i <= layersContainer.length; i++) {
                        if (typeof layersContainer[i] !== 'undefined') {
                            /* draw image from center */
                            context.drawImage(layersContainer[i], canvas.width / 2 - (layersContainer[i].width + 20) / 2,
                                (canvas.height) / 2 - (layersContainer[i].height + 20) / 2);
                        }
                    }


                    /* now we execute logic */
                    var imageData = $productImageCanvas.getCanvasImage('png');
                    $productImageCanvas.remove();

                    // store clodeassets after all files has been uploaded
                    jQuery('body').on('uploadQueueComplete', function (evt) {
                        if ((configurator.getConfig("combinedimage") != 'no') && (configurator.getConfig("combinedimage") != 0)) {
                            Justselling_Configento_App_CloudAsset.storeCloudAsset(
                                imageData,
                                'imgData',
                                Justselling_Configento_App_Webshop.finalizeActionDone
                            );
                        } else {
                            Justselling_Configento_App_Webshop.finalizeActionDone();
                        }
                        jQuery(this).unbind(evt);
                    });

                    // There are files to upload, start uploading
                    if (configurator.uploadQueueComplete === false) {
                        jQuery('body').trigger('processDoropzoneQueue');
                    }
                    // If no upload option or files were added or upload already complete trigger the storeassets immediately
                    else {
                        jQuery('body').trigger('uploadQueueComplete');
                    }
                });

                /* todo: nik refactor this code, shall be using only this loading case... */
                /* this is fallback case when we don't have combined image */
                if (collectImages.length == 0) {
                    //var imageData =document.getElementById('window-product-image').toDataURL('image/png');
                    var imageData = $productImageCanvas.getCanvasImage('png');
                    //console.log(imageData, '-img data');
                    //return false;
                    $productImageCanvas.remove();

                    // store clodeassets after all files has been uploaded
                    jQuery('body').on('uploadQueueComplete', function (evt) {
                        Justselling_Configento_App_CloudAsset.storeCloudAsset(
                            imageData,
                            'imgData',
                            Justselling_Configento_App_Webshop.finalizeActionDone
                        );
                        jQuery(this).unbind(evt);
                    });

                    // There are files to upload, start uploading
                    if (configurator.uploadQueueComplete === false) {
                        jQuery('body').trigger('processDoropzoneQueue');
                    }
                    // If no upload option or files were added or upload already complete trigger the storeassets immediately
                    else {
                        jQuery('body').trigger('uploadQueueComplete');
                    }
                }
            }
        }

        jQuery(document).trigger("configentoFinalizeActionAfter");
    },

    finalizeActionDone : function() {
        if (Justselling_Configento_App_Webshop.getDoneCallback()) {
            var fn = Justselling_Configento_App_Webshop.getDoneCallback();
            if(typeof fn === 'function') {
                // Before Original add to cart function is called -> clear assetsId (necessary for ajax addtocart methods and mutltiple item ordering  )
                Justselling_Configento_App_CloudAsset.assetsID = null;
                fn(Justselling_Configento_App_Webshop.getDoneCallbackParams());
                jQuery('body').pleaseWait('stop');
            }
        }
    },

    getCallback : function() {
        return Justselling_Configento_App_Webshop.callback;
    },
    setCallback : function(callback) {
        Justselling_Configento_App_Webshop.callback = callback;
    },
    getDoneCallback : function() {
        return Justselling_Configento_App_Webshop.doneCallback;
    },
    setDoneCallback : function(doneCallback) {
        Justselling_Configento_App_Webshop.doneCallback = doneCallback;
    },
    getDoneCallbackParams : function() {
        return Justselling_Configento_App_Webshop.doneCallbackParams;
    },
    setDoneCallbackParams : function(params) {
        Justselling_Configento_App_Webshop.doneCallbackParams = params;
    }
};

var Justselling_Configento_Option_Abstract = function() {
    return this;
};

Justselling_Configento_Option_Abstract.prototype.init = function(optionType, configurator, group, internalId, title, label, params) {
        var self = this;

    self.choiceInternalIdToIndex = {};
    self.choiceIdToIndex = {};
    self.choiceValueToIndex = {};
    self.isBlacklisted = false;

    self.isRendered = (false);
    self.internalId =  String(internalId);
    self.optiontype = (optionType);
    self.group = (group);
    self.title = (title);
    self.label = (label);
    self.hasChanged = (true);
    self.frontend_type = undefined;
    self.autocomplete_template = "";
    self.autocomplete_searchby = "label";

    var doRender = false;
    var doBindToDom = true;

    /* register the new option in configurator object */
    self.configurator = (configurator);
    self.arrayIndex = configurator.addOption(self);

    var id = configurator.id
        +"-"+ Justselling_Configento_App_Helper.getIdFromLabel(title)
        +"-"+ self.arrayIndex;
    self.id = (id);
    self.setName("options["+CONFIGENTO_PRODUCT.getProductOptionId()+"]["+id+"]");

    /* parse key/values from params */
        if (params) {
            var keys = Object.keys(params);
            if (params && typeof params == 'object' && keys) {
                for (var i = 0; i < keys.length; i++) {
                    var key = keys[i];
                    var value = params[key];
                    switch (key) {
                        case 'custom_fields':
                            self.custom_fields = value;
                            break;
                        case 'min_value':
                            self.defaultMinValue = value;
                            self.setMinValue(value);
                            break;
                        case 'max_value':
                            if(value != 0) {
                                self.defaultMaxValue = value;
                                self.setMaxValue(value);
                            }
                            break;
                        case 'exact':
                            self.defaultMinValue = value;
                            self.setMinValue(value);
                            if(value != 0) {
                                self.defaultMaxValue = value;
                                self.setMaxValue(value);
                            }
                            break;
                        case 'minMaxPattern':
                            self.setMinMaxPattern(value);
                            break;
                        case 'quantity_per_item':
                            self.setQtyLimitMode(value === "1" ? 'perItem' : 'total');
                            break;
                        case 'is_visible':
                            self.setIsVisible(value);
                            break;
                        case 'image':
                            self.setImage(value);
                            break;
                        case 'visibility':
                            self.setVisibility(value);
                            break;
                        case 'info_text':
                            self.setInfoText(value);
                            break;
                        case 'info_text2':
                            self.setInfoText2(value);
                            break;
                        case 'choiceImageVisibility':
                            self.setChoiceImageVisibility(value);
                            break;
                        case 'render':
                            doRender = value;
                            break;
                        case 'bind_to_dom':
                            doBindToDom = value;
                            break;
                        case 'combifields':
                            self.setCombiFields(value);
                            break;
                        case 'operator_value':
                            self.setOperator(value);
                            break;
                        case 'combination':
                            if(parseInt(value)) {
                                self.setIsCombi(true);
                            }
                            break;
                        case 'decimal_place':
                            self.setDecimal(value);
                            break;
                        case 'multipleSelection':
                            value = 'checkbox';
                            self.setPackageType(value);
                            break;
                        case 'show_choice_tooltip':
                            self.setShowChoiceTooltip(value);
                            break;
                        case  'quantity':
                            if(optionType === 'select' ||
                            optionType === 'checkbox' ||
                            optionType === 'radiobutton' ||
                            optionType === 'multiquantity' ||
                            optionType === 'combi' ||
                            optionType === 'thumb'
                            ) {
                                self.setQtyType(value);
                                self.setWholeQty(0);
                            }
                            break;
                        case  'min_qty':
                            self.setMinQty(value);
                            self.setDefaultMinQty(value);
                            break;
                        case  'max_qty':
                            if(value!=0) {
                                self.setMaxQty(value);
                                self.setDefaultMaxQty(value);
                            }
                            break;
                        case  'sku':
                            self.setSku(value);
                            break;
                        case  'expression':
                            self.setExpression(value);
                            break;
                        case  'operator_value_price':
                            self.setOperatorValuePrice(value);
                            break;
                        case  'package_options':
                            self.setPackageOptions(value);
                            break;
                        case  'choice_matrix':
                            if (value) {
                                self.setChoiceMatrix(value.matrix);
                                self.setChoiceMatrixDim_x(value.dimension_x);
                                self.setChoiceMatrixDim_y(value.dimension_y);

                                self.configurator.setUnparsedOption({
                                    type: 'choice_matrix',
                                    setType: 'setChoiceMatrixDim_x',
                                    optionIndex: self.arrayIndex,
                                    childTitle: value.dimension_x
                                });
                                self.configurator.setUnparsedOption({
                                    type: 'choice_matrix',
                                    setType: 'setChoiceMatrixDim_y',
                                    optionIndex: self.arrayIndex,
                                    childTitle: value.dimension_y
                                });
                                self.addExpressionVariable = function(variable) {
                                        if (this.expressionVariable == null) {
                                            this.expressionVariable = [];
                                        }
                                        if(variable) {
                                            this.expressionVariable.push(variable);
                                        }
                                }
                                self.calculate = function () {

                                    var choices = self.getChoices();
                                    if (choices) {
                                        for (var i = 0; i < choices.length; i++) {
                                            var choice = choices[i];
                                            var price = 0;
                                            var matrix = self.getChoiceMatrix();
                                            if (matrix) {
                                                var configurator = self.getConfigurator();
                                                var dim_x = self.getChoiceMatrixDim_x();
                                                var dim_y = self.getChoiceMatrixDim_y();
                                                if (typeof matrix === 'string') {
                                                    matrix = configurator.getOption(matrix);
                                                    if (matrix) {
                                                        self.setChoiceMatrix(matrix);
                                                    }
                                                }
                                                if (matrix) {
                                                    if (dim_x === 'Xcurrent_choice_valueX') {
                                                        dim_x = choice.getValue();
                                                    }
                                                    else if (typeof dim_x === 'string') {
                                                        dim_x = configurator.getOption(dim_x);
                                                        self.setChoiceMatrixDim_x(dim_x);
                                                        dim_x = dim_x.getValue();
                                                    }
                                                    else {
                                                        dim_x = dim_x.getValue();
                                                    }

                                                    if (dim_y === 'Xcurrent_choice_valueX') {
                                                        dim_y = choice.getValue();
                                                    }
                                                    else if (typeof dim_y === 'string') {
                                                        dim_y = configurator.getOption(dim_y);
                                                        self.setChoiceMatrixDim_y(dim_y);
                                                        dim_y = dim_y.getValue();
                                                    }
                                                    else {
                                                        dim_y = dim_y.getValue();
                                                    }

                                                    price = matrix.getValueFromMatrix(dim_x, dim_y);
                                                    Justselling_Configento_App_Debug.addDebug("Getting price from matrix x="+dim_x+" y="+dim_y+" p="+price);
                                                    choice.setPrice(price);
                                                    // If we do change the price of the active choice, we have to trigger our children
                                                    if (this.isActiveChoice(choice)) {
                                                        this.triggerChildren();
                                                    }
                                                }
                                            }
                                        }
                                        self.setHasChanged(true);
                                        self.setIsRendered(false);
                                    }
                                }
                            }
                            break;
                    }
                }
            }
        }

        self.setBindToDom(doBindToDom);

        var predefinedValue = self.getConfigurator().getPredefinedValue(self.getTitle());
        /* set predefined value, if we have one and value of the option is of type 'simple' */
        if (predefinedValue) {
            self.setPredefinedObject(predefinedValue);
            if(optionType != "expression" && optionType != "matrix" && optionType != "attribute") {
                if (!predefinedValue['valueId']) {
                    self.setDefaultValue(predefinedValue['value'], true);
                }
                self.setIsPredefined(true);
            }
        }

        if (doRender) {
            self.render();
        }

    };
Justselling_Configento_Option_Abstract.prototype.setQtyLimitMode = function(mode) {
    this.qtyLimitMode = mode;  // Mode can be 'total' or 'perItem'
};
Justselling_Configento_Option_Abstract.prototype.getQtyLimitMode = function() {
    return this.qtyLimitMode || 'total';  // Default to 'total' if not set
};
Justselling_Configento_Option_Abstract.prototype.setChoiceMatrix = function(matrix) {
    this.choiceMatrix = matrix;
};
Justselling_Configento_Option_Abstract.prototype.getChoiceMatrix = function() {
    return this.choiceMatrix;
};
Justselling_Configento_Option_Abstract.prototype.setChoiceMatrixDim_x = function(dimension_x) {
    this.choiceDimension_x = dimension_x;
};
Justselling_Configento_Option_Abstract.prototype.getChoiceMatrixDim_x = function() {
    return this.choiceDimension_x;
};
Justselling_Configento_Option_Abstract.prototype.setChoiceMatrixDim_y = function(dimension_y) {
    this.choiceDimension_y = dimension_y;
};
Justselling_Configento_Option_Abstract.prototype.getChoiceMatrixDim_y = function() {
    return this.choiceDimension_y;
};
Justselling_Configento_Option_Abstract.prototype.getCustomFields = function() {
    var self = this;
    if (!self.custom_fields) return false;

    var configurator = this.getConfigurator();
    var customFieldsConfig = configurator.getConfig("customFields");
    if (customFieldsConfig && customFieldsConfig.options) {
        _.each(self.custom_fields, function (custom_field, key) {
            var myTitle = null;
            var myKey = null;
            _.each(customFieldsConfig.options, function (config) {
                if (config.id == key) {
                    myTitle = config.name;
                    myKey = key;
                }
            });
            self.custom_fields[myKey].title = myTitle;
            var id = Justselling_Configento_App_Helper.getIdFromLabel(myTitle)
            self.custom_fields[myKey].id = id;
        });
        return self.custom_fields;
    }
    return false;
};

    /*
     * Add a new choice to this option
     */
Justselling_Configento_Option_Abstract.prototype.addChoice = function(choice) {
        var self = this;
        if (!jQuery.isArray(self.choices)) {
            self.choices = [];
        }
    var choiceIndex = self.choices.push(choice) -1;
    self.choiceInternalIdToIndex[String(choice.internalId)] = choiceIndex;
    self.choiceValueToIndex[choice.originalValue] = choiceIndex;
   // self.addChoiceAfter(choice);
    return choiceIndex;
    };

    /*
     * Bind event to the DOM representation of the the option to be able
     * to sync the internal value and the DOM Value
     */
Justselling_Configento_Option_Abstract.prototype.bindToDom = function() {
        var self = this;
        if (self.getBindToDom()) {
            if (self.getDomElement() && self.getDomElement().length == 1) {
                jQuery(self.getConfigurator().getDomElement()).on("change", "#" + self.getId(), function (event) {
                    self.DOMChangeCallback(event);
                });
            }
        }
    };
Justselling_Configento_Option_Abstract.prototype.getChoiceElementFromEvent = function(event) {
    if (!event) return false;
    var $element = jQuery(event.srcElement);
    if (!$element || $element.length != 1) $element = jQuery(event.currentTarget);
    if (!$element || $element.length != 1) return false;
    var type = $element.prop('nodeName');
    switch (type) {
        case 'SELECT':
            $element = $element.find(":selected");
            break;
        default:
            break;
    }
    return $element;
};
Justselling_Configento_Option_Abstract.prototype.someActivePackagesHasSameChoices = function() {
    var configurator = this.getConfigurator();
    var options = configurator.getOptions();
    var choices = [];
    for (var n=0; n<options.length; n++) {
        var option = options[n];
        if (option.getType() == 'package' && option.getActive() && option.getId() != this.getId()) {
            var self = this;
            for (var u=0; u<option.getPackageOptions().length; u++) {
                var packageOptions = option.getPackageOptions();
                var packageOption =  packageOptions[u];
                for (var t=0; t<packageOption.availableChoices.length; t++) {
                    var availableChoice = packageOption.availableChoices[t];
                    for (var p=0; p<self.getPackageOptions().length; p++) {
                        packageOptions = self.getPackageOptions();
                        var ownPackageOption =  packageOptions[p];
                        for (var i=0; i<ownPackageOption.availableChoices.length; i++) {
                            var ownAvailableChoice = ownPackageOption.availableChoices[i];
                            if (ownAvailableChoice == availableChoice) {
                                choices.push(configurator.getChoiceByInternalId(availableChoice));
                            };
                        }
                    }
                }
            }
        }
    }
    if (choices.length == 0) return false;
    return choices;
};
Justselling_Configento_Option_Abstract.prototype.getChoiceFromEvent = function(event) {
    var $element = this.getChoiceElementFromEvent(event);
    if (!$element || $element.length != 1) return true;
    var internatId = $element.attr('data-cf-internalid');
    var configurator = this.getConfigurator();
    var choice = configurator.getChoiceByInternalId(internatId);
    return choice;
};
Justselling_Configento_Option_Abstract.prototype.isChangeAllowed = function(event) {
    /*
      If a choice was activated by a package, we have to de-activate the whole
      package. Just ask the user, if the package shall be de-activated, otherwise do
      not change the configuration
     */
    var $element = this.getChoiceElementFromEvent(event);
    if (!$element || $element.length != 1) return true;
    var internatId = $element.attr('data-cf-internalid');
    var configurator = this.getConfigurator();
    var choice = false;
    if (this.getType() != 'package') {
        choice = configurator.getChoiceByInternalId(internatId);
        if (!choice) return true;
    }

    var optionType = this.getType();
    if (choice) optionType = choice.getOption().getType();

    var isActiveByPackage = false;
    var someActivePackagesHasSameChoices = false;
    var choiceFromPackage = [choice];
    var isChangeAllowed = false;

    switch (optionType) {
        case 'checkbox':
        case 'multiselect':
            isActiveByPackage = choice.getIsActiveByPackage();
            break;
        case 'radiobutton':
        case 'select':
        case 'thumb':
        case 'selectcombi':
            var choices = choice.getOption().getChoices();
            for (var i=0;i<choices.length; i++) {
                var element = choices[i];
                if (element.getIsActiveByPackage()) {
                    isActiveByPackage = true;
                    choiceFromPackage = [element];
                    isChangeAllowed = true;
                }
            }
            break;
        case 'package':
            someActivePackagesHasSameChoices = this.someActivePackagesHasSameChoices();
            choice = this;
            break;
        default:
            isChangeAllowed = true;
            break;
    }
    if (configurator.isInternalIdFromPackage(internatId) && !someActivePackagesHasSameChoices) return true;

    if ((choice && choiceFromPackage && isActiveByPackage) || someActivePackagesHasSameChoices) {
        if (someActivePackagesHasSameChoices) choiceFromPackage = someActivePackagesHasSameChoices;
        var packages = [];
        for (var i=0;i<choiceFromPackage.length;i++) {
            var item = choiceFromPackage[i];
            packages.push(configurator.getOptionByInternalId(item.getIsActiveByPackage()));
        }

        var newChoice = [];
        if (isChangeAllowed) {
            newChoice.push(choice);
        }
        if (someActivePackagesHasSameChoices) {
            newChoice.push(this);
        }
        var message = Justselling_Configento_App_Message.configurationChangeMessage(packages, newChoice);
        var result = Justselling_Configento_App_Message.confirm(message, event, this, packages);

        if (result) {
            for (var i=0;i<packages.length;i++) {
                var package = packages[i];
                package.setActive(false);
            }
            return isChangeAllowed;
        } else {
            var option = this;
            if (!someActivePackagesHasSameChoices) option = choice.getOption();
            option.setHasChanged(true);
            return false;
        }
    }
    return true;
}

Justselling_Configento_Option_Abstract.prototype.DOMChangeCallback = function(event, force, status, packages) {
        var self = this;

        // Do not process DOM events when processing Option Updates in DOM
        var configurator = self.getConfigurator();
        if (configurator.processingUpdateOptionsInDOM) return;

        var eventId = event["type"] + "-" + event["timeStamp"];
        Justselling_Configento_App_Debug.addDebug("change callback=" + self.getDomElement().attr("id"));
        Justselling_Configento_App_Debug.addDebug(event);
        if (force || eventId != self.lastHandledEvent) {
            Justselling_Configento_App_Debug.addDebug("handle event");
            self.getConfigurator().setIsEventHandler(true);
            if (force || self.isChangeAllowed(event)) {
                var choice = self.getChoiceFromEvent(event);
                var option = false;
                if (choice && choice instanceof Justselling_Configento_Option_Choice) option = choice.getOption();
                var isPackage = true;
                if (option && option.getType() != 'package') { isPackage = false; }

                if (!isPackage && (!force || (force && status))) {
                    self.updateValueFromDom();
                }
                if (force && packages) {
                    for (var i=0;i<packages.length;i++) {
                        var package = packages[i];
                        package.setActive(!status);
                    }
                }
                if (isPackage && (!force || (force && status))) {
                    self.updateValueFromDom();
                }
                self.getConfigurator().updateOptionsInDom();
            }
        }
        self.lastHandledEvent = eventId;
        Justselling_Configento_App_Debug.addDebug("done");
        self.getConfigurator().setIsEventHandler(false);
    };

    /*
     * Integrate or update the HTML Code Snippet of the option in the DOM
     */
Justselling_Configento_Option_Abstract.prototype.render = function() {
    var start = new Date().getTime();

    var self = this;
    var configurator = self.getConfigurator();
        if (self.getIsVisible() && !configurator.noRenderByRules) {
            self.renderBefore();
            var renderValidator = false;
            var templateType = self.getType();
            if(self.getFrontendType() !== undefined) {
                templateType = self.getFrontendType();
                if(Justselling_Configento_App_Helper.$template.find('#' + templateType  + '-template').length == 0) {
                    templateType = self.getType();
                }
            }
            var source = Justselling_Configento_App_Helper.$template.find('#' + templateType  + '-template').html();
            if (source) {
                self.setTemplate(Handlebars.compile(source));
            }
            var html = self.getHtml();
            if(self.getIsRendered() === false) {
                renderValidator = true;
            }
            self.setIsRendered(true);

            var $element = self.getDomElement();
            if (!$element || $element.length == 0) {
                var group = self.getGroup();
                var $container;
                if (group && group.getDomElement() && group.getDomElement().length == 1) {
                    $container = group.getDomElement();
                    $container = $container.find(".options");
                } else if (configurator && configurator.getDomElement() && configurator.getDomElement().length == 1) {
                    $container = configurator.getDomElement();
                }
                if ($container && $container.length == 1) {
                    $container.append(html);
                }
                self.renderValidator(self.getDomElement());
                self.renderMinMaxPattern();

                // render chart option
                if(self.getType() == 'chart') {
                    self.createChart();
                }
                if(self.getChoiceImageVisibility() === 'selected' && typeof self.activateHoverListener === 'function'){
                    self.activateHoverListener();
                }
            } else {
                // Before replacing the new option html, remove valiadtion rules.
                // option with data-fv-excluded attribute cause problems
                var validator = Justselling_Configento_App_Helper.getFormValidator();
                if(validator) {
                    if(validator._cacheFields[self.getName()] != null) {
                        try {
                            validator.removeField($element);
                            delete validator.options.fields[self.getName()];

                        } catch (e) { }
                        delete validator._cacheFields[self.getName()];
                        renderValidator = true;
                    }
                    else if (
                        $element.attr('data-fv-trigger') && $element.attr('data-fv-trigger') != ''
                        && $element.attr('data-fv-excluded') == 'false') {
                        validator.removeField($element);
                        renderValidator = true;
                    }
                }

                /* option was rendered already before, just do update of inner-html */
                var $newElement = jQuery(html);
                self.getDomParentElement().html($newElement.html());

                $element = jQuery("#" + self.getId());
                /* reset Dom element in option object to make sure reference is intact */
                self.setDomElement($element);

                if(renderValidator || self.getType() === 'multiquantity') {
                    // assign validation rules to new object
                    self.renderValidatorAfter($element);
                }
                if(typeof jQuery('body').swSelectboxReplacement === 'function' &&  $element.parent().find('select').length ) {
                    $element.parent().find('select').swSelectboxReplacement();
                }
                self.renderMinMaxPattern();
            }
            self.renderGroupsAndInfo();
            self.renderAfter();
            self.bindToDom();
            if(typeof self.bindQtyToDom === 'function' && self.getQtyType() > 0 ){
                self.bindQtyToDom();
            }

            try {
                jQuery(document).trigger({"type": 'configentoRenderOptionAfter', "option":self} , { "option":self});
            } catch (e) {
                jQuery(document).trigger('configentoRenderOptionAfter', { "option":self});
            }
        }

    var end = new Date().getTime();
    var time = end - start;
    Justselling_Configento_App_Profiler.addMeasuring("abstract:render internalId:" + self.optiontype + ' _ ', time);
    Justselling_Configento_App_Profiler.addMeasuring("abstract:render ", time);

    };

Justselling_Configento_Option_Abstract.prototype.renderGroupsAndInfo = function () {
    this.createChoiceGroups();

    if(this.getShowChoiceTooltip()) {
        this.renderChoiceTooltip();
    }
    if (this.getInfoText2()) {
        this.renderInfoText2();
    }
}

Justselling_Configento_Option_Abstract.prototype.createChoiceGroups = function () {
    var self = this;
    if(_.isArray(self.getChoiceGroups())) {
        var $element = self.getDomElement();

        var optionType = self.getType();
        _.each(self.getChoiceGroups(), function(choiceGroup, index) {

            if(optionType == 'multiquantity' || optionType == 'radiobutton' || optionType == 'checkbox' || optionType == 'package') {
                var choices = $element.find('input[data-cf-choicegroup=' + index + ']').parent();
                if(optionType === 'checkbox') {
                    choices = choices.parent();
                }
                choices.first().before('<div class="c-__option-choices-group" id="'+this.getId()+'-'+ index+'" ><p class="choice-group-title">' + choiceGroup + '</p><div class="c-__option-choices-gwrapper"></div></div>');
                jQuery(choices).appendTo(jQuery('#'+this.getId()+'-'+ index + ' .c-__option-choices-gwrapper'));
            }
            else if(optionType == 'select' || optionType == 'multiselect' || optionType == 'selectcombi' || optionType == 'thumb') {
                var choices = $element.find('option[data-cf-choicegroup=' + index + ']');
                choices.first().before('<optgroup id="'+this.getId()+'-'+ index+'" label="' + choiceGroup + '"></optgroup>');
                jQuery(choices).appendTo('#'+this.getId()+'-'+ index);
            }
            /* try to activate tooltips for groups also */
            self.renderInfoText2();
        }, self);

    }
};

Justselling_Configento_Option_Abstract.prototype.renderBefore = function () {
    var self = this;
    if(self.getQtyType() > 0) {
        // Check qty weith min qty of option
        var minQty = parseInt(self.getMinQty());
        var maxQty = parseInt(self.getMaxQty());
        var wholeQty = 0;
        var updateInDom = false;
        var activeChoice = self.getActiveChoice();
        if(!_.isArray(activeChoice)) {
            if(activeChoice instanceof Justselling_Configento_Option_Choice) {
                activeChoice = [activeChoice];
            } else {
                activeChoice = [];
            }
        }
        _.each(self.getChoices(), function (choice) {
            var qty = parseInt(choice.getQty());
            // Enforce max quantity rules based on the mode
            if (self.getQtyLimitMode() === 'total') {
                // Max total logic: sum all quantities
                wholeQty += qty;
                if (wholeQty > maxQty) {
                    wholeQty -= qty;  // Remove the current choice qty
                    choice.setQty(0);  // Reset this choice to zero
                    activeChoice = _.filter(activeChoice, function (actChoice) {
                        return actChoice.id !== choice.id;
                    });
                    self.setActiveChoice(activeChoice);
                    updateInDom = true;
                }
            } else if (self.getQtyLimitMode() === 'perItem') {
                // Max per item logic: limit each choice individually
                if (qty > maxQty) {
                    choice.setQty(maxQty);  // Restrict to maxQty for each item
                    updateInDom = true;
                }
            }
        });
        // Set the total quantity if in max total mode
        if (self.getQtyLimitMode() === 'total') {
            self.setWholeQty(wholeQty);
        }
        if(updateInDom ) {
            self.updateValueInDom();
        }
        if(self.getQtyChanged()) {
            self.updateValueFromActiveChoice();
        }
    }
};
Justselling_Configento_Option_Abstract.prototype.renderAfter = function() {
        /* specific option types can place code that have to be done after render */
/*
        if (this.getType() == 'checkbox') {
            if (this.getValue() == 1) {
                this.setChecked();
            }
        }*/

        // if qty field is a input box, validate their min and max values
        if(this.getQtyType() == 1){
            var validator = Justselling_Configento_App_Helper.getFormValidator();
            if (validator) {
                var qtyField = this.getDomElement().find('.qty');
                validator.addField(qtyField).validateField(qtyField);
            }
        }
    };

    /*
     * Build HTML Snippet for option, using handlebars template
     */
Justselling_Configento_Option_Abstract.prototype.getHtml = function() {
        var self = this;
        var visibile = "";
        if (!self.getIsVisible()) {
            visibile = "style=\"display:none\"";
        }
        var extraClass = '';
        if(self.getImage()) {
            extraClass = 'hasOptionImage'
        }
        if(self.getIsRequired() == true) {
            extraClass += ' is-required';
        }
        if(self.getQtyType()) {
            extraClass += ' qty-type-'+self.getQtyType();
        }
        var html = '<div id="'+self.getId()+'-container" class="configento pure-control-group option '+extraClass+' type-'+self.getType()+' '+self.getCustomClass()+'" '+visibile+'>';
        var template;
        if (template = self.getTemplate()) {
            var selectedValue;
            var optionType = self.getType();

            var activeChoice = self.getActiveChoice();
            if (activeChoice instanceof Justselling_Configento_Option_Choice) {
                selectedValue = activeChoice.getId();
            }
            else if (_.isArray(activeChoice)) {
                selectedValue = _.map(activeChoice, function (choice) {
                    return choice.getId();
                });
            }

            var choiceImageVisibilityClass = '';
            if(self.getChoiceImageVisibility()) {
                choiceImageVisibilityClass = 'show-choice-'+ self.getChoiceImageVisibility();
            }
            var image = self.getImage();
            if(self.getConfigurator().getConfig("optionImagePosition") == 'donotshow') {
                image = null;
            }

            var context = {
                id: self.getId(),
                internalId: self.getInternalId(),
                title: self.getTitle(),
                label: self.getLabel(),
                image: image,
                choices: self.getActiveChoices(),
                optionMainClass: choiceImageVisibilityClass,
                value: self.getValue(),
                name: self.getName(),
                infotext: self.getInfoText(),
                infotext2: self.getInfoText2(),
                selectedValue: selectedValue,
                type: optionType,
                required: self.getIsRequired(),
                price: self.getPrice(),
                frontend_type: self.getFrontendType()
            };
            if(optionType === 'radiobutton'
                || optionType === 'checkbox'
                || optionType === 'multiquantity'
                || optionType === 'select'
                || optionType === 'selectcombi'
                || optionType === 'thumb')
            {
                if(self.getQtyType()) {
                    context.qtyType = parseInt(self.getQtyType());
                    context.minQty = self.getMinQty();
                    context.maxQty = self.getMaxQty();
                    if(self.hasWholeQty === true) {
                        context.wholeQty = self.getWholeQty();
                    }
                }

                // handle only image styling of option if at least one choice has an image
                if(self.getHasChoiceWithImage()) {
                    if (self.getChoiceImageVisibility() === 'always') {
                        context.showAllChoiceImages = true;
                    }
                    else if (self.getChoiceImageVisibility() === 'selected' && self.getActiveChoice()) {
                        var activeChoice = self.getActiveChoice();
                        if (_.isArray(activeChoice)) {
                            activeChoice = activeChoice[activeChoice.length - 1];
                        }
                        context.currentChoiceImage = activeChoice;
                    }
                }
            }
            else if(optionType === 'package') {
                price = self.getPackagePrice();
                context.price = parseFloat(price);
            }
            else if(optionType === 'combi') {
                var price = self.getPrice();
                if(self.getWholeQty() != null) {
                    price = price / self.getWholeQty();
                }
                context.priceHtml = Justselling_Configento_App_Price.renderPrice(price);
            }
            else if(optionType === 'area' || optionType === 'text'){
                context.placeholder = self.getPlaceholder();
            }
            html += template(context);
        }
        html += "</div>";
        return html;
    };

    /*
     * Add an-other option to the child list. All entries in the
     * child list will be triggered when the value of this option has changed.
     * Will allow other options to re-calculate their value (e.g. expression)
     */
Justselling_Configento_Option_Abstract.prototype.addChild = function(option) {
        if (this.children == null || !_.isArray(this.children)) {
            this.children = [];
        }
        if (option.getId() == this.getId()) {
            Justselling_Configento_App_Debug.addDebug("EXCEPTION: Trying to add self as child: "+option.getId(), true);
        }/* else if(option instanceof Justselling_Configento_Option_Choice){
            this.children.push({optionIndex: option.option.getArrayIndex(), choiceIndex: option.getArrayIndex()});
        } else if(option instanceof Justselling_Configento_Rules_Rule){
            // TODO: use Rules index ID
            this.children.push({ruleIndex: option.getArrayIndex()});
        } */ else {
            this.children.push(option);
        }

    };

    /*
     * Trigger all children from child-list to re-calculate their values
     */
Justselling_Configento_Option_Abstract.prototype.triggerChildren = function() {
    var start = new Date().getTime();
    //var configurator = this.getConfigurator();
    var children = this.children;
        if (_.isArray(children)) {
            for (var i = 0; i < children.length; i++) {
                var child = children[i];

                var start2 = new Date().getTime();

                if(child instanceof Justselling_Configento_Rules_Rule) {
                    child.process(true);
                }else if (typeof child.calculate === 'function') {
                    child.calculate();
                }

                var end2 = new Date().getTime();
                var time2 = end2 - start2;
                Justselling_Configento_App_Profiler.addMeasuring("abstract:triggerChildren_"+child.getId() , time2);
                Justselling_Configento_App_Profiler.addMeasuring("abstract:triggerMyChildren_"+this.getId() , time2);

                /*var obj;
                if(typeof child === 'object' && child.ruleIndex) {
                    configurator.rules[child.ruleIndex].process(true);
                }else {
                    if (typeof child === 'object') {
                        obj = configurator.options[child.optionIndex].choice[child.choiceIndex];
                    }
                    else {
                        obj = configurator.options[child];
                    }
                    if (typeof obj.calculate === 'function') {
                        obj.calculate();
                    }
                }*/
            }
        }
    var end = new Date().getTime();
    var time = end - start;
    Justselling_Configento_App_Profiler.addMeasuring("abstract:triggerChildren" , time);
    };

    /*
     * Getter and Setter for the internal variables
     */
Justselling_Configento_Option_Abstract.prototype.setConfigurator = function(configurator) {
        this.configurator = configurator;
};
Justselling_Configento_Option_Abstract.prototype.getConfigurator = function() {
        return this.configurator;
};
Justselling_Configento_Option_Abstract.prototype.setId = function(tagId) {
        this.id =  tagId;
};
Justselling_Configento_Option_Abstract.prototype.getId = function() {
        return this.id;
};
Justselling_Configento_Option_Abstract.prototype.setArrayIndex = function(arrayIndex) {
        this.arrayIndex =  arrayIndex;
};
Justselling_Configento_Option_Abstract.prototype.getArrayIndex = function() {
        return this.arrayIndex;
};
Justselling_Configento_Option_Abstract.prototype.setInternalId = function(internalId) {
        this.internalId =  String(internalId);
};
Justselling_Configento_Option_Abstract.prototype.getInternalId = function() {
        return this.internalId;
};
Justselling_Configento_Option_Abstract.prototype.setIsRendered = function(value) {
        this.isRendered = value;
};
Justselling_Configento_Option_Abstract.prototype.getIsRendered = function() {
        return this.isRendered;
};
Justselling_Configento_Option_Abstract.prototype.setIsPredefined = function(value) {
        this.isPredefined = value;
};
Justselling_Configento_Option_Abstract.prototype.getIsPredefined = function() {
        return this.isPredefined;
};
Justselling_Configento_Option_Abstract.prototype.setPredefinedObject = function(value) {
        this.predefinedObject = value;
};
Justselling_Configento_Option_Abstract.prototype.getPredefinedObject = function() {
        return this.predefinedObject;
};
Justselling_Configento_Option_Abstract.prototype.setBindToDom = function(value) {
        this.doBindToDom = value;
};
Justselling_Configento_Option_Abstract.prototype.getBindToDom = function() {
        return this.doBindToDom;
};
Justselling_Configento_Option_Abstract.prototype.setMinValue = function(value) {
        this.minValue =  value;
};
Justselling_Configento_Option_Abstract.prototype.getMinValue = function() {
        return this.minValue;
};
Justselling_Configento_Option_Abstract.prototype.setMaxValue = function(value) {
        this.maxValue =  value;
};
Justselling_Configento_Option_Abstract.prototype.getMaxValue = function() {
        return this.maxValue;
};
Justselling_Configento_Option_Abstract.prototype.setMinMaxPattern = function(value) {
        this.minMaxPattern =  value;
};
Justselling_Configento_Option_Abstract.prototype.getMinMaxPattern = function() {
        return this.minMaxPattern;
};
Justselling_Configento_Option_Abstract.prototype.setGroup = function(group) {
        this.group = group;
};
Justselling_Configento_Option_Abstract.prototype.getGroup = function() {
        return this.group;
};
Justselling_Configento_Option_Abstract.prototype.addChoiceGroup = function(choiceGroup) {
        if(this.choiceGroups == null){
            this.choiceGroups = [];
        }
        return this.choiceGroups.push(choiceGroup) - 1;
};
Justselling_Configento_Option_Abstract.prototype.getChoiceGroups = function() {
        return this.choiceGroups;
};
Justselling_Configento_Option_Abstract.prototype.setType = function(optionType) {
    this.optiontype = optionType;
};
Justselling_Configento_Option_Abstract.prototype.getType = function() {
    return this.optiontype;
};
Justselling_Configento_Option_Abstract.prototype.setFrontendType = function(frontEndType) {
    this.frontend_type = frontEndType;
};
Justselling_Configento_Option_Abstract.prototype.getFrontendType = function() {
    return this.frontend_type;
};
Justselling_Configento_Option_Abstract.prototype.setAutocompleteSearchby = function(autocompleteSearchby) {
    this.autocomplete_searchby = autocompleteSearchby;
};
Justselling_Configento_Option_Abstract.prototype.getAutocompleteSearchby = function() {
    return this.autocomplete_searchby;
};
Justselling_Configento_Option_Abstract.prototype.setStaticDateRestriction = function(staticDateRestriction) {
    this.staticDateRestriction = staticDateRestriction;
};
Justselling_Configento_Option_Abstract.prototype.getStaticDateRestriction = function() {
    return this.staticDateRestriction;
};
Justselling_Configento_Option_Abstract.prototype.setAutocompleteTemplate = function(autocompleteTemplate) {
    this.autocomplete_template = autocompleteTemplate;
};
Justselling_Configento_Option_Abstract.prototype.getAutocompleteTemplate = function() {
    return this.autocomplete_template;
};
Justselling_Configento_Option_Abstract.prototype.setTitle = function(title) {
        this.title = title;
};
Justselling_Configento_Option_Abstract.prototype.getTitle = function() {
        return this.title;
};
Justselling_Configento_Option_Abstract.prototype.setLabel = function(label) {
        this.label = label;
};
Justselling_Configento_Option_Abstract.prototype.getLabel = function() {
        return this.label;
};
Justselling_Configento_Option_Abstract.prototype.setName = function(name) {
        this.name = name;
};
Justselling_Configento_Option_Abstract.prototype.getName = function() {
        return this.name;
};
Justselling_Configento_Option_Abstract.prototype.setIsCombi = function(value) {
        this.isCombi = value;
};
Justselling_Configento_Option_Abstract.prototype.getIsCombi = function() {
        if (this.isCombi === undefined) {
            return false;
        }
        return this.isCombi;
};
Justselling_Configento_Option_Abstract.prototype.setCombiFields = function(combiFields) {
        this.combiFields = combiFields;
};
Justselling_Configento_Option_Abstract.prototype.getCombiFields = function() {
        return this.combiFields;
};
Justselling_Configento_Option_Abstract.prototype.setOperator = function(operator) {
        this.operator = operator;
};
Justselling_Configento_Option_Abstract.prototype.getOperator = function() {
        return this.operator;
};
Justselling_Configento_Option_Abstract.prototype.setDecimal = function(decimal) {
        this.decimal = decimal;
};
Justselling_Configento_Option_Abstract.prototype.getDecimal = function() {
        return this.decimal;
};
Justselling_Configento_Option_Abstract.prototype.setShowChoiceTooltip = function(bool) {
        this.showChoiceTooltip = bool;
};
Justselling_Configento_Option_Abstract.prototype.getShowChoiceTooltip = function() {
        return this.showChoiceTooltip;
};

Justselling_Configento_Option_Abstract.prototype.setInfoText = function(value) {
        this.infoText = value;
        this.renderInfoText();
};
Justselling_Configento_Option_Abstract.prototype.getInfoText = function() {
        return this.infoText;
};
Justselling_Configento_Option_Abstract.prototype.setInfoText2 = function(value) {
        this.infoText2 = value;
        this.renderInfoText2();
};
Justselling_Configento_Option_Abstract.prototype.getInfoText2 = function() {
        return this.infoText2;
};
Justselling_Configento_Option_Abstract.prototype.setImage = function(image) {
    /* don't set empty object */
    if (image.length > 0) {
        this.image = image;
    }
};
Justselling_Configento_Option_Abstract.prototype.getImage = function() {
        return this.image;
};
Justselling_Configento_Option_Abstract.prototype.setChoiceImageVisibility = function(visibilityType) {
        this.choiceImageVisibility = visibilityType;
};
Justselling_Configento_Option_Abstract.prototype.getChoiceImageVisibility = function() {
        return this.choiceImageVisibility;
};
Justselling_Configento_Option_Abstract.prototype.setIsRequired = function(isRequired) {
        this.isRequired = isRequired;
};
Justselling_Configento_Option_Abstract.prototype.getIsRequired = function() {
        return this.isRequired;
};

Justselling_Configento_Option_Abstract.prototype.setExpression = function(expression) {
    this.myExpression = expression;
    if(typeof this.parse  === 'function') {
        this.parse(expression);
    }
};
Justselling_Configento_Option_Abstract.prototype.getExpression = function() {
    return this.myExpression;
};

Justselling_Configento_Option_Abstract.prototype.setIsBlacklisted = function(value) {
        var self = this;
        if (self.isBlacklisted == value) {
            return false;
        }

        self.isBlacklisted = value;
        self.setHasChanged(true);

        if (value === true) {
            // If option is Blacklisted set the selected choice back to default value or to 'Please Choose' choice.
            // issue when option was displayed again after selection was made: the price was not recalculated.
            /*if(self.getActiveChoice() ) {
                var defaultValue = self.getDefaultValue();
                if(defaultValue == null) {
                    defaultValue = '';
                }
                var activeChoice = self.getChoiceByValue(defaultValue);
                if(_.isArray(defaultValue)){
                    activeChoice = _.map(defaultValue, function (value) {
                        return this.getChoiceByValue(value);
                    }, self)
                }
                self.setActiveChoice(activeChoice);
            }*/
            /* if option is blacklisted, we don't need active choice, */
            self.setActiveChoice(null);
            self.setOriginalValue(null); //self.getValue());
            self.setValue(null);
          /*  if(self.getType() == 'thumb') {
                var validator = Justselling_Configento_App_Helper.getFormValidator();
                if (validator) {
                    validator.removeField(self.getDomElement());
                    self.renderValidatorAfter(self.getDomElement());
                }
            }*/
        }
        else if (value === false) {
            if (typeof self.calculate === 'function'){
                self.calculate();
            } else {
                var activeChoice;
                var originalValue = self.getOriginalValue();
                /* set again active choice after option has been whitelisted */
                if((originalValue == '') || (originalValue == null)) {
                    originalValue = self.getDefaultValue();
                }
                if(_.isArray(self.getOriginalValue())) {
                    activeChoice = _.map(originalValue, function (value) {
                        return this.getChoiceByValue(value);
                    }, self)
                }else {

                    activeChoice = self.getChoiceByValue(originalValue);
                }
                if(activeChoice == null) {
                    // If no predefined choice was found take the last activeChoice
                    activeChoice = self.getActiveChoice();
                    // if choice is blacklisted set activechoice of option to null
                    if(activeChoice && activeChoice.getIsBlacklisted() === true){
                        activeChoice = null;
                    }
                }
                self.setActiveChoice(activeChoice);
                self.setValue(originalValue);
            }
        }
};
Justselling_Configento_Option_Abstract.prototype.getIsBlacklisted = function() {
        return this.isBlacklisted;
    };
Justselling_Configento_Option_Abstract.prototype.setCollapse = function(collapse) {
        this.collapse = collapse;
    };
Justselling_Configento_Option_Abstract.prototype.getCollapse = function() {
        return this.collapse;
    };
Justselling_Configento_Option_Abstract.prototype.setSortOrderCombiImage = function(sort) {
    this.sortOrderCombiImage = sort;
};
Justselling_Configento_Option_Abstract.prototype.getSortOrderCombiImage = function() {
    return this.sortOrderCombiImage;
};
Justselling_Configento_Option_Abstract.prototype.setOverlay = function(overlay) {
        this.overlay = overlay;
    };
Justselling_Configento_Option_Abstract.prototype.getOverlay = function() {
        return this.overlay;
    };
Justselling_Configento_Option_Abstract.prototype.setVisibility = function(visibility) {
        this.visibility = visibility;
    };
Justselling_Configento_Option_Abstract.prototype.getVisibility = function() {
        return this.visibility;
    };
Justselling_Configento_Option_Abstract.prototype.setIsVisible = function(value) {
        var self = this;
        if (value != self.isVisible) {
            self.isVisible = value;
            if (self.getIsRendered()) {
                if (value) {
                    self.hideOptionInDom(false);
                } else {
                    self.hideOptionInDom(true);
                }
            }
        }
    };
    /*
     * true, if option is visible in configurator frontend
     */
Justselling_Configento_Option_Abstract.prototype.getIsVisible = function() {
        var self = this;
        return self.isVisible;
    };
Justselling_Configento_Option_Abstract.prototype.setCustomClass = function(customClass) {
        var self = this;
        self.customClass = customClass;
        if (!self.defaultClass) {
            var defaultClass = self.getAttributeFromDom(self, "class");
            if (defaultClass != undefined) {
                self.defaultClass = defaultClass;
            }
        }
        if (self.defaultClass) {
            customClass += " " + self.defaultClass;
        }
        self.updateAttributeInDom(self, "class", customClass);
    };
Justselling_Configento_Option_Abstract.prototype.getCustomClass = function() {
        var self = this;
        if (!self.customClass) {
            return "";
        }
        return self.customClass;
    };
Justselling_Configento_Option_Abstract.prototype.setChoice = function(choices) {
        var self = this;
        self.choices = choices;
        self.setValue(choices[0]['value']);
    };
Justselling_Configento_Option_Abstract.prototype.getChoices = function() {
        var self = this;
        return self.choices;
    };
    /*
     * Get all choices that are not blacklisted
     */
Justselling_Configento_Option_Abstract.prototype.getActiveChoices = function() {
        var renderBlacklisted = this.getConfigurator().getConfig('render_blacklisted_choices');
        var self = this;
        var choices = self.getChoices();
        var activeChoices = [];
        if (choices) {
            for (var i = 0; i < choices.length; i++) {
                var choice = choices[i];
                if (renderBlacklisted || !choice.getIsBlacklisted()) {
                    choice.isBlacklisted = choice.getIsBlacklisted();
                    activeChoices.push(choice);
                }
            }
        }
        return activeChoices;
    };
Justselling_Configento_Option_Abstract.prototype.getChoiceByValue = function(value) {
        var self = this;
        var choices = self.getChoices();
        if (_.isArray(choices) && choices.length >= 1) {
            return choices[self.choiceValueToIndex[value]];
        }
        return false;
    };
Justselling_Configento_Option_Abstract.prototype.getChoiceByInternalId = function(internalId) {
        var self = this;
        var choices = self.getChoices();
        if (_.isArray(choices) && choices.length >= 1) {
            return choices[self.choiceInternalIdToIndex[internalId]];
        }
        return false;
    };
Justselling_Configento_Option_Abstract.prototype.getChoiceById = function(id) {
    var self = this;
    var choices = self.getChoices();
    if (_.isArray(choices) && choices.length >= 1) {
        return choices[self.choiceIdToIndex[id]];
    }
    return false;
};
Justselling_Configento_Option_Abstract.prototype.setHasChoiceWithImage = function(bool) {
        var self = this;
        self.hasChoiceWithImage = bool;
    };
Justselling_Configento_Option_Abstract.prototype.getHasChoiceWithImage = function() {
        var self = this;
        return self.hasChoiceWithImage ;
    };

Justselling_Configento_Option_Abstract.prototype.setDomElement = function($element) {
        var self = this;
        if ($element && $element.length == 1) {
            self.$domElement = $element;
        }
    };
Justselling_Configento_Option_Abstract.prototype.getDomElement = function() {
        var self = this;
        if (!self.$domElement || self.$domElement.length != 1) {
            var tagId = self.getId();
            var $element = jQuery("#"+tagId);
            if ($element && $element.length == 1) {
                self.setDomElement($element);
            }
        }
        return self.$domElement;
    };
Justselling_Configento_Option_Abstract.prototype.setDomParentElement = function($element) {
        var self = this;
        if ($element && $element.length == 1) {
            self.$domParentElement = $element;
        }
    };
Justselling_Configento_Option_Abstract.prototype.getDomParentElement = function() {
        var self = this;
        if (!self.$domParentElement) {
            var $element = self.getDomElement();
            if ($element && $element.length == 1) {
                var $parent = $element.parents(".configento.option").first();
                self.setDomParentElement($parent);
            }
        }
        return self.$domParentElement;
    };
Justselling_Configento_Option_Abstract.prototype.setTemplate = function(template) {
        this.template = template;
    };
Justselling_Configento_Option_Abstract.prototype.getTemplate = function() {
        return this.template;
    };
Justselling_Configento_Option_Abstract.prototype.setOriginalValue = function(value) {
        this.originalValue = value;
    };
Justselling_Configento_Option_Abstract.prototype.getOriginalValue = function() {
        return this.originalValue;
    };
Justselling_Configento_Option_Abstract.prototype.getHasChanged = function() {
        return this.hasChanged;
    };
Justselling_Configento_Option_Abstract.prototype.setHasChanged = function(value) {
        return this.hasChanged = value;
    };
Justselling_Configento_Option_Abstract.prototype.getChildren = function() {
        return this.children;
    };
Justselling_Configento_Option_Abstract.prototype.setActiveChoice = function(choice, force) {
        var self = this;
        if (!choice) {
            this.activeChoice = null;
            this.setValue(null);
        }

        if (force) {
            this.activeChoice = null;
        }

        switch (this.getType()) {
            case 'radiobutton':
            case 'select':
            case 'thumb':
            case 'selectcombi':
                this.activeChoice = null;
                break;
        }
        if (_.isArray(choice)) {
            _.each(choice, function (choice) {
                self.addActiveChoice(choice);
            });
        } else {
            this.addActiveChoice(choice);
        }

        return this.activeChoice;
    };
Justselling_Configento_Option_Abstract.prototype.getActiveChoice = function() {
        return this.activeChoice;
    };
Justselling_Configento_Option_Abstract.prototype.addActiveChoice = function(choice) {
    if (!choice) return this.activeChoice;
    if (!this.isActiveChoice(choice)) {
        if (!Array.isArray(this.activeChoice)) {
            if (!this.activeChoice) {
                this.activeChoice = choice;
            } else {
                var currentChoice = this.activeChoice;
                this.activeChoice = [currentChoice, choice];
            }
        } else {
            this.activeChoice.push(choice);
        }
    }

    this.setValueByActiveChoice();
    return this.activeChoice;
};
Justselling_Configento_Option_Abstract.prototype.removeActiveChoice = function(choice) {
    var self = this;
    if (!this.activeChoice) return null;
    if (!_.isArray(this.activeChoice)) {
        if (this.activeChoice.internalId == choice.internalId) this.activeChoice = null;
    } else {
        _.each(this.activeChoice, function (activeChoice, index, choices) {
            if (activeChoice && activeChoice.internalId == choice.internalId) {
                choices.splice(index, 1)
            }
        });
        if (self.activeChoice.length == 1) self.activeChoice = self.activeChoice[0];
        if (self.activeChoice.length == 0) self.activeChoice = null;
    }

    this.setValueByActiveChoice();
    return this.activeChoice;
};
Justselling_Configento_Option_Abstract.prototype.setValueByActiveChoice = function() {
    if (!this.activeChoice) {
        this.setValue(null, true);
        return true;
    }
    if (_.isArray(this.activeChoice)) {
        var values =  _.map(this.activeChoice, function (choice) {
            if(choice.getValue()) {
                return choice.getValue();
            }
        });
        this.setValue(values);
    } else  {
        this.setValue(this.activeChoice.getValue());
    }
    return true;
};
Justselling_Configento_Option_Abstract.prototype.isActiveChoice = function(choice) {
    if (!choice || !this.activeChoice) return false;
    if (this.activeChoice.internalId == choice.internalId) return true;
    var result = false;
    if (Array.isArray(this.activeChoice)) {
        _.each(this.activeChoice, function (activeChoice) {
            if (activeChoice.internalId == choice.internalId) result = true;
        });
    }
    return result;
}
Justselling_Configento_Option_Abstract.prototype.setOperatorValuePrice = function(value) {
        return this.operatorValuePrice = value;
    };
Justselling_Configento_Option_Abstract.prototype.getOperatorValuePrice = function() {
        return this.operatorValuePrice;
    };
Justselling_Configento_Option_Abstract.prototype.setShowPackageOptions = function(value) {
        return this.showPackageOptions = value;
    };
Justselling_Configento_Option_Abstract.prototype.getShowPackageOptions = function() {
        return this.showPackageOptions;
    };
Justselling_Configento_Option_Abstract.prototype.setQtyType = function(qtyType) {
        if(qtyType != 0) {
            this.qtyType = qtyType;
        }
    };
Justselling_Configento_Option_Abstract.prototype.getQtyType = function() {
        return this.qtyType;
    };
Justselling_Configento_Option_Abstract.prototype.setMinQty = function(val) {
        this.minQty = parseInt(val);
    };
Justselling_Configento_Option_Abstract.prototype.getMinQty = function() {
        return this.minQty;
    };
Justselling_Configento_Option_Abstract.prototype.setMaxQty = function(val) {
        this.maxQty = parseInt(val);
    };
Justselling_Configento_Option_Abstract.prototype.getMaxQty = function() {
        return this.maxQty;
    };
Justselling_Configento_Option_Abstract.prototype.setDefaultMinQty = function(val) {
    this.defaultMinQty = parseInt(val);
};
Justselling_Configento_Option_Abstract.prototype.getDefaultMinQty = function() {
    return this.defaultMinQty;
};
Justselling_Configento_Option_Abstract.prototype.setDefaultMaxQty = function(val) {
    this.defaultMaxQty = parseInt(val);
};
Justselling_Configento_Option_Abstract.prototype.getDefaultMaxQty = function() {
    return this.defaultMaxQty;
};

Justselling_Configento_Option_Abstract.prototype.setPackagePrice = function(price) {
    this.packagePrice = price;
};
Justselling_Configento_Option_Abstract.prototype.getPackagePrice = function() {
    return this.packagePrice;
};

Justselling_Configento_Option_Abstract.prototype.setWholeQty = function(qty){
        this.wholeQty = parseInt(qty);
    };
Justselling_Configento_Option_Abstract.prototype.getWholeQty = function() {
        return this.wholeQty;
    };
Justselling_Configento_Option_Abstract.prototype.setQtyChanged = function(bool) {
    this.qtyChanged = bool;
};
Justselling_Configento_Option_Abstract.prototype.getQtyChanged = function() {
    return this.qtyChanged;
};
Justselling_Configento_Option_Abstract.prototype.setIsMultiple = function(val) {
    this.is_multiple = val;
};
Justselling_Configento_Option_Abstract.prototype.getIsMultiple = function() {
    return this.is_multiple;
};
Justselling_Configento_Option_Abstract.prototype.setSku = function(val) {
        this.sku = val;
    };
Justselling_Configento_Option_Abstract.prototype.getSku = function() {
        return this.sku;
    };

Justselling_Configento_Option_Abstract.prototype.getValue = function() {
        var self = this;
        var value = self.value;
        if (_.isArray(value) && value.length === 1) {
            if (value instanceof Justselling_Configento_Option_Abstract) {
                value = value.getValue();
            }
            else {
                value = value[0];
            }
        }
        else if (self.getIsCombi()) {
            var activeChoice = self.getActiveChoice();
            if (activeChoice instanceof Justselling_Configento_Option_Choice) {
                value = activeChoice.getOriginalValue();
            }
            else if (_.isArray(activeChoice)) {
                value = _.map(activeChoice, function (choice) {
                    return choice.getOriginalValue();
                });
            }
        }
        return value;
    };


Justselling_Configento_Option_Abstract.prototype.setValue = function(value, force) {
        var self = this;

        /* TODO
            Currentl this is de-actvated: we the problem, that when a choice was already activated and
            it's activated by a package, the value is this the same, but the price is changed, and
            we need a re-caluclation of it.
         */
        if (/*false &&*/ _.isEqual(self.value, value) && force == null) {
            return false;
        }

        var start2 = new Date().getTime();
        self.value = value;
        self.hasChanged = true;
        self.setPrice(self.calculatePrice());
        self.triggerChildren();
        var end1 = new Date().getTime();
        var time1 = end1 - start2;
        Justselling_Configento_App_Profiler.addMeasuring("SET Value Abstract" , time1);
        return true;
    };


Justselling_Configento_Option_Abstract.prototype.setTierPrice = function(tierprice) {
        var self = this;
        if (tierprice > 0) {
            Justselling_Configento_App_Debug.addDebug("setTierPrice " + self.getTitle() + "=" + tierprice);
        }
        self.tierprice = tierprice;
        self.price = self.calculatePrice();
    };
Justselling_Configento_Option_Abstract.prototype.getTierPrice = function() {
        var self = this;
        return self.tierprice;
    };
Justselling_Configento_Option_Abstract.prototype.setPrice = function(price) {
        var self = this;
        /* if (price > 0) {
            Justselling_Configento_App_Debug.addDebug("setPrice " + self.getTitle() + "=" + price);
        }*/
        if (!self.tierprice) {
            self.tierprice = [["0", price]];
        }
        self.price = price;
    };
Justselling_Configento_Option_Abstract.prototype.getPrice = function() {
        var self = this;
        if (self.price == undefined) {
            return 0;
        }
        return self.price;
    };
Justselling_Configento_Option_Abstract.prototype.calculatePrice = function() {
        var self = this;
        if (self.getIsBlacklisted()) {
            return 0;
        }

        var price = 0;
        var value = self.getValue();
        var activeChoice = self.getActiveChoice();
        if (activeChoice instanceof Justselling_Configento_Option_Choice) {
            price = activeChoice.getPrice();
        }
        else if (_.isArray(activeChoice)) {
            price = _.reduce(activeChoice, function (total, choice) {
                return total + (choice.getPrice() ) ;
            }, 0);
            value = null;
        }
        else if (_.isArray(self.tierprice)) {
            for (var i=self.tierprice.length-1; i>=0; i--) {
                if (value === "" || value == null) {
                    value = 0;
                }
                if (parseFloat(self.tierprice[i][0]) <= parseFloat(value)) {
                    price = self.tierprice[i][1];
                }
            }
            if(price === 0) {
                price = self.tierprice[self.tierprice.length - 1][1];
            }
        }

        value = parseFloat(value);
        if (self.getOperatorValuePrice() === '*') {
            if (jQuery.isNumeric(value)) {
                price = price * value;
            } else if (value === null) {
                price = 0;
            }
        }

        /* if we have not selected a value, reset price */
        if (self.getValue() === '') {
            price = 0;
        }
        Justselling_Configento_App_Debug.addDebug("calculate price="+price+" value="+value);
        return price;
    };

Justselling_Configento_Option_Abstract.prototype.getDefaultValue = function() {
        var self = this;
        /* check if we have a predefined value, to replace default value? */
        var predefinedValue = self.getPredefinedObject();
        if (predefinedValue) {
            if (predefinedValue['valueId']) {
                if(_.isArray(predefinedValue['valueId'])) {
                    var predefinedValueTMP = [];
                    _.each(predefinedValue['valueId'], function (valueId) {
                        var choice = this.getChoiceByInternalId(valueId);
                        if (choice && choice instanceof Justselling_Configento_Option_Choice) {
                            predefinedValueTMP.push(choice.getOriginalValue());
                        }
                    }, self);
                    predefinedValue = predefinedValueTMP;
                }
                else {
                    var choice = self.getChoiceByInternalId(predefinedValue['valueId']);
                    if (choice && choice instanceof Justselling_Configento_Option_Choice) {
                        predefinedValue = choice.getOriginalValue();
                    }
                }
            } else {
                predefinedValue = predefinedValue['value'];
            }
            if (predefinedValue !== null) {
                return predefinedValue;
            }
        }

        return self.defaultValue;
    };
Justselling_Configento_Option_Abstract.prototype.setDefaultValue = function(value, force) {
        var self = this;
        if (value == self.defaultValue && value == null) {
            return false;
        }
        if (value === null) return false;

        var start1 = new Date().getTime();
        // means that we are in edit mode, and we still need default value if user change something
        var predefinedValue = self.getPredefinedObject();
        if (self.getIsPredefined() && !force) {
            if (!predefinedValue) {
                return false;
            }
        }

        self.defaultValue = value;
        if (_.isArray(value) && value.length === 1) {
            value = value[0];
        }
        if (value && value instanceof Justselling_Configento_Option_Choice) {
            self.setActiveChoice(value);
            self.setValue(value.getValue());
        }
        else if (_.isArray(value)) {
            var values =  _.map(value, function (choice) {
                if (choice instanceof Justselling_Configento_Option_Choice) {
                    return choice.getValue();
                }
            });
            self.setActiveChoice(value);
            self.setValue(values);
        }
        else {
            // in case the value param is not an choice object, but the options has choices
            // we need to look for choice with that value and set it as active choice
            var newActiceChoice = self.getChoiceByValue(value);
            if(newActiceChoice) {
                self.setActiveChoice(newActiceChoice);
                if(self.getQtyType() && newActiceChoice.getQty() == 0) {
                    newActiceChoice.setQty(1);
                    if(self.hasWholeQty === true) {
                        self.setWholeQty(1);
                    }
                }
            } else {
                self.setValue(value);
            }
        }

        if (self.getIsRendered()) {
            self.updateValueInDom();
        }

        var end1 = new Date().getTime();
        var time1 = end1 - start1;
        Justselling_Configento_App_Profiler.addMeasuring("abstract::setDefaultValue", time1);
        return true;
    };

Justselling_Configento_Option_Abstract.prototype.renderValidator = function($element) {
        var self = this;
        if ($element && $element.length == 1) {
           /* var validator = Justselling_Configento_App_Helper.getFormValidator();

            var fieldElement = null;
            if (validator) {
                fieldElement = validator.getOptions($element);
            }
            if (validator && fieldElement) {
                try {
                    validator.enableFieldValidators($element, false);
                    validator.removeField($element);
                } catch (err) {
                    Justselling_Configento_App_Debug.addDebug(err);
                }
            } else {
                self.renderValidatorAfter($element);
            }*/
            self.renderValidatorAfter($element);

        }
    };

    /*
     * Here we have methods to render additional information into the DOM element of the option
     */
Justselling_Configento_Option_Abstract.prototype.renderValidatorAfter = function($element) {
        var self = this;
        var validation = false;
        var $allElements;
        var validator = Justselling_Configento_App_Helper.getFormValidator();

        // If we got a radio button, we need to select one input (formvalidation finds all other radiobuttons with teh same name)
        if(self.getType() == 'radiobutton' || self.getType() == 'checkbox' || self.getType() == 'package'){
            $allElements = $element.find('input');
            $element = $allElements.first();
            $allElements = $allElements.slice(1);
        }
        if ($element && $element.length == 1) {
            /* Required */
            $element.removeAttr("data-fv-notempty");
            $element.removeAttr("data-fv-excluded");
            $element.removeAttr("data-fv-notempty-message");
            if (self.getIsRequired()) {
                $element.attr("data-fv-notempty", "true");
                if(self.getType() == 'thumb'){
                    // Validate the hidden select inputs of the imagepicker only in their active tab
                    if(self.getIsBlacklisted() != true && self.getConfigurator().getActiveGroup() == self.getGroup() && $element.closest('.option').is(':visible') ){
                        $element.attr("data-fv-excluded", "false");
                    }
                    $element.attr("data-fv-notempty-message", Justselling_Configento_App_Translate.translate('Please make a selection'))
                }
                if(self.getType() == 'radiobutton' || self.getType() == 'checkbox' || self.getType() == 'package') {
                    $allElements.off('change');
                    $allElements.on('change', function () {
                        $element.trigger('change');
                    });
                    $element.removeAttr("data-fv-notempty");
                    $element.attr("data-fv-requiredradiocheck", "true");
                    $element.attr("data-fv-requiredradiocheck-message", Justselling_Configento_App_Translate.translate('Please make a selection'))
                    $element.attr("data-fv-icon", "false");
                }
                validation = true;
            }
            if(self.getType() === 'fileupload') {
                $element.removeAttr('data-fv-notempty');
                $element.attr('data-fv-minfileupload', "true");
                if (!self.getIsRequired()) {
                    setTimeout(function () { // just wait a bit for DOOM if option is on first place.
                        jQuery("small[data-fv-for='" + $element.attr('name') + "']").remove();
                    }, 250);
                }
            }
            else if(self.getType() === 'multiquantity') {
                $element.removeAttr('data-fv-notempty');
                $element.attr('data-fv-minmultiqty', "true");
            }

            /* min, max and between */
            $element.removeAttr("data-fv-greaterthan-value");
            $element.removeAttr("data-fv-lessthan-value");
            $element.removeAttr("data-fv-between-min");
            $element.removeAttr("data-fv-between-max");
            $element.removeAttr("data-fv-greaterthan");
            $element.removeAttr("data-fv-lessthan");
            $element.removeAttr("data-fv-between");

            if(typeof self.getTextValidate == 'function' && self.getTextValidate()){
                var localeCountry = Justselling_Configento_App_Locale.getCountry();
                var validateNumberRange = false;
                var validateStringRange = false;
                var validateDecimalseperator = function () {
                    if(localeCountry == 'DE' || localeCountry == 'FR' || localeCountry == 'IT') {
                        $element.attr('data-fv-numeric-decimalseparator', ',');
                    }
                };
                $element.attr("data-fv-trigger","change keyup blur");

                switch (self.getTextValidate()) {
                    case 'validate-number':
                        $element.attr('data-fv-numeric', 'true');

                        /* on mobile open num keyboard  */
                        $element.attr('pattern', '[0-9]*');
                        $element.attr('inputmode', 'numeric');
                        $element.attr('type', 'number');

                        validateDecimalseperator();
                        validateNumberRange = true;
                        /*
                        var thousandsseparator = '';

                        if(localeCountry == 'DE' || localeCountry == 'IT') {
                            thousandsseparator =  '.';
                        }
                        else if( localeCountry == 'FR') {
                            thousandsseparator =  ' ';
                        }
                        else if(localeCountry == 'US') {
                            thousandsseparator = ',';
                        }
                        $element.attr('data-fv-numeric-thousandsseparator', thousandsseparator);
                        */
                        break;
                    case 'validate-digits':
                        $element.attr('data-fv-digits', 'true');
                        validateNumberRange = true;
                        break;
                    case 'validate-greater-than-zero':
                        // Positive Zahl
                        $element.attr('data-fv-numeric', 'true');
                        validateDecimalseperator();
                        $element.attr("data-fv-greaterthan", "true");
                        $element.attr("data-fv-greaterthan-inclusive", "false");
                        $element.attr("data-fv-greaterthan-value", 0);
                        validateNumberRange = true;
                        break;
                    case 'validate-zero-or-greater':
                        // Positive Zahl oder Null
                        $element.attr('data-fv-numeric', 'true');
                        validateDecimalseperator();
                        $element.attr("data-fv-greaterthan", "true");
                        $element.attr("data-fv-greaterthan-inclusive", "true");
                        $element.attr("data-fv-greaterthan-value", 0);
                        validateNumberRange = true;
                        break;
                    case 'validate-alpha':
                        $element.attr('data-fv-regexp', 'true');
                        $element.attr('data-fv-regexp-regexp', '^[a-zA-ZäÄöÖüÜß]+$');
                        validateStringRange = true;
                        break;
                    case 'validate-code':
                        $element.attr('data-fv-regexp', 'true');
                        $element.attr('data-fv-regexp-regexp', '^[a-z0-9_äöü]+$');
                        validateStringRange = true;
                        break;
                    case 'validate-lowercase':
                        $element.attr('data-fv-stringcase', 'true');
                        $element.attr('data-fv-stringcase-case', 'lower');
                        $element.attr('data-fv-regexp', 'true');
                        $element.attr('data-fv-regexp-regexp', '^[a-z0-9_äöü]+$');
                        validateStringRange = true;
                        break;
                    case 'validate-uppercase':
                        $element.attr('data-fv-stringcase', 'true');
                        $element.attr('data-fv-stringcase-case', 'upper');
                        $element.attr('data-fv-regexp', 'true');
                        $element.attr('data-fv-regexp-regexp', '^[A-Z0-9_ÄÖÜ]+$');
                        validateStringRange = true;
                        break;
                    case 'validate-alphanum':
                        $element.attr('data-fv-regexp', 'true');
                        $element.attr('data-fv-regexp-regexp', '^[a-zA-Z0-9äÄöÖüÜß]+$');
                        validateStringRange = true;
                        break;
                    case 'validate-data':
                        //Buchstaben, Ziffern, Unterstrich
                        $element.attr('data-fv-regexp', 'true');
                        $element.attr('data-fv-regexp-regexp', '^[a-zA-Z0-9_äÄöÖüÜß]+$');
                        validateStringRange = true;
                        break;
                    case 'validate-zip':
                        $element.attr('data-fv-zipcode', 'true');
                        $element.attr('data-fv-zipcode-country', localeCountry);
                        break;
                    case 'validate-phoneLax':
                        // Telefonnummer
                        $element.attr('data-fv-phone', 'true');
                        $element.attr('data-fv-phone-country', localeCountry);
                        break;
                    case 'validate-email':
                        // More options: Multiple email adresses
                        $element.attr('data-fv-emailaddress', 'true');
                        break;
                    case 'validate-vat':
                        // Telefonnummer
                        $element.attr('data-fv-vat', 'true');
                        $element.attr('data-fv-vat-country', localeCountry);
                        $element.attr("data-fv-vat-message", Justselling_Configento_App_Translate.translate("provide valid vat") );
                        break;
                    case 'validate-iban':
                        $element.attr('data-fv-iban', 'true');
                        break;
                    case 'validate-bic':
                        $element.attr('data-fv-bic', 'true');
                        break;
                    case 'validate-uri':
                        // Has some more options: Set allowed protocols, allow empty protocol, allow local ip address
                        $element.attr('data-fv-uri', 'true');
                        break;
                    default:
                        Justselling_Configento_App_Debug.addDebug('trying to validate non existing type: '+ self.getTextValidate());
                        break;
                }
                // validate Number fields
                if(validateNumberRange) {
                    if (self.getMaxValue() && self.getMinValue()) {
                        $element.attr("data-fv-between", "true");
                        $element.attr("data-fv-between-min", self.getMinValue());
                        $element.attr("data-fv-between-max", self.getMaxValue());
                        validation = true;
                    }
                    else if (self.getMaxValue() && !self.getMinValue()) {
                        $element.attr("data-fv-lessthan", "true");
                        $element.attr("data-fv-lessthan-value", self.getMaxValue());
                       // validation = true;
                    }
                    else if (!self.getMaxValue() && self.getMinValue()) {
                        $element.attr("data-fv-greaterthan", "true");
                        $element.attr("data-fv-greaterthan-value", self.getMinValue());
                       // validation = true;
                    }
                }
                // Do not show the Min Max Pattern
                else {
                    self.setMaxValue('');
                    self.setMinValue('');
                }
                // validate String fields only if it´s text field (specific text methods)
                if(self.getType() == 'text' && validateStringRange || self.getType() == 'area') {
                    // Do not show the Min Max PAttern
                    self.setMaxValue('');
                    self.setMinValue('');

                    if (self.getMaxStringLength() && self.getMinStringLength()) {
                        $element.attr("data-fv-stringlength", "true");
                        $element.attr("data-fv-stringlength-min", self.getMinStringLength());
                        $element.attr("data-fv-stringlength-max", self.getMaxStringLength());
                        var stringErrorMessage = Justselling_Configento_App_Translate.translate("string range error message");
                        stringErrorMessage = stringErrorMessage.replace(/%smin/g, self.getMinStringLength()).replace(/%smax/g, self.getMaxStringLength());
                        $element.attr("data-fv-stringlength-message", stringErrorMessage );
                    }
                    else if (self.getMaxStringLength() && !self.getMinStringLength()) {
                        $element.attr("data-fv-stringlength", "true");
                        $element.attr("data-fv-stringlength-max", self.getMaxStringLength());
                    }
                    else if (!self.getMaxStringLength() && self.getMinStringLength()) {
                        $element.attr("data-fv-stringlength", "true");
                        $element.attr("data-fv-stringlength-min", self.getMinStringLength());
                    }
                }
            }
            var configurator = self.getConfigurator();
            if (validation && configurator) {
                $element.attr("data-fv-trigger","change");

                if (validator) {
                    if(validator._cacheFields[self.getName()] != null) {
                        try {
                            delete validator.options.fields[self.getName()];
                            validator.removeField($element);

                        } catch (e) { }
                            delete validator._cacheFields[self.getName()];
                        }
                    else if ($element.attr('data-fv-trigger') && $element.attr('data-fv-trigger') != ''
                        && $element.attr('data-fv-excluded') == 'false') {
                        try {
                            validator.removeField($element);
                        } catch (e) {}
                    }

                    try {
                        if(typeof validator._cacheFields[self.getName()] === 'undefined') {
                            /*
                            * for this options when we have predefined value and required than system d
                            * looks on that like logic error, because condition is already true
                            * */
                            if ((self.getType() == 'select') || (self.getType() == 'radiobutton')) {
                                if (typeof $element[0] !== 'undefined') {
                                    if ($element[0].value == '') {
                                        validator.addField($element);
                                    }
                                    if (self.getType() == 'radiobutton') { // radio button can have any of value. but still be not selected
                                        validator.addField($element);
                                    }
                                } else{
                                    validator.addField($element);
                                }
                            } else {
                                validator.addField($element);
                            }
                        } else {
                            validator.updateStatus($element, 'NOT_VALIDATED');
                        }
                        validator.validateField($element);
                    } catch (err) {
                        console.log(err);
                    }

                   /* validator.removeField(self.getName());
                    validator
                        .addField($element)
                        .updateStatus($element, 'NOT_VALIDATED')
                        .validateField($element);
                        //.enableFieldValidators($element, true);
*/
                    if($element.attr('data-fv-excluded') == 'false' && ($element.val() == null || $element.val() == '')) {
                        validator.resetField($element, true);
                    }
                }
            }
        }
    };

    /*
     * InfoText will be shown below option label
     */
Justselling_Configento_Option_Abstract.prototype.renderInfoText = function() {
        var self = this;
        if (self.getIsRendered()) {
            var s2 = new Date().getTime();

            var $parent = self.getDomParentElement();
            $parent.find(".optionheader .infotext").html(self.getInfoText());

            var e2 = new Date().getTime();
            var t2 = e2 - s2;
            Justselling_Configento_App_Profiler.addMeasuring("abstract:renderInfoText", t2);
        }
    };

    /*
     * InfoText2 will be shown as "I"-Icon and has a tooltip effect in place
     */
Justselling_Configento_Option_Abstract.prototype.renderInfoText2 = function(isGroup) {
        var self = this;
        var $parent = self.getDomParentElement();
        if (self.getIsRendered() && (typeof $parent !== 'undefined')) {

            var source = Justselling_Configento_App_Helper.$template.find("#infotext2-template").html();
            if (source) {
                template = Handlebars.compile(source);
            }
            var html = "";
            if (template) {
                var context = {
                    infoicon: Justselling_Configento_App_Helper.getAssetBasePath() + "default/info.png"
                };
                var s2 = new Date().getTime();


                html = template(context);
                if (isGroup) {
                    var $container = $parent.find(".c-__option-choices-group .info-text");
                } else {
                    var $container = $parent.find(".optionheader .infotext2");
                }

                var infoText = self.getInfoText2();
               /* if you don't have tooltip, than don't show the icon! */
                if (typeof infoText === 'undefined') {
                    return false;
                }

                $container.html(html);

                var $element = jQuery("");

                var e2 = new Date().getTime();
                var t2 = e2 - s2;
                Justselling_Configento_App_Profiler.addMeasuring("abstract:renderInfoText2", t2);

                try {
                    $element = jQuery(infoText);
                } catch (err) {
                    Justselling_Configento_App_Debug.addDebug("PROBLEM when trying to set tooltip text");
                    Justselling_Configento_App_Debug.addDebug(err);
                }
                if (Justselling_Configento_App_Helper.getCustomTooltip()) {
                    var _this = $element;
                    var id_option = _this.parent().find('input').val();
                    var parent  = _this.parent();

                    if ($container.hasClass("tooltipstered")) $container.tooltipster('destroy');
                    $container.tooltipster({
                        content: $element,
                        theme: 'tooltipster-light',
                        contentAsHTML: true,
                        maxWidth: 800,
                        interactive: true,
                        trigger: 'click'
                    }).on("click", function() {
                        /* here we must lite wait until tooltip si shown */
                        setTimeout(function () {
                            jQuery('.type-package .selected label').each(function () {
                                if (jQuery(this).text().trim() == 'Innovationspaket') {
                                    setTimeout(function () {
                                        jQuery('.led-lights .selected-package-innovation').show();
                                        jQuery('.led-lights .unselected-package-innovation').hide();
                                    }, 10);
                                } else {
                                    jQuery('.led-lights .selected-package-innovation').hide();
                                    jQuery('.led-lights .unselected-package-innovation').show();
                                }

                                if (jQuery(this).text().trim() == 'Komfortpaket') {
                                    setTimeout(function () {
                                        jQuery('.led-lights .selected-package-komfort').show();
                                        jQuery('.led-lights .unselected-package-komfort').hide();
                                    }, 10);
                                } else {
                                    jQuery('.led-lights .selected-package-komfort').hide();
                                    jQuery('.led-lights .unselected-package-komfort').show();
                                }
                            });
                            Justselling_Egomobile_Helper.tooltipPackages();
                            jQuery('.led-lights .unselected-package').attr('id_option', id_option);
                        }, 200);
                    });
                } else if (Justselling_Configento_App_Helper.getShowTooltipInOverlay()) {

                }
                else {
                    if ($container.hasClass("tooltipstered")) $container.tooltipster('destroy');
                    $container.tooltipster({
                        content: $element,
                        theme: 'tooltipster-light',
                        contentAsHTML: true,
                        /*maxWidth: 300,*/
                        interactive: true
                    });
                }
            }
        }
    };

Justselling_Configento_Option_Abstract.prototype.isHTML = function(str) {
    if (!str) return false;
    try {
        var domObjects = jQuery.parseHTML(str);
    } catch(err) {
        return false;
    }
    if (!domObjects || !domObjects.length) return false;
    return true;
};

Justselling_Configento_Option_Abstract.prototype.renderChoiceTooltip = function() {
    var self = this;
    if (self.getIsRendered()) {
        var html = "";
        var source = Justselling_Configento_App_Helper.$template.find("#infotext2-template").html();
        if (source) {
            var template = Handlebars.compile(source);

            var context = {
                infoicon: Justselling_Configento_App_Helper.getAssetBasePath() + "default/info.png"
            };
            html = template(context);
            var $el = self.getDomElement();
            if (!$el) return;
            var $choiceTooltipContainer = $el.find(".c-__checkbox .info-text, > .radiobutton .info-text");
            $choiceTooltipContainer.each(function () {
                var $this = jQuery(this);
                var infoText = $this.html();

                $this.html(html);

                var $element = jQuery("");
                try {
                    $element = jQuery(infoText);
                } catch (err) {
                    Justselling_Configento_App_Debug.addDebug("PROBLEM when trying to set tooltip text of CHOICE");
                    Justselling_Configento_App_Debug.addDebug(err);
                }
                if (Justselling_Configento_App_Helper.getCustomTooltip() && $element && $element[0] && self.isHTML($element[0].innerHTML)) {
                    var _this = jQuery('<div>'+$element[0].innerHTML+'</div>');
                    var id_option = _this.parent().find('input').val();

                    /* ins some cases we don't have html present, so fill it */
                    $this.html($element);
                    if ($this.hasClass("tooltipstered")) $this.tooltipster('destroy');
                    $this.tooltipster({
                        content: $element,
                        theme: 'tooltipster-light',
                        contentAsHTML: true,
                        maxWidth: 800,
                        interactive: true,
                        trigger: 'click'
                    }).on("click", function() {
                        /* here we must lite wait until tooltip si shown */
                        setTimeout(function () {
                            jQuery('.type-package .selected label').each(function () {
                                if (jQuery(thisHTis).text().trim() == 'Innovationspaket') {
                                    setTimeout(function () {
                                        jQuery('.led-lights .selected-package-innovation').show();
                                        jQuery('.led-lights .unselected-package-innovation').hide();
                                    }, 10);
                                } else {
                                    jQuery('.led-lights .selected-package-innovation').hide();
                                    jQuery('.led-lights .unselected-package-innovation').show();
                                }

                                if (jQuery(this).text().trim() == 'Komfortpaket') {
                                    setTimeout(function () {
                                        jQuery('.led-lights .selected-package-komfort').show();
                                        jQuery('.led-lights .unselected-package-komfort').hide();
                                    }, 10);
                                } else {
                                    jQuery('.led-lights .selected-package-komfort').hide();
                                    jQuery('.led-lights .unselected-package-komfort').show();
                                }
                            });
                            Justselling_Egomobile_Helper.tooltipPackages();
                            jQuery('.led-lights .unselected-package').attr('id_option', id_option);
                        }, 200);
                    });

                } else if (Justselling_Configento_App_Helper.getShowTooltipInOverlay()) {

                }
                else {
                    if ($this.hasClass("tooltipstered")) $this.tooltipster('destroy');
                    $this.tooltipster({
                        content: $element,
                        theme: 'tooltipster-light',
                        contentAsHTML: true,
                        /*maxWidth: 300,*/
                        interactive: true
                    });
                }
            });

        }
    }
};

Justselling_Configento_Option_Abstract.prototype.renderMinMaxPattern = function() {
        var self = this;
        if (self.getConfigurator().getConfig("showMinMax") && self.getMinValue() && self.getMaxValue()) {
            var minValue = self.getMinValue();
            var maxValue = self.getMaxValue();
            var pattern = self.getConfigurator().getConfig("minMaxPattern");
            if(self.getMinMaxPattern() ) {
                pattern = self.getMinMaxPattern();
            }
            if ((minValue || maxValue) && pattern) {
                var $parent = self.getDomParentElement();
                if ($parent && $parent.length == 1) {
                    var html = pattern;
                    if (minValue) {
                        html = html.replace('$min', minValue);
                    }
                    if (maxValue) {
                        html = html.replace('$max', maxValue);
                    }
                    var s2 = new Date().getTime();

                    $parent.find(".optionheader .optionlabel .minmax").html(html);

                    var e2 = new Date().getTime();
                    var t2 = e2 - s2;
                    Justselling_Configento_App_Profiler.addMeasuring("abstract:renderMinMaxPettern", t2);
                }
            }
        }
    };

    /*
     * Update the value in DOM by setting the internal value to DOM.
     */
Justselling_Configento_Option_Abstract.prototype.hideOptionInDom = function(value) {
        var self = this;
        var $parent = self.getDomParentElement();
        var configurator = self.getConfigurator();
        if ($parent && $parent.length == 1) {
            if (value) {
                if(configurator.hideElements == false) {
                    configurator.hideElements = $parent;
                }
                else {
                    configurator.hideElements = jQuery(configurator.hideElements).add($parent);
                    configurator.showElements = jQuery(configurator.showElements).not($parent);
                }
              //  $parent.hide(0);
            } else {
                if(configurator.showElements == false) {
                    configurator.showElements = $parent;
                }
                else {
                    configurator.showElements = jQuery(configurator.showElements).add($parent);
                    configurator.hideElements = jQuery(configurator.hideElements).not($parent);
                }
              //  $parent.show(0);
            }
        }
    };
Justselling_Configento_Option_Abstract.prototype.hasChoicesChangeBlackListStatus = function(choices) {
        if (_.isArray(choices)) {
            for (var i = 0; i < choices.length; i++) {
                if (choices[i].getBlacklistStatusHasChanged()) {
                    /* we did change status, mark it on false, until other logic turn it on. (avoid unneed rendering in DOOM) */
                    choices[i].setBlacklistStatusHasChanged(false);
                    return true;
                }
            }
        }
        return false;
    };
Justselling_Configento_Option_Abstract.prototype.hideBlacklistedChoicesInDom = function(option) {
    var self = this;
    var start = new Date().getTime();


    if (self.getIsRendered()) {
        var choices = self.getChoices();
        if (choices && choices.length >= 1 && self.hasChoicesChangeBlackListStatus(choices)) {
            var $parent = option.getDomElement().parent();
            var $optionElement = option.getDomElement().detach();

            var $fullHtml = jQuery(self.getHtml());
            var $partHtml = $fullHtml.find(".optionmain .element");
            $optionElement.html($partHtml.html());

            if ($parent && $parent.length == 1) {
                $parent.prepend($optionElement);
            }

            if (typeof self.renderAfter == 'function') {
                self.renderAfter();
            }

            this.renderGroupsAndInfo();
        }
    }
    var end = new Date().getTime();
    var time = end - start;
    Justselling_Configento_App_Profiler.addMeasuring("abstract::hideBlacklistedChoicesInDom", time);
};
Justselling_Configento_Option_Abstract.prototype.updateValueFromActiveChoice = function() {
    var self = this;
    var activeChoice = self.getActiveChoice();
    if (activeChoice instanceof Justselling_Configento_Option_Choice) {
        self.setValue(activeChoice.getValue());
    }
    else if(_.isArray(activeChoice)) {
        var values =  _.map(activeChoice, function (choice) {
            return choice.getValue();
        });
        self.setValue(values);
    }
};

Justselling_Configento_Option_Abstract.prototype.updateValueInDom = function(preventRender) {
        var self = this;
        var $element;
        if (self.getIsVisible() && self.getHasChanged()) {
            // Justselling_Configento_App_Debug.addDebug("updateValueInDom "+self.getTitle());
            if(preventRender == null) {
                self.setHasChanged(false);
                if (!self.getIsRendered()) {
                    self.render();
                }
            }
            if (($element = self.getDomElement()) && $element.length == 1) {
                var hide = false;
                var choices = self.getChoices();
                var validator = Justselling_Configento_App_Helper.getFormValidator();
                var renderValidator = false;
                var hasVisibleChoice = true;
                if(choices && choices.length > 0) {
                    // find if we have at least one not blacklisted choice
                    // If all choices are blacklisted we get an undefined back.
                    hasVisibleChoice = _.find(choices, function (choice) {
                        if(choice.getIsEmptyChoice()){
                            return false;
                        }
                        return choice.getIsBlacklisted() === false || choice.getIsBlacklisted() == null;
                    });
                }
                if (self.getIsBlacklisted() || self.getIsVisible() == false
                    || hasVisibleChoice == null || !hasVisibleChoice) {
                    hide = true;
                } else {

                    self.hideBlacklistedChoicesInDom(self);

                    var value = self.getValue();
                    var activeChoice = self.getActiveChoice();
                    if (activeChoice instanceof Justselling_Configento_Option_Choice) {
                        value = activeChoice.getOriginalValue();
                    }
                    else if (_.isArray(activeChoice)) {
                        value = _.map(activeChoice, function (choice) {
                            return choice.getOriginalValue();
                        });
                    }
                    if (typeof self.updateChart == 'function') {
                        self.updateChart();
                    }
                    var validator = Justselling_Configento_App_Helper.getFormValidator();
                    if(validator) {
                        if((validator._cacheFields[self.getName()] != null) && (!self.getIsRequired()) || (self.getType() === 'radiobutton')) {
                            /* if option is required we need to check for it */
                            delete validator.options.fields[self.getName()];
                            delete validator._cacheFields[self.getName()];
                            renderValidator = false;
                        }
                        else if (
                            $element.attr('data-fv-trigger') && $element.attr('data-fv-trigger') != ''
                            && $element.attr('data-fv-excluded') == 'false') {
                            validator.removeField($element);
                            renderValidator = true;
                        }
                    }

                    if (value !== "") {
                        if (self.getType() === 'package') {
                            if (this.getActive()) {
                                $element.find('input').prop('checked', true);
                            } else {
                                $element.find('input').prop('checked', false);
                            }
                        } if (self.getType() === 'checkbox' || self.getType() === 'radiobutton')
                        {
                            $element.find('input').prop('checked', false);
                            if (self.getActiveChoice()) {
                                if (activeChoice instanceof Justselling_Configento_Option_Choice) {
                                    jQuery('#' + activeChoice.getId()).prop('checked', true);
                                }
                                else if (_.isArray(activeChoice)) {
                                    _.each(activeChoice, function (choice) {
                                        jQuery('#' + choice.getId()).prop('checked', true);
                                    });
                                }
                            }
                        } else if(self.getActiveChoice() && (self.getType() === 'thumb' || self.getType() === 'select' || self.getType() === 'selectcombi')) {
                            var myValue = value;
                            if(_.isArray(value)) {
                                myValue = value[0];
                            }
                            var myActiveChoice = self.getActiveChoice();
                            if(_.isArray(myActiveChoice)) {
                                myActiveChoice = myActiveChoice[0];
                            }

                            if (typeof myActiveChoice !== 'undefined') {
                                $element.val(myValue);
                                $element.find('option').prop('selected', false);
                                $element.find('option[data-cf-internalid=' + myActiveChoice.getInternalId() + ']').prop('selected', true);
                            }
                        }
                        else {
                            $element.val(value);
                        }
                        // Update product price
                        self.setPrice(self.calculatePrice());
                        self.renderAfter();
                    } else {
                        /* in case we're setting option to blank, we have to reset also validation */
                        $element.val(value);
                        var validator = Justselling_Configento_App_Helper.getFormValidator();
                        if(validator) {
                            delete validator.options.fields[self.getName()];
                            delete validator._cacheFields[self.getName()];
                            renderValidator = false;
                        }
                    }
                }
                self.hideOptionInDom(hide);

                if (validator) {
                    if(self.getType() == 'thumb' || renderValidator && !hide) {
                        self.renderValidatorAfter($element);
                        setTimeout(function () {
                            if(validator._cacheFields[self.getName()] == null) {
                                self.renderValidatorAfter($element);
                            }
                            setTimeout(function () {
                                if (jQuery('.fv-has-error').length > 0) {
                                    jQuery('.fv-has-error:visible').each(function () {
                                        if (jQuery(this).find('.fv-help-block:visible').length === 0) {
                                            jQuery(this).removeClass('fv-has-error');
                                        }
                                    });
                                }
                            }, 1);
                            }, 239);
                    } else {
                        if(validator._cacheFields[self.getName()] == null) {
                            self.renderValidatorAfter($element);
                        }
                       //  validator.updateStatus($element,'NOT_VALIDATED');
                    }
                }
            }
            try {
                jQuery(document).trigger({"type": 'configentoOptionUpdateValueInDomAfter', "option":self} , { "option":self});
            } catch (e) {
                jQuery(document).trigger('configentoOptionUpdateValueInDomAfter', { "option":self});
            }
            return true;
        } else {
            return false;
        }
    };

    // Updates the active choice object of the option from the actual value in the DOM
Justselling_Configento_Option_Abstract.prototype.setActiveChoiceFromDom = function($element) {
        var self = this;
        // Check if the element is a selectbox with an Index
        // Or if it´s  a radiobutton/checkbox option
        if (self.getType() === 'package') {
            if ($element.find("input:checked").length == 1) {
                self.setActive(true);
            } else {
                self.setActive(false);
            }
        }

        if ($element.prop('selectedIndex') != undefined
            || self.getType() === 'checkbox'
            || self.getType() === 'radiobutton'
            || self.getType() === 'multiquantity')
        {
            var $option;
            if(self.getType() === 'radiobutton') {
                $option = $element.find("input:checked:not(:disabled)");
            }
            else if(self.getType() === 'checkbox' ) {
                $option = $element.find("input:checked");
            }
            else if(self.getType() === 'multiquantity' ) {
                if(self.getQtyType() == '2') {
                    $option = $element.find("option:selected:not(:disabled)").closest('.multiquantity').find('input[type=hidden]');
                }else if(self.getQtyType() == '1'){
                    $option = $element.find("input.qty").closest('.multiquantity').find('input[type=hidden]');
                }
            }
            else {
                $option = $element.find("option:selected");
            }
            if($option instanceof jQuery && $option.length > 0) {
                var currentChoice ;
                var forceRender = false;
                var choices = [];
                var wholeQty = 0;
                var maxQty = parseInt(self.getMaxQty());
                var qtyLimitMode = self.getQtyLimitMode(); // Add mode toggle: 'total' or 'perItem'

                $option.each(function () {
                    var id = jQuery(this).attr("data-cf-title");
                    currentChoice = self.getChoiceById(id);
                    // If it's the empty choice placeholder, don't return the value object
                    if (currentChoice && currentChoice.getIsEmptyChoice()) {
                        currentChoice = null;
                    }

                    var qtyVal = 0;
                    if(self.getQtyType()){
                        // we look if the qty change was triggered, and look for the qty field of the selected choice
                        var qty = jQuery(this).parent().find('.qty');
                        // If no qty field was found, the option must has changed
                        // (only  radiobuttons, because there is always one active choice with a qty field)
                        // So we need to grab the previous qty field (should be accessible in the whole option)
                        // type isset, we give the newly seleceted readiobutton the same qty as before (or 1 if before wasn´ a value)
                        if(qty.length === 0){
                            if(self.getType() === 'radiobutton') {
                                qty = $element.find('.qty');
                            }
                            else if(self.getType() === 'checkbox') {
                                qty = self.getMinQty()? parseInt(self.getMinQty()): 1;
                            }
                            else if (self.getType() === 'select' || self.getType() === 'selectcombi') {
                                qty = $element.closest('.optionmain').find('.optionQty .qty');
                            }
                            else if(self.getType() === 'thumb' ) {
                                qty = $element.closest('.optionmain').find('.thumbnails .qty');
                            }
                        }
                        // finally we set the qty
                        if((qty.length > 0 || _.isNumber(qty) ) && currentChoice){
                            if(_.isNumber(qty)) {
                                qtyVal = qty;
                            } else {
                                qtyVal = qty.val();
                            }

                            // Handle max total mode
                            if (qtyLimitMode === 'total') {
                                wholeQty += Number(qtyVal);
                                if (wholeQty > maxQty) {
                                    wholeQty -= Number(qtyVal); // Revert this choice's qty if it exceeds the total limit
                                    qtyVal = 0; // Reset this choice's quantity
                                    forceRender = true;
                                } else {
                                    currentChoice.setQty(qtyVal); // Set the choice's quantity
                                }
                            }

                            // Handle max per item mode
                            if (qtyLimitMode === 'perItem') {
                                var itemMaxQty = parseInt(qty.attr('max')) || maxQty; // Get item's max or global max
                                if (Number(qtyVal) > itemMaxQty) {
                                    qtyVal = itemMaxQty; // Limit quantity to the max for this item
                                    forceRender = true;
                                }
                                currentChoice.setQty(qtyVal); // Set the choice's quantity
                            }
                        }
                    }else {
                        qtyVal = 1;
                    }
                    if(qtyVal != 0) {
                       choices.push(currentChoice);
                    }
                });
                // if we get only one choice we can set the activeChoice directly with the choice object
                if(choices.length === 1) {
                    choices = choices[0];
                }
                else if(choices.length === 0) {
                    choices = '';
                }

                // Update the whole quantity in max total mode
                if (self.hasWholeQty === true && qtyLimitMode === 'total') {
                    self.setWholeQty(wholeQty);
                    if(forceRender) {
                        self.render();
                    }
                }
                self.setActiveChoice(choices, true);
            } else {
                self.setActiveChoice(null);
            }
        } else {
            Justselling_Configento_App_Debug.addDebug("set active choice");
            self.setActiveChoice(null);
            Justselling_Configento_App_Debug.addDebug("set active choice done");
        }
    };

    /*
     * Get the current value in DOM and set internal value the same
     */
Justselling_Configento_Option_Abstract.prototype.updateValueFromDom = function() {
        var self = this;
        var $element = self.getDomElement();
        Justselling_Configento_App_Debug.addDebug("updateValueFromDom "+self.getTitle());
        if ($element) {
            self.setActiveChoiceFromDom($element);
            Justselling_Configento_App_Debug.addDebug("set value");

            var updatedValue = $element.val();
            // if the DOM Element option is type of radiobutton/checkbox we need to assign the value of the actual checked radiobutton/checkbox
            if(self.getType() == 'radiobutton') {
                var checkedRadios = $element.find("input:checked");
                if(checkedRadios.length > 0){
                    updatedValue = checkedRadios.val();
                }else {
                    updatedValue = 0;
                }
            } else if (self.getType() == 'checkbox') {
                var checkedBoxes = $element.find("input:checked");
                if(checkedBoxes.length > 0){
                    updatedValue = [];
                    checkedBoxes.each(function () {
                        updatedValue.push( jQuery(this).val());
                    });
                }else {
                    updatedValue = 0;
                }
            }
            else if(self.getType() === 'multiquantity' ) {
                if(self.getQtyType() == '2') {
                    var inputs;
                    inputs = $element.find("option:selected:not([value=0])").closest('.multiquantity').find('input[type=hidden]');
                }else if(self.getQtyType() == '1'){
                    inputs = $element.find("input.qty").closest('.multiquantity').find('input[type=hidden]');
                }
                if(inputs.length > 0){
                    updatedValue = [];
                    inputs.each(function () {
                        updatedValue.push( jQuery(this).val());
                    });
                }else {
                    updatedValue = 0;
                }
            }
            var forceValueUpdate = null;
            // Notice: (important when the choice hasn´t changed, because the qty has been updated,
            // in this case the value would stay the same an a recalculation wouldn´t be fired)
            // Therefor we force setValue to update
            if(self.getQtyChanged() === true) {
                self.setQtyChanged(false);
                forceValueUpdate = 1;
            }
            self.setValue(updatedValue, forceValueUpdate);
            Justselling_Configento_App_Debug.addDebug("set value "+self.getValue()+" done");

            // render option only if option has selected choice images or it has quantities
            var configurator = self.getConfigurator()
            if((self.getQtyType() || self.getChoiceImageVisibility() == 'selected' || configurator.getConfig("displayPriceType") == 'relative')){
                self.render();
            }
        }
        Justselling_Configento_App_Debug.addDebug("done");
    };

Justselling_Configento_Option_Abstract.prototype.addChoiceAfter = function(choice) {
        var self = this;
        if(self.isCombi && choice.isEmptyChoice!== 1) {
            var option = choice.option;
            var operator = option.operator;
            var configurator = option.configurator;
            /*            var handleMyUpdate = "var myValue=$" + option.getTitle() + ";"; */

            var condition = choice.value;
            if (isNaN(condition)) {
                if (operator == 'string') {
                    condition = '"' + condition + '"';
                }
                /*else if(operator == 'expression') {
                    condition = '';
                }*/
                else if (operator == "*") {
                    condition = "1";
                }
                else if (operator == "+") {
                    condition = "0";
                }
            }
            var combiFields = option.combiFields;
            var expr = option.myExpression;
            if (combiFields && typeof combiFields == "object" || (expr && operator == 'expression')) {
                 if(operator == 'expression') {
                     condition =  expr;
                 }else {
                     for (var i = 0; i < combiFields.length; i++) {
                         switch (operator) {
                             case "*":
                             case "+":
                                 condition += operator + "$" + combiFields[i];
                                 break;
                             case "string":
                                 condition += '+"$' + combiFields[i] + '"';
                                 break;
                         }
                     }
                 }

                condition += ";";

             //   var minVal = Number(self.getMinValue());
             //   var maxVal = Number(self.getMaxValue());
          //      var decimal = Number(self.decimal);
          /*      if (_.isNumber(minVal)) {
                    condition += ' if(a < ' + minVal + ') { a = ' + minVal + '}';
                }
                if (_.isNumber(maxVal)) {
                    condition += ' if(a > ' + maxVal + ') { a = ' + maxVal + '}';
                }*/
             //  if (_.isNumber(decimal)) {
                   // condition += ' a = Justselling_Configento_App_Helper.round(a, ' + decimal + ');';
              //  }

                /* Create expression for calculate combi values */
                var params = {};
                params["is_visible"] = false;
                var expression = new Justselling_Configento_Option_Type_Expression(configurator, null, option.internalId + 'X_'+choice.internalId, 'combi_' + choice.id, 'Combi Expression ' + choice.label, params);
                var fullExpression = "var a = " + condition + ' a;';
                expression.setExpression(fullExpression);
                expression.isCombi = (true);
                expression.callback = (self.updateValue);
                expression.callbackThis = (self);
                expression.choice = (choice);
                choice.myExpression = (expression);
                expression.calculate();
            }

        }
    };

Justselling_Configento_Option_Abstract.prototype.updateOptionValue = function(choice, value) {
        var self = this;
    var start = new Date().getTime();
    /* If the choice is the active one, update value of option */
        var activeChoice = choice.option.activeChoice;
        if (activeChoice instanceof Justselling_Configento_Option_Choice && choice.id === activeChoice.id) {
            choice.option.setValue(value);
        }
        else if(_.isArray(activeChoice)) {
            var values =  _.map(activeChoice, function (choice) {
                if(choice.myExpression) {
                    return choice.myExpression.getValue();
                }
            });
            choice.option.setValue(values);
        }
    var end = new Date().getTime();
    var time = end - start;
    Justselling_Configento_App_Profiler.addMeasuring("abstract::updateOptionValue", time);
    };

Justselling_Configento_Option_Abstract.prototype.updateValue = function(event, expression) {
        var self = this;
        if (expression) {
            var start = new Date().getTime();
            var choice = expression.choice;
            if (choice ) {
                var exprValue = expression.getValue();
                var value = parseFloat(choice.originalValue);
                if (!isNaN(value) && self.operatorValuePrice === '*') {
                    exprValue = exprValue * value;
                }
                if(choice.value != exprValue) {
                    choice.value = exprValue;

                    // TODO: CALL THIS Function only if nessecary
                    if (self.getValue() != exprValue) {
                        self.updateOptionValue(choice, exprValue);
                    }
                    if (!choice.isBlacklisted) {
                        self.updatePriceInDom(expression)
                    }
                }
            }

            var end = new Date().getTime();
            var time = end - start;
            Justselling_Configento_App_Profiler.addMeasuring("abstract::updateValue", time);
        }
    };

Justselling_Configento_Option_Abstract.prototype.updatePriceInDom = function(expression) {
        var start = new Date().getTime();

        if (expression && typeof expression == 'object') {
            /* Update price of choice in DOM */
            if(this.getIsRendered()) {
                var self = this;
                if(this.timeOutActive == null) {
                    this.timeOutActive = true;
                    setTimeout(function () {
                        self.render();
                        self.timeOutActive = null;
                    }, 200);
                }


            }
        }
        var end = new Date().getTime();
        var time = end - start;
        Justselling_Configento_App_Profiler.addMeasuring("choice::updatePriceInDom", time);
    };


    /*
     * Sets the current value in DOM for a given attribute (e.g. class)
     * of the parent (div-container)
     */
Justselling_Configento_Option_Abstract.prototype.updateAttributeInDom = function(element, attribute, value) {
        var $element;
        if (this.getDomElement() && this.getDomElement().length == 1) {
            if ($element = this.getDomElement().parents(".configento").first()) {
                $element.attr(attribute, value);
            }
            return true;
        }
        return false;
    };
    /*
     * Get the current value in DOM from a given attribute (e.g. class)
     * of the parent (div-container)
     */
Justselling_Configento_Option_Abstract.prototype.getAttributeFromDom = function(element, attribute) {
        var $element;
        if (this.getDomElement() && this.getDomElement().length == 1) {
            if ($element = this.getDomElement().parents(".configento").first()) {
                return $element.attr(attribute);
            }
        }
        return false;
    };

var Justselling_Configento_Option_Group = function(configurator, label) {

    var self = this;
    this.isBlacklisted = false;

    this.init = function (configurator, label) {
        var id = configurator.getId() + "-" + Justselling_Configento_App_Helper.getIdFromLabel(label);
        self.setId(id);
        self.setLabel(label);
        self.setIsVisible(true);

        /* register the new choice in option object */
        self.setConfigurator(configurator);
        configurator.addGroup(self);
    };

    /*
     * Getter and Setter for the internal variables
     */
    this.setConfigurator = function(configurator) {
        self.configurator = configurator;
    };
    this.getConfigurator = function() {
        return self.configurator;
    };
    this.setId = function(id) {
        this.id =  id;
    };
    this.getId = function() {
        return this.id;
    };
    this.setInternalId = function(internalId) {
        this.internalId =  internalId;
    };
    this.getInternalId = function() {
        return this.internalId;
    };
    this.setLabel = function(label) {
        self.label = label;
    };
    this.getLabel = function() {
        return self.label;
    };
    this.setIsActive = function(value) {
        self.isActive = value;
    };
    this.getIsActive = function() {
        return self.isActive;
    };
    this.setIndex = function(index) {
        self.index = index;
    };
    this.getIndex = function() {
        return self.index;
    };
    this.setIsVisible = function(value, noUpdate) {
        self.isVisible = value;
        if(value === false) {
            self.visibleClass = 'state-hidden';
        }
        else {
            self.visibleClass = '';
        }
        if(noUpdate == null) {
            Justselling_Configento_App_Wizard.updateWizard();
        }
    };
    this.getIsVisible = function() {
        return self.isVisible;
    };
    this.getIsBlacklisted = function () {
        return this.isBlacklisted;
    };
    this.setIsBlacklisted = function (bool) {
        this.isBlacklisted = bool;
    };

    /*
     * Get DOM Element for the div-tab of this group.
     * If not set already get it from DOM now.
     */
    this.getDomElement = function() {
        if (!self.$domElement) {
            self.$domElement = jQuery('#group-'+this.getId());
        }
        return self.$domElement;
    };

    this.setOptions = function (options) {
        this.options =  options;
    };

    this.getOptions = function () {
        return this.options;
    };

    /**
     * @return $price
     */
    this.getCurrentPrice = function () {
        var configurator = self.configurator;
        var options = this.getOptions();
        var price = 0;
        for(var i=0; i<options.length;i++) {
            var option = configurator.getOptionByInternalId(options[i].id);
            if (option) {
                var activeChoice = option.getActiveChoice();
                if (activeChoice instanceof Justselling_Configento_Option_Choice) {
                    price += parseFloat(activeChoice.getPrice());
                } else {
                    price += parseFloat(option.getPrice());
                }
            }
        }
        price = Justselling_Configento_App_Tax.convert(price);
        return price;
    };

    this.init(configurator, label);
    return this;
};
var Justselling_Configento_Option_Type_Text = function(configurator, group, internalId, title, label, params) {

    var option = new Justselling_Configento_Option_Abstract();
    option.init("text", configurator, group, internalId, title, label, params);

    var self = option;

    self.staticDateRestriction = undefined;
    self.dateRestrictions = [];
    self.tmpDateRestrictions = [];

    if(params['frontend_type']) {
        option.setFrontendType(params['frontend_type']);
    }

    if(params["date_restriction"]) {
        self.setStaticDateRestriction(params["date_restriction"]);
    }

    option.setTextValidate = function(textValidate) {
        self.textValidate = textValidate;
    };
    option.getTextValidate = function() {
      return  self.textValidate;
    };


    option.setMinStringLength = function(value) {
        self.minStringLength =  value;
    };
    option.getMinStringLength = function() {
        return self.minStringLength;
    };
    option.setMaxStringLength = function(value) {
        self.maxStringLength =  value;
    };
    option.getMaxStringLength = function() {
        return self.maxStringLength;
    };
    option.getPlaceholder = function() {
        return self.placeholder;
    };
    option.setPlaceholder = function(defaultValue) {
        self.placeholder = defaultValue;
    };

    option.clearTmpDateRestrictions = function() {
        self.tmpDateRestrictions = [];
    }

    option.clearDateRestrictions = function() {
        self.dateRestrictions = [];
    };

    option.addDateRestriction = function(restriction) {
        self.tmpDateRestrictions.push(restriction);
        // self.setHasChanged(true);
    };

    option.renderAfter = function() {
        if(self.getFrontendType() == "date") {
            var domElement = self.getDomElement();

            var defaultDate = undefined;

            if(option.getDefaultValue() == "next") {
                defaultDate = new Date();
            }

            if(self.getValue()) {
                var parsedDate = self.getValue().split(".");
                if(parsedDate.length >= 3) {
                    defaultDate = new Date(parsedDate[2]+"-"+parsedDate[1]+"-"+parsedDate[0]);
                }
            }

            var locale = Justselling_Configento_App_Locale.getLanguage();

            var options = {
                disable: [],
                dateFormat: "d.m.Y",
                onChange: function(selectedDates, dateStr, instance) {
                    self.getDomElement().val(dateStr);
                },
                defaultDate: defaultDate,
                locale: locale
            };
            for(var dIndex = 0; dIndex < self.dateRestrictions.length; dIndex++) {
                var dr = self.dateRestrictions[dIndex];
                options = addDr(options, dr);
            }

            var staticDr = self.getStaticDateRestriction();
            if(staticDr && staticDr.type != "all") {
                if(staticDr.type == "weekdays") {
                    options.disable.push(function(date) {
                        return staticDr.weekdays.indexOf(date.getDay()) > -1 || staticDr.weekdays.indexOf(String(date.getDay())) > -1;
                    });
                }
				if(staticDr.allow_past == "0") {
					options.minDate = "today";
				}
            }

            var fp = flatpickr(domElement, options); // disabled for now, until main require si done

            if(option.getDefaultValue() == "next") {
                var newDate = new Date();
                while(fp.selectedDates.length == 0) {
                    newDate.setDate(newDate.getDate() + 1);
                    fp.setDate(newDate, true);
                }
            }
        }
    };

    option.checkDateRestrictionsChanges = function() {
        if(self.tmpDateRestrictions.length != self.dateRestrictions.length) {
            self.setHasChanged(true);
            self.dateRestrictions = self.tmpDateRestrictions;
            return;
        }

        var tmp, found, date, t, d;
        for(t = 0; t < self.tmpDateRestrictions.length; t++) {
            tmp = self.tmpDateRestrictions[t];
            found = false;
            for(d = 0; d < self.dateRestrictions.length; d++) {
                date = self.dateRestrictions[d];
                if(!compareDateRestrictions(tmp, date)) {
                    continue;
                }
                found = true;
                break;
            }
            if(!found) {
                self.dateRestrictions = self.tmpDateRestrictions;
                self.setHasChanged(true);
                return;
            }
        }
    };

    function compareDateRestrictions(dr1, dr2) {
        if(
            dr1.type != dr2.type
            || dr1.days != dr2.days
            || dr1.from != dr2.from
            || dr1.to != dr2.to
        ) {
            return false;
        }

        if(dr1.weekdays && dr2.weekdays) {
            var filteredWeekdays =
                (dr1.weekdays.filter(function (i) {
                    return dr2.weekdays.indexOf(i) == -1;
                })).concat(
                    dr2.weekdays.filter(function (i) {
                        return dr1.weekdays.indexOf(i) == -1;
                    })
                );
            if (filteredWeekdays.length > 0) {
                return false;
            }
        } else if(!dr1.weekdays && dr2.weekdays || dr1.weekdays && !dr2.weekdays) {
            return false;
        }

        return true;
    }

    function addDr(options, dr) {
        if(dr.type == "weekdays") {
            options.disable.push(function(date) {
                return dr.weekdays.indexOf(date.getDay()) > -1 || dr.weekdays.indexOf(String(date.getDay())) > -1;
            });
        } else if(dr.type == "days") {
            var days = dr.days.split(";");
            for(var d = 0; d < days.length; d++) {
                options.disable.push(flatpickr.parseDate(days[d], 'Y-m-d'));
            }
        } else if(dr.type == "range") {
            options.disable.push({
                from: dr.from,
                to: dr.to
            });
        } else if(dr.type == "expression") {
            options.disable.push(function(date) {
                return eval(dr.expression);
            });
        }

        return options;
    }

    return option;
};

var Justselling_Configento_Option_Type_Area = function(configurator, group, internalId, title, label, params) {

    var option = new Justselling_Configento_Option_Abstract();
    option.init("area", configurator, group, internalId, title, label, params);


    var self = option;

    option.setTextValidate = function(textValidate) {
        self.textValidate = textValidate;
    };
    option.getTextValidate = function() {
        return  self.textValidate;
    };

    option.setMinStringLength = function(value) {
        self.minStringLength =  value;
    };
    option.getMinStringLength = function() {
        return self.minStringLength;
    };
    option.setMaxStringLength = function(value) {
        self.maxStringLength =  value;
    };
    option.getMaxStringLength = function() {
        return self.maxStringLength;
    };

    option.getPlaceholder = function() {
        return self.placeholder;
    };
    option.setPlaceholder = function(defaultValue) {
        self.placeholder = defaultValue;
    };
    return option;
};

var Justselling_Configento_Option_Type_Select = function(configurator, group, internalId, title, label, params) {

    var option = new Justselling_Configento_Option_Abstract();
    option.init("select", configurator, group, internalId, title, label, params);

    var self = option;
    self.hasWholeQty = true;

    if (!params['default_value']) {
        var defaultChoice = new Justselling_Configento_Option_Choice(
            option,
            Justselling_Configento_App_Translate.translate('Please choose'),
            '',
            0,
            null,
            1,
            "none_" + internalId
        );
        option.setDefaultValue(defaultChoice);
    }

    if(params['frontend_type']) {
        option.setFrontendType(params['frontend_type']);
    }
    if(params['autocomplete_template']) {
        option.setAutocompleteTemplate(params['autocomplete_template']);
    }
    if(params['autocomplete_searchby']) {
        option.setAutocompleteSearchby(params['autocomplete_searchby']);
    }

    self.bindQtyToDom = function() {
        if (self.getDomElement() && self.getDomElement().length == 1) {
            jQuery(self.getConfigurator().getDomElement()).on("change", "#" + self.getId() + '-container .optionQty .qty', function (event) {
                self.DOMChangeCallback(event);
            });
        }
    };

    option.renderAfter = function() {
        if(self.getFrontendType() == "autocomplete") {
            var optionImage = Justselling_Configento_App_Helper.getAssetPath(self.getId(), self.getInternalId()) + Justselling_Configento_App_Helper.getBaseName(self.getImage());

            var choices = self.getActiveChoices();
            choices.sort(function(a, b) {
                if(a.getSortOrder() < b.getSortOrder()) {
                    return -1;
                } else if(a.getSortOrder() > b.getSortOrder()) {
                    return 1;
                }
                return 0;
            });
            var autocompleteOptions = [];
            var searchBy = self.getAutocompleteSearchby();
            for(var c = 0; c < choices.length; c++) {
                var choice = choices[c];
                var basePath = Justselling_Configento_App_Helper.getAssetPath(
                    choice.getId(),
                    self.getInternalId(),
                    choice.getInternalId()
                );

                var imageBaseName = Justselling_Configento_App_Helper.getBaseImage(choice.image);

                if (!imageBaseName && choice.image && choice.image.length > 0) {
                    imageBaseName = choice.image[0].filelink;
                }
                var choiceImage = basePath + imageBaseName;

                var query = [choice.getLabel()];
                if(searchBy == "value") {
                    query = [choice.getValue()];
                } else if(searchBy == "both") {
                    query.push(choice.getValue());
                }

                var option = {
                    value: choice.getValue(),
                    query: query,
                    viewValue: choice.getLabel(),
                    baseImage: optionImage,
                    image: choiceImage,
                    choice: choice,
                    sort: choice.getSortOrder(),
                    additionalQuery: choice.articleValue
                };
                autocompleteOptions.push(option);
            }

            var template = self.getAutocompleteTemplate();
            if(template.length == 0) {
                template = undefined;
            }

            new Justselling_Configento_Autocomplete_Autocomplete(
                jQuery("#select-" + self.getId()),
                self.getDomElement(),
                autocompleteOptions,
                template,
                self
            );

            self.getDomElement().hide();
        }
    };

    return option;
};

var Justselling_Configento_Option_Type_MultiQuantity = function(configurator, group, internalId, title, label, params) {

    var option = new Justselling_Configento_Option_Abstract();
    option.init("multiquantity", configurator, group, internalId, title, label, params);

    var self = option;
    self.hasWholeQty = true;
    self.activateHoverListener = function () {
        var timer, timer2;
        jQuery(self.getConfigurator().getDomElement()).on({

            mouseenter: function () {
                var $this = jQuery(this);
                clearTimeout(timer2);
                timer = setTimeout(function () {
                    var $inputHidden = $this.find('input[type="hidden"]');
                    if ($inputHidden.length === 0) {
                        $inputHidden = $this.find('input');
                    }
                    Justselling_Configento_App_Debug.addDebug("hover=" + $inputHidden.attr("id"));

                    var choice = self.getChoiceByInternalId($inputHidden.attr('data-cf-internalid'));
                    var optionInternalId = self.getInternalId();
                    var choiceImage = "";
                    var activeChoice =self.getActiveChoice();
                    if(_.isArray(activeChoice)) {
                        activeChoice = activeChoice[activeChoice.length -1 ];
                    }
                    var activeChoiceId;
                    if(activeChoice) {
                        activeChoiceId = activeChoice.getId();
                    }

                    var actualImage = $this.parent().find('.choice-image');
                    if(actualImage.length === 0) {
                        $this.parent().prepend('<img class="choice-image " style="display:none;" >');
                        actualImage = $this.parent().find('.choice-image');
                    }
                    if (choice && activeChoiceId !== choice.getId() ) {
                        var imageBaseName = Justselling_Configento_App_Helper.getBaseName(choice.image);
                        var tmpImage = $this.parent().find('#choice-image-hover-'+choice.getId());
                        if (choice.image && imageBaseName && tmpImage.length === 0) {
                            var assetsPath = Justselling_Configento_App_Helper.getAssetPath(choice.id, optionInternalId, choice.internalId);
                            choiceImage = '<img id="choice-image-hover-'+choice.getId()+'" class="choice-image-hover " src="' + assetsPath + imageBaseName + '" >';
                            actualImage.after(choiceImage);
                            tmpImage = $this.parent().find('#choice-image-hover-'+choice.getId());
                            tmpImage.hide();
                        }
                        actualImage.fadeOut(300);
                        tmpImage.fadeIn(200);
                    }else {
                        actualImage.show();
                    }
                }, 250);
            },
            mouseleave: function () {
                clearTimeout(timer);
                var $this = jQuery(this);
                var $inputHidden = $this.find('input[type="hidden"]');
                if ($inputHidden.length === 0) {
                    $inputHidden = $this.find('input');
                }
                var choice = self.getChoiceByInternalId($inputHidden.attr('data-cf-internalid'));

                $this.parent().find('#choice-image-hover-'+choice.getId()).fadeOut(200);
                timer2 = setTimeout(function () {
                    $this.parent().find('.choice-image').show();
                }, 100);
            }
        }, "#" + self.getId()+" .multiquantity"); //pass the element as an argument to .on
    };

    return option;
};
var Justselling_Configento_Option_Type_MultiSelect = function(configurator, group, internalId, title, label, params) {

    var option = new Justselling_Configento_Option_Abstract();
    option.init("multiselect", configurator, group, internalId, title, label, params);

    return option;
};

var Justselling_Configento_Option_Type_SelectCombi = function(configurator, group, internalId, title, label, params) {

    var option = new Justselling_Configento_Option_Abstract();
    option.init("selectcombi", configurator, group, internalId, title, label, params);
    option.setIsCombi(true);
    var self = option;
    self.hasWholeQty = true;

    var defaultChoice = new Justselling_Configento_Option_Choice(
        option,
        Justselling_Configento_App_Translate.translate('Please choose'),
        '',
        0,
        null,
        1,
        "none_"+internalId
    );
    option.setDefaultValue(defaultChoice);

    option.setCombiFields = function(combiFields) {
        self.combiFields = combiFields;
    };
    option.getCombiFields = function() {
        return self.combiFields;
    };
    option.setOperator = function(operator) {
        self.operator = operator;
    };
    option.getOperator = function() {
        return self.operator;
    };
    option.setDecimal = function(decimal) {
        self.decimal = decimal;
    };
    option.getDecimal = function() {
        return self.decimal;
    };

    option.addChoiceAfter = function(choice) {
        var option = choice.getOption();
        var operator = option.getOperator();

        var handleMyUpdate = "var myValue=$"+option.getTitle()+";";

        var condition = choice.getValue();
        if (isNaN(condition)) {
            if (operator == 'string' || operator == 'expression') {
                condition = '"' + condition + '"';
            } else if (operator == "*") {
                condition = "1";
            } else if (operator == "+") {
                condition = "0";
            }
        }

        if (option.getCombiFields()) {
            var combiFields = option.getCombiFields();
            if (combiFields && typeof combiFields == "object") {
                for (var i = 0; i < combiFields.length; i++) {
                    switch (operator) {
                        case "*":
                        case "+":
                            condition += operator + "$" + combiFields[i];
                            break;
                        case "string":
                            condition += '+"$' + combiFields[i] +'"';
                            break;
                        case "expression":
                            break;
                    }
                }

                condition += ";";

                condition += ";";
                var minVal = Number(self.getMinValue());
                var maxVal = Number(self.getMaxValue());
                var decimal = Number(self.getDecimal());
                if(_.isNumber(minVal)) {
                    condition += ' if(a < '+minVal+') { a = '+minVal+'}';
                }
                if(_.isNumber(maxVal)) {
                    condition += ' if(a > '+maxVal+') { a = '+maxVal+'}';
                }
                if(_.isNumber(decimal)) {
                    condition += ' a = Justselling_Configento_App_Helper.round(a, '+decimal+');';
                }

                /* Create expression for calculate combi values */
                var params = {};
                params["is_visible"] = false;
                var expression = new Justselling_Configento_Option_Type_Expression(configurator, null, '99'+option.getInternalId(), 'combi'+choice.getId(),'Combi Expression '+choice.getId(), params);
                var fullExpression = "var a = "+condition + ' a;';
                expression.setExpression(fullExpression);
                expression.setIsCombi(true);
                expression.setCallback(self.updateValue);
                expression.setChoice(choice);
                choice.setExpression(expression);
                expression.calculate();
            }
        }
    };

    option.updateOptionValue = function(choice, value) {
        /* If the choice is the active one, update value of option */
        var option = choice.getOption();
        var activeChoice = option.getActiveChoice();
        if (activeChoice && typeof activeChoice == 'object') {
            if (choice.getId() == activeChoice.getId()) {
                option.setValue(value);
            }
        }
    };

    option.updateValue = function(event, expression) {
        if (expression && typeof expression == 'object') {
            var choice = expression.getChoice();
            if (choice && typeof choice == 'object') {
                choice.setValue(expression.getValue());
                self.updateOptionValue(choice, expression.getValue());
                self.updatePriceInDom(expression)
            }
        }
    };

    option.updatePriceInDom = function(expression) {
        var start = new Date().getTime();

        if (expression && typeof expression == 'object') {
            var choice = expression.getChoice();

            self.updateOptionValue(choice, expression.getValue());

            /* Update price of choice in DOM */
            var price = choice.getPrice();
            if (self.getIsRendered()) {
                if (choice.getDomElement()) {
                    if(choice.getQty() != null) {
                        price = price / choice.getQty();
                    }
                    var priceHtml = "";
                    if (!isNaN(price)) {
                        priceHtml = Justselling_Configento_App_Price.renderPrice(price);
                    }
                    var currentHtml = choice.getDomElement().html();
                    if (currentHtml) {
                        var newHtml = "";
                        if (currentHtml.search(/\[.*\]/) != -1) {
                            newHtml = currentHtml.replace(/\[.*\]/, priceHtml);
                        } else {
                            newHtml = currentHtml + priceHtml;
                        }
                        choice.getDomElement().html(newHtml);
                    }
                }
            }
        }

        var end = new Date().getTime();
        var time = end - start;
        Justselling_Configento_App_Profiler.addMeasuring("choice::updatePriceInDom", time);
    };
    self.bindQtyToDom = function() {
        if (self.getDomElement() && self.getDomElement().length == 1) {
            jQuery(self.getConfigurator().getDomElement()).on("change", "#" + self.getId() + '-container .optionQty .qty', function (event) {
                self.DOMChangeCallback(event);
            });
        }
    };

    return option;
};
var Justselling_Configento_Option_Type_Combi = function(configurator, group, internalId, title, label, params) {

    var option = new Justselling_Configento_Option_Abstract();
    option.init("combi", configurator, group, internalId, title, label, params);
    option.setIsCombi(true);
    var self = option;

    option.setCombiFields = function(combiFields) {
        self.combiFields = combiFields;
    };
    option.getCombiFields = function() {
        return self.combiFields;
    };
    option.setOperator = function(operator) {
        self.operator = operator;
    };
    option.getOperator = function() {
        return self.operator;
    };
    option.setDecimal = function(decimal) {
        self.decimal = decimal;
    };
    option.getDecimal = function() {
        return self.decimal;
    };
    option.initExpression = function () {

        var operator = option.getOperator();

        var condition /*= choice.getValue()*/;
        //if (isNaN(condition)) {
            if (operator == 'string' || operator == 'expression') {
                condition = "''";
            } else if (operator == "*") {
                condition = "1";
            } else if (operator == "+") {
                condition = "0";
            }
        //}


        if (option.getCombiFields()) {
            var combiFields = option.getCombiFields();
            if (_.isArray(combiFields)) {
                _.each(combiFields, function (combifield) {
                    switch (operator) {
                        case "*":
                        case "+":
                            condition += operator + "$" + combifield;
                            break;
                        case "string":
                            condition += '+ ($' + combifield +').toString() ';
                            break;
                        case "expression":
                            break;
                    }
                });
                condition += ";";
                var decimal = self.getDecimal();
                if(_.isNumber(decimal)) {
                    condition += ' a = Justselling_Configento_App_Helper.round(a, '+decimal+');';
                }

                /* Create expression for calculate combi values */
                var params = {};
                params["is_visible"] = false;
                if (operator == 'string') {
                    params['decimals'] = 'undefined';
                } else {
                    params['decimals'] = self.getDecimal();
                }
                var expression = new Justselling_Configento_Option_Type_Expression(configurator, null, '99'+option.getInternalId(), 'combi'+option.getId(),'Combi Expression '+option.getId(), params);
                var fullExpression = "var a = "+condition + ' a;';
                expression.setExpression(fullExpression);
                expression.setIsCombi(true);
                expression.setCallback(self.updateValueCombi);
                expression.setCallbackThis(self);
                expression.calculate();
            }
        }


    };


    option.updateValueCombi = function(event, expression) {
        if (expression && typeof expression == 'object') {
                self.setValue(expression.getValue());
                self.updatePriceInDomCombi(expression)
        }
    };

    option.updatePriceInDomCombi = function(expression) {
        if (expression && typeof expression == 'object') {

            /* Update price of choice in DOM */
            var price = self.getPrice();
            if (self.getIsRendered()) {
                if (self.getDomElement()) {
                    if(self.getWholeQty() != null) {
                        price = price / self.getWholeQty();
                    }
                    var priceHtml = "";
                    if (!isNaN(price)) {
                        priceHtml = Justselling_Configento_App_Price.renderPrice(price);
                    }
                    var currentHtml = self.getDomElement();
                    if (currentHtml) {
                        currentHtml.closest('.option').find('.price').html(priceHtml);
                        /*
                        var newHtml = "";
                        if (currentHtml.search(/\[.*\]/) != -1) {
                            newHtml = currentHtml.replace(/\[.*\]/, priceHtml);
                        } else {
                            newHtml = ;
                        }
                        self.getDomElement().html(newHtml);*/
                    }
                }
            }
        }
    };

    return option;
};
var Justselling_Configento_Option_Type_RadioButtons = function (configurator, group, internalId, title, label, params) {

    var option = new Justselling_Configento_Option_Abstract();
    option.init("radiobutton", configurator, group, internalId, title, label, params);
    var self = option;

    if(params['frontend_type']) {
        option.setFrontendType(params['frontend_type']);
    }

    self.activateHoverListener = function () {
        var timer, timer2;
        jQuery(self.getConfigurator().getDomElement()).on({

            mouseenter: function () {
                var $this = jQuery(this);
                clearTimeout(timer2);
                timer = setTimeout(function () {
                    var $radio = $this.find('input');
                    Justselling_Configento_App_Debug.addDebug("hover=" + $radio.attr("id"));

                    var choice = self.getChoiceByInternalId($radio.attr('data-cf-internalid'));
                    var optionInternalId = self.getInternalId();
                    var choiceImage = "";
                    var activeChoice =self.getActiveChoice();
                    if(_.isArray(activeChoice)) {
                        activeChoice = activeChoice[0];
                    }
                    var actualImage = $this.parent().find('.choice-image');
                    if (choice && activeChoice && activeChoice.getId() !== choice.getId() ) {
                        var imageBaseName = Justselling_Configento_App_Helper.getBaseName(choice.image);
                        var tmpImage = $this.parent().find('#choice-image-hover-'+choice.getId());
                        if (choice.image && imageBaseName && tmpImage.length === 0) {
                            var assetsPath = Justselling_Configento_App_Helper.getAssetPath(choice.id, optionInternalId, choice.internalId);
                            choiceImage = '<img id="choice-image-hover-'+choice.getId()+'" class="choice-image-hover " src="' + assetsPath + imageBaseName + '" >';
                            actualImage.after(choiceImage);
                            tmpImage = $this.parent().find('#choice-image-hover-'+choice.getId());
                            tmpImage.hide();
                        }
                        actualImage.fadeOut(300);
                        tmpImage.fadeIn(200);
                    }else {
                        actualImage.show();
                    }
                }, 250);
            },
            mouseleave: function () {
                clearTimeout(timer);
                var $this = jQuery(this);
                var $radio = $this.find('input');
                var choice = self.getChoiceByInternalId($radio.attr('data-cf-internalid'));

                $this.parent().find('#choice-image-hover-'+choice.getId()).fadeOut(200);
                timer2 = setTimeout(function () {
                        $this.parent().find('.choice-image').show();
                }, 100);
            }
        }, "#" + self.getId()+" .radiobutton"); //pass the element as an argument to .on
    };
    return option;
};
var Justselling_Configento_Option_Type_Checkbox = function(configurator, group, internalId, title, label, params) {

    var option = new Justselling_Configento_Option_Abstract();
    option.init("checkbox", configurator, group, internalId, title, label, params);
    option.hasWholeQty = true;

    return option;
};
var Justselling_Configento_Option_Type_Thumb = function(configurator, group, internalId, title, label, params) {

    var option = new Justselling_Configento_Option_Abstract();
    option.init("thumb", configurator, group, internalId, title, label, params);
    var self = option;

    var defaultChoice = new Justselling_Configento_Option_Choice(
        option,
        Justselling_Configento_App_Translate.translate('Please choose'),
        '',
        0,
        null,
        1,
        "none_"+internalId
    );
    option.setDefaultValue(defaultChoice);

    option.getCollapseHeader = function(thumbDimensions) {
        var choice = self.getActiveChoice();
        var template = "";
        var html = "";

        if (choice && typeof choice == "object") {
            var source = Justselling_Configento_App_Helper.$template.find("#overlay-collapse-header-template").html();
            if (source) {
                template = Handlebars.compile(source);
            }
            if (template ) {
                if (_.isArray(choice)) {
                    choice = choice[0];
                }

                var thumbFilename = choice.getThumb();
                if(_.isArray(thumbFilename)) {
                    thumbFilename = thumbFilename[0].filelink;
                }
                if (thumbFilename) {
                    var parts = thumbFilename.split("/");
                    if (parts.length > 1) {
                        thumbFilename = parts[parts.length - 1];
                    }
                }
                var thumb = Justselling_Configento_App_Helper.getAssetPath(choice.getId(), self.getInternalId(), choice.getInternalId()) + thumbFilename;
                var context = {
                    id: self.getId() + "-overlay-collapse",
                    thumb: thumb,
                    label: choice.getLabel()
                };
                if(choice.getIsEmptyChoice() == 1) {
                    var choices = self.getChoices();
                    if(choices.length > 1) {
                        var thumbWidth = choices[1].getThumbWidth();
                        var thumbHeight = choices[1].getThumbHeight();
                        if(thumbWidth) {
                            if(!isNaN(thumbWidth)){
                                thumbWidth = thumbWidth+'px';
                            }
                            else if(thumbWidth.substr(-1,1) != '%' && thumbWidth.substr(-2,2) != 'px') {
                                thumbWidth = '';
                            }
                            context.thumbWidth = thumbWidth;
                        }
                        if(thumbHeight) {
                            if(!isNaN(thumbHeight)){
                                thumbHeight = thumbHeight+'px';
                            }
                            else if(thumbHeight.substr(-1,1) != '%' && thumbHeight.substr(-2,2) != 'px') {
                                thumbHeight = '';
                            }
                            context.thumbHeight = thumbHeight;
                        }
                    }
                    else {
                        context.thumbWidth = '55px';
                        context.thumbHeight = '55px';
                    }
                    context.thumb = '';
                }
                if(thumbDimensions == true) {
                    if(self.getStyle() == 0 && choice.getIsEmptyChoice() != 1) {
                        context.label = '';
                    }
                    var thumbWidth = choice.getThumbWidth();
                    var thumbHeight = choice.getThumbHeight();
                    if(thumbWidth) {
                        if(!isNaN(thumbWidth)){
                            thumbWidth = thumbWidth+'px';
                        }
                        else if(thumbWidth.substr(-1,1) != '%' && thumbWidth.substr(-2,2) != 'px') {
                            thumbWidth = '';
                        }
                        context.thumbWidth = thumbWidth;
                    }
                    if(thumbHeight) {
                        if(!isNaN(thumbHeight)){
                            thumbHeight = thumbHeight+'px';
                        }
                        else if(thumbHeight.substr(-1,1) != '%' && thumbHeight.substr(-2,2) != 'px') {
                            thumbHeight = '';
                        }
                        context.thumbHeight = thumbHeight;
                    }
                }
                html = template(context);
            }
        }
        return html;
    };

    option.renderAfter = function(key) {
        var style = self.getStyle();
        var $element = self.getDomElement();
        var popup;
        if ($element && $element.length == 1) {


            var s2 = new Date().getTime();

            var $parent = self.getDomParentElement();
            var $collapseContainer;
            /* remove old collapse-container */
            if (self.getCollapse()) {
                $collapseContainer = $parent.find(".collapse");
                if ($collapseContainer.length == 1) {
                    $collapseContainer.remove();
                }
            }
            if (self.getOverlay()) {
                var $overlayContainer = $parent.find(".overlay");
                if ($overlayContainer.length == 1) {
                    $overlayContainer.remove();
                }
            }

            $element.imagepicker({
                limit: 1,
                show_label: style,
                hide_select: true,
                clicked: function() {
                    if(jQuery.modal || jQuery(this).modal) {
                        if (jQuery("body").hasClass('configento-magento2')) {
                            if (typeof popup !== 'undefined') {
                                popup.closeModal();
                            }
                        } else {
                            jQuery.modal.close();
                        }
                        /* if we have popup modal, double one, than we need to secure that options, will be refreshed. */
                        if ((typeof $collapseContainer === 'undefined') && (typeof popup !== 'undefined')) {
                            self.render();
                        }
                    }
                    if ($collapseContainer && $collapseContainer.length == 1) {
                        $collapseContainer.find('.active.open a').trigger('click');
                        setTimeout(function () { // we have here small delay to avoid max execute, if we are already in run
                            self.render();
                        }, 400);
                    }
                }
            });

            var pickerInstance =  $element.data('picker');
            var $imagepicker = $parent.find(".thumbnails.image_picker_selector");

            /* create new collapse container */
            if (self.getCollapse()) {
                $imagepicker.wrap('<div class="collapse"></div>');
                $imagepicker.before("<span class='active'>" + self.getCollapseHeader() + "</span>");
                $collapseContainer = $parent.find(".collapse");
                $collapseContainer.collapse({
                    'query': 'span'
                });
                $collapseContainer.find("span.active").click(function () {
                    if(pickerInstance.picker_options.length == 0) {
                        pickerInstance.recursively_parse_option_groups(pickerInstance.select, pickerInstance.picker);
                        pickerInstance.sync_picker_with_select();
                    }
                });
            }
            else if (self.getOverlay()) {
                $imagepicker.wrap('<div class="overlay"></div>');
                $imagepicker.before("<span class='active'>" + self.getCollapseHeader(true) + "</span>");
                $overlayContainer = $parent.find(".overlay");
                $imagepicker.hide();
                $imagepicker.addClass("simplemodal-close");

                var minHeight = 600;
                if ( jQuery(window).height() < 820) {
                    minHeight = jQuery(window).height() * 80/100;
                }
                var minWidth = 560;
                if ( jQuery(window).width() < 620) {
                    minWidth = jQuery(window).width() * 80/100;
                }

                if (jQuery("body").hasClass('configento-magento2')) { /* Magento 2 has it's own modal class */
                    require(['jquery', 'Magento_Ui/js/modal/modal'],
                        function ($, modal) {
                            var options = {
                                type: 'popup',
                                responsive: true,
                                innerScroll: true,
                                title: self.getLabel(),
                                modalClass: 'see-detail-modal',
                                buttons: []
                            };

                            $overlayContainer.find("span.active").click(function () {
                                if (jQuery(this).parent().parent().hasClass('prevent-click')) {
                                    return false;
                                }
                                if (pickerInstance.picker_options.length == 0) {
                                    pickerInstance.recursively_parse_option_groups(pickerInstance.select, pickerInstance.picker);
                                    pickerInstance.sync_picker_with_select();
                                }

                                popup = modal(options, $imagepicker);
                                $imagepicker.modal('openModal');
                            });
                        }
                    );
                } else {
                    $overlayContainer.find("span.active").click(function () {
                        if (jQuery(this).parent().parent().hasClass('prevent-click')) {
                            return false;
                        }

                        if (pickerInstance.picker_options.length == 0) {
                            pickerInstance.recursively_parse_option_groups(pickerInstance.select, pickerInstance.picker);
                            pickerInstance.sync_picker_with_select();
                        }
                        $imagepicker.modal({
                            minHeight: minHeight,
                            maxHeight: minHeight,
                            minWidht: minWidth,
                            maxWidth: minWidth,
                            onClose: function () {
                                jQuery.modal.close();
                                self.render(); // Make sure imagepicker is getting rendered in every case
                            }
                        });
                    });
                }
            }
            else {
                if(pickerInstance.picker_options.length == 0) {
                    pickerInstance.recursively_parse_option_groups(pickerInstance.select, pickerInstance.picker);
                    pickerInstance.sync_picker_with_select();
                }
            }
            var e2 = new Date().getTime();
            var t2 = e2 - s2;
            Justselling_Configento_App_Profiler.addMeasuring("THUMB:renderAfter", t2);
            jQuery(document).trigger("configentoThumbRenderAfter");

        }
    };

    option.setStyle = function(myStyle) {
        self.myStyle = myStyle;
    };
    option.getStyle = function() {
        return self.myStyle;
    };

    option.setStyle(CONFIGENTO.OPTION_THUMB_STYLE_IMAGE_ONLY);

    jQuery(document).on("configentoActiveGroupVisible", function () {
        var $element = self.getDomElement();
        var validator = Justselling_Configento_App_Helper.getFormValidator();
        if (validator) {
            self.renderValidatorAfter($element);
        }
    });

    return option;
};

var Justselling_Configento_Option_Type_Matrix = function(configurator, group, internalId, title, label, params) {

    var option = new Justselling_Configento_Option_Abstract();
    params["bind_to_dom"] = false;
    option.init("matrix", configurator, group, internalId, title, label, params);
    var self = option;

    option.addMatrix = function(matrix) {
        if (!self.matrix || !(self.matrix instanceof Array)) {
            self.matrix = [];
        }
        self.matrix.push(matrix);
    };
    option.getMatrix = function(index) {
        var myMatrix = self.matrix;
        if (myMatrix && myMatrix instanceof Array) {
            if (index) {
                if (typeof myMatrix[index] !== 'undefined') {
                    return myMatrix[index];
                }
            }
            return myMatrix[0];
        }
        return false;
    };

    option.getCurrentMatrix = function() {
        var index = 0;
        if (self.getMatrixSelector()) {
            index = self.getMatrixSelector().getValue();
        }
        return self.getMatrix(index);
    };

    /*
     * Set matching mode for the row
     * See constants in CONFIGENTO consts
     */
    option.setModeRow = function(mode) {
        self.modeRow = mode;
        self.calculate();
    };
    option.getModeRow = function() {
        return self.modeRow;
    };
    /*
     * Set matching mode for the column
     * See constants in CONFIGENTO consts
     */
    option.setModeColumn = function(mode) {
        self.modeColumn = mode;
        self.calculate();
    };
    option.getModeColumn = function() {
        return self.modeColumn;
    };

    option.setMatrixSelector = function(option) {
        self.matrixSelector = option;
        if (typeof option == 'object') {
            option.addChild(self);
        } else {
            var unparsedOption = {
                type: 'matrixvalue',
                setType: 'setMatrixSelector',
                childTitle: option,
                self: self
            };
            configurator.setUnparsedOption(unparsedOption);
        }
        self.calculate(true);
    };
    option.getMatrixSelector = function() {
        return self.matrixSelector;
    };
    option.setMatrixValueSelectorRow = function(option) {
        self.matrixValueSelectorRow = option;
        if (typeof option == 'object') {
            option.addChild(self);
        } else {
            var unparsedOption = {
                type: 'matrixvalue',
                setType: 'setMatrixValueSelectorRow',
                childTitle: option,
                self: self
            };
            configurator.setUnparsedOption(unparsedOption);
        }
        self.calculate();
    };
    option.getMatrixValueSelectorRow = function(option) {
        return self.matrixValueSelectorRow;
    };
    option.setMatrixValueSelectorColumn = function(option) {
        self.matrixValueSelectorColumn = option;
        if (typeof option == 'object') {
            option.addChild(self);
        } else {
            var unparsedOption = {
                type: 'matrixvalue',
                setType: 'setMatrixValueSelectorColumn',
                childTitle: option,
                self: self
            };
            configurator.setUnparsedOption(unparsedOption);
        }
        self.calculate();
    };
    option.getMatrixValueSelectorColumn = function(option) {
        return self.matrixValueSelectorColumn;
    };

    /*
     * Get index of the currently selected row in given matrix
     */
    option.getMatchingRowIndex = function(matrix, rowValueParam) {
        var mode = self.getModeRow();
        if (self.getMatrixValueSelectorRow()) {
            var rowValue = self.getMatrixValueSelectorRow();
            if (typeof self.getMatrixValueSelectorRow() == 'object') {
                rowValue =  self.getMatrixValueSelectorRow().getValue();
            }
            if (jQuery.isNumeric(rowValue)) {
                rowValue = rowValue.toString();
            }
            if (rowValueParam) {
                rowValue = rowValueParam;
            }
            for (var i=0; i<matrix.length; i++) {
                if (typeof matrix[i] !== 'undefined') {
                    if (/^[a-zA-Z0-9_ ]*$/.test(matrix[i][0]) == false) {
                        Justselling_Configento_App_Debug.addDebug('CSV Row contains illegal characters: ' + JSON.stringify(matrix[i][0]));
                    }
                }

                if (mode == CONFIGENTO.MODE_NEXT_HEIGHER && parseFloat(matrix[i][0]) >= parseFloat(rowValue)) {
                    return i;
                }
                if (mode == CONFIGENTO.MODE_MATCH && matrix[i][0] === rowValue) {
                    return i;
                }
                if (mode == CONFIGENTO.MODE_NEXT_LOWER && parseFloat(matrix[i][0]) > parseFloat(rowValue)) {
                    if (i>0) return i-1;
                    return 0;
                }
            }
        }
    };
    /*
     * Get index of the currently selected column in given matrix
     */
    option.getMatchingColumnIndex = function(matrix, columnValueParam) {
        var mode = self.getModeColumn();
        if (self.getMatrixValueSelectorColumn()) {
            var columnValue = self.getMatrixValueSelectorColumn();
            if (typeof self.getMatrixValueSelectorColumn() == 'object') {
                columnValue = self.getMatrixValueSelectorColumn().getValue();
            }
            if (jQuery.isNumeric(columnValue)) {
                columnValue = columnValue.toString();
            }
            if (columnValueParam) {
                columnValue = columnValueParam;
            }
            for (var i=0; i<matrix[0].length; i++) {
                if (typeof matrix[0] !== 'undefined') {
                    if (/^[a-zA-Z0-9_ ]*$/.test(matrix[0][i]) == false) {
                        Justselling_Configento_App_Debug.addDebug('CSV Column contains illegal characters: ' + JSON.stringify(matrix[0][i]));
                    }
                }
                if (mode == CONFIGENTO.MODE_NEXT_HEIGHER && parseFloat(matrix[0][i]) >= parseFloat(columnValue)) {
                    return i;
                }
                if (mode == CONFIGENTO.MODE_MATCH && matrix[0][i] === columnValue) {
                    return i;
                }
                if (mode == CONFIGENTO.MODE_NEXT_LOWER && parseFloat(matrix[0][i]) > parseFloat(columnValue)) {
                    if (i>0) return i-1;
                    return 0;
                }
            }
        }
    };

    /*
     * Get index of the currently selected column in given matrix
     */
    option.getMatchingColumnIndexCustomValue = function(matrix, columnVal) {
        var mode = self.getModeColumn();
        if (columnVal) {
            if (jQuery.isNumeric(columnVal)) {
                columnVal = columnVal.toString();
            }
            for (var i=0; i<matrix[0].length; i++) {
                if (mode == CONFIGENTO.MODE_NEXT_HEIGHER && parseFloat(matrix[0][i]) >= parseFloat(columnVal)) {
                    return i;
                }
                if (mode == CONFIGENTO.MODE_MATCH && matrix[0][i] === columnVal) {
                    return i;
                }
                if (mode == CONFIGENTO.MODE_NEXT_LOWER && parseFloat(matrix[0][i]) > parseFloat(columnVal)) {
                    if (i>0) return i-1;
                    return 0;
                }
            }
        }
    };

    option.getMatchingRowIndexCustomValue = function(matrix, rowVal) {
        var mode = self.getModeRow();
        if (rowVal) {
            if (jQuery.isNumeric(rowVal)) {
                rowVal = rowVal.toString();
            }
            for (var i=0; i<matrix.length; i++) {
                if (mode == CONFIGENTO.MODE_NEXT_HEIGHER && parseFloat(matrix[i][0]) >= parseFloat(rowVal)) {
                    return i;
                }
                if (mode == CONFIGENTO.MODE_MATCH && matrix[i][0] === rowVal) {
                    return i;
                }
                if (mode == CONFIGENTO.MODE_NEXT_LOWER && parseFloat(matrix[i][0]) > parseFloat(rowVal)) {
                    if (i>0) return i-1;
                    return 0;
                }
            }
        }
    };
    /*
     * Calculate the internal value by evaluating the matrix
     */
    option.getValueFromMatrix = function(columnVal,rowVal) {
        var matrix = self.getCurrentMatrix();
        if (matrix && columnVal && rowVal) {
            var rowIndex = self.getMatchingRowIndexCustomValue(matrix, rowVal);
            var columnIndex = self.getMatchingColumnIndexCustomValue(matrix, columnVal);
            var value = "";
            if (rowIndex != undefined && columnIndex != undefined) {
                value = matrix[rowIndex][columnIndex];
            }
            return value;
        }
    };
    /*
     * Calculate the internal value by evaluating the matrix
     */
    option.calculate = function(preserveRender) {
        var matrix = self.getCurrentMatrix();
        if (matrix) {
            var rowValue = self.getMatrixValueSelectorRow();
            if (typeof self.getMatrixValueSelectorRow() == 'object') {
                rowValue =  self.getMatrixValueSelectorRow().getValue();
            }
            var columnValue = self.getMatrixValueSelectorColumn();
            if (typeof self.getMatrixValueSelectorColumn() == 'object') {
                columnValue = self.getMatrixValueSelectorColumn().getValue();
            }
            var value = 0;
            if (_.isArray(rowValue)) {
                jQuery.each(rowValue, function( index, rcValue ) {
                    rowIndex = self.getMatchingRowIndex(matrix, rcValue);
                    columnIndex = self.getMatchingColumnIndex(matrix);
                    if (rowIndex != undefined && columnIndex != undefined) {
                        if (jQuery.isNumeric(parseFloat(matrix[rowIndex][columnIndex])))
                            value += parseFloat(matrix[rowIndex][columnIndex]);
                    }
                });
            } else {
                var rowIndex = self.getMatchingRowIndex(matrix);
                var columnIndex = self.getMatchingColumnIndex(matrix);
                var value = "";
                if (rowIndex != undefined && columnIndex != undefined) {
                    value = matrix[rowIndex][columnIndex];
                }
            }
            if(self.setValue(value))
                self.updateValueInDom(preserveRender);
        }
    };

    return option;
};
var Justselling_Configento_Option_Type_Expression = function (configurator, group, internalId, title, label, params) {

    Justselling_Configento_Option_Abstract.call(this );
    params["bind_to_dom"] = false;

    this.init('expression', configurator, group, internalId, title, label, params);
    return this;
};

Justselling_Configento_Option_Type_Expression.prototype = new Justselling_Configento_Option_Abstract();


    Justselling_Configento_Option_Type_Expression.prototype.setCallback = function(callback) {
        this.callback = callback;
    };
    Justselling_Configento_Option_Type_Expression.prototype.getCallback = function() {
        return this.callback;
    };
    Justselling_Configento_Option_Type_Expression.prototype.setCallbackThis = function(callbackThis) {
        this.callbackThis = callbackThis;
    };
    Justselling_Configento_Option_Type_Expression.prototype.getCallbackThis = function() {
        return this.callbackThis;
    };
    Justselling_Configento_Option_Type_Expression.prototype.setChoice = function(choice) {
        this.choice = choice;
    };
    Justselling_Configento_Option_Type_Expression.prototype.getChoice = function() {
        return this.choice;
    };
    Justselling_Configento_Option_Type_Expression.prototype.addExpressionVariable = function (variable) {
        if (this.expressionVariable == null) {
            this.expressionVariable = [];
        }
        // ensure that variable is an object with certain properties.
        if(variable) {
            this.expressionVariable.push(variable);
        }
    };
    Justselling_Configento_Option_Type_Expression.prototype.getExpressionVariable = function () {
        return this.expressionVariable;
    };

    /*
     * Parse the given expression and check which options/variables are used
     * Register as child at this options to trigger calculate when option values are
     * being changed
     */
    Justselling_Configento_Option_Type_Expression.prototype.parse = function(expression) {
        var self = this;
        var configurator = self.getConfigurator();
        if (expression) {
            // var variables = expression.match(/\$\w+/g);
            // Matches field names with - _
            var variables = expression.match(/\${1,2}\w+[.]?[_]*\w*/g);
            variables = _.uniq(variables);
            for(var i=0; i<variables.length;i++) {
                var variable = variables[i];
                var title = variable.replace('$', '');
                // replace twice if we have a double $
                title = title.replace('$', '');
                var completeTitle = title;
                if (title.split('.').length > 1) {
                    title = title.split('.')[0];
                }
                var optionIndex = configurator.getOptionIndex(title);

                if (optionIndex >= 0) {
                    // save all varaibles found in expression
                    self.addExpressionVariable({title: completeTitle, optionIndex: optionIndex});

                    if (variable.substr(0, 2) !== '$$') {
                        configurator.options[optionIndex].addChild(self);
                    }
                }
                else {
                    // save the titles of the variables of the expression which could not add childs (parsing failed)
                    // the childs will be added  after all options has been rendered
                    var unparsedOption = {
                        optionIndex: self.arrayIndex,
                        childTitle:      title,
                        title: completeTitle
                    };
                    configurator.setUnparsedOption(unparsedOption);

                //    Justselling_Configento_App_Debug.addDebug("EXCEPTION: Trying to add a none existing child option | current option=" + this.getTitle() + " | child option=" + title, true);
                }
            }
        }
    };

    Justselling_Configento_Option_Type_Expression.prototype.parseExpressionTitle = function (title, fromObject, normalValue) {
        var retVal;
        if(_.isArray(title) && title.length > 1){
            switch (title[1]) {
                case 'price':
                    retVal = fromObject.getPrice();
                    break;
                case 'originalPrice':
                    retVal = fromObject.getOriginalPrice();
                    break;
                case 'qty' && !normalValue:
                    retVal = fromObject.getQty();
                    break;
            }
        }
        else {
            if(normalValue) {
                retVal = fromObject.getValue();
            }else {
                retVal = fromObject.getOriginalValue();
            }
        }
        return retVal;
    };

    /*
     * Prepare the expression before eval.
     * Replace all option-value variables (like $xxx, where xxx is value-title) with their current values
     */
    Justselling_Configento_Option_Type_Expression.prototype.prepare = function() {
         var self = this;
        var myExpression = self.myExpression;
        if (myExpression ) {
            var variables = self.expressionVariable;
            _.each(variables, function (expressionVarObj) {
                var title = expressionVarObj.title;
                var optionIndex = expressionVarObj.optionIndex;

                var variableRegex = new RegExp('\\${1,2}' + title + '(?!\\w)', 'g');
                var value;
                var currOption;

                var splittedTitle = title.split('.');
                currOption = this.configurator.options[optionIndex];
                if(currOption) {
                    value = self.parseExpressionTitle(splittedTitle, currOption, true);

                    if (!this.getIsCombi()) {
                        var activeChoice = currOption.getActiveChoice();
                        if (activeChoice instanceof Justselling_Configento_Option_Choice) {
                            value = self.parseExpressionTitle(splittedTitle, activeChoice);
                        }
                        else if (_.isArray(activeChoice)) {
                            value = _.map(activeChoice, function (choice) {
                                if(typeof choice === "string") {
                                    choice = this.getChoiceByValue(choice);
                                }
                                if(choice instanceof Justselling_Configento_Option_Choice){
                                    return self.parseExpressionTitle(splittedTitle, choice);
                                }
                            });
                        }
                    }
                }
                if (value == undefined || value == null || _.isNaN(value)) {
                    value = "''";
                }
                else {
                    if (typeof value.getOriginalValue === 'function') {
                        value = value.getOriginalValue();
                    }
                    if (_.isArray(value)) {
                        value = _.map(value, function (a) {
                            return '\'' + a + '\'';
                        });
                        value = '[' + value + ']';
                    }
                    else if (typeof value === "string" && /^\d+,\d+$/.test(value) && !isNaN(parseFloat(value.replace(/,/, '.')))) {
                            value = parseFloat(value.replace(/,/, '.'));
                    }
                    else if ((!jQuery.isNumeric(value) || /^0+(\d+|\w+)$/.test(value))) {
                            value = "'" + value + "'";
                    }
                }
                // Important in the expression statement: we have to work with array´s and not just values
                myExpression = myExpression.replace(variableRegex,  value);
            }, self);
            /* try to execute eval of expression, send only expression if you can execute it */
            try {
                eval(myExpression);
            } catch (e) {
                if (e instanceof SyntaxError) {
                    Justselling_Configento_App_Debug.addDebug("EXCEPTION evaluating expression "+self.getLabel()+": "+e.message, true);
                    Justselling_Configento_App_Debug.addDebug(e.message, true);
                    Justselling_Configento_App_Debug.addDebug(myExpression, true);
                    return false;
                }
            }
            return myExpression;
        }
        return false;
    };

    /*
     * Calculate the internal value by evaluating the expression
     */
    Justselling_Configento_Option_Type_Expression.prototype.calculate = function() {
        var self = this;
        // var myExpression = self.myExpression;
        var myExpression = self.prepare();
        var decimals = self.decimal;
        try {
            var result = eval(myExpression);
            if (result === true) {
                result = '1';
            }
            if (result === false ) { // || isNaN(result) || result == null
                result = '0';
            }
            /* if we have set decimals in template, set value by that */
            if (typeof decimals !== 'undefined' && !isNaN(result)) {
                result = parseFloat(result).toFixed(decimals);
            }
            if(self.setValue(result)) {
                if(self.getRule()){
                    var rule = self.getRule();
                    if(rule.getType() == CONFIGENTO.RULE_PREDEFINE_VALUE) {
                        self.getConfigurator().addToProcessList(rule);
                    }
                    else if(rule.getType() == CONFIGENTO.RULE_BLACKLIST) {
                        self.getConfigurator().setProcessBlacklistingRules(true);
                    }
                }
                self.setHasChanged(true);
                self.updateValueInDom(true);

                if (self.getCallback()) {
                    var fn = self.getCallback();
                    var fnThis = self.getCallbackThis();
                    if (typeof fn === 'function' && fnThis) {
                        fn.call(fnThis, "calculate", self);
                    }
                }
            }

        } catch (exception) {
            Justselling_Configento_App_Debug.addDebug("EXCEPTION evaluating expression "+self.getLabel()+": "+exception, true);
            Justselling_Configento_App_Debug.addDebug(exception, true);
            Justselling_Configento_App_Debug.addDebug(myExpression, true);
            self.setValue(0);
        }
    };

    Justselling_Configento_Option_Type_Expression.prototype.setRule = function(value) {
         var self = this;
        self.rule = value;
        if (value && Justselling_Configento_App_Debug.getDebugMode()) {
            /* Enable rules expressions if debug mode is active */
           // self.setIsVisible(true);
        }
    };
    Justselling_Configento_Option_Type_Expression.prototype.getRule = function() {
         var self = this;
        if (self.rule === undefined) {
            return false;
        }
        return self.rule;
    };
    Justselling_Configento_Option_Type_Expression.prototype.setIsCombi = function(value) {
         var self = this;
        self.isCombi = value;
        if (value && Justselling_Configento_App_Debug.getDebugMode()) {
            self.setIsVisible(true);
        }
    };
    Justselling_Configento_Option_Type_Expression.prototype.getIsCombi = function() {
         var self = this;
        if (self.isCombi === undefined) {
            return false;
        }
        return self.isCombi;
    };

var Justselling_Configento_Option_Type_Static = function(configurator, group, internalId, title, label, params) {

    var option = new Justselling_Configento_Option_Abstract();
    option.init("static", configurator, group, internalId, title, label, params);

    return option;
};

var Justselling_Configento_Option_Type_SaveButton = function(configurator, group, internalId, title, label, params) {

    var option = new Justselling_Configento_Option_Abstract();
    option.init("savebutton", configurator, group, internalId, title, label, params);
    var self  =option;
    self.clickHandlerApplied = false;

    self.setRedirectUrl = function (redirectUrl) {
        self.redirectUrl = redirectUrl;
    };
    self.getRedirectUrl = function () {
        return self.redirectUrl;
    };

    self.setPostUrl = function (postUrl) {
        self.postUrl = postUrl;
    };
    self.getPostUrl = function () {
        return self.postUrl;
    };


    self.renderAfter = function(key) {
        var $element = self.getDomElement();
        var $parentElement = self.getDomParentElement();

        var redirectTo;
        if(self.getRedirectUrl()) {
            redirectTo = function (assetId, assetFolder, assetType, assetFile) {
                var getParam = '';
                if(assetId){
                    getParam = '?asset_id='+assetId+"&asset_folder="+assetFolder+"&asset_type="+assetType+"&asset_file="+assetFile;
                }

                window.location.href = self.getRedirectUrl()+getParam;
            };
        }

        var configurator = option.getConfigurator();
        if ($element && $element.length == 1 && self.clickHandlerApplied == false ) {
            self.clickHandlerApplied = true;
            $parentElement.on('click', '#'+self.getId() ,function(e){
                e.preventDefault();
                /* do form validation */
                if (!Justselling_Configento_App_Wizard.validateForm()) {
                    return false;
                }

                // store clodeassets after all files has been uploaded
                jQuery('body').on('uploadQueueComplete', function (evt) {
                    var configBase64 = configurator.generateHeaderValue();
                    Justselling_Configento_App_CloudAsset.storeCloudAsset(configBase64, 'configData', redirectTo, self.getTitle(), self.getPostUrl());
                    jQuery(this).unbind(evt);
                });


                // There are files to upload, start uploading
                if(configurator.uploadQueueComplete === false) {
                    jQuery('body').trigger('processDoropzoneQueue');
                }
                // If no upload option or files were added or upload already complete trigger the storeassets immediately
                else {
                    jQuery('body').trigger('uploadQueueComplete');
                }

            });
        }
    };

    return option;
};

var Justselling_Configento_Option_Type_Attribute = function(configurator, group, internalId, title, label, params) {

    var option = new Justselling_Configento_Option_Abstract();
    params["bind_to_dom"] = false;
    option.init("attribute", configurator, group, internalId, title, label, params);
    var self = option;

    option.setAttributeKey = function(key) {
        self.attributeKey = key;
        var myValue = "";
        if (CONFIGENTO_PRODUCT.attribute && CONFIGENTO_PRODUCT.attribute instanceof Object) {
            myValue = CONFIGENTO_PRODUCT.attribute[key];
        }
        self.setValue(myValue);
    };

    return option;
};
var Justselling_Configento_Option_Type_Chart = function(configurator, group, internalId, title, label, params) {

    var option = new Justselling_Configento_Option_Abstract();
    option.init("chart", configurator, group, internalId, title, label, params);
    var self = option;

    self.chart = null;

    option.setChartType = function(chartType) {
        self.chartType = chartType;
    };
    option.getChartType = function() {
        return self.chartType;
    };
    option.setAutomaticUpdate = function(automaticUpdate) {
        self.automaticUpdate = automaticUpdate;
    };
    option.getAutomaticUpdate = function() {
        return self.automaticUpdate;
    };
    option.setChartLabel  = function(chartLabel){
        if (!jQuery.isArray(chartLabel)) {
            self.chartLabel = [chartLabel];
        }else {
            self.chartLabel = chartLabel;
        }
    };
    option.getChartLabel = function () {
       return self.chartLabel;
    };

    option.addChartSeries  = function(chartSeries){
        if (!jQuery.isArray(self.chartSeries)) {
            self.chartSeries = [];
        }
        // var must be array, if it´s no array make one
        if (!jQuery.isArray(chartSeries)) {
            chartSeries = [chartSeries];
        }
        self.chartSeries.push(chartSeries);
    };
    option.setChartSeries  = function(chartSeries){
        if (!jQuery.isArray(chartSeries)) {
            chartSeries = [[chartSeries]];
        }
        self.chartSeries = chartSeries;
    };
    option.setChartSeriesFromExpression  = function(){
        //Get current value form expression refered from own chart option -> expression title
        var seriesData =  self.getConfigurator().getOptionValue(self.getExpressionTitle());
        var chartSeries = self.getChartSeries();
        var chartLabel = self.getChartSeries();
        if(seriesData && JSON.stringify(seriesData.data) != JSON.stringify(chartSeries) && JSON.stringify(seriesData.label) != JSON.stringify(chartLabel) ) {
            self.setChartSeries(seriesData.data);
            self.setChartLabel(seriesData.label);
            return true;
        }
    };
    option.getChartSeries = function () {
       return self.chartSeries;
    };

    option.setExtraOptions  = function(extraOptions){
        self.extraOptions = extraOptions;
    };
    option.getExtraOptions = function () {
        if(!self.extraOptions) {
            self.extraOptions = "{}";
        }
        return self.extraOptions;
    };

    option.setResponsiveOptions  = function(responsiveOptions){
        self.responsiveOptions = responsiveOptions;
    };
    option.getResponsiveOptions = function () {
        if(!self.responsiveOptions) {
            self.responsiveOptions = "[]";
        }
        return self.responsiveOptions;
    };

    option.setOnDrawOptions  = function(onDrawOptions){
        self.onDrawOptions = onDrawOptions;
    };
    option.getOnDrawOptions = function () {
        if(!self.onDrawOptions) {
            self.onDrawOptions = "";
        }
        return self.onDrawOptions;
    };




    option.setExpressionTitle = function (chartExpressionTitle) {
       return self.chartExpressionTitle = chartExpressionTitle;
    };
    option.getExpressionTitle = function () {
       return self.chartExpressionTitle ;
    };

    option.setAspectRatio  = function(aspectRatio){
        self.aspectRatio = aspectRatio;
    };
    option.getAspectRatio = function () {
        if(self.aspectRatio == ''){
            // Default value is perfect fourth
            self.setAspectRatio('ct-perfect-fourth')
        }
       return self.aspectRatio;
    };

    option.createChart = function() {
        self.setChartSeriesFromExpression();

        var automaticUpdate = self.getAutomaticUpdate();
        if(automaticUpdate == 1 || automaticUpdate === '') {
            var expression = self.getConfigurator().getOption(self.getExpressionTitle());
            expression.setCallback(self.updateChart);
            expression.setCallbackThis(self);
        }


        var query ='#'+ option.getId();
        var data =  {
            labels: self.chartLabel,
            series: self.chartSeries
        };
        // type of object
        var options = eval(self.getExtraOptions());
        // type of array
        var responsiveOptions = eval(self.getResponsiveOptions());

        switch (self.getChartType()) {
            case 'bar':
                self.chart = new Chartist.Bar(query, data, options, responsiveOptions);
                break;
            case 'line':
                self.chart = new Chartist.Line(query, data, options, responsiveOptions);
                break;
            case 'pie':
                self.chart = new Chartist.Pie(query, data, options, responsiveOptions);
                break;
        }
        if(self.chart) {
            self.chart.on('draw', function(data) {
                eval(self.getOnDrawOptions());
                self.chartCreated = true;
                // Set aspect ratio of chart
                self.getDomElement().addClass(self.getAspectRatio());
            });
        }

        jQuery(document).on("configentoActiveGroupVisible", function () {
            var $element = self.getDomElement();
            var hideagain = false;
            var panel;
            if($element) {
                var panel = $element.closest('.r-tabs-panel');
                if(panel.is(':not(:visible)')) {
                    hideagain = true;
                    panel.addClass('displayBlock');
                }
            }
            self.updateChart();
            if(hideagain && panel) {
                panel.removeClass('displayBlock');
            }

        });

    };
    option.updateChart = function(){
        if(self.chartCreated) {
            self.setChartSeriesFromExpression();
            self.chart.update({
                labels: self.chartLabel,
                series: self.chartSeries
            });
            var $element = self.getDomElement();
            if($element) {
                var XMLS = new XMLSerializer();
                var svgChart = $element.find('svg.ct-chart-bar')[0];
                var svgString = XMLS.serializeToString(svgChart);

                self.setValue(svgString);
            }
        }
    };

    return option;
};

var Justselling_Configento_Option_Type_Fileupload = function(configurator, group, internalId, title, label, params) {

    var option = new Justselling_Configento_Option_Abstract();
    option.init("fileupload", configurator, group, internalId, title, label, params);

    var self = option;
    var dropzoneAttached = false;
    self.dropzoneConfig = {};

    option.addDropzoneConfig = function (key, val) {
        self.dropzoneConfig[key] = val;
    };
    option.getDropzoneConfig = function () {
        return self.dropzoneConfig;
    };
    option.setMinFiles = function (val) {
        self.minFiles= parseInt(val);
    };
    option.getMinFiles = function () {
        return self.minFiles;
    };
    option.getDropzone = function () {
        return self.dropzone;
    };

    option.renderAfter = function() {
        if(dropzoneAttached === false) {
            var $element = this.getDomElement();
            var dropzoneConfig = this.getDropzoneConfig();
            var configurator = this.getConfigurator();
            var fileName = this.getTitle();
            if(!dropzoneConfig.hasOwnProperty('url')) {
                dropzoneConfig.url = Justselling_Configento_App_CloudAsset.getBasePath() + "storeasset.php";
            }
            if(dropzoneConfig.hasOwnProperty('acceptedFiles')) {
                var split = dropzoneConfig.acceptedFiles.split(',');

                split = _.map(split, function(curr) {
                    if(curr.substr(0,1) != '.'){
                        curr = '.' + curr;
                    }
                    return curr;
                });
                dropzoneConfig.acceptedFiles = split.join(', ');
            }
            dropzoneConfig.autoProcessQueue = true;
            dropzoneConfig.parallelUploads = 1;
            dropzoneConfig.addRemoveLinks = true;
            dropzoneConfig.dictRemoveFile = '';
            dropzoneConfig.dictCancelUpload = '';
            dropzoneConfig.dictCancelUploadConfirmation = '';
            dropzoneConfig.dictDefaultMessage = Justselling_Configento_App_Translate.translate("Drop files here to upload");
            dropzoneConfig.dictFallbackMessage = Justselling_Configento_App_Translate.translate("Your browser does not support drag'n'drop file uploads.");
            dropzoneConfig.dictFallbackText = Justselling_Configento_App_Translate.translate("Please use the fallback form below to upload your files like in the olden days.");
            dropzoneConfig.dictFileTooBig = Justselling_Configento_App_Translate.translate("File is too big ({{filesize}}MiB). Max filesize = {{maxFilesize}}MiB.");
            dropzoneConfig.dictInvalidFileType = Justselling_Configento_App_Translate.translate("You can't upload files of this type.");
            dropzoneConfig.dictResponseError = Justselling_Configento_App_Translate.translate("Server responded with {{statusCode}} code.");
            dropzoneConfig.dictRemoveFileConfirmation = Justselling_Configento_App_Translate.translate(null);
            dropzoneConfig.dictMaxFilesExceeded = Justselling_Configento_App_Translate.translate("You can not upload any more files.");
            dropzoneConfig.params = {
                assetsType: 'uploadData',
                assetsFolder:  '/' + CONFIGENTO_PRODUCT.getCustomerId() + '/' + CONFIGENTO_PRODUCT.getTemplateId() + '/'
            };
            dropzoneConfig.init = function() {
                var dz = this;
                jQuery('body').on('processDoropzoneQueue', function () {
                    dz.processQueue();
                });
                this
                  /*
                .on("success", function(file) {
                    if(file.xhr.response) {
                        var result = JSON.parse(file.xhr.response);
                        if (file.type == "application/pdf") {
                            getPdfData(result['filelink']);
                        }
                        // Save assets ID to group assets of one user session
                        Justselling_Configento_App_CloudAsset.assetsID = result['id'];
                        Justselling_Configento_App_CloudAsset.assets.push({
                            type: result['type'],
                            folder: result['folder'],
                            id: result['id'],
                            file: result['file']
                        });
                    }
                })
                   */
               /* .on('error', function(file) {
                    if(file.xhr.response) {
                        var result = (file.xhr.response);
                        // Save assets ID to group assets of one user session
                    }
                })*/
                .on('complete', function(file) {
                    if (this.getQueuedFiles().length > 0 && file.accepted === true) {
                        this.processQueue();
                    } else {
                        var queuedFiles = this.getAcceptedFiles().length - this.getFilesWithStatus('error').length;
                        $element.attr('data-fileupload-files',  queuedFiles);
                        var validator = Justselling_Configento_App_Helper.getFormValidator();
                        if (validator) {
                            validator.revalidateField($element);
                        }
                        if(this.options.maxFiles && this.files.length > parseInt(this.options.maxFiles) && queuedFiles === parseInt(this.options.maxFiles) ) {
                            var noticeMsg = Justselling_Configento_App_Translate.translate('Max %s Files can be selected').replace('%s', this.options.maxFiles);
                            $element.parent().nextAll('.fv-help-block').show().text(noticeMsg);
                        }
                    }
                })
                .on("processing", function(file) {
                    if(Justselling_Configento_App_CloudAsset.assetsID != null && this.options.params.assetsId == null) {
                        this.options.params.assetsId = Justselling_Configento_App_CloudAsset.assetsID;
                    }
                    this.options.params.filename = fileName + '_' + Justselling_Configento_App_Helper.getUniqueId().substr(0,3);

                })
                .on('queuecomplete', function() {
                    console.log('queuecomplete');
                    jQuery('body').trigger('uploadQueueComplete');
                    configurator.uploadQueueComplete = true;
                })
                .on('addedfile', function () {
                    // We assume the newly added file should is valid, if not the the complete event will be fired and newly calculated
                    var queuedFiles = this.getAcceptedFiles().length + 1 - this.getFilesWithStatus('error').length;
                    $element.attr('data-fileupload-files',  queuedFiles);
                    var validator = Justselling_Configento_App_Helper.getFormValidator();
                    if (validator) {
                        validator.revalidateField($element);
                    }
                    configurator.uploadQueueComplete = false;
                })
                .on('removedfile', function () {
                    var queuedFiles = this.getAcceptedFiles().length - this.getFilesWithStatus('error').length;
                    $element.attr('data-fileupload-files',  queuedFiles);
                    var validator = Justselling_Configento_App_Helper.getFormValidator();
                    if (validator) {
                        validator.revalidateField($element);
                    }

                });
            };

            dropzoneAttached = this.getDomElement().dropzone(dropzoneConfig);
            this.dropzone = dropzoneAttached;
        }
    };
    return option;
};

var Justselling_Configento_Option_Type_Webservice = function(configurator, group, internalId, title, label, params) {

    var option = new Justselling_Configento_Option_Abstract();
    option.init("webservice", configurator, group, internalId, title, label, params);
    var self  =option;
    self.clickHandlerApplied = false;

    self.setWebserviceUrl = function (webserviceUrl) {
        self.webserviceUrl = webserviceUrl;
    };
    self.getWebserviceUrl = function () {
        return self.webserviceUrl;
    };

    self.setWebserviceReturnType = function (webserviceReturnType) {
        self.webserviceReturnType = webserviceReturnType;
    };
    self.getWebserviceReturnType = function () {
        return self.webserviceReturnType;
    };

    self.setWebservicePath = function (webservicePath) {
        self.webservicePath = webservicePath;
    };
    self.getWebservicePath = function () {
        return self.webservicePath;
    };
    self.setValueFromWebserviceUrl = function () {
        //var cloudCallApiUrl = 'http://127.0.0.1/js_admin/data/callApi.php';
        var cloudCallApiUrl = Justselling_Configento_App_Helper.getCloudBase() + 'data/callApi.php';
        var path = self.getWebservicePath();
        var returnType  = self.getWebserviceReturnType();
        var data = {
            url: self.getWebserviceUrl()
        };
        jQuery.ajax({
            type: "POST",
            url: cloudCallApiUrl,
            data: data
        }).done(function(data) {
            var result;
            if(returnType === 'xml') {
                var doc = new DOMParser().parseFromString(data, 'text/xml');
                result = doc.evaluate(path, doc, null, XPathResult.STRING_TYPE, null);
                result = result.stringValue;
            }
            else if(returnType === 'json'){
                result = JSON.parse(data);
                result = jsonPath(result, path);
            }

            self.setValue(result);
            if (self.getIsRendered()) {
                self.updateValueInDom();
            }
        }).fail(function(data) {

            console.log(data);
        });
    };
    return option;
};

var Justselling_Configento_Option_Type_Package = function(configurator, group, internalId, title, label, params) {

    var active = false;
    var packagePrice = 0;
    var option = new Justselling_Configento_Option_Abstract();

    option.getPrice = function() {
        if (!this.getActive()) return 0;
        return this.packagePrice;
    };
    option.getPackagePrice = function() {
        return this.packagePrice;
    };
    option.setActive = function(value) {
        this.active = value;
        if (value) this.selectPackageOptions();
        if (!value) this.deSelectPackageOptions();
        this.setHasChanged(true);
    };
    option.getActive = function() {
        return this.active;
    };
    option.selectPackageOptions = function() {
        var self = this;
        _.each(this.packageOptions, function (packageOption) {
            var configurator = self.getConfigurator();
            var option = configurator.getOption(packageOption.alt_title);

            _.each(packageOption.availableChoices, function (choiceId) {
                var choice = option.getChoiceByInternalId(choiceId);
                if (!choice.getIsBlacklisted()) {
                    choice.setIsActiveByPackage(self.getInternalId());

                    switch (option.getType()) {
                        case 'checkbox':
                        case 'multiselect':
                            option.addActiveChoice(choice);
                            break;
                        case 'radiobutton':
                        case 'select':
                        case 'thumb':
                        case 'selectcombi':
                        default:
                            option.setActiveChoice(choice);
                            break;
                    }
                }
            });
        });
    };
    option.deSelectPackageOptions = function() {
        var self = this;
        _.each(this.packageOptions, function (packageOption) {
            var configurator = self.getConfigurator();
            var option = configurator.getOption(packageOption.alt_title);

            _.each(packageOption.availableChoices, function (choiceId) {
                var choice = option.getChoiceByInternalId(choiceId);
                choice.setIsActiveByPackage(false);
                option.removeActiveChoice(choice);
            });
            if (!option.activeChoice && option.defaultValue) option.setDefaultValue(option.defaultValue, true);
        });
    };
    option.getAllChoices = function(filter) {
        var choices = [];
        var configurator = this.getConfigurator();
        _.each(this.getPackageOptions(), function (packageOption) {
            var option = configurator.getOption(packageOption.alt_title);
            _.each(packageOption.availableChoices, function (choiceId) {
                var choice = option.getChoiceByInternalId(choiceId);
                var isBlacklisted = choice.getIsBlacklisted();
                if ((filter == undefined && !choice.getIsBlacklisted()) || filter)
                    choices.push(choice);
            });
        });
        return choices;
    },
    option.getAllActiveChoices = function() {

    }
    option.getPackageOptions = function() {
            return this.packageOptions;
    };
    option.setPackageOptions = function(value) {
        this.packageOptions = value;
    };

    option.getLayerPosition = function(id) {
        var layer_position = 0;
        _.each(this.group.options, function (op) {
            if (op.id == id) {
                layer_position = op.layer_position;
                return layer_position;
            }
        });
        return layer_position;
    };

    option.setValue(false, true);
    option.active = false;
    if (params['package_price']) option.packagePrice = params['package_price'];
    option.init("package", configurator, group, internalId, title, label, params);

    return option;
};

var Justselling_Configento_Option_Choice = function (option, label, value, price, thumb, isEmpty, internalId, sortOrder) {

    this.minQty = 0;
    this.maxQty = 0;
    this.init(option, label, value, price, thumb, isEmpty, internalId, sortOrder);
    return this;
};
Justselling_Configento_Option_Choice.prototype.init = function (option, label, value, price, thumb, isEmpty, internalId, sortOrder) {

    this.internalId = (internalId);
    this.label = (label);
    this.value = (value);
    this.originalValue = (value);
    this.price = (price);
    this.thumb = (thumb);
    this.isEmptyChoice = (isEmpty);
    this.sortOrder = (sortOrder);
    this.isActiveByPackage = false;
    this.articleValue = '';

    /* register the new choice in option object */
    this.option = (option);
    this.arrayIndex = (option.addChoice(this));

    var id = option.id
        + "-" + Justselling_Configento_App_Helper.getIdFromLabel(label)
        + "-" + this.arrayIndex;
    this.id = (id);

    option.choiceIdToIndex[id] = this.arrayIndex;
    option.addChoiceAfter(this);
};

/*
 * Getter and Setter for the internal varibales
 */
Justselling_Configento_Option_Choice.prototype.setIsEmptyChoice = function (value) {
    this.isEmptyChoice = value;
};
Justselling_Configento_Option_Choice.prototype.getIsEmptyChoice = function () {
    return this.isEmptyChoice;
};
Justselling_Configento_Option_Choice.prototype.setSortOrder = function (value) {
    this.sortOrder = value;
};
Justselling_Configento_Option_Choice.prototype.getSortOrder = function () {
    return this.sortOrder;
};
Justselling_Configento_Option_Choice.prototype.setIsActiveByPackage = function (value) {
    this.isActiveByPackage = value;
};
Justselling_Configento_Option_Choice.prototype.getIsActiveByPackage = function () {
    return this.isActiveByPackage;
};
Justselling_Configento_Option_Choice.prototype.setIsDisabled = function (value) {
    if(this.isDisabled === value) {
        return;
    }
    var domEl = this.getDomElement();

    /* this is used to prevent click on image picker if is disabled e.g. part of packages */
    if (typeof domEl !== 'undefined') {
        var getIds = jQuery(domEl[0]).attr('id');
        if (value) {
            jQuery('#' + getIds).parent().parent().addClass('prevent-click');
        } else {
            jQuery('#' + getIds).parents('.show-choice-hide').removeClass('prevent-click');
            jQuery('#' + getIds).parent().parent().removeClass('prevent-click');
        }
    }

    if(domEl) {
        domEl.prop('disabled', value);
        if(value) {
            var self = this;
            var parOption = this.getOption();
            var activeChoice = parOption.getActiveChoice() || [];
            var activeValue = parOption.getValue() || [];

            if (activeChoice instanceof Justselling_Configento_Option_Choice) {
                activeChoice = [activeChoice]
            }
            activeChoice = _.filter(activeChoice, function (actCh) {
                return ! (actCh.id == self.id);
            });
            if(activeChoice.length === 1) {
                activeChoice = activeChoice[0];
            }
            parOption.setActiveChoice(activeChoice);


            if(!_.isArray(activeValue)) {
                activeValue = [activeValue];
            }
            activeValue = _.filter(activeValue, function (actVal) {
                return ! (actVal == self.value);
            });
            if(activeValue.length === 1) {
                activeValue = activeValue[0];
            }
            parOption.setValue(activeValue);


        }
    }
    this.isDisabled = value;
};
Justselling_Configento_Option_Choice.prototype.getIsDisabled = function () {
    return this.isDisabled;
};
Justselling_Configento_Option_Choice.prototype.setChoiceGroup = function (value) {
    this.choiceGroup = value;
};
Justselling_Configento_Option_Choice.prototype.getChoiceGroup = function () {
    return this.choiceGroup;
};
Justselling_Configento_Option_Choice.prototype.setOption = function (option) {
    this.option = option;
};
Justselling_Configento_Option_Choice.prototype.getOption = function () {
    return this.option;
};
Justselling_Configento_Option_Choice.prototype.setId = function (id) {
    this.id = id;
};
Justselling_Configento_Option_Choice.prototype.getId = function () {
    return this.id;
};
Justselling_Configento_Option_Choice.prototype.setArrayIndex = function (arrayIndex) {
    this.arrayIndex = arrayIndex;
};
Justselling_Configento_Option_Choice.prototype.getArrayIndex = function () {
    return this.arrayIndex;
};
Justselling_Configento_Option_Choice.prototype.getTitle = function () {
    return this.id;
};
Justselling_Configento_Option_Choice.prototype.setInternalId = function (internalId) {
    this.internalId = String(internalId);
};
Justselling_Configento_Option_Choice.prototype.getInternalId = function () {
    return this.internalId;
};
Justselling_Configento_Option_Choice.prototype.setLabel = function (label) {
    this.label = label;
};
Justselling_Configento_Option_Choice.prototype.getLabel = function () {
    return this.label;
};
Justselling_Configento_Option_Choice.prototype.setOriginalValue = function (value) {
    this.originalValue = value;
};
Justselling_Configento_Option_Choice.prototype.getOriginalValue = function () {
    return this.originalValue;
};
Justselling_Configento_Option_Choice.prototype.setValue = function (value) {
    this.value = value;
};
Justselling_Configento_Option_Choice.prototype.getValue = function () {
    return this.value;
};
Justselling_Configento_Option_Choice.prototype.setPrice = function (price) {
    this.price = price;
};
Justselling_Configento_Option_Choice.prototype.getPrice = function () {
    if (this.isActiveByPackage) return 0;
    var price = this.price;

    if (this.getExpression()) {
        price = parseFloat(this.getValue()) * parseFloat(price);
    }
    // Multiply price with qty, if qty was set
    if (this.getQty()) {
        price = price * this.getQty();
    }
    // if price is null, than set it to 0, to avoid NaN
    if (price == null) price = 0;
    return parseFloat(price);
};
Justselling_Configento_Option_Choice.prototype.getOriginalPrice = function () {
    var price = this.price;

    if (this.getExpression()) {
        price = parseFloat(this.getValue()) * parseFloat(price);
    }
    return price;
};
Justselling_Configento_Option_Choice.prototype.setMinQty = function (val) {
    this.minQty = parseInt(val);
};
Justselling_Configento_Option_Choice.prototype.getMinQty = function () {
    return this.minQty;
};
Justselling_Configento_Option_Choice.prototype.setMaxQty = function (val) {
    this.maxQty = parseInt(val);
};
Justselling_Configento_Option_Choice.prototype.getMaxQty = function () {
    return this.maxQty;
};
Justselling_Configento_Option_Choice.prototype.setQty = function (val) {
    val = parseInt(val);
    if (this.qty !== val) {
        var option = this.getOption();
        option.setQtyChanged(true);
    }
    this.qty = val;
};
Justselling_Configento_Option_Choice.prototype.getQty = function () {
    return this.qty;
};
Justselling_Configento_Option_Choice.prototype.setThumb = function (thumb) {
    this.thumb = thumb;
};
Justselling_Configento_Option_Choice.prototype.getThumb = function () {
    return this.thumb;
};
Justselling_Configento_Option_Choice.prototype.setImage = function (image) {
    this.image = image;
};
Justselling_Configento_Option_Choice.prototype.getImage = function () {
    return this.image;
};
Justselling_Configento_Option_Choice.prototype.setImageWidth = function (imageWidth) {
    this.imageWidth = imageWidth;
};
Justselling_Configento_Option_Choice.prototype.getImageWidth = function () {
    return this.imageWidth;
};
Justselling_Configento_Option_Choice.prototype.setImageHeight = function (imageHeight) {
    this.imageHeight = imageHeight;
};
Justselling_Configento_Option_Choice.prototype.getImageHeight = function () {
    return this.imageHeight;
};
Justselling_Configento_Option_Choice.prototype.setImageTop = function (top) {
    this.imageTop = top;
};
Justselling_Configento_Option_Choice.prototype.getImageTop = function () {
    if (this.imageTop == null) {
        this.setImageTop(0);
    }
    return this.imageTop;
};
Justselling_Configento_Option_Choice.prototype.setImageLeft = function (left) {
    this.imageLeft = left;
};
Justselling_Configento_Option_Choice.prototype.getImageLeft = function () {
    if (this.imageLeft == null) {
        this.setImageLeft(0);
    }
    return this.imageLeft;
};
Justselling_Configento_Option_Choice.prototype.setThumbWidth = function (value) {
    this.thumbWidth = value;
};
Justselling_Configento_Option_Choice.prototype.getThumbWidth = function () {
    return this.thumbWidth;
};

Justselling_Configento_Option_Choice.prototype.setGroupLayer = function (value) {
    this.groupLayer = value;
};
Justselling_Configento_Option_Choice.prototype.getGroupLayer = function () {
    return this.groupLayer;
};

Justselling_Configento_Option_Choice.prototype.setLayerPosition = function (value) {
    this.layerPosition = value;
};
Justselling_Configento_Option_Choice.prototype.getLayerPosition = function () {
    return this.layerPosition;
};

Justselling_Configento_Option_Choice.prototype.setThumbHeight = function (value) {
    this.thumbHeight = value;
};
Justselling_Configento_Option_Choice.prototype.getThumbHeight = function () {
    return this.thumbHeight;
};
Justselling_Configento_Option_Choice.prototype.setInfoText = function (value) {
    this.infoText = value;
};
Justselling_Configento_Option_Choice.prototype.getInfoText = function () {
    if (this.isBlacklisted) {
        return Justselling_Configento_App_Helper.getInfoTextForBlacklistedChoice(this);
    }
    return this.infoText;
};

Justselling_Configento_Option_Choice.prototype.setInfoTextAdditional = function (value) {
    this.additionalInfo = value;
};
Justselling_Configento_Option_Choice.prototype.getInfoTextAdditional = function () {
    return this.additionalInfo;
};
Justselling_Configento_Option_Choice.prototype.setSku = function (val) {
    this.sku = val;
};
Justselling_Configento_Option_Choice.prototype.getSku = function () {
    return this.sku;
};

Justselling_Configento_Option_Choice.prototype.setExpression = function (expression) {
    this.myExpression = expression;
};
Justselling_Configento_Option_Choice.prototype.getExpression = function () {
    return this.myExpression;
};
Justselling_Configento_Option_Choice.prototype.getCustomFields = function() {
    var self = this;
    if (!self.customFields) return false;

    var configurator = this.getOption().getConfigurator();
    var customFieldsConfig = configurator.getConfig("customFields");
    if (customFieldsConfig && customFieldsConfig.choices) {
        _.each(self.customFields, function (custom_field, key) {
            var myTitle = null;
            var myKey = null;
            _.each(customFieldsConfig.choices, function (config) {
                if (config.id == key) {
                    myTitle = config.name;
                    myKey = key;
                }
            });
            if (self.customFields[myKey]) {
                self.customFields[myKey].title = myTitle;
                var id = Justselling_Configento_App_Helper.getIdFromLabel(myTitle)
                self.customFields[myKey].id = id;
            }
        });
        return self.customFields;
    }
    return false;
};
Justselling_Configento_Option_Choice.prototype.setBlacklistStatusHasChanged = function (value) {
    this.blacklistStatusHasChanged = value;
};
Justselling_Configento_Option_Choice.prototype.getBlacklistStatusHasChanged = function () {
    return this.blacklistStatusHasChanged;
};
Justselling_Configento_Option_Choice.prototype.setIsBlacklisted = function (value) {
    if (this.isBlacklisted == value) {
        return false;
    }
    var option = this.option;
    this.isBlacklisted = value;
    this.blacklistStatusHasChanged = true;
    option.hasChanged = true;

    // if choice should be blacklisted
    if (value) {
        // Get selected active Choice of option
        var activeChoice = option.getActiveChoice();
        // If a choice exists and active choice matches the current element
        if (activeChoice instanceof Justselling_Configento_Option_Choice && this.id === activeChoice.id) {
            // Set to default option if current active option is blacklisted
            var defaultValue = option.getDefaultValue();
            if(defaultValue === null) {
                defaultValue = '';
            }
            var activeChoice = option.getChoiceByValue(defaultValue);
            option.setActiveChoice(activeChoice);
            // set value of option to 0 and recalculate product price
            option.setValue(defaultValue);
        }
        else if (Object.prototype.toString.call(activeChoice) === '[object Array]') {
            // filter all choices which are
            activeChoice = _.filter(activeChoice, function (choice) {
                if (this.getId() === choice.getId()) {
                    choice = false;
                }
                return choice;
            }, this); 
            var activeChoiceValue = null;
            var optionValue = '';
            if (activeChoice.length > 0) {
                activeChoiceValue = activeChoice;
                optionValue = _.map(activeChoice, function (choice) {
                    return choice.getValue();
                });
            }
            // TODO: if all active choices are deselected
            option.setActiveChoice(activeChoiceValue);
            option.setValue(optionValue);

            /* collect indexes of options that are blacklisted */
            var optionActiveChoice = option.getActiveChoice();
            var collectIndexes = [];
            _.each(optionActiveChoice, function (act, key) {
                if (act.isBlacklisted) {
                   collectIndexes.push(key);
                }
            });

            /* remove from active choice options that are blacklisted */
            while(collectIndexes.length) {
                option.activeChoice.splice(collectIndexes.pop(), 1);
            }
        }
    }
};

/*  this.setIsBlacklisted1 = function(value) {
 if (this.isBlacklisted == value) {
 return false;
 }
 var option = this.getOption();

 this.isBlacklisted = value;
 this.setBlacklistStatusHasChanged(true);
 option.setHasChanged(true);

 // if choice should be blacklisted
 if(value) {
 // Get selected active Choice of option
 var activeChoice = option.getActiveChoice();
 // If a choice exists and active choice matches the current element
 if (activeChoice instanceof Justselling_Configento_Option_Choice && this.getId() == activeChoice.getId()) {
 // Set value of  dropdown to null
 option.setActiveChoice(option.getChoiceByValue(''));
 // set value of option to 0 and recalculate product price
 option.setValue('');
 }
 else if (_.isArray(activeChoice)) {
 activeChoice =  _.filter(activeChoice, function (choice) {
 if(this.getId() === choice.getId()) {
 choice = false;
 }
 return choice;
 });
 var activeChoiceValue = null;
 var optionValue = '';
 if(activeChoice.length > 0) {
 activeChoiceValue = activeChoice;
 optionValue =  _.map(activeChoice, function (choice) {
 return choice.getValue();
 });
 }
 option.setActiveChoice(activeChoiceValue);
 option.setValue(optionValue);
 }
 }
 // Choice is visible again
 else {
 var defaultValue = null;
 // Get default value of option
 if (option.getDefaultValue() instanceof Justselling_Configento_Option_Choice) {
 defaultValue = option.getDefaultValue().getValue();
 } else {
 defaultValue = option.getDefaultValue();
 }
 // default value of option matches whitelisted choice
 // -> need to set option´s active choice and value to values of default choice
 // Notice: is important due to rerendering of option, the default option is being selected,
 // but values stayed old
 if (this.getValue() === defaultValue) {
 option.setActiveChoice(this);
 option.setValue(defaultValue);

 }
 }
 };*/
Justselling_Configento_Option_Choice.prototype.getIsBlacklisted = function () {
    if (this.isBlacklisted == undefined) return false;
    return this.isBlacklisted;
};
Justselling_Configento_Option_Choice.prototype.getDomElement = function () {
    if (!this.$domElement || this.$domElement.length != 1) {
        this.$domElement = jQuery("#" + this.getId());
    }
    return this.$domElement;
};


var Justselling_Configento_Rules_Rule = function (configurator, condition, type, dependencies, label, extraConfig, dateRestrictions) {
    this.init(configurator, condition, type, dependencies, label, extraConfig, dateRestrictions);
    return this;
};

Justselling_Configento_Rules_Rule.prototype.init = function (configurator, condition, type, dependencies, label, extraConfig, dateRestrictions) {
    var ruleId = Justselling_Configento_App_Helper.getRuleId();
    var id = configurator.getId() + ruleId;
    this.setId(id);
    this.setInternalId(ruleId);
    this.setConfigurator(configurator);
    this.setCondition(condition);
    this.setType(type);
    this.setDependencies(dependencies);
    this.setLabel(label);
    this.setExtraConfig(extraConfig);
    this.setDateRestrictions(dateRestrictions);

    this.setArrayIndex(configurator.addRule(this));

    var params = {};
    params["is_visible"] = false;
    var expression = new Justselling_Configento_Option_Type_Expression(configurator, null, ruleId + 'R', 'rule' + this.getId(), 'Rule Expression ' + this.getLabel(), params);
    expression.setExpression(condition);
    expression.setRule(this);
    expression.calculate();
    this.setExpression(expression);

};

/*
 * Getter and Setter for the internal variables
 */
Justselling_Configento_Rules_Rule.prototype.setConfigurator = function (configurator) {
    this.configurator = configurator;
};
Justselling_Configento_Rules_Rule.prototype.getConfigurator = function () {
    return this.configurator;
};
Justselling_Configento_Rules_Rule.prototype.setId = function (tagId) {
    this.id = tagId;
};
Justselling_Configento_Rules_Rule.prototype.getId = function () {
    return this.id;
};
Justselling_Configento_Rules_Rule.prototype.setArrayIndex = function (index) {
    this.ruleIndex = index;
};
Justselling_Configento_Rules_Rule.prototype.getArrayIndex = function () {
    return this.ruleIndex;
};
Justselling_Configento_Rules_Rule.prototype.setInternalId = function (internalId) {
    this.internalId = internalId;
};
Justselling_Configento_Rules_Rule.prototype.getInternalId = function () {
    return this.internalId;
};
Justselling_Configento_Rules_Rule.prototype.setLabel = function (label) {
    this.label = label;
};
Justselling_Configento_Rules_Rule.prototype.getLabel = function () {
    return this.label;
};
Justselling_Configento_Rules_Rule.prototype.setExtraConfig = function (extraConfig) {
    this.extraConfig = extraConfig;
};
Justselling_Configento_Rules_Rule.prototype.getExtraConfig = function () {
    return this.extraConfig;
};
Justselling_Configento_Rules_Rule.prototype.setDateRestrictions = function (dateRestriction) {
    this.dateRestriction = dateRestriction;
};
Justselling_Configento_Rules_Rule.prototype.getDateRestrictions = function () {
    return this.dateRestriction;
};
Justselling_Configento_Rules_Rule.prototype.setCondition = function (condition) {
    this.condition = condition;
};
Justselling_Configento_Rules_Rule.prototype.getCondition = function () {
    return this.condition;
};
Justselling_Configento_Rules_Rule.prototype.setType = function (type) {
    this.type = type;
};
Justselling_Configento_Rules_Rule.prototype.getType = function () {
    return this.type;
};
Justselling_Configento_Rules_Rule.prototype.setDependencies = function (dependencies) {
    this.dependencies = dependencies;
};
Justselling_Configento_Rules_Rule.prototype.getDependencies = function () {
    return this.dependencies;
};
Justselling_Configento_Rules_Rule.prototype.setExpression = function (expression) {
    this.expression = expression;
};
Justselling_Configento_Rules_Rule.prototype.getExpression = function () {
    return this.expression;
};
Justselling_Configento_Rules_Rule.prototype.getExpressionApplied = function () {
    return this.expressionApplied;
};
Justselling_Configento_Rules_Rule.prototype.setExpressionApplied = function (bool) {
    this.expressionApplied = bool;
};
Justselling_Configento_Rules_Rule.prototype.getIgnore = function () {
    return this.ignore;
};
Justselling_Configento_Rules_Rule.prototype.setIgnore = function (bool) {
    this.ignore = bool;
};

Justselling_Configento_Rules_Rule.prototype.addErrorMessageVariable = function (variable) {
    if (this.messageVariable == null) {
        this.messageVariable = [];
    }
    // ensure that variable is an object with certain properties.
    if(variable) {
        this.messageVariable.push(variable);
    }
};

Justselling_Configento_Rules_Rule.prototype.parseVariables = function(errorMessage) {
    var self = this;
    var configurator = self.getConfigurator();
    if (errorMessage) {
        // var variables = errorMessage.match(/\$\w+/g);
        // Matches field names with - _
        var variables = errorMessage.match(/\${1,2}\w+[.]?[_]*\w*/g);
        variables = _.uniq(variables);
        for(var i=0; i<variables.length;i++) {
            var variable = variables[i];
            var title = variable.replace('$', '');
            // replace twice if we have a double $
            title = title.replace('$', '');
            var completeTitle = title;
            if (title.split('.').length > 1) {
                title = title.split('.')[0];
            }
            var optionIndex = configurator.getOptionIndex(title);

            if (optionIndex >= 0) {
                // save all varaibles found in expression
                self.addErrorMessageVariable({title: completeTitle, optionIndex: optionIndex});

                if (variable.substr(0, 2) !== '$$') {
                    configurator.options[optionIndex].addChild(self);
                }
            }
            else {
                console.log('!!! Error Message Variable not found: ' + title);
            }
        }
    }
};

Justselling_Configento_Rules_Rule.prototype.parseErrorMessageTitle = function (title, fromObject, normalValue) {
    var retVal;
    if(_.isArray(title) && title.length > 1){
        switch (title[1]) {
            case 'price':
                retVal = fromObject.getPrice();
                break;
            case 'originalPrice':
                retVal = fromObject.getOriginalPrice();
                break;
            case 'qty' && !normalValue:
                retVal = fromObject.getQty();
                break;
        }
    }
    else {
        if(normalValue) {
            retVal = fromObject.getValue();
        }else {
            retVal = fromObject.getOriginalValue();
        }
    }
    return retVal;
};
Justselling_Configento_Rules_Rule.prototype.prepare = function(errorMessage) {
    var self = this;
        var variables = self.messageVariable;
        _.each(variables, function (errorMessageVarObj) {
            var title = errorMessageVarObj.title;
            var optionIndex = errorMessageVarObj.optionIndex;

            var variableRegex = new RegExp('\\${1,2}' + title + '(?!\\w)', 'g');
            var value;
            var currOption;

            var splittedTitle = title.split('.');
            currOption = this.configurator.options[optionIndex];
            if(currOption) {
                value = self.parseErrorMessageTitle(splittedTitle, currOption, true);
            }
            if (value == undefined || value == null || _.isNaN(value)) {
                value = "''";
            }
            else {
                if (typeof value.getOriginalValue === 'function') {
                    value = value.getOriginalValue();
                }
                if (_.isArray(value)) {
                    value = _.map(value, function (a) {
                        return '\'' + a + '\'';
                    });
                    value = '[' + value + ']';
                }
                else if (typeof value === "string" && /^\d+,\d+$/.test(value) && !isNaN(parseFloat(value.replace(/,/, '.')))) {
                    value = parseFloat(value.replace(/,/, '.'));
                }
                else if ((!jQuery.isNumeric(value) || /^0+(\d+|\w+)$/.test(value))) {
                    value = "'" + value + "'";
                }
            }
            errorMessage = errorMessage.replace(variableRegex,  '<span class="pc__message-variable-value">' + value + '</span>');
        }, self);
        return errorMessage;
};


Justselling_Configento_Rules_Rule.prototype.getErrorPopupHtml = function (type, message, execute) {

    var template;
    var source = Justselling_Configento_App_Helper.$template.find('#pc__error-rule-template').html();
    if (source) {
        template = Handlebars.compile(source);

        var context = {
            expressionTitle: 'rule' + this.getId(),
            title: Justselling_Configento_App_Translate.translate('error_popup'),
            cancel: Justselling_Configento_App_Translate.translate('cancel'),
            type: type
        };
        if(type === "warning") {
            if(execute === "cart") {
                context.proceed = Justselling_Configento_App_Translate.translate('proceed');
            }
            context.title = Justselling_Configento_App_Translate.translate('warning_popup');
        }

        return template(context);
    }
};

Justselling_Configento_Rules_Rule.prototype.getCurrentState = function () {
    if (typeof this.getExpression() == 'object') {
        return this.getExpression().getValue();
    }
    return false;
};

Justselling_Configento_Rules_Rule.prototype.process = function (updateDependencyOption, errorExecution) {
    var self = this;
    var condition = self.getType() ? parseInt(self.getType()) : 0;

    if (self.getType() === CONFIGENTO.RULE_ERROR) {
        Justselling_Configento_App_Helper.setErrorPopupMessage('', '');
    }

    if (this.getCurrentState() == true) {
        if (condition === CONFIGENTO.RULE_BLACKLIST) {
            _.each(self.getDependencies(), function (dependency) {
                if (dependency.optiontype == 'static') {
                    if ((dependency.value == null) && dependency.defaultValue) {
                        dependency.value = dependency.defaultValue;
                    }
                }
            });
            for (var i = 0; i < self.dependencies.length; i++) {
                self.getConfigurator().addItemToBlacklist(self.dependencies[i]);
            }

            var date_restrictions = self.getDateRestrictions();
            if(date_restrictions !== undefined) {
                for(var oId in date_restrictions) {
                    var option = this.getConfigurator().getOptionByInternalId(oId);
                    if(option !== false) {
                        for(var i = 0; i < date_restrictions[oId].length; i++) {
                            option.addDateRestriction(date_restrictions[oId][i]);
                        }
                    }
                }
            }
        }
        else if (self.getType() === CONFIGENTO.RULE_ERROR && self.getIgnore() !== true) {
            var error = self.getExtraConfig();
            if (error.execute === "wizard") {
                if(self.messageVariable == null) {
                    self.parseVariables(error.message);
                }
                var message = self.prepare(error.message);
                // GET Html element of popup with values
                var popupHtml = self.getErrorPopupHtml(error.type, message, error.execute);
                var indexGroup = Justselling_Configento_App_Helper.getConfigurator().getActiveGroup().getIndex();
                Justselling_Configento_App_Helper.setErrorPopupMessage(popupHtml, message, error.execute, indexGroup);

                if (Justselling_Configento_App_Helper.getErrorPopupMessageHelper() !== message) {
                    Justselling_Configento_App_Helper.setErrorPopupMessageHelper(message);
                    Justselling_Configento_App_Helper.setErrorPopupMessageHelperIndex(indexGroup);
                    Justselling_Configento_App_Helper.setErrorMessageHelperHtml(popupHtml);
                }
                return true;
            }
            // Execute only uf Expression is nit applied and the given execution type matches or rule is an error and add to cart was triggered
            if (((!self.getExpressionApplied() && error.execute === "directly") || errorExecution === "cart")  && (error.type === "error" || error.type === "warning") ) {
                if(self.messageVariable == null) {
                    self.parseVariables(error.message);
                }
                var message = self.prepare(error.message);
                // GET Html element of popup with values
                var popupHtml = self.getErrorPopupHtml(error.type, message, error.execute);
                var $popupHtmlContainer = jQuery('#pc__error-rule');
                // Create Popupbox if it´s not found in DOM
                if($popupHtmlContainer.length === 0) {
                    $popupHtmlContainer = jQuery('<div id="pc__error-rule"></div>');
                    jQuery('body').append($popupHtmlContainer);

                    $popupHtmlContainer.on('click', '.pc__popup-close, .pc__popup-cancel', function () {
                        jQuery('#pc__error-rule').fadeOut(400);
                        self.setExpressionApplied(false);
                    }).on('click', '.pc__popup-proceed', function () {
                        jQuery('#pc__error-rule').fadeOut(400);
                        self.setIgnore(true);
                        self.setExpressionApplied(false);
                        Justselling_Configento_App_Webshop.finalizeAction();
                    });
                }
                $popupHtmlContainer.html(popupHtml).fadeIn(400).find('.pc__popup-content').html(message);

                self.setExpressionApplied(true);
                return true;
            } else {
                return true;
            }
        }
        else if (condition === CONFIGENTO.RULE_PREDEFINE_QTY || condition === CONFIGENTO.RULE_PREDEFINE_VALUE || condition === CONFIGENTO.RULE_PREDEFINE_MINMAX) {
            if (!self.getExpressionApplied()) {
                //        var start1 = new Date().getTime();

                //self.setExpressionApplied(true);
                _.each(self.getDependencies(), function (dependency) {
                    var option = dependency.option;
                    if (condition > 1) {
                        var defaultValue = option.getDefaultValue();
                        var currentValue = option.getValue();
                        var predefinedOption = option.getPredefinedObject();
                        if (_.isArray(currentValue) && currentValue.length === 1) {
                            currentValue = currentValue[0];
                        }
                        if (condition === CONFIGENTO.RULE_PREDEFINE_VALUE) {
                            var activeChoice = option.getActiveChoice();
                            switch (dependency.condition) {
                                case "1":
                                    condition = 1;
                                    break;
                                case "2":
                                case "3":
                                    if (!predefinedOption && currentValue === defaultValue) condition = 1; // in edit mode if user already picked value, this can't be restricted, and default one is not current!
                                    if (dependency.condition == 3 && (currentValue == '' || (activeChoice instanceof Justselling_Configento_Option_Choice && activeChoice.getIsBlacklisted() ))) condition = 1
                                    break;
                            }
                            /*
                            if (currentValue === defaultValue
                                || activeChoice == null
                                || currentValue == ''
                                || (activeChoice instanceof Justselling_Configento_Option_Choice && activeChoice.getIsBlacklisted() )
                            ) {
                                condition = 1;
                            }

                             */
                        }
                    }

                    if (condition === CONFIGENTO.RULE_PREDEFINE_VALUE) {
                        var choice;
                        if (dependency.value) {
                            var valueToSet = dependency.value;
                            if (dependency.dynamicValue == '1') {
                                var preOption = self.getConfigurator().getOption(dependency.value);
                                if (preOption) {
                                    var preChoiceValue = preOption.getValue();
                                    if (preChoiceValue instanceof Justselling_Configento_Option_Choice) {
                                        preChoiceValue = preChoiceValue.getValue();
                                    }
                                    valueToSet = preChoiceValue;
                                    if (dependency.dynamicChoiceBy) {
                                        if (dependency.dynamicChoiceBy == 'value') {
                                            choice = option.getChoiceByValue(preChoiceValue);
                                        }
                                        else if (dependency.dynamicChoiceBy == 'id') {
                                            choice = option.getChoiceByInternalId(preChoiceValue);
                                        }
                                        if (!choice) {
                                            valueToSet = null;
                                        }
                                    }
                                }
                            }
                            else {
                                choice = option.getChoiceByInternalId(dependency.value);
                                if (choice) {
                                    if (choice.getIsBlacklisted()) {
                                        choice = null;
                                        valueToSet = null;
                                    }
                                    else {
                                        valueToSet = choice.getOriginalValue();
                                    }
                                }
                            }
                            if (choice) {
                                if (!option.getActiveChoice()) {
                                    option.setActiveChoice(choice);
                                }
                            }
                            if (valueToSet != null) {
                                if (!option.getValue()) {
                                    option.setValue(valueToSet);
                                }
                            }
                        }
                    }

                    /* TODO research and test predefined options, e.g. project TIP, initial load fine, some change problem!, quick fix:   */
                    if (condition === 1 || condition === CONFIGENTO.RULE_PREDEFINE_QTY || condition === CONFIGENTO.RULE_PREDEFINE_MINMAX || Justselling_Configento_App_Helper.getForcePredefinedOptions() /*|| condition === CONFIGENTO.RULE_PREDEFINE_VALUE*/) {
                        //          var start2 = new Date().getTime();

                        var choice;
                        if (dependency.value) {
                            var valueToSet = dependency.value;
                            if (dependency.dynamicValue == '1') {
                                // :(
                                var preOption = self.getConfigurator().getOption(dependency.value);
                                if (preOption) {
                                    var preChoiceValue = preOption.getValue();
                                    if (preChoiceValue instanceof Justselling_Configento_Option_Choice) {
                                        preChoiceValue = preChoiceValue.getValue();
                                    }
                                    valueToSet = preChoiceValue;
                                    if (dependency.dynamicChoiceBy) {
                                        if (dependency.dynamicChoiceBy == 'value') {
                                            choice = option.getChoiceByValue(preChoiceValue);
                                        }
                                        else if (dependency.dynamicChoiceBy == 'id') {
                                            choice = option.getChoiceByInternalId(preChoiceValue);
                                        }
                                        if (!choice) {
                                            valueToSet = null;
                                        }
                                    }
                                }
                            }
                            else {
                                choice = option.getChoiceByInternalId(dependency.value);
                                if (choice) {
                                    if (choice.getIsBlacklisted()) {
                                        choice = null;
                                        valueToSet = null;
                                    }
                                    else {
                                        valueToSet = choice.getOriginalValue();
                                    }
                                }
                            }
                            if (self.getType() === CONFIGENTO.RULE_PREDEFINE_MINMAX && valueToSet != null) {
                                choice = null;
                                try {
                                    var minmax = valueToSet.split('-');
                                    valueToSet = null;
                                    if (minmax.length > 1) {
                                        var min = parseInt(minmax[0]);
                                        var max = parseInt(minmax[1]);
                                        if (min <= max) {
                                            option.minMaxOverwriteBy = (self.id);
                                            option.setMinValue(min);
                                            option.setMaxValue(max);
                                        }
                                        else {
                                            Justselling_Configento_App_Debug.addDebug("Min is bigger than max");
                                        }
                                    } else {
                                    Justselling_Configento_App_Debug.addDebug("Wrong MinMax pattern");
                                    }
                                } catch (err) {
                                    Justselling_Configento_App_Debug.addDebug("EXCEPTION when checking min-max rule: "+err);
                                }
                            }

                            if (choice) {
                                option.setActiveChoice(choice);
                            }
                            if (valueToSet != null) {
                                option.setValue(valueToSet);
                            }
                        }
                        if (dependency.qty && option.getQtyType() > 0) {
                            if (choice == null) {
                                choice = option.getChoiceByInternalId(dependency.value);
                            }
                            if (choice) {
                                choice.setQty(dependency.qty);
                            }
                            else {
                                option.setWholeQty(dependency.qty)
                            }
                        }
                        if (dependency.min_qty) {
                            var minQty = dependency.min_qty;
                            if (dependency.dynamicQtyValue == '1') {
                                var optionMinQty = self.getConfigurator().getOption(dependency.min_qty);
                                if (optionMinQty) {
                                    var optionMinQtyChoice = optionMinQty.getValue();
                                    if (optionMinQtyChoice instanceof Justselling_Configento_Option_Choice) {
                                        optionMinQtyChoice = optionMinQtyChoice.getValue();
                                    }
                                    minQty = parseInt(optionMinQtyChoice);
                                }
                            }
                            option.setMinQty(minQty);
                        }
                        if (dependency.max_qty) {
                            var maxQty = dependency.max_qty;
                            if (dependency.dynamicQtyValue == '1') {
                                var optionMaxQty = self.getConfigurator().getOption(dependency.max_qty);
                                if (optionMaxQty) {
                                    var optionMaxQtyChoice = optionMaxQty.getValue();
                                    if (optionMaxQtyChoice instanceof Justselling_Configento_Option_Choice) {
                                        optionMaxQtyChoice = optionMaxQtyChoice.getValue();
                                    }
                                }
                                maxQty = parseInt(optionMaxQtyChoice);
                                /* if we have combined options than take whole qty */
                                var wholeQty = optionMaxQty.getWholeQty();
                                if (wholeQty > maxQty) {
                                    maxQty = wholeQty;
                                }
                            }
                            option.setMaxQty(maxQty);
                        }
                        option.setHasChanged(true);
                        option.setIsRendered(false);
                        if (updateDependencyOption) {
                            option.updateValueInDom();
                        }
                        if (dependency.dynamicQtyValue == '1') { // when we have dynamic qty than we need to refresh DOOM values
                            option.render();
                        }

                        /*                            var end1 = new Date().getTime();
                         var time1 = end1 - start2;
                         Justselling_Configento_App_Profiler.addMeasuring("predefine QTY CONDITION == 1", time1); */
                    }
                });
                /*var end1 = new Date().getTime();
                 var time1 = end1 - start1;
                 Justselling_Configento_App_Profiler.addMeasuring("predefine QTY"+ self.getLabel(), time1); */

            }
        }
    }
    else {
        if (condition === CONFIGENTO.RULE_PREDEFINE_QTY || condition === CONFIGENTO.RULE_PREDEFINE_VALUE || condition === CONFIGENTO.RULE_PREDEFINE_MINMAX) {
            _.each(self.getDependencies(), function (dependency) {
                var option = dependency.option;
                if (dependency.min_qty) {
                    var minQty = parseInt(dependency.min_qty);
                    if (dependency.dynamicQtyValue == '1') {
                        var optionMinQty = self.getConfigurator().getOption(dependency.min_qty);
                        if (optionMinQty) {
                            var optionMinQtyChoice = optionMinQty.getValue();
                            if (optionMinQtyChoice instanceof Justselling_Configento_Option_Choice) {
                                optionMinQtyChoice = optionMinQtyChoice.getValue();
                            }
                            minQty = parseInt(optionMinQtyChoice);
                        }
                    }
                    if (minQty === option.getMinQty()) {
                        option.setMinQty(option.getDefaultMinQty());
                        option.setHasChanged(true);
                        option.setIsRendered(false);
                    }
                }
                if (dependency.max_qty) {
                    var maxQty = parseInt(dependency.max_qty);
                    if (dependency.dynamicQtyValue == '1') {
                        var optionMaxQty = self.getConfigurator().getOption(dependency.max_qty);
                        if (optionMaxQty) {
                            var optionMaxQtyChoice = optionMaxQty.getValue();
                            if (optionMaxQtyChoice instanceof Justselling_Configento_Option_Choice) {
                                optionMaxQtyChoice = optionMaxQtyChoice.getValue();
                            }
                        }
                        maxQty = parseInt(optionMaxQtyChoice);
                    }
                    if (maxQty === option.getMaxQty()) {
                        option.setMaxQty(option.getDefaultMaxQty());
                        option.setHasChanged(true);
                        option.setIsRendered(false);
                    }
                }
                if (condition === CONFIGENTO.RULE_PREDEFINE_MINMAX && option.minMaxOverwriteBy === self.id) {
                    try {
                        option.minMaxOverwriteBy = null;
                        option.setMinValue(option.defaultMinValue);
                        option.setMaxValue(option.defaultMaxValue);

                        option.setHasChanged(true);
                        option.setIsRendered(false);
                        if (updateDependencyOption) {
                            option.updateValueInDom();
                        }
                    } catch (err) {
                        Justselling_Configento_App_Debug.addDebug("EXCEPTION when checking resetting min max to default: "+err);
                    }
                }

                /*if (condition === CONFIGENTO.RULE_PREDEFINE_VALUE) {
                    try {
                        var activeChoice = option.getActiveChoice();
                        if ((activeChoice != null)  || (typeof activeChoice !== 'undefined')) {
                            option.setActiveChoice(null);
                            option.setValue(null);
                        }
                    } catch (err) {
                        Justselling_Configento_App_Debug.addDebug("EXCEPTION when checking resetting active choice: "+err);
                    }
                }*/
            });
            self.setExpressionApplied(false);

        }
    }
};
var Justselling_Configento_CombinedImage_CombinedImage = function(configurator) {

    var self = this;

    this.init = function(configurator) {
        self.setConfigurator(configurator);
    };

    this.setConfigurator = function(configurator) {
        self.configurator = configurator;
    };
    this.getConfigurator = function() {
        return self.configurator;
    };

    this.getCurrentImageStack = function() {
        var images = [];
        var options = self.getConfigurator().getOptions();
        if (options) {
            for (var i = 0; i < options.length; i++) {
                var option = options[i];
                if (Justselling_Configento_App_Helper.getMultipleLayers().length > 0) {
                    if (typeof option.choices !== 'undefined') {
                        var oc = option.choices;
                        if (!_.isArray(oc)) {
                            oc = [oc];
                        }
                        _.each(oc, function (c) {
                            if (Justselling_Configento_App_Helper.getMultipleLayers().indexOf(c.originalValue) >= 0) {
                                if (c.getImage()) {
                                    images.push({
                                        'id': option.getId(),
                                        'image': c.getImage(),
                                        'choiceId': option.getId(),
                                        'optionInternalId': option.getInternalId(),
                                        'internalId': c.getInternalId(),
                                        'top': c.getImageTop(),
                                        'left': c.getImageLeft(),
                                        'width': c.getImageWidth(),
                                        'height': c.getImageHeight(),
                                        'optiontype': option.optiontype,
                                        'layerPosition': c.getLayerPosition()
                                    });
                                }
                            }
                        });
                    }
                    if (option.optiontype == 'package') {
                        if (option.active) {
                            if (option.getImage()) {
                                images.push({
                                    'id': option.getId(),
                                    'image': option.getImage(),
                                    'choiceId': '',
                                    'optionInternalId': option.getInternalId(),
                                    'internalId': '',
                                    'layerPosition': option.getLayerPosition(option.getInternalId())
                                });
                            }
                        }
                    }
                }
                var choices;
                if (choices = option.getActiveChoice()) {
                    if(!_.isArray(choices)) {
                        choices = [choices];
                    }
                    _.each(choices, function (choice) {
                        //console.log('zovem combined image... ', 1000, choice.getGroupLayer(), Justselling_Configento_App_Helper.getActiveGroupLayer(), choice.getGroupLayer() == Justselling_Configento_App_Helper.getActiveGroupLayer());
                        if (Justselling_Configento_App_Helper.getActiveGroupLayer()){
                            if (choice.getGroupLayer() == Justselling_Configento_App_Helper.getActiveGroupLayer()) { // we need to add one more identificator to know current active view
                                if (Justselling_Configento_App_Helper.getBlacklistCombinedImages().length == 0) {
                                    if (choice.getImage()) {
                                        if (choice.originalValue != 'dummyx') { // this is just one more secure case!
                                            images.push({
                                                'id': option.getId(),
                                                'image': choice.getImage(),
                                                'choiceId': option.getId(),
                                                'optionInternalId': option.getInternalId(),
                                                'internalId': choice.getInternalId(),
                                                'top': choice.getImageTop(),
                                                'left': choice.getImageLeft(),
                                                'width': choice.getImageWidth(),
                                                'height': choice.getImageHeight(),
                                                'layerPosition': choice.getLayerPosition()
                                            });
                                        }
                                    }
                                } else if (Justselling_Configento_App_Helper.getBlacklistCombinedImages().indexOf(choice.id) >= 0) { // or use this one?
                                    if (choice.getImage()) {
                                        if (choice.originalValue != 'dummyx') { // this is just one more secure case!
                                            images.push({
                                                'id': option.getId(),
                                                'image': choice.getImage(),
                                                'choiceId': option.getId(),
                                                'optionInternalId': option.getInternalId(),
                                                'internalId': choice.getInternalId(),
                                                'top': choice.getImageTop(),
                                                'left': choice.getImageLeft(),
                                                'width': choice.getImageWidth(),
                                                'height': choice.getImageHeight(),
                                                'layerPosition': choice.getLayerPosition()
                                            });
                                        }
                                    }
                                }
                            }
                        } else { // old logic, we will remove it, after new logic implement.
                            if (Justselling_Configento_App_Helper.getBlacklistCombinedImages().indexOf(choice.originalValue) < 0) {
                                if (choice.getImage()) {
                                    if (choice.originalValue != 'dummyx') { // this is just one more secure case!
                                        var layerPosition = choice.getLayerPosition();
                                        if (typeof choice.getLayerPosition() === 'undefined') {
                                            layerPosition = choice.getGroupLayer();
                                        }
                                        images.push({
                                            'id': option.getId(),
                                            'image': choice.getImage(),
                                            'choiceId': option.getId(),
                                            'optionInternalId': option.getInternalId(),
                                            'internalId': choice.getInternalId(),
                                            'top': choice.getImageTop(),
                                            'left': choice.getImageLeft(),
                                            'width': choice.getImageWidth(),
                                            'height': choice.getImageHeight(),
                                            'layerPosition': layerPosition,
                                            'optiontype': option.optiontype,
                                            'sortOrderCombiImage': option.getSortOrderCombiImage()
                                        });
                                    }
                                }
                            }
                        }
                    });
                }
            }
        }

        return images;
    };

    this.formatCssValue = function(value) {
        if (!isNaN(value)) {
            value += "px";
        }
        return value;
    };

    this.justselling360combinedimage = function (images360collection, $baseContainer, images, maxPerset) {
        if (images360collection.length > 0) {
            if (Justselling_Configento_App_Helper.getSequences360TextLoading()) {
                jQuery('.rotate-3d-indicator svg').css({'opacity': '0.2'});
                jQuery('.rotation-text').html(Justselling_Configento_App_Helper.getSequences360TextLoading());
            } else {
                jQuery('.rotate-3d-indicator').remove();
            }


            Justselling360.activateLoader(self.getConfigurator().getConfig('loadingAnimationColor'), self.getConfigurator().getConfig('showPercentage360'));
            images360collection = images360collection.filter(function (e) { return e });
            if (Justselling_Configento_App_Helper.getStore()) {
                maxPerset = 1;
            }

            var calculateMaxImagesPerSet = Math.floor(images360collection.length / maxPerset);

            /* all the time set image, because we can have different image sizes! */
            Justselling360.setInitLoadImage(images360collection[0]);


            /* call method for expand monitoring, so we can get percent of loaded image */
            Justselling_Configento_App_Helper.expandImageForMonitoring();

            var imageGetSize = new Image();
            imageGetSize.src = Justselling360.getInitLoadImage();// images360collection[0];
            if ((Justselling_Configento_App_Helper.getBackgroundWidth() == 0) && (Justselling_Configento_App_Helper.getBackgroundHeight() == 0)) {
                imageGetSize.onload = function() {
                    /* with this we will secure aspect ratio */
                    Justselling_Configento_App_Helper.setBackgroundWidth(this.width);
                    Justselling_Configento_App_Helper.setBackgroundHeight(this.height);
                    self.helpCombinedImage(this.width, this.height, calculateMaxImagesPerSet, images360collection, maxPerset);
                }
            } else {
                self.helpCombinedImage(Justselling_Configento_App_Helper.getBackgroundWidth(), Justselling_Configento_App_Helper.getBackgroundHeight(), calculateMaxImagesPerSet, images360collection, maxPerset);
            }

        }
    };

    this.helpCombinedImage = function (w,h, calculateMaxImagesPerSet, images360collection, maxPerset) {
        var imageOriginalWidth = w;
        var imageOriginalHeight = h;

        /* this is only temp, will be replaced with param */
        if(CONFIGENTO_PRODUCT.getWebShopCode() == 'magento2') {
            if (jQuery('.justselling360combinedimage').length == 0) {
                if (Justselling_Configento_App_Helper.getCustomContainerCanvasClass()) {
                    jQuery('.'+Justselling_Configento_App_Helper.getCustomContainerCanvasClass()).prepend(jQuery('<div />').addClass('justselling360combinedimage'));
                } else {
                    jQuery('.product.media').addClass('js-360-ci-product-media').prepend(jQuery('<div />').addClass('justselling360combinedimage')
                        .css('min-height', Justselling_Configento_App_Helper.getImageContainer360Size().height+'px')
                        .css('min-width', Justselling_Configento_App_Helper.getImageContainer360Size().width+'px'));
                }
                jQuery('.fotorama, .fotorama__img').hide(); // hide default gallery, we are using our
            }

            /* for now is only hardcoded, will be param  */
            var width = jQuery('.tp-bgimg.defaultimg').width();
        } else {
            var galleryClass = Justselling_Configento_App_Helper.getGalleryClass();
            var $baseContainer = jQuery(galleryClass);
            if (jQuery('.justselling360combinedimage').length == 0) {
                $baseContainer.html(jQuery('<div />').addClass('js-360-ci-product-media').addClass('justselling360combinedimage')
                    .css('min-height', Justselling_Configento_App_Helper.getImageContainer360Size().height+'px')
                    .css('min-width', Justselling_Configento_App_Helper.getImageContainer360Size().width+'px'));
                /**
                 * we must remove default wrapper, because in SW we have slider that can't work with our 360,
                 * so here we remove this slider to act like any other shop
                 */
                if (CONFIGENTO_PRODUCT.getWebShopCode() == 'shopware5') {
                    jQuery('.combined-image-container').unwrap();
                }

                /* hide magnify on product on 360 view, will open blank preview */
                if(CONFIGENTO_PRODUCT.getWebShopCode() == 'woocommerce') {
                    jQuery('.woocommerce-product-gallery__trigger').hide();
                }
            }
            var width = $baseContainer.width();
        }

        if (Justselling_Configento_App_Helper.canvas360css.width > 0) {
            width = Justselling_Configento_App_Helper.canvas360css.width;
        }

        /* calculate new height for keep aspect ratio  */
        var height = (imageOriginalHeight / imageOriginalWidth) * width;

        /* now we this set to 0, but later system will transform whole container and images to 100% */
        if (Justselling_Configento_App_Helper.getResponsive360preview()) {
            width = 0;
            height = 0;
        }

        if (Justselling_Configento_App_Helper.canvas360css.ContainerHeight > 0) {
            if (height > Justselling_Configento_App_Helper.canvas360css.ContainerHeight) {
                Justselling_Configento_App_Helper.canvas360css.height = Justselling_Configento_App_Helper.canvas360css.ContainerHeight;
            }
        }

        if (Justselling_Configento_App_Helper.canvas360css.height > 0) {
            height = Justselling_Configento_App_Helper.canvas360css.height;
            width = (imageOriginalWidth / imageOriginalHeight) * height;
        }

        /**
         * calculate center of image based on size of container, size of container has to be > 0 to trigger logic
         * */
        var cAspectRatio = imageOriginalWidth / imageOriginalHeight;
        if (Justselling_Configento_App_Helper.calculateCenter.containerWidth != 0) {
            var cWidth = Justselling_Configento_App_Helper.calculateCenter.containerHeight * cAspectRatio;
            var cRes = 0;
            if (cWidth > Justselling_Configento_App_Helper.calculateCenter.containerWidth) {
                cRes = (Justselling_Configento_App_Helper.calculateCenter.containerWidth - cWidth) / 2;
            }
            if (
                (Justselling_Configento_App_Helper.calculateCenter.containerHeight < imageOriginalHeight) &&
                (Justselling_Configento_App_Helper.calculateCenter.containerWidth < imageOriginalWidth)
            ) {
                cRes = (Justselling_Configento_App_Helper.calculateCenter.containerWidth - imageOriginalWidth) / 2;
            }
            Justselling_Configento_App_Helper.setImageLeftCenter(cRes);
        }

        /**
         * with this logic we secure to scale image as it own container, so every time layer will match to background
         * we are compare aspect ratio of container and aspect ratio or real size image, and than this logic will
         * do math (css)
         */
        if (Justselling_Configento_App_Helper.calculateCenter.takeAsTheyAreSet) {
            Justselling_Configento_App_Helper.setImageLeftCenter(0);
            height = Justselling_Configento_App_Helper.calculateCenter.containerHeight;
            width = Justselling_Configento_App_Helper.calculateCenter.containerWidth;

            var calculateTop = 0;
            var imgWidth = 0;
            var imgHeight = 0;

            var containerAspectRatio = width / height;
            if (containerAspectRatio > cAspectRatio) {
                Justselling_Configento_App_Helper.setImageLeftCenter(0);
                imgWidth = width;
                imgHeight = width / cAspectRatio;
                calculateTop = (height - imgHeight) / 2;
            }
            if (containerAspectRatio < cAspectRatio)  {
                imgHeight = height;
                imgWidth = height * cAspectRatio;
                calculateTop = 0;

                cRes = (width - imgWidth) / 2;
                Justselling_Configento_App_Helper.setImageLeftCenter(cRes);
            }

            Justselling_Configento_App_Helper.setImageInlineCss('position: absolute; min-height: 100%; min-width: 100%; width:'+imgWidth+'px; height:'+imgHeight+'px;');
            Justselling_Configento_App_Helper.setCalculateTopImage(calculateTop);
        }

        /* make deploy*/
        jQuery('#image-main').hide();
        canvas360({
            canvasId: '.justselling360combinedimage',
            canvasWidth: parseInt(width),
            canvasHeight: parseInt(height),
            framesPath: jQuery(this).data('framespath') || '',
            framesFile: jQuery(this).data('framesfile'),
            framesReverse: !!jQuery(this).data('framesreverse') || false,
            background: Justselling_Configento_App_Helper.getBackgroundImage(),
            images: images360collection,
            maxImagesPerSet: maxPerset,
            framesCount: calculateMaxImagesPerSet, // we start from 0
            currentFrame: Justselling360.getCurrentFrame(),
            wrapperCSS: false,
            animationSettings: self.getConfigurator().getConfig('showPercentage360'),
            loadingAnimationColor: self.getConfigurator().getConfig('loadingAnimationColor'),
            sequences360: self.getConfigurator().getConfig('sequences360'),
            sequences360IconAfter: Justselling_Configento_App_Helper.getSequences360IconAfter(),
            // autorotate: true
        });
        Justselling360.setStopLoading(true);
    },

    this.render = function() {
        Justselling_Configento_App_Debug.addDebug("combinedimage.render");
        var images = self.getCurrentImageStack();
        if (images.length >= 1) {
            var galleryClass = Justselling_Configento_App_Helper.getGalleryClass();
            var $baseContainer = jQuery(galleryClass);

            if ($baseContainer && $baseContainer.length >= 1) {
                $baseContainer = $baseContainer.eq(0);
                var $mainImage = $baseContainer.find('img:first-child');

                $baseContainer.html($mainImage);
                $baseContainer.addClass("combined-image-container");
                window.combinedIamgeMinHeight = 0;
                var images360collection = [];
                var maxPerset = 0;

                var collectLayerPosition = [];
                for (var i = 0; i < images.length; i++) {
                    var image = images[i];
                    var imageName = '';
                    var is360active = false;
                    if (_.isArray(image.image) && (image.image.length > 0)) {
                        if (typeof image.image[0] !== 'undefined') {
                            imageName = image.image[0].filelink;
                        } else {
                            imageName = image;
                        }
                    } else {
                        imageName = image.image;
                    }
                    
                    if (imageName.length ==0) {
                        Justselling_Configento_App_Debug.addDebug('Combined image is missing for option ID: '+image.id, true);
                        continue;
                    }

                    if (self.getConfigurator().getConfig("combinedimage") == 'combined-product-image-360') {
                        is360active = true;
                    }

                    var imageInternalId = image.internalId;
                    if (image.optiontype == 'package') {
                        imageInternalId = '';
                    }
                   

                    if ((typeof image.layerPosition !== 'undefined') && (image.layerPosition != null)) {
                        if (jQuery.isNumeric(image.layerPosition)) {
                            collectLayerPosition.push(image.layerPosition);
                            Justselling_Configento_App_Helper.setLayerPosition(collectLayerPosition);
                        }
                    }

                    var path = Justselling_Configento_App_Helper.getAssetPath(image.choiceId, image.optionInternalId, image.internalId) + imageName;

                    var zindex = 0;
                    if(image.sortOrderCombiImage > 0) {
                        zindex = image.sortOrderCombiImage;
                    }

                    var $imageObject = jQuery('<img crossorigin="anonymous" style="z-index: '+zindex+';" class="combined-image-item" src="' + path + '"/>');
                    if (image.width) {
                        var width = self.formatCssValue(image.width);
                        $imageObject.css("width", width);
                    }
                    if (image.height) {
                        var height = self.formatCssValue(image.height);
                        $imageObject.css("height", height);
                        if (parseInt(image.height) > parseInt(window.combinedIamgeMinHeight)) {
                            window.combinedIamgeMinHeight = image.height;
                        }
                    }
                    if (image.top || image.top === 0) {
                        var top = self.formatCssValue(image.top);
                        $imageObject.css("top", top);
                    }
                    if (image.left || image.left === 0) {
                        var left = self.formatCssValue(image.left);
                        $imageObject.css("left", left);
                    }

                    if (!is360active) {
                        $baseContainer.append($imageObject);
                    }

                    $imageObject.one('load', function() {
                        if (jQuery(this).height() > window.combinedIamgeMinHeight) {
                            window.combinedIamgeMinHeight = jQuery(this).height();
                            $baseContainer.css("min-height", window.combinedIamgeMinHeight+"px");
                        }
                    });


                    /**
                     * collect images for 360 plugin
                     * */
                    if (is360active) {
                        if (images[i].image.length > 1) {
                            maxPerset++;
                        }
                        /* make sort, if we have correct naming of images, e.g. 1,2,3... than we are sure that product will be rotated correct */
                        //images[i].image.sort(Justselling_Configento_App_Helper.dynamicSort('filelink'));
                        jQuery.each(images[i].image, function (key, value) {
                            /* collect data only if we have 2 or more images */
                            if (images[i].image.length > 1) {
                                //maxPerset++;
                                var splitToGetName = value.filelink.split('baseimage');
                                if (splitToGetName.length <= 1) { // don't add base image to rotate stack
                                    var imageInternalId = image.internalId;
                                    if (image.optiontype == 'package') {
                                        imageInternalId = '';
                                    }
                                    images360collection.push(Justselling_Configento_App_Helper.getAssetPath(image.choiceId, image.optionInternalId, imageInternalId) + value.filelink);
                                }
                            }
                        });
                    }
                }
                /* we have numbers and names, so we need to sort it! */
                /*var collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
                images360collection.sort(collator.compare);


                /!* we have numbers and names, so we need to sort it! *!/
                var collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
                images360collection.sort(collator.compare);

                /!* we have numbers and names, so we need to sort it! *!/
                var collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
                images360collection.sort(collator.compare);

                /!* we have numbers and names, so we need to sort it! *!/
                var collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
                images360collection.sort(collator.compare);

                /!* we have numbers and names, so we need to sort it! *!/
                var collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
                images360collection.sort(collator.compare);*/

                if (Justselling_Configento_App_Helper.getStore()) {
                    maxPerset = 1;
                }

                /* this is fired when we do some select in configurator */
                self.justselling360combinedimage(images360collection, $baseContainer, images, maxPerset);



                /* As we are using position absolute we have to set the
                 height of the image container
                 */
                if (window.combinedIamgeMinHeight) {
                    $baseContainer.css("min-height", window.combinedIamgeMinHeight+"px");
                }
            }
            else if(galleryClass === '.product.media .gallery-placeholder .fotorama__active'){
                var galleryPlcaeholder = jQuery('.product.media .gallery-placeholder');
                if (galleryPlcaeholder.length >0 && galleryPlcaeholder.hasClass('_block-content-loading')) {
                    // TODO: trigger after product image has loaded
        //            setTimeout(self.render(), 10000);
                }
            }
        }
    };

    this.init(configurator);
    return this;
};


var Justselling_Configento_Autocomplete_Autocomplete = function(searchInput, valueInput, src, entryTemplate, option) {

	const imageVisibility = option.getChoiceImageVisibility() === "selected";
	if (entryTemplate === undefined) {
		const withImage =
			'<div class="autocomplete-entry">' +
			'<img class="autocomplete-entry-img" src="{{image}}" />' +
			'<div>{{viewValue}}</div>' +
			'</div>';

		const withoutImage = '<div>{{viewValue}}</div>';

		entryTemplate = imageVisibility ? withImage : withoutImage;

	}
	searchInput = jQuery(searchInput);
	valueInput = jQuery(valueInput);

	var self = this;
	var currentFocus = -1;
	var resultsContainer;

	this.generateResults = function() {
		var entryContainer, val = searchInput.val();

		if (imageVisibility) {
			jQuery('.show-choice-selected').css('display', 'block');
		}

		self.closeList();
		if(!val) { return false; }
		currentFocus = -1;

		resultsContainer = jQuery("<div>");
		resultsContainer.addClass("autocomplete-list");
		src.sort(function(a,b) {
			return Justselling_Configento_App_Storage.compareOptionsAlphanumeric(a, b, 'value');
		});
		for(var i = 0; i < src.length; i++) {
			var srcEntry = src[i];
			var showEntry = false;
			var foundedQuery = "";
			for(var q = 0; q < srcEntry.query.length; q++) {
				if(srcEntry.query[q].toUpperCase().startsWith(val.toUpperCase()) || (typeof srcEntry.additionalQuery !== 'undefined' ? srcEntry.additionalQuery.toUpperCase().startsWith(val.toUpperCase()) : '')) {
					showEntry = true;
					foundedQuery = srcEntry.query[q];
					break;
				}
			}

			if(showEntry) {
				var entry = jQuery(entryTemplate).addClass("autocomplete-entry");
				entry.attr("autocomplete-value", srcEntry.value);
				entry.attr("autocomplete-view", srcEntry.viewValue);
				entry.attr("autocomplete-index", i);
				var html = jQuery("<div>").append(entry).html();
				var completion = foundedQuery.substr(val.length);
				html = self.replaceAll(html, "{{search}}", foundedQuery.substr(0, val.length));
				html = self.replaceAll(html, "{{completion}}", completion);

				for(var se in srcEntry) {
					html = self.replaceAll(html, "{{" + se + "}}", srcEntry[se]);
				}

				entryContainer = jQuery(html);
				entryContainer.click(function(e) {
					searchInput.val(jQuery(this).attr("autocomplete-view"));
					//valueInput.find("option[value='" + jQuery(this).attr("autocomplete-value") + "']").attr("selected", true).trigger("change");
					/* we may have same values and same name, so search for both */
					valueInput.find("option[data-cf-label='" + jQuery(this).attr("autocomplete-view") + "']option[value='" + jQuery(this).attr("autocomplete-value") + "']").prop("selected", true).trigger("change");

					if (imageVisibility) {
						var image = jQuery(this).find("img").attr("src");
						jQuery('.autocomplete-preview-image').remove();
						var imgEl = jQuery("<img class='autocomplete-preview-image' />");
						jQuery('#'+searchInput.attr('id')).after(imgEl);
						imgEl.attr("src", image);
					}

					self.closeList();
				});

				resultsContainer.append(entryContainer);
			}
		}

		searchInput.parent().append(resultsContainer);
	};

	this.closeList = function() {
		if(resultsContainer !== undefined) {
			resultsContainer.remove();
		}
	};

	this.addActive = function() {
		var entries = resultsContainer.children();
		if(entries.length == 0) {
			return false;
		}

		self.removeActive();

		if(currentFocus >= entries.length) {
			currentFocus = 0;
		}
		if(currentFocus < 0) {
			currentFocus = entries.length - 1;
		}

		var entry = jQuery(entries[currentFocus]);
		entry.addClass("active");
		var maxOffset = resultsContainer.offset().top + resultsContainer.height();
		var offsetHeightEntry = entry.outerHeight() + entry.offset().top;

		if(offsetHeightEntry > maxOffset || entry.offset().top < resultsContainer.offset().top) {
			var scrollTop = entry.offset().top - resultsContainer.offset().top + resultsContainer.scrollTop();
			resultsContainer.scrollTop(scrollTop);
		}
	};

	this.removeActive = function() {
		jQuery(".autocomplete-entry.active").removeClass("active");
	};

	this.onKeyDown = function(e) {
		if(e.keyCode == 13) {
			e.stopPropagation();
			e.preventDefault();
			if(resultsContainer.children().length > 0 && currentFocus > -1) {
				jQuery(resultsContainer.children()[currentFocus]).click();
			}
		} else if(e.keyCode == 40) {
			currentFocus++;
			self.addActive();
		} else if(e.keyCode == 38) {
			currentFocus--;
			self.addActive();
		}
	};

	this.replaceAll = function(string, search, replacement) {
		return string.replace(new RegExp(search, 'g'), replacement);
	};

	searchInput.off("input");
	searchInput.off("click");
	searchInput.off("keydown");

	searchInput.unbind("input");
	searchInput.unbind("click");
	searchInput.unbind("keydown");

	searchInput.on("input", self.generateResults);
	searchInput.on("click", self.generateResults);
	searchInput.on("keydown", self.onKeyDown);

	var valueFound = false;
	var value = valueInput.val();
	for(var s in src) {
		if(src[s].value == value) {
			valueFound = true;
			break;
		}
	}
	if(!valueFound) {
		valueInput.attr("value", "");
		searchInput.attr("value", "");
	}
};

//# sourceMappingURL=compiled-bundle.js.map
